/* ============================================================
   JV Admin CRM — Shopify Bridge Mode
   Transplanted from GAS AdminCRM-v2.html
   google.script.run calls replaced with jvBridge.callAdmin()
   ============================================================ */

/* ============================================================
   GOOGLE.SCRIPT.RUN CALL SITE MAP
   All preserved from AdminCRM.html — DO NOT CHANGE PATTERNS
   ============================================================
   1.  getScriptUrl()                                          — cache URL on load
   2.  adminCrm_getPipeline(opts)                             — pipeline kanban data
   3.  adminCrm_updateStage(clientId, newStage)               — drag/drop stage update
   4.  adminCrm_getClients(q, statusFilter)                   — clients list
   5.  adminCrm_getClient(clientId)                           — single client detail
   6.  adminCrm_getCommsSummary(brideEmail)                   — comms summary
   7.  adminCrm_getCommsLog(clientId)                         — full comms timeline
   8.  adminCrm_updateField(clientId, fieldName, value)        — inline field save
   9.  adminCrm_getRunsheets()                                — runsheets list
   10. adminCrm_getProposals()                                — proposals list
   11. adminCrm_voidProposal(token)                           — void proposal
   12. adminCrm_getInvoices()                                 — invoices list
   13. adminCrm_getAnalytics(period)                          — analytics data
   14. adminCrm_sendToPipeline(clientId)                      — [UI: "Send Proposal"]
   15. adminCrm_preflightLead(clientId)                       — preflight check
   16. handleGetNotifications({ token: nToken })               — notifications
   17. adminApi_getSettings({ token })                         — settings
   18. adminApi_getAutomations({ token })                      — automations list
   19. adminApi_getAuditLog({ token, limit, offset, type })    — audit log
   20. adminApi_getShopifySyncStatus({ token })                — shopify status
   21. adminApi_getAdvancedAnalytics({ token, period })        — advanced analytics
   22. adminApi_getMoxieMigrationStatus({ token })             — moxie status
   23. adminApi_getBookingAdmin({ token })                     — studio booking
   24. adminApi_setSafeMode({ token, enabled })                — toggle safe mode
   25. adminApi_toggleAutomation({ token, id, enabled })       — toggle automation
   26. adminApi_triggerShopifySync({ token, scope })           — trigger shopify sync
   27. adminApi_exportCsv({ token, type })                     — export CSV
   28. adminApi_callRepairRoute(payload)                       — xero/repair proxy
   ============================================================ */

/* ============================================================
   FEATURE FLAGS
   ============================================================ */
// Void Proposal is not yet implemented on the backend.
// adminCrm_voidProposal (AdminCRMAPI.gs) now delegates to the real builder's
// own working void implementation (proposalVoid, ProposalBuilderAPI.gs) --
// fixed 2026-09-09 (c4e7e63e), confirmed live. Flag turned ON 2026-09-10 per
// Jess's direct "go" after reviewing the test plan (writes
// PROPOSAL_STATUS=VOID + timestamp, voids the token, fires an admin Chat
// alert, gracefully no-ops on an already-voided proposal). Visible to any
// admin team member, not scoped to Jess only (her explicit instruction).
var JV_FEATURE_VOID_PROPOSAL = true;

// B2 artist-bill lifecycle/review cutover. This is deliberately sourced from a
// page-level boolean and fails closed when the page does not emit it. Production
// currently emits no value, so the exact pre-B2 Admin behavior remains active.
var JV_ADMIN_B2_UI_ENABLED_ = (typeof window !== 'undefined' && window.JV_ADMIN_B2_UI_ENABLED_FLAG_ === true);

/* ============================================================
   STATE
   ============================================================ */
var STATE = {
  token: '',
  currentView: 'pipeline',
  currentStageFilter: 'All',
  pipeline: null,
  pipelineStages: null,
  stageConfig: null,
  stageColours: {},
  clients: null,
  drawerClientId: null,
  drawerTab: 'overview',
  reportPeriod: 90,
  auditOffset: 0,
  safeModeActive: false
};

/* ============================================================
   PAYLOAD CACHE — stale-while-revalidate via localStorage
   Renders the pipeline instantly on repeat visits while GAS
   fetches fresh data in the background.
   ============================================================ */
var JV_PAYLOAD_CACHE_KEY = 'jv_crm_payload_v2';
// 30 min. Safe: the payload always background-refreshes from GAS within ~8s of
// page load, so the TTL only governs how stale the instant first paint can be.
var JV_PAYLOAD_CACHE_TTL_MS = 1800000; // 30 minutes

function jvPayloadCache_get() {
  try {
    var raw = localStorage.getItem(JV_PAYLOAD_CACHE_KEY);
    if (!raw) return null;
    var obj = JSON.parse(raw);
    if (!obj || !obj.ts || !obj.data) return null;
    if (Date.now() - obj.ts > JV_PAYLOAD_CACHE_TTL_MS) { localStorage.removeItem(JV_PAYLOAD_CACHE_KEY); return null; }
    return obj.data;
  } catch(e) { return null; }
}

function jvPayloadCache_set(data) {
  try { localStorage.setItem(JV_PAYLOAD_CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); } catch(e) {}
}

function jvPayloadCache_clear() {
  try { localStorage.removeItem(JV_PAYLOAD_CACHE_KEY); } catch(e) {}
}

// Clear the client search index (localStorage + in-memory) so a freshly added/
// edited bride appears in search immediately. Called from the force-refresh path
// that runs after every CRM write (stage drag, edit, promote, etc.).
function jvClientIdxCache_clear() {
  try { localStorage.removeItem('jv_cidx'); } catch(e) {}
  try { _jvClientIdx = null; } catch(e) {}
}

/* ============================================================
   CACHE-BUSTING — preserve original pattern
   ============================================================ */
var cachedScriptUrl = '';
/* 2026-10-07 (C3): this used to fire a GAS call (getScriptUrl) at EVERY page load, competing with the calendar/pipeline
   calls for Apps Script capacity, although the URL is only used by navigateToPage(). Now fetched on first use. */
var _scriptUrlRequested_ = false;
function ensureScriptUrl_() {
  if (_scriptUrlRequested_ || cachedScriptUrl) return;
  _scriptUrlRequested_ = true;
  if (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function') {
    window.jvBridge.callAdmin('bridge_admin_generic', { function: 'getScriptUrl' })
      .then(function(res) { if (res.ok) cachedScriptUrl = res.data; })
      .catch(function() {});
  }
}

/* ============================================================
   RATE-LIMIT-AWARE ADMIN CALL. bridge_admin_generic is one shared
   fan-out route with a per-window ceiling. When the ceiling trips,
   GAS returns { ok:false, error:'Rate limit exceeded', code:'RATE_LIMIT' }.
   That is a TRANSIENT throttle, not "no data", so this wrapper auto-
   retries after a short backoff (the window is 60s but the count is
   per-window, so a brief wait usually clears it) and lets callers show
   a "Busy, retrying..." state instead of a silent empty result.
   Returns the raw response; callers inspect res.code === 'RATE_LIMIT'
   if all retries are exhausted.
   ============================================================ */
function jvIsRateLimited_(res) {
  return !!(res && res.ok === false && (res.code === 'RATE_LIMIT' || res.error === 'Rate limit exceeded'));
}
function callAdminRetry_(payload, opts) {
  opts = opts || {};
  var maxRetries = (typeof opts.retries === 'number') ? opts.retries : 2;
  var delayMs = (typeof opts.delayMs === 'number') ? opts.delayMs : 1500;
  var onBusy = typeof opts.onBusy === 'function' ? opts.onBusy : null;
  function attempt(n) {
    return window.jvBridge.callAdmin('bridge_admin_generic', payload).then(function(res) {
      if (jvIsRateLimited_(res) && n < maxRetries) {
        if (onBusy) { try { onBusy(n + 1); } catch (e) {} }
        return new Promise(function(resolve) { setTimeout(resolve, delayMs); }).then(function() { return attempt(n + 1); });
      }
      return res;
    });
  }
  return attempt(0);
}

/* ============================================================
   NAVIGATION. preserve navigateToPage from AuthBridge pattern
   ============================================================ */
function navigateToPage(action, customToken) {
  ensureScriptUrl_();
  var token = customToken || STATE.token ||
    (typeof jvGetToken === 'function' ? jvGetToken() : '') ||
    (function(){ try { return sessionStorage.getItem('jv_session_token'); } catch(e){ return ''; } })() || '';
  var url = (cachedScriptUrl || window._jvScriptUrl || '') + '?action=' + encodeURIComponent(action) + (token ? '&token=' + encodeURIComponent(token) : '');
  var a = document.createElement('a');
  a.href = url; a.target = '_top'; a.style.display = 'none';
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
}

/* ============================================================
   HELPERS
   ============================================================ */
var STAGE_DISPLAY = {
  'Enquiry':          'Enquiry',
  'Proposal Drafted for Review': 'Proposal Drafted for Review',
  'Quoted':           'Quoted',
  'Booked':      'Booked',
  'Onboarding':  'Setting Up',
  'Trial':       'Trial',
  'Wedding Prep':'Wedding Prep',
  'Post-Wedding':'Post-Wedding',
  'Closed':      'Closed'
};
var PIPELINE_STAGES = ['Enquiry','Proposal Drafted for Review','Quoted','Booked','Onboarding','Trial','Wedding Prep','Post-Wedding'];

function stageDisplay(s) { return STAGE_DISPLAY[s] || s; }

function stageBadgeClass(stage) {
  var m = {
    'Enquiry':'enquiry','Quoted':'proposal',
    'Booked':'booked','Onboarding':'setting-up','Trial':'trial',
    'Wedding Prep':'prep','Post-Wedding':'post','Closed':'closed'
  };
  return m[stage] || '';
}

function getInitials(name) {
  if (!name) return '?';
  // Strip any HTML tags BEFORE splitting on whitespace, otherwise polluted
  // names like "</b>Jill from" produce initials like "<F" (the "<" being the
  // first char of "</b>Jill"). See BRIEFS/admin-crm-html-strip-second-pass-2026-05-27.md.
  var clean = String(name).replace(/<[^>]*>/g, '').trim();
  if (!clean) return '?';
  var parts = clean.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length-1][0]).toUpperCase();
  return clean.slice(0,2).toUpperCase();
}

// Parses DD/MM/YYYY, YYYY-MM-DD, or Date objects safely (Australian format first)
function parseDate(d) {
  if (!d) return null;
  if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
  var s = String(d).trim();
  // ISO: YYYY-MM-DD, safe to pass directly
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return new Date(s + (s.length === 10 ? 'T00:00:00' : ''));
  // DD/MM/YYYY, Australian format (must NOT pass to new Date directly, V8 reads as MM/DD)
  var dm = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (dm) return new Date(parseInt(dm[3]), parseInt(dm[2]) - 1, parseInt(dm[1]));
  // Raw JS Date.toString() shape, e.g. "Thu Jun 27 2024 00:00:00 GMT+1000". A GAS-side
  // String(dateCell) call (rather than Utilities.formatDate/toISOString) can hand this
  // down for a due-date field. Unambiguous (no DD/MM-vs-MM/DD risk, it's a named month),
  // so safe to fall back to the native parser. Fixes the invoicing table's unformatted
  // raw date bug (2026-08-27, RESULTS-admin-crm-full-shell-grade3-xray-2026-08-27.md).
  if (/^[A-Za-z]{3} [A-Za-z]{3} \d{1,2} \d{4}/.test(s)) {
    var nd = new Date(s);
    if (!isNaN(nd.getTime())) return nd;
  }
  return null;
}

function formatDate(d, style) {
  if (!d) return '—';
  var date = parseDate(d);
  if (!date || isNaN(date.getTime())) return String(d);
  // Sheets 1899 epoch guard: a time-only cell becomes 1899-12-30T…; never
  // a real date. Treat as missing so the header shows nothing instead of
  // "Sat Dec 30 1899". Mirrors adminCrm_isoDate_ on the GAS write side.
  if (date.getFullYear() < 2000) return '—';
  if (style === 'short') {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    return dd + '/' + mm + '/' + date.getFullYear();
  }
  var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var day = date.getDate();
  var suffix = (day === 1 || day === 21 || day === 31) ? 'st' :
               (day === 2 || day === 22) ? 'nd' :
               (day === 3 || day === 23) ? 'rd' : 'th';
  return days[date.getDay()] + ' ' + day + suffix + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
}

function daysUntil(d) {
  if (!d) return null;
  var date = parseDate(d);
  if (!date || isNaN(date.getTime())) return null;
  if (date.getFullYear() < 2000) return null; // 1899 epoch guard (see formatDate)
  var now = new Date(); now.setHours(0,0,0,0);
  return Math.round((date - now) / 86400000);
}

function daysPill(d) {
  var n = daysUntil(d);
  if (n === null) return '';
  if (n < 0) return '<span class="days-pill ok">' + Math.abs(n) + 'd ago</span>';
  if (n <= 30) return '<span class="days-pill urgent">' + n + 'd</span>';
  if (n <= 90) return '<span class="days-pill warn">' + n + 'd</span>';
  return '<span class="days-pill ok">' + n + 'd</span>';
}

function formatCurrency(v) {
  var n = Number(v);
  if (isNaN(n) || v === null || v === undefined) return '$0';
  return '$' + n.toLocaleString('en-AU', {minimumFractionDigits:0,maximumFractionDigits:0});
}

function escHtml(s) {
  if (!s) return '';
  // 2026-08-13: was missing apostrophe escaping (escAttr, right below, already had it).
  // Real, if low-practical-severity, defect flagged by external review: many call sites
  // in this file build inline onclick="fn('...')" markup with escHtml() output sitting
  // inside the inner single-quoted JS string -- an unescaped apostrophe in the value can
  // break out of that string and inject into the handler. Today's callers pass numeric
  // CRM ids almost exclusively (not free text), so exploitability is low in practice, but
  // the helper itself should be correct for any future caller. Escaping ' as &#39; is
  // always safe in any HTML text or attribute context -- this changes no existing
  // rendering, it only closes the gap. The larger fix (moving inline onclick markup to
  // addEventListener, also flagged) is a separate, much larger refactor across ~264
  // call sites in this file and is not attempted in this pass.
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function escAttr(s) {
  if (!s) return '';
  return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function stripTagsAndEscape_(s) {
  return escHtml(String(s || '').replace(/<[^>]*>/g, '').trim());
}

var _loaderTimers = {};
// 2026-08-26 (BRIEFS/BUG-admin-crm-stale-error-banner-after-late-success-2026-08-26.md):
// extended 20s to 30s. The documented ~7-10s GAS cold-start floor occasionally stacks
// with a view's own real work and lands right on/just past 20s, which raced this
// safety-net timer against a load that was genuinely about to succeed. 30s still fires
// well before an admin would assume the page is broken, but gives real-but-slow loads
// more room before the stale-banner race becomes possible at all. This is a mitigation,
// not the fix, see the showContent()/showError() changes below for the actual
// "late success always wins" guarantee regardless of timing.
var _LOADER_SAFETY_NET_MS_ = 30000;
// Tracks whether a view's content has genuinely rendered via showContent() at least
// once for the CURRENT load cycle (reset by showLoader() on every fresh load start).
// Generalises the pre-existing window._jvIslandPainted guard in showError() (which only
// protected CDN-island-backed views) to every view sharing this loader/content/error
// triad, 2026-08-26 (BRIEFS/BUG-admin-crm-stale-error-banner-after-late-success-2026-08-26.md).
var _viewContentPainted = {};
function showLoader(viewId) {
  var l = document.getElementById(viewId + '-loader');
  var c = document.getElementById(viewId + '-content');
  var e = document.getElementById(viewId + '-error');
  if (l) l.style.display = 'flex';
  if (c) c.style.display = 'none';
  if (e) { e.style.display = 'none'; e.textContent = ''; }
  _viewContentPainted[viewId] = false;
  // Safety net: if loader is still showing after _LOADER_SAFETY_NET_MS_, hide it automatically
  clearTimeout(_loaderTimers[viewId]);
  _loaderTimers[viewId] = setTimeout(function() {
    var ll = document.getElementById(viewId + '-loader');
    if (ll && ll.style.display !== 'none') {
      ll.style.display = 'none';
      var cc = document.getElementById(viewId + '-content');
      if (cc && cc.style.display === 'none') {
        var ee = document.getElementById(viewId + '-error');
        if (ee) { ee.style.display = 'block'; ee.textContent = 'Still getting this ready for you. Give it a moment, or refresh to try again.'; }
      }
    }
  }, _LOADER_SAFETY_NET_MS_);
}

function showContent(viewId) {
  // 2026-08-11: guard against a slow background fetch un-hiding a view the admin
  // has already navigated away from. Every genuine caller passes the SAME viewId
  // it is loading data for (verified: all 34 call sites in this file), so a
  // mismatch here always means the load finished late, after switchView already
  // moved STATE.currentView on. Without this, the fetch's stale showContent()
  // still fires and snaps the page back, e.g. Pipeline's ~7-10s cold GAS load
  // finishing after the admin already clicked to another page.
  //
  // Safe for every view including the comms compose sub-views: comms-compose-sms
  // and comms-compose-email are static HTML with their own #view-* wrapper and
  // NO -loader/-content split, so nothing ever calls showContent('comms-compose-sms')
  // or showContent('comms-compose-email'), confirmed by grep, zero hits. They are
  // shown purely by switchView's classList toggle, never by this function.
  //
  // 2026-08-18 correction: the 2026-08-11 comment above claimed every genuine
  // caller passes the SAME viewId it is loading data for -- true for 33 of the
  // 34 call sites, but wrong for loadServiceBookingView(), which reuses the
  // internal-booking DOM panel (no separate #view-service-booking liquid panel
  // exists) and therefore calls showContent('internal-booking') while
  // STATE.currentView holds 'service-booking'. That single-string mismatch made
  // this guard block the S.O. picker's reveal on every load -- stuck forever on
  // "Loading booking form..." even though the service grid rendered correctly
  // underneath. See BRIEFS/HANDOFF-internal-service-booker-stuck-loading-2026-08-18.md.
  // Special-cased narrowly (only this known pairing, now extended to a third
  // equivalent id) so the guard's protection for every other call site is
  // unchanged. The free-styling-booking variant of this special case (added
  // 2026-10-01, removed same day) is gone now that Free Styling Session is a
  // tile in the shared service grid (ibSelectFreeStylingTile_) rather than
  // its own STATE.currentView value.
  //
  // 'booking' added 2026-10-10 (IB Phase 2,
  // BRIEFS/SCOPE-admin-internal-booking-master-2026-10-09.md §3): the
  // brief's canonical new view id, a third name for the SAME shared
  // view-internal-booking panel, same equivalence-class pattern as
  // service-booking above.
  var _ibEquivViews_ = { 'internal-booking': 1, 'service-booking': 1, 'booking': 1 };
  var _effectiveView = (viewId === 'internal-booking' && _ibEquivViews_[STATE.currentView])
    ? STATE.currentView : viewId;
  if (_effectiveView !== STATE.currentView) return;
  clearTimeout(_loaderTimers[viewId]);
  var l = document.getElementById(viewId + '-loader');
  var c = document.getElementById(viewId + '-content');
  var e = document.getElementById(viewId + '-error');
  if (l) l.style.display = 'none';
  if (c) c.style.display = '';
  // 2026-08-26 (BRIEFS/BUG-admin-crm-stale-error-banner-after-late-success-2026-08-26.md):
  // a load that ultimately succeeds, just slowly, could leave a stale error banner
  // permanently visible if showLoader's safety-net timer had already fired and written
  // the banner text before this function ran (clearTimeout on an already-fired timer is
  // a no-op, and this function previously never touched -error at all). A successful
  // render must always win over any earlier stale-timer banner regardless of firing
  // order, so explicitly hide/clear -error here too, same as -loader.
  if (e) { e.style.display = 'none'; e.textContent = ''; }
  // Mark this view's content as genuinely painted (2026-08-26, same fix), so a LATER
  // stale/duplicate error response for the same view (e.g. a second in-flight call
  // landing after the first one already succeeded) is recognised by showError below
  // and suppressed instead of overwriting real content with a spurious error banner.
  // Generalises the existing window._jvIslandPainted guard (2026-07-31), which only
  // covered CDN-island-backed views, to every view using this loader/content/error triad.
  _viewContentPainted[viewId] = true;
}

function showError(viewId, msg) {
  clearTimeout(_loaderTimers[viewId]);
  // 2026-07-31 (permanent local-first fix): if this view already painted from a CDN island,
  // a later background-verify/refresh failure must NOT replace the painted content with an
  // error. The admin already has correct, fast data; a slow GAS verify is invisible by
  // design. Only genuine cold failures (nothing painted) still surface the error.
  if (window._jvIslandPainted === true) {
    try { console.warn('[adminCrm] verify failed for "' + viewId + '" but island already painted; error suppressed: ' + (msg || '')); } catch (e0) {}
    var _l0 = document.getElementById(viewId + '-loader');
    if (_l0) _l0.style.display = 'none';
    return;
  }
  // 2026-08-26 (BRIEFS/BUG-admin-crm-stale-error-banner-after-late-success-2026-08-26.md):
  // same principle as the CDN-island guard above, generalised to every view. If this
  // view's content has already genuinely rendered via showContent() during the CURRENT
  // load cycle, a stale/duplicate error response arriving afterwards (e.g. a second
  // in-flight call for the same view landing late) must not overwrite/co-display with
  // real, already-correct content. The admin already has the data; suppress the error
  // the same way the island-painted case does. A genuine failure where nothing has
  // rendered yet still surfaces normally below, unaffected by this check.
  if (_viewContentPainted[viewId] === true) {
    try { console.warn('[adminCrm] error for "' + viewId + '" arrived after content already painted; suppressed: ' + (msg || '')); } catch (e1) {}
    var _l1 = document.getElementById(viewId + '-loader');
    if (_l1) _l1.style.display = 'none';
    return;
  }
  var l = document.getElementById(viewId + '-loader');
  var e = document.getElementById(viewId + '-error');
  if (l) l.style.display = 'none';
  if (e) {
    e.style.display = 'block';
    // T5: friendly, on-brand, actionable — never a raw error string front-and-centre.
    // The technical message is still reachable (support/debugging) behind a <details>.
    var safeMsg = (typeof escHtml === 'function') ? escHtml(msg || 'Unknown error') : String(msg || 'Unknown error');
    var safeView = (typeof escAttr === 'function') ? escAttr(viewId) : viewId;
    e.innerHTML =
      '<div style="margin-bottom:0.6rem;">We had trouble loading this. Please try again.</div>' +
      '<button type="button" class="btn btn-ghost" style="font-size:0.72rem;" onclick="jvRetryView_(\'' + safeView + '\')">Try again</button>' +
      '<details style="margin-top:0.6rem;"><summary style="cursor:pointer;color:var(--text-light);font-size:0.7rem;">Technical details</summary>' +
      '<div style="font-size:0.7rem;color:var(--text-light);margin-top:0.25rem;">' + safeMsg + '</div></details>';
  }
  // Speed guard recovery (2026-07-17): a view whose load FAILED must not stay
  // marked "loaded" (that would strand the admin on the error with no retry on
  // re-switch). Clearing the flag makes the next hash/tab switch re-attempt the load.
  if (typeof _viewLoaded !== 'undefined') _viewLoaded[viewId] = false;
}

// T5 error-state retry: routes to each view's real re-fetch entry point so "Try
// again" behaves identically to that view's own Refresh button.
function jvRetryView_(viewId) {
  if (viewId === 'clients') { loadClientsView(true); return; }
  if (viewId === 'pipeline') { loadPipelineView(true); return; }
  if (typeof lazyLoadView === 'function') lazyLoadView(viewId, true);
}

/* ============================================================
   NAV GROUP (SUB-MENU) HELPERS
   ============================================================ */
function toggleNavGroup(name) {
  var grp = document.getElementById('navgroup-' + name);
  if (grp) grp.classList.toggle('open');
}
function closeNavGroup(name) {
  var grp = document.getElementById('navgroup-' + name);
  if (grp) grp.classList.remove('open');
}
function openProposalBuilder() {
  window.location.href = '/pages/proposal-builder';
}
function openRunsheetBuilder() {
  window.location.href = '/pages/runsheet-app';
}

/* ============================================================
   SIDEBAR TOGGLE
   ============================================================ */
var sidebarCollapsed = false;
function toggleSidebar() {
  sidebarCollapsed = !sidebarCollapsed;
  var s = document.getElementById('sidebar');
  var m = document.getElementById('main-content');
  if (sidebarCollapsed) { s.classList.add('collapsed'); m.classList.add('collapsed'); }
  else { s.classList.remove('collapsed'); m.classList.remove('collapsed'); }
}

/* ============================================================
   INTELLIGENCE STRIP COLLAPSE
   ============================================================ */
var INTEL_KEY = 'jv_intel_minimised';

function toggleIntelStrip() {
  var wrap = document.getElementById('intel-strip-wrap');
  var isMin = wrap.classList.toggle('minimised');
  try { localStorage.setItem(INTEL_KEY, isMin ? '1' : '0'); } catch(e) {}
}

function restoreIntelStrip() {
  try {
    var stored = localStorage.getItem(INTEL_KEY);
    if (stored === '1') {
      var wrap = document.getElementById('intel-strip-wrap');
      if (wrap) wrap.classList.add('minimised');
    }
  } catch(e) {}
}

// Same collapse/persist pattern as toggleIntelStrip/restoreIntelStrip above,
// own localStorage key so the two strips remember their state independently.
var PUBLISH_INTEGRITY_KEY = 'jv_admin_publish_integrity_minimised';
function togglePublishIntegrityStrip() {
  var wrap = document.getElementById('publish-integrity-strip-wrap');
  if (!wrap) return;
  var isMin = wrap.classList.toggle('minimised');
  try { localStorage.setItem(PUBLISH_INTEGRITY_KEY, isMin ? '1' : '0'); } catch (e) {}
}
/* MINIMISED BY DEFAULT (2026-09-12, external UX review "Critical: navigation
   appears broken").

   This used to open EXPANDED unless localStorage said otherwise, and the strip
   renders above every view with no height cap, so a fresh browser put the
   Create New Invoice form at roughly y=1620 -- below the fold. An explicit
   click appeared to do nothing, which is a worse failure than a tall panel:
   the admin reasonably concludes the button is broken and clicks again.

   The severity is inverted from how it first reads. The strip self-hides when
   there is nothing to report, so it only occupies that space when there IS
   pending publish work -- exactly when the admin is busiest and least able to
   afford it above the thing she just clicked.

   DEFAULT FLIPPED, PREFERENCE STILL HONOURED. Only an explicit '0' (the admin
   opened it herself) expands it now; unset or '1' stays minimised. So anyone who
   deliberately opens it keeps it open across reloads, and the toggle is
   unchanged -- it is one click away and the badge still reports state while
   collapsed. This hides chrome, never information.

   Deliberately NOT auto-expanding on a problem state. That would reintroduce
   the same displacement at the exact moment the admin is trying to work, and it
   is what the badge already exists to communicate. */
function restorePublishIntegrityStrip() {
  try {
    var wrap = document.getElementById('publish-integrity-strip-wrap');
    if (!wrap) return;
    var stored = localStorage.getItem(PUBLISH_INTEGRITY_KEY);
    if (stored !== '0') wrap.classList.add('minimised');
  } catch (e) {
    // Storage unavailable (private mode, blocked cookies): still minimise, so
    // the failure mode is a collapsed panel rather than a displaced page.
    try {
      var w = document.getElementById('publish-integrity-strip-wrap');
      if (w) w.classList.add('minimised');
    } catch (_) {}
  }
}

/* ============================================================
   VIEW SWITCHING
   ============================================================ */
var VIEW_META = {
  'pipeline':       { title: 'Pipeline CRM', subtitle: 'All active clients' },
  'clients':        { title: 'All Clients', subtitle: 'Search and manage client records' },
  'comms':          { title: 'Comms', subtitle: 'Communications log' },
  'comms-compose-sms':   { title: 'Send SMS', subtitle: 'Compose and send an SMS message' },
  'comms-compose-email': { title: 'Send Email', subtitle: 'Compose and send an email' },
  'comms-templates':     { title: 'Email Templates', subtitle: 'Manage reusable email templates' },
  'proposals':         { title: 'Proposals', subtitle: 'Manage client proposals' },
  'proposals-pending': { title: 'Proposals — Awaiting Response', subtitle: 'Sent but not yet accepted or signed' },
  'invoicing':      { title: 'Invoicing', subtitle: 'Invoice records and payment status' },
  'invoice-new':    { title: 'Create New Invoice', subtitle: 'Build and send an invoice' },
  'runsheets':      { title: 'Runsheets', subtitle: 'All runsheet files' },
  'calendar':       { title: 'Calendar', subtitle: 'Scheduling and events' },
  'studio-booking': { title: 'Studio Schedule', subtitle: 'Team deployment and rostering calendar' },
  'studio-schedule':      { title: 'Studio Schedule', subtitle: 'Day View — Team Dispatch' },
  'studio-schedule-week': { title: 'Studio Schedule', subtitle: 'Week View — Team Overview' },
  'internal-booking':     { title: 'Book for a Client', subtitle: 'Trials, special occasion services and Free Styling sessions, booked on a client\'s behalf' },
  'service-booking':      { title: 'Book for a Client', subtitle: 'Trials, special occasion services and Free Styling sessions, booked on a client\'s behalf' },
  // 'booking' (IB Phase 2, 2026-10-10, BRIEFS/SCOPE-admin-internal-booking-master-2026-10-09.md
  // §3): the brief's canonical new view id. Reuses the SAME unified shared panel the 2026-10-06
  // UNIFIED change already built for internal-booking/service-booking -- there is no separate
  // feature to build here, 'booking' is a third equivalent id in the existing redirect pattern
  // (see showContent's _effectiveView guard + loadInternalBookingView/loadServiceBookingView
  // below). /pages/admin-crm#booking is the brief's named URL.
  'booking':              { title: 'New Booking', subtitle: 'Trials, special occasion services and Free Styling sessions, booked on a client\'s behalf' },
  'analytics':      { title: 'Analytics', subtitle: 'Business performance metrics' },
  'reports':        { title: 'Reports', subtitle: 'Detailed reports' },
  'automations':    { title: 'Automations', subtitle: 'Configure automated workflows' },
  'settings':       { title: 'Settings', subtitle: 'System configuration' },
  'audit-log':      { title: 'Audit Log', subtitle: 'System event history' },
  'shopify-sync':   { title: 'Shopify Sync', subtitle: 'Sync status and triggers' },
  'moxie-migration':{ title: 'Moxie Migration', subtitle: 'Migration status' },
  'client-portal-preview': { title: 'Client Portal Preview', subtitle: 'See the portal exactly as a bride sees it' },
  'xero-repair':    { title: 'Xero Tools', subtitle: 'Xero data repair utilities' },
  'notifications':  { title: 'Notifications', subtitle: 'System notifications' },
  'forms-inbox':    { title: 'Form Submissions', subtitle: 'All inbound form responses across every form' },
  'addons-queue':   { title: 'Add-On Approvals', subtitle: 'Approve or decline post-booking add-on requests' },
  'team':           { title: 'Team Roster', subtitle: 'Every current artist' }
};

// 2026-08-11: tracks whether switchView has ever actually applied a view this
// page load, so the boot sequence's own re-application calls (see
// applyInitialPayload_ below) can tell "nothing has run yet" apart from "the
// admin has since navigated away". Flipped true the first time switchView
// completes a real switch (i.e. runs past its same-view early return).
var _switchViewRanOnce_ = false;

function switchView(viewId, skipHash) {
  // BUGFIX 2026-08-07: normalise a deep-link query HERE, at the single choke
  // point, rather than in each caller.
  //
  // The Partners nav entry links to #clients?type=partner. I stripped the query
  // in the two HASH routers (initial load, popstate) but missed the nav CLICK
  // interceptor, which is the path an admin actually uses. It passed the raw
  // "clients?type=partner" straight in, which missed VIEW_META, so the header
  // fell back to printing the id verbatim as the page title and lazyLoadView
  // matched no case and loaded nothing: a literal "clients?type=partner"
  // heading above a blank page.
  //
  // Fixing it at each entry point is what caused the bug (2 of 3 hardened).
  // Every caller funnels through here, so normalising once means no future
  // caller can reintroduce it. The query itself is still read straight off
  // location.hash by applyClientsDeepLinkFilter_, so the filter still applies.
  var _viewQuery = '';
  var _q = String(viewId || '').indexOf('?');
  if (_q !== -1) {
    _viewQuery = String(viewId).substring(_q + 1);
    viewId = String(viewId).substring(0, _q);
  }

  // 2026-08-07: the same-view early return would swallow a deep link fired while
  // ALREADY on that view, e.g. sitting on Clients and clicking Partners, which
  // is both plausible and confusing (nothing at all would happen). Apply the
  // query and re-filter in place, then return, rather than re-running the whole
  // view switch.
  if (STATE.currentView === viewId) {
    try {
      // 2026-08-16: the SAME skipHash guard as the main body below (~line 577).
      // STATE.currentView defaults to 'pipeline' (see STATE init), and
      // _initialView also defaults to 'pipeline' when the URL has no hash, so
      // the FIRST boot call on a clean /pages/admin-crm visit always matched
      // this early-return branch, not the main switchView body -- meaning the
      // skipHash fix added there for the boot-path callers never actually ran,
      // because control flow never reached it. This branch's own
      // history.replaceState was unconditional and is the REAL cause of the
      // URL bar being rewritten to #pipeline on a clean visit.
      if (!skipHash) {
        history.replaceState({ view: viewId }, '', '#' + viewId + (_viewQuery ? '?' + _viewQuery : ''));
      }
      if (_viewQuery) {
        if (typeof applyClientsDeepLinkFilter_ === 'function' && applyClientsDeepLinkFilter_()) {
          if (typeof filterClientsList === 'function') filterClientsList();
        }
      } else if (viewId === 'clients') {
        // 2026-08-07: clicking "All Clients" while already on the Partners-filtered
        // list did NOTHING (confirmed live, reproduced 3x). Both links resolve to
        // the same view, so this early return fired and the Partners filter stayed
        // applied with no way back except a manual dropdown change. A link with NO
        // query means "show me everything", so honour that by clearing the filter.
        var _catEl = document.getElementById('clients-category-filter');
        if (_catEl && _catEl.value) {
          _catEl.value = '';
          if (typeof filterClientsList === 'function') filterClientsList();
        }
      }
    } catch (e) {}
    return;
  }
  STATE.currentView = viewId;
  _switchViewRanOnce_ = true;
  // A team-member drawer left open would sit over the next view (QA 2026-10-06). It is view-scoped, so close it on any real view switch.
  try { if (document.getElementById('team-member-drawer') && typeof closeTeamMemberDrawer === 'function') closeTeamMemberDrawer(); } catch (e) {}
  // 2026-08-07 (2nd fix): clear a stale category filter on a FULL view switch too.
  // My first attempt only cleared it inside onClientsLoaded, which does not run
  // when returning to an already-loaded Clients view, so Partners -> Pipeline ->
  // All Clients still showed only partners (confirmed live: hash was the clean
  // "#clients" yet the control still read "__partner"). Navigating here with no
  // query means "show everything", so honour that at the point of navigation
  // rather than depending on a data reload that may never happen.
  //
  // The re-filter below is NOT optional: 'clients' is in the GUARDED set, so a
  // revisit calls showContent and returns WITHOUT repainting. Clearing the
  // control alone would leave the previously-filtered rows on screen while the
  // dropdown claimed "All Types", which is worse than the bug it replaces.
  if (viewId === 'clients' && !_viewQuery) {
    var _staleCat = document.getElementById('clients-category-filter');
    if (_staleCat && _staleCat.value) {
      _staleCat.value = '';
      if (STATE.clients && typeof filterClientsList === 'function') {
        try { filterClientsList(); } catch (e) {}
      }
    }
  }
  // Deactivate all views and nav elements
  document.querySelectorAll('.view').forEach(function(v){ v.classList.remove('active'); });
  document.querySelectorAll('.nav-item').forEach(function(n){ n.classList.remove('active'); });
  document.querySelectorAll('.nav-sub-item').forEach(function(n){ n.classList.remove('active'); });
  document.querySelectorAll('.nav-group-toggle').forEach(function(n){ n.classList.remove('active'); });
  // Activate target view
  var v = document.getElementById('view-' + viewId);
  if (v) v.classList.add('active');
  // Activate matching nav-item (regular) or nav-sub-item
  var navEl = document.querySelector('.nav-item[data-view="' + viewId + '"]');
  if (navEl) navEl.classList.add('active');
  var subEl = document.querySelector('.nav-sub-item[data-view="' + viewId + '"]');
  if (subEl) {
    subEl.classList.add('active');
    // Also mark the parent group toggle as active and open the group
    var grp = subEl.closest('.nav-group');
    if (grp) {
      grp.classList.add('open');
      var toggle = grp.querySelector('.nav-group-toggle');
      if (toggle) toggle.classList.add('active');
    }
  }
  // KPI overview strip is pipeline-only
  var intelWrap = document.getElementById('intel-strip-wrap');
  if (intelWrap) intelWrap.style.display = (viewId === 'pipeline') ? '' : 'none';
  // Update header
  // Fallback title is the raw viewId, so an unmatched id renders as a literal
  // heading. That is how "clients?type=partner" appeared as the page title with
  // a blank body: the deep-link query reached here unstripped from the nav click
  // path, missed VIEW_META, printed itself, and lazyLoadView loaded nothing.
  // switchView now normalises at the top (see the query strip there), so this
  // fallback should only ever fire for a genuinely unknown view.
  var meta = VIEW_META[viewId] || { title: viewId, subtitle: '' };
  document.getElementById('topbar-title').textContent = meta.title;
  document.getElementById('topbar-subtitle').textContent = meta.subtitle;
  // Update URL hash for back/forward navigation.
  // 2026-08-07: preserve the deep-link query. viewId was stripped at the top of
  // this function, so writing '#' + viewId here would DESTROY "?type=partner"
  // before applyClientsDeepLinkFilter_ (which reads location.hash) ever sees it,
  // leaving the Partners entry on an unfiltered client list. Re-attach it.
  if (!skipHash) {
    try {
      history.pushState({ view: viewId }, '', '#' + viewId + (_viewQuery ? '?' + _viewQuery : ''));
    } catch(e) {}
  }
  // Notify canonical nav (jv-app-nav) to sync active state
  try {
    window.dispatchEvent(new CustomEvent('jv:view-changed', { detail: { view: viewId } }));
  } catch(e) {}
  // Real bug found 2026-09-11 (Cowork nightly-batch finding: the Partners sidebar
  // link renders the full unfiltered client list). The ONLY other place this
  // function applies a clients deep-link filter is the STATE.currentView ===
  // viewId early-return branch above (admin already ON Clients, clicking
  // Partners again), and onClientsLoaded (fires only when loadClientsView()
  // actually runs a fresh load). Neither covers navigating INTO Clients with a
  // deep-link query from a DIFFERENT view once Clients has already loaded once
  // this session: lazyLoadView's GUARDED load-once gate below skips
  // loadClientsView() entirely, onClientsLoaded never fires, and the filter is
  // silently never applied even though STATE.clients is already populated and
  // ready to filter right now. Apply it here too, unconditionally, so the
  // filter is honoured on this path regardless of whether a reload happens.
  if (viewId === 'clients' && _viewQuery) {
    try {
      if (typeof applyClientsDeepLinkFilter_ === 'function' && applyClientsDeepLinkFilter_()) {
        if (STATE.clients && typeof filterClientsList === 'function') filterClientsList();
      }
    } catch (e) {}
  }
  // Lazy load
  lazyLoadView(viewId);
}

/* ============================================================
   CANONICAL NAV CLICK INTERCEPTION (2026-05-28)
   jv-app-nav links to /pages/admin-crm#<view>. On the hub itself,
   intercept those clicks and call switchView() instead of reloading.
   Cross-page links (/pages/booking-settings etc.) navigate normally.
   ============================================================ */
(function wireCanonicalNavInterception() {
  if (typeof document === 'undefined') return;
  function bind() {
    document.addEventListener('click', function(e) {
      var a = e.target && e.target.closest ? e.target.closest('a.jv-nav__item, a.jv-nav__sub-item') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      // Only intercept hub hash links on the hub page itself
      var m = href.match(/^\/pages\/admin-crm#(.+)$/);
      if (!m) return;
      // Allow modified clicks (new tab, etc.) to behave normally
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      var view = m[1];
      if (typeof switchView === 'function') {
        switchView(view);
      } else {
        try { location.hash = '#' + view; } catch(_e) {}
      }
    }, false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* Hash-based navigation for browser back/forward buttons */
window.addEventListener('popstate', function(e) {
  var viewId = (e.state && e.state.view) || (location.hash ? location.hash.substring(1) : '') || 'pipeline';
  // 2026-08-06: same query-strip as the initial-load path, so back/forward onto
  // a deep link (#clients?type=partner) resolves to the view, not to pipeline.
  if (viewId.indexOf('?') !== -1) viewId = viewId.substring(0, viewId.indexOf('?'));
  if (VIEW_META[viewId]) {
    switchView(viewId, true);
  }
});

// Speed (2026-07-17): the "heavy" views below re-fired their full GAS load on
// EVERY hash/tab switch (analytics was ~4 cold calls, ~30s, every visit). We now
// load each once and keep it, mirroring the existing pipeline/clients guards.
// _viewLoaded tracks first-load; switchView-with-force + each view's Refresh button
// pass force=true to bypass and re-pull. A view stays "loaded" for the page session;
// its own Refresh control is the freshness escape hatch (added where missing).
var _viewLoaded = {};
function jvRefreshView(viewId) {
  // Called by the per-view Refresh buttons. Clears the load flag and re-runs the
  // loader live. Also resets the view's data array so an empty re-pull is honoured.
  _viewLoaded[viewId] = false;
  lazyLoadView(viewId, true);
}

function lazyLoadView(viewId, force) {
  // Load-once guard for the heavy views (skip if already loaded this session unless forced).
  // Guard only the clearly-heavy, safe-to-cache-for-the-session data views. Config
  // pages (settings/automations/audit-log/shopify-sync/forms-inbox/addons-queue) are
  // left unguarded, they are lower-traffic and some want freshness on every open.
  var GUARDED = { analytics:1, proposals:1, 'proposals-pending':1, invoicing:1, runsheets:1, comms:1, notifications:1, clients:1, team:1 };
  if (GUARDED[viewId] && !force && _viewLoaded[viewId]) { showContent(viewId); return; }
  if (GUARDED[viewId]) _viewLoaded[viewId] = true; // mark loaded now; if the load FAILS, showError() clears this flag so the next switch retries
  switch(viewId) {
    case 'pipeline':      if (!STATE.pipeline) loadPipelineView(); break;
    // PERF FIX 2026-07-23: do NOT gate on `!STATE.clients` — pipeline_syncStateClients_
    // pre-seeds STATE.clients (a thinner dataset, for drawer lookups) before the Clients
    // tab is ever opened, since pipeline is the default landing view. That made this
    // condition false on the FIRST visit to Clients, so loadClientsView() (the only thing
    // that reads the CDN island and calls renderClientsList) never ran, leaving the view
    // stuck on the static "Loading clients…" placeholder forever. `clients` is now in
    // GUARDED above, which is the sole load-once gate; loadClientsView() itself already
    // paints from the island (or falls back live) and is safe to call unconditionally here.
    case 'clients':        loadClientsView(); break;
    case 'comms':         loadCommsView(); break;
    case 'comms-compose-sms':   initComposeSms(); break;
    case 'comms-compose-email': initComposeEmail(); break;
    case 'comms-templates':     loadCommsTemplatesView(); break;
    case 'proposals':         loadProposalsView(); break;
    case 'proposals-pending': loadProposalsPendingView(); break;
    case 'invoicing':     loadInvoicingView(); break;
    case 'invoice-new':   showContent('invoice-new'); _invoiceLineItems = []; _invoiceClientId = ''; invoiceNewInit_(); break;
    case 'runsheets':     loadRunsheetsView(); break;
    case 'calendar':      loadCalendarView(); break;
    case 'studio-booking':loadStudioBookingView(); break;
    case 'studio-schedule':      loadDispatchView('day'); break;
    case 'studio-schedule-week': loadDispatchView('week'); break;
    case 'internal-booking':     loadInternalBookingView(); break;
    case 'service-booking':      loadServiceBookingView(); break;
    case 'booking':              loadInternalBookingView(); break;
    case 'analytics':     loadAnalyticsView(); break;
    case 'reports':       loadReportsView(); break;
    case 'automations':   loadAutomationsView(); break;
    case 'settings':      loadSettingsView(); break;
    case 'audit-log':     loadAuditLogView(0); break;
    case 'shopify-sync':  loadShopifySyncView(); break;
    case 'moxie-migration': loadMoxieMigrationView(); break;
    case 'xero-repair':   break;
    case 'notifications': loadNotificationsView(); break;
    case 'forms-inbox':   loadFormsInbox(); break;
    case 'addons-queue':  loadAddOnsQueueView(); break;
    case 'client-portal-preview': initClientPortalPreviewView(); break;
    case 'team':          loadTeamRosterView(); break;
  }
}

/* ============================================================
   MOBILE TAB BAR
   ============================================================ */
function setMobileTab(id) {
  document.querySelectorAll('.mobile-tab').forEach(function(t){ t.classList.remove('active'); });
  var el = document.getElementById('mob-tab-' + id);
  if (el) el.classList.add('active');
}
/* ---- Mobile More drawer (P1-01/P4-05) ---- */
var JV_MORE_NAV_ITEMS = [
  { id: 'pipeline',   label: 'Pipeline',   icon: '<svg viewBox="0 0 24 24"><rect x="2" y="3" width="6" height="18" rx="1"/><rect x="9" y="7" width="6" height="14" rx="1"/><rect x="16" y="11" width="6" height="10" rx="1"/></svg>' },
  { id: 'comms',      label: 'Comms',      icon: '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' },
  { id: 'calendar',   label: 'Calendar',   icon: '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' },
  { id: 'invoicing',  label: 'Invoicing',  icon: '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>' },
  { id: 'proposals',  label: 'Proposals',  icon: '<svg viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>' },
  { id: 'runsheets',  label: 'Runsheets',  icon: '<svg viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>' },
  { id: 'settings',   label: 'Settings',   icon: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>' }
];

function showMobileMenu() {
  var existing = document.getElementById('jv-more-overlay');
  if (existing) { existing.classList.add('open'); return; }

  var overlay = document.createElement('div');
  overlay.id = 'jv-more-overlay';
  overlay.className = 'jv-more-overlay open';
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hideMobileMenu();
  });

  var items = JV_MORE_NAV_ITEMS.map(function(nav) {
    return '<button class="jv-more-item" onclick="hideMobileMenu();switchView(\'' + nav.id + '\')">' +
      nav.icon + '<span>' + nav.label + '</span></button>';
  }).join('');

  overlay.innerHTML = '<div class="jv-more-sheet">' +
    '<div class="jv-more-handle"></div>' +
    '<div class="jv-more-title">All Views</div>' +
    '<div class="jv-more-grid">' + items + '</div></div>';

  document.body.appendChild(overlay);
}

function hideMobileMenu() {
  var overlay = document.getElementById('jv-more-overlay');
  if (overlay) overlay.classList.remove('open');
}

/* ============================================================
   KPI OVERVIEW — server-computed via adminApi_getKpiOverview
   Replaces the old client-computed 5-tile intel strip.
   ============================================================ */
var _kpiOverviewInFlight = false;
var _kpiOverviewLastFetchMs = 0;
var KPI_OVERVIEW_THROTTLE_MS = 2000;

// KPI strip is now ISLAND-ONLY, NEVER a live GAS call (2026-07-17, Jess).
// adminApi_getKpiOverview took 30s+ and TIMED OUT the relay (30s ceiling) on every
// admin-crm open (3 times per load), throwing "upstream timed out" and dragging the
// whole page. KPI is non-essential on the main client screen, so we do NOT call it
// live any more. If the pipeline island (_PIPELINE_INLINE_) carries a warmed `kpi`
// payload (populated by JV_adminCrmPipelineCache_warmNow), we paint it for free with
// zero GAS. If not, the strip is simply hidden. `force` is honoured only to re-read
// the island (e.g. after a background pipeline refresh), never to hit GAS.
function loadKpiOverview(force) {
  try {
    var kpi = (typeof _PIPELINE_INLINE_ !== 'undefined' && _PIPELINE_INLINE_ && _PIPELINE_INLINE_.kpi) ? _PIPELINE_INLINE_.kpi : null;
    var cards = kpi && Array.isArray(kpi.cards) ? kpi.cards : null;
    if (cards && cards.length) {
      renderKpiOverview(cards);
    } else {
      // No warmed KPI on the island: hide the strip rather than block on a 30s call.
      var host = document.getElementById('kpi-overview');
      var wrap = document.getElementById('intel-strip') || (host && host.closest ? host.closest('.intel-strip') : null);
      if (wrap) { wrap.style.display = 'none'; }
      else if (host) { host.innerHTML = ''; }
    }
  } catch (e) { /* non-fatal: KPI is cosmetic */ }
}

// Back-compat shim — the old function is still called from 3 sites after
// pipeline/proposals loads. Delegate to the throttled loader.
function updateIntelStrip(_pipelineItems, _proposalsData) {
  loadKpiOverview(false);
}

/* Publish integrity readiness card (2026-09-03).
   HANDOFF-publish-integrity-admin-card-to-admin-crm-2026-09-03.md, Runsheet
   Builder finding 1, Part 4. Surfaces upcoming weddings whose latest runsheet
   publish had an incomplete downstream step. Zero-GAS: reads D1 directly via
   the App-Proxy-verified 'publish-integrity' entity, same trust chain and
   transport pattern as the live partner-dashboard fast path
   (assets/jv-partner-portal.js tryPartnerDashboardCdnFastPath_).

   STATE MODEL (SYSTEMS/State_Modelling, trust and business state kept
   separate, "empty" and "unknown" never share copy):
     checking          -> "Checking..." (empty-unconfirmed, request in flight)
     empty-confirmed   -> "All recent publishes are complete." (rows:[] really
                           means nothing incomplete, not "we don't know yet")
     has-items         -> populated list, one row per incomplete wedding
     error             -> hidden entirely (see the render-error function below
                           for why, not the same copy as empty-confirmed)
   The card starts hidden (style="display:none" in the Liquid) so a slow/failed
   check never leaves a broken-looking empty shell on screen; it only reveals
   itself once a real state (empty-confirmed or has-items) is known. A
   non-admin, or any page load where window._jvAdminProxyBase was never
   emitted (see the Liquid gate), gets a silent no-op, never a stuck spinner. */
function adminPublishIntegrity_init() {
  var base = window._jvAdminProxyBase;
  if (!base) return; // not an admin session (see Liquid gate), nothing to do

  var wrap = document.getElementById('publish-integrity-strip-wrap');
  var body = document.getElementById('publish-integrity-body');
  var badge = document.getElementById('publish-integrity-badge');
  if (!wrap || !body) return;

  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var url = String(base).replace(/\/+$/, '') + '/partner/publish-integrity/read';

  nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({})
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (!res || res.ok !== true || !Array.isArray(res.rows)) {
        adminPublishIntegrity_renderError_(wrap, body, badge);
        return;
      }
      if (!res.rows.length) {
        adminPublishIntegrity_renderEmpty_(wrap, body, badge);
        return;
      }
      adminPublishIntegrity_renderRows_(wrap, body, badge, res.rows);
    })
    .catch(function () {
      adminPublishIntegrity_renderError_(wrap, body, badge);
    });
}

function adminPublishIntegrity_renderEmpty_(wrap, body, badge) {
  wrap.style.display = '';
  if (badge) badge.style.display = 'none';
  body.innerHTML = '<div class="publish-integrity-empty">All recent publishes are complete.</div>';
}

function adminPublishIntegrity_renderError_(wrap, body, badge) {
  // Deliberately hidden, not shown with error copy: this is a nice-to-have
  // operational visibility card (per the handoff, "no urgency"), and a
  // transient App Proxy hiccup showing a permanent-looking error banner on
  // every admin page load would be worse than staying quiet and letting the
  // next page load try again. Logged for diagnosability, never surfaced.
  wrap.style.display = 'none';
  if (badge) badge.style.display = 'none';
  try { console.warn('[jv-admin-crm] publish-integrity read failed (non-fatal, card hidden)'); } catch (e) {}
}

function adminPublishIntegrity_renderRows_(wrap, body, badge, rows) {
  wrap.style.display = '';
  if (badge) {
    badge.style.display = '';
    badge.textContent = String(rows.length);
  }
  var stepLabels = {
    step_metafield_synced: 'Shopify sync',
    step_party_blob_synced: 'Party blob sync',
    step_artists_synced: 'Artist sync',
    step_calendar_synced: 'Calendar sync',
    step_comms_sent: 'Comms'
  };
  function failedSteps(row) {
    return Object.keys(stepLabels)
      .filter(function (k) { return Number(row[k]) !== 1; })
      .map(function (k) { return stepLabels[k]; });
  }
  var html = rows.map(function (row) {
    var missing = failedSteps(row);
    var dateStr = row.wedding_date ? escHtml(String(row.wedding_date)) : '';
    var noteHtml = row.step_failure_notes
      ? '<div class="publish-integrity-note">' + escHtml(String(row.step_failure_notes)) + '</div>'
      : '';
    return '<div class="publish-integrity-row">' +
      '<div class="publish-integrity-row__main">' +
        '<span class="publish-integrity-row__name">' + escHtml(String(row.bride_name || row.bride_email || 'Unknown')) + '</span>' +
        (dateStr ? '<span class="publish-integrity-row__date">' + dateStr + '</span>' : '') +
      '</div>' +
      '<div class="publish-integrity-row__steps">' + missing.map(function (m) {
        return '<span class="publish-integrity-chip">' + escHtml(m) + '</span>';
      }).join('') + '</div>' +
      noteHtml +
    '</div>';
  }).join('');
  body.innerHTML = html;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', adminPublishIntegrity_init);
} else {
  adminPublishIntegrity_init();
}

/* ============================================================
   D1 BRIDE SEARCH (2026-09-25). Cloudflare-first, NO GAS FALLBACK.
   ============================================================
   Slice 1 of state/findings/PLAN-admin-crm-cloudflare-first-migration-
   2026-09-25.md. Per the Consolidator's explicit direction (2026-09-25,
   citing CLAUDE.md's 2026-09-19 escalation, "we are moving off gas...
   there should be no fallback its lazy! just make it watertight"): this
   is a DELIBERATE departure from every other D1-first switch on this
   project (notes/profile/partner/invoice/runsheet caches), all of which
   silently fall back to a GAS call on any D1 failure. THIS helper never
   calls GAS. If D1 is unreachable or the mirror is stale, the caller
   sees a clear "search unavailable, retrying" state, not a silent GAS
   rescue.

   HARD PREREQUISITE, NOT YET LIVE. The bride-search Worker route
   (handleBrideSearch, jv-crm-mirror/worker.js) had NO freshness/
   staleness guard when this was written, a real gap, since removing
   the GAS fallback makes a stale-but-unflagged mirror a silent-wrong-
   data risk, exactly what this project's own non-negotiable rule
   ("degrade to slow, never to wrong") bans. Fix spec'd and handed to
   Cloudflare/Edge: state/findings/HANDOFF-bride-search-staleness-guard-
   to-cloudflare-edge-2026-09-25.md. adminD1SearchBrides_ below is built
   assuming that fix lands (it treats a _staleData/_d1Miss response as a
   normal watertight-retry failure, same as a network error). DO NOT
   flip ADMIN_D1_SEARCH_ENABLED_ until that fix is confirmed deployed.

   FLAG: ADMIN_D1_SEARCH_ENABLED_ below, hardcoded false. When false,
   adminD1SearchBrides_ never makes a network call and immediately
   resolves { ok: false, error: 'flag_disabled' }. Every caller (today:
   none; this is the template for Comms' commsDoSearch switch) must
   treat that as "not available yet", not an error worth surfacing
   loudly.

   WATERTIGHT SHAPE, per Consolidator direction verbatim:
     - Idempotent GET-shaped read (query params only, no side effects),
       safe to retry freely.
     - Automatic retries with backoff: 3 attempts, 300ms/900ms between.
     - Every attempt distinguishes "genuinely no results" (ok:true,
       empty array) from "the call itself failed" (network error, non-
       2xx, _staleData/_d1Miss). Only the latter triggers a retry.
     - After all retries are exhausted, the caller gets an explicit
       { ok:false, error:'d1_exhausted', attempts:3 } result, never a
       silent empty array standing in for "we don't actually know".
     - No GAS call anywhere in this function, ever, by design.
   ============================================================ */
var ADMIN_D1_SEARCH_ENABLED_ = false; // flip only after the jfg live check + the staleness-guard fix are both confirmed deployed
var ADMIN_D1_SEARCH_MAX_ATTEMPTS_ = 3;
var ADMIN_D1_SEARCH_BACKOFF_MS_ = [300, 900]; // delay BEFORE attempt 2, attempt 3 respectively

/**
 * D1-only bride search. Query params, GET-shaped (idempotent, safe to
 * retry), same relay entity 'bride-search' action 'search' already live
 * on the Worker (state/findings/PATCH-admin-search-storm-fix-and-d1-
 * 2026-09-23.md). Returns the SAME field shape as bridge_admin_searchBrides
 * minus rowIndex (by design, see the Worker handler's own header comment;
 * a caller must key on brideUid/email, never rowIndex, for any follow-up
 * action against a result from this function).
 *
 * @param {string} query - search text (name/email/phone substring)
 * @return {Promise<{ok:boolean, data?:Array, error?:string, attempts?:number}>}
 */
function adminD1SearchBrides_(query, callerEnabled) {
  if (!ADMIN_D1_SEARCH_ENABLED_ && callerEnabled !== true) {
    return Promise.resolve({ ok: false, error: 'flag_disabled' });
  }
  var base = window._jvAdminProxyBase;
  if (!base) return Promise.resolve({ ok: false, error: 'proxy_unavailable' });
  var q = String(query || '').trim();
  if (!q) return Promise.resolve({ ok: true, data: [] });

  var url = String(base).replace(/\/+$/, '') + '/partner/bride-search/search';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);

  function attempt(n) {
    return nf(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ q: q })
    })
      .then(function (r) {
        return r.json().then(function (parsedBody) {
          return { httpOk: r.ok, httpStatus: r.status, body: parsedBody };
        });
      })
      .then(function (res) {
        var body = res.body;
        // A real result: ok:true with a data array (empty array is a
        // legitimate "no matches", not a failure, must NOT retry that).
        if (res.httpOk && body && body.ok === true && Array.isArray(body.data)) {
          return { ok: true, data: body.data, attempts: n };
        }
        // Anything else (network-level non-2xx, ok:false, _staleData,
        // _d1Miss, malformed body) is a genuine failure worth retrying.
        var failReason = (body && (body.reason || body.error)) || ('http_' + res.httpStatus);
        return retryOrGiveUp_(n, failReason);
      })
      .catch(function (err) {
        return retryOrGiveUp_(n, 'network_error: ' + String((err && err.message) || err));
      });
  }

  function retryOrGiveUp_(n, reason) {
    if (n >= ADMIN_D1_SEARCH_MAX_ATTEMPTS_) {
      try { console.error('[adminD1SearchBrides_] exhausted ' + ADMIN_D1_SEARCH_MAX_ATTEMPTS_ + ' attempts, last reason: ' + reason); } catch (e) {}
      return { ok: false, error: 'd1_exhausted', lastReason: reason, attempts: n };
    }
    var delay = ADMIN_D1_SEARCH_BACKOFF_MS_[n - 1] || 900;
    return new Promise(function (resolve) {
      setTimeout(function () { resolve(attempt(n + 1)); }, delay);
    });
  }

  return attempt(1);
}

/**
 * Shows a persistent, unmissable "search unavailable" state in the given
 * container element, the frontend half of "fail loud", per the
 * Consolidator's watertight-search direction. Deliberately NOT a toast
 * (a toast auto-dismisses after about 3s; an admin mid-search must not
 * lose the signal that their search silently isn't working). Includes a
 * manual Retry button, no auto-retry loop beyond the 3 attempts already
 * spent inside adminD1SearchBrides_ itself, to avoid hammering a genuinely
 * down backend.
 *
 * KNOWN GAP, FLAGGED NOT BUILT: this function surfaces the failure to the
 * ADMIN AT THE KEYBOARD only. It does not page/alert Jess or anyone else
 * out-of-band (no admin Chat webhook call exists from the frontend on
 * this project, every Chat alert is server-side). If out-of-band
 * alerting on a search outage is wanted, that is new small infra (a
 * fire-and-forget failure-telemetry beacon a Worker route could relay to
 * Chat), not built here, flagged for a separate decision rather than
 * assumed in scope for "wire the frontend switch".
 *
 * @param {HTMLElement} container
 * @param {string} reason
 * @param {Function} onRetry - called with no args when Retry is clicked
 */
function adminD1SearchShowUnavailable_(container, reason, onRetry) {
  if (!container) return;
  container.innerHTML = '';
  var wrap = document.createElement('div');
  wrap.setAttribute('role', 'alert');
  wrap.style.cssText = 'padding:12px 14px;font-size:12px;color:#9a2020;background:#fdf1f0;border:1px solid #f0d0cc;border-radius:8px;';
  wrap.textContent = 'Search unavailable, retrying failed (' + (reason || 'unknown error') + '). ';
  var retryBtn = document.createElement('button');
  retryBtn.type = 'button';
  retryBtn.textContent = 'Retry';
  retryBtn.style.cssText = 'margin-left:6px;padding:2px 10px;border-radius:6px;border:1px solid #9a2020;background:#fff;color:#9a2020;cursor:pointer;font-size:12px;';
  retryBtn.onclick = function () { if (typeof onRetry === 'function') onRetry(); };
  wrap.appendChild(retryBtn);
  container.style.display = 'block';
  container.appendChild(wrap);
}

function renderKpiOverview(cards, globalError) {
  var host = document.getElementById('kpi-overview');
  if (!host) return;
  if (globalError && (!cards || !cards.length)) {
    host.innerHTML = '<div class="kpi-card kpi-card--error" role="alert">' +
      '<div class="kpi-card__eyebrow">KPI OVERVIEW</div>' +
      '<div class="kpi-card__empty">Unavailable · ' + escHtml(globalError) + '</div>' +
      '</div>';
    return;
  }
  if (!cards || !cards.length) { host.innerHTML = ''; return; }
  host.innerHTML = cards.map(renderKpiCard).join('');
}

function renderKpiCard(card) {
  if (!card) return '';
  var tier = card.tier || 'operational';
  var stateClass = 'kpi-card--' + (card.state || 'ok');
  var tierClass = 'kpi-card--' + tier;
  var eyebrow = escHtml(card.eyebrow || '');

  // Error / empty / insufficient_data degraded states
  if (card.state === 'error') {
    return '<div class="kpi-card ' + tierClass + ' ' + stateClass + '" role="alert">' +
      '<div class="kpi-card__eyebrow">' + eyebrow + '</div>' +
      '<div class="kpi-card__empty">Unavailable · retry</div>' +
      '</div>';
  }
  if (card.state === 'empty') {
    return '<div class="kpi-card ' + tierClass + ' ' + stateClass + '">' +
      '<div class="kpi-card__eyebrow">' + eyebrow + '</div>' +
      '<div class="kpi-card__empty">No data yet</div>' +
      (card.contextLabel ? '<div class="kpi-card__context">' + escHtml(card.contextLabel) + '</div>' : '') +
      '</div>';
  }
  if (card.state === 'insufficient_data') {
    return '<div class="kpi-card ' + tierClass + ' ' + stateClass + '">' +
      '<div class="kpi-card__eyebrow">' + eyebrow + '</div>' +
      '<div class="kpi-card__empty">Insufficient data</div>' +
      (card.insufficientReason ? '<div class="kpi-card__context">' + escHtml(card.insufficientReason) + '</div>' : '') +
      '</div>';
  }

  // OK state — full editorial card
  var html = '<div class="kpi-card ' + tierClass + ' ' + stateClass + '" data-kpi-id="' + escHtml(card.id) + '">';
  html += '<div class="kpi-card__eyebrow">' + eyebrow;
  // Pro Team Profit-Per-Wedding cards (Session 3) flag pure-estimate state so
  // Jess can see at a glance which cards have no actuals declared yet. Tiny
  // inline pill — does not interrupt the editorial card hierarchy.
  if (card.isEstimate) {
    html += ' <span class="kpi-card__est-pill" title="No actuals declared yet — value is from rate-card estimate">Est.</span>';
  }
  html += '</div>';
  html += '<div class="kpi-card__value">' + escHtml(card.valueFormatted || '') + '</div>';

  if (card.pctOfTarget != null && card.target) {
    html += renderKpiArc(card.pctOfTarget);
  }

  if (card.contextLabel) {
    html += '<div class="kpi-card__context">' + escHtml(card.contextLabel) + '</div>';
  }

  if (card.trend) html += renderKpiTrend(card.trend);
  if (card.sparkline && card.sparkline.length) html += renderKpiSparkline(card.sparkline);
  if (card.breakdown && card.breakdown.length) html += renderKpiBreakdown(card.breakdown);

  html += '</div>';
  return html;
}

function renderKpiArc(pct) {
  var p = Math.max(0, Math.min(100, Number(pct) || 0));
  // 270° arc — radius 40, circumference = 2πr ≈ 251.33, 270° = 188.5
  var arcLen = 188.5;
  var filled = (p / 100) * arcLen;
  var gap = arcLen - filled;
  return '<svg class="kpi-card__arc" viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
    '<path class="kpi-card__arc-track" d="M 22 78 A 40 40 0 1 1 78 78" fill="none" stroke-linecap="round"/>' +
    '<path class="kpi-card__arc-fill" d="M 22 78 A 40 40 0 1 1 78 78" fill="none" stroke-linecap="round" ' +
    'stroke-dasharray="' + filled.toFixed(1) + ' ' + gap.toFixed(1) + '"/>' +
    '<text class="kpi-card__arc-label" x="50" y="60" text-anchor="middle">' + p + '%</text>' +
    '</svg>';
}

function renderKpiTrend(trend) {
  var direction = trend.direction || 'flat';
  var icons = { up: '▲', down: '▼', flat: '·', 'new': '○', unknown: '?' };
  var tags  = { up: 'ahead', down: 'behind', flat: 'flat', 'new': 'new', unknown: 'unknown' };
  var icon = icons[direction] || '·';
  var tag = tags[direction] || direction;
  var deltaText = trend.deltaLabel ? ' ' + escHtml(trend.deltaLabel) : '';
  var compareText = trend.compareLabel ? ' ' + escHtml(trend.compareLabel) : '';
  var leapNote = trend.yoyAnchorNote === 'leap_year_coerced'
    ? ' <span class="kpi-card__leap-note" tabindex="0" aria-label="Feb 29 not available in prior year — compared against Feb 28" title="Feb 29 not available in prior year — compared against Feb 28">ⓘ</span>'
    : '';

  return '<div class="kpi-card__delta kpi-card__delta--' + direction + '">' +
    '<span class="kpi-card__delta-icon" aria-hidden="true">' + icon + '</span>' +
    '<span class="kpi-card__delta-tag" aria-label="trend: ' + tag + '">' + tag + '</span>' +
    '<span class="kpi-card__delta-text">' + deltaText + compareText + '</span>' +
    leapNote +
    '</div>';
}

function renderKpiSparkline(points) {
  if (!points || points.length < 2) return '';
  var vals = points.map(function(p) { return Number(p.value) || 0; });
  var max = Math.max.apply(null, vals) || 1;
  var w = 200, h = 28;
  var step = w / (points.length - 1);
  var d = vals.map(function(v, i) {
    var x = (i * step).toFixed(1);
    var y = (h - (v / max) * h).toFixed(1);
    return (i === 0 ? 'M ' : 'L ') + x + ' ' + y;
  }).join(' ');
  return '<svg class="kpi-card__sparkline" viewBox="0 0 ' + w + ' ' + h + '" aria-hidden="true" focusable="false" preserveAspectRatio="none">' +
    '<path d="' + d + '" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
}

function renderKpiBreakdown(breakdown) {
  if (!breakdown || !breakdown.length) return '';
  var html = '<ul class="kpi-card__breakdown">';
  breakdown.forEach(function(item) {
    var label = escHtml(item.label || '');
    // Pro Team cards (Session 3) attach contextLabel per breakdown row
    // (e.g. "57.3% · 12 weddings"). Render alongside the main label when present.
    var ctx = item.contextLabel ? ' <span class="kpi-card__breakdown-ctx">' + escHtml(item.contextLabel) + '</span>' : '';
    if (item.href) {
      html += '<li><a href="' + escHtml(item.href) + '" class="kpi-card__breakdown-link">' + label + ctx + '</a></li>';
    } else {
      html += '<li>' + label + ctx + '</li>';
    }
  });
  html += '</ul>';
  return html;
}

/* ============================================================
   PIPELINE VIEW
   ============================================================ */
function loadPipelineView(forceRefresh) {
  loadPipelineViewWithStages(forceRefresh);
}

/* ============================================================
   K.2 — PIPELINE SORT
   ============================================================ */
var PIPELINE_SORT_KEY = 'jv_pipeline_sort';

function getPipelineSortValue() {
  try { return localStorage.getItem(PIPELINE_SORT_KEY) || 'last-activity'; } catch(e) { return 'last-activity'; }
}

function setPipelineSortValue(val) {
  try { localStorage.setItem(PIPELINE_SORT_KEY, val); } catch(e) {}
}

/**
 * Injects the sort dropdown into .pipeline-header-bar if not already present.
 * Called once from onPipelineLoaded.
 */
function buildPipelineSortControl() {
  var bar = document.getElementById('pipeline-header-bar-right');
  if (!bar) {
    // Fallback: find the header bar and inject a right-side container
    var headerBar = document.querySelector('.pipeline-header-bar');
    if (!headerBar) return;
    // Check if sort wrap already present
    if (headerBar.querySelector('.pipeline-sort-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pipeline-sort-wrap';
    wrap.id = 'pipeline-sort-wrap';
    var currentSort = getPipelineSortValue();
    wrap.innerHTML = '<label for="pipeline-sort-select">Sort:</label>' +
      '<select class="pipeline-sort-select" id="pipeline-sort-select" onchange="onPipelineSortChange(this.value)">' +
      '<option value="last-activity"' + (currentSort === 'last-activity' ? ' selected' : '') + '>Last activity</option>' +
      '<option value="wedding-date"' + (currentSort === 'wedding-date' ? ' selected' : '') + '>Wedding date</option>' +
      '<option value="alphabetical"' + (currentSort === 'alphabetical' ? ' selected' : '') + '>A – Z</option>' +
      '<option value="date-added"' + (currentSort === 'date-added' ? ' selected' : '') + '>Date added</option>' +
      '</select>';
    // Insert before the Stages button (last child of header bar)
    var stagesBtn = headerBar.querySelector('.btn-manage-stages');
    if (stagesBtn) {
      headerBar.insertBefore(wrap, stagesBtn);
    } else {
      headerBar.appendChild(wrap);
    }
  }
}

function onPipelineSortChange(val) {
  setPipelineSortValue(val);
  if (STATE.pipeline) renderKanban(STATE.pipeline.items || []);
}

/**
 * Sort pipeline items client-side according to current sort preference.
 * Returns a NEW array — does not mutate the original.
 */
function sortPipelineItems(items) {
  var sort = getPipelineSortValue();
  var sorted = items.slice(); // copy
  sorted.sort(function(a, b) {
    if (sort === 'alphabetical') {
      var la = (a.lastName || '').toLowerCase(), lb = (b.lastName || '').toLowerCase();
      if (la !== lb) return la < lb ? -1 : 1;
      var fa = (a.firstName || a.name || '').toLowerCase(), fb = (b.firstName || b.name || '').toLowerCase();
      return fa < fb ? -1 : fa > fb ? 1 : 0;
    }
    if (sort === 'wedding-date') {
      var wa = a.weddingDate || '9999-99-99';
      var wb = b.weddingDate || '9999-99-99';
      return wa < wb ? -1 : wa > wb ? 1 : 0;
    }
    if (sort === 'date-added') {
      // rowIndex is a proxy for CRM entry order
      return (a.rowIndex || a.id || 0) - (b.rowIndex || b.id || 0);
    }
    // default: last-activity — most recent first
    var ta = a.lastActivityTs || a.enquiryDate || '1970-01-01';
    var tb = b.lastActivityTs || b.enquiryDate || '1970-01-01';
    return ta > tb ? -1 : ta < tb ? 1 : 0;
  });
  return sorted;
}

function onPipelineLoaded(data) {
  STATE.pipeline = data;
  // Instant-paint fallback (2026-06-27): flatten the pipeline into STATE.clients so
  // findClientById() resolves on a cold drawer open. Without this STATE.clients is
  // only populated when the Clients tab is visited, so opening a bride straight from
  // the pipeline left the drawer on a blank skeleton for ~16s until the async bundle
  // landed (read as "broken empty Facets" in the Grade-3 audit). The hero now paints
  // from pipeline data immediately while the bundle hydrates the facets behind it.
  pipeline_syncStateClients_(data);

  // Build dynamic filter bar with counts (including Closed)
  var stageCounts = data.stageCounts || {};
  buildStageFilterBar(stageCounts);

  // K.2 — inject sort control (once; idempotent)
  buildPipelineSortControl();

  // Handle current filter
  var kanbanBoard = document.getElementById('kanban-board');
  var closedContainer = document.getElementById('closed-leads-container');

  if (STATE.currentStageFilter === 'Closed') {
    kanbanBoard.style.display = 'none';
    closedContainer.style.display = '';
    renderClosedLeads(data.closedClients || []);
  } else {
    kanbanBoard.style.display = 'flex';
    closedContainer.style.display = 'none';
    renderKanban(data.items || []);
  }

  showContent('pipeline');
  document.getElementById('pipeline-loader').style.display = 'none';

  // Update intel strip
  updateIntelStrip(data.items || [], null);

  // If cache returned active-only (Enquiry leads excluded to fit 100KB cache limit),
  // silently reload full data in background so Enquiry column populates
  if (data.enquiryNotCached) {
    setTimeout(function() {
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getPipelineAndStages', args: { token: STATE.token, refresh: true } })
        .then(function(res) { if (res.ok) { var _h = function(res) {
              if (!res || !res.pipeline) return;
              var fullData = res.pipeline;
              STATE.pipeline = fullData;
              // Re-flatten once Enquiry leads arrive (they're excluded from the first
              // cached payload to fit the 100KB limit) so a cold drawer open on an
              // Enquiry-stage bride also has the instant-paint fallback.
              pipeline_syncStateClients_(fullData);
              if (STATE.currentStageFilter === 'All' || STATE.currentStageFilter === 'Enquiry') {
                renderKanban(fullData.items || []);
              }
              updateIntelStrip(fullData.items || [], null);
            }; _h(res.data); } })
        .catch(function() {});
    }, 500);
  }

  // Dataset too large for single payload — fetch each stage individually and merge progressively
  if (data.countOnly) {
    var _stagesToLoad = PIPELINE_STAGES.slice();
    var _mergedItems = [];
    function _loadNextStage() {
      if (!_stagesToLoad.length) {
        STATE.pipeline.items = _mergedItems;
        STATE.pipeline.countOnly = false;
        renderKanban(_mergedItems);
        updateIntelStrip(_mergedItems, null);
        return;
      }
      var _stage = _stagesToLoad.shift();
      jvBridge.callAdmin('bridge_admin_getPipeline', { stageFilter: _stage, refresh: true })
        .then(function(res) {
          var _pd = (res && res.ok && res.data) ? res.data : null;
          if (_pd && _pd.items && _pd.items.length) {
            _mergedItems = _mergedItems.concat(_pd.items);
            STATE.pipeline.items = _mergedItems.slice();
            renderKanban(STATE.pipeline.items);
          }
          _loadNextStage();
        })
        .catch(function() { _loadNextStage(); });
    }
    setTimeout(_loadNextStage, 200);
  }
}

var CARDS_PER_STAGE = 20;
var stageOffsets = {}; // how many cards visible per stage

// Confirmed whole-pipeline-empty state (checklist item 12, external GPT design
// pack BRIEFS/CRM-kanban-empty-state-deliverables.zip, 2026-09-07). Per that
// pack's own state model: zero records is DATA, not an error, and a
// stage-FILTERED zero (currentStageFilter != 'All') is a DIFFERENT state
// (filtered-empty) that must keep the normal Kanban columns visible, not this
// panel. This branch only fires when the unfiltered item count is genuinely
// zero AND no stage filter narrows the view, so it can never fire on a loading
// or error path (renderKanban is only ever called after pipeline data has
// actually resolved) and can never be confused with "this one stage has no
// cards right now".
function jvKanbanEmptyState_shouldShow_(items) {
  return Array.isArray(items) && items.length === 0 && STATE.currentStageFilter === 'All';
}

function jvKanbanEmptyState_toggle_(show) {
  var panel = document.getElementById('jv-kanban-empty');
  var board = document.getElementById('kanban-board');
  if (panel) panel.style.display = show ? '' : 'none';
  if (board) board.style.display = show ? 'none' : 'flex';
}

function renderKanban(items) {
  // K.2, sort items before rendering
  items = sortPipelineItems(items);

  if (jvKanbanEmptyState_shouldShow_(items)) {
    jvKanbanEmptyState_toggle_(true);
    var boardForEmpty = document.getElementById('kanban-board');
    if (boardForEmpty) boardForEmpty.innerHTML = '';
    return;
  }
  jvKanbanEmptyState_toggle_(false);

  var board = document.getElementById('kanban-board');
  board.innerHTML = '';
  stageOffsets = {}; // reset on full re-render

  var dynamicStages = STATE.pipelineStages || PIPELINE_STAGES;
  var stagesFilter = STATE.currentStageFilter === 'All' ? dynamicStages : [STATE.currentStageFilter];

  stagesFilter.forEach(function(stage) {
    var stageItems = items.filter(function(c){ return c.stage === stage; });
    var col = document.createElement('div');
    col.className = 'kanban-col';
    col.dataset.stage = stage;
    var colHtml = '<div class="kanban-col-header">';
    colHtml += '<span class="stage-name">' + escHtml(stageDisplay(stage)) + '</span>';
    colHtml += '<span class="col-count">' + stageItems.length + '</span>';
    colHtml += '</div>';
    colHtml += '<div class="kanban-cards" data-stage="' + escHtml(stage) + '" ';
    colHtml += 'ondragover="dragOver(event)" ondrop="dropCard(event, \'' + escHtml(stage) + '\')">';

    // Lazy load: only show first CARDS_PER_STAGE cards
    var limit = CARDS_PER_STAGE;
    var visible = stageItems.slice(0, limit);
    var remaining = stageItems.length - visible.length;

    visible.forEach(function(c) {
      colHtml += renderKanbanCard(c);
    });
    colHtml += '</div>';

    // "Load More" button if remaining cards
    if (remaining > 0) {
      colHtml += '<button class="load-more-btn" data-stage="' + escAttr(stage) + '" onclick="loadMoreCards(\'' + escAttr(stage) + '\')">' +
        'Load ' + Math.min(remaining, CARDS_PER_STAGE) + ' more (' + remaining + ' remaining)</button>';
    }

    col.innerHTML = colHtml;
    board.appendChild(col);
  });
  initKanbanDragDrop();
}

function loadMoreCards(stage) {
  stageOffsets[stage] = (stageOffsets[stage] || CARDS_PER_STAGE) + CARDS_PER_STAGE;
  var items = sortPipelineItems((STATE.pipeline && STATE.pipeline.items) || []);
  var stageItems = items.filter(function(c){ return c.stage === stage; });
  var limit = stageOffsets[stage];
  var visible = stageItems.slice(0, limit);
  var remaining = stageItems.length - visible.length;

  // Find the column and re-render just that column's cards
  var colEl = document.querySelector('.kanban-col[data-stage="' + stage + '"]');
  if (!colEl) return;
  var cardsContainer = colEl.querySelector('.kanban-cards');
  if (cardsContainer) {
    var cardsHtml = '';
    visible.forEach(function(c) { cardsHtml += renderKanbanCard(c); });
    cardsContainer.innerHTML = cardsHtml;
  }

  // Update or remove Load More button
  var existingBtn = colEl.querySelector('.load-more-btn');
  if (existingBtn) {
    if (remaining > 0) {
      existingBtn.textContent = 'Load ' + Math.min(remaining, CARDS_PER_STAGE) + ' more (' + remaining + ' remaining)';
    } else {
      existingBtn.remove();
    }
  }

  initKanbanDragDrop();
}

function renderClientCard(c) {
  var initials = getInitials(c.name);
  var stageCls = stageBadgeClass(c.stage);
  var services = Array.isArray(c.services) ? c.services : (c.services ? [c.services] : []);
  var serviceChips = services.slice(0,2).map(function(s){ return '<span class="service-chip">' + escHtml(s) + '</span>'; }).join('');
  var flagDots = '';
  if (!c.hasRunsheet) flagDots += '<span class="flag-dot red"><span class="dot-tip">No runsheet</span></span>';
  if (!c.hasTrial && (c.stage === 'Booked' || c.stage === 'Onboarding' || c.stage === 'Trial')) {
    flagDots += '<span class="flag-dot amber"><span class="dot-tip">No trial booked</span></span>';
  }
  if (c.balanceDue && Number(c.balanceDue) > 0) {
    flagDots += '<span class="flag-dot teal"><span class="dot-tip">Balance owing</span></span>';
  }
  var dPill = daysPill(c.weddingDate);
  // Partner marker (2026-08-06). Replaces the old hardcoded EBM-only badge: EBM
  // is just one partner, and a partner-managed bride was otherwise
  // indistinguishable from a direct bride on the board (she only showed
  // "Managed by X" once the drawer was opened). That blind spot is why partner
  // brides went unverified. Names the actual partner where known, and falls back
  // to the EBM badge so nothing regresses if partnerAccountName is blank on an
  // older cached payload.
  var partnerName_ = String(c.partnerAccountName || '').trim();
  var isEbmPending_ = c.externalBookingSource === 'EBM' && c.stage === 'Enquiry';
  var ebmBadge;
  if (isEbmPending_) {
    // 2026-08-18, held EBM enquiry, not yet promoted to Booked. Distinct
    // from the routine EBM/partner badge below so Jess can see at a glance
    // which EBM rows still need her review before invoicing/onboarding.
    // Falls back to the normal badge automatically once promoted (c.stage
    // stops being 'Enquiry'), no extra state to track or clean up.
    ebmBadge = '<span class="badge badge--ebm-pending" title="New EBM enquiry, not yet reviewed. Promote to Booked when ready to invoice + onboard.">EBM &middot; Pending Approval</span>';
  } else if (partnerName_) {
    ebmBadge = '<span class="badge badge--ebm" title="Managed by ' + escAttr(partnerName_) +
      ', billed to the partner, not to the bride">' + escHtml(partnerName_) + '</span>';
  } else if (c.externalBookingSource === 'EBM') {
    ebmBadge = '<span class="badge badge--ebm">EBM</span>';
  } else {
    ebmBadge = '';
  }
  return '<div class="client-card" data-client-id="' + escHtml(c.id) + '" draggable="true" ' +
    'ondragstart="dragStart(event, \'' + escHtml(c.id) + '\')" ' +
    'onclick="openDrawer(\'' + escHtml(c.id) + '\')">' +
    '<div class="card-row1">' +
    '<div class="avatar-circle">' + escHtml(initials) + '</div>' +
    '<div class="card-name">' + escHtml(c.name) + '</div>' +
    '<div class="card-wedding-date">' + formatDate(c.weddingDate) + '</div>' +
    '</div>' +
    '<div class="card-row2">' +
    '<span class="stage-badge ' + stageCls + '">' + escHtml(stageDisplay(c.stage)) + '</span>' +
    ebmBadge +
    serviceChips +
    dPill +
    '</div>' +
    (flagDots ? '<div class="flag-dots">' + flagDots + '</div>' : '') +
    '<div class="card-actions">' +
    '<button class="card-action-btn" onclick="event.stopPropagation(); openRunsheet(\'' + escHtml(c.id) + '\')">' +
    '<svg viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>Runsheet' +
    '</button>' +
    '<button class="card-action-btn" onclick="event.stopPropagation(); openClientComms(\'' + escHtml(c.id) + '\')">' +
    '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Comms' +
    '</button>' +
    '<button class="card-action-btn" onclick="event.stopPropagation(); openDrawer(\'' + escHtml(c.id) + '\')">' +
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>Detail' +
    '</button>' +
    '</div>' +
    '</div>';
}

/* ============================================================
   POLISHED KANBAN CARD — renderKanbanCard + helpers
   ============================================================ */
function renderKanbanCard(c) {
  var initials = getInitials(c.name);
  var wdStr = c.weddingDate ? formatDate(c.weddingDate) : '—';
  var daysPillHtml = buildDaysPill(c.weddingDate);
  var svcChips = buildServiceChips(c.services);
  var flags = buildFlagDots(c);
  var cardId = 'kcard-' + escAttr(c.id || c.email || '');
  // Partner marker (2026-08-06). Replaces the old hardcoded EBM-only badge: EBM
  // is just one partner, and a partner-managed bride was otherwise
  // indistinguishable from a direct bride on the board (she only showed
  // "Managed by X" once the drawer was opened). That blind spot is why partner
  // brides went unverified. Names the actual partner where known, and falls back
  // to the EBM badge so nothing regresses if partnerAccountName is blank on an
  // older cached payload.
  var partnerName_ = String(c.partnerAccountName || '').trim();
  var isEbmPending_ = c.externalBookingSource === 'EBM' && c.stage === 'Enquiry';
  var ebmBadge;
  if (isEbmPending_) {
    // 2026-08-18, held EBM enquiry, not yet promoted to Booked. Distinct
    // from the routine EBM/partner badge below so Jess can see at a glance
    // which EBM rows still need her review before invoicing/onboarding.
    // Falls back to the normal badge automatically once promoted (c.stage
    // stops being 'Enquiry'), no extra state to track or clean up.
    ebmBadge = '<span class="badge badge--ebm-pending" title="New EBM enquiry, not yet reviewed. Promote to Booked when ready to invoice + onboard.">EBM &middot; Pending Approval</span>';
  } else if (partnerName_) {
    ebmBadge = '<span class="badge badge--ebm" title="Managed by ' + escAttr(partnerName_) +
      ', billed to the partner, not to the bride">' + escHtml(partnerName_) + '</span>';
  } else if (c.externalBookingSource === 'EBM') {
    ebmBadge = '<span class="badge badge--ebm">EBM</span>';
  } else {
    ebmBadge = '';
  }
  // TBC pill: bride's WEDDING LOCATION === 'TBC' — surface so Jess can chase
  // the getting-ready address from the kanban view.
  var tbcPill = c.weddingLocationTbc
    ? '<span class="kc-tbc-pill" title="Bride hasn’t confirmed where she’s getting ready yet">TBC: address</span>'
    : '';

  return '<div class="kanban-card' + attentionCardClass_(c) + '" id="' + cardId + '"' +
    ' draggable="true"' +
    ' data-id="' + escAttr(c.id) + '"' +
    ' data-stage="' + escAttr(c.stage) + '"' +
    ' data-name="' + escAttr(c.name || '') + '"' +
    ' data-email="' + escAttr(c.email || '') + '"' +
    ' onmouseenter="prefetchDrawerBundleOnHover_(this.getAttribute(\'data-id\'))"' +
    ' onmouseleave="cancelDrawerBundlePrefetch_()"' +
    ' onclick="openDrawer(\'' + escAttr(c.id) + '\')"' +
    ' ondragstart="onCardDragStart(event, \'' + escAttr(c.id) + '\', \'' + escAttr(c.stage) + '\')">' +
    '<button class="kc-menu-btn" onclick="event.stopPropagation(); toggleCardMenu(this, \'' + escAttr(c.id) + '\', \'' + escAttr(c.name || '') + '\')" title="Actions">&#8942;</button>' +
    '<div class="kc-row1">' +
      '<div class="kc-avatar">' + escHtml(initials) + '</div>' +
      '<div class="kc-name">' + stripTagsAndEscape_(c.name || '—') + '</div>' +
      '<div class="kc-wdate">' + escHtml(wdStr) + '</div>' +
    '</div>' +
    '<div class="kc-row2">' +
      '<span class="stage-badge ' + stageBadgeClass(c.stage) + '">' + escHtml(stageDisplay(c.stage)) + '</span>' +
      ebmBadge +
      tbcPill +
      svcChips +
      daysPillHtml +
    '</div>' +
    (flags ? '<div class="kc-flags">' + flags + '</div>' : '') +
    '<div class="kc-footer" onclick="event.stopPropagation();">' +
      '<button class="kc-footer-btn" onclick="openRunsheet(\'' + escAttr(c.id) + '\')">Runsheet</button>' +
      '<button class="kc-footer-btn" onclick="openClientComms(\'' + escAttr(c.id) + '\')">Comms</button>' +
      (c.stage === 'Proposal Drafted for Review'
        ? '<button class="kc-footer-btn kc-footer-btn--approve" onclick="pipelineApproveSend(this)" data-bride="' + escAttr(c.name || '') + '" data-email="' + escAttr(c.email || '') + '" title="Review proposal in builder before sending">Approve &amp; Send</button>'
        : '<button class="kc-footer-btn" onclick="openDrawer(\'' + escAttr(c.id) + '\')">Detail →</button>') +
    '</div>' +
  '</div>';
}

function buildDaysPill(weddingDate) {
  if (!weddingDate) return '';
  var wd = parseDate(weddingDate);
  if (!wd || isNaN(wd)) return '';
  var now = new Date(); now.setHours(0,0,0,0);
  var days = Math.round((wd - now) / 86400000);
  if (days < 0) return '<span class="kc-days-pill past">' + Math.abs(days) + 'd ago</span>';
  var cls = days <= 30 ? 'red' : days <= 90 ? 'amber' : 'muted';
  return '<span class="kc-days-pill ' + cls + '">' + days + 'd</span>';
}

function buildServiceChips(services) {
  if (!services) return '';
  var arr = Array.isArray(services) ? services : String(services).split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  var html = '';
  var max = 3;
  arr.slice(0, max).forEach(function(s) {
    html += '<span class="kc-svc-chip">' + escHtml(s) + '</span>';
  });
  if (arr.length > max) html += '<span class="kc-svc-chip">+' + (arr.length - max) + '</span>';
  return html;
}

function buildFlagDots(c) {
  var html = '';
  if (!c.hasRunsheet) html += '<div class="kc-flag-dot red" title="No runsheet"></div>';
  if (!c.hasTrialDate && c.stage !== 'Enquiry' && c.stage !== 'Quoted')
    html += '<div class="kc-flag-dot amber" title="No trial booked"></div>';
  if (c.balanceOwing && Number(c.balanceOwing) > 0)
    html += '<div class="kc-flag-dot teal" title="Balance owing: $' + Number(c.balanceOwing).toFixed(0) + '"></div>';
  // Gap #3 — needs-attention flag (baked into pipeline cache by NeedsAttentionResolver.gs)
  if (c.attention && c.attention.flag) {
    var sev = c.attention.maxSeverity || 'info';
    var label = (c.attention.top && c.attention.top.label) ? c.attention.top.label : 'Needs attention';
    var sevClass = sev === 'escalated' ? 'attention-escalated' : (sev === 'warn' ? 'attention-warn' : 'attention-info');
    html += '<div class="kc-attention-dot ' + sevClass + '" title="' + escAttr(label) + '" aria-label="' + escAttr(label) + '"></div>';
  }
  return html;
}

/**
 * Gap #3: returns the attention border class for a kanban card.
 * escalated → rose left-border; warn → thin left-border; info → none.
 */
function attentionCardClass_(c) {
  if (!c || !c.attention || !c.attention.flag) return '';
  var sev = c.attention.maxSeverity || 'info';
  if (sev === 'escalated') return ' kc-attention-escalated';
  if (sev === 'warn')      return ' kc-attention-warn';
  return '';
}

/* ============================================================
   TOAST HELPER
   ============================================================ */
function jvToast(msg, type) {
  var container = document.getElementById('jv-toast-container');
  if (!container) return;
  var el = document.createElement('div');
  el.className = 'jv-toast ' + (type || 'success');
  el.textContent = msg;
  container.appendChild(el);
  setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 3200);
}

/* ============================================================
   P4.1 (master brief): ONE honest action-response + toast helper.
   Phantom-success kept recurring because the FE only checked res.ok and the BE
   returned ok:true regardless of outcome. jvActionResolve_ normalises ANY bridge
   reply into a single { success, status, message } shape; jvActionToast shows a
   SUCCESS toast ONLY when the action verifiably happened (status done/sent/queued)
   and the honest state otherwise (blocked, deferred, rate-limited, no-op, error).
   status in {done, sent, queued, deferred, blocked_safe_mode, blocked_quiet_hours,
              rate_limited, no_op, error}
   ============================================================ */
function jvActionResolve_(res) {
  // doPost-level safe-mode block: { ok:false, blocked:'safe_mode', message }
  if (res && res.ok === false && res.blocked) {
    return { success: false,
             status: (res.blocked === 'safe_mode' ? 'blocked_safe_mode' : String(res.blocked)),
             message: res.message || ('Blocked: ' + res.blocked) };
  }
  // Bridge-level failure
  if (res && res.ok === false) {
    return { success: false, status: 'error',
             message: (res.error && res.error.message) || res.error || res.message || 'Request failed.' };
  }
  // res.ok === true: inspect the handler's own return (res.data), tolerate un-enveloped res
  var d = (res && res.data != null) ? res.data : (res || {});
  if (d && d.safeMode === true) {
    return { success: false, status: 'blocked_safe_mode', message: d.message || 'Blocked: safe mode is active.' };
  }
  if (d && d.deferred === true) {
    return { success: false, status: 'deferred', message: d.message || 'Deferred: outside contact hours. Will send after 8am Sydney.' };
  }
  var st = (d && d.status) ? String(d.status).toLowerCase() : '';
  switch (st) {
    case 'blocked_safe_mode':
    case 'blocked':
      return { success: false, status: 'blocked_safe_mode', message: d.message || 'Blocked: safe mode is active.' };
    case 'blocked_quiet_hours':
    case 'deferred':
      return { success: false, status: 'deferred', message: d.message || 'Deferred: outside contact hours. Will send after 8am Sydney.' };
    case 'rate_limited':
      return { success: false, status: 'rate_limited', message: d.message || 'Rate-limited, please try again shortly.' };
    case 'no_op':
      return { success: false, status: 'no_op', message: d.message || 'No change made.' };
    case 'error':
      return { success: false, status: 'error', message: d.error || d.message || 'Action failed.' };
  }
  var ok = !!(d && (d.ok === true || d.success === true)) || (!!st && st !== 'error');
  if (ok) {
    var good = (st === 'sent' || st === 'queued' || st === 'done' || st === '');
    return { success: good, status: st || 'done', message: d.message || '' };
  }
  return { success: false, status: 'error', message: (d && (d.error || d.message)) || 'Action failed.' };
}

function jvActionToast(res, opts) {
  opts = opts || {};
  var r = jvActionResolve_(res);
  if (r.success) {
    jvToast(opts.successMsg || r.message || 'Done.', 'success');
  } else if (r.status === 'deferred' || r.status === 'no_op') {
    jvToast(r.message, 'warn');
  } else {
    jvToast(r.message, 'error');
  }
  return r;
}

/* ============================================================
   KANBAN DRAG & DROP (event-listener based)
   ============================================================ */
var _dragId = null, _dragFromStage = null;

function onCardDragStart(event, clientId, fromStage) {
  _dragId = clientId;
  _dragFromStage = fromStage;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/plain', clientId);
}

function initKanbanDragDrop() {
  document.querySelectorAll('.kanban-cards').forEach(function(col) {
    col.addEventListener('dragover', function(e) {
      e.preventDefault();
      col.classList.add('drag-over');
    });
    col.addEventListener('dragleave', function() {
      col.classList.remove('drag-over');
    });
    col.addEventListener('drop', function(e) {
      e.preventDefault();
      col.classList.remove('drag-over');
      var toStage = col.dataset.stage;
      if (!_dragId || !toStage || toStage === _dragFromStage) return;
      var dragId = _dragId;
      var fromStage = _dragFromStage;

      // P1.2 (pipeline brief, per D2): confirm before moving a BOOKED bride backwards.
      // Booking artefacts (portal access, Shopify tags/metafields, queued SMS, calendar
      // event) are NOT auto-removed on a reverse move; warn the admin first. Confirm runs
      // synchronously before the optimistic DOM move so a cancel is a clean no-op.
      var BOOKED_CLASS_STAGES_FE = ['Booked', 'Onboarding', 'Trial', 'Wedding Prep', 'Post-Wedding'];
      if (BOOKED_CLASS_STAGES_FE.indexOf(fromStage) !== -1 && BOOKED_CLASS_STAGES_FE.indexOf(toStage) === -1) {
        var _revCard = document.getElementById('kcard-' + dragId);
        var _revName = (_revCard && _revCard.dataset.name) || 'This bride';
        if (!window.confirm(_revName + ' is booked. Move her back to ' + stageDisplay(toStage) +
            '? Her booking artefacts (portal access, queued messages, calendar event) will NOT be removed.')) {
          return;
        }
      }
      // Optimistic UI: move card DOM node
      var cardEl = document.getElementById('kcard-' + dragId);
      var origParent = cardEl ? cardEl.parentNode : null;
      if (cardEl) col.appendChild(cardEl);
      // Update stage attribute + badge
      if (cardEl) {
        cardEl.dataset.stage = toStage;
        var badge = cardEl.querySelector('.stage-badge');
        if (badge) {
          badge.className = 'stage-badge ' + stageBadgeClass(toStage);
          badge.textContent = stageDisplay(toStage);
        }
      }
      // Update column counts + in-memory state
      updateColCounts();
      if (STATE.pipeline && STATE.pipeline.items) {
        STATE.pipeline.items.forEach(function(c) { if (String(c.id) === String(dragId)) c.stage = toStage; });
      }
      // Lock card while modal/API is in flight
      if (cardEl) cardEl.setAttribute('draggable', 'false');

      function revert_() {
        if (cardEl && origParent) {
          origParent.appendChild(cardEl);
          cardEl.dataset.stage = fromStage;
          var b = cardEl.querySelector('.stage-badge');
          if (b) { b.className = 'stage-badge ' + stageBadgeClass(fromStage); b.textContent = stageDisplay(fromStage); }
        }
        if (STATE.pipeline && STATE.pipeline.items) {
          STATE.pipeline.items.forEach(function(c) { if (String(c.id) === String(dragId)) c.stage = fromStage; });
        }
        updateColCounts();
        if (cardEl) cardEl.setAttribute('draggable', 'true');
      }

      function commit_(force) {
        var cardEmail = (cardEl && cardEl.dataset.email) || '';
        jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_updateStage', args: { clientId: dragId, newStage: toStage, forceOverride: !!force, email: cardEmail } })
          .then(function(res) {
            if (cardEl) cardEl.setAttribute('draggable', 'true');
            if (res.ok) {
              // B.4: backend asks for confirmation when no payment signal exists.
              if (res.data && res.data.requiresOverride && !force) {
                var brideName = (cardEl && cardEl.dataset.name) || 'this bride';
                paymentGuard_showModal(brideName, fromStage, toStage, function() {
                  if (cardEl) cardEl.setAttribute('draggable', 'false');
                  commit_(true);
                }, function() {
                  revert_();
                });
                return;
              }
              if (!res.data || !res.data.success) {
                revert_();
                jvToast('Stage update failed: ' + (res.data && res.data.message || 'Unknown error'), 'error');
              } else {
                jvToast(stageDisplay(toStage) + ' — updated', 'success');
                // Invalidate the cached drawer bundle for this bride — server
                // already invalidated server-side, drop the inline-CDN copy too
                // so the next drawer-open fetches fresh from GAS.
                if (typeof _drawerBundleCache !== 'undefined') delete _drawerBundleCache[String(dragId)];
              }
            } else {
              revert_();
              jvToast('Error: ' + (res.error && res.error.message ? res.error.message : String(res.error || '')), 'error');
            }
          })
          .catch(function(err) {
            if (cardEl) cardEl.setAttribute('draggable', 'true');
            revert_();
            jvToast('Error: ' + (err.message || String(err)), 'error');
          });
      }

      // Check pending tasks before committing the stage move
      jvBridge.callAdmin('bridge_admin_getPendingTasksForStageMove', { clientId: dragId, currentStage: fromStage })
        .then(function(res) {
          var tasks   = (res && res.ok && Array.isArray(res.tasks)) ? res.tasks : [];
          var pending = tasks.filter(function(t) { return t.status === 'pending'; });
          if (!pending.length) {
            commit_();
            return;
          }
          var brideName = (cardEl && cardEl.dataset.name) || 'this bride';
          pipelineLock_showModal(brideName, fromStage, toStage, pending, function(decisions) {
            jvBridge.callAdmin('bridge_admin_resolveTaskDecisions', { clientId: dragId, brideName: brideName, decisions: decisions })
              .then(function(dr) {
                if (dr && dr.ok && !dr.stageAllowed) {
                  jvToast('Stage move blocked — complete pending tasks first.', 'warn');
                  revert_();
                } else {
                  commit_();
                }
              })
              .catch(function() { commit_(); });
          }, function() {
            revert_();
          });
        })
        .catch(function() {
          // Task check failed — proceed without modal so admin is never blocked
          commit_();
        });
    });
  });
}

/* ============================================================
   PIPELINE LOCK MODAL — stage move task intercept
   ============================================================ */
function pipelineLock_injectStyles_() {
  if (document.getElementById('jv-pipeline-lock-styles')) return;
  var s = document.createElement('style');
  s.id = 'jv-pipeline-lock-styles';
  s.textContent = [
    '.jv-lock-overlay{position:fixed;inset:0;background:rgba(30,23,22,.55);z-index:9999;display:flex;align-items:center;justify-content:center;animation:jvLockFadeIn .18s ease}',
    '@keyframes jvLockFadeIn{from{opacity:0}to{opacity:1}}',
    '.jv-lock-modal{background:#fff;border-radius:var(--radius-large,1.5rem);padding:2rem;max-width:540px;width:calc(100% - 2rem);box-shadow:0 20px 60px rgba(47,37,36,.18);font-family:"Plus Jakarta Sans",sans-serif}',
    '.jv-lock-modal h3{font-size:1.1rem;font-weight:700;color:var(--brand-dark,#1e1716);margin:0 0 .25rem}',
    '.jv-lock-modal .jv-lock-sub{font-size:.85rem;color:var(--brand-text,#2f2524);margin:0 0 1.25rem;opacity:.8}',
    '.jv-lock-task{border:1px solid #ede8e6;border-radius:var(--radius-medium,1rem);padding:.75rem 1rem;margin-bottom:.625rem;display:flex;align-items:center;gap:.75rem;flex-wrap:wrap}',
    '.jv-lock-task-label{flex:1;font-size:.88rem;font-weight:600;color:var(--brand-dark,#1e1716)}',
    '.jv-lock-badge{font-size:.72rem;font-weight:700;padding:.2rem .55rem;border-radius:2rem;background:#fef3c7;color:#92400e;letter-spacing:.03em}',
    '.jv-lock-actions{display:flex;gap:.4rem;margin-left:auto}',
    '.jv-lock-btn{font-size:.78rem;font-weight:700;padding:.3rem .75rem;border-radius:var(--radius-pill,3rem);border:none;cursor:pointer;transition:opacity .15s}',
    '.jv-lock-btn.forsake{background:#fee2e2;color:#991b1b}.jv-lock-btn.forsake.active,.jv-lock-btn.forsake:hover{background:#fca5a5}',
    '.jv-lock-btn.push{background:#fef3c7;color:#92400e}.jv-lock-btn.push.active,.jv-lock-btn.push:hover{background:#fde68a}',
    '.jv-lock-btn.hold{background:#f3f4f6;color:#374151;border:1px solid #d1d5db}.jv-lock-btn.hold.active,.jv-lock-btn.hold:hover{background:#e5e7eb}',
    '.jv-lock-btn.active{box-shadow:0 0 0 2px var(--brand-primary,#c99591)}',
    '.jv-lock-hold-note{font-size:.78rem;color:#991b1b;margin:.75rem 0 0;display:none}',
    '.jv-lock-footer{display:flex;gap:.75rem;justify-content:flex-end;margin-top:1.5rem;padding-top:1rem;border-top:1px solid #f0ebe9}',
    '.jv-lock-confirm{background:var(--brand-primary,#c99591);color:#fff;border:none;border-radius:var(--radius-pill,3rem);padding:.55rem 1.5rem;font-weight:700;font-size:.88rem;cursor:pointer;transition:opacity .15s}',
    '.jv-lock-confirm:disabled{opacity:.45;cursor:not-allowed}',
    '.jv-lock-cancel{background:transparent;border:1px solid #d1d5db;border-radius:var(--radius-pill,3rem);padding:.55rem 1.25rem;font-weight:600;font-size:.88rem;cursor:pointer;color:var(--brand-text,#2f2524)}'
  ].join('');
  document.head.appendChild(s);
}

function pipelineLock_showModal(brideName, fromStage, toStage, pendingTasks, onConfirm, onCancel) {
  pipelineLock_injectStyles_();

  var decisions = {}; // taskId → { taskId, taskLabel, action }
  // Default every task to 'hold' (blocked)
  pendingTasks.forEach(function(t) {
    decisions[t.id] = { taskId: t.id, taskLabel: t.label, action: 'hold' };
  });

  function taskRowHtml(t) {
    return '<div class="jv-lock-task" data-task-id="' + escAttr(t.id) + '">' +
      '<span class="jv-lock-task-label">' + escHtml(t.label) + '</span>' +
      '<span class="jv-lock-badge">Pending</span>' +
      '<div class="jv-lock-actions">' +
      (t.canForsake ? '<button class="jv-lock-btn forsake" data-action="forsake" data-task="' + escAttr(t.id) + '" data-label="' + escAttr(t.label) + '">Forsake</button>' : '') +
      (t.canPush    ? '<button class="jv-lock-btn push"    data-action="push"    data-task="' + escAttr(t.id) + '" data-label="' + escAttr(t.label) + '">Push</button>'    : '') +
      '<button class="jv-lock-btn hold active" data-action="hold" data-task="' + escAttr(t.id) + '" data-label="' + escAttr(t.label) + '">Hold</button>' +
      '</div>' +
      '</div>';
  }

  var overlay = document.createElement('div');
  overlay.className = 'jv-lock-overlay';
  overlay.innerHTML =
    '<div class="jv-lock-modal">' +
    '<h3>Moving ' + escHtml(brideName) + '</h3>' +
    '<p class="jv-lock-sub">' + escHtml(fromStage) + ' &rarr; ' + escHtml(toStage) +
      ' &mdash; the following tasks are still pending at this stage:</p>' +
    pendingTasks.map(taskRowHtml).join('') +
    '<p class="jv-lock-hold-note" id="jvLockHoldNote">Stage move blocked &mdash; complete pending tasks first, or forsake/push them.</p>' +
    '<div class="jv-lock-footer">' +
    '<button class="jv-lock-cancel" id="jvLockCancel">Cancel</button>' +
    '<button class="jv-lock-confirm" id="jvLockConfirm" disabled>Confirm Move</button>' +
    '</div>' +
    '</div>';
  document.body.appendChild(overlay);

  function updateConfirmState() {
    var hasHold    = Object.keys(decisions).some(function(k) { return decisions[k].action === 'hold'; });
    var confirmBtn = overlay.querySelector('#jvLockConfirm');
    var holdNote   = overlay.querySelector('#jvLockHoldNote');
    if (confirmBtn) confirmBtn.disabled = hasHold;
    if (holdNote)   holdNote.style.display = hasHold ? 'block' : 'none';
  }

  function close_() {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  overlay.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.jv-lock-btn');
    if (btn) {
      var taskId = btn.dataset.task;
      var action = btn.dataset.action;
      var label  = btn.dataset.label;
      var taskEl = btn.closest('.jv-lock-task');
      if (taskEl) taskEl.querySelectorAll('.jv-lock-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      decisions[taskId] = { taskId: taskId, taskLabel: label, action: action };
      updateConfirmState();
      return;
    }
    if (e.target.id === 'jvLockCancel') {
      close_();
      onCancel();
      return;
    }
    if (e.target.id === 'jvLockConfirm' && !e.target.disabled) {
      close_();
      onConfirm(Object.keys(decisions).map(function(k) { return decisions[k]; }));
      return;
    }
  });

  updateConfirmState();
}

// B.4 (2026-05-26 admin-crm-data-integrity-self-healing brief): payment-signal guard
// modal. Fires when the backend returns { requiresOverride: true } on a drag to a
// BOOKED-flipping stage with no agreement signature, no Xero invoice, no active
// mandate, and no confirmed payment. Reuses the pipeline-lock overlay styles.
function paymentGuard_showModal(brideName, fromStage, toStage, onConfirm, onCancel) {
  pipelineLock_injectStyles_();
  var overlay = document.createElement('div');
  overlay.className = 'jv-lock-overlay';
  overlay.innerHTML =
    '<div class="jv-lock-modal">' +
    '<h3>Moving ' + escHtml(brideName) + '</h3>' +
    '<p class="jv-lock-sub">' + escHtml(fromStage || '?') + ' &rarr; ' + escHtml(toStage) + '</p>' +
    '<p style="font-size:.95rem;line-height:1.5;color:var(--brand-dark,#1e1716);font-weight:600;margin:0 0 .5rem">' +
      "She hasn't paid yet. Proceed anyway?" +
    '</p>' +
    '<p style="font-size:.8rem;line-height:1.5;color:var(--brand-text,#2f2524);opacity:.75;margin:0">' +
      'No agreement signature, Xero invoice, active mandate, or confirmed payment was found. ' +
      'Moving her to ' + escHtml(toStage) + ' will record an override in the audit log and ping the admin Chat.' +
    '</p>' +
    '<div class="jv-lock-footer">' +
    '<button class="jv-lock-cancel" id="jvPgCancel">Cancel</button>' +
    '<button class="jv-lock-confirm" id="jvPgConfirm">Proceed anyway</button>' +
    '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  overlay.addEventListener('click', function(e) {
    if (e.target.id === 'jvPgCancel') { close_(); try { onCancel && onCancel(); } catch(_){} return; }
    if (e.target.id === 'jvPgConfirm') { close_(); try { onConfirm && onConfirm(); } catch(_){} return; }
  });
}

/* ============================================================
   B.8 (2026-05-26 admin-crm-data-integrity-self-healing brief Lane 8):
   Proposal click → itemised modal. Renders PROPOSAL_CALC_JSON line items
   grouped by category, with status pill + timestamps + Open bride view.
   ============================================================ */
function proposalCalcModal_injectStyles_() {
  if (document.getElementById('jv-pcm-styles')) return;
  var s = document.createElement('style');
  s.id = 'jv-pcm-styles';
  s.textContent = [
    '.jv-pcm-overlay{position:fixed;inset:0;background:rgba(30,23,22,.55);z-index:9999;display:flex;align-items:center;justify-content:center;animation:jvLockFadeIn .18s ease;padding:1rem}',
    '.jv-pcm-modal{background:#fff;border-radius:var(--radius-large,1.5rem);padding:1.75rem 2rem;max-width:680px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 20px 60px rgba(47,37,36,.18);font-family:"Plus Jakarta Sans",sans-serif;color:var(--brand-text,#2f2524)}',
    '.jv-pcm-head{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:.4rem}',
    '.jv-pcm-head h3{font-family:"Raleway",sans-serif;font-weight:300;font-size:1.35rem;color:var(--brand-dark,#1e1716);margin:0;letter-spacing:.01em}',
    '.jv-pcm-close{background:transparent;border:none;font-size:1.6rem;line-height:1;color:#7e706c;cursor:pointer;padding:.1rem .4rem;border-radius:50%;transition:background .15s}',
    '.jv-pcm-close:hover{background:#f6f1ee;color:var(--brand-dark,#1e1716)}',
    '.jv-pcm-sub{font-size:.78rem;color:#7e706c;margin:0 0 1rem}',
    '.jv-pcm-status-row{display:flex;align-items:center;justify-content:space-between;gap:1rem;flex-wrap:wrap;padding:.85rem 1rem;background:#f6f1ee;border-radius:var(--radius-medium,1rem);margin-bottom:1.25rem}',
    '.jv-pcm-status-pill{font-size:.7rem;font-weight:800;letter-spacing:.08em;padding:.32rem .85rem;border-radius:var(--radius-pill,3rem);text-transform:uppercase;flex-shrink:0}',
    '.jv-pcm-status-pill.active{background:var(--brand-primary,#c99591);color:#fff}',
    '.jv-pcm-status-pill.accepted{background:#1f6b46;color:#fff}',
    '.jv-pcm-status-pill.expired{background:#9a2020;color:#fff}',
    '.jv-pcm-status-pill.voided,.jv-pcm-status-pill.void{background:#7e706c;color:#fff}',
    '.jv-pcm-status-pill.unknown{background:#e6dad4;color:#4a3f3d}',
    '.jv-pcm-timestamps{display:flex;gap:1.25rem;flex-wrap:wrap;font-size:.72rem;color:var(--brand-text,#2f2524)}',
    '.jv-pcm-timestamps span{display:inline-flex;flex-direction:column;line-height:1.3}',
    '.jv-pcm-timestamps span strong{font-weight:700;font-size:.62rem;text-transform:uppercase;letter-spacing:.08em;color:#7e706c}',
    '.jv-pcm-group{border:1px solid #ede8e6;border-radius:var(--radius-medium,1rem);padding:.4rem .85rem;margin-bottom:.6rem;background:#fff}',
    '.jv-pcm-group-head{font-family:"Raleway",sans-serif;font-weight:500;font-size:.74rem;text-transform:uppercase;letter-spacing:.12em;color:var(--brand-primary-deep,#a9706c);padding:.5rem 0 .35rem;border-bottom:1px solid #f6f1ee;margin-bottom:.25rem}',
    '.jv-pcm-row{display:grid;grid-template-columns:1fr auto auto;align-items:center;gap:.75rem;padding:.4rem 0;font-size:.85rem}',
    '.jv-pcm-row + .jv-pcm-row{border-top:1px dashed #f0ebe9}',
    '.jv-pcm-row .jv-pcm-desc{color:var(--brand-dark,#1e1716);font-weight:500}',
    '.jv-pcm-row .jv-pcm-qty{font-size:.72rem;color:#7e706c;text-align:right;min-width:1.8rem}',
    '.jv-pcm-row .jv-pcm-amt{font-weight:600;color:var(--brand-dark,#1e1716);text-align:right;min-width:5rem}',
    '.jv-pcm-totals{margin-top:1rem;padding:1rem 1.25rem;background:#f9f5f3;border-radius:var(--radius-medium,1rem)}',
    '.jv-pcm-totals .jv-pcm-trow{display:flex;justify-content:space-between;padding:.18rem 0;font-size:.85rem;color:var(--brand-text,#2f2524)}',
    '.jv-pcm-totals .jv-pcm-grand{margin-top:.4rem;padding-top:.55rem;border-top:1px solid #e8dcd7;font-family:"Raleway",sans-serif;font-weight:600;font-size:1.05rem;color:var(--brand-dark,#1e1716)}',
    '.jv-pcm-empty{padding:1.5rem;text-align:center;color:#7e706c;font-size:.85rem;background:#f9f5f3;border-radius:var(--radius-medium,1rem)}',
    '.jv-pcm-footer{display:flex;gap:.75rem;justify-content:flex-end;margin-top:1.25rem;padding-top:1rem;border-top:1px solid #f0ebe9;flex-wrap:wrap}',
    '.jv-pcm-cancel{background:transparent;border:1px solid #d1d5db;border-radius:var(--radius-pill,3rem);padding:.55rem 1.25rem;font-weight:600;font-size:.85rem;cursor:pointer;color:var(--brand-text,#2f2524)}',
    '.jv-pcm-primary{background:var(--brand-primary,#c99591);color:#fff;border:none;border-radius:var(--radius-pill,3rem);padding:.55rem 1.5rem;font-weight:700;font-size:.85rem;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:.4rem;transition:opacity .15s}',
    '.jv-pcm-primary:hover{opacity:.92}',
    '.jv-pcm-loading{padding:2rem;text-align:center;color:#7e706c;font-size:.85rem}',
    '.jv-pcm-error{padding:1.25rem;background:#fef1f1;color:#9a2020;border-radius:var(--radius-medium,1rem);font-size:.85rem}'
  ].join('');
  document.head.appendChild(s);
}

function proposalCalcModal_formatCurrency_(v) {
  var n = Number(v);
  if (!isFinite(n)) return '—';
  return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function proposalCalcModal_groupLineItems_(lineItems) {
  // Returns { bride, party, trial, travel, addon, other } each array of items.
  var groups = { bride: [], party: [], trial: [], travel: [], addon: [], other: [] };
  (lineItems || []).forEach(function(li) {
    var cat = String(li.category || '').toLowerCase();
    if (cat === 'bride') groups.bride.push(li);
    else if (cat === 'bridesmaid' || cat === 'mother' || cat === 'guest' || cat === 'flowergirl') groups.party.push(li);
    else if (cat === 'trial') groups.trial.push(li);
    else if (cat === 'travel') groups.travel.push(li);
    else if (cat === 'addon') groups.addon.push(li);
    else groups.other.push(li);
  });
  return groups;
}

function proposalCalcModal_renderGroup_(title, items) {
  if (!items || !items.length) return '';
  var rowsHtml = items.map(function(li) {
    var desc = String(li.description || li.label || li.category || '—');
    var qty  = Number(li.qty || li.quantity || 1);
    var line = (li.total != null) ? Number(li.total)
             : (Number(li.unitPrice || li.rate || 0) * qty);
    var qtyStr = (qty && qty !== 1) ? '× ' + qty : '';
    return '<div class="jv-pcm-row">' +
      '<span class="jv-pcm-desc">' + escHtml(desc) + '</span>' +
      '<span class="jv-pcm-qty">' + escHtml(qtyStr) + '</span>' +
      '<span class="jv-pcm-amt">' + escHtml(proposalCalcModal_formatCurrency_(line)) + '</span>' +
    '</div>';
  }).join('');
  return '<div class="jv-pcm-group">' +
    '<div class="jv-pcm-group-head">' + escHtml(title) + '</div>' +
    rowsHtml +
  '</div>';
}

function proposalCalcModal_statusPill_(data) {
  // Prefer token status (canonical, comes from JV AUTO Proposal Tokens sheet),
  // then fall back to crmProposalStatus.
  var raw = String(data.tokenStatus || data.crmProposalStatus || '').toUpperCase();
  var label = 'UNKNOWN', cls = 'unknown';
  if (raw === 'ACTIVE' || raw === 'SENT' || raw === 'READY' || raw === 'PROPOSAL SENT') { label = 'Active'; cls = 'active'; }
  else if (raw === 'ACCEPTED' || raw === 'SIGNED' || raw === 'DEPOSIT_PAID' || raw === 'DEPOSIT PAID') { label = 'Accepted'; cls = 'accepted'; }
  else if (raw === 'EXPIRED') { label = 'Expired'; cls = 'expired'; }
  else if (raw === 'VOIDED' || raw === 'VOID') { label = 'Voided'; cls = 'voided'; }
  else if (raw) { label = raw.charAt(0) + raw.slice(1).toLowerCase(); cls = 'unknown'; }
  return '<span class="jv-pcm-status-pill ' + cls + '">' + escHtml(label) + '</span>';
}

function proposalCalcModal_render_(data) {
  var calc = data.calc || null;
  var hasItems = calc && Array.isArray(calc.lineItems) && calc.lineItems.length > 0;

  var bodyHtml;
  if (!hasItems) {
    bodyHtml = '<div class="jv-pcm-empty">No itemised line items recorded for this proposal. ' +
               (data.calcEmpty
                  ? 'PROPOSAL_CALC_JSON is empty — likely a legacy bride sent before proposal-v2.'
                  : 'PROPOSAL_CALC_JSON parsed without line items.') +
               '</div>';
  } else {
    var groups = proposalCalcModal_groupLineItems_(calc.lineItems);
    bodyHtml = '';
    bodyHtml += proposalCalcModal_renderGroup_('Bride',         groups.bride);
    bodyHtml += proposalCalcModal_renderGroup_('Bridal party',  groups.party);
    bodyHtml += proposalCalcModal_renderGroup_('Trial',         groups.trial);
    bodyHtml += proposalCalcModal_renderGroup_('Travel',        groups.travel);
    bodyHtml += proposalCalcModal_renderGroup_('Add-ons',       groups.addon);
    bodyHtml += proposalCalcModal_renderGroup_('Other',         groups.other);
  }

  var subtotal = calc && calc.subtotal != null ? Number(calc.subtotal) : null;
  var gst      = calc && calc.gst      != null ? Number(calc.gst)      : null;
  var total    = calc && calc.total    != null ? Number(calc.total)
               : (data.tokenTotal != null ? Number(data.tokenTotal) : null);

  var totalsHtml = '';
  if (subtotal != null || gst != null || total != null) {
    totalsHtml = '<div class="jv-pcm-totals">';
    if (subtotal != null) totalsHtml += '<div class="jv-pcm-trow"><span>Subtotal</span><span>' + escHtml(proposalCalcModal_formatCurrency_(subtotal)) + '</span></div>';
    if (gst      != null) totalsHtml += '<div class="jv-pcm-trow"><span>GST</span><span>' + escHtml(proposalCalcModal_formatCurrency_(gst)) + '</span></div>';
    if (total    != null) totalsHtml += '<div class="jv-pcm-trow jv-pcm-grand"><span>Total</span><span>' + escHtml(proposalCalcModal_formatCurrency_(total)) + '</span></div>';
    totalsHtml += '</div>';
  }

  var bookingTier = calc && calc.bookingTier ? String(calc.bookingTier) : '';
  var tierLabel = bookingTier === 'jessica' ? 'Jessica only'
                : bookingTier === 'proTeam' ? 'Pro Team'
                : bookingTier === 'jessAndProTeam' || bookingTier === 'jessicaAndProTeam' ? 'Jessica + Pro Team'
                : '';

  var subParts = [];
  if (data.brideName) subParts.push(escHtml(data.brideName));
  if (data.weddingDate) subParts.push('Wedding ' + escHtml(formatDate(data.weddingDate)));
  if (tierLabel) subParts.push('Tier: ' + escHtml(tierLabel));

  var ts = data;
  var tsParts = [];
  tsParts.push('<span><strong>Sent</strong>'    + (ts.sentAt     ? escHtml(formatDate(ts.sentAt))     : ' —') + '</span>');
  tsParts.push('<span><strong>Viewed</strong>'  + (ts.viewedAt   ? escHtml(formatDate(ts.viewedAt))   : ' —') + '</span>');
  tsParts.push('<span><strong>Accepted</strong>'+ (ts.acceptedAt ? escHtml(formatDate(ts.acceptedAt)) : ' —') + '</span>');
  if (ts.expiryDate) tsParts.push('<span><strong>Expires</strong>' + escHtml(formatDate(ts.expiryDate)) + '</span>');

  var openBtnHtml = data.proposalUrl
    ? '<a class="jv-pcm-primary" id="jvPcmOpen" href="' + escAttr(data.proposalUrl) + '" target="_blank" rel="noopener">Open bride view</a>'
    : '';

  return '<div class="jv-pcm-modal">' +
    '<div class="jv-pcm-head">' +
      '<h3>Proposal</h3>' +
      '<button class="jv-pcm-close" id="jvPcmClose" aria-label="Close">&times;</button>' +
    '</div>' +
    (subParts.length ? '<p class="jv-pcm-sub">' + subParts.join(' &middot; ') + '</p>' : '') +
    '<div class="jv-pcm-status-row">' +
      proposalCalcModal_statusPill_(data) +
      '<div class="jv-pcm-timestamps">' + tsParts.join('') + '</div>' +
    '</div>' +
    bodyHtml +
    totalsHtml +
    '<div class="jv-pcm-footer">' +
      '<button class="jv-pcm-cancel" id="jvPcmCancel">Close</button>' +
      openBtnHtml +
    '</div>' +
  '</div>';
}

function openProposalModal(email) {
  if (!email) { jvToast('Missing bride email', 'error'); return; }
  proposalCalcModal_injectStyles_();
  var overlay = document.createElement('div');
  overlay.className = 'jv-pcm-overlay';
  overlay.innerHTML = '<div class="jv-pcm-modal"><div class="jv-pcm-loading">Loading proposal…</div></div>';
  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) { close_(); return; }
    if (e.target && (e.target.id === 'jvPcmClose' || e.target.id === 'jvPcmCancel')) { close_(); return; }
  });

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getProposalCalc', args: { email: email } })
    .then(function(res) {
      if (!res.ok) {
        overlay.innerHTML = '<div class="jv-pcm-modal"><div class="jv-pcm-head"><h3>Proposal</h3><button class="jv-pcm-close" id="jvPcmClose">&times;</button></div><div class="jv-pcm-error">Bridge error: ' + escHtml(res.error && res.error.message || String(res.error || 'unknown')) + '</div><div class="jv-pcm-footer"><button class="jv-pcm-cancel" id="jvPcmCancel">Close</button></div></div>';
        return;
      }
      var data = res.data;
      if (!data || !data.ok) {
        overlay.innerHTML = '<div class="jv-pcm-modal"><div class="jv-pcm-head"><h3>Proposal</h3><button class="jv-pcm-close" id="jvPcmClose">&times;</button></div><div class="jv-pcm-error">' + escHtml(data && data.message || 'Could not load proposal.') + '</div><div class="jv-pcm-footer"><button class="jv-pcm-cancel" id="jvPcmCancel">Close</button></div></div>';
        return;
      }
      overlay.innerHTML = proposalCalcModal_render_(data);
    })
    .catch(function(err) {
      overlay.innerHTML = '<div class="jv-pcm-modal"><div class="jv-pcm-head"><h3>Proposal</h3><button class="jv-pcm-close" id="jvPcmClose">&times;</button></div><div class="jv-pcm-error">' + escHtml(err && err.message || String(err)) + '</div><div class="jv-pcm-footer"><button class="jv-pcm-cancel" id="jvPcmCancel">Close</button></div></div>';
    });
}

function updateColCounts() {
  document.querySelectorAll('.kanban-col').forEach(function(col) {
    var stage = col.dataset.stage;
    var count = col.querySelectorAll('.kanban-card').length;
    var badge = col.querySelector('.col-count');
    if (badge) badge.textContent = count;
    // Also update stage chip
    var chipId = 'chip-count-' + (stage || '').replace(/\s+/g,'-');
    var chip = document.getElementById(chipId);
    if (chip) chip.textContent = count;
  });
  // Update "All" chip
  var allChip = document.getElementById('chip-count-All');
  if (allChip) allChip.textContent = document.querySelectorAll('.kanban-card').length;
}

function setStageFilter(stage, btn) {
  STATE.currentStageFilter = stage;
  document.querySelectorAll('.stage-chip').forEach(function(b){ b.classList.remove('active'); });
  if (btn) btn.classList.add('active');

  var kanbanBoard      = document.getElementById('kanban-board');
  var closedContainer  = document.getElementById('closed-leads-container');
  var todayView        = document.getElementById('today-view');
  var emptyPanel       = document.getElementById('jv-kanban-empty');

  // Hide all panels, then show the one we need
  if (kanbanBoard)     kanbanBoard.style.display     = 'none';
  if (closedContainer) closedContainer.style.display = 'none';
  if (todayView)       todayView.style.display       = 'none';
  if (emptyPanel)      emptyPanel.style.display      = 'none';

  if (stage === 'Closed') {
    if (closedContainer) closedContainer.style.display = '';
    renderClosedLeads(STATE.pipeline ? STATE.pipeline.closedClients || [] : []);
  } else if (stage === 'Today') {
    // Gap #3, Today / Needs You view
    if (todayView) todayView.style.display = '';
    renderTodayView();
  } else {
    if (kanbanBoard) kanbanBoard.style.display = 'flex';
    if (STATE.pipeline) renderKanban(STATE.pipeline.items || []);
  }
}

/* ============================================================
   DYNAMIC STAGE FILTER BAR
   ============================================================ */
function buildStageFilterBar(stageCounts) {
  var bar = document.getElementById('stage-filter-bar');
  if (!bar) return;
  var total = 0;
  var stages = STATE.pipelineStages || PIPELINE_STAGES;
  stages.forEach(function(s) { total += (stageCounts[s] || 0); });
  var closedCount = stageCounts['Closed'] || 0;

  // Gap #3 — count flagged brides for Today chip badge
  var todayCount = getTodayItems_().length;
  var todayActive = STATE.currentStageFilter === 'Today' ? ' active' : '';
  var todayStyle = 'border-left: 2px solid var(--brand-primary); margin-left: 0.35rem; padding-left: 0.75rem;';
  var html = '<button class="stage-chip today-chip' + todayActive + '" data-stage="Today" onclick="setStageFilter(\'Today\', this)" style="' + todayStyle + '">'
    + 'Needs You <span class="chip-count today-chip-count" id="chip-count-Today">' + todayCount + '</span></button>';

  html += '<button class="stage-chip' + (STATE.currentStageFilter === 'All' ? ' active' : '') +
    '" data-stage="All" onclick="setStageFilter(\'All\', this)">All <span class="chip-count" id="chip-count-All">' + total + '</span></button>';

  stages.forEach(function(stage) {
    var count = stageCounts[stage] || 0;
    var display = stageDisplay(stage);
    var safeId = stage.replace(/\s+/g, '-');
    var active = STATE.currentStageFilter === stage ? ' active' : '';
    html += '<button class="stage-chip' + active + '" data-stage="' + escAttr(stage) +
      '" onclick="setStageFilter(\'' + escAttr(stage) + '\', this)">' +
      escHtml(display) + ' <span class="chip-count" id="chip-count-' + safeId + '">' + count + '</span></button>';
  });

  html += '<button class="stage-chip' + (STATE.currentStageFilter === 'Closed' ? ' active' : '') +
    '" data-stage="Closed" onclick="setStageFilter(\'Closed\', this)" style="border-left: 2px solid var(--line); margin-left: 0.35rem; padding-left: 0.75rem;">Closed <span class="chip-count" id="chip-count-Closed">' + closedCount + '</span></button>';

  bar.innerHTML = html;
}

/* ============================================================
   GAP #3 — TODAY VIEW (Needs You)
   ============================================================ */

/**
 * Returns pipeline items that have attention.flag === true,
 * sorted by maxSeverity desc then daysUntil asc.
 */
function getTodayItems_() {
  var items = (STATE.pipeline && STATE.pipeline.items) || [];
  var sevOrder = { escalated: 0, warn: 1, info: 2 };
  return items
    .filter(function(c) { return c.attention && c.attention.flag; })
    .sort(function(a, b) {
      var sa = sevOrder[a.attention.maxSeverity] != null ? sevOrder[a.attention.maxSeverity] : 9;
      var sb = sevOrder[b.attention.maxSeverity] != null ? sevOrder[b.attention.maxSeverity] : 9;
      if (sa !== sb) return sa - sb;
      var da = (a.daysUntil != null) ? a.daysUntil : 9999;
      var db = (b.daysUntil != null) ? b.daysUntil : 9999;
      return da - db;
    });
}

/**
 * Renders the Today view list from cached pipeline data.
 * Zero GAS calls — reads STATE.pipeline which is already loaded.
 */
function renderTodayView() {
  var container = document.getElementById('today-list');
  if (!container) return;

  var items = getTodayItems_();

  if (items.length === 0) {
    container.innerHTML =
      '<div class="today-empty">' +
        '<div class="today-empty-icon">&#10003;</div>' +
        '<p class="today-empty-title">Nothing needs you right now.</p>' +
        '<p class="today-empty-sub">Everyone is on track.</p>' +
      '</div>';
    return;
  }

  var html = '<div class="today-list-inner">';
  items.forEach(function(c) {
    var sev = (c.attention && c.attention.maxSeverity) || 'info';
    var label = (c.attention && c.attention.top && c.attention.top.label) || 'Needs attention';
    var actionRoute = (c.attention && c.attention.top && c.attention.top.actionRoute) || '';
    var sevClass = sev === 'escalated' ? 'today-sev-escalated' : (sev === 'warn' ? 'today-sev-warn' : 'today-sev-info');
    var wdStr = c.weddingDate ? formatDate(c.weddingDate) : '';
    var daysStr = '';
    if (c.daysUntil != null) {
      var d = Number(c.daysUntil);
      if (d > 0)       daysStr = d + ' wk' === '1 wk' ? '1 wk' : Math.ceil(d / 7) + ' wks';
      else if (d === 0) daysStr = 'today';
      else              daysStr = Math.abs(d) + 'd ago';
      // Use days directly if < 14
      if (Math.abs(d) < 14) daysStr = d + 'd';
      else daysStr = Math.ceil(Math.abs(d) / 7) + 'wk' + (d < 0 ? ' ago' : '');
    }

    html += '<div class="today-row" onclick="openDrawerToday_(\'' + escAttr(c.id) + '\', \'' + escAttr(actionRoute) + '\')">';
    html += '<div class="today-row-sev"><div class="today-sev-dot ' + sevClass + '"></div></div>';
    html += '<div class="today-row-body">';
    html += '<div class="today-row-name">' + stripTagsAndEscape_(c.name || '—') + '</div>';
    html += '<div class="today-row-meta">' + escHtml(stageDisplay(c.stage || '')) +
              (wdStr ? ' &middot; ' + escHtml(wdStr) + (daysStr ? ' (' + escHtml(daysStr) + ')' : '') : '') + '</div>';
    html += '<div class="today-row-reason">' + escHtml(label) + '</div>';
    html += '</div>';
    html += '<button class="btn-ghost today-open-btn" onclick="event.stopPropagation(); openDrawerToday_(\'' + escAttr(c.id) + '\', \'' + escAttr(actionRoute) + '\')">Open &#9656;</button>';
    html += '</div>';
  });
  html += '</div>';

  container.innerHTML = html;
}

/**
 * Opens the drawer and, if possible, navigates to the relevant facet.
 */
function openDrawerToday_(clientId, actionRoute) {
  openDrawer(clientId);
  if (actionRoute) {
    // Attempt to open the facet after a short delay to allow drawer to render
    setTimeout(function() {
      if (typeof CC !== 'undefined' && CC && typeof CC.openFacet === 'function') {
        CC.openFacet(actionRoute);
      }
    }, 600);
  }
}

/* ============================================================
   CLOSE ENQUIRY — Context Menu + Modal
   ============================================================ */
var CLOSE_REASONS = [
  'Lost to competitor',
  'Unresponsive',
  'Budget mismatch',
  'Date unavailable',
  'Not suitable',
  'Other'
];

function toggleCardMenu(btn, clientId, clientName) {
  // Close any existing menus
  document.querySelectorAll('.kc-context-menu').forEach(function(m) { m.remove(); });

  var card = btn.closest('.kanban-card');
  if (!card) return;
  // Row-position identity guard for the mutating actions below (Mark
  // Unavailable -- adminCrm_declineUnavailable now fails closed without an
  // email, same pattern as reopenEnquiry/closeEnquiry). data-email is already
  // rendered onto every card (line ~1585), just reading it here.
  var clientEmail = card.getAttribute('data-email') || '';

  var menu = document.createElement('div');
  menu.className = 'kc-context-menu';
  var html = '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); openDrawer(\'' + escAttr(clientId) + '\')">View Details</div>';
  html += '<div class="ctx-divider"></div>';
  html += '<div class="ctx-item ctx-unavailable" onclick="event.stopPropagation(); closeContextMenus(); openDeclineModal(\'' +
    escAttr(clientId) + '\', \'' + escAttr(clientName) + '\', \'' + escAttr(clientEmail) + '\')">&#x26D4; Mark Unavailable &amp; Notify</div>';
  html += '<div class="ctx-divider"></div>';
  html += '<div class="ctx-item" onclick="event.stopPropagation();" style="font-weight:600; cursor:default; pointer-events:none; color:var(--muted); font-size:0.7rem;">Close Enquiry</div>';
  CLOSE_REASONS.forEach(function(reason) {
    html += '<div class="ctx-item ctx-sub" onclick="event.stopPropagation(); closeContextMenus(); openCloseModal(\'' +
      escAttr(clientId) + '\', \'' + escAttr(clientName) + '\', \'' + escAttr(reason) + '\')">' + escHtml(reason) + '</div>';
  });
  html += '<div class="ctx-divider"></div>';
  html += '<div class="ctx-item danger" onclick="event.stopPropagation(); closeContextMenus(); openCloseModal(\'' +
    escAttr(clientId) + '\', \'' + escAttr(clientName) + '\', \'Archived\')">Archive</div>';

  menu.innerHTML = html;
  // Render on body (position:fixed) so the menu is never clipped by the card's
  // overflow:hidden (the reasons used to be clipped below the card edge - 2026-07-18).
  var r = btn.getBoundingClientRect();
  menu.style.position = 'fixed';
  menu.style.top = r.bottom + 'px';
  menu.style.right = (window.innerWidth - r.right) + 'px';
  menu.style.left = 'auto';
  document.body.appendChild(menu);
  // If it would overflow the bottom of the viewport, flip it above the button.
  var mh = menu.getBoundingClientRect().height;
  if (r.bottom + mh > window.innerHeight) {
    menu.style.top = 'auto';
    menu.style.bottom = (window.innerHeight - r.top) + 'px';
  }

  // Close on outside click
  function closeOnOutside(e) {
    if (!menu.contains(e.target) && e.target !== btn) {
      menu.remove();
      document.removeEventListener('click', closeOnOutside);
    }
  }
  setTimeout(function() { document.addEventListener('click', closeOnOutside); }, 10);
}

function closeContextMenus() {
  document.querySelectorAll('.kc-context-menu').forEach(function(m) { m.remove(); });
}

function openCloseModal(clientId, clientName, reason) {
  var isOther = reason === 'Other';
  var overlay = document.createElement('div');
  overlay.className = 'close-modal-overlay';
  overlay.id = 'close-modal-overlay';
  overlay.innerHTML =
    '<div class="close-modal">' +
      '<h3>Close Enquiry: ' + escHtml(clientName) + '</h3>' +
      '<div class="close-reason-label">Reason: <strong>' + escHtml(reason) + '</strong></div>' +
      '<label style="font-size:0.78rem; color:var(--muted);">Notes' + (isOther ? ' (required)' : ' (optional)') + ':</label>' +
      '<textarea id="close-notes-input" placeholder="Add any notes…"></textarea>' +
      '<div class="close-modal-actions">' +
        '<button class="btn-cancel" onclick="document.getElementById(\'close-modal-overlay\').remove()">Cancel</button>' +
        '<button class="btn-close-lead" id="btn-confirm-close" onclick="confirmCloseEnquiry(\'' + escAttr(clientId) + '\', \'' + escAttr(reason) + '\')">Close Lead</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.querySelector('textarea').focus();

  // Close on background click
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) overlay.remove();
  });
}

function confirmCloseEnquiry(clientId, reason, opt_confirmBookedClose) {
  var notes = document.getElementById('close-notes-input').value.trim();
  if (reason === 'Other' && !notes) {
    jvToast('Please add a note for "Other" close reason.', 'error');
    return;
  }
  var btn = document.getElementById('btn-confirm-close');
  btn.disabled = true;
  btn.textContent = 'Closing…';

  var args = { clientId: clientId, reason: reason, notes: notes };
  if (opt_confirmBookedClose) args.confirmBookedClose = true;

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_closeEnquiry', args: args })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      // Booked-bride guardrail (2026-09-08, BUILD-extension-hire-remaining-
      // gaps-and-cancel-close-path-confusion-2026-09-08.md Item 5, Jess: allow
      // with a warning, don't block). First call on a booked bride returns
      // this instead of closing -- re-prompt with the exact scope warning the
      // backend already composed, then re-send with confirmBookedClose:true
      // if the admin still wants to proceed. In-page (2026-09-09, XRAY item 7:
      // "the three remaining window.confirm calls are all on higher-stakes
      // actions than the one that got fixed" -- closing a BOOKED bride is
      // exactly that class) rather than a native dialog stacked on top of the
      // still-open Close Enquiry modal, same reasoning as Mark As Returned's
      // in-page fix: the modal stays visible with its full context instead of
      // a blocking browser dialog that hides all of it. clientName is read
      // from the modal's own already-rendered heading rather than threaded
      // through as a new parameter -- confirmCloseEnquiry never had it in
      // scope, only openCloseModal did.
      if (res && res.needsBookedConfirmation) {
        var overlayForWarn = document.getElementById('close-modal-overlay');
        var modalBox = overlayForWarn ? overlayForWarn.querySelector('.close-modal, .close-modal-content, :scope > div') : null;
        var headingEl = overlayForWarn ? overlayForWarn.querySelector('h3') : null;
        var headingHtml = headingEl ? headingEl.outerHTML : '<h3>Close Enquiry</h3>';
        var reasonLabelEl = overlayForWarn ? overlayForWarn.querySelector('.close-reason-label') : null;
        var reasonHtml = reasonLabelEl ? reasonLabelEl.outerHTML : '<div class="close-reason-label">Reason: <strong>' + escHtml(reason) + '</strong></div>';
        if (modalBox) {
          modalBox.innerHTML =
            headingHtml + reasonHtml +
            '<div style="margin:0.6rem 0;padding:0.6rem 0.75rem;border-radius:var(--radius-small);background:rgba(179,39,39,0.08);color:var(--danger,#b32727);font-size:0.85rem;">' +
              escHtml(res.message) +
            '</div>' +
            '<div class="close-modal-actions">' +
              '<button class="btn-cancel" onclick="document.getElementById(\'close-modal-overlay\').remove()">Keep as booked</button>' +
              '<button class="btn-close-lead" onclick="confirmCloseEnquiry(\'' + escAttr(clientId) + '\', \'' + escAttr(reason) + '\', true)">Close anyway</button>' +
            '</div>';
        } else {
          // Modal element unexpectedly missing (should not happen) -- do not
          // silently drop the guardrail, still refuse to auto-proceed.
          jvToast(res.message || 'Booked bride -- close refused.', 'error');
        }
        return;
      }
      var overlay = document.getElementById('close-modal-overlay');
      if (overlay) overlay.remove();
      if (res && res.ok) {
        // Animate card out
        var card = document.getElementById('kcard-' + clientId);
        if (card) {
          card.classList.add('closing');
          setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); updateColCounts(); }, 350);
        }
        // Remove from in-memory state
        if (STATE.pipeline && STATE.pipeline.items) {
          STATE.pipeline.items = STATE.pipeline.items.filter(function(c) { return String(c.id) !== String(clientId); });
        }
        jvToast(res.message || 'Lead closed', 'success');
      } else {
        jvToast((res && res.message) || 'Failed to close lead', 'error');
      }
    }; _h(res.data); } else { var _e = function(err) {
      var overlay = document.getElementById('close-modal-overlay');
      if (overlay) overlay.remove();
      jvToast('Error: ' + (err.message || String(err)), 'error');
    }; _e(res.error); } })
    .catch(function(err) {
      var overlay = document.getElementById('close-modal-overlay');
      if (overlay) overlay.remove();
      jvToast('Error: ' + (err.message || String(err)), 'error');
    });
}

/* ============================================================
   DECLINE / UNAVAILABLE WORKFLOW
   ============================================================ */
function openDeclineModal(clientId, clientName, clientEmail) {
  var overlay = document.createElement('div');
  overlay.className = 'close-modal-overlay';
  overlay.id = 'decline-modal-overlay';
  overlay.dataset.clientEmail = clientEmail || '';
  overlay.innerHTML =
    '<div class="close-modal">' +
      '<h3 style="color:#c94040;">&#x26D4; Unavailable — ' + escHtml(clientName) + '</h3>' +
      '<p style="font-size:0.85rem; color:var(--muted); margin:0.25rem 0 1rem;">This will close the enquiry as <strong>Unavailable — Fully Booked</strong> and send a polite decline email to the bride.</p>' +
      '<label style="font-size:0.78rem; color:var(--muted);">Internal notes (optional):</label>' +
      '<textarea id="decline-notes-input" placeholder="e.g. Date fully committed, trial + 3 weddings…" style="margin-bottom:0.75rem;"></textarea>' +
      '<label style="display:flex; align-items:center; gap:0.5rem; font-size:0.85rem; cursor:pointer; margin-bottom:1rem;">' +
        '<input type="checkbox" id="decline-send-email" checked style="width:16px; height:16px; accent-color:var(--brand-primary);"> Send decline email to bride' +
      '</label>' +
      '<div class="close-modal-actions">' +
        '<button class="btn-cancel" onclick="document.getElementById(\'decline-modal-overlay\').remove()">Cancel</button>' +
        '<button class="btn-close-lead" id="btn-confirm-decline" style="background:#c94040;" onclick="confirmDeclineUnavailable(\'' + escAttr(clientId) + '\')">Confirm &amp; Close</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.querySelector('textarea').focus();
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
}

function confirmDeclineUnavailable(clientId) {
  var notes     = (document.getElementById('decline-notes-input') || {}).value || '';
  var sendEmail = document.getElementById('decline-send-email') ? document.getElementById('decline-send-email').checked : true;
  var overlayEl = document.getElementById('decline-modal-overlay');
  // Row-position identity guard (adminCrm_declineUnavailable now fails closed
  // without an email, see AdminCRMAPI.gs, same pattern as reopenEnquiry).
  var clientEmail = (overlayEl && overlayEl.dataset.clientEmail) || '';
  var btn = document.getElementById('btn-confirm-decline');
  if (btn) { btn.disabled = true; btn.textContent = 'Processing…'; }

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_declineUnavailable', args: { clientId: clientId, notes: notes.trim(), sendEmail: sendEmail, email: clientEmail } })
    .then(function(res) {
      var overlay = document.getElementById('decline-modal-overlay');
      if (overlay) overlay.remove();
      if (res.ok) {
        var data = res.data || res;
        var card = document.getElementById('kcard-' + clientId);
        if (card) {
          card.classList.add('closing');
          setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); updateColCounts(); }, 350);
        }
        if (STATE.pipeline && STATE.pipeline.items) {
          STATE.pipeline.items = STATE.pipeline.items.filter(function(c) { return String(c.id) !== String(clientId); });
        }
        jvToast((data && data.message) || 'Lead closed — decline email sent', 'success');
      } else {
        jvToast((res.error && res.error.message) || res.error || 'Failed to decline', 'error');
      }
    })
    .catch(function(err) {
      var overlay = document.getElementById('decline-modal-overlay');
      if (overlay) overlay.remove();
      jvToast('Error: ' + (err.message || String(err)), 'error');
    });
}

/* ============================================================
   CLOSED LEADS VIEW + REOPEN
   ============================================================ */
function renderClosedLeads(closedClients) {
  var container = document.getElementById('closed-leads-container');
  if (!container) return;

  if (!closedClients || closedClients.length === 0) {
    container.innerHTML = '<div style="text-align:center; padding:2rem; color:var(--muted); font-size:0.85rem;">No closed leads</div>';
    return;
  }

  var html = '<div class="closed-list">';
  closedClients.forEach(function(c) {
    html += '<div class="closed-card">' +
      '<div class="kc-avatar">' + escHtml(getInitials(c.name)) + '</div>' +
      '<div class="closed-info">' +
        '<div class="closed-name">' + stripTagsAndEscape_(c.name) + '</div>' +
        '<div class="closed-meta">' + stripTagsAndEscape_(c.email || '') +
          (c.closeDate ? ' · Closed ' + escHtml(c.closeDate) : '') +
          (c.closeNotes ? ' · ' + escHtml(c.closeNotes) : '') +
        '</div>' +
      '</div>' +
      '<span class="closed-reason">' + escHtml(c.closeReason || 'Closed') + '</span>' +
      '<button class="btn-reopen" onclick="reopenEnquiry(\'' + escAttr(c.id) + '\', \'' + escAttr(c.name) + '\', this, \'' + escAttr(c.email || '') + '\')">Reopen</button>' +
    '</div>';
  });
  html += '</div>';
  container.innerHTML = html;
}

function reopenEnquiry(clientId, clientName, btnEl, clientEmail) {
  if (!confirm('Reopen ' + clientName + '? This will move them back to the Enquiry stage.')) return;
  var origLabel = btnEl ? btnEl.textContent : '';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Reopening…'; }

  // Row-position identity guard (adminCrm_reopenEnquiry fails closed without
  // an email -- see AdminCRMAPI.gs BRIEF-row-position-staleness-fixes-2026-07-16).
  // Found live-broken 2026-09-23: this caller never passed email, so every
  // reopen click was silently refused server-side ("Cannot verify this
  // bride's row without an email on record"). c.email is already rendered
  // into the closed-card markup in renderClosedLeads -- just wasn't threaded
  // through the onclick until now.
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_reopenEnquiry', args: { clientId: clientId, email: clientEmail || '' } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res && res.ok) {
        jvToast(res.message || 'Lead reopened', 'success');
        loadPipelineView(true); // full refresh, bust cache
      } else {
        jvToast((res && res.message) || 'Failed to reopen', 'error');
        if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
      }
    }; _h(res.data); } else { var _e = function(err) {
      jvToast('Error: ' + (err.message || String(err)), 'error');
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
    }; _e(res.error); } })
    .catch(function(err) {
      jvToast('Error: ' + (err.message || String(err)), 'error');
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
    });
}

/* ============================================================
   PROPOSAL PENDING - APPROVE & SEND PREVIEW MODAL
   (2026-10-02, BUILD-SCOPE-admin-crm-pipeline-cloudflare-hardening-2026-10-01
   PL-03: a bare native confirm() let one click send a live proposal email
   with no recipient/total/review-status visible first. Replaced with a real
   preview reusing the SAME data source and render helpers as the existing
   "Proposal" view modal (adminCrm_getProposalCalc + proposalCalcModal_*) --
   same totals/status-pill/timestamps Jess already trusts there, surfaced
   BEFORE the irreversible send instead of only after it. No new GAS send
   logic per build doctrine: proposalApproveAndSend is the SAME call as
   before, unchanged, now gated behind an explicit "Send proposal" button in
   this modal instead of a native confirm(). Deliberately NOT dry-run/
   disabled -- this hardens an already-live send action, it does not add a
   new one, so disabling it would be a regression, not a safety improvement.
   ============================================================ */
function pipelineApproveSend(btn) {
  var brideName = btn.getAttribute('data-bride');
  var email = btn.getAttribute('data-email') || '';
  if (!brideName) return;

  proposalCalcModal_injectStyles_();
  var overlay = document.createElement('div');
  overlay.className = 'jv-pcm-overlay';
  overlay.innerHTML = '<div class="jv-pcm-modal"><div class="jv-pcm-loading">Loading proposal...</div></div>';
  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) { close_(); return; }
    if (e.target && (e.target.id === 'jvApmClose' || e.target.id === 'jvApmCancel')) { close_(); return; }
    if (e.target && e.target.id === 'jvApmSend') { doApproveSend_(btn, brideName, overlay); return; }
  });

  if (!email) {
    // No email on the card -- can't look up a proposal calc for totals, but
    // still show a real preview rather than a bare confirm(): bride name
    // only, with an explicit warning so the admin knows recipient details
    // could not be verified before sending.
    overlay.innerHTML = pipelineApproveSendModal_render_(null, brideName, email,
      'Could not verify recipient email for this card, check the client record before sending.');
    return;
  }

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getProposalCalc', args: { email: email } })
    .then(function(res) {
      var data = (res && res.ok && res.data && res.data.ok) ? res.data : null;
      overlay.innerHTML = pipelineApproveSendModal_render_(data, brideName, email,
        data ? '' : 'Could not load proposal details, review in the Proposal Builder before sending.');
    })
    .catch(function() {
      overlay.innerHTML = pipelineApproveSendModal_render_(null, brideName, email,
        'Could not load proposal details, review in the Proposal Builder before sending.');
    });
}

function pipelineApproveSendModal_render_(data, brideName, email, warning) {
  var calc = data && data.calc ? data.calc : null;
  var subtotal = calc && calc.subtotal != null ? Number(calc.subtotal) : null;
  var gst      = calc && calc.gst      != null ? Number(calc.gst)      : null;
  var total    = calc && calc.total    != null ? Number(calc.total)
               : (data && data.tokenTotal != null ? Number(data.tokenTotal) : null);

  var totalsHtml = '';
  if (subtotal != null || gst != null || total != null) {
    totalsHtml = '<div class="jv-pcm-totals">';
    if (subtotal != null) totalsHtml += '<div class="jv-pcm-trow"><span>Subtotal</span><span>' + escHtml(proposalCalcModal_formatCurrency_(subtotal)) + '</span></div>';
    if (gst      != null) totalsHtml += '<div class="jv-pcm-trow"><span>GST</span><span>' + escHtml(proposalCalcModal_formatCurrency_(gst)) + '</span></div>';
    if (total    != null) totalsHtml += '<div class="jv-pcm-trow jv-pcm-grand"><span>Total</span><span>' + escHtml(proposalCalcModal_formatCurrency_(total)) + '</span></div>';
    totalsHtml += '</div>';
  }

  var statusHtml = data
    ? ('<div class="jv-pcm-status-row">' + proposalCalcModal_statusPill_(data) +
       '<div class="jv-pcm-timestamps"><span><strong>Last sent</strong>' +
       (data.sentAt ? escHtml(formatDate(data.sentAt)) : ' -') + '</span></div></div>')
    : '';

  return '<div class="jv-pcm-modal">' +
    '<div class="jv-pcm-head">' +
      '<h3>Send proposal to ' + escHtml(brideName) + '?</h3>' +
      '<button class="jv-pcm-close" id="jvApmClose" aria-label="Close">&times;</button>' +
    '</div>' +
    '<p class="jv-pcm-sub">Recipient: ' + escHtml(email || 'unknown email') + '</p>' +
    (warning ? '<div class="jv-pcm-error" style="margin-bottom:1rem">' + escHtml(warning) + '</div>' : '') +
    statusHtml +
    totalsHtml +
    '<p class="jv-pcm-sub">Make sure this has been reviewed in the Proposal Builder before sending. ' +
      'This emails the client immediately and cannot be undone.</p>' +
    '<div class="jv-pcm-footer">' +
      '<button class="jv-pcm-cancel" id="jvApmCancel">Cancel</button>' +
      '<button class="jv-pcm-primary" id="jvApmSend">Send proposal</button>' +
    '</div>' +
  '</div>';
}

function doApproveSend_(btn, brideName, overlay) {
  var sendBtn = document.getElementById('jvApmSend');
  if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = 'Sending...'; }

  jvBridge.callAdmin('proposalApproveAndSend', { brideName: brideName, options: { firedBy: (window.jvAuth && window.jvAuth.email) || '' } })
    .then(function(res) {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      var data = (res && res.data) ? res.data : res;
      if (res && res.ok && data && data.ok !== false) {
        jvToast('Proposal sent to ' + brideName, 'success');
        setTimeout(function() { loadPipelineView(true); }, 1200);
      } else {
        var msg = (data && data.error) || (res && res.error) || 'Unknown error';
        jvToast('Send failed: ' + msg, 'error');
      }
    })
    .catch(function(err) {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      jvToast('Send failed: ' + (err.message || String(err)), 'error');
    });
}

/* ============================================================
   STAGE MANAGER MODAL
   ============================================================ */
function openStageManager() {
  // Load current stages from backend
  jvBridge.callAdmin('bridge_admin_getStages', )
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res && res.ok) {
        renderStageManagerModal(res.stages);
      } else {
        jvToast('Failed to load stages: ' + (res && res.error || ''), 'error');
      }
    }; _h(res.data); } else { var _e = function(err) {
      jvToast('Error loading stages: ' + (err.message || String(err)), 'error');
    }; _e(res.error); } })
    .catch(function(err) {
      jvToast('Error loading stages: ' + (err.message || String(err)), 'error');
    });
}

function renderStageManagerModal(stages) {
  var overlay = document.createElement('div');
  overlay.className = 'stage-mgr-overlay';
  overlay.id = 'stage-mgr-overlay';

  var html = '<div class="stage-mgr-modal">' +
    '<h3>Manage Pipeline Stages</h3>' +
    '<div class="stage-mgr-list" id="stage-mgr-list">';

  stages.forEach(function(s, idx) {
    html += buildStageManagerRow(s, idx);
  });

  html += '</div>' +
    '<button class="stage-mgr-add" onclick="addStageRow()">+ Add Stage</button>' +
    '<div class="stage-mgr-hint">' +
      '<span><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/></svg> drag to reorder</span>' +
      '<span><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> system stage (cannot be removed)</span>' +
    '</div>' +
    '<div class="stage-mgr-footer">' +
      '<button class="btn-cancel" onclick="document.getElementById(\'stage-mgr-overlay\').remove()">Cancel</button>' +
      '<button class="btn-save" id="btn-save-stages" onclick="saveStagesFromModal()">Save</button>' +
    '</div>' +
  '</div>';

  overlay.innerHTML = html;
  document.body.appendChild(overlay);

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) overlay.remove();
  });

  initStageManagerDragDrop();
}

function buildStageManagerRow(s, idx) {
  var isSystem = s.system;
  return '<div class="stage-mgr-row" data-stage-name="' + escAttr(s.name) + '" data-system="' + (isSystem ? 'true' : 'false') + '">' +
    '<span class="stage-mgr-drag"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/></svg></span>' +
    '<span class="stage-mgr-order">' + (idx + 1) + '</span>' +
    '<input class="stage-mgr-name" type="text" value="' + escAttr(s.name) + '"' +
      (isSystem ? ' readonly title="System stage — cannot be renamed"' : '') +
      ' data-original="' + escAttr(s.name) + '">' +
    '<input class="stage-mgr-colour" type="color" value="' + escAttr(s.colour || '#d3d3d3') + '">' +
    (isSystem
      ? '<span class="stage-mgr-lock" title="System stage"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span><span style="width:22px"></span>'
      : '<button class="stage-mgr-remove icon-btn" title="Remove stage" onclick="removeStageRow(this)"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>') +
  '</div>';
}

function addStageRow() {
  var list = document.getElementById('stage-mgr-list');
  if (!list) return;
  var idx = list.querySelectorAll('.stage-mgr-row').length;
  var tmpDiv = document.createElement('div');
  tmpDiv.innerHTML = buildStageManagerRow({ name: '', colour: '#d3d3d3', system: false, count: 0 }, idx);
  var row = tmpDiv.firstChild;
  list.appendChild(row);
  row.querySelector('.stage-mgr-name').focus();
  renumberStageRows();
  initStageManagerDragDrop();
}

function removeStageRow(btn) {
  var row = btn.closest('.stage-mgr-row');
  if (!row) return;
  var stageName = row.querySelector('.stage-mgr-name').value.trim();
  if (row.dataset.system === 'true') {
    jvToast('System stages cannot be removed.', 'error');
    return;
  }
  row.remove();
  renumberStageRows();
}

function renumberStageRows() {
  var list = document.getElementById('stage-mgr-list');
  if (!list) return;
  list.querySelectorAll('.stage-mgr-row').forEach(function(row, i) {
    var order = row.querySelector('.stage-mgr-order');
    if (order) order.textContent = i + 1;
  });
}

function initStageManagerDragDrop() {
  var list = document.getElementById('stage-mgr-list');
  if (!list) return;
  var dragEl = null;

  list.querySelectorAll('.stage-mgr-row').forEach(function(row) {
    row.setAttribute('draggable', 'true');
    row.addEventListener('dragstart', function(e) {
      dragEl = row;
      row.classList.add('dragging');
      e.dataTransfer.effectAllowed = 'move';
    });
    row.addEventListener('dragend', function() {
      row.classList.remove('dragging');
      dragEl = null;
      renumberStageRows();
    });
    row.addEventListener('dragover', function(e) {
      e.preventDefault();
      if (!dragEl || dragEl === row) return;
      var rect = row.getBoundingClientRect();
      var midY = rect.top + rect.height / 2;
      if (e.clientY < midY) {
        list.insertBefore(dragEl, row);
      } else {
        list.insertBefore(dragEl, row.nextSibling);
      }
    });
  });
}

function saveStagesFromModal() {
  var list = document.getElementById('stage-mgr-list');
  if (!list) return;
  var btn = document.getElementById('btn-save-stages');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  var stages = [];
  var renames = [];
  var rows = list.querySelectorAll('.stage-mgr-row');

  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    var nameInput = row.querySelector('.stage-mgr-name');
    var colourInput = row.querySelector('.stage-mgr-colour');
    var name = nameInput.value.trim();
    var original = nameInput.dataset.original || '';
    if (!name) {
      jvToast('Stage name cannot be empty.', 'error');
      btn.disabled = false;
      btn.textContent = 'Save';
      return;
    }
    stages.push({
      order: i + 1,
      name: name,
      colour: colourInput.value,
      system: row.dataset.system === 'true',
      created: '',
      createdBy: original ? '' : 'Admin'
    });
    // Track renames
    if (original && original !== name) {
      renames.push({ oldName: original, newName: name });
    }
  }

  // Process renames first (sequentially), then save
  processRenames(renames, 0, function() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_saveStages', args: { stages: stages } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
        if (res && res.ok) {
          document.getElementById('stage-mgr-overlay').remove();
          jvToast(res.message || 'Stages saved', 'success');
          // Refresh pipeline to pick up new stages
          loadPipelineViewWithStages(true);
        } else {
          btn.disabled = false;
          btn.textContent = 'Save';
          jvToast((res && res.message) || 'Failed to save stages', 'error');
        }
      }; _h(res.data); } else { var _e = function(err) {
        btn.disabled = false;
        btn.textContent = 'Save';
        jvToast('Error: ' + (err.message || String(err)), 'error');
      }; _e(res.error); } })
    .catch(function(err) {
        btn.disabled = false;
        btn.textContent = 'Save';
        jvToast('Error: ' + (err.message || String(err)), 'error');
      });
  });
}

function processRenames(renames, idx, callback) {
  if (idx >= renames.length) { callback(); return; }
  var r = renames[idx];
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_renameStage', args: { oldName: r.oldName, newName: r.newName } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res && res.ok) {
        jvToast('Renamed "' + r.oldName + '" → "' + r.newName + '" (' + (res.rowsUpdated || 0) + ' clients updated)', 'success');
      }
      processRenames(renames, idx + 1, callback);
    }; _h(res.data); } else { var _e = function() {
      processRenames(renames, idx + 1, callback);
    }; _e(res.error); } })
    .catch(function() {
      processRenames(renames, idx + 1, callback);
    });
}

/* ============================================================
   DYNAMIC STAGE LOADING
   ============================================================ */
// Extracted handler — shared between inline CDN path and GAS path.
function _applyInitialPayload_(payload) {
  if (!payload) { showError('pipeline', 'No response from server'); return; }
  if (payload.stages && payload.stages.ok) {
    STATE.stageConfig = payload.stages.stages;
    STATE.pipelineStages = payload.stages.stages.map(function(s) { return s.name; });
    STATE.stageColours = {};
    payload.stages.stages.forEach(function(s) { STATE.stageColours[s.name] = s.colour; });
  }
  if (payload.notifications) {
    _bellNotifications = payload.notifications.notifications || [];
    var counts = payload.notifications.counts || { high: 0, medium: 0, low: 0 };
    var total = counts.high + counts.medium + counts.low;
    var badge = document.getElementById('bell-badge');
    if (badge) badge.textContent = total > 0 ? total : '';
    renderBellDropdown();
  }
  onPipelineLoaded(payload.pipeline);
}

function loadPipelineViewWithStages(forceRefresh) {
  // A forced refresh follows a CRM write — drop the client search index too so
  // search reflects the change without waiting for the 30-min TTL.
  if (forceRefresh) { try { jvClientIdxCache_clear(); } catch(e) {} }
  showLoader('pipeline');
  document.getElementById('kanban-board').style.display = 'none';
  document.getElementById('closed-leads-container').style.display = 'none';

  var pipelineOpts = { token: STATE.token };
  if (forceRefresh) pipelineOpts.refresh = true;

  // ── Fast path: render inline CDN data immediately, then background-refresh ──
  // _PIPELINE_INLINE_ is populated from the <script id="jv-admin-pipeline-payload">
  // tag baked into the page by Liquid from custom.admin_crm_pipeline_cache metafield.
  if (!forceRefresh && _PIPELINE_INLINE_ && _PIPELINE_INLINE_.ok) {
    _applyInitialPayload_(_PIPELINE_INLINE_);
    // 2026-07-31 (permanent local-first fix): the page painted from the CDN island, so a
    // subsequent background-verify failure must be INVISIBLE, never a banner. This flag is
    // read by both this page's showError and the shared jvPortalShell.showError.
    window._jvIslandPainted = true;
    // Silent background refresh: always refresh STATE.pipeline (so closedClients
    // and notifications are populated), re-render visible view only if counts changed
    // or the user is currently viewing the Closed stage.
    setTimeout(function() {
      jvBridge.callAdmin('bridge_admin_getInitialPayload', { token: STATE.token })
        .then(function(res) {
          if (!res || !res.ok || !res.data) return;
          _PIPELINE_INLINE_ = res.data;
          var viewingClosed = STATE.currentStageFilter === 'Closed';
          var prev = STATE.pipeline && JSON.stringify(STATE.pipeline.stageCounts);
          var next = res.data.pipeline && JSON.stringify(res.data.pipeline.stageCounts);
          if (viewingClosed || prev !== next) {
            _applyInitialPayload_(res.data); // full re-render
          } else if (res.data.pipeline) {
            // Silently update pipeline state (populates closedClients for later use)
            STATE.pipeline = res.data.pipeline;
            if (res.data.notifications) {
              _bellNotifications = res.data.notifications.notifications || [];
              renderBellDropdown();
            }
          }
        })
        .catch(function() {});
    }, 800);
    return;
  }

  // ── Normal path: GAS call (inline cache absent or force-refresh) ──
  jvBridge.callAdmin('bridge_admin_getInitialPayload', pipelineOpts)
    .then(function(res) {
      if (res.ok) {
        if (res.data) _PIPELINE_INLINE_ = res.data; // cache for background re-use
        _applyInitialPayload_(res.data);
      } else {
        pipelineLoadFailed_((res.error && (res.error.message || String(res.error))) || 'Load failed');
      }
    })
    .catch(function(err) { pipelineLoadFailed_(err.message || String(err)); });
}

// 2026-08-18 (BRIEF-pipeline-force-refresh-stale-fallback-2026-08-18.md): the
// fast path already suppresses a failed background refresh when the island
// painted (window._jvIslandPainted, showError's own guard). This is the same
// idea for the "Normal path" above (island absent, or an explicit force-
// refresh), which had NO such guard: any failure there went straight to a
// blank hard-error screen even when STATE.pipeline already held good data
// from a prior successful load earlier in the same session (e.g. the admin
// clicks "Try again" and that retry itself fails again).
//
// If STATE.pipeline has real content, skip the hard error, re-render it (the
// loading function above unconditionally hides the kanban board and shows
// the loader at the very start of every call, including a force-refresh, so
// the DOM needs re-painting even though the data itself was never cleared),
// and show a small non-blocking toast instead of nothing. First-ever load
// with no prior data (genuinely nothing to fall back to) still gets the
// normal hard-error banner, unchanged.
function pipelineLoadFailed_(msg) {
  if (STATE.pipeline && STATE.pipeline.stageCounts) {
    onPipelineLoaded(STATE.pipeline);
    jvToast("Couldn't refresh, showing the last loaded data.", 'warn');
    return;
  }
  showError('pipeline', msg);
}

/* ============================================================
   DRAG & DROP
   ============================================================ */
var _dragClientId = null;
function dragStart(event, clientId) {
  _dragClientId = clientId;
  event.dataTransfer.effectAllowed = 'move';
}
function dragOver(event) {
  event.preventDefault();
  event.currentTarget.classList.add('drag-over');
}
function dropCard(event, newStage) {
  event.preventDefault();
  event.currentTarget.classList.remove('drag-over');
  var clientId = _dragClientId;
  if (!clientId || !newStage) return;
  var oldStage = null;
  var cardEmail = '';
  // Optimistic update
  if (STATE.pipeline && STATE.pipeline.items) {
    STATE.pipeline.items.forEach(function(c){ if (c.id === clientId) { oldStage = c.stage; cardEmail = c.email || ''; c.stage = newStage; } });
    renderKanban(STATE.pipeline.items);
  }
  function revertOptim_() {
    if (STATE.pipeline && STATE.pipeline.items && oldStage) {
      STATE.pipeline.items.forEach(function(c){ if (c.id === clientId) c.stage = oldStage; });
      renderKanban(STATE.pipeline.items);
    }
  }
  // B.4 (2026-05-26): payment-guard aware drop. Re-callable with forceOverride after admin confirms.
  function sendDropCardUpdate_(force) {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_updateStage', args: { clientId: clientId, newStage: newStage, forceOverride: !!force, email: cardEmail } })
      .then(function(res) {
        if (!res.ok) {
          revertOptim_();
          jvToast('Error: ' + (res.error && res.error.message ? res.error.message : String(res.error || '')), 'error');
          return;
        }
        var data = res.data;
        if (data && data.requiresOverride && !force) {
          var brideName = 'this bride';
          if (STATE.pipeline && STATE.pipeline.items) {
            STATE.pipeline.items.forEach(function(c) { if (c.id === clientId && c.name) brideName = c.name; });
          }
          paymentGuard_showModal(brideName, oldStage || '?', newStage, function() {
            sendDropCardUpdate_(true);
          }, function() {
            revertOptim_();
          });
          return;
        }
        if (!data || !data.success) {
          revertOptim_();
          jvToast('Stage update failed: ' + (data && data.message || 'Unknown error'), 'error');
        } else {
          jvToast(stageDisplay(newStage) + ' — updated', 'success');
          if (typeof _drawerBundleCache !== 'undefined') delete _drawerBundleCache[String(clientId)];
        }
      })
      .catch(function(err) {
        revertOptim_();
        jvToast('Error: ' + (err.message || String(err)), 'error');
      });
  }
  sendDropCardUpdate_(false);
}

/* ============================================================
   CLIENTS VIEW
   ============================================================ */
/* Deep-link support (2026-08-06): the sidebar's "Partners" entry points at
   #clients?type=partner. There is no separate Partners page; partners ARE
   client rows with CLIENT_CATEGORY Vendor / Wedding Planner. This preselects
   the category filter so the entry lands on a partner list rather than the
   full client list, which is what made partners unfindable before.
   Reads location.hash only, sets a value, no network call. */
function applyClientsDeepLinkFilter_() {
  var raw = '';
  try { raw = location.hash ? location.hash.substring(1) : ''; } catch (e) { return false; }
  // 2026-08-07: a hash with NO query means "show all clients", so CLEAR any
  // filter left over from a previous Partners visit. Previously this returned
  // early and left the stale filter applied, so Partners -> Pipeline -> All
  // Clients still showed only partners. Returns true when it changed something
  // so the caller re-filters.
  if (raw.indexOf('?') === -1) {
    var _clearEl = document.getElementById('clients-category-filter');
    if (_clearEl && _clearEl.value) { _clearEl.value = ''; return true; }
    return false;
  }
  var qs = raw.substring(raw.indexOf('?') + 1);
  var type = '';
  qs.split('&').forEach(function (kv) {
    var bits = kv.split('=');
    if (decodeURIComponent(bits[0] || '') === 'type') type = decodeURIComponent(bits[1] || '');
  });
  if (!type) return false;
  var catEl = document.getElementById('clients-category-filter');
  if (!catEl) return false;
  var target = (type === 'partner') ? '__partner' : type;
  // Only apply a value the control actually offers, so a stale or hand-typed
  // URL cannot put the filter into a state that matches nothing.
  var valid = Array.prototype.some.call(catEl.options, function (o) { return o.value === target; });
  if (!valid) return false;
  catEl.value = target;
  return true;
}

// Admin-clients CF read (2026-10-07). Dark by default; flipped via the shop
// metafield `custom.admin_clients_d1_read` which `sections/jv-admin-crm.liquid`
// renders into `window.ADMIN_CLIENTS_D1_READ_FLAG_` at section-render time.
// Rollback = flip the metafield back to false in Shopify Admin; no code
// deploy needed. See BRIEFS/PATCH-admin-clients-wireup-2026-10-07.md and the
// bridge-fix follow-up at state/findings/HANDOFF-admin-clients-metafield-
// bridge-fix-2026-10-07.md.
var ADMIN_CLIENTS_D1_READ_ENABLED_ = (typeof window !== 'undefined' && window.ADMIN_CLIENTS_D1_READ_FLAG_ === true);

// Normalise the exporter contract (empty-string on blank) vs D1 reality (NULL on
// pre-backfill rows for pre-9d9b28ace rows). Costs nothing on a correctly-
// exported row.
function _normaliseExtra_(row) {
  if (!row) return row;
  row.quote_sent_at_date  = row.quote_sent_at_date  == null ? '' : row.quote_sent_at_date;
  row.last_comms_response = row.last_comms_response == null ? '' : row.last_comms_response;
  row.assigned_artist     = row.assigned_artist     == null ? '' : row.assigned_artist;
  row.balance_due         = row.balance_due         == null ? '' : row.balance_due;
  return row;
}

function loadClientsView(forceLive) {
  // T1 (Group B, 2026-07-19): paint the clients list from the CDN island first (~0.3s,
  // zero GAS) instead of the ~30s-timeout cold adminCrm_getClients. The island is written
  // by AdminClientsCache.gs -> shop.metafields.custom.admin_clients_cache_json and is
  // server-refreshed hourly + daily.
  //
  // PERF FIX 2026-07-23: when the island paints, DO NOT auto-fire the live refresh.
  // The live adminCrm_getClients call routes through the Cloudflare worker whose relay
  // cap is ~30s; the call takes ~32s and 504s every time, stalling the tab and flooding
  // the console with Gateway Timeouts for ZERO benefit (island is already hourly-fresh).
  // Live is now used ONLY when the island is empty, or on an explicit Refresh
  // (loadClientsView(true) from the Refresh button).
  //
  // CF wire-up (2026-10-07): _clientsBg_ now tries the D1 Worker (via the relay's
  // /partner/admin-clients/read entity, same App-Proxy identity chain as every
  // other 'admin' actorType entity) FIRST when ADMIN_CLIENTS_D1_READ_ENABLED_ is
  // true, falling through to the GAS adminCrm_getClients route on error, empty
  // response, or unexpected shape. Three-tier stack: island (Tier 0) unchanged ->
  // CF (Tier 1) new -> GAS (Tier 2). A failure at Tier 1 is invisible to admins
  // because Tier 2 catches it. Same native-fetch escape (_jvNativeFetch) +
  // Content-Type: text/plain + simple-request body as every other /partner/
  // relay call so third-party XHR patching cannot promote this to preflight.
  var _clientsBg_ = function() {
    var cfTried = false;
    function tryCf_() {
      var base = window._jvAdminProxyBase;
      if (!ADMIN_CLIENTS_D1_READ_ENABLED_ || !base) return Promise.resolve({ ok: false, _skip: true });
      cfTried = true;
      var nf = (window._jvNativeFetch || window.fetch).bind(window);
      var url = String(base).replace(/\/+$/, '') + '/partner/admin-clients/read';
      return nf(url, {
        method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({})
      }).then(function(r) { return r.json(); }).then(function(b) {
        if (!b || b.ok !== true) return { ok: false };
        var list = Array.isArray(b.data) ? b.data : (b.data && (b.data.clients || b.data.rows)) || b.clients || [];
        if (!Array.isArray(list) || !list.length) return { ok: false };   // honest unchecked -> fall through to GAS
        list.forEach(_normaliseExtra_);
        return { ok: true, data: list };
      }).catch(function() { return { ok: false }; });
    }
    function fallbackGas_() {
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients' })
        .then(function(res) { if (res.ok) onClientsLoaded(res.data); else if (!STATE.clients || !STATE.clients.length) { showError('clients', (res.error && res.error.message) || String(res.error)); } })
        .catch(function(err){ if (!STATE.clients || !STATE.clients.length) showError('clients', err.message || String(err)); });
    }
    tryCf_().then(function(cf) {
      if (cf.ok) { onClientsLoaded(cf.data); return; }
      if (cfTried) {
        // Log once per load so a stale/empty D1 is visible but not noisy.
        try { console.info('[admin-clients] CF path returned empty/error, falling back to GAS.'); } catch (e) {}
      }
      fallbackGas_();
    });
  };
  if (forceLive) {                      // explicit Refresh: paint whatever is there, then live
    // Partners view (2026-08-13): Refresh while on Partners must re-fetch the
    // partner roster, not the bride list -- the bride fetch would silently do
    // nothing useful here and the stale partner cache would keep showing.
    var catElRefresh = document.getElementById('clients-category-filter');
    if (catElRefresh && catElRefresh.value === '__partner') {
      _partnersCache_ = null;
      loadPartnersList_();
      return;
    }
    showLoader('clients');
    _clientsBg_();
    return;
  }
  adminCacheParseIsland_('jv-admin-clients-cache', function(cached) {
    var list = cached && (Array.isArray(cached) ? cached : (cached.data || cached.clients));
    if (Array.isArray(list) && list.length) {
      onClientsLoaded(list);           // instant paint from island; trust it, no live call
    } else {
      showLoader('clients');           // no island -> fall back to the live call
      document.getElementById('clients-list').style.display = 'none';
      _clientsBg_();
    }
  });
}

function onClientsLoaded(data) {
  STATE.clients = Array.isArray(data) ? data : [];
  // 2026-08-06: honour a #clients?type=partner deep link BEFORE the paint below,
  // so the sidebar's Partners entry lands on a filtered list on first render
  // rather than flashing the full client list and then filtering.
  try { applyClientsDeepLinkFilter_(); } catch (e) {}
  // Money-canonical override (2026-08-12, Slice 1): adminCrm_getClients's own
  // balanceDue reads the CRM's whole-invoice BALANCE DUE column, a separate,
  // independently-derived figure from the itemised-charge reconciliation
  // engine (bbsRecon_build_) that Bride Profile / Money / Operations Inbox all
  // read. Overlay the canonical per-bride balance from the SAME hourly cache
  // Money itself paints from, so the "Balance Owing" badge here can never
  // disagree with those three surfaces. Async (cache may be gzip'd); repaints
  // once resolved if it changed anything, using the paint path already below.
  applyClientsMoneyOverride_(function () {
    paintClientsList_();
  });
  try { primeStaleCount_(); } catch (e) {}
  paintClientsList_();
  showContent('clients');
  document.getElementById('clients-list').style.display = '';
}

// Extracted from onClientsLoaded (2026-08-12) so the money-override repaint
// and the initial paint share one path.
function paintClientsList_() {
  // BUGFIX 2026-07-26 (BRIEF-stale-list-sort-filter-bug): re-apply the admin's ACTIVE
  // filter/sort instead of dumping the raw list. Previously this called
  // renderClientsList(STATE.clients) with the unfiltered/unsorted list, so every live
  // or background refresh silently discarded the selected filter/sort until the admin
  // re-touched a control ("not sorting as per the selected filter until the page loads").
  // filterClientsList() reads the current control values and applies the default 'date'
  // sort when none is chosen, so routing first paint through it also fixes raw sheet-order
  // on first render. Fall back to a raw render only if the filter controls aren't in the
  // DOM yet (defensive; they are part of the same section markup so this is rare).
  if (document.getElementById('clients-sort') && typeof filterClientsList === 'function') {
    filterClientsList();
  } else {
    renderClientsList(STATE.clients);
  }
}

var _clientsMoneyOverrideApplied_ = false;
function applyClientsMoneyOverride_(onChanged) {
  if (_clientsMoneyOverrideApplied_) { return; }
  adminCacheParseIsland_('jv-admin-clients-money-cache', function (cached) {
    var rows = cached && cached.data && cached.data.rows;
    if (!Array.isArray(rows) || !Array.isArray(STATE.clients)) return;
    var byEmail = {};
    rows.forEach(function (r) { if (r && r.email) byEmail[String(r.email).toLowerCase().trim()] = r; });
    var changed = false;
    var todayMs = Date.now();
    STATE.clients.forEach(function (c) {
      var key = String(c.email || '').toLowerCase().trim();
      if (!key) return;
      // bbsReconDashboard_build_ only scans BOOKED + future-wedding brides
      // (matches the exact predicate in BbsReconDashboard.gs). Only override
      // within that same scope -- for anyone outside it (not booked, or
      // wedding already past) the dashboard has no opinion either way, so
      // leave the CRM figure alone rather than asserting a wrong zero.
      if (!c.isBooked) return;
      var wdMs = c.weddingDate ? Date.parse(c.weddingDate) : NaN;
      if (!isNaN(wdMs) && wdMs < todayMs) return;
      var recon = byEmail[key];
      // No drift row within scope means bbsRecon considers her reconciled
      // (owedCents/balanceDueCents both 0) -- the dashboard only lists
      // brides WITH drift, so absence within scope is itself the canonical
      // "nothing owing" signal.
      var canonicalBalance = recon ? (recon.balanceDueCents || 0) / 100 : 0;
      if (c.balanceDue !== canonicalBalance) { c.balanceDue = canonicalBalance; changed = true; }
    });
    _clientsMoneyOverrideApplied_ = true;
    if (changed && typeof onChanged === 'function') onChanged();
  });
}

// --- All Clients pagination state (perf: avoid one ~48,000px innerHTML for ~1,300 rows) ---
var CLIENTS_PAGE_SIZE = 75;
var _clientsRendered = [];   // module-level ref to the current (full filtered) array
var _clientsShown = 0;       // how many rows currently rendered

// Build the HTML for a single client row (preserves exact original markup/classes).
// All Clients row click -> the full tokenised client page (the real client home),
// not the pipeline drawer (BRIEF-bbs-client-page-placement 2026-07-26: pipeline/drawer
// is a stage-reference surface; the client page is where the BBS + everything lives).
// Falls back to the drawer only when the row has no resolvable email (thin/unresolved).
window.openClientProfile_ = function (email, id, brideUid) {
  var e = String(email || '').trim();
  if (e) {
    // Pass brideUid too (2026-08-25 identity-mismatch fix) so a bride sharing her
    // email with another CRM row (duplicate/test rows) opens the EXACT row
    // clicked, not whichever row the email-only resolver happens to prefer.
    // brideUid is the real per-bride identity (never shifts); id (the sheet row
    // number) is only a same-call fallback for rows minted before the BRIDE_UID
    // backfill. AdminBrideProfileAPI.gs treats both as optional, absent/invalid
    // falls back to the existing email-only resolution unchanged.
    var url = '/pages/admin-bride-profile?bride=' + encodeURIComponent(e);
    if (brideUid) url += '&uid=' + encodeURIComponent(brideUid);
    else if (id) url += '&row=' + encodeURIComponent(id);
    window.location.href = url;
    return;
  }
  if (typeof openDrawer === 'function' && id) openDrawer(id);
};

function buildClientRowHtml_(c) {
  var payStatus = getPaymentStatus(c);
  var atRiskClass = c.atRisk ? 'critical' : '';
  var initials = getInitials(c.name);
  var html = '';
  html += '<div class="client-row ' + atRiskClass + '" onclick="openClientProfile_(\'' + escAttr(c.email || '') + '\',\'' + escHtml(c.id) + '\',\'' + escAttr(c.brideUid || '') + '\')">';
  html += '<div class="avatar-circle" style="width:30px;height:30px;font-size:0.62rem;">' + escHtml(initials) + '</div>';
  html += '<div class="cell-name"><strong>' + stripTagsAndEscape_(c.name) + '</strong><span>' + stripTagsAndEscape_(c.email || '') + '</span></div>';
  html += '<div class="cell-date">' + formatDate(c.weddingDate) + '</div>';
  // SERVICES REQUESTED is free text and can run long (notes-like content from the
  // enquiry form). Render single-line; the CSS clamps with an ellipsis and the
  // title attr keeps the full text reachable on hover, so the row stays scannable.
  var svcText = Array.isArray(c.services) ? c.services.join(', ') : (c.services || '');
  html += '<div class="cell-services" title="' + escAttr(svcText) + '">' + escHtml(svcText) + '</div>';
  html += '<div class="cell-stage"><span class="stage-badge ' + stageBadgeClass(c.stage) + '">' + escHtml(stageDisplay(c.stage)) + '</span></div>';
  html += '<div class="cell-payment"><span class="payment-chip ' + payStatus.cls + '">' + payStatus.label + '</span></div>';
  html += '<button class="row-menu-btn" onclick="event.stopPropagation(); showClientMenu(event, \'' + escHtml(c.id) + '\', \'' + escAttr(c.email || '') + '\')" title="Actions">';
  html += '<svg viewBox="0 0 24 24"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg></button>';
  html += '</div>';
  return html;
}

// Refresh / inject the "Show more" pager button under the list.
function renderClientsPager_(listEl) {
  var pager = document.getElementById('clients-more-wrap');
  var remaining = _clientsRendered.length - _clientsShown;
  if (remaining <= 0) {
    if (pager) pager.parentNode.removeChild(pager);
    return;
  }
  var batch = Math.min(remaining, CLIENTS_PAGE_SIZE);
  var label = 'Show more (' + batch + ' of ' + remaining + ' remaining)';
  if (!pager) {
    pager = document.createElement('div');
    pager.id = 'clients-more-wrap';
    pager.style.textAlign = 'center';
    pager.style.padding = '16px 0';
    pager.innerHTML = '<button type="button" class="btn-ghost" id="clients-more-btn" onclick="showMoreClients()"></button>';
    listEl.parentNode.insertBefore(pager, listEl.nextSibling);
  }
  var btn = document.getElementById('clients-more-btn');
  if (btn) btn.textContent = label;
}

// Append the next page of rows.
function showMoreClients() {
  var listEl = document.getElementById('clients-list');
  if (!listEl) return;
  var next = _clientsRendered.slice(_clientsShown, _clientsShown + CLIENTS_PAGE_SIZE);
  var html = '';
  next.forEach(function(c) { html += buildClientRowHtml_(c); });
  listEl.insertAdjacentHTML('beforeend', html);
  _clientsShown += next.length;
  renderClientsPager_(listEl);
}

function renderClientsList(clients) {
  var listEl = document.getElementById('clients-list');
  // Reset to page 1 from the (full) filtered array.
  _clientsRendered = clients || [];
  _clientsShown = 0;
  var existingPager = document.getElementById('clients-more-wrap');
  if (existingPager) existingPager.parentNode.removeChild(existingPager);

  if (!clients || clients.length === 0) {
    // Friendly, actionable empty state (T5): distinguish "no clients at all" from
    // "filters/search matched nothing" so the admin isn't left staring at a dead end.
    var filtersActive = clientsFiltersActive_();
    if (filtersActive) {
      listEl.innerHTML = '<div class="empty-state"><div class="empty-icon">◎</div>' +
        '<p>No clients match this filter.</p>' +
        '<button type="button" class="btn btn-ghost" style="margin-top:0.5rem;" onclick="clearClientsFilters_()">Clear filters</button></div>';
    } else {
      listEl.innerHTML = '<div class="empty-state"><div class="empty-icon">◎</div><p>No clients found yet.</p></div>';
    }
    return;
  }
  var first = _clientsRendered.slice(0, CLIENTS_PAGE_SIZE);
  var html = '';
  first.forEach(function(c) { html += buildClientRowHtml_(c); });
  listEl.innerHTML = html;
  _clientsShown = first.length;
  renderClientsPager_(listEl);
}

function getPaymentStatus(c) {
  if (c.balanceDue && Number(c.balanceDue) > 0) return { cls: 'owing', label: 'Balance Owing' };
  if (c.depositPaid) return { cls: 'deposit', label: 'Deposit Paid' };
  if (c.isBooked) return { cls: 'paid', label: 'Paid' };
  return { cls: 'unknown', label: '—' };
}

// Debounce (T5): the search box filters STATE.clients in-memory (no GAS re-fetch,
// already speed-safe), but rebuilding the row list on every single keystroke for
// ~1,300 rows is unnecessary churn. 300ms feels instant while avoiding jank on
// fast typing.
var _clientsFilterDebounceTimer_ = null;
function debouncedFilterClientsList() {
  if (_clientsFilterDebounceTimer_) clearTimeout(_clientsFilterDebounceTimer_);
  _clientsFilterDebounceTimer_ = setTimeout(filterClientsList, 300);
}

function clientsFiltersActive_() {
  var qEl = document.getElementById('clients-search');
  var stageEl = document.getElementById('clients-stage-filter');
  var payEl = document.getElementById('clients-payment-filter');
  // 2026-08-06: include the category filter, otherwise a Partners-filtered list
  // reports "no filters active" and the empty-state/refresh logic misreads it.
  var catEl = document.getElementById('clients-category-filter');
  return !!((qEl && qEl.value) || (stageEl && stageEl.value) || (payEl && payEl.value) || (catEl && catEl.value));
}

function clearClientsFilters_() {
  var qEl = document.getElementById('clients-search');
  var stageEl = document.getElementById('clients-stage-filter');
  var payEl = document.getElementById('clients-payment-filter');
  var catEl = document.getElementById('clients-category-filter');
  if (qEl) qEl.value = '';
  if (stageEl) stageEl.value = '';
  if (payEl) payEl.value = '';
  // Must clear too, or "clear filters" silently leaves the list stuck on Partners.
  if (catEl) catEl.value = '';
  filterClientsList();
}

// Stale saved-view (2026-08-12, Slice 1). Client-side join against
// admin_stale_deals_cache_json -- the SAME cache the standalone
// /pages/stale-deals page reads, so "stale" means the same thing in both
// places. Bulk follow-up/archive stay on that page (genuinely distinct
// workflow capability, confirmed with Jess); this toggle is only for finding
// stale clients from the list they already live in.
var _staleClientEmails_ = null; // null = not loaded yet; Set-like object once loaded
var _staleFilterActive_ = false;

function ensureStaleClientEmails_(cb) {
  if (_staleClientEmails_) { cb(_staleClientEmails_); return; }
  adminCacheParseIsland_('jv-admin-clients-stale-cache', function (cached) {
    var deals = cached && cached.data && cached.data.deals;
    var set = {};
    if (Array.isArray(deals)) {
      deals.forEach(function (d) { if (d && d.email) set[String(d.email).toLowerCase().trim()] = true; });
    }
    _staleClientEmails_ = set;
    cb(set);
  });
}

window.toggleStaleClientsFilter_ = function () {
  ensureStaleClientEmails_(function (set) {
    _staleFilterActive_ = !_staleFilterActive_;
    var btn = document.getElementById('clients-stale-toggle');
    if (btn) btn.classList.toggle('btn-primary', _staleFilterActive_);
    if (btn) btn.classList.toggle('btn-ghost', !_staleFilterActive_);
    filterClientsList();
  });
};

function primeStaleCount_() {
  // Populate the count pill on the Stale button. Called from onClientsLoaded
  // (the Clients view's own paint hook) rather than at script-parse time, so
  // the #clients-stale-count element is guaranteed to exist in the DOM.
  ensureStaleClientEmails_(function (set) {
    var n = Object.keys(set).length;
    var pill = document.getElementById('clients-stale-count');
    if (pill) { pill.textContent = n; pill.style.display = n > 0 ? '' : 'none'; }
  });
}

function filterClientsList() {
  if (!STATE.clients) return;
  // Category filter (2026-08-06). Optional element: guarded so an older cached
  // section without the control cannot break the whole filter.
  var catEl = document.getElementById('clients-category-filter');
  var cat = catEl ? catEl.value : '';

  // Partners (2026-08-13, BUILD-partners-list-canonical-roster): '__partner' no
  // longer filters the generic bride-shaped client list client-side. That list
  // (adminCrm_getClients) derives row visibility via adminCrm_deriveStage_,
  // bride-lifecycle-shaped machinery the 2026-08-10 partner-identity xray traced
  // as the root cause of partners silently disappearing from the main Pipeline
  // view. Route to the roster builder instead (shopifyBridge_adminListPartners),
  // which counts each partner's brides without going anywhere near the bride
  // pipeline at all -- already proven correct, already live, previously only
  // ever called from the invoicing-partner dropdown. See
  // BRIEFS/RESULTS-partner-managed-weddings-readfirst-2026-08-13.md Part 2.
  if (cat === '__partner') {
    loadPartnersList_();
    return;
  }

  var q = (document.getElementById('clients-search').value || '').toLowerCase().replace(/[''‚‛′‵`]/g, "'");
  var stage = document.getElementById('clients-stage-filter').value;
  var pay = document.getElementById('clients-payment-filter').value;
  var sort = document.getElementById('clients-sort').value;

  var filtered = STATE.clients.filter(function(c) {
    if (q && !(c.name || '').toLowerCase().includes(q) && !(c.email || '').toLowerCase().includes(q)) return false;
    if (cat) {
      // Default to 'Bridal' to match the backend, which does the same when
      // CLIENT_CATEGORY is blank (AdminCRMAPI.gs:5225).
      // '__partner' never reaches here -- filterClientsList() returns early
      // above and routes to loadPartnersList_() instead (2026-08-13).
      var cc = String(c.clientCategory || 'Bridal').trim();
      if (cc !== cat) return false;
    }
    if (stage && c.stage !== stage) return false;
    if (pay) {
      var ps = getPaymentStatus(c);
      if (pay === 'paid' && ps.cls !== 'paid') return false;
      if (pay === 'owing' && ps.cls !== 'owing') return false;
      if (pay === 'deposit' && ps.cls !== 'deposit') return false;
    }
    if (_staleFilterActive_ && _staleClientEmails_) {
      var em = String(c.email || '').toLowerCase().trim();
      if (!em || !_staleClientEmails_[em]) return false;
    }
    return true;
  });

  filtered.sort(function(a, b) {
    if (sort === 'name') return (a.name || '').localeCompare(b.name || '');
    if (sort === 'stage') return PIPELINE_STAGES.indexOf(a.stage) - PIPELINE_STAGES.indexOf(b.stage);
    // default: date
    var da = a.weddingDate ? (parseDate(a.weddingDate) || new Date(9999,0,1)) : new Date(9999,0,1);
    var db = b.weddingDate ? (parseDate(b.weddingDate) || new Date(9999,0,1)) : new Date(9999,0,1);
    return da - db;
  });

  // FIX 2026-09-22 (BRIEFS/RESULTS-admin-crm-invoice-new-e2e-audit-2026-09-22.md):
  // same root cause and same fallback as invoiceClientSearch() above --
  // STATE.clients only ever holds the active-pipeline set (Completed/
  // Archived/Closed/Lost stages are permanently excluded server-side by
  // design once a wedding date passes), so a genuine text search for a
  // past-wedding bride's name/email always came up empty here with no way
  // to actually find her. Only fires the server fallback on a TEXT search
  // with no other filter narrowing the result (cat/stage/pay/stale) --
  // those other filters are meaningless against the "everyone, regardless
  // of stage" fallback set, so this stays scoped to the one case it's
  // actually built for: "I typed a real name/email and got nothing."
  if (q && !filtered.length && !cat && !stage && !pay && !_staleFilterActive_) {
    var listQ = q;
    // CLICK-RACE FIX (2026-10-27, HANDOFF-partners-list-wrong-bride-fix-2026-10-27.md,
    // Bug 2 of the same Cowork E2E report): this live fallback call measures
    // 3-10s. Previously nothing was painted synchronously here, so the
    // PREVIOUS render (whatever rows were on screen before this keystroke --
    // another client, a different filter's results) stayed fully visible
    // AND fully clickable for that whole window, each row still carrying
    // its OLD onclick(email/id/brideUid). A click landing in that window
    // opened whichever stale row happened to be there, not whatever the
    // admin was now searching for -- the same "label looked right a moment
    // ago, destination is wrong" symptom as the partner-row bug above, just
    // triggered by typing instead of a category switch. Fix: synchronously
    // replace the list with a non-clickable loading placeholder the instant
    // the live call is fired, so there is nothing stale left to click
    // during the wait. The .then()/.catch() below are unchanged.
    var listElLoading_ = document.getElementById('clients-list');
    if (listElLoading_) {
      _clientsRendered = [];
      _clientsShown = 0;
      listElLoading_.innerHTML = '<div class="empty-state"><div class="empty-icon">…</div>' +
        '<p>Searching for &ldquo;' + escHtml(listQ) + '&rdquo;…</p></div>';
    }
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients', args: { q: listQ, includeCompleted: true } })
      .then(function(r) {
        var currentQ = (document.getElementById('clients-search').value || '').toLowerCase().replace(/[''‚‛′‵`]/g, "'");
        if (currentQ !== listQ) return; // admin kept typing, don't paint a stale result
        var fallback = (r && r.ok && Array.isArray(r.data)) ? r.data : [];
        if (!fallback.length) { renderClientsList([]); return; }
        renderClientsList(fallback);
      })
      .catch(function() { /* stay on the empty active-set result, same as before this fix */ });
    return;
  }

  renderClientsList(filtered);
}

/* ------------------------------------------------------------------
   Partners list (2026-08-13, BUILD-partners-list-canonical-roster)
   Read-only. Fetches from the roster builder (shopifyBridge_adminListPartners),
   which counts each partner's brides without touching the bride pipeline, and
   renders partner-shaped columns (business name, role, roster count, source)
   instead of bride-list columns (wedding date, services, stage, payment) that
   are meaningless for a partner row. Does NOT touch any bride-creation path,
   read-only list swap only, per the brief's explicit scope.
   ------------------------------------------------------------------ */
var _partnersCache_ = null;   // last-loaded partner list, for search-without-refetch

function loadPartnersList_() {
  var listEl = document.getElementById('clients-list');
  var loaderEl = document.getElementById('clients-loader');
  var errorEl = document.getElementById('clients-error');
  var existingPager = document.getElementById('clients-more-wrap');
  if (existingPager) existingPager.parentNode.removeChild(existingPager);

  if (Array.isArray(_partnersCache_)) {
    // Already fetched this session, just re-filter/re-render on search input,
    // no need to re-hit GAS for every keystroke.
    renderPartnersList_(filterPartnersCache_(_partnersCache_));
    return;
  }

  // 2026-08-18 (BRIEF-partner-list-lookup-timeout-5-surfaces-2026-08-18.md,
  // surface #4): the in-memory _partnersCache_ guard above only helps repeat
  // views WITHIN a session -- the first-ever view of this tab each session
  // still paid the full uncached cold-start. Paint from the CDN island first
  // so even the first view is instant; the live call below still runs to
  // populate _partnersCache_ for the in-memory guard AND to self-heal a
  // stale/missing island, same pattern as every other surface in this fix.
  // 2026-08-20: island read is now async (gzip-safe) -- see
  // jvAdminPartnerList_getCached_'s own note.
  jvAdminPartnerList_getCached_(function(partnersIslandData) {
    if (partnersIslandData) {
      _partnersCache_ = partnersIslandData;
      if (listEl) listEl.style.display = '';
      if (loaderEl) loaderEl.style.display = 'none';
      renderPartnersList_(filterPartnersCache_(_partnersCache_));
    } else {
      if (loaderEl) loaderEl.style.display = '';
      if (errorEl) errorEl.textContent = '';
      if (listEl) listEl.style.display = 'none';
    }

    jvBridge.callAdmin('bridge_admin_listPartners', {})
      .then(function (res) {
        if (loaderEl) loaderEl.style.display = 'none';
        if (listEl) listEl.style.display = '';
        if (!res || res.success === false) {
          if (!partnersIslandData && errorEl) errorEl.textContent = 'Could not load partners: ' + ((res && res.error) || 'unknown error');
          return;
        }
        _partnersCache_ = Array.isArray(res.partners) ? res.partners : [];
        renderPartnersList_(filterPartnersCache_(_partnersCache_));
      })
      .catch(function (err) {
        if (loaderEl) loaderEl.style.display = 'none';
        if (listEl) listEl.style.display = '';
        if (!partnersIslandData && errorEl) errorEl.textContent = 'Could not load partners: ' + (err.message || String(err));
      });
  });
}

// Re-applies the existing search box against the cached partner list, so typing
// in the same search input the bride list uses also works for partners without
// a second fetch. Sort control does not apply here (no wedding date / stage on
// a partner row); left at whatever the bride view had selected, unused.
function filterPartnersCache_(partners) {
  var q = (document.getElementById('clients-search').value || '').toLowerCase().replace(/[''‚‛′‵`]/g, "'");
  if (!q) return partners;
  return partners.filter(function (p) {
    var name = (p.businessName || p.firstName + ' ' + p.lastName || '').toLowerCase();
    var email = (p.email || '').toLowerCase();
    return name.indexOf(q) !== -1 || email.indexOf(q) !== -1;
  });
}

// Needs-attention pills (2026-08-13, BUILD-admin-crm-partner-needs-attention-signals).
// Data comes straight off the bridge_admin_listPartners response (extended server-side
// in the SAME single sheet scan the roster count already used, PartnerManagedAdminAPI.gs)
// -- zero new live calls per row, per the brief's own explicit requirement. Only renders
// a pill when its signal is genuinely non-zero; a partner with nothing outstanding shows
// NO pills at all, per the pack's own "don't render decorative zeros" guidance.
function buildPartnerAttentionPillsHtml_(p) {
  var pills = [];
  if (p.hasUnpaidWedding) {
    pills.push('<span class="stage-badge partner-attn-danger" title="Unpaid on a booked wedding due within 30 days, or already past">' +
      (Number(p.unpaidCount) || 1) + ' unpaid</span>');
  }
  if (p.hasUpcomingWedding) {
    pills.push('<span class="stage-badge partner-attn-info" title="Booked wedding within the next 30 days">' +
      (Number(p.upcomingCount) || 1) + ' upcoming</span>');
  }
  if (p.hasRunsheetPending) {
    pills.push('<span class="stage-badge partner-attn-warn" title="Booked wedding with no runsheet ready yet">' +
      (Number(p.runsheetPendingCount) || 1) + ' runsheet pending</span>');
  }
  // Rate-card status (2026-09-17, Jess's Partners-console go-ahead, item 3).
  // Only rendered when MISSING -- per this function's own established
  // "don't render decorative zeros" convention, an admin needs to know
  // when something's absent, not see a badge celebrating its presence.
  if (!p.hasRateCard) {
    pills.push('<span class="stage-badge partner-attn-warn" title="No rate card stored for this partner">no rate card</span>');
  }
  // Welcome/setup-state proxy (2026-09-17, same go-ahead) -- fraction of
  // this partner's managed brides with ONBOARDING_COMPLETE=Yes. Only
  // rendered when genuinely incomplete (roster > 0 and not fully
  // onboarded), same "don't render decorative zeros" rule -- a fully
  // onboarded roster shows nothing extra here.
  var rosterCount = Number(p.rosterCount) || 0;
  var onboardedCount = Number(p.onboardedCount) || 0;
  if (rosterCount > 0 && onboardedCount < rosterCount) {
    pills.push('<span class="stage-badge setting-up" title="Managed brides with onboarding not yet complete">' +
      onboardedCount + '/' + rosterCount + ' onboarded</span>');
  }
  return pills.join(' ');
}

function buildPartnerRowHtml_(p) {
  var name = (p.businessName || '').trim() || ((p.firstName || '') + ' ' + (p.lastName || '')).trim() || p.email || 'Unnamed partner';
  var initials = getInitials(name);
  var roleLabel = (p.role || '').trim();
  var srcLabel = (p.externalSrc || '').trim();
  var count = Number(p.rosterCount) || 0;
  var html = '';
  // DATA-EXPOSURE FIX (2026-10-27, HANDOFF-partners-list-wrong-bride-fix-2026-10-27.md):
  // this row used to call openClientProfile_(p.email, '') -- the SAME click
  // handler the bride-shaped "All Clients" rows use (buildClientRowHtml_
  // above, ~line 3666, onclick="openClientProfile_(c.email, c.id, c.brideUid)").
  // openClientProfile_ ALWAYS treats its first argument as a BRIDE identity
  // and navigates straight to /pages/admin-bride-profile?bride=<email> --
  // there is no "partner" branch in that function at all. A partner's own
  // account email is not a bride's email, so this sent the admin to a
  // bride-profile page resolved by the backend against an identity the
  // click never meant to look up, landing on whichever record that email
  // happened to match -- confirmed live (Cowork E2E, 2026-10-27) as an
  // UNRELATED real bride's profile, not an error state. There is no
  // dedicated partner detail/management page today (grepped
  // sections/templates/assets -- only the PARTNER'S OWN portal at
  // /pages/partner-portal exists, which admins cannot open for another
  // partner's identity). Per doctrine ("fail safely rather than show the
  // wrong person's private data"), route this click to openPartnerDetail_
  // below, which NEVER navigates off this page and only ever reflects this
  // exact partner's own already-fetched, already-rendered fields back to
  // the admin. A real partner detail/roster-drill-down view is a separate,
  // larger piece of work (bridge_admin_getPartnerRoster returns a
  // differently-shaped bride row than buildClientRowHtml_ expects --
  // brideEmail/brideName/row vs email/name/id/brideUid -- needs an adapter,
  // not a one-liner) and is flagged in the handoff rather than attempted here.
  html += '<div class="client-row" onclick="openPartnerDetail_(\'' + escAttr(p.email || '') + '\')">';
  html += '<div class="avatar-circle" style="width:30px;height:30px;font-size:0.62rem;">' + escHtml(initials) + '</div>';
  html += '<div class="cell-name"><strong>' + stripTagsAndEscape_(name) + '</strong><span>' + stripTagsAndEscape_(p.email || '') + '</span></div>';
  html += '<div class="cell-date">' + (roleLabel ? escHtml(roleLabel) : '') + '</div>';
  html += '<div class="cell-services" title="' + escAttr(srcLabel) + '">' + (srcLabel ? escHtml(srcLabel) : '') + '</div>';
  html += '<div class="cell-stage"><span class="stage-badge">' + count + ' bride' + (count === 1 ? '' : 's') + '</span></div>';
  html += '<div class="cell-payment">' + buildPartnerAttentionPillsHtml_(p) + '</div>';
  html += '<button class="row-menu-btn" onclick="event.stopPropagation();" title="" style="visibility:hidden;">';
  html += '<svg viewBox="0 0 24 24"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg></button>';
  html += '</div>';
  return html;
}

// Partner Detail drawer (2026-10-27, Partner Detail View build -- follow-up to
// HANDOFF-partners-list-wrong-bride-fix-2026-10-27.md, which replaced the old
// wrong-bride-navigation click handler with a safe "not built yet" toast
// placeholder pending this build). _partnersCache_ is the same array
// buildPartnerRowHtml_ was called from (set by loadPartnersList_ above), so
// the identity header paints from already-fetched data with zero extra call.
//
// Roster painting is CDN-fast-path-first, same pattern as
// invoicePartnerChange_ above: invoicePartnerRosterFromCdn_() reads the
// partner_profile_cache Shopify metaobject directly via Storefront GraphQL
// (near-instant), then a background call to the admin-partner-detail relay
// entity (jv-crm-mirror POST /partner-roster, D1) verifies/repairs. A
// background miss/failure never clobbers an already-correct CDN paint -- it
// just leaves the CDN roster on screen, same degrade-to-existing shape every
// other fast-path-plus-verify surface in this file uses. Never calls GAS
// (bridge_admin_getPartnerRoster) from this drawer: that route stays reserved
// for the Invoice screen's partner picker, which needs the rate-card field
// this drawer does not show.
var _partnerDetailOpenEmail_ = '';

window.openPartnerDetail_ = function (email) {
  var e = String(email || '').trim();
  if (!e) return;
  _partnerDetailOpenEmail_ = e;
  var p = null;
  if (Array.isArray(_partnersCache_)) {
    for (var i = 0; i < _partnersCache_.length; i++) {
      var row = _partnersCache_[i];
      if (row && String(row.email || '').toLowerCase() === e.toLowerCase()) { p = row; break; }
    }
  }
  var label = (p && ((p.businessName || '').trim() ||
    ((p.firstName || '') + ' ' + (p.lastName || '')).trim() || p.email)) || e;
  var roleLabel = (p && (p.role || '').trim()) || '';
  var srcLabel = (p && (p.externalSrc || '').trim()) || '';

  var nameEl = document.getElementById('pdd-name');
  var metaEl = document.getElementById('pdd-meta');
  var roleEl = document.getElementById('pdd-role');
  var srcEl = document.getElementById('pdd-source');
  var phoneEl = document.getElementById('pdd-phone');
  var invDelEl = document.getElementById('pdd-invoice-delivery');
  var rsDelEl = document.getElementById('pdd-runsheet-delivery');
  var rosterEl = document.getElementById('pdd-roster');
  var cdnNoteEl = document.getElementById('pdd-cdn-note');
  if (nameEl) nameEl.textContent = stripTagsAndEscape_ ? label.replace(/<[^>]*>/g, '') : label;
  if (metaEl) metaEl.textContent = e;
  if (roleEl) roleEl.textContent = roleLabel || '-';
  if (srcEl) srcEl.textContent = srcLabel || '-';
  if (phoneEl) phoneEl.textContent = '-';
  if (invDelEl) invDelEl.textContent = '-';
  if (rsDelEl) rsDelEl.textContent = '-';
  if (rosterEl) rosterEl.innerHTML = '<div class="empty-state" style="padding:1.2rem 0.5rem;"><p class="lead-paragraph" style="margin-bottom:0;">Loading...</p></div>';
  if (cdnNoteEl) cdnNoteEl.style.display = 'none';

  var overlay = document.getElementById('partner-detail-drawer-overlay');
  var drawer = document.getElementById('partner-detail-drawer');
  if (overlay) overlay.classList.add('show');
  if (drawer) drawer.classList.add('open');

  // Fast path: CDN metaobject read (shared helper, also used by the Invoice
  // screen's partner picker above).
  invoicePartnerRosterFromCdn_(e).then(function (cdnBrides) {
    if (_partnerDetailOpenEmail_ !== e) return; // admin closed/switched while this was in flight
    if (cdnBrides) {
      renderPartnerDetailRoster_(cdnBrides);
      if (cdnNoteEl) cdnNoteEl.style.display = '';
    }
    // Background verify/repair via D1, regardless of whether the CDN hit.
    partnerDetailFetchFromRelay_(e).then(function (res) {
      if (_partnerDetailOpenEmail_ !== e) return;
      if (!res || res.ok !== true) return; // CDN paint (if any) stands; no regression vs today
      if (res.partner) {
        if (phoneEl) phoneEl.textContent = res.partner.phone || '-';
        if (invDelEl) invDelEl.textContent = res.partner.invoiceDelivery || '-';
        if (rsDelEl) rsDelEl.textContent = res.partner.runsheetDelivery || '-';
      }
      if (Array.isArray(res.brides)) {
        renderPartnerDetailRoster_(res.brides);
        if (cdnNoteEl) cdnNoteEl.style.display = 'none';
      }
    });
  });
};

window.closePartnerDetailDrawer_ = function () {
  _partnerDetailOpenEmail_ = '';
  var overlay = document.getElementById('partner-detail-drawer-overlay');
  var drawer = document.getElementById('partner-detail-drawer');
  if (overlay) overlay.classList.remove('show');
  if (drawer) drawer.classList.remove('open');
};

// Narrow custom row layout (.pdd-bride-row, defined in jv-admin-crm.css next to
// #partner-detail-drawer), NOT .client-row -- .client-row is a 7-column CSS
// grid tuned for the full-width "All Clients" table and would misalign badly
// at this drawer's 420px width with only 4 of its 7 expected children.
function renderPartnerDetailRoster_(brides) {
  var rosterEl = document.getElementById('pdd-roster');
  if (!rosterEl) return;
  if (!Array.isArray(brides) || !brides.length) {
    rosterEl.innerHTML = '<div class="empty-state" style="padding:1.2rem 0.5rem;"><p class="lead-paragraph" style="margin-bottom:0;">No brides in this partner\'s roster yet.</p></div>';
    return;
  }
  var html = '';
  brides.forEach(function (b) {
    var brideEmail = String((b && b.brideEmail) || '').trim();
    var brideName = (b && b.brideName) || brideEmail || 'Unnamed bride';
    var dateLabel = (b && b.weddingDate) ? formatDate(b.weddingDate) : 'No date yet';
    var stageLabel = (b && (b.stage || b.runsheetStage)) || '';
    var payLabel = (b && b.paymentStatus) || '';
    html += '<div class="pdd-bride-row" style="cursor:' + (brideEmail ? 'pointer' : 'default') + ';" ' +
      (brideEmail ? 'onclick="openClientProfile_(\'' + escAttr(brideEmail) + '\',\'\',\'\')"' : '') + '>' +
      '<div class="pdd-bride-row-name"><strong>' + stripTagsAndEscape_(brideName) + '</strong><span>' + stripTagsAndEscape_(brideEmail) + '</span></div>' +
      '<div class="pdd-bride-row-meta">' + escHtml(dateLabel) +
      (stageLabel ? ' &middot; <span class="stage-badge">' + escHtml(stageLabel) + '</span>' : '') +
      (payLabel ? ' &middot; ' + escHtml(payLabel) : '') +
      '</div></div>';
  });
  rosterEl.innerHTML = html;
}

// Background-verify read via the admin-partner-detail relay entity (jv-crm-mirror
// POST /partner-roster, D1). Resolves to null on any miss/timeout/error --
// caller always treats null as "leave the CDN paint as-is", never as a reason
// to show an error state, since the CDN paint (if it hit) is already correct
// data, just possibly a few minutes stale.
function partnerDetailFetchFromRelay_(email) {
  var base = window._jvAdminProxyBase;
  if (!base || !email) return Promise.resolve(null);
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-partner-detail/read';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return new Promise(function (resolve) {
    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; resolve(null); } }, 8000);
    nf(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      credentials: 'same-origin',
      body: JSON.stringify({ partnerEmail: email })
    })
      .then(function (r) { return r.json(); })
      .then(function (body) {
        if (done) return;
        done = true; clearTimeout(timer);
        resolve(body || null);
      })
      .catch(function () { if (!done) { done = true; clearTimeout(timer); resolve(null); } });
  });
}

/* ============================================================
   PARTNER ROUTING SUMMARY (2026-08-13, BUILD-admin-crm-partner-routing-summary)
   ============================================================
   Canonical answer to "for THIS bride, who gets the invoice, who gets the
   runsheet, who gets bride-facing comms, and on what terms" -- ONE resolved
   object, computed once, so every money/comms surface reads the same
   decision instead of re-deriving it independently (the exact drift risk
   openBillPartnerModal above already shows: it assumes partner-billing
   whenever a partner link exists, never checking the partner's own actual
   invoiceDeliveryEffective setting).

   FRONTEND-DERIVED, not a new backend function, decided explicitly per the
   brief's own instruction to check this first: adminCrm_getClient (fetched
   for every bride the drawer/profile page opens) already carries
   isPartnerManaged / partnerAccountEmail / partnerAccountName -- enough to
   resolve the non-partner-managed case (the overwhelming majority of
   brides) with ZERO extra calls, synchronously. Only a genuinely
   partner-managed bride needs one more call, and that's the EXISTING
   bridge_admin_getPartnerSettings route (already live, already used by the
   partner settings panel) -- not a new GAS function. */

/**
 * Resolves the canonical routing summary for a bride/client object (the
 * same shape adminCrm_getClient / adminCrm_getClients rows already return).
 * Always resolves (never rejects). Synchronous fast path for the common
 * non-partner-managed case; only fires the partner-settings call when the
 * bride is genuinely partner-managed.
 *
 * @param {object} c - a client object with at minimum: email, name,
 *   isPartnerManaged, partnerAccountEmail, partnerAccountName.
 * @returns {Promise<object>} the resolved routing summary, shape:
 *   {
 *     recordKind: 'bride' | 'partner-managed-bride',
 *     partnerEmail, partnerName,
 *     invoiceRecipient:       { type: 'bride'|'partner', email },
 *     runsheetRecipient:      { type: 'bride'|'partner', email },
 *     communicationRecipient: { type: 'bride', email },  // bride-facing comms
 *                                                          // ALWAYS go to the
 *                                                          // bride herself --
 *                                                          // confirmed: no
 *                                                          // field anywhere
 *                                                          // in this codebase
 *                                                          // routes bride
 *                                                          // comms to a
 *                                                          // partner, only
 *                                                          // invoicing/
 *                                                          // runsheet
 *                                                          // delivery are
 *                                                          // partner-
 *                                                          // routable
 *     paymentTerms: string|null,      // e.g. 'net_14', null if not set
 *     rateCardSource: 'partner_rate_card'|'direct', // has the partner set a rate card?
 *     resolvedAt: ISO string
 *   }
 */
function resolvePartnerRoutingSummary_(c) {
  var brideEmail = (c && c.email) || '';
  var brideRecipient = { type: 'bride', email: brideEmail };
  var baseNonPartner = {
    recordKind: 'bride',
    partnerEmail: null,
    partnerName: null,
    invoiceRecipient: brideRecipient,
    runsheetRecipient: brideRecipient,
    communicationRecipient: brideRecipient,
    paymentTerms: null,
    rateCardSource: 'direct',
    resolvedAt: new Date().toISOString()
  };

  if (!c || !c.isPartnerManaged || !c.partnerAccountEmail) {
    return Promise.resolve(baseNonPartner);
  }

  var partnerEmail = c.partnerAccountEmail;
  var partnerName = c.partnerAccountName || partnerEmail;

  return jvBridge.callAdmin('bridge_admin_getPartnerSettings', { partnerEmail: partnerEmail })
    .then(function (res) {
      // Fail toward the SAFER default, not a silent partner-billing assumption:
      // if settings can't be read, route to the partner anyway (matches the
      // existing invoiceDeliveryEffective default of 'partner' when unset --
      // this resolver must never disagree with that already-live default), but
      // mark it explicitly so a consumer can show "settings unavailable" rather
      // than presenting a resolved decision with unwarranted confidence.
      // FIX (2026-10-28, item 8 Issue B): bridge_admin_getPartnerSettings
      // (shopifyBridge_adminGetPartnerSettings, PARTNER.gs) returns
      // {success, partner, settings, available} -- it never sets an `ok`
      // field. The sibling caller of this same route (partnerSettings_afterRender_,
      // below in this file) already correctly checks res.success. This call
      // site checked res.ok instead, which is always undefined, so this branch
      // fired for EVERY partner every time, not just the one test partner a
      // prior session's finding attributed it to.
      if (!res || res.success !== true) {
        return {
          recordKind: 'partner-managed-bride',
          partnerEmail: partnerEmail,
          partnerName: partnerName,
          invoiceRecipient: { type: 'partner', email: partnerEmail },
          runsheetRecipient: { type: 'partner', email: partnerEmail },
          communicationRecipient: brideRecipient,
          paymentTerms: null,
          rateCardSource: 'partner_rate_card',
          resolvedAt: new Date().toISOString(),
          settingsUnavailable: true
        };
      }
      var s = res.settings || {};
      var invType = (s.invoiceDeliveryEffective === 'bride') ? 'bride' : 'partner';
      var rsType  = (s.runsheetGateEffective === 'bride') ? 'bride' : 'partner';
      return {
        recordKind: 'partner-managed-bride',
        partnerEmail: partnerEmail,
        partnerName: partnerName,
        invoiceRecipient: {
          type: invType,
          email: invType === 'partner' ? partnerEmail : brideEmail
        },
        runsheetRecipient: {
          type: rsType,
          email: rsType === 'partner' ? partnerEmail : brideEmail
        },
        communicationRecipient: brideRecipient,
        paymentTerms: s.invoiceTermsRaw || null,
        rateCardSource: s.hasRateCard ? 'partner_rate_card' : 'direct',
        resolvedAt: new Date().toISOString()
      };
    })
    .catch(function () {
      // Same fail-toward-partner default as the res.ok!==true branch above,
      // for a genuine network/transport failure rather than a resolved error.
      return {
        recordKind: 'partner-managed-bride',
        partnerEmail: partnerEmail,
        partnerName: partnerName,
        invoiceRecipient: { type: 'partner', email: partnerEmail },
        runsheetRecipient: { type: 'partner', email: partnerEmail },
        communicationRecipient: brideRecipient,
        paymentTerms: null,
        rateCardSource: 'partner_rate_card',
        resolvedAt: new Date().toISOString(),
        settingsUnavailable: true
      };
    });
}

function renderPartnersList_(partners) {
  var listEl = document.getElementById('clients-list');
  if (!listEl) return;
  _clientsRendered = [];   // partners list does not share bride pagination state
  _clientsShown = 0;

  if (!partners || partners.length === 0) {
    listEl.innerHTML = '<div class="empty-state"><div class="empty-icon">◎</div><p>No partners found.</p></div>';
    return;
  }
  // Sort by roster count descending, then name, busiest partners first, the
  // ones Jess is most likely to be looking for.
  var sorted = partners.slice().sort(function (a, b) {
    var ca = Number(a.rosterCount) || 0, cb = Number(b.rosterCount) || 0;
    if (cb !== ca) return cb - ca;
    var na = (a.businessName || a.email || '').toLowerCase();
    var nb = (b.businessName || b.email || '').toLowerCase();
    return na.localeCompare(nb);
  });
  var html = '';
  sorted.forEach(function (p) { html += buildPartnerRowHtml_(p); });
  listEl.innerHTML = html;
}

/* ------------------------------------------------------------------
   Inline per-row actions (P4b Part 1 item 2)
   Act on a client straight from the list without opening the drawer.
   Bride-facing actions (book / message / create proposal) are gated to
   bridal-eligible categories, mirroring the drawer Book-button gate in
   _paintDrawerHeader_ + comms gate section 4 (feedback_ebm_never_touch)
   so a Vendor / Planner / Academy row is never offered them. Log note is
   internal and always available. The Message action routes through the
   drawer's gated send path (bridge_admin_sendMessage to JV_sendOrDefer_*).
   ------------------------------------------------------------------ */
function showClientMenu(event, clientId, clientEmail) {
  if (event && event.stopPropagation) event.stopPropagation();
  // Toggle: if a menu is already open, close it (and stop if it was this row's).
  var already = document.querySelectorAll('.kc-context-menu');
  already.forEach(function(m){ m.remove(); });
  if (already.length) return;

  var btn = (event && event.currentTarget) ? event.currentTarget
          : (event && event.target ? event.target.closest('.row-menu-btn') : null);
  var row = btn ? btn.closest('.client-row') : null;
  if (!row) { openDrawer(clientId); return; }

  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  var bridal = !c || !c.category || ['Bridal', 'Non-Bridal'].indexOf(c.category) !== -1;
  var idAttr = escAttr(String(clientId));
  // 2026-11-02 fix (see BRIEFS/DIAGNOSTIC-admin-crm-view-details-stale-cache-id-collision-2026-11-02.md):
  // View details must resolve identity the same stable way the plain row click
  // already does (openClientProfile_, 2026-08-25 fix), not via findClientById(clientId)
  // against STATE.clients, which can be stale after a fallback/includeCompleted search
  // and open the wrong client's profile. Other menu items below still use
  // findClientById(clientId) to decide which items to show -- that usage is untouched.
  var emailAttr = escAttr(String(clientEmail || ''));
  var ICON = {
    view: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>',
    book: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    msg:  '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    note: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
    prop: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>'
  };
  var menu = document.createElement('div');
  menu.className = 'kc-context-menu';
  var html = '';
  html += '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); openClientProfile_(\'' + emailAttr + '\', \'' + idAttr + '\')">' + ICON.view + 'View details</div>';
  if (bridal) {
    html += '<div class="ctx-divider"></div>';
    html += '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); clientRowBook(\'' + idAttr + '\')">' + ICON.book + 'Book</div>';
    html += '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); clientRowMessage(\'' + idAttr + '\')">' + ICON.msg + 'Message</div>';
    html += '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); clientRowCreateProposal(\'' + idAttr + '\')">' + ICON.prop + 'Create proposal</div>';
  }
  html += '<div class="ctx-divider"></div>';
  html += '<div class="ctx-item" onclick="event.stopPropagation(); closeContextMenus(); clientRowLogNote(\'' + idAttr + '\')">' + ICON.note + 'Log note</div>';
  menu.innerHTML = html;
  // 2026-07-30 fix: append to BODY with position:fixed (same pattern toggleCardMenu
  // already uses for the kanban card menu) instead of row.appendChild + the default
  // position:absolute. Appended inside the .client-row, the menu was clipped by /
  // stacked under the NEXT row below it (its z-index:900 lost to the following row's
  // own stacking context). Body-anchored + fixed escapes every ancestor's clip.
  var r = btn.getBoundingClientRect();
  menu.style.position = 'fixed';
  menu.style.top = r.bottom + 'px';
  menu.style.right = (window.innerWidth - r.right) + 'px';
  menu.style.left = 'auto';
  menu.style.zIndex = '1200';
  document.body.appendChild(menu);
  // Flip above the button if it would overflow the viewport bottom.
  var mh = menu.getBoundingClientRect().height;
  if (r.bottom + mh > window.innerHeight) {
    menu.style.top = 'auto';
    menu.style.bottom = (window.innerHeight - r.top) + 'px';
  }

  // Close on the next outside click (deferred a tick so this very click,
  // which is still bubbling, does not instantly close the menu).
  setTimeout(function() {
    function onDoc(e) {
      if (!menu.contains(e.target) && e.target !== btn) {
        menu.remove();
        document.removeEventListener('click', onDoc);
      }
    }
    document.addEventListener('click', onDoc);
  }, 0);
}

function clientRowBook(clientId) {
  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  if (!c) { openDrawer(clientId); return; }
  ibOpenForClient({
    rowIndex: clientId,
    fullName: c.name || '',
    email: c.email || '',
    weddingDateLabel: (c.weddingDate && typeof formatDate === 'function') ? formatDate(c.weddingDate) : ''
  });
}

function clientRowCreateProposal(clientId) {
  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  if (!c || !c.email) { jvToast('No email on file for this client.', 'error'); openDrawer(clientId); return; }
  openProposalModal(c.email);
}

// Message: jump to the bride's comms thread. The actual send is the drawer
// composer (bridge_admin_sendMessage to JV_sendOrDefer_* / quiet-hours-gated),
// so there is no new ungated send path here. The composer (#comms-send-panel)
// is injected by the timeline render AFTER the bundle resolves (the 8s wall),
// so poll briefly then open it once; if it never appears the user is already
// on the thread.
function clientRowMessage(clientId) {
  openDrawer(clientId);
  setTimeout(function() {
    var tab = document.querySelector('.drawer-tab[data-pane="timeline"]');
    if (tab) switchDrawerTab('timeline', tab);
    var tries = 0;
    var poll = setInterval(function() {
      tries++;
      if (String(STATE.drawerClientId) !== String(clientId)) { clearInterval(poll); return; }
      var panel = document.getElementById('comms-send-panel');
      if (panel) {
        clearInterval(poll);
        if (!panel.classList.contains('open')) { try { sendCommsMessage(); } catch (_) {} }
      } else if (tries > 30) {
        clearInterval(poll); // ~12s ceiling; give up silently.
      }
    }, 400);
  }, 140);
}

function clientRowLogNote(clientId) {
  openNotePrompt_(clientId);
}

// jv-ui note modal (not a native prompt) for the inline Log-note action.
// Verify-after-write: only toast success once bridge_admin_logNote returns ok.
function openNotePrompt_(clientId) {
  if (document.getElementById('jv-note-overlay')) return;
  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  var name = (c && c.name) || 'this client';
  var overlay = document.createElement('div');
  overlay.className = 'jv-note-overlay';
  overlay.id = 'jv-note-overlay';
  overlay.innerHTML =
    '<div class="jv-note-modal" role="dialog" aria-label="Log a note">' +
      '<div class="jv-note-head"><h3>Log a note</h3>' +
        '<button class="jv-note-close" id="jvNoteClose" aria-label="Close">&times;</button></div>' +
      '<p class="jv-note-sub">' + escHtml(name) + '</p>' +
      '<textarea id="jvNoteText" class="jv-note-text" rows="4" placeholder="Add an internal note..."></textarea>' +
      '<div class="jv-note-err" id="jvNoteErr"></div>' +
      '<div class="jv-note-foot">' +
        '<button type="button" class="btn btn-ghost" id="jvNoteCancel">Cancel</button>' +
        '<button type="button" class="btn btn-primary" id="jvNoteSave">Save note</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  overlay.addEventListener('click', function(e){ if (e.target === overlay) close_(); });
  document.getElementById('jvNoteClose').onclick = close_;
  document.getElementById('jvNoteCancel').onclick = close_;
  var ta = document.getElementById('jvNoteText');
  setTimeout(function(){ try { ta.focus(); } catch (_) {} }, 40);
  document.getElementById('jvNoteSave').onclick = function() {
    var note = (ta.value || '').trim();
    var errEl = document.getElementById('jvNoteErr');
    if (!note) { errEl.textContent = 'Note cannot be empty.'; errEl.style.display = 'block'; return; }
    var saveBtn = document.getElementById('jvNoteSave');
    saveBtn.disabled = true; saveBtn.textContent = 'Saving...';

    function onNoteDone(ok, res, errMsg) {
      if (ok) {
        close_();
        jvToast('Note saved.', 'success');
        if (String(STATE.drawerClientId) === String(clientId) && STATE.drawerTab === 'timeline') {
          loadDrawerTimeline(clientId);
        }
      } else {
        var msg = errMsg || (res && res.error && res.error.message) || (res && res.error) || (res && res.message) || 'Could not save note.';
        errEl.textContent = String(msg); errEl.style.display = 'block';
        saveBtn.disabled = false; saveBtn.textContent = 'Save note';
      }
    }

    function fallbackToGasNoteCrm() {
      jvBridge.callAdmin('bridge_admin_logNote', { clientId: clientId, note: note })
        .then(function(res) { onNoteDone(!!(res && res.ok), res, null); })
        .catch(function(err) { onNoteDone(false, null, 'Error: ' + (err.message || String(err))); });
    }

    // D1-first, insert mode (2026-08-29, per BRIEFS/HANDOFF-insert-mode-frontend-
    // wiring-to-admin-crm-2026-08-29.md). admin-note is an APPEND to the COMMS
    // log, not an update to a bride column. Fresh idempotency key on every
    // save attempt, never reused on retry -- insert mode relies on it alone
    // to prevent a duplicate note.
    var brideUid = (c && c.brideUid) || '';
    if (!brideUid) {
      fallbackToGasNoteCrm();
      return;
    }
    var idempotencyKey = brideUid + '|note|' + Date.now() + '|' + Math.random().toString(36).slice(2);
    jvBridge.call('bridge_admin_logNoteD1', {
      bride_uid: brideUid, bride_email: (c && c.email) || '',
      idempotency_key: idempotencyKey, record: { note: note }
    }).then(function(res) {
      if (res && res.ok && res.writtenTo === 'd1') {
        onNoteDone(true, res, null);
      } else {
        fallbackToGasNoteCrm();
      }
    }).catch(function() {
      fallbackToGasNoteCrm();
    });
  };
}

/* ============================================================
   DETAIL DRAWER
   ============================================================
   Bundle pre-warm (2026-05-27): every per-bride drawer payload
   (overview/timeline/proposals/invoices/runsheet/forms/portal/
   onboarding) is fetched in a single GAS call kicked off the
   moment the drawer opens. Each tab then renders from the cached
   blob — no per-tab cold start. Falls back to legacy per-tab
   fetches if the bundle errors.
   ============================================================ */
var _drawerBundleCache = {};

// Path A: seed the cache from the inline JSON blob baked into the page by
// Liquid from the Shopify `drawer_bundle` metaobject pool. Drawer-open + any
// tab render then runs zero-GAS-call until the cache misses or expires.
// ── Pipeline inline CDN cache (2026-06-01) ──────────────────────────────────
// Reads the pre-baked payload from the <script id="jv-admin-pipeline-payload">
// tag written by Liquid from custom.admin_crm_pipeline_cache metafield.
// Makes the kanban render instantly without any GAS call on page load.
// gzip-aware (2026-07-17): large payloads are stored gzip+base64'd as a JSON string
// literal "JVGZ_...." by adminCache_encodeForStore_ (GAS). Small payloads are a plain
// JSON object as before. Plain payloads still resolve SYNCHRONOUSLY (zero behaviour
// change for today's payload). A gzip payload inflates async via DecompressionStream
// and populates _PIPELINE_INLINE_ when ready; a flag + optional re-paint hook lets the
// boot flow use it once inflated. This is what lets the kanban payload keep compressing
// as the bride list grows instead of silently overflowing the size cap.
var _PIPELINE_INLINE_ = null;
var _PIPELINE_INLINE_READY_ = false;      // true once the island has been resolved (plain or inflated)
var _onPipelineInlineReady_ = null;       // optional callback set by the boot flow if it had to wait
(function() {
  function _finalize_(obj) {
    if (obj && typeof obj === 'object') {
      _PIPELINE_INLINE_ = obj;
      _PIPELINE_INLINE_.fromInlineCdn = true;
    }
    _PIPELINE_INLINE_READY_ = true;
    if (typeof _onPipelineInlineReady_ === 'function') {
      try { _onPipelineInlineReady_(_PIPELINE_INLINE_); } catch (e) {}
    }
  }
  try {
    var el = document.getElementById('jv-admin-pipeline-payload');
    if (!el) { _finalize_(null); return; }
    var raw = (el.textContent || '').trim();
    if (!raw || raw === 'null') { _finalize_(null); return; }

    // Detect the gzip marker BEFORE JSON.parse. The GAS encoder emits
    // JSON.stringify('JVGZ_'+b64) = the QUOTED string literal "JVGZ_...", but a
    // json-typed metafield rendered through Liquid can arrive UNQUOTED as a bare
    // JVGZ_.... (BUGFIX 2026-07-17: the bare form made JSON.parse throw, the whole
    // island was silently discarded, the kanban body went blank and fell back to the
    // 30s live call that 504s. This is exactly what Jess hit.). Handle both forms:
    // strip surrounding quotes if present, then check the JVGZ_ prefix directly.
    var marker = raw;
    if (marker.charAt(0) === '"' && marker.charAt(marker.length - 1) === '"') {
      try { marker = JSON.parse(raw); } catch (e) { marker = raw.slice(1, -1); }
    }
    if (typeof marker === 'string' && marker.indexOf('JVGZ_') === 0) {
      // gzip path (async). Old browsers without DecompressionStream fall back to live.
      if (typeof DecompressionStream === 'undefined') { _finalize_(null); return; }
      var b64 = marker.slice(5);
      var bin = atob(b64);
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      var ds = new DecompressionStream('gzip');
      new Response(new Blob([bytes]).stream().pipeThrough(ds)).text()
        .then(function(txt) { try { _finalize_(JSON.parse(txt)); } catch (e) { _finalize_(null); } })
        .catch(function() { _finalize_(null); });
      return;
    }
    // Not gzipped: plain JSON object (synchronous, unchanged behaviour).
    _finalize_(JSON.parse(raw));
  } catch(e) { _finalize_(null); }
})();

// ── Reusable admin CDN-cache island reader (Group B, 2026-07-19) ──────────────
// Generalises the proven jv-admin-pipeline-payload gzip logic (above) so the
// clients-list (T1) + analytics (T3) island reads share ONE tested inflate path.
// Reads the <script id=elementId> JSON island, handles both plain-JSON and the
// GAS gzip form ("JVGZ_..." from adminCache_encodeForStore_, quoted or bare), and
// invokes cb(obj) with the parsed object, or cb(null) if absent/empty/unusable
// (browsers without DecompressionStream, or malformed). cb ALWAYS fires exactly
// once. Plain payloads resolve synchronously; gzip payloads inflate async.
function adminCacheParseIsland_(elementId, cb) {
  var done = false;
  function fin_(obj) { if (done) return; done = true; try { cb(obj && typeof obj === 'object' ? obj : null); } catch (e) {} }
  try {
    var el = document.getElementById(elementId);
    if (!el) { fin_(null); return; }
    var raw = (el.textContent || '').trim();
    if (!raw || raw === 'null' || raw === '{}') { fin_(null); return; }
    var marker = raw;
    if (marker.charAt(0) === '"' && marker.charAt(marker.length - 1) === '"') {
      try { marker = JSON.parse(raw); } catch (e) { marker = raw.slice(1, -1); }
    }
    if (typeof marker === 'string' && marker.indexOf('JVGZ_') === 0) {
      if (typeof DecompressionStream === 'undefined') { fin_(null); return; }
      var b64 = marker.slice(5);
      var bin = atob(b64);
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      var ds = new DecompressionStream('gzip');
      new Response(new Blob([bytes]).stream().pipeThrough(ds)).text()
        .then(function(txt) { try { fin_(JSON.parse(txt)); } catch (e) { fin_(null); } })
        .catch(function() { fin_(null); });
      return;
    }
    fin_(JSON.parse(raw));
  } catch (e) { fin_(null); }
}

(function _hydrateDrawerBundlesFromInlineJson_() {
  try {
    var el = document.getElementById('jv-admin-drawer-bundles');
    if (!el) return;
    var raw = (el.textContent || '').trim();
    if (!raw || raw === '{}') return;
    var map = JSON.parse(raw);
    var now = Date.now();
    Object.keys(map).forEach(function(key) {
      var bundle = map[key];
      if (!bundle) return;
      bundle.fromInlineCdn = true;
      _drawerBundleCache[key] = { data: bundle, ts: now, promise: null };
    });
  } catch (e) {
    // Swallow — if parsing fails (malformed JSON, no metaobject yet), drawer
    // simply falls back to the GAS path. No harm.
    if (typeof console !== 'undefined') console.warn('drawer bundle hydration failed:', e);
  }
})();

/* Drawer perf Option B Phase 1 (2026-06-16): per-bride Storefront lazy-fetch.
   Tier-0 reads the single drawer_bundle metaobject straight from the Shopify
   Storefront API (~150ms, CDN, zero GAS), falls back to GAS on a miss/stale
   snapshot, and fires a background self-heal so the NEXT open is a Storefront
   hit. Mirrors the proven proposal_snapshot pattern (sections/jv-proposal-v2). */
var _SF_DRAWER_SHOP = 'jessicavegas.com';
var _SF_DRAWER_VER  = '2026-01';
var _drawerHealInFlight_ = {}; // clientId -> true; client-side dedup (C3 belt-and-braces)

function _drawerSfToken_() {
  // Emitted into JS by the admin-crm section from shop.metafields.custom.storefront_api_token.
  return (typeof window !== 'undefined' && window.JV_SF_DRAWER_TOKEN) ? String(window.JV_SF_DRAWER_TOKEN) : '';
}

// SECURITY (2026-07-28): the drawer_bundle handle is SHA-256(clientId + '|' + salt),
// NOT the old enumerable 'drawer-bundle-<clientId>'. The salt is emitted server-side
// ONLY into this admin-gated page (window.JV_DRAWER_CACHE_SALT). MUST match GAS
// _drawerBundle_handleFor_ byte-for-byte. Returns a Promise; resolves null if the salt
// or crypto is unavailable (caller then falls back to the authenticated live GAS call).
function _drawerCacheSalt_() {
  return (typeof window !== 'undefined' && window.JV_DRAWER_CACHE_SALT) ? String(window.JV_DRAWER_CACHE_SALT) : '';
}
function _drawerSha256Hex_(str) {
  try {
    if (!(window.crypto && window.crypto.subtle)) return Promise.resolve(null);
    var enc = new TextEncoder().encode(str);
    return window.crypto.subtle.digest('SHA-256', enc).then(function (buf) {
      var b = new Uint8Array(buf), out = '';
      for (var i = 0; i < b.length; i++) out += ('0' + b[i].toString(16)).slice(-2);
      return out;
    }).catch(function () { return null; });
  } catch (e) { return Promise.resolve(null); }
}
function _drawerBundleHandle_(clientId) {
  var salt = _drawerCacheSalt_();
  if (!salt) return Promise.resolve(null);
  return _drawerSha256Hex_(String(clientId) + '|' + salt).then(function (hex) {
    return hex ? ('drawer-bundle-' + hex) : null;
  });
}

// C4 freshness gate: only trust a snapshot that has client.quickLinks (shipped
// 2026-06-13). Pre-quickLinks snapshots lack the key, so they are treated as
// stale and routed to GAS + self-heal, never served with pills silently missing.
function _drawerBundleFresh_(b) {
  return !!(b && b.client && !b.client.error && Object.prototype.hasOwnProperty.call(b.client, 'quickLinks'));
}

function _drawerStorefrontFetch_(clientId, tok) {
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  // Salted handle is async (SHA-256). A null handle (missing salt / no crypto) means the
  // CDN read cannot be constructed, so fall back to the live authenticated GAS call.
  return _drawerBundleHandle_(clientId).then(function (handle) {
    if (!handle) return null;
    var q = 'query($h:MetaobjectHandleInput!){ metaobject(handle:$h){ field(key:"bundle"){ value } } }';
    var body = { query: q, variables: { h: { type: 'drawer_bundle', handle: handle } } };
    return nf('https://' + _SF_DRAWER_SHOP + '/api/' + _SF_DRAWER_VER + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(d){
      var v = d && d.data && d.data.metaobject && d.data.metaobject.field && d.data.metaobject.field.value;
      return v ? JSON.parse(v) : null;
    }).catch(function(){ return null; });
  });
}

// Fire-and-forget background self-heal (rebuild FULL + push to Shopify) so the
// next open is a Storefront hit. Server-side lock (C3) is the real backstop;
// this per-session map just avoids re-firing for the same bride repeatedly.
function _drawerSelfHeal_(clientId) {
  var k = String(clientId);
  if (_drawerHealInFlight_[k]) return;
  _drawerHealInFlight_[k] = true;
  try {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_ensureDrawerSnapshot', args: { clientId: clientId } })
      .then(function(){ _drawerHealInFlight_[k] = false; })
      .catch(function(){ _drawerHealInFlight_[k] = false; });
  } catch (e) { _drawerHealInFlight_[k] = false; }
}

function getDrawerBundle_(clientId, opts) {
  var key = String(clientId);
  opts = opts || {};
  var cached = _drawerBundleCache[key];
  // Inline-CDN entries are fresh for the page session (Liquid re-emits each load,
  // GAS invalidates the metaobject on edit, Refresh forces a rebuild). Option B:
  // gated on _drawerBundleFresh_ so a pre-quickLinks inline blob is not served stale.
  if (!opts.fresh && cached && cached.data && cached.data.fromInlineCdn && _drawerBundleFresh_(cached.data)) {
    return Promise.resolve(cached.data);
  }
  if (!opts.fresh && cached && cached.data && !cached.data.error && (Date.now() - cached.ts < 60000) && _drawerBundleFresh_(cached.data)) {
    return Promise.resolve(cached.data);
  }
  if (!opts.fresh && cached && cached.promise) {
    return cached.promise;
  }
  // Resilience (2026-05-27): preserve any pre-existing cache data while a fresh
  // fetch is in flight, so a failed GAS call (e.g. "Function not allowed" before a
  // whitelist deploy) never wipes a usable bundle and strands tab clicks on the spinner.
  var preserveData = (cached && cached.data) ? cached.data : null;

  // Identity token (2026-07-22): the email the frontend believes this clientId
  // belongs to, so the backend can verify the row number still holds that bride
  // and re-resolve by email if the row drifted (deletion/archive/re-sort). Falls
  // back to whatever the list/pipeline knows for this id.
  var expectedEmail = opts.expectedEmail || '';
  if (!expectedEmail && typeof findClientById === 'function') {
    var _known = findClientById(clientId);
    if (_known && _known.email) expectedEmail = _known.email;
  }

  // GAS fetch (authoritative path; factored so tier-0 can fall back to it).
  function gasFetch_() {
    var args = { clientId: clientId };
    if (expectedEmail) args.expectedEmail = expectedEmail;
    if (opts.forceServer) args.force = true;
    // Lite open path: server returns shell + lightweight tabs fast, heavy sections
    // marked {lite:true} and lazy-loaded on first click.
    if (opts.lite) args.lite = true;
    return jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientDrawerBundle', args: args })
      .then(function(res) {
        var bundle = (res && res.ok && res.data && res.data.ok) ? res.data : null;
        var finalData = bundle || preserveData;
        var existingNow = _drawerBundleCache[key] && _drawerBundleCache[key].data;
        if (finalData && finalData.lite && existingNow && !existingNow.lite && !existingNow.error) {
          finalData = existingNow;
        }
        _drawerBundleCache[key] = { data: finalData, ts: Date.now(), promise: null };
        return finalData;
      })
      .catch(function() {
        _drawerBundleCache[key] = { data: preserveData, ts: Date.now(), promise: null };
        return preserveData;
      });
  }

  // Tier-0: Storefront single-metaobject read (skip on forceServer / no token).
  function networkFetch_() {
    var tok = _drawerSfToken_();
    if (opts.forceServer || !tok) return gasFetch_();
    return _drawerStorefrontFetch_(clientId, tok).then(function(sf) {
      // Identity guard: the Storefront metaobject is keyed by row number too, so a
      // drifted row could hand back the wrong bride's pre-built bundle. If it does
      // not match the bride we expect, ignore it and go to the email-verified GAS path.
      if (sf && sf.ok && expectedEmail) {
        var sfEmail = String((sf.client && (sf.client.email || sf.client.EMAIL)) || '').trim().toLowerCase();
        if (sfEmail && sfEmail !== String(expectedEmail).trim().toLowerCase()) {
          _drawerSelfHeal_(clientId);
          return gasFetch_();
        }
      }
      if (sf && sf.ok && _drawerBundleFresh_(sf)) {
        sf.fromStorefront = true;
        var existingNow = _drawerBundleCache[key] && _drawerBundleCache[key].data;
        if (sf.lite && existingNow && !existingNow.lite && !existingNow.error) {
          return existingNow; // don't downgrade a richer cache already loaded
        }
        _drawerBundleCache[key] = { data: sf, ts: Date.now(), promise: null };
        return sf;
      }
      // Miss or stale snapshot: render via GAS now, self-heal in the background.
      _drawerSelfHeal_(clientId);
      return gasFetch_();
    }).catch(function() { return gasFetch_(); });
  }

  var p = networkFetch_();

  // Background refresh path (fresh:true with pre-existing data): serve cached
  // immediately, let the fetch update the cache for future calls.
  if (opts.fresh && preserveData) {
    _drawerBundleCache[key] = { data: preserveData, ts: cached ? cached.ts : Date.now(), promise: p };
    return Promise.resolve(preserveData);
  }
  _drawerBundleCache[key] = { promise: p, ts: Date.now(), data: preserveData };
  return preserveData ? Promise.resolve(preserveData) : p;
}

/* ------------------------------------------------------------------
   HOVER PREFETCH (2026-08-09, BUILD-admin-504-timeouts)
   A hover is a mouse passing over a card, not a request for data. Binding
   getDrawerBundle_ straight to onmouseenter meant crossing a cold board fired
   one live GAS drawer-bundle call per card, which was the biggest single
   contributor to the 504 storm.

   This path is deliberately weaker than getDrawerBundle_:
     - cache hit                -> zero network
     - cache miss               -> AT MOST one Storefront/CDN read
     - never gasFetch_, never _drawerSelfHeal_ (both POST GAS)
     - dwell >= 250ms, restarted per card; leaving cancels
     - concurrency cap 1; one attempt per bride per page session
     - all errors silent (a prefetch failing must never surface)
   getDrawerBundle_ semantics are UNCHANGED: the ~18 other callers are real
   opens and must keep fetching authoritatively.
   ------------------------------------------------------------------ */
var _HOVER_DWELL_MS_ = 250;
var _hoverDwellTimer_ = null;
var _hoverPrefetchInFlight_ = false;
var _hoverPrefetchTried_ = {};

// True when the session cache already holds a usable bundle (same freshness
// rules getDrawerBundle_ applies before deciding to hit the network).
function _hoverBundleCached_(key) {
  var cached = _drawerBundleCache[key];
  if (!cached || !cached.data) return false;
  if (cached.data.fromInlineCdn && _drawerBundleFresh_(cached.data)) return true;
  return !cached.data.error && (Date.now() - cached.ts < 60000) && _drawerBundleFresh_(cached.data);
}

function prefetchDrawerBundleOnHover_(clientId) {
  if (_hoverDwellTimer_) { clearTimeout(_hoverDwellTimer_); _hoverDwellTimer_ = null; }
  if (!clientId) return;
  var key = String(clientId);
  if (_hoverPrefetchTried_[key] || _hoverBundleCached_(key)) return;

  _hoverDwellTimer_ = setTimeout(function () {
    _hoverDwellTimer_ = null;
    if (_hoverPrefetchInFlight_) return;                 // concurrency cap 1
    if (_hoverPrefetchTried_[key] || _hoverBundleCached_(key)) return;
    if (_drawerBundleCache[key] && _drawerBundleCache[key].promise) return; // open already in flight

    var tok = (typeof _drawerSfToken_ === 'function') ? _drawerSfToken_() : '';
    if (!tok) return;                                    // no Storefront token, do nothing (never GAS)

    _hoverPrefetchTried_[key] = true;
    _hoverPrefetchInFlight_ = true;
    try {
      _drawerStorefrontFetch_(clientId, tok).then(function (sf) {
        // Only bank a hit that is fresh and identity-matched. A mismatch or a
        // miss is dropped silently: the real open will resolve it properly.
        if (!sf || !sf.ok || !_drawerBundleFresh_(sf)) return;
        var expected = '';
        if (typeof findClientById === 'function') {
          var known = findClientById(clientId);
          if (known && known.email) expected = String(known.email).trim().toLowerCase();
        }
        var sfEmail = String((sf.client && (sf.client.email || sf.client.EMAIL)) || '').trim().toLowerCase();
        if (expected && sfEmail && sfEmail !== expected) return;
        var existing = _drawerBundleCache[key] && _drawerBundleCache[key].data;
        if (existing && !existing.error && sf.lite) return; // never downgrade a richer cache
        sf.fromStorefront = true;
        _drawerBundleCache[key] = { data: sf, ts: Date.now(), promise: null };
      })['catch'](function () { /* silent: a prefetch must never surface an error */ })
        .then(function () { _hoverPrefetchInFlight_ = false; });
    } catch (e) { _hoverPrefetchInFlight_ = false; }
  }, _HOVER_DWELL_MS_);
}

// Leaving a card cancels a dwell that has not fired yet.
function cancelDrawerBundlePrefetch_() {
  if (_hoverDwellTimer_) { clearTimeout(_hoverDwellTimer_); _hoverDwellTimer_ = null; }
}
window.prefetchDrawerBundleOnHover_ = prefetchDrawerBundleOnHover_;
window.cancelDrawerBundlePrefetch_ = cancelDrawerBundlePrefetch_;

// A bundle section is "ready" only when present, error-free, AND not a lite
// placeholder ({lite:true}). On drawer-open we fetch a LITE bundle so the shell
// plus lightweight tabs (Overview, Progress, Invoices, Runsheet, Party) render
// at the ~8s startup floor instead of waiting ~15s for the heavy aggregators.
// The heavy tabs (Timeline comms, Proposals, Forms, Portal Preview) treat their
// lite placeholder as "not loaded" and lazy-load via the legacy per-tab fetch.
function _bundleSectionReady_(section) {
  return !!(section && !section.error && !section.lite);
}

/* ------------------------------------------------------------------
   Lazy drawer-tab watchdog (P4b Part 1 item 4)
   A lazy tab fetch that hangs on the ~8s GAS wall (or a never-resolving
   bridge promise) used to spin forever. This arms a per-pane watchdog on
   every lazy load: if the pane is still showing its spinner after the
   window, it auto-retries the load ONCE, and if it is still stuck after
   that, it swaps the spinner for a "Couldn't load, tap to retry" affordance
   instead of an endless spinner. Panes render their loading state as a
   `.view-loader`; its absence means the tab painted, so no false retries.
   ------------------------------------------------------------------ */
var _LAZY_DRAWER_PANES_ = {
  'timeline':       'drawer-timeline-content',
  'proposals':      'drawer-proposals-content',
  'invoices':       'drawer-invoices-content',
  'runsheet':       'drawer-runsheet-content',
  'forms':          'drawer-forms-content',
  'portal-preview': 'drawer-portal-preview-content'
};
var _TAB_WATCHDOG_MS_ = 14000; // > the ~8s cold-start wall + render margin.
var _tabWatchdogTimer_ = null;

function _clearTabWatchdog_() {
  if (_tabWatchdogTimer_) { clearTimeout(_tabWatchdogTimer_); _tabWatchdogTimer_ = null; }
}

function _armTabWatchdog_(pane, clientId, attempt) {
  _clearTabWatchdog_();
  var elId = _LAZY_DRAWER_PANES_[pane];
  if (!elId) return;
  attempt = attempt || 1;
  _tabWatchdogTimer_ = setTimeout(function() {
    _tabWatchdogTimer_ = null;
    // Only act if the user is still on this exact pane for this exact client.
    if (STATE.drawerTab !== pane || String(STATE.drawerClientId) !== String(clientId)) return;
    var el = document.getElementById(elId);
    if (!el) return;
    // If the spinner is gone, the tab painted fine; nothing to do.
    if (!el.querySelector('.view-loader')) return;
    if (attempt < 2) {
      // One automatic retry.
      loadDrawerPane(pane, clientId, attempt + 1);
    } else {
      _renderTabRetry_(el, pane, clientId);
    }
  }, _TAB_WATCHDOG_MS_);
}

function _renderTabRetry_(el, pane, clientId) {
  el.innerHTML =
    '<div class="tab-retry">' +
      '<p class="tab-retry-msg">Couldn\'t load this tab.</p>' +
      '<button type="button" class="btn btn-ghost" onclick="loadDrawerPane(\'' +
        escAttr(pane) + '\', \'' + escAttr(String(clientId)) + '\')">Tap to retry</button>' +
    '</div>';
}

// Manual refresh — wired to the drawer header ↻ button. Forces a fresh
// server-side recompute (bypasses both client cache AND GAS CacheService) and
// re-renders the currently-active drawer tab.
function refreshDrawerBundle() {
  var clientId = STATE.drawerClientId;
  if (!clientId) return;
  var key = String(clientId);
  // Clear local cache + invalidate any in-flight promise
  delete _drawerBundleCache[key];
  // Visual feedback
  var btn = document.getElementById('drawer-refresh-btn');
  if (btn) { btn.style.opacity = '0.5'; btn.style.pointerEvents = 'none'; }
  try { jvToast && jvToast('Refreshing from CRM…', 'info'); } catch (_) {}
  // Re-render whatever tab is currently active by forcing a fresh fetch
  getDrawerBundle_(clientId, { fresh: true, forceServer: true }).then(function(b) {
    if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; }
    if (!b) {
      try { jvToast && jvToast('Refresh failed — keeping previous data', 'error'); } catch (_) {}
      return;
    }
    try { jvToast && jvToast('Refreshed.', 'success'); } catch (_) {}
    // Re-fire the active tab loader so the user sees the fresh data immediately
    var pane = STATE.drawerTab || 'overview';
    if (pane === 'overview') loadDrawerClient(clientId);
    else loadDrawerPane(pane, clientId);
  });
}

function openDrawer(clientId) {
  STATE.drawerClientId = clientId;
  var drawer = document.getElementById('detail-drawer');
  var overlay = document.getElementById('drawer-overlay');
  drawer.classList.add('open');
  overlay.classList.add('show');
  // Inject Progress tab if not already present (JS-side injection avoids touching frozen section)
  if (typeof ensureOnboardProgressTab_ === 'function') ensureOnboardProgressTab_();
  // Inject Profitability tab (Pro Team Profit Session 3, 2026-05-27)
  if (typeof ensureProfitabilityTab_ === 'function') ensureProfitabilityTab_();
  // Reset tabs
  switchDrawerTab('overview', document.querySelector('.drawer-tab[data-pane="overview"]'));
  // Instant-paint safety net (2026-06-27, Grade-3 H3): the pipeline payload excludes
  // some clickable brides (Enquiry leads dropped to fit the cache limit, and some rows
  // adminCrm_getClients returns that the pipeline does not). If STATE.clients can't
  // resolve this id yet, lazy-load the full client list (fast, no per-row Xero) so
  // findClientById() succeeds and the hero paints from it while the bundle hydrates.
  // Without this the drawer sat on a blank skeleton for ~16s on a cold open.
  if (typeof findClientById === 'function' && !findClientById(clientId)) {
    if (!Array.isArray(STATE.clients) || !STATE.clients.length) {
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients', args: {} })
        .then(function(r){
          var list = (r && r.ok && Array.isArray(r.data)) ? r.data : null;
          if (list && list.length) {
            STATE.clients = list;
            // Re-paint overview if this drawer is still open on the same client.
            if (String(STATE.drawerClientId) === String(clientId)) loadDrawerClient(clientId);
          }
        })
        .catch(function(){});
    }
  }
  // Pre-warm a LITE bundle: fires one GAS call that feeds the shell + the
  // lightweight tabs fast, instead of blocking the title/overview on the heavy
  // aggregators (the old ~15s first-open hang). The heavy tabs lazy-load their
  // own data on first click. Fresh on every open so admins see current data.
  getDrawerBundle_(clientId, { fresh: true, lite: true });
  // Load Overview (will read from bundle when it resolves)
  loadDrawerClient(clientId);
}

/* Drawer Book action: open the Internal Booking flow pre-filled with this client. */
function drawerBookTrial() {
  var id = STATE.drawerClientId;
  var c = STATE.drawerClient || {};
  if (!id) { jvToast('Open a client first.', 'error'); return; }
  var prefill = {
    rowIndex: id,
    fullName: c.name || '',
    email: c.email || '',
    weddingDateLabel: (c.weddingDate && typeof formatDate === 'function') ? formatDate(c.weddingDate) : ''
  };
  closeDrawer();
  ibOpenForClient(prefill);
}

function closeDrawer() {
  var drawer = document.getElementById('detail-drawer');
  drawer.classList.remove('open');
  drawer.classList.remove('expanded');
  document.getElementById('drawer-overlay').classList.remove('show');
  updateExpandIcon_();
  _clearTabWatchdog_();
  STATE.drawerClientId = null;
}

function toggleDrawerExpand() {
  // Full-screen bride (2026-07-22): "Expand" now opens the real full-screen, per-client
  // cockpit at /pages/admin-bride-profile?bride=<email> instead of widening the drawer
  // to 80vw (which slid over the shell nav and never became a true workspace). The page
  // is portal-shell-wrapped (nav stays), CDN-fast, bookmarkable, and browser-back returns
  // here. The drawer stays the quick-glance peek. If we cannot resolve the bride's email
  // (thin/unresolved client), fall back to the legacy in-drawer widen so Expand is never
  // a dead click. Additive change only; the CC IIFE + pipeline/detail JS are untouched.
  var email = '';
  try {
    var known = (typeof findClientById === 'function' && STATE && STATE.drawerClientId != null)
      ? findClientById(STATE.drawerClientId) : null;
    email = (known && known.email) ? String(known.email).trim() : '';
  } catch (e) {}
  if (email) {
    // 2026-08-25 identity-mismatch fix (see openClientProfile_ above), pass the
    // exact row too, not just the email, so a duplicate-email bride opens the
    // row actually being viewed in the drawer.
    var expandUrl = '/pages/admin-bride-profile?bride=' + encodeURIComponent(email);
    if (STATE && STATE.drawerClientId != null) expandUrl += '&row=' + encodeURIComponent(STATE.drawerClientId);
    window.location.href = expandUrl;
    return;
  }
  // Legacy fallback: no email resolved -> widen the drawer in place.
  var drawer = document.getElementById('detail-drawer');
  drawer.classList.toggle('expanded');
  updateExpandIcon_();
}

function updateExpandIcon_() {
  var btn = document.getElementById('drawer-expand-btn');
  var isExpanded = document.getElementById('detail-drawer').classList.contains('expanded');
  btn.title = isExpanded ? 'Collapse view' : 'Expand view';
  btn.innerHTML = isExpanded
    ? '<svg viewBox="0 0 24 24"><polyline points="4 14 4 20 10 20"/><polyline points="20 10 20 4 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'
    : '<svg viewBox="0 0 24 24"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>';
}

function switchDrawerTab(pane, tabEl) {
  STATE.drawerTab = pane;
  _clearTabWatchdog_(); // cancel any pending watchdog from the tab we are leaving
  document.querySelectorAll('.drawer-tab').forEach(function(t){ t.classList.remove('active'); });
  document.querySelectorAll('.drawer-pane').forEach(function(p){ p.classList.remove('active'); });
  if (tabEl) tabEl.classList.add('active');
  var paneEl = document.getElementById('drawer-pane-' + pane);
  if (paneEl) paneEl.classList.add('active');
  // Lazy load pane content
  if (STATE.drawerClientId) loadDrawerPane(pane, STATE.drawerClientId);
}

function loadDrawerClient(clientId) {
  // Paint the title + meta INSTANTLY from the already-loaded list/kanban data so
  // the drawer header never sits on the "..." placeholder while the bundle loads.
  // Warmed brides resolve from the inline-CDN bundle in ~50ms; unwarmed clients
  // pay the GAS cold-start wall, but the header is already filled either way.
  var known = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  if (known && known.name) {
    _paintDrawerHeader_(known);
  } else {
    document.getElementById('drawer-name').textContent = '…';
    document.getElementById('drawer-meta').textContent = '';
  }
  document.getElementById('drawer-overview-content').innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    // Drawer may have moved on to a different bride while this (possibly slow,
    // cold-start) bundle was in flight. Drop the stale response so it can never
    // overwrite the currently-open drawer with the wrong bride's data.
    if (String(STATE.drawerClientId) !== String(clientId)) return;
    if (b && b.client && !b.client.error) {
      // Carry the bride's readiness (dimensions + Admin/Bride task split) onto the
      // client so renderDrawerOverview can show the same split as the board card.
      if (b.readiness) b.client._readiness = b.readiness;
      onDrawerClientLoaded(b.client);
      return;
    }
    _loadDrawerClient_legacy(clientId);
  });
}

// Paint just the drawer header (title, meta badge, Book-button visibility). Used
// both for the instant paint from list data on open and the full paint once the
// bundle client resolves.
function _paintDrawerHeader_(client) {
  var bookBtn = document.getElementById('drawer-book-btn');
  var bookable = !client.category || ['Bridal', 'Non-Bridal'].indexOf(client.category) !== -1;
  if (bookBtn) bookBtn.style.display = bookable ? '' : 'none';
  var isBridalContact = bookable;
  document.getElementById('drawer-name').textContent = client.businessName && !isBridalContact
    ? client.businessName
    : (client.name || '');
  document.getElementById('drawer-meta').innerHTML =
    '<span class="stage-badge ' + stageBadgeClass(client.stage) + '" style="margin-right:0.4rem;">' + escHtml(stageDisplay(client.stage)) + '</span>' +
    (isBridalContact ? escHtml(formatDate(client.weddingDate)) : escHtml(client.category || 'Contact'));
}

function _loadDrawerClient_legacy(clientId) {
  // Pass the expected email so the backend can verify the row still holds this
  // bride and re-resolve by email if the row number drifted (object arg form).
  var _known = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  var _args = (_known && _known.email)
    ? { clientId: clientId, expectedEmail: _known.email }
    : clientId;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClient', args: _args })
    .then(function(res) {
      // Same staleness guard as loadDrawerClient: if the drawer moved to another
      // bride while this legacy call was in flight, discard the response.
      if (String(STATE.drawerClientId) !== String(clientId)) return;
      if (res.ok) { onDrawerClientLoaded(res.data); } else {
      document.getElementById('drawer-overview-content').innerHTML = '<div class="alert danger">Failed to load: ' + escHtml((res.error && res.error.message) || String(res.error || '')) + '</div>';
    } })
    .catch(function(err) {
      document.getElementById('drawer-overview-content').innerHTML = '<div class="alert danger">Failed to load: ' + escHtml(err.message || String(err)) + '</div>';
    });
}

function onDrawerClientLoaded(client) {
  if (!client) {
    document.getElementById('drawer-name').textContent = 'Not found';
    return;
  }
  // Remember the loaded client so the drawer Book action can pre-fill the booker.
  STATE.drawerClient = client;
  // Header (title, meta badge, Book-button visibility) via the shared painter.
  _paintDrawerHeader_(client);
  renderDrawerOverview(client);
}

var BRIDAL_CATEGORIES = ['Bridal', 'Non-Bridal'];

/* ----------------------------------------------------------------------
   Quick Links: a row of .btn-ghost pills in the bride drawer that open the
   Google-Sheets-referenced resources for this bride (runsheet, drive folders,
   invoices, agreement, pay link, proposal) in one click, so Jess stops hunting
   for URLs. Pills only render for links that exist.

   CRM-column links come from c.quickLinks (built read-only by adminCrm_getClient).
   The proposal viewer link is derived from the bride's proposal token, which
   lives in the Proposal Tokens sheet, not the CRM row, so we pull it from the
   already-loaded drawer bundle's proposals data if present, and omit the pill
   otherwise (it remains available on the Proposals tab).
   ---------------------------------------------------------------------- */
var QL_ICON = {
  runsheet:    '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/></svg>',
  folder:      '<svg viewBox="0 0 24 24"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>',
  image:       '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
  agreement:   '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></svg>',
  pay:         '<svg viewBox="0 0 24 24"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>',
  invoice:     '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/></svg>',
  proposal:    '<svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>'
};

// Derive the bride-facing proposal viewer URL from the cached drawer bundle's
// proposals data (token lives in Proposal Tokens, not the CRM row). Returns ''
// when proposals aren't loaded yet (lite bundle) or no live token exists.
function _quickLinkProposalUrl_(c) {
  try {
    if (typeof _drawerBundleCache === 'undefined' || !c) return '';
    var entry = _drawerBundleCache[String(c.id)];
    var b = entry && entry.data;
    var proposals = b && b.proposals;
    if (!proposals || proposals.lite || !Array.isArray(proposals)) return '';
    var match = null;
    for (var i = 0; i < proposals.length; i++) {
      var p = proposals[i];
      if ((c.email && p.email === c.email) || String(p.clientId) === String(c.id)) { match = p; break; }
    }
    if (!match || !match.proposalToken || match.proposalStatus === 'voided') return '';
    return 'https://jessicavegas.com/pages/your-bridal-beauty-package?token=' + encodeURIComponent(match.proposalToken);
  } catch (e) { return ''; }
}

// Build the Quick Links row HTML for a loaded client. Returns '' when there is
// nothing to link to (so no empty section renders).
function _renderBrideQuickLinks_(c) {
  var ql = (c && c.quickLinks) || {};
  var pills = [];
  function pill(icon, label, url) {
    pills.push('<a class="btn btn-ghost btn-sm quick-link-pill" href="' + escAttr(url) +
      '" target="_blank" rel="noopener">' + icon + '<span>' + escHtml(label) + '</span></a>');
  }

  if (ql.runsheet)    pill(QL_ICON.runsheet,  'Runsheet',     ql.runsheet);
  if (ql.driveFolder) pill(QL_ICON.folder,    'Drive folder', ql.driveFolder);
  if (ql.trialFolder) pill(QL_ICON.folder,    'Trial folder', ql.trialFolder);
  if (ql.inspoFolder) pill(QL_ICON.image,     'Inspiration',  ql.inspoFolder);
  if (ql.agreement)   pill(QL_ICON.agreement, 'Agreement',    ql.agreement);
  if (ql.payLink)     pill(QL_ICON.pay,       'Pay link',     ql.payLink);

  var proposalUrl = _quickLinkProposalUrl_(c);
  if (proposalUrl)    pill(QL_ICON.proposal,  'Proposal',     proposalUrl);

  if (Array.isArray(ql.invoices)) {
    ql.invoices.forEach(function (inv) {
      if (inv && inv.url) pill(QL_ICON.invoice, inv.label || 'Invoice', inv.url);
    });
  }

  if (!pills.length) return '';
  return '<div class="drawer-quick-links">' +
    '<div class="drawer-quick-links-label">Quick Links</div>' +
    '<div class="drawer-quick-links-row">' + pills.join('') + '</div>' +
    '</div>';
}

function renderDrawerOverview(c) {
  var isBridal = !c.category || BRIDAL_CATEGORIES.indexOf(c.category) !== -1;
  var html = '';

  // Partner Managed Booking — badge at the top of the drawer overview so the
  // admin sees immediately that this bride is billed via a partner (e.g. Kyle
  // / Elope Blue Mountains) and they should not chase her for payment.
  if (c.isPartnerManaged && c.partnerAccountName) {
    html += '<div class="jv-partner-badge">' +
      '<span class="jv-partner-badge-dot" aria-hidden="true"></span>' +
      'Managed by <strong>' + escHtml(c.partnerAccountName) + '</strong>' +
      (c.partnerRole ? ' &middot; ' + escHtml(c.partnerRole) : '') +
      '</div>';
  }

  if (isBridal) {
    var completion = estimateCompletion(c);
    html += '<div class="journey-bar-wrap">';
    html += '<div class="journey-bar-label"><span>Journey Completion</span><span>' + completion + '%</span></div>';
    html += '<div class="journey-bar-bg"><div class="journey-bar-fill" style="width:' + completion + '%"></div></div>';
    html += '</div>';
    var fields = [
      ['Email', c.email],
      ['Phone', c.phone],
      ['Venue', c.venue],
      ['Services', Array.isArray(c.services) ? c.services.join(', ') : c.services],
      ['Wedding Date', formatDate(c.weddingDate)],
      ['Artist', c.assignedArtist],
      ['Source', c.source],
      ['Booking Confirmed', c.isBooked ? 'Yes' : 'No']
    ];
    // Partner Managed Booking — replace "Has Proposal" with "Billed To" so the
    // admin sees who pays. Proposals aren't sent to partner-managed brides.
    if (c.isPartnerManaged) {
      fields.push(['Billed To', (c.partnerAccountName || c.partnerAccountEmail || 'Partner') +
        (c.partnerAccountEmail ? ' (' + c.partnerAccountEmail + ')' : '')]);
    } else {
      fields.push(['Has Proposal', c.hasProposal ? 'Yes' : 'No']);
    }
    // 2026-07-30 fix (FIX-invoice-create-and-send-must-actually-send-2026-07-30.md
    // Item 2): manual "Send welcome email" trigger for partner-managed/EBM brides.
    // Wired to the EXISTING partnerBooking_sendWelcomeEmail_ (via
    // adminCrm_sendPartnerWelcomeEmail), no new sender, no bypassed guards.
    if (c.isPartnerManaged) {
      html += '<div style="margin-top:0.6rem;">' +
        '<button class="btn btn-ghost" style="font-size:0.78rem;" onclick="openSendPartnerWelcomeModal_(\'' + escHtml(c.id) + '\')">' +
        'Send welcome email</button></div>';
    }
    // 2026-07-30 fix: an invoice created DIRECTLY in Xero (not via the CRM's own
    // Bill Partner / Create Invoice flows) never gets XERO_INVOICE_ID written
    // onto this row, so the invoicing list shows nothing and the resend
    // buttons have nothing to attach to. This finds and links any such
    // invoice (checking both the bride's own Xero contact and, for
    // partner-managed brides, her linked partner's Xero contact).
    html += '<div style="margin-top:0.4rem;">' +
      '<button class="btn btn-ghost" style="font-size:0.78rem;" onclick="openFindUnlinkedInvoicesModal_(\'' + escHtml(c.id) + '\')">' +
      'Find Xero invoice</button></div>';
    // 2026-07-30 fix: on-demand priority warm, jumps ONE bride to the front
    // instead of waiting for the automatic historical backfill (commit
    // ee0edccb) to drain the whole backlog. Reachable from this drawer (the
    // regular CRM board), which stays usable even if a bride's OWN Admin
    // Bride Profile page is blank/erroring, so it never depends on the page
    // it is trying to fix being reachable.
    html += '<div style="margin-top:0.4rem;" id="abp-priority-warm-row-' + escHtml(c.id) + '">' +
      '<button class="btn btn-ghost" style="font-size:0.78rem;" onclick="priorityWarmBrideProfile_(\'' + escHtml(c.id) + '\', this)">' +
      'Warm profile page now</button></div>';
    fields.push(['Has Runsheet', c.hasRunsheet ? 'Yes' : 'No']);
    fields.forEach(function(f) {
      if (f[1]) {
        html += '<div class="info-row"><span class="info-label">' + escHtml(f[0]) + '</span><span class="info-value">' + escHtml(String(f[1])) + '</span></div>';
      }
    });
    // Readiness: this bride's stage plus the Admin/Bride task split (same as the board).
    html += renderReadinessPanel_(c._readiness);
    // Team KPI Phase 1: Lead Owner attribution (assign / claim). Bride/lead drawer only.
    html += renderLeadOwnerControl_(c);
    if (c.readyForPipeline && !c.hasProposal) {
      html += '<div style="margin-top:1rem;">';
      html += '<a class="btn btn-primary" href="/pages/proposal-builder?bride=' + encodeURIComponent(c.email || '') + '" target="_blank" rel="noopener">';
      html += '<svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2;"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';
      html += 'Build and Send Proposal</a>';
      html += '</div>';
    }
    // Cancel Wedding (2026-09-04, BUILD-cancel-wedding-admin-crm-button-2026-09-04.md).
    // Bride forfeits money already paid, is never charged anything further. Not
    // shown once a bride is already Closed (nothing left to cancel).
    if (c.stage !== 'Closed') {
      html += '<div style="margin-top:0.6rem;">' +
        '<button class="btn btn-ghost" style="font-size:0.78rem;color:var(--danger,#b32727);border-color:var(--danger,#b32727);" ' +
        'onclick="openCancelWeddingModal_(\'' + escHtml(c.id) + '\', \'' + escAttr(c.email) + '\', \'' + escHtml(c.name || '') + '\')">' +
        'Cancel Wedding</button></div>';
    }
  } else {
    // Business / vendor / contact view
    var catLabel = escHtml(c.category || 'Contact');
    var typeLabel = escHtml(c.contactType || 'Individual');
    html += '<div class="info-row"><span class="info-label">Type</span><span class="info-value">' + catLabel + ' · ' + typeLabel + '</span></div>';
    if (c.businessName) html += '<div class="info-row"><span class="info-label">Business</span><span class="info-value">' + escHtml(c.businessName) + '</span></div>';
    var contactFields = [
      ['Email',   c.email],
      ['Phone',   c.phone],
      ['ABN',     c.abn],
      ['Website', c.website],
      ['Source',  c.source]
    ];
    contactFields.forEach(function(f) {
      if (f[1]) {
        var val = f[0] === 'Website'
          ? '<a href="' + escAttr(c.website) + '" target="_blank" rel="noopener" style="color:var(--brand-primary);">' + escHtml(c.website) + '</a>'
          : escHtml(String(f[1]));
        html += '<div class="info-row"><span class="info-label">' + escHtml(f[0]) + '</span><span class="info-value">' + val + '</span></div>';
      }
    });
    // Social links
    var sl = c.socialLinks || {};
    var socials = [
      ['Instagram', sl.instagram],
      ['Facebook',  sl.facebook],
      ['TikTok',    sl.tiktok]
    ].filter(function(s) { return !!s[1]; });
    if (socials.length) {
      html += '<div class="info-row"><span class="info-label">Socials</span><span class="info-value" style="display:flex;flex-wrap:wrap;gap:0.5rem;">';
      socials.forEach(function(s) {
        html += '<a href="' + escAttr(s[1]) + '" target="_blank" rel="noopener" style="color:var(--brand-primary);font-size:0.78rem;">' + escHtml(s[0]) + '</a>';
      });
      html += '</span></div>';
    }
    if (c.xeroContactId) {
      html += '<div class="info-row"><span class="info-label">Xero</span><span class="info-value" style="font-size:0.75rem;color:var(--muted);">Synced ✓</span></div>';
    }
  }

  // Quick Links: one-click access to this bride's runsheet, folders, invoices,
  // agreement, pay link and proposal (only the links that exist render).
  html += _renderBrideQuickLinks_(c);

  // ── Client actions (available for all categories) ──
  _lastDrawerClient = c;
  html += '<div class="drawer-client-actions">';
  if (c.isPartnerManaged && c.partnerAccountEmail) {
    html += '<button class="btn btn-primary btn-sm" onclick="openBillPartnerModal(\'' + escAttr(String(c.id)) + '\')" title="Create a Xero invoice billed to ' + escAttr(c.partnerAccountName || c.partnerAccountEmail) + '">';
    html += '<svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2;"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>';
    html += 'Bill ' + escHtml(c.partnerAccountName || 'Partner') + '</button>';
  }
  // Payment Plan button: booked brides without a completed or active plan
  var fpStatus      = String(c.finalPaymentStatus || '').toUpperCase();
  var planStatus    = String(c.paymentPlanStatus  || '').toLowerCase();
  var hasActivePlan = planStatus === 'active' || planStatus === 'partial';
  if (c.bookedStatus === 'Yes' && fpStatus !== 'CHARGED' && !hasActivePlan) {
    html += '<button class="btn btn-ghost btn-sm" onclick="openPaymentPlanModal()" title="Set up a flexible installment plan for the final balance">';
    html += '<svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2;margin-right:4px;vertical-align:-1px;"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="14" x2="10" y2="14"/></svg>';
    html += 'Payment Plan</button>';
  }
  if (hasActivePlan) {
    html += '<button class="btn btn-ghost btn-sm" onclick="openPaymentPlanModal()" title="View active payment plan">';
    html += '<svg viewBox="0 0 24 24" style="width:13px;height:13px;stroke:currentColor;fill:none;stroke-width:2;margin-right:4px;vertical-align:-1px;"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>';
    html += 'View Plan</button>';
  }
  html += '<button class="btn btn-ghost btn-sm" onclick="openRecategorisePanel()">Change Category</button>';
  html += '<button class="btn btn-ghost btn-sm btn-danger-ghost" onclick="confirmArchiveClient(' + escHtml(String(c.id)) + ')">Archive Contact</button>';
  html += '</div>';

  // Partner settings panel (2026-08-06). PARTNER ROWS ONLY: a bride row must
  // never show it. Rendered as a placeholder here and populated asynchronously
  // by partnerSettings_afterRender_ so the drawer paints immediately.
  if (partnerSettings_isPartnerContact_(c)) {
    html += '<div id="jv-partner-settings-panel" style="margin-top:1rem;"></div>';
  }

  document.getElementById('drawer-overview-content').innerHTML = html;
  // Team KPI Phase 1: populate the Lead Owner select once the drawer HTML is in the DOM.
  try { leadOwner_afterRender_(c); } catch (e) {}
  try { partnerSettings_afterRender_(c); } catch (e) {}
}

/* -- Partner settings panel ------------------------------------------------
   Surface over the per-partner switches that were previously SHEET-ONLY
   (Jess, 2026-08-06: "I set it in the admin CRM").

   THIS IS A SURFACE, NOT NEW ROUTING. Every gate it writes to is already
   built, live and tested in GAS. Setting a value here only changes what those
   existing gates read; no routing, comms or money logic is touched.

   Three rules this panel exists to honour:
     1. PARTNER ROWS ONLY. Never rendered for a bride.
     2. Defaults are shown AS defaults ("Not set"), never as a saved choice.
     3. A control whose CRM column does not physically exist is DISABLED with a
        visible reason. PARTNER_RUNSHEET_APPROVAL_GATE and PARTNER_RATE_CARD_JSON
        were registered in JV_EXPECTED_CRM_HEADERS but may never have been
        appended to the sheet (00_Globals.gs:78). An inert toggle that appears
        to save but writes nowhere is worse than no toggle. */

function partnerSettings_isPartnerContact_(c) {
  if (!c) return false;
  var cat = String(c.clientCategory || '').trim().toLowerCase();
  if (cat === 'vendor' || cat === 'wedding planner') return true;
  return /_VENDOR$/i.test(String(c.externalBookingSource || ''));
}

function partnerSettings_afterRender_(c) {
  var host = document.getElementById('jv-partner-settings-panel');
  if (!host || !partnerSettings_isPartnerContact_(c)) return;
  if (!c.email) {
    host.innerHTML = partnerSettings_note_('This partner has no email address on file, so their settings cannot be looked up.');
    return;
  }

  host.innerHTML = partnerSettings_shell_('<div style="font-size:0.78rem;color:var(--muted,#7e706c);">Loading partner settings...</div>');

  jvBridge.callAdmin('bridge_admin_getPartnerSettings', { partnerEmail: c.email })
    .then(function (res) {
      if (!res || res.success !== true) {
        host.innerHTML = partnerSettings_note_('Could not load partner settings' +
          (res && res.error ? ' (' + escHtml(String(res.error)) + ')' : '') + '.');
        return;
      }
      PARTNER_SETTINGS_STATE_ = {
        email: c.email,
        settings: res.settings || {},
        available: res.available || {}
      };
      host.innerHTML = partnerSettings_shell_(partnerSettings_body_(res.settings || {}, res.available || {}));
    })
    .catch(function (e) {
      host.innerHTML = partnerSettings_note_('Could not load partner settings (' + escHtml(String(e && e.message || e)) + ').');
    });
}

var PARTNER_SETTINGS_STATE_ = null;

function partnerSettings_shell_(inner) {
  return '<div style="padding:0.9rem 1rem;border:1px solid var(--line,#e6dad4);border-radius:1rem;background:var(--brand-bg-white,#fff);">' +
    '<div style="font-family:\'Raleway\',sans-serif;font-size:0.6rem;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:var(--brand-primary,#c99591);margin-bottom:0.6rem;">' +
      'Partner Settings</div>' + inner + '</div>';
}

function partnerSettings_note_(msg) {
  return partnerSettings_shell_('<div style="font-size:0.78rem;color:var(--muted,#7e706c);">' + msg + '</div>');
}

/* One setting row: label, explanation, and either a live select or a disabled
   control with the reason it is unavailable. */
function partnerSettings_row_(opts) {
  var id = 'jv-ps-' + opts.field;
  var control;

  if (!opts.available) {
    // NEVER render an inert toggle. Disabled plus the actual reason.
    control =
      '<select id="' + id + '" disabled style="width:100%;padding:0.5rem 0.7rem;border-radius:1rem;' +
        'border:1px solid var(--line,#e6dad4);background:var(--brand-bg-soft,#f6f1ee);' +
        'font-family:\'Plus Jakarta Sans\',sans-serif;font-size:0.8rem;opacity:0.55;cursor:not-allowed;">' +
        '<option>Unavailable</option></select>' +
      '<div style="font-size:0.68rem;color:var(--danger,#b32727);margin-top:0.3rem;">' +
        'Not available: the ' + escHtml(opts.column) + ' column does not exist in the CRM sheet yet. ' +
        'It must be added before this setting can be saved.</div>';
  } else {
    var optsHtml = opts.options.map(function (o) {
      return '<option value="' + escAttr(o.value) + '"' +
        (o.value === opts.current ? ' selected' : '') + '>' + escHtml(o.label) + '</option>';
    }).join('');
    control =
      '<select id="' + id + '" onchange="partnerSettings_save_(\'' + escAttr(opts.field) + '\', this.value)" ' +
        'style="width:100%;padding:0.5rem 0.7rem;border-radius:1rem;border:1px solid var(--line,#e6dad4);' +
        'background:var(--brand-bg-soft,#f6f1ee);font-family:\'Plus Jakarta Sans\',sans-serif;font-size:0.8rem;">' +
        optsHtml + '</select>' +
      (opts.isDefault
        ? '<div style="font-size:0.68rem;color:var(--muted,#7e706c);margin-top:0.3rem;">Not set, defaulting to ' +
            escHtml(opts.defaultLabel) + '.</div>'
        : '');
  }

  return '<div style="margin-bottom:0.9rem;">' +
    '<label for="' + id + '" style="display:block;font-size:0.72rem;font-weight:600;color:var(--brand-text,#2f2524);margin-bottom:0.15rem;">' +
      escHtml(opts.label) + '</label>' +
    '<div style="font-size:0.68rem;color:var(--muted,#7e706c);margin-bottom:0.35rem;">' + opts.help + '</div>' +
    control + '</div>';
}

function partnerSettings_body_(s, avail) {
  var html = '';

  html += partnerSettings_row_({
    field: 'invoiceDelivery',
    column: 'PARTNER_INVOICE_DELIVERY',
    available: avail.invoiceDelivery !== false,
    label: 'Invoice delivery',
    help: 'Who receives the invoice for this partner&rsquo;s brides.',
    current: s.invoiceDeliveryEffective || 'partner',
    isDefault: !!s.invoiceDeliveryIsDefault,
    defaultLabel: 'bill the partner',
    options: [
      { value: 'partner', label: 'Bill the partner (default)' },
      { value: 'bride',   label: 'Bill each bride directly' }
    ]
  });

  html += partnerSettings_row_({
    field: 'runsheetGate',
    column: 'PARTNER_RUNSHEET_APPROVAL_GATE',
    available: avail.runsheetGate !== false,
    label: 'Runsheet notification',
    help: 'Who receives the runsheet when it is published.',
    current: s.runsheetGateEffective || 'partner',
    isDefault: !!s.runsheetGateIsDefault,
    defaultLabel: 'send to the partner with the PDF',
    options: [
      { value: 'partner', label: 'Send to the partner, with PDF (default)' },
      { value: 'bride',   label: 'Send straight to the bride' }
    ]
  });

  html += partnerSettings_row_({
    field: 'invoiceTerms',
    column: 'PARTNER_INVOICE_TERMS',
    available: avail.invoiceTerms !== false,
    label: 'Invoice terms',
    help: 'Payment terms used when billing this partner.',
    current: s.invoiceTermsRaw || '',
    isDefault: !s.invoiceTermsRaw,
    defaultLabel: 'no specific terms',
    options: [
      { value: '',                      label: 'Not set' },
      { value: 'due_on_receipt',        label: 'Due on receipt' },
      { value: 'net_7',                 label: 'Net 7 days' },
      { value: 'net_14',                label: 'Net 14 days' },
      { value: 'net_30',                label: 'Net 30 days' },
      { value: '50_deposit_balance_2w', label: '50% deposit, balance 2 weeks' }
    ]
  });

  // Rate card is READ-ONLY here: it is a JSON pricing blob, not a toggle, and
  // editing it belongs in its own surface rather than a free-text box that
  // could corrupt partner pricing with one malformed paste.
  html += '<div style="font-size:0.7rem;color:var(--muted,#7e706c);padding-top:0.4rem;border-top:1px solid var(--line,#e6dad4);">' +
    'Rate card: ' +
    (avail.rateCard === false
      ? 'unavailable (the PARTNER_RATE_CARD_JSON column does not exist in the CRM sheet yet).'
      : (s.hasRateCard ? 'stored for this partner.' : 'none stored.')) +
    '</div>';

  html += '<div id="jv-ps-status" style="font-size:0.72rem;margin-top:0.5rem;min-height:1rem;"></div>';
  return html;
}

/* Saves one setting and reports what the SHEET actually contains afterwards.
   The backend re-reads every written cell and returns readBack/match, so a
   write into a missing column can never be reported as a success here. */
function partnerSettings_save_(field, value) {
  if (!PARTNER_SETTINGS_STATE_ || !PARTNER_SETTINGS_STATE_.email) return;
  var statusEl = document.getElementById('jv-ps-status');
  var say = function (msg, colour) {
    if (statusEl) statusEl.innerHTML = '<span style="color:' + colour + ';">' + msg + '</span>';
  };
  say('Saving...', 'var(--muted,#7e706c)');

  var settings = {};
  settings[field] = value;

  jvBridge.callAdmin('bridge_admin_savePartnerSettings', {
    partnerEmail: PARTNER_SETTINGS_STATE_.email,
    settings: settings
  }).then(function (res) {
    if (!res || res.success !== true) {
      say('Not saved' + (res && res.error ? ': ' + escHtml(String(res.error)) : '.'), 'var(--danger,#b32727)');
      return;
    }
    var skipped = (res.skipped || []).filter(function (s) { return s.field === field; })[0];
    if (skipped) {
      say('Not saved: ' + (skipped.reason === 'column_missing'
        ? 'the ' + escHtml(String(skipped.column || '')) + ' column does not exist in the CRM sheet.'
        : 'that value was rejected.'), 'var(--danger,#b32727)');
      return;
    }
    var v = (res.verified || {})[field];
    if (v && v.match === false) {
      say('Save could not be confirmed, the sheet still reads "' + escHtml(String(v.readBack)) + '".',
        'var(--danger,#b32727)');
      return;
    }
    if (res.settings) PARTNER_SETTINGS_STATE_.settings = res.settings;
    say('Saved and confirmed in the CRM sheet.', 'var(--success,#1f6b46)');
  }).catch(function (e) {
    say('Not saved: ' + escHtml(String(e && e.message || e)), 'var(--danger,#b32727)');
  });
}

/* ── Readiness panel (bride drawer): stage dimensions + Admin/Bride task split ──
   Read-only mirror of the Wedding Readiness board card, scoped to this bride.
   Data: bundle.readiness (adminCrm_getBrideReadiness) carried onto c._readiness.
   Zero GAS on render (comes from the cached drawer bundle). */
function renderReadinessPanel_(r) {
  if (!r || r.ok === false || !r.dimensions) return '';
  var d = r.dimensions;
  var tasks = r.tasks || [];

  function tone(kind, val) {
    val = String(val || '');
    if (kind === 'onboarding') return (d.onboardingPct >= 100) ? 'good' : (d.onboardingPct >= 60 ? 'mid' : 'low');
    if (kind === 'trial')    return (/^(Not required|Done|Booked|Completed)/.test(val)) ? 'good' : (/^Required/.test(val) ? 'low' : 'mid');
    if (kind === 'runsheet') return (/^Signed off/.test(val)) ? 'good' : (/^(Not started|Change)/.test(val) ? 'low' : 'mid');
    if (kind === 'staff')    return (val === 'None assigned') ? 'low' : (/^Poll/.test(val) ? 'mid' : 'good');
    return '';
  }
  var toneColor = { good: 'var(--success, #1f6b46)', mid: 'var(--warning, #9b4c1e)', low: 'var(--danger, #b32727)', '': 'var(--brand-text, #2f2524)' };
  function dimChip(label, val, kind) {
    var t = tone(kind, val);
    return '<div style="background:var(--brand-bg-soft,#f6f1ee);border-radius:0.5rem;padding:0.45rem 0.6rem;">' +
      '<span style="display:block;font-size:0.55rem;text-transform:uppercase;letter-spacing:0.06em;color:var(--muted,#7e706c);">' + label + '</span>' +
      '<span style="display:block;font-size:0.78rem;margin-top:0.12rem;color:' + toneColor[t] + ';">' + escHtml(String(val)) + '</span></div>';
  }

  var ours = tasks.filter(function(t) { return t.delegateTo !== 'bride'; });
  var theirs = tasks.filter(function(t) { return t.delegateTo === 'bride'; });
  function taskLine(t) {
    var sevColor = t.severity === 'critical' ? 'var(--danger,#b32727)' : (t.severity === 'warn' ? 'var(--warning,#9b4c1e)' : 'var(--info,#1a5fa3)');
    return '<div style="display:flex;align-items:center;gap:0.4rem;font-size:0.78rem;color:var(--brand-text,#2f2524);padding:0.2rem 0;">' +
      '<span style="width:6px;height:6px;border-radius:50%;flex:none;background:' + sevColor + ';"></span>' + escHtml(t.label) + '</div>';
  }
  function col(title, list, emptyMsg) {
    var rows = list.length ? list.map(taskLine).join('') : '<div style="font-size:0.74rem;color:var(--muted,#7e706c);padding:0.2rem 0;">' + emptyMsg + '</div>';
    return '<div style="flex:1;min-width:0;">' +
      '<div style="font-family:\'Raleway\',sans-serif;font-size:0.6rem;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:var(--brand-primary,#c99591);margin-bottom:0.4rem;">' +
        title + ' <span style="color:var(--muted,#7e706c);">(' + list.length + ')</span></div>' + rows + '</div>';
  }

  return '<div style="margin-top:1rem;padding:0.9rem 1rem;border:1px solid var(--line,#e6dad4);border-radius:1rem;background:var(--brand-bg-white,#fff);">' +
    '<div style="font-family:\'Raleway\',sans-serif;font-size:0.62rem;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted,#7e706c);margin-bottom:0.6rem;">Readiness</div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0.4rem;margin-bottom:0.8rem;">' +
      dimChip('Onboarding', d.onboardingPct + '%', 'onboarding') +
      dimChip('Trial', d.trialStatus, 'trial') +
      dimChip('Runsheet', d.runsheetStatus, 'runsheet') +
      dimChip('Staff', d.staffStatus, 'staff') +
    '</div>' +
    (tasks.length
      ? '<div style="display:flex;gap:1rem;border-top:1px solid var(--line,#e6dad4);padding-top:0.7rem;">' +
          col('Admin tasks', ours, 'Nothing on our plate.') +
          col('Bride tasks', theirs, 'Nothing outstanding.') +
        '</div>'
      : '<div style="border-top:1px solid var(--line,#e6dad4);padding-top:0.7rem;font-size:0.78rem;color:var(--success,#1f6b46);">Ready: nothing outstanding.</div>') +
    '</div>';
}

/* ── Team KPI Phase 1: Lead Owner attribution (bride drawer) ──────────── */
var _leadOwnerArtists = null; // session cache of active roster artists
/* Lead-owner artist list from D1 (2026-10-06, QA: the drawer sat on "Loading artists" for 15s+ on
   a cold Apps Script read of the _TeamOptions sheet). Flag OFF. When ON the list comes from the D1
   team_members mirror via the admin-team-roster relay entity (POST /team-members-list, staleness
   guarded, active members with an email); any D1 miss falls back to the Apps Script read, since this
   is a read-only list and an empty roster would block assignments. Remaining GAS dependency: the
   fallback, and the Sheet->D1 team sync that feeds the mirror. Moves off when the fallback is retired. */
var ADMIN_LEAD_OWNER_D1_ENABLED_ = true;
function leadOwnerArtistsFetch_() {
  var gas = function() { return jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getLeadOwnerArtists' }); };
  var base = window._jvAdminProxyBase;
  if (!ADMIN_LEAD_OWNER_D1_ENABLED_ || !base) return gas();
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/partner/admin-team-roster/read', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ activeOnly: true })
  }).then(function(r) { return r.json(); }).then(function(b) {
    if (!b || b.ok !== true || !Array.isArray(b.members)) return gas();
    var artists = b.members.filter(function(m) { return m && m.active && m.email; })
      .map(function(m) { return { name: m.displayName || m.email, email: String(m.email).toLowerCase(), role: '' }; });
    if (!artists.length) return gas(); // never present an empty roster as authoritative
    return { ok: true, data: { ok: true, artists: artists } };
  }).catch(function() { return gas(); });
}

function renderLeadOwnerControl_(c) {
  var ownerLabel = c.leadOwnerName ? escHtml(c.leadOwnerName) : 'Unassigned';
  var convNote = '';
  if (c.leadConvertedAt) {
    var d;
    try { d = formatDate(c.leadConvertedAt); } catch (e) { d = c.leadConvertedAt; }
    convNote = '<div class="lead-owner-converted">Converted ' + escHtml(String(d || '')) + '</div>';
  }
  var idAttr = escAttr(String(c.id));
  var h = '';
  h += '<div class="lead-owner-block">';
  h += '<div class="info-row"><span class="info-label">Lead Owner</span>';
  h += '<span class="info-value" id="lead-owner-current">' + ownerLabel + '</span></div>';
  h += convNote;
  h += '<div class="lead-owner-editor">';
  h += '<span class="lead-owner-loading" id="lead-owner-loading"><span class="mini-spinner"></span> Loading artists…</span>';
  h += '<select id="lead-owner-select" class="lead-owner-select" aria-label="Lead owner" aria-busy="true" disabled style="display:none;"><option value="">Loading artists…</option></select>';
  h += '<button class="btn btn-ghost btn-sm" type="button" onclick="assignLeadOwner_(\'' + idAttr + '\')">Assign</button>';
  h += '<button class="btn btn-ghost btn-sm" type="button" onclick="claimLeadOwner_(\'' + idAttr + '\')">Claim</button>';
  h += '</div>';
  h += '<div id="lead-owner-msg" class="lead-owner-msg"></div>';
  h += '</div>';
  return h;
}

function leadOwner_afterRender_(c) {
  var sel = document.getElementById('lead-owner-select');
  if (!sel) return;
  var loadEl = document.getElementById('lead-owner-loading');
  function showSelect_() {
    if (loadEl) loadEl.style.display = 'none';
    sel.style.display = '';
    sel.removeAttribute('disabled');
    sel.removeAttribute('aria-busy');
  }
  function showFailed_() {
    if (loadEl) {
      loadEl.innerHTML = 'Couldn\'t load. <button class="btn btn-ghost btn-sm" type="button" onclick="leadOwner_afterRender_(_lastDrawerClient)">Retry</button>';
    }
    sel.style.display = 'none';
  }
  function showLoading_() {
    if (loadEl) {
      loadEl.style.display = '';
      loadEl.innerHTML = '<span class="mini-spinner"></span> Loading artists…';
    }
    sel.style.display = 'none';
    sel.setAttribute('disabled', 'disabled');
    sel.setAttribute('aria-busy', 'true');
  }
  function fill(list) {
    var cur = String(c.leadOwner || '').toLowerCase();
    var opts = '<option value="">Select artist...</option>';
    (list || []).forEach(function(a) {
      if (!a.email) return;
      var selAttr = (String(a.email).toLowerCase() === cur) ? ' selected' : '';
      opts += '<option value="' + escAttr(a.email) + '"' + selAttr + '>' + escHtml(a.name || a.email) + '</option>';
    });
    opts += '<option value="__clear__">Clear owner</option>';
    sel.innerHTML = opts;
    showSelect_();
  }
  if (_leadOwnerArtists) { fill(_leadOwnerArtists); return; }
  showLoading_();
  leadOwnerArtistsFetch_()
    .then(function(res) {
      if (!(res && res.ok && res.data && res.data.artists)) { showFailed_(); return; }
      _leadOwnerArtists = res.data.artists;
      fill(_leadOwnerArtists);
    })
    .catch(function() { showFailed_(); });
}

function assignLeadOwner_(clientId) {
  var c = _lastDrawerClient;
  if (!c || !c.email) { jvToast('No email on file for this client.', 'error'); return; }
  var sel = document.getElementById('lead-owner-select');
  var msg = document.getElementById('lead-owner-msg');
  if (!sel) return;
  var val = sel.value;
  var ownerEmail = (val === '__clear__' || val === '') ? '' : val;
  if (msg) msg.textContent = 'Saving...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_setLeadOwner', args: { email: c.email, ownerEmail: ownerEmail } })
    .then(function(res) {
      var data = res && res.data;
      if (res && res.ok && data && data.ok) {
        c.leadOwner = data.owner || '';
        c.leadOwnerName = data.ownerName || '';
        var cur = document.getElementById('lead-owner-current');
        if (cur) cur.textContent = data.owner ? (data.ownerName || data.owner) : 'Unassigned';
        if (msg) msg.textContent = data.message || 'Saved.';
        jvToast(data.message || 'Lead owner updated.', 'success');
      } else {
        var err = (data && data.error) || (res && res.error) || 'Save failed';
        if (msg) msg.textContent = String(err);
        jvToast(String(err), 'error');
      }
    })
    .catch(function(e) { if (msg) msg.textContent = String(e.message || e); jvToast('Save failed.', 'error'); });
}

function claimLeadOwner_(clientId) {
  var c = _lastDrawerClient;
  if (!c || !c.email) { jvToast('No email on file for this client.', 'error'); return; }
  var who = (window.jvAuth && window.jvAuth.email) ? String(window.jvAuth.email).trim().toLowerCase() : '';
  var msg = document.getElementById('lead-owner-msg');
  if (!who) { if (msg) msg.textContent = 'Could not identify the logged-in artist.'; jvToast('Could not identify you.', 'error'); return; }
  if (msg) msg.textContent = 'Claiming...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_claimLead', args: { email: c.email, claimantEmail: who } })
    .then(function(res) {
      var data = res && res.data;
      if (res && res.ok && data && data.ok) {
        if (data.claimed) {
          c.leadOwner = data.owner || who;
          c.leadOwnerName = data.ownerName || '';
          var cur = document.getElementById('lead-owner-current');
          if (cur) cur.textContent = c.leadOwnerName || c.leadOwner;
        }
        if (msg) msg.textContent = data.message || '';
        jvToast(data.message || 'Done.', data.claimed ? 'success' : 'info');
      } else {
        var err = (data && data.error) || (res && res.error) || 'Claim failed';
        if (msg) msg.textContent = String(err);
        jvToast(String(err), 'error');
      }
    })
    .catch(function(e) { if (msg) msg.textContent = String(e.message || e); jvToast('Claim failed.', 'error'); });
}

var ALL_CLIENT_CATEGORIES = ['Bridal', 'Non-Bridal', 'Vendor', 'Wedding Planner', 'Academy', 'Other'];
var _lastDrawerClient = null;

function openRecategorisePanel() {
  var c = _lastDrawerClient;
  if (!c) return;
  var existing = document.getElementById('recategorise-panel');
  if (existing) existing.remove();

  var panel = document.createElement('div');
  panel.id = 'recategorise-panel';
  panel.className = 'recategorise-overlay';
  panel.innerHTML =
    '<div class="recategorise-modal">' +
      '<div class="recategorise-header"><span>Change Category</span>' +
        '<button class="icon-btn" onclick="document.getElementById(\'recategorise-panel\').remove()">&#10005;</button>' +
      '</div>' +
      '<form id="recategorise-form" onsubmit="submitRecategorise(event,' + escAttr(String(c.id)) + ')">' +
        '<div class="acm-field">' +
          '<label>Category</label>' +
          '<select id="rcat-category">' +
            ALL_CLIENT_CATEGORIES.map(function(cat) {
              return '<option value="' + escAttr(cat) + '"' + (cat === c.category ? ' selected' : '') + '>' + escHtml(cat) + '</option>';
            }).join('') +
          '</select>' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Type</label>' +
          '<select id="rcat-type">' +
            '<option value="Individual"' + (c.contactType === 'Individual' || !c.contactType ? ' selected' : '') + '>Individual</option>' +
            '<option value="Business"'   + (c.contactType === 'Business'   ? ' selected' : '') + '>Business</option>' +
          '</select>' +
        '</div>' +
        '<div id="rcat-error" class="acm-error" style="display:none;"></div>' +
        '<div class="acm-actions">' +
          '<button type="button" class="btn btn-ghost" onclick="document.getElementById(\'recategorise-panel\').remove()">Cancel</button>' +
          '<button type="submit" class="btn btn-primary" id="rcat-submit">Save</button>' +
        '</div>' +
      '</form>' +
    '</div>';

  document.body.appendChild(panel);
  panel.addEventListener('click', function(e) { if (e.target === panel) panel.remove(); });
}

function submitRecategorise(e, clientId) {
  e.preventDefault();
  var category    = document.getElementById('rcat-category').value;
  var contactType = document.getElementById('rcat-type').value;
  var errEl = document.getElementById('rcat-error');
  errEl.style.display = 'none';

  var btn = document.getElementById('rcat-submit');
  btn.disabled = true; btn.textContent = 'Saving…';

  jvBridge.callAdmin('bridge_admin_recategoriseClient', { clientId: clientId, category: category, contactType: contactType, expectedEmail: jvExpectedEmailFor(clientId) })
    .then(function(res) {
      if (res.ok) {
        document.getElementById('recategorise-panel').remove();
        jvToast('Category updated.');
        openDrawer(clientId);
      } else {
        // CONTACT_TYPE column may not exist in all sheet deployments — treat as partial success
        // (CLIENT_CATEGORY update always runs first and saves successfully)
        var isContactTypeMissing = res.error && (res.error.indexOf('CONTACT_TYPE') !== -1 || res.error.indexOf('not found') !== -1);
        if (isContactTypeMissing) {
          document.getElementById('recategorise-panel').remove();
          jvToast('Category updated.');
          openDrawer(clientId);
        } else {
          errEl.textContent = res.error || 'Failed to save.';
          errEl.style.display = '';
          btn.disabled = false; btn.textContent = 'Save';
        }
      }
    })
    .catch(function(err) {
      errEl.textContent = 'Request failed.';
      errEl.style.display = '';
      btn.disabled = false; btn.textContent = 'Save';
    });
}

function confirmArchiveClient(clientId) {
  var clientName = (_lastDrawerClient && (_lastDrawerClient.name || _lastDrawerClient.firstName)) || 'this contact';
  var existing = document.getElementById('jv-archive-confirm-overlay');
  if (existing) existing.remove();
  var overlay = document.createElement('div');
  overlay.id = 'jv-archive-confirm-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.5);display:flex;align-items:center;justify-content:center;z-index:9999;';
  overlay.innerHTML =
    '<div style="background:var(--brand-bg-white,#fff);border-radius:1.5rem;padding:2rem;max-width:400px;width:90%;box-shadow:0 4px 24px rgba(47,37,36,0.12);">' +
      '<h3 style="font-family:Raleway,sans-serif;font-size:1.25rem;margin:0 0 0.75rem;color:var(--brand-dark,#1e1716);">Archive ' + escHtml(clientName) + '?</h3>' +
      '<p style="font-size:0.9rem;color:var(--brand-text,#2f2524);margin:0 0 1.5rem;line-height:1.5;">This will remove them from your active pipeline. You can find archived contacts under Stale Deals.</p>' +
      /* In-modal error slot (2026-10-28, Archive Contact silent-no-op fix): the
         original failure path relied ONLY on jvToast, which renders in
         #jv-toast-container at the SAME z-index (9999) as this overlay -- a
         later-appended element at an equal z-index paints on top and fully
         hides an earlier one, so any error toast fired while this overlay
         stays open (the deliberate retry-friendly behaviour on failure) was
         invisible to the admin, who saw only the button quietly revert from
         "Archiving..." back to "Archive" with no visible explanation. The
         toast container's z-index was ALSO raised (jv-admin-crm.css) as a
         system-wide belt-and-braces fix for every other modal with the same
         shape, but this in-modal slot (same pattern already used by the
         invoice confirm modal's #inv-create-send-result) is the primary,
         guaranteed-visible fix for THIS flow specifically -- it can never be
         covered by anything else since it lives inside the overlay itself. */
      '<div id="jv-archive-error" style="display:none;font-size:0.82rem;color:#9b2020;background:rgba(155,32,32,0.08);border-radius:0.75rem;padding:0.6rem 0.8rem;margin:0 0 1rem;line-height:1.4;"></div>' +
      '<div style="display:flex;gap:0.75rem;justify-content:flex-end;">' +
        '<button type="button" onclick="document.getElementById(\'jv-archive-confirm-overlay\').remove()" style="padding:0.6rem 1.25rem;border-radius:3rem;background:none;border:1px solid rgba(30,23,22,0.2);cursor:pointer;font-family:Plus Jakarta Sans,sans-serif;font-size:0.875rem;color:var(--brand-text,#2f2524);">Cancel</button>' +
        '<button type="button" id="jv-archive-confirm-btn" onclick="doArchiveClient(\'' + escAttr(String(clientId)) + '\')" style="padding:0.6rem 1.25rem;border-radius:3rem;background:var(--brand-dark,#1e1716);color:#fff;border:none;cursor:pointer;font-family:Plus Jakarta Sans,sans-serif;font-size:0.875rem;">Archive</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
}

// Archive Contact cutover gate (2026-10-29, Issue #1/#2, Sub-A1). false (default) = today's direct
// GAS archive (bridge_admin_archiveClient -> adminCrm_archiveClient). true = Cloudflare-native
// admin-archive-client relay entity ONLY, no GAS fallback (see DEPOLYMENT/jv-crm-mirror/admin-archive-client.mjs,
// behind ADMIN_ARCHIVE_CLIENT_CF_ENABLED, default OFF). Same cutover shape as JV_CANCEL_WEDDING_CF above.
var JV_ARCHIVE_CLIENT_CF = true;
function _jvArchiveClientProxy_(email) {
  var base = window._jvAdminProxyBase;
  if (!base) return Promise.resolve({ ok: false, error: 'proxy_unavailable' });
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-archive-client/archive';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ email: email, expectedEmail: email }) })
    .then(function (r) { return r.json(); })
    .catch(function () { return { ok: false, error: 'network_error' }; });
}
function doArchiveClient(clientId) {
  var btn = document.getElementById('jv-archive-confirm-btn');
  var errEl = document.getElementById('jv-archive-error');
  if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
  if (btn) { btn.disabled = true; btn.textContent = 'Archiving…'; }
  // The live Command Centre drawer keeps its hydrated record in
  // _lastDrawerClient, while jvExpectedEmailFor() only checks the legacy
  // STATE.drawerClient / STATE.clients stores. On a cold Command Centre open
  // those legacy stores can be empty, so Archive sent an empty identity and
  // the backend correctly refused the write. Resolve from the visible record
  // first, then retain the shared resolver as a fallback.
  var expectedEmail = '';
  if (_lastDrawerClient && String(_lastDrawerClient.id) === String(clientId)) {
    expectedEmail = String(_lastDrawerClient.email || _lastDrawerClient.EMAIL || '').trim().toLowerCase();
  }
  if (!expectedEmail) expectedEmail = jvExpectedEmailFor(clientId);
  if (!expectedEmail) {
    if (btn) { btn.disabled = false; btn.textContent = 'Archive'; }
    var identityMsg = 'Failed to archive: contact email is unavailable. Close and reopen the contact, then try again.';
    if (errEl) { errEl.textContent = identityMsg; errEl.style.display = ''; }
    jvToast(identityMsg, 'error');
    return;
  }
  var archivePromise = JV_ARCHIVE_CLIENT_CF
    ? _jvArchiveClientProxy_(expectedEmail)
    : jvBridge.callAdmin('bridge_admin_archiveClient', { clientId: clientId, expectedEmail: expectedEmail });
  archivePromise
    .then(function(res) {
      if (res && res.ok) {
        var modal = document.getElementById('jv-archive-confirm-overlay');
        if (modal) modal.remove();
        closeDrawer();
        jvToast('Contact archived.');
        var card = document.querySelector('[data-client-id="' + clientId + '"]');
        if (card) {
          var col = card.closest('.kanban-col');
          card.remove();
          if (col) updateColCounts();
        }
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Archive'; }
        var msg = 'Failed to archive: ' + ((res && res.error) || 'Unknown error');
        if (errEl) { errEl.textContent = msg; errEl.style.display = ''; }
        jvToast(msg, 'error');
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Archive'; }
      var msg = 'Request failed: ' + ((err && err.message) || 'network error');
      if (errEl) { errEl.textContent = msg; errEl.style.display = ''; }
      jvToast(msg, 'error');
    });
}

function estimateCompletion(c) {
  var milestones = ['email','phone','weddingDate','services','isBooked','hasProposal','hasRunsheet'];
  var done = 0;
  milestones.forEach(function(m) {
    if (c[m] && c[m] !== false) done++;
  });
  return Math.round((done / milestones.length) * 100);
}

function loadDrawerPane(pane, clientId, _attempt) {
  if (pane === 'timeline') loadDrawerTimeline(clientId);
  else if (pane === 'proposals') loadDrawerProposals(clientId);
  else if (pane === 'invoices') loadDrawerInvoices(clientId);
  else if (pane === 'runsheet') loadDrawerRunsheet(clientId);
  else if (pane === 'forms') loadDrawerForms(clientId);
  // 'portal-preview' pane RETIRED 2026-07-31 (Jess). The tab + pane are removed from the
  // liquid so this branch is unreachable; loadDrawerPortalPreview + renderPortalPreview +
  // the standalone Client Portal Preview view are kept ARCHIVED (dead code, no caller) in
  // case we revive it later from the bride_profile_cache CDN instead of a live hub build.
  else if (pane === 'onboard-progress') loadDrawerOnboardingProgress(clientId);
  else if (pane === 'profitability') loadDrawerProfitability(clientId);
  else if (pane === 'party-members') loadDrawerPartyMembers(clientId);
  // Arm the spinner-forever watchdog for the heavy lazy panes (item 4).
  if (_LAZY_DRAWER_PANES_[pane]) _armTabWatchdog_(pane, clientId, _attempt || 1);
}

/* ============================================================
   ONBOARDING PROGRESS — drawer tab (JV-BRIDE-ONBOARD widget)
   Injected at runtime so the frozen jv-admin-crm.liquid section is untouched.
   ============================================================ */
function ensureOnboardProgressTab_() {
  if (document.getElementById('drawer-pane-onboard-progress')) return;
  var tabs = document.querySelector('#detail-drawer .drawer-tabs');
  var paneHost = document.querySelector('#detail-drawer .drawer-tabs') ? document.querySelector('#detail-drawer') : null;
  if (!tabs || !paneHost) return;

  // Tab: insert after Overview tab so Progress sits next to it.
  var overviewTab = tabs.querySelector('.drawer-tab[data-pane="overview"]');
  var newTab = document.createElement('div');
  newTab.className = 'drawer-tab';
  newTab.setAttribute('data-pane', 'onboard-progress');
  newTab.setAttribute('onclick', "switchDrawerTab('onboard-progress', this)");
  newTab.textContent = 'Progress';
  if (overviewTab && overviewTab.nextSibling) tabs.insertBefore(newTab, overviewTab.nextSibling);
  else tabs.appendChild(newTab);

  // Pane: same level as the existing drawer-pane elements, appended after the last one.
  var lastPane = paneHost.querySelector('.drawer-pane:last-of-type');
  var pane = document.createElement('div');
  pane.id = 'drawer-pane-onboard-progress';
  pane.className = 'drawer-pane';
  pane.innerHTML = '<div id="drawer-onboard-progress-content"></div>';
  if (lastPane && lastPane.parentNode) lastPane.parentNode.insertBefore(pane, lastPane.nextSibling);
  else paneHost.appendChild(pane);
}

function loadDrawerOnboardingProgress(clientId) {
  ensureOnboardProgressTab_();
  var mount = document.getElementById('drawer-onboard-progress-content');
  if (!mount) return;
  mount.innerHTML = '<div class="jv-bride-onboard__skeleton">Loading progress…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    if (b && b.onboardingProgress && b.onboardingProgress.ok && b.onboardingProgress.bride) {
      mount.innerHTML = renderBrideOnboardProgressHtml_(b.onboardingProgress.bride);
      return;
    }
    _loadDrawerOnboardingProgress_legacy(clientId);
  });
}

function _loadDrawerOnboardingProgress_legacy(clientId) {
  var mount = document.getElementById('drawer-onboard-progress-content');
  if (!mount) return;
  var email = (_lastDrawerClient && _lastDrawerClient.email) ? String(_lastDrawerClient.email).trim().toLowerCase() : '';
  if (!email) {
    mount.innerHTML = '<p class="jv-bride-onboard__error">No email on this client — onboarding progress unavailable.</p>';
    return;
  }
  jvBridge.callAdmin('bridge_admin_getBrideOnboardingProgress', { email: email })
    .then(function(res) {
      if (!res || !res.ok || !res.bride) {
        var msg = (res && res.error) ? String(res.error) : 'Couldn\'t load progress.';
        mount.innerHTML = '<p class="jv-bride-onboard__error">' + escHtml(msg) + '</p>';
        return;
      }
      mount.innerHTML = renderBrideOnboardProgressHtml_(res.bride);
    })
    .catch(function(err) {
      mount.innerHTML = '<p class="jv-bride-onboard__error">' + escHtml(String(err && err.message || err)) + '</p>';
    });
}

function brideOnboard_signalState_(score, max) {
  if (!score || score <= 0) return 'empty';
  if (score >= max) return 'complete';
  return 'partial';
}

function brideOnboard_trialLine_(trial) {
  if (!trial) return '';
  var req = String(trial.required || '').toLowerCase();
  if (req === 'no' || req === 'opted_out') return 'Trial: not required';
  if (trial.date) return 'Trial: booked ' + escHtml(String(trial.date));
  if (req === 'yes' || req === 'y') return 'Trial: required, not yet booked';
  return 'Trial: (unset)';
}

function brideOnboard_fieldRow_(label, ok) {
  return '<li class="jv-bride-onboard__field" data-ok="' + (ok ? '1' : '0') + '">'
    + '<span class="jv-bride-onboard__field-mark" aria-hidden="true"></span>'
    + '<span class="jv-bride-onboard__field-label">' + escHtml(label) + '</span>'
    + '</li>';
}

function brideOnboard_signalGroup_(label, score, max, fieldsHtml, valueOverride) {
  var state = brideOnboard_signalState_(score, max);
  var valueText = valueOverride || (score + '/' + max);
  return '<section class="jv-bride-onboard__signal-group" data-state="' + state + '">'
    + '<header class="jv-bride-onboard__signal-head">'
    +   '<span class="jv-bride-onboard__signal-label">' + escHtml(label) + '</span>'
    +   '<span class="jv-bride-onboard__signal-value">' + escHtml(valueText) + '</span>'
    + '</header>'
    + '<ul class="jv-bride-onboard__fields">' + fieldsHtml + '</ul>'
    + '</section>';
}

function renderBrideOnboardProgressHtml_(b) {
  var visionMax = 4, briefMax = 4, dreamMax = 5, picMax = 1, partyMax = 5;
  var visionScore = (b.vision && b.vision.score) || 0;
  var briefScore  = (b.brief  && b.brief.score)  || 0;
  var dreamCount  = (b.dreamTeam && b.dreamTeam.count) || 0;
  var dreamScore  = Math.min(dreamCount, dreamMax);
  var dreamRoles  = (b.dreamTeam && b.dreamTeam.roles) || [];
  var partyTotal  = (b.party && b.party.total) || 0;
  var partyDone   = (b.party && b.party.completed) || 0;
  var partyProg   = (b.party && b.party.inProgress) || 0;
  var partyNotSent= (b.party && b.party.notSent) || 0;
  var partyScore  = partyTotal > 0 ? Math.min(partyDone, partyMax) : 0;
  var picScore    = b.profilePic ? 1 : 0;

  var pct = Math.max(0, Math.min(100, parseInt(b.overallPct, 10) || 0));

  // Badge only when actually fully onboarded by signal completion — not just the operational flag.
  var onboardedBadge = (pct === 100)
    ? '<span class="jv-bride-onboard__badge">Fully onboarded</span>'
    : '';

  var visionFlags = (b.vision && b.vision.flags) || {};
  var briefFlags  = (b.brief  && b.brief.flags)  || {};

  // Vision Profile
  var visionFields = ''
    + brideOnboard_fieldRow_('Partner name',  !!visionFlags.partner)
    + brideOnboard_fieldRow_('Vision words',  !!visionFlags.visionWords)
    + brideOnboard_fieldRow_('Beauty notes',  !!visionFlags.beautyNotes)
    + brideOnboard_fieldRow_('Profile saved', !!visionFlags.completedAt);

  // Beauty Brief
  var briefFields = ''
    + brideOnboard_fieldRow_('Hairstyle preference', !!briefFlags.hairstyle)
    + brideOnboard_fieldRow_('Makeup vibe',          !!briefFlags.makeupVibe)
    + brideOnboard_fieldRow_('Hair situation',       !!briefFlags.hairSit)
    + brideOnboard_fieldRow_('Makeup situation',     !!briefFlags.makeupSit);

  // Dream Team — show top 5 standard vendor roles + count of any extras
  var dreamRoleLabels = {
    photographer: 'Photographer', videographer: 'Videographer', planner: 'Planner',
    florist: 'Florist', dress: 'Dress', venue: 'Venue', celebrant: 'Celebrant',
    cake: 'Cake', catering: 'Catering'
  };
  var dreamRolesShown = ['photographer','videographer','planner','florist','venue'];
  var dreamFields = dreamRolesShown.map(function(role) {
    return brideOnboard_fieldRow_(dreamRoleLabels[role], dreamRoles.indexOf(role) !== -1);
  }).join('');
  var dreamValueText = dreamScore + '/' + dreamMax + (dreamCount > dreamMax ? ' (+' + (dreamCount - dreamMax) + ' more)' : '');

  // Profile Pic
  var picFields = brideOnboard_fieldRow_('Photo uploaded', !!b.profilePic);

  // Bridal Party — show breakdown of member completion buckets
  var partyFields = '';
  var partyValueText;
  if (partyTotal === 0) {
    partyFields = brideOnboard_fieldRow_('No party members added yet', false);
    partyValueText = '0/' + partyMax;
  } else {
    partyFields = ''
      + brideOnboard_fieldRow_(partyDone + ' of ' + partyTotal + ' completed forms', partyDone > 0 && partyDone === partyTotal)
      + brideOnboard_fieldRow_(partyProg + ' form' + (partyProg === 1 ? '' : 's') + ' in progress', partyProg === 0)
      + brideOnboard_fieldRow_(partyNotSent + ' form' + (partyNotSent === 1 ? '' : 's') + ' not sent', partyNotSent === 0);
    partyValueText = Math.min(partyDone, partyMax) + '/' + partyMax
      + (partyTotal > partyMax ? ' (' + partyTotal + ' members)' : '');
  }

  var trialHtml = brideOnboard_trialLine_(b.trial);

  return ''
    + '<section class="jv-bride-onboard">'
    +   '<header class="jv-bride-onboard__header">'
    +     '<div class="jv-bride-onboard__title-wrap">'
    +       '<h3 class="jv-bride-onboard__title">Onboarding</h3>'
    +       onboardedBadge
    +     '</div>'
    +     '<span class="jv-bride-onboard__pct" aria-label="Overall completeness">' + pct + '%</span>'
    +   '</header>'
    +   '<div class="jv-bride-onboard__bar" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100">'
    +     '<div class="jv-bride-onboard__bar-fill" style="width:' + pct + '%"></div>'
    +   '</div>'
    +   brideOnboard_signalGroup_('Vision Profile', visionScore, visionMax, visionFields)
    +   brideOnboard_signalGroup_('Beauty Brief',   briefScore,  briefMax,  briefFields)
    +   brideOnboard_signalGroup_('Dream Team',     dreamScore,  dreamMax,  dreamFields, dreamValueText)
    +   brideOnboard_signalGroup_('Profile Pic',    picScore,    picMax,    picFields)
    +   brideOnboard_signalGroup_('Bridal Party',   partyScore,  partyMax,  partyFields, partyValueText)
    +   (trialHtml ? '<p class="jv-bride-onboard__trial">' + trialHtml + '</p>' : '')
    + '</section>';
}

var FORM_TYPE_CONFIG = {
  bridal_enquiry:   { label: 'Bridal Enquiry',    accent: 'var(--brand-primary)' },
  vision_profile:   { label: 'Vision Profile',    accent: '#9B7E2E' },
  inspiration:      { label: 'Inspiration Upload', accent: '#7a6222' },
  trial_feedback:   { label: 'Trial Feedback',     accent: 'var(--brand-primary-deep)' },
  runsheet_signoff: { label: 'Runsheet Sign-off',  accent: '#1f6b46' },
  trial_assist:     { label: 'Trial Prep Notes',   accent: '#5c9bd9' },
  contact_enquiry:  { label: 'Contact Enquiry',    accent: '#8a2068' },
  onboarding:       { label: 'Guest Onboarding',   accent: '#1a5fa3' }
};

function loadDrawerForms(clientId, bust) {
  var el = document.getElementById('drawer-forms-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading forms…</div>';
  // bust=true means user clicked Refresh — always hit GAS fresh.
  if (!bust) {
    return getDrawerBundle_(clientId).then(function(b) {
      if (b && _bundleSectionReady_(b.forms)) {
        if (!ADMIN_TRIAL_FEEDBACK_D1_ENABLED_) { renderDrawerForms(b.forms, clientId); return; }
        var _bem = jvExpectedEmailFor(clientId);
        (_bem ? tfD1Fetch_({ email: _bem, limit: 50 }) : Promise.resolve(null)).then(function (items) {
          var _bc = (typeof findClientById === 'function' ? findClientById(clientId) : null) || {};
          var merged = Object.assign({}, b.forms, { forms: tfMergeForms_(b.forms.forms, items === null ? null : tfToDrawerForms_(items, _bc.name || ''), false) });
          renderDrawerForms(merged, clientId);
        });
        return;
      }
      _loadDrawerForms_legacy(clientId, false);
    });
  }
  _loadDrawerForms_legacy(clientId, true);
}

/* Trial feedback from D1 (Stage 2, 2026-10-06). Replaces the Apps Script readers of the "Trial Feedback
   Form" Sheet (Forms Inbox, per-bride form submissions, journey step) with the relay route
   bridge_admin_trialFeedbackList (D1 trial_feedback, jv-d1-health GET /feedback). Flag OFF. When ON:
   GAS still answers every OTHER form type; its trial_feedback entries are DROPPED and replaced by the D1
   ones. If the D1 call fails, the GAS entries are kept (fallback) until D1 is proven the only source
   (5e's one-shot backfill of the old Sheet rows must be verified first, see the turn-on brief).
   Photos: R2 keys are signed through bridge_admin_trialFeedbackPhotoUrl (5-minute URLs; Refresh re-signs);
   Sheet-era Drive URLs open directly. The inbox hides closed/Completed/Archived brides SERVER-side
   (activeOnly:true). Remaining GAS/Sheets dependency: the GAS replay still writes the Sheet. */
var ADMIN_TRIAL_FEEDBACK_D1_ENABLED_ = false;
function tfD1Fetch_(payload) {
  if (!ADMIN_TRIAL_FEEDBACK_D1_ENABLED_ || typeof jvBridge === 'undefined') return Promise.resolve(null);
  return jvBridge.callAdmin('bridge_admin_trialFeedbackList', payload).then(function (res) {
    var items = res && (res.items || (res.data && res.data.items));
    if (!(res && (res.ok === true || (res.data && res.data.ok === true)) && Array.isArray(items))) return null;
    return tfSignPhotos_(items).then(function () { return items; });
  }).catch(function () { return null; });
}
// Photos: D1 holds R2 keys (private bucket). Ask the relay for 5-minute signed URLs, <=10 keys per call. Sheet-era
// photos arrive as Drive URLs and need no signing. Sets it._files (URL strings). A signing failure leaves _files
// empty for that item and the photo COUNT is still shown; it never fails the list.
function tfSignPhotos_(items) {
  var jobs = [];
  (items || []).forEach(function (it) {
    it._files = [];
    var keys = [];
    (it.photos || []).forEach(function (ph) {
      var k = (ph && typeof ph === 'object') ? (ph.url || ph.key) : ph;
      k = String(k || '');
      if (/^https?:\/\//i.test(k)) it._files.push(k);          // Drive URL (Sheet era)
      else if (/^trial-feedback\//.test(k)) keys.push(k);        // R2 key, needs a signed URL
    });
    for (var i = 0; i < keys.length; i += 10) {
      (function (chunk) {
        jobs.push(jvBridge.callAdmin('bridge_admin_trialFeedbackPhotoUrl', { keys: chunk }).then(function (r) {
          var got = r && (r.items || (r.data && r.data.items));
          (got || []).forEach(function (g) { if (g && g.url) it._files.push(g.url); });
        }).catch(function () {}));
      })(keys.slice(i, i + 10));
    }
  });
  return Promise.all(jobs);
}
/* Signed photo URLs expire after 5 minutes (relay bridge_admin_trialFeedbackPhotoUrl). Belt and braces so an
   admin never lands on a dead link or a broken thumbnail:
   (1) a click on a signed "File N" link whose URL is expired or within 15s of expiry is intercepted, a tab is
       opened synchronously (so the popup blocker allows it), the key is re-signed, and the tab is pointed at the
       fresh URL; the link's href is refreshed too;
   (2) any <img> that fails to load from a signed URL is re-signed ONCE (data-tf-resigned) and retried.
   Rate limit: one re-sign per key per 20s (result reused), max 3 in flight. A failure closes the blank tab and
   toasts; it never throws. */
var _tfResignCache_ = {};
var _tfResignInflight_ = 0;
function tfParseSigned_(url) {
  try {
    var u = new URL(String(url || ''), 'https://x.invalid');
    if (u.pathname.slice(-6) !== '/photo') return null;
    var key = u.searchParams.get('key'), exp = parseInt(u.searchParams.get('exp'), 10);
    if (!key || !/^trial-feedback\//.test(key) || !u.searchParams.get('sig') || !(exp > 0)) return null;
    return { key: key, exp: exp };
  } catch (e) { return null; }
}
function tfSignedNeedsResign_(url, nowMs, marginMs) {
  var p = tfParseSigned_(url);
  return !!p && (p.exp * 1000 - nowMs) < (marginMs == null ? 15000 : marginMs);
}
function tfResignKey_(key, nowMs) {
  var c = _tfResignCache_[key];
  if (c && (nowMs - c.at) < 20000) return c.promise; // rate limit: reuse a recent result
  if (_tfResignInflight_ >= 3) return Promise.resolve(null);
  _tfResignInflight_++;
  var pr = jvBridge.callAdmin('bridge_admin_trialFeedbackPhotoUrl', { keys: [key] }).then(function (r) {
    var got = r && (r.items || (r.data && r.data.items));
    return (got && got[0] && got[0].url) ? got[0].url : null;
  }).catch(function () { return null; }).then(function (u) { _tfResignInflight_--; if (!u) delete _tfResignCache_[key]; return u; });
  _tfResignCache_[key] = { at: nowMs, promise: pr };
  return pr;
}
function tfInstallResignHandlers_() {
  if (typeof document === 'undefined' || document._tfResignInstalled) return;
  document._tfResignInstalled = true;
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a || !tfSignedNeedsResign_(a.getAttribute('href'), Date.now(), 15000)) return;
    var p = tfParseSigned_(a.getAttribute('href'));
    ev.preventDefault(); ev.stopPropagation();
    var w = null; try { w = window.open('about:blank', '_blank'); } catch (e) {}
    tfResignKey_(p.key, Date.now()).then(function (url) {
      if (!url) { try { if (w) w.close(); } catch (e) {} if (typeof jvToast === 'function') jvToast('Could not refresh that photo link. Press Refresh and try again.', 'error'); return; }
      a.setAttribute('href', url);
      if (w) { try { w.location.href = url; } catch (e) {} } else { window.location.href = url; }
    });
  }, true);
  document.addEventListener('error', function (ev) {
    var im = ev.target;
    if (!im || im.tagName !== 'IMG' || im.getAttribute('data-tf-resigned')) return;
    var p = tfParseSigned_(im.getAttribute('src'));
    if (!p) return;
    im.setAttribute('data-tf-resigned', '1'); // once per element
    tfResignKey_(p.key, Date.now()).then(function (url) { if (url) im.setAttribute('src', url); });
  }, true);
}
tfInstallResignHandlers_();

function tfItemFields_(it) {
  var f = [
    { label: 'Overall Rating', value: it.rating != null ? String(it.rating) : '' },
    { label: 'Makeup Feedback', value: it.muFeedback || '' },
    { label: 'Makeup Changes Requested', value: it.muChanges || '' },
    { label: 'Hair Feedback', value: it.hairFeedback || '' },
    { label: 'Hair Changes Requested', value: it.hairChanges || '' },
    { label: 'Additional Notes', value: it.notes || '' },
    { label: 'Would Recommend', value: it.recommend || '' },
    // The count only shows when no viewable files came back (signing failed / not configured).
    { label: 'Photos', value: (it.photoCount && !(it._files && it._files.length)) ? (it.photoCount + (it.photoCount === 1 ? ' photo uploaded' : ' photos uploaded')) : '' },
    { label: 'Source', value: it.source || '' }
  ];
  return f.filter(function (x) { return !!x.value; });
}
// Drawer / task-panel shape (adminCrm_getFormSubmissions).
function tfToDrawerForms_(items, submitter) {
  return (items || []).map(function (it) {
    return { type: 'trial_feedback', label: 'Trial Feedback', submittedAt: it.submittedAt || '', submitter: submitter || '', fields: tfItemFields_(it), files: (it._files || []).slice() };
  });
}
// Inbox shape (adminCrm_getAllFormSubmissions).
function tfToInboxForms_(items) {
  return (items || []).map(function (it) {
    return { type: 'trial_feedback', label: 'Trial Feedback', submittedAt: it.submittedAt || '',
             submitterName: it.email || '', submitterEmail: String(it.email || '').toLowerCase(), fields: tfItemFields_(it), files: (it._files || []).slice() };
  });
}
function tfPatchJourney_(journey) {
  ((journey && journey.steps) || []).forEach(function (st) {
    if (st && st.name === 'Trial Feedback Form' && st.status !== 'skipped' && st.status !== 'completed') { st.status = 'completed'; st.detail = 'Submitted'; }
  });
}
// Replace every GAS trial_feedback entry with the D1 ones. d1Forms === null means the D1 call failed: keep GAS.
function tfMergeForms_(gasForms, d1Forms, newestFirst) {
  if (d1Forms === null || d1Forms === undefined) return gasForms || [];
  var kept = (gasForms || []).filter(function (f) { return f && f.type !== 'trial_feedback'; });
  var out = kept.concat(d1Forms);
  if (newestFirst) out.sort(function (a, b) { return String(b.submittedAt || '').localeCompare(String(a.submittedAt || '')); });
  return out;
}

function _loadDrawerForms_legacy(clientId, bust) {
  var el = document.getElementById('drawer-forms-content');
  // Identity guard (2026-09-01): always send id + expectedEmail as an object
  // (was a bare clientId in the non-bust case), matching the pattern used
  // everywhere else in this file, see the journey call above.
  var args = { id: clientId, expectedEmail: jvExpectedEmailFor(clientId) };
  if (bust) args.bust = true;
  var _tfEmail = jvExpectedEmailFor(clientId);
  var _tfP = _tfEmail ? tfD1Fetch_({ email: _tfEmail, limit: 50 }) : Promise.resolve(null);
  Promise.all([jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getFormSubmissions', args: args }), _tfP])
    .then(function(pair) {
      var res = pair[0];
      if (res.ok && res.data && ADMIN_TRIAL_FEEDBACK_D1_ENABLED_) {
        var _dc = (typeof findClientById === 'function' ? findClientById(clientId) : null) || {};
        res.data.forms = tfMergeForms_(res.data.forms, pair[1] === null ? null : tfToDrawerForms_(pair[1], _dc.name || ''), false);
      }
      if (res.ok) { renderDrawerForms(res.data, clientId); }
      else { el.innerHTML = '<div class="alert danger">' + escHtml(String(res.error || 'Failed to load')) + '</div>'; }
    })
    .catch(function(err) { el.innerHTML = '<div class="alert danger">' + escHtml(String(err)) + '</div>'; });
}

function renderDrawerForms(data, clientId) {
  var el = document.getElementById('drawer-forms-content');
  var forms = (data && data.forms) || [];

  var refreshBtn = '<div style="display:flex;justify-content:flex-end;margin-bottom:0.5rem;">'
    + '<button class="btn btn-ghost" style="font-size:0.67rem;padding:0.18rem 0.6rem;" '
    + 'onclick="loadDrawerForms(' + parseInt(clientId, 10) + ', true)">↻ Refresh</button></div>';

  if (forms.length === 0) {
    el.innerHTML = refreshBtn + '<div class="empty-state"><p>No form submissions on record for this client.</p></div>';
    return;
  }

  var html = refreshBtn;
  var _fdIdx = 0;
  forms.forEach(function(sub) {
    var key = 'fd_' + (_fdIdx++);
    _formSubModal[key] = sub;
    var cfg = FORM_TYPE_CONFIG[sub.type] || { label: sub.label || sub.type, accent: 'var(--brand-primary)' };
    var accent = cfg.accent;
    var dateStr = sub.submittedAt ? formatDate(sub.submittedAt) : '';

    html += '<div style="border:1px solid #e6dad4;border-radius:var(--radius-medium);margin-bottom:0.75rem;overflow:hidden;">';

    // Card header
    html += '<div style="background:' + accent + '1a;border-bottom:1px solid #e6dad4;padding:0.55rem 0.85rem;display:flex;align-items:center;justify-content:space-between;gap:0.5rem;">';
    html += '<div style="display:flex;align-items:center;gap:0.5rem;">';
    html += '<span style="font-size:0.74rem;font-weight:700;color:' + accent + ';letter-spacing:0.01em;">' + escHtml(cfg.label) + '</span>';
    if (sub.submitter) html += '<span style="font-size:0.7rem;color:var(--muted);">' + escHtml(sub.submitter) + '</span>';
    html += '</div>';
    html += '<div style="display:flex;align-items:center;gap:0.4rem;">';
    if (dateStr) html += '<span style="font-size:0.68rem;color:var(--muted);white-space:nowrap;">' + escHtml(dateStr) + '</span>';
    html += '<button class="btn btn-ghost" style="font-size:0.65rem;padding:0.15rem 0.5rem;" onclick="openFormSubmissionModal(\'' + key + '\')">View Full ↗</button>';
    html += '</div></div>';

    // Card body — preview (first 3 fields)
    if (sub.fields && sub.fields.length) {
      html += '<div style="padding:0.55rem 0.85rem;">';
      html += '<dl style="margin:0 0 0.35rem;display:grid;grid-template-columns:auto 1fr;gap:0.1rem 0.7rem;">';
      sub.fields.slice(0, 3).forEach(function(f) {
        html += '<dt style="font-size:0.7rem;font-weight:600;color:var(--brand-text);white-space:nowrap;padding:0.1rem 0;">' + escHtml(f.label) + '</dt>';
        html += '<dd style="font-size:0.71rem;color:var(--brand-text);margin:0;padding:0.1rem 0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:260px;">' + escHtml(f.value) + '</dd>';
      });
      html += '</dl>';
      if (sub.fields.length > 3) html += '<div style="font-size:0.67rem;color:var(--muted);">+ ' + (sub.fields.length - 3) + ' more — click View Full</div>';
      var validFiles = (sub.files || []).filter(function(u) { return /^https?:\/\//i.test(u); });
      if (validFiles.length) {
        html += '<div style="display:flex;flex-wrap:wrap;gap:0.3rem;margin-top:0.4rem;">';
        validFiles.forEach(function(url, idx) {
          html += '<a href="' + escHtml(url) + '" target="_blank" rel="noopener" class="btn btn-ghost" style="font-size:0.67rem;padding:0.18rem 0.5rem;" onclick="event.stopPropagation();">File ' + (idx + 1) + ' ↗</a>';
        });
        html += '</div>';
      }
      html += '</div>';
    }

    html += '</div>';
  });

  el.innerHTML = html;
}

var _drawerSocialLinks = { instagram: null, facebook: null };

function loadDrawerTimeline(clientId) {
  var el = document.getElementById('drawer-timeline-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading timeline…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    // Comms log is a heavy section omitted from the lite open bundle. Only render
    // from the bundle once it's actually loaded; otherwise lazy-load via legacy
    // (which also re-fetches the lightweight journey + social links).
    if (b && _bundleSectionReady_(b.commsLog)) {
      var journeyData = (b.journey && !b.journey.error) ? b.journey : { steps: [] };
      var commsData   = Array.isArray(b.commsLog) ? b.commsLog : [];
      _drawerSocialLinks = (b.socialLinks && !b.socialLinks.error) ? b.socialLinks : { instagram: null, facebook: null };
      try { _commsUpdateChannelOptions_(); } catch(_) {}
      renderDrawerTimelineFull(journeyData, commsData);
      return;
    }
    _loadDrawerTimeline_legacy(clientId);
  });
}

function _renderDrawerTimelineRetry_(clientId) {
  var el = document.getElementById('drawer-timeline-content');
  if (!el) return;
  var h = '';
  h += '<div class="empty-state" style="text-align:center;">';
  h += '<p style="font-weight:600;margin-bottom:0.25rem;">We couldn\'t load this just now.</p>';
  h += '<p style="margin-bottom:0.9rem;">Give it a moment and try again.</p>';
  h += '<button class="btn btn-ghost btn-sm" type="button" onclick="loadDrawerTimeline(\'' + escAttr(String(clientId)) + '\')">Retry</button>';
  h += '</div>';
  el.innerHTML = h;
}

/* D1 first paint for the drawer comms history (2026-10-06, Step 3, Consolidator-approved).
   Flag OFF. When ON, the comms list paints from the D1 comms_log mirror (relay entity
   'admin-comms' action 'timeline', same rows jv-comms.js and v6 read) while the Apps Script
   timeline is still cold-starting; the Apps Script result then ALWAYS re-renders over it, so
   the drawer ends on the complete answer. D1 comms_log starts 1 April 2026 and lacks
   open_count/gmail_thread_id, which is exactly why Apps Script still completes the render
   (no history is ever lost, only shown late). Never a final state. Do NOT flip until a jfg
   capture shows D1 rows render identically (fields used: timestamp, channel, direction,
   subject, body_snippet, body_full, source, logged_by, triggered_by). */
var ADMIN_COMMS_D1_FIRSTPAINT_ENABLED_ = false;
function adminCommsD1Timeline_(email) {
  var base = window._jvAdminProxyBase;
  if (!ADMIN_COMMS_D1_FIRSTPAINT_ENABLED_ || !base || !email) return Promise.resolve(null);
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/partner/admin-comms/timeline', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ brideEmail: email, limit: 200 })
  }).then(function(r) { return r.json(); })
    .then(function(b) { return (b && b.ok === true && Array.isArray(b.data)) ? b.data : null; })
    .catch(function() { return null; });
}

function _loadDrawerTimeline_legacy(clientId) {
  // Primary content (journey + comms) drives whether the pane renders. If either
  // primary call fails, we show a warm retryable state rather than a blank or a
  // misleading "no history". Social links are non-critical and degrade quietly.
  var pending = 2, journeyData = null, commsData = null, primaryFailed = false, gasDone = false;
  adminCommsD1Timeline_(jvExpectedEmailFor(clientId)).then(function(rows) {
    // Paint only if Apps Script has not already finished, and D1 has something to show;
    // an empty D1 answer never paints "no comms" (Apps Script may hold older history).
    if (gasDone || !rows || !rows.length) return;
    renderDrawerTimelineFull(null, rows, { journeyPending: true });
  });
  function tryRender() {
    pending--;
    if (pending > 0) return;
    gasDone = true;
    if (primaryFailed) { _renderDrawerTimelineRetry_(clientId); return; }
    renderDrawerTimelineFull(journeyData, commsData);
  }
  // Identity guard (2026-09-01): pass the bride's email so a drifted clientId
  // (row number shifted by an archive/delete/re-sort since this drawer was
  // opened) re-resolves to the correct row instead of silently reading whoever
  // now occupies that row number. Matches the pattern already used on every
  // WRITE call in this file (jvExpectedEmailFor).
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientJourney', args: { clientId: clientId, expectedEmail: jvExpectedEmailFor(clientId) } })
    .then(function(res) {
      if (!res.ok) { primaryFailed = true; tryRender(); return; }
      journeyData = res.data;
      // Trial Feedback step (Stage 2): GAS read the Sheet; if D1 holds a feedback record, mark it completed.
      // Upgrade only (never downgrade), so a Sheet row missing from D1 can never un-complete the step.
      var _jem = jvExpectedEmailFor(clientId);
      if (!ADMIN_TRIAL_FEEDBACK_D1_ENABLED_ || !_jem) { tryRender(); return; }
      tfD1Fetch_({ email: _jem, limit: 1 }).then(function (items) {
        if (items && items.length) tfPatchJourney_(journeyData);
        tryRender();
      });
    })
    .catch(function() { primaryFailed = true; tryRender(); });
  // FIXED 2026-09-25 (URGENT, Consolidator-directed): this route's payload
  // shape did not match what the GAS side expects -- bridge_admin_getCommsLog
  // reads payload.email, but this sent a bare clientId (a number). GAS's own
  // shopifyBridge_adminGetCommsLog only reads payload.email, so a bare
  // number's .email is undefined, sanitised to '', and adminCrm_getCommsLog
  // early-returns [] the instant brideEmail resolves empty. Confirmed live
  // impact: EVERY drawer open showed "No communications logged yet" for
  // EVERY bride, silently, no error -- this was not an edge case, it was the
  // only path, always empty. Fix: send { email } using the same
  // jvExpectedEmailFor(clientId) resolver the identity-guarded journey call
  // right above already uses.
  jvBridge.callAdmin('bridge_admin_getCommsLog', { email: jvExpectedEmailFor(clientId) })
    .then(function(res) { if (res.ok) { commsData = res.data; } else { primaryFailed = true; } tryRender(); })
    .catch(function() { primaryFailed = true; tryRender(); });
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getSocialLinks', args: clientId })
    .then(function(res) { if (res.ok) { _drawerSocialLinks = res.data || { instagram: null, facebook: null }; try { _commsUpdateChannelOptions_(); } catch(_) {} } else { _drawerSocialLinks = { instagram: null, facebook: null }; } })
    .catch(function() { _drawerSocialLinks = { instagram: null, facebook: null }; });
}

function renderDrawerTimelineFull(journey, commsEntries, opts) {
  var el = document.getElementById('drawer-timeline-content');
  var html = '';

  // ── Section 1: Journey Progress ──
  html += '<div class="journey-section">';
  html += '<div class="journey-section-title">Journey</div>';
  var steps = (journey && journey.steps) || [];
  if (steps.length === 0 && opts && opts.journeyPending) {
    html += '<div class="empty-state"><p>Loading journey…</p></div>';
  } else if (steps.length === 0) {
    html += '<div class="empty-state"><p>No journey data available.</p></div>';
  } else {
    html += '<div class="journey-stepper">';
    steps.forEach(function(step) {
      var cls = step.status || 'pending';
      html += '<div class="journey-step ' + escHtml(cls) + '">';
      html += '<div class="journey-step-dot">';
      html += '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
      html += '</div>';
      html += '<div>';
      html += '<div class="journey-step-label">' + escHtml(step.name) + '</div>';
      if (step.detail) html += '<div class="journey-step-detail">' + escHtml(step.detail) + '</div>';
      html += '</div>';
      if (step.date) {
        var dateDisplay = formatJourneyDate_(step.date);
        html += '<div class="journey-step-date">' + escHtml(dateDisplay) + '</div>';
      }
      html += '</div>';
    });
    html += '</div>';
  }
  html += '</div>';

  // ── Divider ──
  html += '<hr class="comms-divider">';

  // ── Section 2: Comms Workflow ──
  html += '<div class="comms-section">';
  html += '<div class="comms-filter-row">';
  html += '<div class="journey-section-title" style="margin-bottom:0">Comms Workflow</div>';
  html += '<div style="display:flex;gap:0.4rem;align-items:center;flex-wrap:wrap;">';
  html += '<select class="comms-filter-select" id="comms-filter-channel" onchange="filterCommsWorkflow()">';
  html += '<option value="all">All</option>';
  html += '<option value="email">Email</option>';
  html += '<option value="sms">SMS</option>';
  html += '<option value="chat">Chat</option>';
  html += '<option value="social">Social</option>';
  html += '<option value="system">System</option>';
  html += '</select>';
  html += '<button class="btn btn-ghost" style="font-size:0.7rem;padding:0.2rem 0.5rem;" onclick="sendCommsMessage()" title="Send a message">';
  html += '<svg viewBox="0 0 24 24" style="width:11px;height:11px;stroke:currentColor;fill:none;stroke-width:2;margin-right:2px;"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>Send</button>';
  html += '<button class="btn btn-ghost" style="font-size:0.7rem;padding:0.2rem 0.5rem;" onclick="logNoteForDrawer()" title="Log a manual note">+ Note</button>';
  html += '</div>';
  html += '</div>';

  // ── Send panel (collapsed by default) ──
  html += '<div class="comms-send-panel" id="comms-send-panel">';
  html += '<label>Channel</label>';
  html += '<select id="comms-send-channel" onchange="_commsChannelChange_()">';
  html += '<option value="email">Email</option>';
  html += '<option value="sms">SMS</option>';
  html += '</select>';
  html += '<div id="comms-send-subject-wrap">';
  html += '<label>Subject</label>';
  html += '<input type="text" id="comms-send-subject" placeholder="(no subject)">';
  html += '</div>';
  html += '<label>Message</label>';
  html += '<textarea id="comms-send-body" rows="4" maxlength="2000" placeholder="Type your message…" oninput="_commsBodyInput_()"></textarea>';
  html += '<div id="comms-sms-char" class="sms-char-count" style="display:none;"></div>';
  html += '<div class="send-panel-actions">';
  html += '<button class="btn btn-ghost" style="font-size:0.72rem;padding:0.25rem 0.75rem;" onclick="collapseSendPanel_()">Cancel</button>';
  html += '<button class="btn btn-primary" id="comms-send-btn" style="font-size:0.72rem;padding:0.25rem 0.75rem;" onclick="submitCommsMessage_()">Send</button>';
  html += '</div>';
  html += '</div>';

  var entries = commsEntries || [];
  if (entries.length === 0) {
    html += '<div class="empty-state" style="padding:0.5rem 0;">';
    html += '<p style="margin-bottom:0.25rem;font-size:0.75rem;">No communications logged yet.</p>';
    html += '<p style="font-size:0.68rem;color:var(--text-light);">No messages have been logged yet.</p>';
    html += '</div>';
  } else {
    html += '<div id="comms-workflow-list">';
    entries.slice(0, 80).forEach(function(e) {
      var ch = (e.channel || 'note').toLowerCase();
      var source = deriveCommsSource_(e);
      var sourceTag = source === 'auto' ? 'AUTO' : source === 'client' ? 'CLIENT' : 'JV';
      var ts = formatCommsTimestamp_(e.timestamp || e.date);
      var msg = e.subject || e.body_snippet || e.message || e.body_full || e.notes || '';
      if (msg.length > 120) msg = msg.substring(0, 117) + '…';
      var linkUrl = e.source_url || '';
      var chLabel = ch === 'chat' ? 'Chat' : ch === 'social' ? 'Social' : ch;

      html += '<div class="comms-entry" data-channel="' + escHtml(ch) + '">';
      html += '<div class="comms-entry-ts">' + escHtml(ts) + '</div>';
      html += '<div class="comms-entry-body">';
      html += '<span class="comms-source-tag ' + escHtml(source) + '">' + escHtml(sourceTag) + '</span>';
      if (ch !== 'email' && ch !== 'sms' && ch !== 'note') {
        html += '<span class="comms-source-tag auto" style="margin-left:2px;">' + escHtml(chLabel) + '</span> ';
      }
      html += escHtml(msg);
      if (linkUrl) html += ' <a class="comms-entry-link" href="' + escHtml(linkUrl) + '" target="_blank">View</a>';
      html += '</div>';
      html += '</div>';
    });
    html += '</div>';
  }
  html += '</div>';

  el.innerHTML = html;
}

function formatJourneyDate_(isoStr) {
  if (!isoStr) return '';
  return formatDate(isoStr);
}

function formatCommsTimestamp_(val) {
  if (!val) return '';
  var d = val instanceof Date ? val : new Date(val);
  if (isNaN(d.getTime())) return String(val).substring(0, 16);
  var h = d.getHours(), m = d.getMinutes();
  var ampm = h >= 12 ? 'pm' : 'am';
  h = h % 12 || 12;
  var mm = m < 10 ? '0' + m : m;
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return h + ':' + mm + ampm + ' ' + String(d.getDate()).padStart(2,'0') + '/' + String(d.getMonth()+1).padStart(2,'0');
}

function deriveCommsSource_(entry) {
  var src = (entry.source || entry.triggered_by || entry.logged_by || '').toLowerCase();
  var dir = (entry.direction || '').toLowerCase();
  if (dir === 'inbound') return 'client';
  if (src === 'system' || src === 'trigger' || src === 'auto' || src === 'automation') return 'auto';
  if (dir === 'outbound' && (src === 'gmail_sync' || src === 'sms_queue' || src === 'email_tracking')) return 'auto';
  if (src) return 'manual';
  return 'auto';
}

function filterCommsWorkflow() {
  var filter = document.getElementById('comms-filter-channel').value;
  var items = document.querySelectorAll('#comms-workflow-list .comms-entry');
  items.forEach(function(item) {
    if (filter === 'all') { item.style.display = ''; return; }
    var ch = item.getAttribute('data-channel') || '';
    if (filter === 'system') {
      item.style.display = (ch !== 'email' && ch !== 'sms') ? '' : 'none';
    } else {
      item.style.display = ch === filter ? '' : 'none';
    }
  });
}

function logNoteForDrawer() {
  var clientId = STATE.drawerClientId;
  if (!clientId) return;
  var note = window.prompt('Log a note for this client:');
  if (!note || !note.trim()) return;
  jvBridge.callAdmin('bridge_admin_logNote', { clientId: clientId, note: note.trim(), expectedEmail: jvExpectedEmailFor(clientId) })
    .then(function(res) {
      if (res && res.ok) {
        // Switch to Timeline tab so the note is visible immediately
        var timelineTab = document.querySelector('.drawer-tab[data-tab="timeline"]');
        if (timelineTab) timelineTab.click();
        loadDrawerTimeline(clientId);
      } else {
        var msg = (res && res.error && res.error.message) || (res && res.message) || 'Unknown error';
        console.error('[logNoteForDrawer] GAS returned error:', msg, res);
        alert('Error saving note: ' + msg);
      }
    })
    .catch(function(err) {
      console.error('[logNoteForDrawer] Bridge call failed:', err);
      alert('Error saving note: ' + (err.message || String(err)));
    });
}

function sendCommsMessage() {
  var panel = document.getElementById('comms-send-panel');
  if (!panel) return;
  if (panel.classList.contains('open')) {
    collapseSendPanel_();
  } else {
    panel.classList.add('open');
    _commsUpdateChannelOptions_();
    _commsChannelChange_();
    var body = document.getElementById('comms-send-body');
    if (body) setTimeout(function() { body.focus(); }, 50);
  }
}

function collapseSendPanel_() {
  var panel = document.getElementById('comms-send-panel');
  if (panel) panel.classList.remove('open');
  var body = document.getElementById('comms-send-body');
  if (body) body.value = '';
  var subj = document.getElementById('comms-send-subject');
  if (subj) subj.value = '';
}

function _commsUpdateChannelOptions_() {
  var sel = document.getElementById('comms-send-channel');
  if (!sel) return;
  // Remove old social options
  ['ig-option', 'fb-option'].forEach(function(id) {
    var opt = document.getElementById(id);
    if (opt) opt.parentNode.removeChild(opt);
  });
  // Add Instagram option if linked
  if (_drawerSocialLinks && _drawerSocialLinks.instagram) {
    var ig = document.createElement('option');
    ig.id = 'ig-option'; ig.value = 'instagram';
    ig.textContent = 'Instagram DM';
    sel.appendChild(ig);
  }
  // Add Facebook option if linked
  if (_drawerSocialLinks && _drawerSocialLinks.facebook) {
    var fb = document.createElement('option');
    fb.id = 'fb-option'; fb.value = 'facebook';
    fb.textContent = 'Facebook DM';
    sel.appendChild(fb);
  }
}

function _commsChannelChange_() {
  var sel    = document.getElementById('comms-send-channel');
  var channel = sel ? sel.value : 'email';
  var subjWrap = document.getElementById('comms-send-subject-wrap');
  var smsChar  = document.getElementById('comms-sms-char');
  if (subjWrap) subjWrap.style.display = (channel === 'email') ? '' : 'none';
  if (smsChar)  smsChar.style.display  = (channel === 'sms') ? '' : 'none';
  _commsBodyInput_();
}

function _commsBodyInput_() {
  var sel     = document.getElementById('comms-send-channel');
  var channel = sel ? sel.value : 'email';
  var body    = document.getElementById('comms-send-body');
  var counter = document.getElementById('comms-sms-char');
  if (channel === 'sms' && body && counter) {
    var len = body.value.length;
    counter.textContent = len + ' / 160';
    counter.className = 'sms-char-count' + (len > 160 ? ' warn' : '');
  }
}

function submitCommsMessage_() {
  var sel     = document.getElementById('comms-send-channel');
  var channel = sel ? sel.value : 'email';
  var subject = document.getElementById('comms-send-subject') ? document.getElementById('comms-send-subject').value : '';
  var bodyEl  = document.getElementById('comms-send-body');
  var body    = bodyEl ? bodyEl.value.trim() : '';

  if (!body) { jvToast('Message cannot be empty', 'error'); return; }

  var sendBtn = document.getElementById('comms-send-btn');
  if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = 'Sending\u2026'; }

  jvBridge.callAdmin('bridge_admin_sendMessage', {
      brideId: STATE.drawerClientId,
      email: jvExpectedEmailFor(STATE.drawerClientId),
      brideUid: (STATE.drawerClient && STATE.drawerClient.brideUid) || '',
      channel: channel,
      subject: subject,
      body:    body
    })
    .then(function(res) { if (res.ok) { var _h = function(result) {
      if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send \u2192'; }
      // P0.6 (2026-06-04): honest status, "Sent" only on a real send.
      var _st = result && result.status ? String(result.status).toLowerCase() : '';
      if (_st === 'blocked_safe_mode' || _st === 'blocked') {
        jvToast(result.message || 'Blocked: safe mode is active. Nothing was sent.', 'error');
        return;
      }
      if (_st === 'deferred' || _st === 'blocked_quiet_hours') {
        jvToast('Deferred: outside contact hours. Will send after 8am Sydney.', 'warn');
        collapseSendPanel_();
        loadDrawerTimeline(STATE.drawerClientId);
        return;
      }
      if (_st === 'rate_limited') {
        jvToast(result.message || 'Not sent: daily message limit for this bride reached.', 'error');
        return;
      }
      if (result && result.ok && (_st === 'sent' || _st === 'queued' || !_st)) {
        jvToast('Sent via ' + channel);
        collapseSendPanel_();
        loadDrawerTimeline(STATE.drawerClientId);
      } else {
        var errMsg = (result && result.error === 'no_ig_link')
          ? 'No Instagram linked for this bride. Link their handle in SOCIAL_LINKS first.'
          : (result && result.error === 'no_fb_link')
          ? 'No Facebook linked for this bride. Link their handle in SOCIAL_LINKS first.'
          : 'Send failed: ' + ((result && result.error) || 'unknown error');
        jvToast(errMsg, 'error');
      }
    }; _h(res.data); } else { var _e = function(err) {
      if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send \u2192'; }
      jvToast('Error: ' + (err && err.message ? err.message : String(err)), 'error');
    }; _e(res.error); } })
    .catch(function(err) {
      if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send \u2192'; }
      jvToast('Error: ' + (err && err.message ? err.message : String(err)), 'error');
    });
}

function loadDrawerProposals(clientId) {
  var el = document.getElementById('drawer-proposals-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    if (b && _bundleSectionReady_(b.proposals)) {
      _renderDrawerProposals_(clientId, b.proposals);
      return;
    }
    _loadDrawerProposals_legacy(clientId);
  });
}

function _loadDrawerProposals_legacy(clientId) {
  var el = document.getElementById('drawer-proposals-content');
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getProposals' })
    .then(function(res) { if (res.ok) { _renderDrawerProposals_(clientId, res.data); } else { el.innerHTML = '<div class="alert danger">' + escHtml((res.error && res.error.message) || String(res.error || '')) + '</div>'; } })
    .catch(function(err){ el.innerHTML = '<div class="alert danger">' + escHtml(err.message || String(err)) + '</div>'; });
}

function _renderDrawerProposals_(clientId, proposals) {
  var el = document.getElementById('drawer-proposals-content');
  var client = findClientById(clientId);
  var filtered = (proposals || []).filter(function(p){ return client && (p.email === client.email || p.clientId === clientId); });
  if (filtered.length === 0) { el.innerHTML = '<div class="empty-state"><p>No proposals found.</p></div>'; return; }
  var html = '';
  filtered.forEach(function(p) {
    var statusCls = p.proposalStatus === 'accepted' ? 'signed' : p.proposalStatus === 'voided' ? 'void' : 'out';
    var clickAttr = p.email
      ? ' style="margin-bottom:0.5rem;cursor:pointer;" onclick="openProposalModal(\'' + escAttr(p.email) + '\')"'
      : ' style="margin-bottom:0.5rem;"';
    html += '<div class="proposal-card"' + clickAttr + '>';
    html += '<div class="proposal-icon ' + statusCls + '">';
    html += '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';
    html += '</div><div class="proposal-info"><strong>' + escHtml(p.clientName || '') + '</strong>';
    html += '<span>' + escHtml(p.status || p.proposalStatus || '') + (p.quoteDate ? ' · ' + escHtml(p.quoteDate) : '') + '</span></div>';
    html += '<div class="proposal-amount">' + formatCurrency(p.proposalTotal) + '</div>';
    if (p.url) html += '<a href="' + escHtml(p.url) + '" target="_blank" class="btn btn-ghost" style="margin-left:0.5rem;padding:0.35rem 0.65rem;font-size:0.72rem;" onclick="event.stopPropagation();">View</a>';
    if (JV_FEATURE_VOID_PROPOSAL && p.proposalToken && p.proposalStatus !== 'voided') {
      html += '<button class="btn btn-ghost" style="margin-left:0.4rem;padding:0.35rem 0.65rem;font-size:0.72rem;color:var(--danger);" onclick="event.stopPropagation();voidProposal(\'' + escHtml(p.clientName) + '\', this)">Void</button>';
    }
    html += '</div>';
  });
  el.innerHTML = html;
}

function loadDrawerInvoices(clientId) {
  var el = document.getElementById('drawer-invoices-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    if (b && b.invoices && !b.invoices.error) {
      var client = findClientById(clientId);
      var clientEmail = (client && client.email) ? client.email : '';
      _paintDrawerInvoices_(clientId, clientEmail, b.invoices);
      return;
    }
    var client = findClientById(clientId);
    var clientEmail = (client && client.email) ? client.email : '';
    _renderDrawerInvoices(clientId, clientEmail, { skipXero: true, email: clientEmail });
  });
}

function _paintDrawerInvoices_(clientId, clientEmail, invoices) {
  var el = document.getElementById('drawer-invoices-content');
  var client = findClientById(clientId);
  var filtered = (invoices || []).filter(function(i){ return client && i.email === client.email; });
  var refreshBtn = '<div style="margin-bottom:0.75rem;text-align:right;">' +
    '<button class="btn btn-ghost" style="padding:0.35rem 0.65rem;font-size:0.72rem;" onclick="refreshDrawerInvoicesFromXero(\'' + escAttr(String(clientId)) + '\')">Refresh from Xero</button>' +
    '</div>';
  if (filtered.length === 0) { el.innerHTML = refreshBtn + '<div class="empty-state"><p>No invoices found.</p></div>'; return; }
  var html = refreshBtn + '<table class="data-table"><thead><tr><th>Total</th><th>Deposit</th><th>Balance</th><th>Status</th><th></th></tr></thead><tbody>';
  filtered.forEach(function(i) {
    html += '<tr><td>' + formatCurrency(i.totalValue) + '</td><td>' + escHtml(i.depositPaid ? 'Paid' : '—') + '</td><td>' + formatCurrency(i.balanceDue) + '</td><td>' + escHtml(i.status || '—') + '</td>';
    html += '<td>';
    if (i.pdfUrl) html += '<a href="' + escHtml(i.pdfUrl) + '" target="_blank" class="action-link">PDF</a>';
    html += '</td></tr>';
  });
  html += '</tbody></table>';
  el.innerHTML = html;
}

function refreshDrawerInvoicesFromXero(clientId) {
  var client = findClientById(clientId);
  var clientEmail = (client && client.email) ? client.email : '';
  _renderDrawerInvoices(clientId, clientEmail, { refresh: true, email: clientEmail });
}

function _renderDrawerInvoices(clientId, clientEmail, args) {
  var el = document.getElementById('drawer-invoices-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading…</div>';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoices', args: args })
    .then(function(res) { if (res.ok) { var _h = function(invoices) {
      var client = findClientById(clientId);
      var filtered = (invoices || []).filter(function(i){ return client && i.email === client.email; });
      var _cEmail = (client && client.email) ? client.email : (clientEmail || '');
      var refreshBtn = '<div style="margin-bottom:0.75rem;display:flex;justify-content:space-between;gap:0.5rem;align-items:center;flex-wrap:wrap;">' +
        '<button class="btn btn-primary" style="padding:0.35rem 0.75rem;font-size:0.72rem;" onclick="openAddonAddModal(\'' + escAttr(String(clientId)) + '\',\'' + escAttr(_cEmail) + '\')">Add a service to this booking</button>' +
        '<button class="btn btn-ghost" style="padding:0.35rem 0.65rem;font-size:0.72rem;" onclick="refreshDrawerInvoicesFromXero(\'' + escAttr(String(clientId)) + '\')">Refresh from Xero</button>' +
        '</div>';
      if (filtered.length === 0) { el.innerHTML = refreshBtn + '<div class="empty-state"><p>No invoices found.</p></div>'; return; }
      var html = refreshBtn + '<table class="data-table"><thead><tr><th>Total</th><th>Deposit</th><th>Balance</th><th>Status</th><th></th></tr></thead><tbody>';
      filtered.forEach(function(i) {
        html += '<tr><td>' + formatCurrency(i.totalValue) + '</td><td>' + escHtml(i.depositPaid ? 'Paid' : '—') + '</td><td>' + formatCurrency(i.balanceDue) + '</td><td>' + escHtml(i.status || '—') + '</td>';
        html += '<td>';
        // New-system bride: primary Open goes to the LOCAL branded invoice snapshot
        // (/pages/invoice-view); keep the PDF as a secondary link. Legacy brides
        // keep just the PDF link as before (2026-07-07).
        var iLocal = invoiceLocalViewUrl_(i);
        if (iLocal) html += '<a href="' + escHtml(iLocal) + '" target="_blank" class="action-link">Open ↗</a>';
        if (i.pdfUrl) html += '<a href="' + escHtml(i.pdfUrl) + '" target="_blank" class="action-link"' + (iLocal ? ' style="margin-left:6px;opacity:0.75;"' : '') + '>PDF</a>';
        html += '</td></tr>';
      });
      html += '</tbody></table>';
      el.innerHTML = html;
    }; _h(res.data); } else { var _e = function(err){ el.innerHTML = '<div class="alert danger">' + escHtml(err.message || String(err)) + '</div>'; }; _e(res.error); } })
    .catch(function(err){ el.innerHTML = '<div class="alert danger">' + escHtml(err.message || String(err)) + '</div>'; });
}

function loadDrawerRunsheet(clientId) {
  var el = document.getElementById('drawer-runsheet-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading runsheet status…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    if (b && b.runsheet && !b.runsheet.error) {
      _paintDrawerRunsheet_(el, b.runsheet);
      return;
    }
    _loadDrawerRunsheet_legacy(clientId);
  });
}

function _paintDrawerRunsheet_(el, status) {
  if (!status) { renderRunsheetNone_(el); return; }
  var st = status.runsheetState || 'none';
  if (st === 'published') renderRunsheetPublished_(el, status);
  else if (st === 'draft') renderRunsheetDraft_(el, status);
  else renderRunsheetNone_(el, status);
}

function _loadDrawerRunsheet_legacy(clientId) {
  var el = document.getElementById('drawer-runsheet-content');
  // Identity guard (2026-09-01): see the matching comment on the journey call
  // in _loadDrawerTimeline_legacy above, same reasoning.
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getRunsheetStatus', args: { clientId: clientId, expectedEmail: jvExpectedEmailFor(clientId) } })
    .then(function(res) { if (res.ok) { _paintDrawerRunsheet_(el, res.data); } else { el.innerHTML = '<div class="alert danger">' + escHtml((res.error && res.error.message) || String(res.error || '')) + '</div>'; } })
    .catch(function(err){ el.innerHTML = '<div class="alert danger">' + escHtml(err.message || String(err)) + '</div>'; });
}

/* --- State 1: No runsheet ------------------------------------------------ */
function renderRunsheetNone_(el, status) {
  var brideName = (status && status.brideName) || '';
  el.innerHTML =
    '<div class="runsheet-empty">' +
      '<div class="runsheet-empty-icon"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg></div>' +
      '<div class="runsheet-empty-title">No runsheet built yet</div>' +
      '<div class="runsheet-empty-sub">Create a runsheet to schedule services and assign artists for this event.</div>' +
      '<div class="runsheet-actions" style="justify-content:center;">' +
        '<button class="btn btn-primary" onclick="openRunsheetBuilderForBride(\'' + escHtml(brideName.replace(/'/g, "\\'")) + '\')">Build in Runsheet Builder</button>' +
        '<button class="btn btn-ghost" data-runsheet-copy-link="' + escHtml(brideName) + '" onclick="copyBrideRunsheetLink(this)">Copy bride link</button>' +
      '</div>' +
    '</div>';
}

/* --- State 2: Draft ------------------------------------------------------ */
function renderRunsheetDraft_(el, status) {
  var d = status.draftMeta || {};
  var brideName = status.brideName || '';
  var lastEdited = d.lastEdited ? formatDate(d.lastEdited) : 'Unknown';
  var html =
    '<div class="runsheet-draft-card">' +
      '<div class="runsheet-draft-label">Draft Runsheet</div>' +
      '<div class="runsheet-draft-meta">' +
        '<span><span class="meta-label">Last edited:</span> ' + escHtml(lastEdited) + '</span>' +
        '<span><span class="meta-label">Services:</span> ' + (d.serviceCount || 0) + '</span>' +
        '<span><span class="meta-label">Artists:</span> ' + (d.artistCount || 0) + '</span>' +
        '<span><span class="meta-label">Status:</span> Unpublished</span>' +
      '</div>';

  // Service breakdown if available
  if (d.serviceCounts && Object.keys(d.serviceCounts).length) {
    html += '<div style="font-size:0.72rem;color:var(--muted);margin-bottom:0.5rem;">';
    Object.keys(d.serviceCounts).forEach(function(label) {
      html += escHtml(label) + ' (' + d.serviceCounts[label] + ')&nbsp;&nbsp;';
    });
    html += '</div>';
  }

  html += '</div>' +
    '<div class="runsheet-actions">' +
      '<button class="btn btn-primary" onclick="openRunsheetBuilderForBride(\'' + escHtml(brideName.replace(/'/g, "\\'")) + '\')">Edit Draft in Runsheet Builder</button>' +
      '<button class="btn btn-ghost" data-runsheet-copy-link="' + escHtml(brideName) + '" onclick="copyBrideRunsheetLink(this)">Copy bride link</button>' +
    '</div>';
  el.innerHTML = html;
}

/* --- State 3: Published -------------------------------------------------- */
// Artist photo CDN map — mirrors appGetArtistPhotoUrl_ in GAS (RunsheetEngineV4.gs)
var _ARTIST_PHOTOS = {
  'mia':     'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-144.jpg?v=1761992913',
  'emma':    'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/b37acd64-ed3d-43f3-83bc-8adb970c7d3b.png?v=1763667268',
  'kaelin':  'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-2.jpg?v=1761995994',
  'jessy':   'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-69.jpg?v=1761995684',
  'belinda': 'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-97.jpg?v=1761995585',
  'alana':   'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-105.jpg?v=1761994572',
  'jessica': 'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-180.jpg?v=1761993533',
  'jill':    'https://cdn.shopify.com/s/files/1/0331/8834/8036/files/JessVegasProTeam-101.jpg?v=1761992985'
};
function _artistPhoto(name) { return _ARTIST_PHOTOS[(name||'').trim().toLowerCase()] || ''; }
function _artistInitial(name) { return ((name||'').trim().charAt(0)||'?').toUpperCase(); }
function _artistAvatar(name, size, borderPx) {
  var px = size || 28; var b = borderPx || 0;
  var photo = _artistPhoto(name);
  var style = 'width:' + px + 'px;height:' + px + 'px;border-radius:50%;object-fit:cover;flex-shrink:0;' + (b ? 'border:' + b + 'px solid var(--brand-primary);' : '');
  if (photo) return '<img src="' + escHtml(photo) + '" title="' + escHtml(name||'') + '" style="' + style + '">';
  return '<div title="' + escHtml(name||'') + '" style="' + style + ';background:var(--brand-primary);color:#fff;display:flex;align-items:center;justify-content:center;font-size:' + Math.round(px*0.42) + 'px;font-weight:700;">' + escHtml(_artistInitial(name)) + '</div>';
}

function renderRunsheetPublished_(el, status) {
  var pub = status.publishedData || {};
  var d = status.draftMeta || {};
  var brideName = status.brideName || '';
  var publishedDate = pub.publishedDate ? formatDate(pub.publishedDate) : '';
  var services = (pub.services || []).slice().sort(function(a, b) {
    return (a.time || '').localeCompare(b.time || '');
  });

  var html = '';

  // ── Header bar ──────────────────────────────────────────────────────────────
  html += '<div class="runsheet-pub-header">' +
    '<span class="runsheet-pub-badge">Published</span>' +
    (publishedDate ? '<span class="runsheet-pub-date">Published ' + escHtml(publishedDate) + '</span>' : '') +
  '</div>';

  // ── Summary strip ───────────────────────────────────────────────────────────
  html += '<div class="runsheet-draft-meta" style="margin-bottom:0.85rem;">';
  if (pub.location) html += '<span><span class="meta-label">Location:</span> ' + escHtml(pub.location) + '</span>';
  if (pub.readyBy)  html += '<span><span class="meta-label">Ready by:</span> ' + escHtml(pub.readyBy) + '</span>';
  html += '</div>';

  // ── Artist profile chips ─────────────────────────────────────────────────
  var uniqueArtists = [];
  services.forEach(function(s) {
    if (s.artist && uniqueArtists.indexOf(s.artist) === -1) uniqueArtists.push(s.artist);
  });
  if (pub.leadArtist && uniqueArtists.indexOf(pub.leadArtist) === -1) uniqueArtists.unshift(pub.leadArtist);

  if (uniqueArtists.length) {
    html += '<div style="display:flex;gap:0.85rem;flex-wrap:wrap;margin-bottom:1rem;padding-bottom:0.85rem;border-bottom:1px solid var(--line);">';
    uniqueArtists.forEach(function(artist) {
      var isLead = artist === pub.leadArtist;
      html += '<div style="display:flex;align-items:center;gap:0.45rem;">' +
        _artistAvatar(artist, 36, 2) +
        '<div>' +
          '<div style="font-size:0.8rem;font-weight:600;color:var(--brand-dark);line-height:1.1;">' + escHtml(artist) + '</div>' +
          (isLead ? '<div style="font-size:0.65rem;color:var(--brand-primary);font-weight:600;text-transform:uppercase;letter-spacing:0.04em;">Lead</div>' : '') +
        '</div>' +
      '</div>';
    });
    html += '</div>';
  }

  // ── Service cards ────────────────────────────────────────────────────────
  if (services.length) {
    html += '<div style="display:flex;flex-direction:column;gap:0.35rem;margin-bottom:1rem;">';
    services.forEach(function(svc, idx) {
      var timeStr = svc.time || '';
      if (svc.endTime) timeStr += ' – ' + svc.endTime;
      var role = (svc.role || '').toLowerCase();
      var isBride = role === 'bride' || role === 'bride' ;
      var dotColor = isBride ? 'var(--brand-primary)' : 'var(--brand-primary-deep)';

      html += '<div onclick="toggleRunsheetDetail(' + idx + ')" style="background:var(--brand-bg-soft);border-radius:0.65rem;padding:0.55rem 0.75rem;cursor:pointer;display:grid;grid-template-columns:1fr auto auto;gap:0.5rem;align-items:center;">' +

        // Left: person + service label
        '<div>' +
          '<div style="display:flex;align-items:center;gap:0.35rem;">' +
            '<span style="width:7px;height:7px;border-radius:50%;background:' + dotColor + ';flex-shrink:0;"></span>' +
            '<span style="font-size:0.82rem;font-weight:600;color:var(--brand-dark);">' + escHtml(svc.client || '—') + '</span>' +
            (svc.role ? '<span style="font-size:0.6rem;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:var(--text-light);background:var(--brand-bg-white);border:1px solid var(--line);border-radius:999px;padding:0.1rem 0.4rem;margin-left:0.1rem;">' + escHtml(svc.role) + '</span>' : '') +
          '</div>' +
          '<div style="font-size:0.72rem;color:var(--muted);padding-left:1rem;">' + escHtml(svc.service || '') + '</div>' +
        '</div>' +

        // Centre: time
        '<div style="font-size:0.7rem;color:var(--brand-primary-deep);font-weight:600;font-variant-numeric:tabular-nums;white-space:nowrap;">' + escHtml(timeStr) + '</div>' +

        // Right: artist avatar
        _artistAvatar(svc.artist || '', 26, 0) +

      '</div>' +

      // Expanded detail row
      '<div class="runsheet-detail" id="runsheet-detail-' + idx + '" style="padding:0.35rem 0.75rem 0.4rem;margin-top:-0.35rem;background:var(--brand-bg-soft);border-radius:0 0 0.65rem 0.65rem;">' +
        (svc.artist ? '<span style="font-size:0.72rem;"><strong>Artist:</strong> ' + escHtml(svc.artist) + '</span>' : '') +
      '</div>';
    });
    html += '</div>';
  }

  // ── Action buttons ───────────────────────────────────────────────────────
  var brideAttr = escHtml(brideName.replace(/'/g, "\\'"));
  html += '<div class="runsheet-actions">' +
    '<button class="btn btn-primary" onclick="openRunsheetBuilderForBride(\'' + brideAttr + '\')">Edit in Runsheet Builder</button>' +
    '<button class="btn btn-ghost" data-runsheet-copy-link="' + escHtml(brideName) + '" onclick="copyBrideRunsheetLink(this)">Copy bride link</button>';
  if (pub.pdfUrl) {
    html += '<a href="' + escHtml(pub.pdfUrl) + '" target="_blank" class="btn btn-ghost">View Runsheet PDF</a>';
  }
  if (pub.pdfFileId) {
    html += '<a href="https://drive.google.com/uc?export=download&id=' + escHtml(pub.pdfFileId) + '" target="_blank" class="btn btn-ghost">Download PDF</a>';
  }
  html += '</div>';

  el.innerHTML = html;
}

// Fetches the bride's RUNSHEET_VIEWER_TOKEN (creating it if missing) via
// bridge_runsheet_getPreviewUrl and copies the JV-branded Shopify viewer URL
// to the clipboard. Same URL the bride receives via SMS/email/Chat.
function copyBrideRunsheetLink(btn) {
  if (!btn) return;
  var brideName = btn.getAttribute('data-runsheet-copy-link') || '';
  if (!brideName) { alert('No bride name available.'); return; }
  var originalLabel = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Generating…';
  jvBridge.call('bridge_runsheet_getPreviewUrl', { brideName: brideName })
    .then(function(res) {
      if (!res || !res.ok || !res.data || !res.data.url) {
        btn.disabled = false;
        btn.textContent = originalLabel;
        alert('Error: ' + ((res && res.error) || 'Failed to generate runsheet link'));
        return;
      }
      var url = res.data.url;
      var done = function() {
        btn.textContent = 'Copied!';
        setTimeout(function() { btn.disabled = false; btn.textContent = originalLabel; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function() {
          window.prompt('Copy this link:', url);
          done();
        });
      } else {
        window.prompt('Copy this link:', url);
        done();
      }
    })
    .catch(function(err) {
      btn.disabled = false;
      btn.textContent = originalLabel;
      alert('Error: ' + (err.message || String(err)));
    });
}

function toggleRunsheetDetail(idx) {
  var detail = document.getElementById('runsheet-detail-' + idx);
  if (detail) detail.classList.toggle('open');
}

function openRunsheetBuilderForBride(brideName) {
  var url = '/pages/runsheet-app';
  if (brideName) url += '#bride=' + encodeURIComponent(brideName);
  window.open(url, '_blank');
}

function findClientById(id) {
  if (!STATE.clients) return null;
  return STATE.clients.find(function(c){ return String(c.id) === String(id); }) || null;
}

/**
 * Identity guard (2026-07-28): resolve the email the frontend believes a clientId
 * belongs to, so every WRITE can pass expectedEmail and the backend can verify the
 * row number still holds that bride (re-resolving by email if the row drifted after
 * an archive/delete/re-sort). The clientId = sheet row number is NOT a stable id.
 * Prefers the loaded drawer bride, then the pipeline/clients list. Returns '' if
 * unknown (backend then warns-and-proceeds for low-stakes writes, or refuses for
 * the dangerous send/archive writes).
 */
function jvExpectedEmailFor(clientId) {
  try {
    var dc = STATE.drawerClient;
    if (dc && String(dc.id) === String(clientId)) {
      var de = dc.email || dc.EMAIL || '';
      if (de) return String(de).trim().toLowerCase();
    }
    var c = findClientById(clientId);
    var e = c && (c.email || c.EMAIL);
    return e ? String(e).trim().toLowerCase() : '';
  } catch (_) { return ''; }
}

/**
 * Flatten the pipeline payload (active items plus closed leads) into STATE.clients so
 * findClientById() resolves on a cold drawer open, giving renderLanding() an instant
 * hero paint from pipeline data while the heavy bundle hydrates the facets behind it.
 * Non-destructive: if the richer Clients-tab list is already loaded (it carries more
 * fields), keep it; only seed STATE.clients from the pipeline when it is empty, or add
 * ids the current list is missing (e.g. Enquiry leads arriving on the enquiryNotCached
 * background reload). Added 2026-06-27 (Grade-3 H3 fix).
 */
function pipeline_syncStateClients_(data) {
  if (!data) return;
  var items = (data.items || []).concat(data.closedClients || []);
  if (!items.length) return;
  if (!Array.isArray(STATE.clients) || !STATE.clients.length) {
    STATE.clients = items.slice();
    return;
  }
  // Merge: add any pipeline ids not already present (do not overwrite richer rows).
  var seen = {};
  STATE.clients.forEach(function(c){ if (c && c.id != null) seen[String(c.id)] = true; });
  items.forEach(function(c){
    if (c && c.id != null && !seen[String(c.id)]) { STATE.clients.push(c); seen[String(c.id)] = true; }
  });
}

/* ============================================================
   SEND PROPOSAL (was "Send to Pipeline")
   ============================================================ */
// Money/irreversible action — confirm-first, then LOCK the clicked button until the
// live call actually returns (T3: never optimistic for send/void/mark-paid).
function sendProposal(clientId, btnEl) {
  if (!confirm('Send proposal for this client?')) return;
  var btn = btnEl || (typeof event !== 'undefined' && event && event.currentTarget) || null;
  var origLabel = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  // Identity guard (2026-07-28): pass the object form with expectedEmail so a drifted
  // row can't send a proposal to the wrong bride. Backend REQUIRES it (refuses if absent).
  var _spEmail = jvExpectedEmailFor(clientId);
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_sendProposal', args: { clientId: clientId, expectedEmail: _spEmail } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res && res.success) {
        jvToast('Proposal sent successfully.', 'success');
        loadPipelineView(true);
      } else {
        jvToast('Error: ' + (res && res.message ? res.message : 'Unknown error'), 'error');
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
      }
    }; _h(res.data); } else { var _e = function(err){
      jvToast('Error: ' + (err.message || String(err)), 'error');
      if (btn) { btn.disabled = false; btn.textContent = origLabel; }
    }; _e(res.error); } })
    .catch(function(err){
      jvToast('Error: ' + (err.message || String(err)), 'error');
      if (btn) { btn.disabled = false; btn.textContent = origLabel; }
    });
}

function voidProposal(brideName, btnEl) {
  if (!JV_FEATURE_VOID_PROPOSAL) {
    jvToast('Voiding proposals is not available yet. Please void the quote directly in Xero/JV AUTO.', 'error');
    return;
  }
  if (!confirm('Void this proposal? This cannot be undone.')) return;
  var btn = btnEl || (typeof event !== 'undefined' && event && event.currentTarget) || null;
  var origLabel = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Voiding…'; }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_voidProposal', args: brideName })
    .then(function(res) {
      // AdminCRMAPI functions return {success,message} directly, bridge_admin_generic wraps in {ok,data}.
      var payload = (res && res.data) || res;
      if (res && res.ok !== false && payload && payload.success) {
        jvToast(payload.message || 'Proposal voided.', 'success');
      } else {
        jvToast('Error: ' + ((payload && payload.message) || res.error || 'Unknown error'), 'error');
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
      }
    })
    .catch(function(err){
      jvToast('Error: ' + (err.message || String(err)), 'error');
      if (btn) { btn.disabled = false; btn.textContent = origLabel; }
    });
}

/* ============================================================
   OPEN RUNSHEET / COMMS shortcuts
   ============================================================ */
function openRunsheet(clientId) {
  openDrawer(clientId);
  setTimeout(function(){ switchDrawerTab('runsheet', document.querySelector('.drawer-tab[data-pane="runsheet"]')); }, 100);
}
function openClientComms(clientId) {
  openDrawer(clientId);
  setTimeout(function(){ switchDrawerTab('timeline', document.querySelector('.drawer-tab[data-pane="timeline"]')); }, 100);
}

/* ============================================================
   PARTNER PARTY-SEAT PICKER, SHARED HELPERS (2026-09-11)
   BUILD-SCOPE-partner-party-seat-picker-full-fidelity-2026-09-11.md
   ============================================================

   THREE frontend copies of the partner party picker exist and must stay in
   lockstep: addPmb* (Add Partner Managed Bride, this file), bp* (Bill a
   Partner, this file), and abp-bp-* (Bill a Partner on the bride profile,
   assets/jv-admin-bride-profile-v2.js). They were built as near-identical
   copies differing only by id prefix, so extending one and not the others
   silently diverges the payload shape, the exact warning in the build scope.
   These helpers exist so the ROLE/SERVICE-TYPE and JUNIOR-DISCOUNT rules have
   ONE implementation rather than three that can drift apart.

   WHY THE CLIENT PRICES AT ALL: each modal shows a running total and puts the
   amount on its own submit button ("Create Bride + Invoice $X"), so the client
   duplicates the server's pricing. That duplication is pre-existing, not
   introduced here, but it means these rules MUST mirror
   PartnerManagedCore.gs's rateForPartyEntry_/labelForPartyEntry_ and its
   junior-discount block exactly, or the admin is shown a total that disagrees
   with the invoice the bride/partner actually receives. Any change to the
   pricing rules in that .gs file must be mirrored here in the same commit.

   PAYLOAD SHAPE (from PartnerManagedCore.gs's own header): the original four
   FLAT types (hairAndMakeup/hairOnly/makeupOnly/maleGrooming) keep sending
   `type` alone with NO `role`, unchanged, so every rate card written before
   2026-09-11 (e.g. EBM's) keeps working. The three NEW roles (mother, guest,
   flowergirl) are NESTED on rateCard.party and must send BOTH `role` and
   `serviceType`. Never send a `role` for the flat four. */

var JV_PMB_NESTED_ROLES_ = { mother: 1, guest: 1, flowergirl: 1 };
var JV_PMB_JUNIOR_MAX_ = 2;                   // matches PARTNER_MANAGED_JUNIOR_MAX_
var JV_PMB_DEFAULT_JUNIOR_DISCOUNT_PCT_ = 25; // matches PARTNER_MANAGED_DEFAULT_JUNIOR_DISCOUNT_PCT_

// The party-row markup shared by all three pickers. `p` is the id/class
// prefix ('pmb', 'bp', 'abp-bp'); `onchange` is that picker's own refresh fn.
// Role and service-type are SEPARATE selects, matching the nested payload:
// choosing "Bridal party" (value '') means the flat legacy shape.
function jvPmbPartyRowHtml_(p, onchange, removeFn) {
  return '' +
    '<input type="number" class="filter-select ' + p + '-party-count" min="0" step="1" value="0" placeholder="qty" style="width:100%;border-radius:var(--radius-small);" oninput="' + onchange + '()">' +
    '<select class="filter-select ' + p + '-party-role" style="width:100%;border-radius:var(--radius-small);" onchange="' + onchange + '()">' +
      '<option value="">Bridal party</option>' +
      '<option value="mother">Mother</option>' +
      '<option value="guest">Guest</option>' +
      '<option value="flowergirl">Flowergirl</option>' +
    '</select>' +
    '<select class="filter-select ' + p + '-party-type" style="width:100%;border-radius:var(--radius-small);" onchange="' + onchange + '()">' +
      '<option value="hairAndMakeup">Hair &amp; Makeup</option>' +
      '<option value="hairOnly">Hair only</option>' +
      '<option value="makeupOnly">Makeup only</option>' +
      '<option value="maleGrooming">Male Grooming</option>' +
    '</select>' +
    // Junior count. Only meaningful for the flat "Bridal party" shape (the
    // backend's isBridesmaid is `!p.role && p.type !== 'maleGrooming'`), so it
    // is disabled otherwise rather than hidden: a visibly-disabled control
    // explains itself, a vanishing one reads as a bug.
    '<input type="number" class="filter-select ' + p + '-party-junior" min="0" max="' + JV_PMB_JUNIOR_MAX_ + '" step="1" value="0" placeholder="jr" title="Junior bridesmaids (max ' + JV_PMB_JUNIOR_MAX_ + ', discounted)" style="width:100%;border-radius:var(--radius-small);" oninput="' + onchange + '()">' +
    '<input type="number" class="filter-select ' + p + '-party-amt" min="0" step="0.01" placeholder="$ override" style="width:100%;border-radius:var(--radius-small);" oninput="' + onchange + '()">' +
    '<button type="button" class="btn btn-ghost" style="padding:0;width:28px;height:28px;font-size:0.9rem;line-height:1;" onclick="' + removeFn + '(this)" title="Remove">&times;</button>';
}

// Grid template for the row above. Kept beside the markup so the two cannot
// drift apart (6 columns: qty, role, service, junior, override, remove).
var JV_PMB_PARTY_ROW_GRID_ = 'display:grid;grid-template-columns:64px 1fr 1fr 56px 100px 28px;gap:0.4rem;align-items:center;';

// Mirrors PartnerManagedCore.gs's isBridesmaid exactly. See the long comment
// at that call site for why this is the correct test: this schema has no
// distinct 'bridesmaid' value, a party row with no explicit role IS the
// generic bridal-party member, and maleGrooming is an add-on the age-based
// discount should not touch.
function jvPmbIsBridesmaidEntry_(p) {
  return !p.role && p.type !== 'maleGrooming';
}

// Reads one party row into the backend's expected entry shape. Returns null
// for a row that should be skipped.
function jvPmbCollectPartyRow_(row, p) {
  var count = parseInt((row.querySelector('.' + p + '-party-count') || {}).value || '0', 10) || 0;
  var type  = (row.querySelector('.' + p + '-party-type') || {}).value || '';
  var role  = (row.querySelector('.' + p + '-party-role') || {}).value || '';
  var override = parseFloat((row.querySelector('.' + p + '-party-amt') || {}).value || '0');
  if (count <= 0 || !type) return null;

  var entry = { type: type, count: count };
  // Only attach role/serviceType for the nested roles. The flat four must keep
  // their exact historical shape (type only, no role) or older rate cards stop
  // resolving.
  if (role && JV_PMB_NESTED_ROLES_[role]) {
    entry.role = role;
    entry.serviceType = type;
  }
  if (override > 0) entry.overrideAmount = override;

  // Junior count applies ONLY where the backend's isBridesmaid is true.
  // Clamped to [0, min(JUNIOR_MAX, count)] here as well as server-side, so the
  // displayed total can never be computed from a value the server will reject.
  if (jvPmbIsBridesmaidEntry_(entry)) {
    var jr = parseInt((row.querySelector('.' + p + '-party-junior') || {}).value || '0', 10) || 0;
    jr = Math.max(0, Math.min(jr, JV_PMB_JUNIOR_MAX_, count));
    if (jr > 0) entry.juniorCount = jr;
  }
  return entry;
}

// Per-seat rate for one entry. Mirrors rateForPartyEntry_.
function jvPmbRateForPartyEntry_(p, rateCard) {
  var r = jvPmbResolveRate_(p, rateCard);
  return r.priceable ? r.rate : 0;
}

/* Resolves a seat's rate AND whether it could be priced at all.
   Returns {priceable: boolean, rate: number}.

   ADDED 2026-09-12 after the Cowork live pass (§2.3,
   RESULTS-admin-crm-money-paths-live-verify-2026-09-12.md) found this silently
   pricing real seats at $0.

   WHAT WENT WRONG: jvPmbRateForPartyEntry_ ended `return 0` whenever the stored
   rate card had no entry for the chosen role/service. EBM's card is the flat
   legacy shape -- `party` is {hairAndMakeup, hairOnly, makeupOnly} with no
   mother/guest/flowergirl sub-objects and no maleGrooming key at any level --
   so the picker offered four roles and a service the card could not price, and
   returned 0 for each. Four Mother seats sat visibly on screen while the submit
   button offered "Create Bride + Invoice $396.00", the bride's own service and
   nothing else. No warning, no disabled submit.

   0 IS A LEGITIMATE PRICE AND "I HAVE NO RATE" IS NOT A PRICE. Conflating them
   is the whole bug, so they are now separate values. Callers must check
   `priceable` and REFUSE rather than quietly charging nothing.

   This is the code half of the fix and it protects EVERY partner. Extending
   EBM's stored card to the nested shape fixes EBM alone and leaves the next
   partner exposed to exactly this; the two are complementary, not alternatives. */
function jvPmbResolveRate_(p, rateCard) {
  var rc = rateCard || {};
  // An explicit override is always priceable, whatever the card holds. It is a
  // deliberate admin decision, and it is the documented way to bill a seat the
  // stored card cannot price.
  if (p.overrideAmount != null && Number(p.overrideAmount) > 0) {
    return { priceable: true, rate: Number(p.overrideAmount) };
  }
  var v;
  if (p.role && JV_PMB_NESTED_ROLES_[p.role]) {
    v = ((rc.party || {})[p.role] || {})[String(p.serviceType || 'hairAndMakeup')];
  } else {
    v = (rc.party || {})[p.type];
  }
  if (v == null || v === '' || isNaN(Number(v))) return { priceable: false, rate: 0 };
  return { priceable: true, rate: Number(v) };
}

/* Human label for an unpriceable seat, e.g. "Mother (Hair)" or "Male Grooming",
   so the warning names what is actually missing rather than saying "a seat". */
function jvPmbUnpriceableLabel_(p, labels) {
  return jvPmbLabelForPartyEntry_(p, labels || {});
}

/* Every seat in `entries` that has a real quantity but NO rate the stored card
   can supply. Returns an array of human labels, deduped, for the warning.
   Seats with qty 0 are ignored -- an empty row is not an error. */
function jvPmbUnpriceableEntries_(entries, rateCard, labels) {
  var seen = {}, out = [];
  (entries || []).forEach(function (p) {
    if (!p || !(p.count > 0)) return;
    if (jvPmbResolveRate_(p, rateCard).priceable) return;
    var lbl = jvPmbUnpriceableLabel_(p, labels);
    if (seen[lbl]) return;
    seen[lbl] = 1;
    out.push(lbl);
  });
  return out;
}

/* Paints (or clears) the unpriceable warning and enables/disables submit.

   REFUSE, DO NOT QUIETLY UNDERCHARGE. Before this, a seat the card could not
   price contributed 0 and the submit button cheerfully offered to invoice
   without it. The admin had no way to know. Now the button is disabled and the
   warning names the exact seats, with the two real ways forward: enter a price
   override on those rows, or have the partner's rate card extended.

   `warnElId`/`submitElId` differ per picker, so this is shared rather than
   duplicated three times. Returns true when everything is priceable. */
function jvPmbApplyUnpriceableGuard_(entries, rateCard, labels, warnElId, submitElId, submitLabelWhenOk) {
  var missing = jvPmbUnpriceableEntries_(entries, rateCard, labels);
  var warnEl = document.getElementById(warnElId);
  var btn = document.getElementById(submitElId);
  if (!missing.length) {
    if (warnEl) { warnEl.style.display = 'none'; warnEl.textContent = ''; }
    if (btn) btn.disabled = false;
    return true;
  }
  if (warnEl) {
    warnEl.style.display = '';
    warnEl.textContent = 'No stored rate for: ' + missing.join(', ') +
      '. Enter a price for those rows, or ask for the partner\'s rate card to be updated. ' +
      'They are not included in the total.';
  }
  // Disabling submit is the load-bearing half. A warning alone would still let
  // an admin send an invoice missing real seats.
  if (btn) {
    btn.disabled = true;
    if (submitLabelWhenOk) btn.textContent = submitLabelWhenOk;
  }
  return false;
}

// Line total for one entry INCLUDING the junior discount, mirroring the
// server's split of adultCount/juniorCount and its rounding (junior rate is
// rounded to cents BEFORE multiplying, same as the .gs).
function jvPmbPartyEntryTotal_(p, rateCard) {
  var pr = jvPmbRateForPartyEntry_(p, rateCard);
  if (!(pr > 0)) return 0;
  var count = p.count || 0;
  var juniorCount = jvPmbIsBridesmaidEntry_(p)
    ? Math.min(Math.max(0, parseInt(p.juniorCount, 10) || 0), JV_PMB_JUNIOR_MAX_, count)
    : 0;
  var adultCount = count - juniorCount;
  var total = pr * adultCount;
  if (juniorCount > 0) {
    var pct = Number((rateCard || {}).juniorBridesmaidDiscountPct);
    if (!(pct > 0)) pct = JV_PMB_DEFAULT_JUNIOR_DISCOUNT_PCT_;
    total += (Math.round(pr * (1 - pct / 100) * 100) / 100) * juniorCount;
  }
  return total;
}

// Human label for one entry. Mirrors PartnerManagedCore.gs labelForPartyEntry_:
// a nested role reads as its role name with the service in brackets
// ("Mother (Hair)"), the flat four keep their historical service-only label.
// `labels` is the caller's own label map (BP_SERVICE_LABELS_ etc.).
function jvPmbLabelForPartyEntry_(p, labels) {
  var map = labels || {};
  if (p.role && JV_PMB_NESTED_ROLES_[p.role]) {
    var base = map[p.role] || p.role;
    var svc = String(p.serviceType || 'hairAndMakeup');
    if (svc === 'hairOnly')   return base + ' (Hair)';
    if (svc === 'makeupOnly') return base + ' (Makeup)';
    return base;
  }
  return map[p.type] || p.type;
}

// Splits one entry into the invoice lines it should produce: an adult line
// and, when juniors are present, a separate discounted line. Mirrors the
// server's own two-pushItem_ split so the invoice the partner receives matches
// what the admin was shown. Returns [] for a zero-rate entry.
function jvPmbPartyLineSplit_(p, rateCard, labels) {
  var pr = jvPmbRateForPartyEntry_(p, rateCard);
  if (!(pr > 0)) return [];
  var label = jvPmbLabelForPartyEntry_(p, labels);
  var count = p.count || 0;
  var juniorCount = jvPmbIsBridesmaidEntry_(p)
    ? Math.min(Math.max(0, parseInt(p.juniorCount, 10) || 0), JV_PMB_JUNIOR_MAX_, count)
    : 0;
  var adultCount = count - juniorCount;
  var out = [];
  if (adultCount > 0) out.push({ label: label, qty: adultCount, unitAmount: pr, junior: false });
  if (juniorCount > 0) {
    var pct = Number((rateCard || {}).juniorBridesmaidDiscountPct);
    if (!(pct > 0)) pct = JV_PMB_DEFAULT_JUNIOR_DISCOUNT_PCT_;
    out.push({
      label: label + ' (Junior, ' + pct + '% off)',
      qty: juniorCount,
      unitAmount: Math.round(pr * (1 - pct / 100) * 100) / 100,
      junior: true
    });
  }
  return out;
}

// Stable per-entry id fragment, so a nested role does not collide with the
// flat type of the same service (e.g. party_mother_hairOnly vs party_hairOnly).
function jvPmbPartyServiceId_(p) {
  return (p.role && JV_PMB_NESTED_ROLES_[p.role])
    ? ('party_' + p.role + '_' + String(p.serviceType || 'hairAndMakeup'))
    : ('party_' + p.type);
}

// Enables/disables the junior input to match the chosen role, and clamps it to
// the current qty. Called from each picker's refresh fn so the control can
// never sit enabled-but-meaningless (or hold a stale value from before the
// role changed).
function jvPmbSyncPartyRowControls_(p) {
  Array.prototype.forEach.call(document.querySelectorAll('.' + p + '-party-row'), function (row) {
    var roleEl = row.querySelector('.' + p + '-party-role');
    var typeEl = row.querySelector('.' + p + '-party-type');
    var jrEl   = row.querySelector('.' + p + '-party-junior');
    if (!jrEl) return;
    var role = (roleEl || {}).value || '';
    var type = (typeEl || {}).value || '';
    var allowed = !role && type !== 'maleGrooming';
    jrEl.disabled = !allowed;
    jrEl.style.opacity = allowed ? '' : '0.45';
    if (!allowed) { jrEl.value = '0'; return; }
    var count = parseInt((row.querySelector('.' + p + '-party-count') || {}).value || '0', 10) || 0;
    var jr = parseInt(jrEl.value || '0', 10) || 0;
    var max = Math.min(JV_PMB_JUNIOR_MAX_, count);
    if (jr > max) jrEl.value = String(Math.max(0, max));
  });
}

/* ============================================================
   ADD PARTNER MANAGED BRIDE, modal (phase 7)
   ============================================================ */
var _addPmbModalEl  = null;
var _addPmbPartners = [];
var _addPmbOnSuccess = null;  // optional callback: fn(result), fires after successful create
var _addPmbRateCard = null;   // partner's rate card (lazy-loaded on partner select)
var _addPmbPartyRowCount = 0;
var _addPmbTrialRowCount = 0;
// STABLE IDENTITY (2026-08-11, BRIEFS/CRITICAL-partner-managed-bride-stable-identity-rebuild-2026-08-11.md):
// once a create in THIS modal session returns a brideUid, remember it and
// send it back automatically on any further submit within the same modal
// open (e.g. a retry after an error, or an explicit resend). Reset on every
// modal open, a fresh open is a fresh bride until a create returns one.
var _addPmbBrideUid = '';

function openAddPartnerManagedBrideModal(preselectPartnerEmail, onSuccess) {
  _addPmbModalEl = document.getElementById('add-pmb-modal');
  if (!_addPmbModalEl) { console.warn('[add-pmb] modal element not in DOM'); return; }
  _addPmbOnSuccess = (typeof onSuccess === 'function') ? onSuccess : null;
  var sel = document.getElementById('add-pmb-partner');
  var statusEl = document.getElementById('add-pmb-status');
  if (statusEl) statusEl.textContent = '';
  if (sel) sel.innerHTML = '<option value="">Loading partners…</option>';
  // Reset form fields each open
  ['add-pmb-bride-first','add-pmb-bride-last','add-pmb-bride-email','add-pmb-bride-phone','add-pmb-wedding-date','add-pmb-location'].forEach(function(id){
    var el = document.getElementById(id); if (el) el.value = '';
  });
  var hmEl = document.getElementById('add-pmb-hm-qty'); if (hmEl) hmEl.value = '1';
  // STABLE IDENTITY (2026-08-11): a fresh modal open is a fresh bride until a
  // create returns a real brideUid.
  _addPmbBrideUid = '';
  // 2026-08-13 (secondary finding from the checkbox-investigation brief): closing this
  // modal after selecting a partner, then reopening WITHOUT a page reload, left the
  // routing-summary panel and the services/travel panel showing stale content under a
  // freshly-reset, unselected Partner dropdown. Reset both here alongside everything
  // else the open already resets.
  var summaryElReset = document.getElementById('add-pmb-routing-summary');
  if (summaryElReset) { summaryElReset.style.display = 'none'; summaryElReset.innerHTML = ''; }
  var servicesWrapReset = document.getElementById('add-pmb-services-wrap');
  if (servicesWrapReset) servicesWrapReset.style.display = 'none';
  // Welcome email is opt-in, default OFF (Jess, 2026-08-11, BUILD-partner-managed-bride-row-collision-and-welcome-controls).
  var welcomeEl = document.getElementById('add-pmb-send-welcome'); if (welcomeEl) welcomeEl.checked = false;
  var welcomeConfirmWrap = document.getElementById('add-pmb-welcome-resend-wrap'); if (welcomeConfirmWrap) welcomeConfirmWrap.remove();
  // Reset the persistent-success UI state from any previous create in this modal.
  var submitBtnReset = document.getElementById('add-pmb-submit');
  if (submitBtnReset) { submitBtnReset.style.display = ''; submitBtnReset.disabled = false; }
  var cancelBtnReset = _addPmbModalEl.querySelector('.btn-ghost[onclick="closeAddPartnerManagedBrideModal()"]');
  if (cancelBtnReset) cancelBtnReset.textContent = 'Cancel';
  _addPmbModalEl.style.display = 'flex';

  // 2026-08-19 (Jess, direct instruction: "keep it reliant on Cloudflare/local
  // data, NOT GAS"): paint instantly from the CDN island when available and
  // STOP THERE -- do not also fire a live bridge_admin_listPartners call on
  // every open. The previous version always fired the live call regardless of
  // whether the island already had a good answer, and its success handler
  // unconditionally overwrote the island's paint with whatever GAS returned
  // (see git history 2026-08-18/19) -- so a slow, erroring, or empty live
  // response could silently wipe out a correct island-painted list, or leave
  // the dropdown hung on "Loading partners..." while it waited. That matched
  // both reported failure modes ("No partner rows in CRM" and "hangs
  // indefinitely") without any bug in the island itself. Live GAS is now used
  // ONLY as the self-heal path for a genuinely empty/missing island (e.g. a
  // brand-new partner not yet warmed into the cache) -- never as a repaint
  // over an island that already worked.
  // 2026-08-20: island read is now async (gzip-safe) -- see
  // jvAdminPartnerList_getCached_'s own note.
  jvAdminPartnerList_getCached_(function(addPmbIslandPartners) {
    if (addPmbIslandPartners) {
      _addPmbPartners = addPmbIslandPartners;
      addPmbRenderPartnerOptions_(sel, addPmbIslandPartners, preselectPartnerEmail);
      return;
    }

    jvBridge.callAdmin('bridge_admin_listPartners', {})
      .then(function(res) {
        if (!res || res.success === false) {
          var errMsg = res && res.error ? res.error : 'Failed to load partners';
          if (sel) sel.innerHTML = '<option value="">' + escHtml(errMsg) + '</option>';
          return;
        }
        var livePartners = res.partners || [];
        if (!livePartners.length) {
          if (sel) sel.innerHTML = '<option value="">No partner rows in CRM</option>';
          return;
        }
        _addPmbPartners = livePartners;
        addPmbRenderPartnerOptions_(sel, livePartners, preselectPartnerEmail);
      })
      .catch(function(err) {
        if (sel) {
          sel.innerHTML = '<option value="">Error: ' + escHtml(err.message || String(err)) + '</option>';
        }
      });
  });
}

// Extracted from the inline body above (2026-08-18) so the fast-path paint and
// the live-refresh repaint share one render implementation instead of two
// copies drifting apart. Same option shape as the invoice panel's partner
// dropdown (businessName/role/rosterCount), kept as its own function rather
// than merged with invoiceRenderPartnerOptions_ because the two selects wire
// up different onchange handlers (addPmbOnPartnerChange_ vs
// invoicePartnerChange_) and this modal's preselect never needs the
// prevValue-vs-target unchanged-selection guard the invoice panel needed (this
// dropdown is freshly reset to blank every time the modal opens, never holds
// an admin's in-progress selection across a background refresh).
function addPmbRenderPartnerOptions_(sel, partners, preselectEmail) {
  if (!sel) return;
  var opts = '<option value="">Choose a partner…</option>';
  partners.forEach(function(p) {
    opts += '<option value="' + escAttr(p.email) + '">' +
      escHtml(p.businessName || p.email) +
      (p.role ? ' · ' + escHtml(p.role) : '') +
      ' (' + (p.rosterCount || 0) + ' brides)' +
      '</option>';
  });
  sel.innerHTML = opts;
  sel.onchange = function() { addPmbOnPartnerChange_(); };
  if (preselectEmail) {
    sel.value = String(preselectEmail).toLowerCase();
    addPmbOnPartnerChange_();
  }
}

// Local-only update to the routing-summary panel's "Welcome email" line when the
// checkbox is toggled -- deliberately does NOT re-fetch/re-resolve the whole
// routing summary (the welcome-email choice has no bearing on invoice/runsheet
// routing, so a full re-resolve would just be a wasted round-trip on every click).
function addPmbUpdateWelcomeLineInSummary_() {
  var summaryEl = document.getElementById('add-pmb-routing-summary');
  if (!summaryEl || summaryEl.style.display === 'none' || !summaryEl.innerHTML) return;
  var welcomeEl = document.getElementById('add-pmb-send-welcome');
  var welcomeLabel = (welcomeEl && welcomeEl.checked) ? 'On' : 'Off';
  summaryEl.innerHTML = summaryEl.innerHTML.replace(
    /<strong>Welcome email:<\/strong> (On|Off)/,
    '<strong>Welcome email:</strong> ' + welcomeLabel
  );
}

function addPmbOnPartnerChange_() {
  var sel = document.getElementById('add-pmb-partner');
  var email = (sel && sel.value) || '';
  var wrap = document.getElementById('add-pmb-services-wrap');
  var src  = document.getElementById('add-pmb-rates-source');
  var summaryEl = document.getElementById('add-pmb-routing-summary');
  if (!email) {
    if (wrap) wrap.style.display = 'none';
    if (summaryEl) summaryEl.style.display = 'none';
    _addPmbRateCard = null;
    return;
  }

  // Routing summary review (2026-08-13, BUILD-admin-crm-partner-routing-summary):
  // per the brief's own explicit ask, the final review before creating a managed
  // bride should state Partner / Billed To / Runsheet Recipient / Welcome Email
  // using the SAME resolved object every other money/comms surface reads, not a
  // separately re-derived summary. The bride herself does not exist yet at this
  // point in the flow, so this constructs the minimal synthetic client shape the
  // resolver needs (email left blank, filled in once the bride is actually
  // created below) using the selected partner's own data, already loaded into
  // _addPmbPartners when the dropdown was populated.
  var selectedPartner = (_addPmbPartners || []).filter(function (p) { return p.email === email; })[0] || {};
  if (summaryEl) {
    summaryEl.style.display = '';
    summaryEl.textContent = 'Loading routing summary...';
    resolvePartnerRoutingSummary_({
      email: '',
      isPartnerManaged: true,
      partnerAccountEmail: email,
      partnerAccountName: selectedPartner.businessName || email
    }).then(function (summary) {
      if (!sel || sel.value !== email) return; // admin already switched partners
      var partnerLabel = summary.partnerName || email;
      var welcomeEl = document.getElementById('add-pmb-send-welcome');
      var welcomeLabel = (welcomeEl && welcomeEl.checked) ? 'On' : 'Off';
      var lines = [
        '<strong>Partner:</strong> ' + escHtml(partnerLabel),
        '<strong>Billed to:</strong> ' + escHtml(summary.invoiceRecipient.type === 'partner' ? partnerLabel : 'the bride directly'),
        '<strong>Runsheet sent to:</strong> ' + escHtml(summary.runsheetRecipient.type === 'partner' ? partnerLabel : 'the bride directly'),
        '<strong>Welcome email:</strong> ' + welcomeLabel
      ];
      if (summary.settingsUnavailable) {
        lines.push('<span style="color:var(--danger);">Could not confirm this partner\'s routing settings, showing the default. Verify in Partner Settings before relying on this.</span>');
      }
      summaryEl.innerHTML = lines.join('<br>');
    });
  }
  jvBridge.callAdmin('bridge_admin_getPartnerRateCard', { partnerEmail: email })
    .then(function(res) {
      if (!res || res.success === false || !res.rateCard) {
        _addPmbRateCard = null;
        if (wrap) wrap.style.display = 'none';
        if (src) src.textContent = 'No rate card on partner — manual amount only via Bill Partner.';
        return;
      }
      _addPmbRateCard = res.rateCard;
      if (wrap) wrap.style.display = '';
      if (src) src.textContent = 'Rates auto-filled from ' + (sel.options[sel.selectedIndex] || {}).text;
      // Reset rows + override fields when partner switches
      _addPmbPartyRowCount = 0;
      _addPmbTrialRowCount = 0;
      var pRows = document.getElementById('add-pmb-party-rows');  if (pRows) pRows.innerHTML = '';
      var tRows = document.getElementById('add-pmb-trial-rows');  if (tRows) tRows.innerHTML = '';
      addPmbAddPartyRow_();  // start with one party row by default
      addPmbRefreshTotal_();
    })
    .catch(function(err) {
      _addPmbRateCard = null;
      if (src) src.textContent = 'Rate card load error: ' + (err.message || String(err));
      if (wrap) wrap.style.display = 'none';
    });
}

function addPmbAddPartyRow_() {
  var host = document.getElementById('add-pmb-party-rows');
  if (!host) return;
  var idx = ++_addPmbPartyRowCount;
  var row = document.createElement('div');
  // Row class carries the 'pmb' prefix the shared helpers query on
  // (.pmb-party-row), while the element also keeps its historical
  // 'add-pmb-party-row' class so every existing selector keeps working.
  row.className = 'add-pmb-party-row pmb-party-row';
  row.dataset.idx = idx;
  row.style.cssText = JV_PMB_PARTY_ROW_GRID_;
  row.innerHTML = jvPmbPartyRowHtml_('pmb', 'addPmbRefreshTotal_', 'addPmbRemoveRow_');
  host.appendChild(row);
}

function addPmbAddTrialRow_() {
  var host = document.getElementById('add-pmb-trial-rows');
  if (!host) return;
  var idx = ++_addPmbTrialRowCount;
  var row = document.createElement('div');
  row.className = 'add-pmb-trial-row';
  row.dataset.idx = idx;
  row.style.cssText = 'display:grid;grid-template-columns:1fr 110px 28px;gap:0.4rem;align-items:center;';
  row.innerHTML =
    '<select class="filter-select pmb-trial-type" style="width:100%;border-radius:var(--radius-small);" onchange="addPmbRefreshTotal_()">' +
      '<option value="hairAndMakeup">Hair &amp; Makeup</option>' +
      '<option value="hairOnly">Hair only</option>' +
      '<option value="makeupOnly">Makeup only</option>' +
    '</select>' +
    '<input type="number" class="filter-select pmb-trial-amt" min="0" step="0.01" placeholder="$ override" style="width:100%;border-radius:var(--radius-small);" oninput="addPmbRefreshTotal_()">' +
    '<button type="button" class="btn btn-ghost" style="padding:0;width:28px;height:28px;font-size:0.9rem;line-height:1;" onclick="addPmbRemoveRow_(this)" title="Remove">&times;</button>';
  host.appendChild(row);
}

function addPmbRemoveRow_(btn) {
  if (!btn) return;
  var row = btn.closest('.add-pmb-party-row, .add-pmb-trial-row');
  if (row && row.parentNode) row.parentNode.removeChild(row);
  addPmbRefreshTotal_();
}

function addPmbCollectBreakdown_() {
  function rate(group, type) {
    var rc = _addPmbRateCard || {};
    var g  = rc[group] || {};
    var v  = g[type];
    return (v != null && !isNaN(Number(v))) ? Number(v) : 0;
  }

  var bd = { bride: null, party: [], trials: [], travel: {} };

  // Bride
  var brideType = (document.getElementById('add-pmb-bride-svc-type') || {}).value || '';
  if (brideType) {
    var brideOverride = parseFloat((document.getElementById('add-pmb-bride-svc-amt') || {}).value || '0');
    bd.bride = { type: brideType };
    if (brideOverride > 0) bd.bride.overrideAmount = brideOverride;
  }

  // Party rows. Shared collector so this picker, bp* and abp-bp-* all emit
  // the identical payload shape (see the shared-helpers block above).
  Array.prototype.forEach.call(document.querySelectorAll('.add-pmb-party-row'), function(row) {
    var entry = jvPmbCollectPartyRow_(row, 'pmb');
    if (entry) bd.party.push(entry);
  });

  // Trial rows
  Array.prototype.forEach.call(document.querySelectorAll('.add-pmb-trial-row'), function(row) {
    var type     = (row.querySelector('.pmb-trial-type') || {}).value || '';
    var override = parseFloat((row.querySelector('.pmb-trial-amt') || {}).value || '0');
    if (!type) return;
    var entry = { type: type };
    if (override > 0) entry.overrideAmount = override;
    bd.trials.push(entry);
  });

  // Travel
  bd.travel.includeJess         = !!(document.getElementById('add-pmb-travel-jess') || {}).checked;
  bd.travel.proTeamArtistCount  = parseInt((document.getElementById('add-pmb-travel-pro-count') || {}).value || '0', 10) || 0;
  bd.travel.trialKm             = parseFloat((document.getElementById('add-pmb-trial-km') || {}).value || '0') || 0;
  var jessOverride  = parseFloat((document.getElementById('add-pmb-travel-jess-amt') || {}).value || '0');
  var proOverride   = parseFloat((document.getElementById('add-pmb-travel-pro-amt')  || {}).value || '0');
  var perKmOverride = parseFloat((document.getElementById('add-pmb-trial-perkm-amt') || {}).value || '0');
  if (jessOverride  > 0) bd.travel.overrideJess              = jessOverride;
  if (proOverride   > 0) bd.travel.overrideProTeamPerArtist  = proOverride;
  if (perKmOverride > 0) bd.travel.overrideTrialPerKm        = perKmOverride;

  return bd;
}

function addPmbRefreshTotal_() {
  // Keep the junior input consistent with the chosen role BEFORE collecting,
  // so the total is never computed from a value the row is about to clear.
  jvPmbSyncPartyRowControls_('pmb');
  var bd = addPmbCollectBreakdown_();
  var rc = _addPmbRateCard || {};
  var subtotal = 0;
  function r(group, type, override) {
    if (override != null && Number(override) > 0) return Number(override);
    var v = (rc[group] || {})[type];
    return (v != null && !isNaN(Number(v))) ? Number(v) : 0;
  }
  if (bd.bride && bd.bride.type) subtotal += r('bride', bd.bride.type, bd.bride.overrideAmount);
  // Shared pricing: handles nested roles AND the junior-bridesmaid discount,
  // mirroring PartnerManagedCore.gs. Must not revert to a flat
  // rate * count, that would show a total the invoice disagrees with.
  bd.party.forEach(function(p)  { subtotal += jvPmbPartyEntryTotal_(p, rc); });
  bd.trials.forEach(function(t) { subtotal += r('trial', t.type, t.overrideAmount); });
  if (bd.travel.includeJess) {
    subtotal += (bd.travel.overrideJess != null && bd.travel.overrideJess > 0)
      ? bd.travel.overrideJess
      : Number((rc.travel || {}).jess || 0);
  }
  if (bd.travel.proTeamArtistCount > 0) {
    var pa = (bd.travel.overrideProTeamPerArtist != null && bd.travel.overrideProTeamPerArtist > 0)
      ? bd.travel.overrideProTeamPerArtist
      : Number((rc.travel || {}).proTeamPerArtist || 0);
    subtotal += pa * bd.travel.proTeamArtistCount;
  }
  if (bd.travel.trialKm > 0) {
    var pk = (bd.travel.overrideTrialPerKm != null && bd.travel.overrideTrialPerKm > 0)
      ? bd.travel.overrideTrialPerKm
      : Number((rc.travel || {}).trialPerKm || 0);
    subtotal += pk * bd.travel.trialKm;
  }
  var ex   = Math.round(subtotal * 100) / 100;
  var gst  = Math.round(ex * 0.1 * 100) / 100;
  var inc  = Math.round((ex + gst) * 100) / 100;
  function fmt(n) { return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  var ex_el = document.getElementById('add-pmb-total-ex');  if (ex_el)  ex_el.textContent  = fmt(ex);
  var g_el  = document.getElementById('add-pmb-total-gst'); if (g_el)   g_el.textContent   = fmt(gst);
  var in_el = document.getElementById('add-pmb-total-inc'); if (in_el)  in_el.textContent  = fmt(inc);
  // Update submit button label
  var btn = document.getElementById('add-pmb-submit');
  if (btn) btn.textContent = (inc > 0) ? ('Create Bride + Invoice ' + fmt(inc)) : 'Create Bride & Onboard';
  // Unpriceable guard (2026-09-12, Cowork §2.3). Runs AFTER the label is set so
  // it can override both the label and the enabled state. Without this, seats
  // the stored rate card cannot price contribute 0 and the button offers to
  // invoice without them, silently.
  jvPmbApplyUnpriceableGuard_(bd.party, rc, BP_SERVICE_LABELS_,
    'add-pmb-unpriceable-warning', 'add-pmb-submit', 'Fix unpriced seats to continue');
}

function closeAddPartnerManagedBrideModal() {
  if (_addPmbModalEl) _addPmbModalEl.style.display = 'none';
  // Reset services-panel state so reopening starts clean
  _addPmbRateCard = null;
  _addPmbPartyRowCount = 0;
  _addPmbTrialRowCount = 0;
  var wrap = document.getElementById('add-pmb-services-wrap'); if (wrap) wrap.style.display = 'none';
  var pRows = document.getElementById('add-pmb-party-rows');   if (pRows) pRows.innerHTML = '';
  var tRows = document.getElementById('add-pmb-trial-rows');   if (tRows) tRows.innerHTML = '';
}

/* ============================================================
   BILL PARTNER, service picker (mode c serviceLines, 2026-09-10)
   ============================================================
   Closes the gap flagged by the Vendor & Partner Manager Agent:
   bridge_admin_billPartner has 3 payload modes, but only mode (c)
   serviceLines feeds bbsCharges_prefillFromPartnerInvoice_ (the real
   BBS/entitlement write), and no frontend code anywhere built
   serviceLines, so every real "Bill a Partner" click only ever sent a
   flat dollar amount (mode a), correctly invoicing Xero but silently
   never writing the BBS entitlement data the runsheet builder, trial
   system, and artist-allocation logic all need for a partner-managed
   bride.

   Same {bride, party, trials, travel} breakdown shape and rate-card
   field names as addPmbCollectBreakdown_/addPmbRefreshTotal_ above
   (Add Partner Managed Bride modal), deliberately a SEPARATE, bp-
   prefixed copy, not a shared refactor, so this modal's logic can
   never accidentally regress that tested flow, and vice versa. Keep
   both in sync manually if the rate-card shape ever changes.
   ============================================================ */
var _bpRateCard = null;
var _bpPartyRowCount = 0;
var _bpTrialRowCount = 0;

function bpOnModeChange_() {
  var isServices = (document.getElementById('bp-mode-services') || {}).checked;
  var svcWrap = document.getElementById('bp-services-wrap');
  var manWrap = document.getElementById('bp-manual-wrap');
  if (svcWrap) svcWrap.style.display = isServices ? '' : 'none';
  if (manWrap) manWrap.style.display = isServices ? 'none' : '';
}

function bpAddPartyRow_() {
  var host = document.getElementById('bp-party-rows');
  if (!host) return;
  var idx = ++_bpPartyRowCount;
  var row = document.createElement('div');
  row.className = 'bp-party-row';
  row.dataset.idx = idx;
  row.style.cssText = JV_PMB_PARTY_ROW_GRID_;
  row.innerHTML = jvPmbPartyRowHtml_('bp', 'bpRefreshTotal_', 'bpRemoveRow_');
  host.appendChild(row);
}

function bpAddTrialRow_() {
  var host = document.getElementById('bp-trial-rows');
  if (!host) return;
  var idx = ++_bpTrialRowCount;
  var row = document.createElement('div');
  row.className = 'bp-trial-row';
  row.dataset.idx = idx;
  row.style.cssText = 'display:grid;grid-template-columns:1fr 110px 28px;gap:0.4rem;align-items:center;';
  row.innerHTML =
    '<select class="filter-select bp-trial-type" style="width:100%;border-radius:var(--radius-small);" onchange="bpRefreshTotal_()">' +
      '<option value="hairAndMakeup">Hair &amp; Makeup</option>' +
      '<option value="hairOnly">Hair only</option>' +
      '<option value="makeupOnly">Makeup only</option>' +
    '</select>' +
    '<input type="number" class="filter-select bp-trial-amt" min="0" step="0.01" placeholder="$ override" style="width:100%;border-radius:var(--radius-small);" oninput="bpRefreshTotal_()">' +
    '<button type="button" class="btn btn-ghost" style="padding:0;width:28px;height:28px;font-size:0.9rem;line-height:1;" onclick="bpRemoveRow_(this)" title="Remove">&times;</button>';
  host.appendChild(row);
}

function bpRemoveRow_(btn) {
  if (!btn) return;
  var row = btn.closest('.bp-party-row, .bp-trial-row');
  if (row && row.parentNode) row.parentNode.removeChild(row);
  bpRefreshTotal_();
}

function bpCollectBreakdown_() {
  var bd = { bride: null, party: [], trials: [], travel: {} };

  var brideType = (document.getElementById('bp-bride-svc-type') || {}).value || '';
  if (brideType) {
    var brideOverride = parseFloat((document.getElementById('bp-bride-svc-amt') || {}).value || '0');
    bd.bride = { type: brideType };
    if (brideOverride > 0) bd.bride.overrideAmount = brideOverride;
  }

  // Shared collector, identical payload shape to addPmb* and abp-bp-*.
  Array.prototype.forEach.call(document.querySelectorAll('.bp-party-row'), function(row) {
    var entry = jvPmbCollectPartyRow_(row, 'bp');
    if (entry) bd.party.push(entry);
  });

  Array.prototype.forEach.call(document.querySelectorAll('.bp-trial-row'), function(row) {
    var type     = (row.querySelector('.bp-trial-type') || {}).value || '';
    var override = parseFloat((row.querySelector('.bp-trial-amt') || {}).value || '0');
    if (!type) return;
    var entry = { type: type };
    if (override > 0) entry.overrideAmount = override;
    bd.trials.push(entry);
  });

  bd.travel.includeJess        = !!(document.getElementById('bp-travel-jess') || {}).checked;
  bd.travel.proTeamArtistCount = parseInt((document.getElementById('bp-travel-pro-count') || {}).value || '0', 10) || 0;
  bd.travel.trialKm            = parseFloat((document.getElementById('bp-trial-km') || {}).value || '0') || 0;
  var jessOverride  = parseFloat((document.getElementById('bp-travel-jess-amt') || {}).value || '0');
  var proOverride   = parseFloat((document.getElementById('bp-travel-pro-amt')  || {}).value || '0');
  var perKmOverride = parseFloat((document.getElementById('bp-trial-perkm-amt') || {}).value || '0');
  if (jessOverride  > 0) bd.travel.overrideJess             = jessOverride;
  if (proOverride   > 0) bd.travel.overrideProTeamPerArtist = proOverride;
  if (perKmOverride > 0) bd.travel.overrideTrialPerKm       = perKmOverride;

  return bd;
}

// Converts the breakdown + resolved rate-card values directly into mode (c)
// serviceLines: [{serviceId, description, qty, unitAmountCents, category?}].
// Deliberately NOT routed through partnerBooking_composeLineItemsFromRateCard_
// (mode b, lineItems), that shape has no serviceId/qty/category and does not
// feed bbsCharges_prefillFromPartnerInvoice_, which is the whole point of
// building this. unitAmountCents is EX-GST integer cents per unit.
// Mirrors PARTNER_MANAGED_SERVICE_LABELS_ in PartnerManagedCore.gs, including
// the three nested party roles added 2026-09-11. Keep both in step: these
// strings land on the real invoice a partner receives.
var BP_SERVICE_LABELS_ = {
  hairAndMakeup: 'Hair & Makeup',
  hairOnly:      'Hair',
  makeupOnly:    'Makeup',
  maleGrooming:  'Male Grooming',
  mother:        'Mother',
  guest:         'Guest',
  flowergirl:    'Flowergirl'
};

function bpBuildServiceLines_(bd, rc) {
  rc = rc || {};
  function rate(group, type, override) {
    if (override != null && Number(override) > 0) return Number(override);
    var v = (rc[group] || {})[type];
    return (v != null && !isNaN(Number(v))) ? Number(v) : 0;
  }
  var lines = [];
  function push(serviceId, description, qty, unitAmount, category) {
    var cents = Math.round(Number(unitAmount) * 100);
    if (!cents || cents <= 0) return;
    lines.push({ serviceId: serviceId, description: description, qty: qty || 1, unitAmountCents: cents, category: category });
  }

  if (bd.bride && bd.bride.type) {
    var br = rate('bride', bd.bride.type, bd.bride.overrideAmount);
    push('bride_' + bd.bride.type, 'Bride ' + (BP_SERVICE_LABELS_[bd.bride.type] || bd.bride.type), 1, br, 'services');
  }
  // Party seats. Uses the shared split so a nested role (Mother/Guest/
  // Flowergirl) prices from its own nested rate-card entry, and juniors become
  // their own discounted line, exactly as PartnerManagedCore.gs does. A flat
  // `rate('party', p.type)` here would silently bill a Mother seat at the
  // generic bridal-party rate and drop the junior discount entirely.
  bd.party.forEach(function(p) {
    var baseId = jvPmbPartyServiceId_(p);
    jvPmbPartyLineSplit_(p, rc, BP_SERVICE_LABELS_).forEach(function (ln) {
      push(baseId + (ln.junior ? '_junior' : ''), 'Bridal party ' + ln.label, ln.qty, ln.unitAmount, 'party_size');
    });
  });
  bd.trials.forEach(function(t, ix) {
    var tr = rate('trial', t.type, t.overrideAmount);
    var suffix = (bd.trials.length > 1) ? ' #' + (ix + 1) : '';
    push('trial_' + t.type + '_' + (ix + 1), 'Trial ' + (BP_SERVICE_LABELS_[t.type] || t.type) + suffix, 1, tr, 'trial');
  });
  if (bd.travel.includeJess) {
    var jr = (bd.travel.overrideJess != null && bd.travel.overrideJess > 0) ? bd.travel.overrideJess : Number((rc.travel || {}).jess || 0);
    push('travel_jess', 'Travel, Jessica Vegas', 1, jr, 'travel');
  }
  if (bd.travel.proTeamArtistCount > 0) {
    var pa = (bd.travel.overrideProTeamPerArtist != null && bd.travel.overrideProTeamPerArtist > 0) ? bd.travel.overrideProTeamPerArtist : Number((rc.travel || {}).proTeamPerArtist || 0);
    push('travel_pro_team', 'Travel, Pro Team artists', bd.travel.proTeamArtistCount, pa, 'additional_artists');
  }
  if (bd.travel.trialKm > 0) {
    var pk = (bd.travel.overrideTrialPerKm != null && bd.travel.overrideTrialPerKm > 0) ? bd.travel.overrideTrialPerKm : Number((rc.travel || {}).trialPerKm || 0);
    push('travel_trial_km', 'Trial travel (' + bd.travel.trialKm + ' km)', 1, pk * bd.travel.trialKm, 'travel');
  }
  return lines;
}

function bpRefreshTotal_() {
  jvPmbSyncPartyRowControls_('bp');
  var bd = bpCollectBreakdown_();
  var lines = bpBuildServiceLines_(bd, _bpRateCard);
  var exCents = lines.reduce(function(sum, l) { return sum + (l.unitAmountCents * l.qty); }, 0);
  var ex  = exCents / 100;
  var gst = Math.round(ex * 0.1 * 100) / 100;
  var inc = Math.round((ex + gst) * 100) / 100;
  function fmt(n) { return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  var exEl  = document.getElementById('bp-total-ex');  if (exEl)  exEl.textContent  = fmt(ex);
  var gEl   = document.getElementById('bp-total-gst'); if (gEl)   gEl.textContent   = fmt(gst);
  var incEl = document.getElementById('bp-total-inc'); if (incEl) incEl.textContent = fmt(inc);
  // Unpriceable guard (2026-09-12, Cowork 2.3), see jvPmbApplyUnpriceableGuard_.
  jvPmbApplyUnpriceableGuard_(bd.party, _bpRateCard, BP_SERVICE_LABELS_,
    'bp-unpriceable-warning', 'bill-partner-submit', 'Fix unpriced seats to continue');
}

/* ============================================================
   BILL PARTNER, modal (phase 7 follow-on)
   ============================================================ */
var _billPartnerModalEl = null;
var _billPartnerClientId = null;

function openBillPartnerModal(clientId) {
  _billPartnerModalEl = document.getElementById('bill-partner-modal');
  if (!_billPartnerModalEl) { console.warn('[bill-partner] modal not in DOM'); return; }
  _billPartnerClientId = clientId;

  var c = _lastDrawerClient || {};
  var brideLabel  = (c.name || 'bride') + (c.weddingDate ? ' (' + c.weddingDate + ')' : '');
  var partnerName = c.partnerAccountName || c.partnerAccountEmail || 'partner';

  var titleEl   = document.getElementById('bill-partner-title');
  var brideEl   = document.getElementById('bill-partner-bride');
  var partnerEl = document.getElementById('bill-partner-partner');
  var amtEl     = document.getElementById('bill-partner-amount');
  var termsEl   = document.getElementById('bill-partner-terms');
  var dueEl     = document.getElementById('bill-partner-duedate');
  var notesEl   = document.getElementById('bill-partner-notes');
  var statusEl  = document.getElementById('bill-partner-status');
  var btnEl     = document.getElementById('bill-partner-submit');

  if (titleEl)   titleEl.textContent = 'Bill ' + partnerName + ' for ' + (c.name || 'this bride');
  if (brideEl)   brideEl.textContent = brideLabel;
  if (partnerEl) partnerEl.textContent = partnerName + (c.partnerAccountEmail ? ' (' + c.partnerAccountEmail + ')' : '');
  if (amtEl)     amtEl.value = '';
  if (termsEl)   termsEl.value = 'net_14';
  if (dueEl)     dueEl.value = '';
  if (notesEl)   notesEl.value = '';
  if (statusEl)  statusEl.textContent = '';
  if (btnEl)     { btnEl.disabled = false; btnEl.textContent = 'Create Invoice in Xero'; }

  // Service picker reset (mode c serviceLines, 2026-09-10), see the bp*
  // function block above openBillPartnerModal for the full context.
  _bpRateCard = null;
  _bpPartyRowCount = 0; _bpTrialRowCount = 0;
  var bpPartyRowsEl = document.getElementById('bp-party-rows'); if (bpPartyRowsEl) bpPartyRowsEl.innerHTML = '';
  var bpTrialRowsEl = document.getElementById('bp-trial-rows'); if (bpTrialRowsEl) bpTrialRowsEl.innerHTML = '';
  var bpModeServicesEl = document.getElementById('bp-mode-services');
  if (bpModeServicesEl) bpModeServicesEl.checked = true;
  bpOnModeChange_();

  var bpSrc = document.getElementById('bp-rates-source');
  if (c.partnerAccountEmail) {
    jvBridge.callAdmin('bridge_admin_getPartnerRateCard', { partnerEmail: c.partnerAccountEmail })
      .then(function(res) {
        if (_billPartnerClientId !== clientId) return;
        if (!res || res.success === false || !res.rateCard) {
          _bpRateCard = null;
          if (bpSrc) bpSrc.textContent = 'No rate card on partner, use Manual amount.';
          var bpModeManualEl1 = document.getElementById('bp-mode-manual');
          if (bpModeManualEl1) bpModeManualEl1.checked = true;
          bpOnModeChange_();
          return;
        }
        _bpRateCard = res.rateCard;
        if (bpSrc) bpSrc.textContent = 'Rates auto-filled from ' + partnerName;
        bpAddPartyRow_();
        bpRefreshTotal_();
      })
      .catch(function() {
        _bpRateCard = null;
        if (bpSrc) bpSrc.textContent = 'Rate card load error, use Manual amount.';
        var bpModeManualEl2 = document.getElementById('bp-mode-manual');
        if (bpModeManualEl2) bpModeManualEl2.checked = true;
        bpOnModeChange_();
      });
  } else {
    var bpModeManualEl3 = document.getElementById('bp-mode-manual');
    if (bpModeManualEl3) bpModeManualEl3.checked = true;
    bpOnModeChange_();
  }

  _billPartnerModalEl.style.display = 'flex';

  // Routing-summary check (2026-08-13, BUILD-admin-crm-partner-routing-summary):
  // this modal is titled "Bill [Partner]" purely from the presence of a partner
  // link on the bride (partnerAccountName/Email), never checking whether that
  // partner's OWN settings actually route invoices to her or to the bride
  // directly, exactly the drift risk the routing-summary brief describes.
  // Resolve it and correct the title/status if it disagrees, rather than
  // silently letting the admin send a partner invoice a bride should have
  // received directly. Fires after the modal is already visible so this never
  // blocks opening it (the fast path above is unchanged); it only refines what's
  // shown, same non-blocking pattern this file uses elsewhere for async verify.
  resolvePartnerRoutingSummary_(c).then(function (summary) {
    if (_billPartnerClientId !== clientId) return; // admin already moved to a different client
    if (summary.invoiceRecipient.type === 'bride') {
      if (titleEl)  titleEl.textContent = 'Bill ' + (c.name || 'this bride') + ' directly';
      if (statusEl) statusEl.textContent = partnerName + ' settings route invoices to the bride, not the partner. ' +
        'This form still creates an invoice for this bride, confirm this is intended before sending.';
    } else if (summary.settingsUnavailable) {
      if (statusEl) statusEl.textContent = 'Could not confirm ' + partnerName + ' invoice routing preference, defaulting to partner, verify before sending.';
    }
  });
}

function closeBillPartnerModal() {
  if (_billPartnerModalEl) _billPartnerModalEl.style.display = 'none';
}

function submitBillPartner() {
  var isServices = (document.getElementById('bp-mode-services') || {}).checked;
  var terms   = (document.getElementById('bill-partner-terms')   || {}).value || 'net_14';
  var dueDate = (document.getElementById('bill-partner-duedate') || {}).value || '';
  var notes   = (document.getElementById('bill-partner-notes')   || {}).value || '';
  var statusEl = document.getElementById('bill-partner-status');
  var btnEl    = document.getElementById('bill-partner-submit');

  if (!_billPartnerClientId) {
    if (statusEl) statusEl.textContent = 'Missing clientId, close and reopen the bride drawer.';
    return;
  }

  var payload = { clientId: _billPartnerClientId, terms: terms, dueDate: dueDate, notes: notes };

  // Service package (mode c serviceLines) vs Manual amount (mode a), see the
  // bp* function block above openBillPartnerModal for the full context on
  // why mode c is the only one that feeds the real BBS entitlement write.
  if (isServices) {
    var bd = bpCollectBreakdown_();
    var lines = bpBuildServiceLines_(bd, _bpRateCard);
    if (!lines.length) {
      if (statusEl) statusEl.textContent = 'Add at least one priced service, or switch to Manual amount.';
      return;
    }
    payload.serviceLines = lines;
  } else {
    var amount = parseFloat((document.getElementById('bill-partner-amount') || {}).value || '0');
    if (!amount || isNaN(amount) || amount <= 0) {
      if (statusEl) statusEl.textContent = 'Enter an amount greater than zero (dollars, GST-inclusive).';
      return;
    }
    payload.amount = amount;
  }

  if (statusEl) statusEl.textContent = 'Sending to Xero via Pabbly, may take a few seconds.';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Creating...'; }

  jvBridge.callAdmin('bridge_admin_billPartner', payload)
    .then(function(res) {
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Create Invoice in Xero'; }
      if (!res || res.success === false) {
        var msg = (res && res.message) || (res && res.error) || 'unknown error';
        if (statusEl) statusEl.textContent = 'Error: ' + msg;
        return;
      }
      var lines = [];
      lines.push('Invoiced ' + (res.billedTo || 'partner') + ' $' + Number(res.amount || 0).toFixed(2) + ' for ' + (res.forBride || 'bride') + '.');
      if (res.invoiceNumber) lines.push('Xero invoice: ' + res.invoiceNumber);
      if (res.dueDate)       lines.push('Due: ' + res.dueDate);
      if (res.onlineInvoiceUrl) {
        lines.push('<a href="' + res.onlineInvoiceUrl + '" target="_blank" rel="noopener" style="color:var(--brand-primary-deep);font-weight:600;">Open in Xero ↗</a>');
      }
      if (statusEl) statusEl.innerHTML = lines.join('<br>');
      if (btnEl) btnEl.textContent = 'Done';
    })
    .catch(function(err) {
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Create Invoice in Xero'; }
      if (statusEl) statusEl.textContent = 'Error: ' + (err.message || String(err));
    });
}

/* ====================================================================
   Payment Plan modal
   ==================================================================== */

var _paymentPlanData      = null;
var _paymentPlanRows      = [];
var _paymentPlanInFlight  = false;

function openPaymentPlanModal() {
  var modal = document.getElementById('payment-plan-modal');
  if (!modal) { console.warn('[payment-plan] modal not in DOM'); return; }

  var c = _lastDrawerClient || {};
  if (!c.email) { alert('No bride email on record.'); return; }

  _paymentPlanData     = null;
  _paymentPlanRows     = [];
  _paymentPlanInFlight = false;

  var titleEl  = document.getElementById('pp-title');
  var bodyEl   = document.getElementById('pp-body');
  var statusEl = document.getElementById('pp-status');
  if (titleEl)  titleEl.textContent = 'Payment Plan' + (c.name ? ': ' + c.name : '');
  if (bodyEl)   bodyEl.innerHTML = '<p style="color:var(--muted);text-align:center;padding:24px 0;">Loading balance...</p>';
  if (statusEl) statusEl.textContent = '';

  modal.style.display = 'flex';

  jvBridge.callAdmin('bridge_admin_getPaymentPlanData', { email: c.email })
    .then(function(res) {
      if (!res || !res.ok) {
        if (bodyEl) bodyEl.innerHTML = '<p style="color:var(--brand-error,#c0392b);padding:16px 0;">Error: ' + escHtml((res && res.error) || 'Could not load plan data.') + '</p>';
        return;
      }
      _paymentPlanData = res;
      renderPaymentPlanBody_();
    })
    .catch(function(err) {
      if (bodyEl) bodyEl.innerHTML = '<p style="color:var(--brand-error,#c0392b);padding:16px 0;">Error: ' + escHtml(err.message || String(err)) + '</p>';
    });
}

function closePaymentPlanModal() {
  var modal = document.getElementById('payment-plan-modal');
  if (modal) modal.style.display = 'none';
}

function renderPaymentPlanBody_() {
  var d      = _paymentPlanData;
  var bodyEl = document.getElementById('pp-body');
  if (!bodyEl || !d) return;

  if (d.existingPlan && (d.existingPlan.status === 'active' || d.existingPlan.status === 'partial')) {
    bodyEl.innerHTML = renderPaymentPlanReadOnly_(d);
    return;
  }

  var fmtAmt = function(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  var html = '';
  html += '<div style="display:flex;gap:12px;margin-bottom:20px;flex-wrap:wrap;">';
  html += '<div style="flex:1;min-width:110px;background:var(--surface-soft,#f6f1ee);border-radius:10px;padding:12px 14px;">';
  html += '<div style="font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);margin-bottom:4px;">Total Package</div>';
  html += '<div style="font-weight:600;color:var(--text);">' + fmtAmt(d.totalCents || 0) + '</div></div>';
  html += '<div style="flex:1;min-width:110px;background:var(--surface-soft,#f6f1ee);border-radius:10px;padding:12px 14px;">';
  html += '<div style="font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);margin-bottom:4px;">Booking Fee Paid</div>';
  html += '<div style="font-weight:600;color:var(--text);">' + fmtAmt(d.depositCents || 0) + '</div></div>';
  html += '<div style="flex:1;min-width:110px;background:#fdf8f7;border:1.5px solid var(--brand-primary);border-radius:10px;padding:12px 14px;">';
  html += '<div style="font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:var(--brand-primary-deep);margin-bottom:4px;">Remaining</div>';
  html += '<div style="font-weight:700;color:var(--brand-primary-deep);">' + fmtAmt(d.finalBalanceCents || 0) + '</div></div>';
  html += '</div>';

  if (!d.gcMandateActive) {
    html += '<div style="margin-bottom:16px;padding:10px 14px;background:#fff8f0;border-left:3px solid #e8a030;border-radius:0 8px 8px 0;font-size:0.8rem;color:#7a5a1e;">';
    html += 'No GoCardless mandate on file. A direct debit setup link will be included in the confirmation email.</div>';
  }
  if (d.weddingDate) {
    html += '<div style="margin-bottom:16px;font-size:0.8125rem;color:var(--muted);">Wedding date: <strong style="color:var(--text);">' + escHtml(d.weddingDate) + '</strong></div>';
  }

  html += '<div style="display:flex;gap:8px;margin-bottom:16px;">';
  html += '<button id="pp-tab-monthly" class="btn btn-primary btn-sm" onclick="switchPlanTab_(\'monthly\')" style="border-radius:999px;">Monthly</button>';
  html += '<button id="pp-tab-custom"  class="btn btn-ghost  btn-sm" onclick="switchPlanTab_(\'custom\')"  style="border-radius:999px;">Custom</button>';
  html += '</div>';

  html += '<div id="pp-monthly-section">';
  html += '<div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end;margin-bottom:12px;">';
  html += '<div><label style="display:block;font-size:0.75rem;font-weight:600;color:var(--muted);margin-bottom:4px;">Number of instalments</label>';
  html += '<input id="pp-num-inst" type="number" min="2" max="12" value="3" style="width:80px;padding:8px 10px;border:1.5px solid #e6dad4;border-radius:8px;font-size:0.9rem;" onchange="generateMonthlyInstallments_()"></div>';
  html += '<div><label style="display:block;font-size:0.75rem;font-weight:600;color:var(--muted);margin-bottom:4px;">First payment date</label>';
  html += '<input id="pp-first-date" type="date" style="padding:8px 10px;border:1.5px solid #e6dad4;border-radius:8px;font-size:0.9rem;" onchange="generateMonthlyInstallments_()"></div>';
  html += '<button class="btn btn-ghost btn-sm" onclick="generateMonthlyInstallments_()">Generate</button>';
  html += '</div></div>';

  html += '<div id="pp-custom-section" style="display:none;">';
  html += '<div id="pp-custom-rows"></div>';
  html += '<button class="btn btn-ghost btn-sm" onclick="addCustomInstallmentRow_()" style="margin-top:8px;width:100%;">+ Add instalment</button>';
  html += '</div>';

  html += '<div id="pp-preview" style="margin-top:16px;"></div>';
  html += '<div style="margin-top:20px;">';
  html += '<button id="pp-submit-btn" class="btn btn-primary" onclick="submitPaymentPlan()" style="width:100%;" disabled>Create plan and email bride</button>';
  html += '</div>';
  html += '<div id="pp-status" style="margin-top:10px;min-height:18px;font-size:0.8125rem;"></div>';

  bodyEl.innerHTML = html;

  var minDate = new Date();
  minDate.setDate(minDate.getDate() + 3);
  var firstDateEl = document.getElementById('pp-first-date');
  if (firstDateEl) {
    firstDateEl.min   = minDate.toISOString().split('T')[0];
    firstDateEl.value = minDate.toISOString().split('T')[0];
  }
  generateMonthlyInstallments_();
}

function renderPaymentPlanReadOnly_(d) {
  var plan   = d.existingPlan;
  var fmtAmt = function(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var html   = '<div style="margin-bottom:12px;padding:10px 14px;background:#f0faf4;border-left:3px solid #2d7d4f;border-radius:0 8px 8px 0;font-size:0.8rem;color:#1a4a2e;">Active payment plan in progress. To modify instalments, update them directly in GoCardless.</div>';
  html += '<table style="width:100%;border-collapse:collapse;font-size:0.875rem;">';
  html += '<thead><tr><th style="text-align:left;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Instalment</th><th style="text-align:left;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Date</th><th style="text-align:right;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Amount</th><th style="text-align:center;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Status</th></tr></thead><tbody>';
  (plan.installments || []).forEach(function(inst) {
    var paid   = inst.status === 'confirmed' || inst.status === 'paid_out';
    var sBg    = paid ? '#f0faf4' : '#f6f1ee';
    var sColor = paid ? '#1a4a2e' : '#5c4d4a';
    html += '<tr><td style="padding:8px 0;border-bottom:1px solid #f0e8e6;">Instalment ' + inst.seq + '</td>';
    html += '<td style="padding:8px 0;border-bottom:1px solid #f0e8e6;">' + escHtml(inst.chargeDate) + '</td>';
    html += '<td style="padding:8px 0;text-align:right;border-bottom:1px solid #f0e8e6;font-weight:600;">' + fmtAmt(inst.amountCents) + '</td>';
    html += '<td style="padding:8px 0;text-align:center;border-bottom:1px solid #f0e8e6;"><span style="display:inline-block;padding:2px 10px;border-radius:999px;background:' + sBg + ';color:' + sColor + ';font-size:0.7rem;font-weight:600;text-transform:uppercase;">' + escHtml(inst.status) + '</span></td></tr>';
  });
  html += '</tbody></table>';
  return html;
}

function switchPlanTab_(mode) {
  var monthlyEl = document.getElementById('pp-monthly-section');
  var customEl  = document.getElementById('pp-custom-section');
  var tabM      = document.getElementById('pp-tab-monthly');
  var tabC      = document.getElementById('pp-tab-custom');
  if (!monthlyEl || !customEl) return;
  if (mode === 'monthly') {
    monthlyEl.style.display = '';
    customEl.style.display  = 'none';
    if (tabM) tabM.className = 'btn btn-primary btn-sm';
    if (tabC) tabC.className = 'btn btn-ghost  btn-sm';
    generateMonthlyInstallments_();
  } else {
    monthlyEl.style.display = 'none';
    customEl.style.display  = '';
    if (tabM) tabM.className = 'btn btn-ghost  btn-sm';
    if (tabC) tabC.className = 'btn btn-primary btn-sm';
    if (!_paymentPlanRows.length) addCustomInstallmentRow_();
    renderCustomRows_();
    renderPlanPreview_();
  }
}

function generateMonthlyInstallments_() {
  var d       = _paymentPlanData;
  var numEl   = document.getElementById('pp-num-inst');
  var firstEl = document.getElementById('pp-first-date');
  if (!d || !numEl || !firstEl || !firstEl.value) return;

  var n          = Math.max(2, Math.min(12, parseInt(numEl.value) || 3));
  var remaining  = d.finalBalanceCents || 0;
  var base       = Math.floor(remaining / n);
  var leftover   = remaining - base * n;

  _paymentPlanRows = [];
  var d0 = new Date(firstEl.value);
  for (var i = 0; i < n; i++) {
    var dt = new Date(d0);
    dt.setMonth(dt.getMonth() + i);
    _paymentPlanRows.push({
      amountCents: base + (i === n - 1 ? leftover : 0),
      chargeDate:  dt.toISOString().split('T')[0]
    });
  }
  renderPlanPreview_();
}

function addCustomInstallmentRow_() {
  var d   = _paymentPlanData;
  var min = new Date();
  min.setDate(min.getDate() + 3);
  _paymentPlanRows.push({
    amountCents: d ? Math.round((d.finalBalanceCents || 0) / 2) : 0,
    chargeDate:  min.toISOString().split('T')[0]
  });
  renderCustomRows_();
  renderPlanPreview_();
}

function removeCustomRow_(idx) {
  _paymentPlanRows.splice(idx, 1);
  renderCustomRows_();
  renderPlanPreview_();
}

function renderCustomRows_() {
  var container = document.getElementById('pp-custom-rows');
  if (!container) return;
  var html = '';
  _paymentPlanRows.forEach(function(row, idx) {
    html += '<div style="display:flex;gap:8px;align-items:center;margin-bottom:8px;">';
    html += '<input type="number" step="0.01" min="1" value="' + (row.amountCents / 100).toFixed(2) + '" ';
    html += 'style="flex:1;padding:8px 10px;border:1.5px solid #e6dad4;border-radius:8px;font-size:0.875rem;" ';
    html += 'onchange="updateCustomRow_(' + idx + ',\'amount\',this.value)" placeholder="Amount ($)">';
    html += '<input type="date" value="' + escAttr(row.chargeDate) + '" ';
    html += 'style="flex:1;padding:8px 10px;border:1.5px solid #e6dad4;border-radius:8px;font-size:0.875rem;" ';
    html += 'onchange="updateCustomRow_(' + idx + ',\'date\',this.value)">';
    html += '<button onclick="removeCustomRow_(' + idx + ')" style="padding:6px 10px;border:none;background:transparent;color:var(--muted);cursor:pointer;font-size:1.1rem;" title="Remove">&times;</button>';
    html += '</div>';
  });
  container.innerHTML = html;
}

function updateCustomRow_(idx, field, value) {
  if (!_paymentPlanRows[idx]) return;
  if (field === 'amount') _paymentPlanRows[idx].amountCents = Math.round(parseFloat(value) * 100) || 0;
  else if (field === 'date') _paymentPlanRows[idx].chargeDate = value;
  renderPlanPreview_();
}

function renderPlanPreview_() {
  var previewEl = document.getElementById('pp-preview');
  var submitBtn = document.getElementById('pp-submit-btn');
  if (!previewEl) return;

  var d         = _paymentPlanData;
  var remaining = d ? (d.finalBalanceCents || 0) : 0;
  var rows      = _paymentPlanRows;
  var fmtAmt    = function(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  if (!rows.length) {
    previewEl.innerHTML = '';
    if (submitBtn) submitBtn.disabled = true;
    return;
  }

  var total = rows.reduce(function(s, r) { return s + (r.amountCents || 0); }, 0);
  var ok    = total === remaining;

  var html = '<table style="width:100%;border-collapse:collapse;font-size:0.875rem;">';
  html += '<thead><tr>';
  html += '<th style="text-align:left;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Instalment</th>';
  html += '<th style="text-align:left;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Date</th>';
  html += '<th style="text-align:right;padding:6px 0;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.1em;color:var(--muted);border-bottom:2px solid var(--brand-primary);">Amount</th>';
  html += '</tr></thead><tbody>';
  rows.forEach(function(row, idx) {
    html += '<tr><td style="padding:7px 0;border-bottom:1px solid #f0e8e6;">Instalment ' + (idx + 1) + '</td>';
    html += '<td style="padding:7px 0;border-bottom:1px solid #f0e8e6;">' + escHtml(row.chargeDate || '') + '</td>';
    html += '<td style="padding:7px 0;border-bottom:1px solid #f0e8e6;text-align:right;font-weight:600;">' + fmtAmt(row.amountCents) + '</td></tr>';
  });
  html += '</tbody></table>';
  html += '<div style="display:flex;justify-content:flex-end;align-items:center;gap:10px;margin-top:8px;">';
  html += '<span style="font-size:0.8125rem;color:var(--muted);">Total: <strong style="color:var(--text);">' + fmtAmt(total) + '</strong></span>';
  if (!ok) {
    var diff = total - remaining;
    html += '<span style="font-size:0.75rem;padding:2px 10px;border-radius:999px;background:#fff0ec;color:#b32727;font-weight:600;">' + (diff > 0 ? '+' + fmtAmt(diff) + ' over' : fmtAmt(Math.abs(diff)) + ' short') + '</span>';
  } else {
    html += '<span style="font-size:0.75rem;padding:2px 10px;border-radius:999px;background:#f0faf4;color:#1a4a2e;font-weight:600;">Balanced</span>';
  }
  html += '</div>';
  previewEl.innerHTML = html;
  if (submitBtn) submitBtn.disabled = !ok;
}

function submitPaymentPlan() {
  if (_paymentPlanInFlight) return;
  var c        = _lastDrawerClient || {};
  var statusEl = document.getElementById('pp-status');
  var submitBtn = document.getElementById('pp-submit-btn');

  if (!_paymentPlanData || !c.email) {
    if (statusEl) statusEl.textContent = 'Missing data. Close and reopen the bride drawer.';
    return;
  }
  if (!_paymentPlanRows.length) {
    if (statusEl) statusEl.textContent = 'Add at least one instalment.';
    return;
  }

  _paymentPlanInFlight = true;
  if (statusEl)  statusEl.textContent = 'Creating plan and scheduling payments...';
  if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Creating...'; }

  jvBridge.callAdmin('bridge_admin_createPaymentPlan', {
    email:        c.email,
    installments: _paymentPlanRows,
    adminEmail:   (window.JV_ADMIN_EMAIL || '')
  })
    .then(function(res) {
      _paymentPlanInFlight = false;
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Create plan and email bride'; }
      if (!res || !res.ok) {
        if (statusEl) statusEl.textContent = 'Error: ' + escHtml((res && res.error) || 'Unknown error');
        return;
      }
      if (statusEl) statusEl.innerHTML = '<span style="color:#1a4a2e;font-weight:600;">' + escHtml(res.message || 'Plan created.') + '</span>';
      if (submitBtn) submitBtn.textContent = 'Done';
      setTimeout(function() { if (typeof openDrawer === 'function') openDrawer(c.id); }, 1800);
    })
    .catch(function(err) {
      _paymentPlanInFlight = false;
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Create plan and email bride'; }
      if (statusEl) statusEl.textContent = 'Error: ' + escHtml(err.message || String(err));
    });
}

var _addPmbInFlight = false;
function submitAddPartnerManagedBride() {
  // Hard idempotency — synchronous flag that wins over any race a button-disable could lose to.
  if (_addPmbInFlight) {
    var s0 = document.getElementById('add-pmb-status');
    if (s0) s0.textContent = 'Already submitting — please wait.';
    return;
  }
  _addPmbInFlight = true;
  var partnerEmail = (document.getElementById('add-pmb-partner') || {}).value || '';
  var firstName    = (document.getElementById('add-pmb-bride-first') || {}).value || '';
  var lastName     = (document.getElementById('add-pmb-bride-last')  || {}).value || '';
  var brideEmail   = (document.getElementById('add-pmb-bride-email') || {}).value || '';
  var bridePhone   = (document.getElementById('add-pmb-bride-phone') || {}).value || '';
  var weddingDate  = (document.getElementById('add-pmb-wedding-date') || {}).value || '';
  var location     = (document.getElementById('add-pmb-location')    || {}).value || '';
  var hmQuantity   = (document.getElementById('add-pmb-hm-qty')      || {}).value || '';
  var sendWelcome  = !!(document.getElementById('add-pmb-send-welcome') || {}).checked;
  var statusEl     = document.getElementById('add-pmb-status');
  var submitBtn    = document.getElementById('add-pmb-submit');

  if (!partnerEmail)            { _addPmbInFlight = false; if (statusEl) statusEl.textContent = 'Pick a partner.'; return; }
  if (!firstName.trim())        { _addPmbInFlight = false; if (statusEl) statusEl.textContent = 'Bride first name is required.'; return; }
  if (!weddingDate)             { _addPmbInFlight = false; if (statusEl) statusEl.textContent = 'Wedding date is required.'; return; }
  // Issue #13-adjacent bug (found 2026-10-27, BRIEFS/complete - external gpt/RESULTS-
  // partner-bride-duplicate-guard-verify-2026-10-27.md "Issue A"): if the bride's email
  // is left as the partner's OWN account email, GAS's crmIdentity_resolveByEmailOrShopify
  // Customer_ (PARTNER.gs, frozen, cannot be patched) resolves it to the partner's
  // existing CRM/Shopify identity and refuses the create outright via the row-collision
  // guard, even on a single clean submit. Block it here instead, with a message that
  // actually explains what's wrong (the GAS error text just says "row already belongs
  // to X ... this create is for X", which is confusing). Email is optional on this form,
  // so a blank bride email is always fine.
  if (brideEmail.trim() && partnerEmail.trim() &&
      brideEmail.trim().toLowerCase() === partnerEmail.trim().toLowerCase()) {
    _addPmbInFlight = false;
    if (statusEl) statusEl.textContent = 'Bride email can\'t be the same as the partner\'s own account email (' + partnerEmail.trim() + '). Leave it blank or use the bride\'s real email instead.';
    return;
  }

  // weddingDate from <input type="date"> is YYYY-MM-DD. CRM expects DD/MM/YYYY.
  var weddingDateAU = weddingDate;
  var m = String(weddingDate).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) weddingDateAU = m[3] + '/' + m[2] + '/' + m[1];

  var payload = {
    token: STATE.token,
    partnerEmail: partnerEmail,
    // STABLE IDENTITY (2026-08-11): sent back once a create in THIS modal
    // session has already returned one, so a retry/resubmit for the same
    // bride resolves by ID rather than falling back to name+date matching.
    // Blank on a genuine first submit, expected and correct.
    brideUid: _addPmbBrideUid,
    bride: {
      firstName:       firstName.trim(),
      lastName:        lastName.trim(),
      email:           brideEmail.trim().toLowerCase(),
      phone:           bridePhone.trim(),
      weddingDateAU:   weddingDateAU,
      weddingLocation: location.trim()
    },
    metadata: hmQuantity ? { hmQuantity: parseInt(hmQuantity, 10) } : {},
    // Welcome email is opt-in (Jess, 2026-08-11): the backend default is now
    // OFF unless this admin explicitly ticked the box. If it turns out this
    // email already received a welcome before, the response carries
    // welcomeNeedsConfirm:true and NO email is sent yet, the confirm/resend
    // choice is handled separately via bridge_admin_resendPartnerWelcome
    // (addPmbShowWelcomeResendConfirm_ below), not by resubmitting this form.
    options: {
      sendWelcome: sendWelcome
    }
  };

  // If a rate card is loaded for this partner, attach the service breakdown
  // and trigger auto-invoice in the same call.
  if (_addPmbRateCard) {
    payload.serviceBreakdown = addPmbCollectBreakdown_();
    payload.autoInvoice      = true;
  }

  // The onboarding chain behind this call is sequential (Drive folder, runsheet,
  // calendar, Chat, SMS queue, welcome email, each its own ~7-10s GAS cold-start
  // call per the documented perf wall) and can genuinely take 30-60s+. Cowork's
  // 2026-08-11 live verify watched a static "Creating..." label for ~20s with no
  // sign of life and reasonably read that as broken. It wasn't, the promise was
  // still pending, but nothing told the admin that. Surface elapsed time so a
  // long wait reads as "still working", not "stuck".
  var pmbStartTs = Date.now();
  var pmbTicker = setInterval(function() {
    if (!statusEl) return;
    var secs = Math.round((Date.now() - pmbStartTs) / 1000);
    statusEl.textContent = 'Creating... (' + secs + 's, this can take up to a minute, onboarding runs several steps)';
  }, 3000);
  if (statusEl) statusEl.textContent = 'Creating...';
  if (submitBtn) submitBtn.disabled = true;

  jvBridge.callAdmin('bridge_admin_createPartnerManagedBride', payload)
    .then(function(res) {
      _addPmbInFlight = false;
      clearInterval(pmbTicker);
      if (submitBtn) submitBtn.disabled = false;
      // FIX 2026-08-11 (BRIEFS/CRITICAL-partner-managed-create-broken-response-and-
      // invisible-row-2026-08-11.md): this MUST check res.success !== true, not
      // res.success === false. When jvBridge's own transport gives up (relay
      // timeout, both fetch and XHR failed), it resolves with its OWN synthetic
      // shape — { ok:false, error, notRetried:true, mayHaveSucceeded:true } — which
      // has no `success` field at all (undefined, not false). The old check let
      // that object fall straight through into the success-message branch below,
      // where `res.created` and `res.rowIndex` are also undefined, producing the
      // exact garbled "Updated existing row undefined" text a live Cowork test hit
      // 2026-08-11. This is a network-outcome object, not a backend response, and
      // must never be read as one.
      if (!res || res.success !== true) {
        // BRIDGE TRANSPORT FAILURE, OUTCOME UNKNOWN (2026-08-11): this specific
        // route is in jv-gas-bridge.liquid's NO_RETRY_ROUTES because its onboarding
        // chain can genuinely run 30-90s+, past where the Cloudflare relay is known
        // to 502/504 under load. A failure here does NOT mean the write failed —
        // it may have completed server-side with the response simply lost in
        // transit. Never imply success, and tell the admin exactly what to do
        // instead of guessing.
        if (res && res.notRetried && res.mayHaveSucceeded) {
          if (statusEl) statusEl.innerHTML = '<span style="color:#9b4c1e;font-weight:600;">' +
            'Connection lost waiting for a response. This bride may already have been ' +
            'created server-side (the write was NOT automatically retried, to avoid a ' +
            'duplicate). Search for "' + escHtml(firstName.trim()) + '" in All Clients ' +
            'before submitting again.</span>';
          return;
        }
        // ROW COLLISION (2026-08-11): the backend refused rather than silently
        // overwriting a different bride sharing first name + wedding date. This
        // is a genuine "stop and check" state, not a generic error, give the
        // admin the concrete next step instead of a bare error code.
        if (res && res.error === 'row_collision') {
          if (statusEl) statusEl.innerHTML = '<span style="color:#9b2020;font-weight:600;">' +
            escHtml(res.message || 'A different bride already occupies this row (same first name and wedding date). No changes were made.') +
            '</span>';
          return;
        }
        // LOCK CONTENTION (2026-10-28, same-day regression after the 55s->135s
        // relay-timeout fix for this route): GAS's PARTNER.gs holds a SINGLE
        // project-wide LockService.getScriptLock() for up to 65s while creating
        // a partner-managed bride, to stop two overlapping creates from racing
        // on the same sheet append. That 65s wait was sized against the OLD
        // 55s relay ceiling ("65s = 55s + 10s headroom", per that file's own
        // comment) and was never updated when the relay ceiling moved to 135s
        // today -- any genuinely long-running execution (now explicitly
        // permitted to run 105s+) can outlast the 65s wait, so the SECOND
        // overlapping call (this one, or any other GAS code anywhere in the
        // project using the same global lock) gets refused with this code.
        // GAS itself supplies a friendly `message` for this ("nothing was
        // written, try again"), but shopifyBridge_adminCreatePartnerManagedBride
        // (PARTNER.gs) only forwards `result.error`, not `result.message`, to
        // the client -- so there is nothing useful to read from `res.message`
        // here; this text is authored on the frontend instead. The underlying
        // fix (raise PARTNER.gs's tryLock(65000) to comfortably clear the new
        // 135s ceiling) is GAS-side and GAS is frozen -- this only makes the
        // existing failure legible instead of a bare error code, it does not
        // fix the contention itself.
        if (res && res.error === 'lock_unavailable') {
          if (statusEl) statusEl.innerHTML = '<span style="color:#9b4c1e;font-weight:600;">' +
            'The system is busy with another partner-managed bride creation right now. Nothing ' +
            'was written for this bride &mdash; wait about a minute, then try submitting again.</span>';
          return;
        }
        if (statusEl) statusEl.innerHTML = '<span style="color:#9b2020;font-weight:600;">Error: ' + escHtml(res && res.error ? res.error : 'unknown') + '</span>';
        return;
      }
      // STABLE IDENTITY (2026-08-11): capture the bride's own ID as soon as a
      // real success response arrives, before any of the branches below,
      // so a subsequent retry/resend within this same modal session resolves
      // by ID rather than falling back to name+date matching.
      if (res.brideUid) _addPmbBrideUid = res.brideUid;
      // PRIOR WELCOME SEND (2026-08-11, item 3): the bride record itself was
      // created/updated successfully, but the welcome send was withheld
      // because this email already received one before. Offer the admin an
      // explicit resend confirmation rather than silently skipping or
      // silently resending. This check only applies when sendWelcome was
      // actually requested, res.welcomeNeedsConfirm is never set otherwise.
      if (res.welcomeNeedsConfirm) {
        addPmbShowWelcomeResendConfirm_(res);
        return;
      }
      var msgParts = [
        (res.created ? 'Created bride row ' : 'Updated existing row ') + res.rowIndex,
        res.onboarded ? 'onboarding fired' : 'onboarding pending'
      ];
      if (sendWelcome) {
        if (res.welcomeSent) {
          msgParts.push('welcome email sent');
        } else if (res.welcomeDeferred) {
          msgParts.push('welcome email queued (quiet hours)');
        } else if (res.welcomeSkipped) {
          msgParts.push('welcome email not sent (' + (res.welcomeSkipped === true ? 'skipped' : escHtml(String(res.welcomeSkipped))) + ')');
        }
      }
      if (res.invoice) {
        if (res.invoice.success) {
          var inv = res.invoice;
          msgParts.push('invoiced ' + (inv.billedTo || 'partner') + ' $' + Number(inv.amount || 0).toFixed(2) + (inv.invoiceNumber ? ' (' + inv.invoiceNumber + ')' : ''));
          if (inv.onlineInvoiceUrl) {
            msgParts.push('<a href="' + inv.onlineInvoiceUrl + '" target="_blank" rel="noopener" style="color:var(--brand-primary-deep);font-weight:600;">Open in Xero &#8599;</a>');
          }
        } else {
          msgParts.push('invoice failed: ' + (res.invoice.error || res.invoice.message || 'unknown'));
        }
      }
      // Success is now a PERSISTENT state, not a 1.5s flash before auto-close.
      // The 2026-08-11 Cowork verify screenshotted every 3-10s and never caught
      // the old success message because the modal auto-closed 1.5s after it
      // appeared, a real UX bug, not a backend failure. The admin now sees a
      // clear, lasting confirmation and closes it themselves.
      if (statusEl) statusEl.innerHTML = '<span style="color:#1a4a2e;font-weight:700;">&#10003; ' + msgParts.join(' &middot; ') + '</span>';
      if (submitBtn) submitBtn.style.display = 'none';
      var cancelBtn = _addPmbModalEl ? _addPmbModalEl.querySelector('.btn-ghost[onclick="closeAddPartnerManagedBrideModal()"]') : null;
      if (cancelBtn) cancelBtn.textContent = 'Close';
      // STALE-DROPDOWN FIX (2026-09-28, DISCOVERY-invoice-new-bride-dropdown-stale):
      // same as submitAddClient's success handler above, invalidate the in-memory
      // client list so the next invoiceClientSearch / loadInvoicingView call
      // re-fetches instead of returning the pre-create snapshot for the rest of
      // the browser session.
      STATE.clients = null;
      // If a caller wired a success callback (e.g. invoice builder partner mode),
      // hand back the result immediately so it can use the new bride, do NOT
      // gate this on the modal closing, since closing is now a manual admin action.
      var cb = _addPmbOnSuccess;
      _addPmbOnSuccess = null;
      if (cb) {
        try { cb({
          rowIndex:    res.rowIndex,
          created:     res.created,
          partnerEmail: partnerEmail,
          brideEmail:   payload.bride.email,
          brideName:    (payload.bride.firstName + ' ' + payload.bride.lastName).trim(),
          weddingDate:  payload.bride.weddingDateAU
        }); } catch (cbErr) { console.warn('[add-pmb onSuccess]', cbErr); }
      } else {
        if (typeof loadPipelineView === 'function') loadPipelineView();
      }
    })
    .catch(function(err) {
      _addPmbInFlight = false;
      clearInterval(pmbTicker);
      if (submitBtn) submitBtn.disabled = false;
      if (statusEl) statusEl.innerHTML = '<span style="color:#9b2020;font-weight:600;">Error: ' + escHtml(err.message || String(err)) + '. The bride may or may not have been created, search for her before retrying to avoid a duplicate.</span>';
    });
}

/**
 * Prior-welcome-send confirm (Jess, 2026-08-11, item 3 of
 * BUILD-partner-managed-bride-row-collision-and-welcome-controls). The backend
 * refused to auto-send because this bride's email already received a welcome
 * before (res.priorSentAt). Never silently skip and never silently resend,
 * show the admin what happened and let them choose explicitly.
 */
function addPmbShowWelcomeResendConfirm_(res) {
  var statusEl = document.getElementById('add-pmb-status');
  if (!statusEl) return;
  var existing = document.getElementById('add-pmb-welcome-resend-wrap');
  if (existing) existing.remove();

  // Bride record already exists (res.rowIndex) by the time this shows, the
  // create/update itself is done, only the welcome email is gated. "Send
  // again" therefore hits a DEDICATED resend route, not a full re-submit of
  // this form. Re-submitting would re-run partnerBooking_maybeOnboardBride_,
  // which short-circuits the moment ONBOARDING_COMPLETE='Yes' (set right
  // after the first pass), so a re-submit would silently never reach the
  // welcome send at all, forceWelcomeResend or not.
  var rowIndex = res.rowIndex;

  var wrap = document.createElement('div');
  wrap.id = 'add-pmb-welcome-resend-wrap';
  wrap.style.cssText = 'background:var(--brand-bg-soft);border-radius:var(--radius-small);padding:0.75rem 0.9rem;margin-top:0.6rem;font-size:0.82rem;color:var(--brand-text);';
  var whenText = res.priorSentAt ? (' on ' + escHtml(res.priorSentAt)) : '';
  wrap.innerHTML =
    '<div style="margin-bottom:0.5rem;">A welcome email was already sent to this address' + whenText + '. Send it again?</div>' +
    '<div style="display:flex;gap:0.5rem;">' +
      '<button type="button" class="btn btn-primary" id="add-pmb-welcome-resend-yes" style="font-size:0.78rem;padding:0.35rem 0.8rem;">Send again</button>' +
      '<button type="button" class="btn btn-ghost" id="add-pmb-welcome-resend-no" style="font-size:0.78rem;padding:0.35rem 0.8rem;">Do not send</button>' +
    '</div>';
  statusEl.parentNode.insertBefore(wrap, statusEl.nextSibling);
  statusEl.innerHTML = '<span style="color:#1a4a2e;font-weight:700;">&#10003; Created bride row ' + rowIndex + '</span>. Welcome email withheld, awaiting your choice above.';
  var submitBtn0 = document.getElementById('add-pmb-submit');
  if (submitBtn0) submitBtn0.style.display = 'none';
  var cancelBtn0 = _addPmbModalEl ? _addPmbModalEl.querySelector('.btn-ghost[onclick="closeAddPartnerManagedBrideModal()"]') : null;
  if (cancelBtn0) cancelBtn0.textContent = 'Close';

  document.getElementById('add-pmb-welcome-resend-yes').onclick = function() {
    var yesBtn = document.getElementById('add-pmb-welcome-resend-yes');
    var noBtn  = document.getElementById('add-pmb-welcome-resend-no');
    if (yesBtn) { yesBtn.disabled = true; yesBtn.textContent = 'Sending...'; }
    if (noBtn)  { noBtn.disabled  = true; }
    jvBridge.callAdmin('bridge_admin_resendPartnerWelcome', { token: STATE.token, rowIndex: rowIndex })
      .then(function(resendRes) {
        wrap.remove();
        // FIX 2026-08-11 (same root cause as the create path above): check
        // success !== true, not === false, so jvBridge's own network-failure
        // shape (no `success` field, since bridge_admin_resendPartnerWelcome is
        // now also in NO_RETRY_ROUTES) is never mistaken for a real resend.
        if (!resendRes || resendRes.success !== true) {
          if (resendRes && resendRes.notRetried && resendRes.mayHaveSucceeded) {
            statusEl.innerHTML = '<span style="color:#9b4c1e;font-weight:600;">' +
              'Connection lost waiting for a response. The resend was NOT automatically ' +
              'retried, to avoid sending it twice. Check the comms log for this bride ' +
              'before trying again.</span>';
            return;
          }
          statusEl.innerHTML = '<span style="color:#9b2020;font-weight:600;">Welcome resend failed: ' +
            escHtml((resendRes && resendRes.error) || 'unknown') + '</span>';
          return;
        }
        var resendMsg = resendRes.sent ? 'Welcome email resent.' :
          (resendRes.deferred ? 'Welcome email queued (quiet hours).' : 'Welcome email not sent (' + escHtml(String(resendRes.blocked || 'unknown reason')) + ').');
        statusEl.innerHTML = '<span style="color:#1a4a2e;font-weight:700;">&#10003; Created bride row ' + rowIndex + '</span>. ' + resendMsg;
        if (typeof loadPipelineView === 'function') loadPipelineView();
      })
      .catch(function(err) {
        wrap.remove();
        statusEl.innerHTML = '<span style="color:#9b2020;font-weight:600;">Welcome resend failed: ' + escHtml(err.message || String(err)) + '</span>';
      });
  };
  document.getElementById('add-pmb-welcome-resend-no').onclick = function() {
    wrap.remove();
    // The bride record itself was already saved server-side (this confirm only
    // gates the welcome send), reflect that so the admin does not think nothing
    // happened and try to create her again.
    statusEl.innerHTML = '<span style="color:#1a4a2e;font-weight:700;">&#10003; Created bride row ' + rowIndex + '</span>. Welcome email not sent.';
    if (typeof loadPipelineView === 'function') loadPipelineView();
  };
}

/* ============================================================
   PROPOSALS VIEW
   ============================================================ */
var _proposalsData = [];
// Toggle (default ON): collapses CRM-row + history-revision dupes so each bride
// surfaces once with a "· N revisions" badge. Flipped off shows every raw row
// for audit.
var _proposalsGroupByBride = true;

function onProposalGroupingChanged() {
  var cb = document.getElementById('prop-group-by-bride');
  _proposalsGroupByBride = cb ? !!cb.checked : true;
  loadProposalsView();
}

function loadProposalsView() {
  showLoader('proposals');
  var cb = document.getElementById('prop-group-by-bride');
  if (cb) _proposalsGroupByBride = !!cb.checked;
  // TODO: Bridge route needed for: adminCrm_getProposals
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getProposals',
    args: { groupByBride: _proposalsGroupByBride }
  })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      _proposalsData = Array.isArray(data) ? data : [];
      filterProposalsView();
      // Update intel strip proposals out count
      updateIntelStrip(STATE.pipeline ? STATE.pipeline.items : [], _proposalsData);
      showContent('proposals');
    }; _h(res.data); } else { var _e = function(err){ showError('proposals', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('proposals', err.message || String(err)); });
}

function filterProposalsView() {
  var statusF = (document.getElementById('prop-status-filter') || {}).value || '';
  var dateFrom = (document.getElementById('prop-date-from')    || {}).value || '';
  var dateTo   = (document.getElementById('prop-date-to')      || {}).value || '';
  var sortBy   = (document.getElementById('prop-sort')         || {}).value || 'date-desc';
  var searchQ  = ((document.getElementById('prop-search')      || {}).value || '').toLowerCase().trim();

  var filtered = _proposalsData.filter(function(p) {
    if (searchQ && ((p.clientName||'') + ' ' + (p.email||'')).toLowerCase().indexOf(searchQ) === -1) return false;
    // Map filter value to actual data fields
    if (statusF === 'agreed')   return p.proposalStatus === 'accepted';
    if (statusF === 'declined') return p.proposalStatus === 'voided';
    if (statusF === 'booked')   return (p.status || '').toLowerCase() === 'booked';
    if (statusF === 'sent')     return (p.status || '').toLowerCase() !== 'booked' && p.proposalStatus !== 'accepted' && p.proposalStatus !== 'voided';
    // date range filters on quoteDate
    if (dateFrom && p.quoteDate && p.quoteDate < dateFrom) return false;
    if (dateTo   && p.quoteDate && p.quoteDate > dateTo)   return false;
    return true;
  });

  // Apply date filter even when no statusF
  if (!statusF) {
    filtered = _proposalsData.filter(function(p) {
      if (searchQ && ((p.clientName||'') + ' ' + (p.email||'')).toLowerCase().indexOf(searchQ) === -1) return false;
      if (dateFrom && p.quoteDate && p.quoteDate < dateFrom) return false;
      if (dateTo   && p.quoteDate && p.quoteDate > dateTo)   return false;
      return true;
    });
  }

  filtered.sort(function(a, b) {
    if (sortBy === 'date-asc')   return String(a.quoteDate||'').localeCompare(String(b.quoteDate||''));
    if (sortBy === 'client-asc') return String(a.clientName||'').localeCompare(String(b.clientName||''));
    if (sortBy === 'status')     return String(a.proposalStatus||'').localeCompare(String(b.proposalStatus||''));
    // date-desc (default)
    return String(b.quoteDate||'').localeCompare(String(a.quoteDate||''));
  });

  var countEl = document.getElementById('prop-count');
  if (countEl) {
    if (_proposalsGroupByBride) {
      var totalSends = 0;
      filtered.forEach(function(p) { totalSends += (p.revisionCount || 1); });
      countEl.textContent = filtered.length + ' bride' + (filtered.length !== 1 ? 's' : '') +
                            ' · ' + totalSends + ' send' + (totalSends !== 1 ? 's' : '');
    } else {
      countEl.textContent = filtered.length + ' row' + (filtered.length !== 1 ? 's' : '') + ' (ungrouped)';
    }
  }

  var list = document.getElementById('proposals-list');
  if (!list) return;
  if (filtered.length === 0) {
    list.innerHTML = '<div class="empty-state"><div class="empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg></div><p>No proposals match these filters.</p></div>';
    return;
  }
  list.innerHTML = filtered.map(renderProposalCard).join('');
}

function renderProposalCard(p) {
  // Determine display status and chip class from actual fields
  var chipLabel, chipCls, iconCls;
  if (p.proposalStatus === 'accepted') {
    chipLabel = 'Agreed'; chipCls = 'agreed'; iconCls = 'signed';
  } else if (p.proposalStatus === 'voided') {
    chipLabel = 'Voided'; chipCls = 'declined'; iconCls = 'void';
  } else if ((p.status || '').toLowerCase() === 'booked') {
    chipLabel = 'Booked'; chipCls = 'booked'; iconCls = 'signed';
  } else {
    chipLabel = 'Sent'; chipCls = 'sent'; iconCls = 'out';
  }
  var amountStr = p.proposalTotal ? '$' + Number(p.proposalTotal).toLocaleString('en-AU', {minimumFractionDigits:2}) : '—';
  var dateStr = p.quoteDate ? 'Sent ' + escHtml(formatDate(p.quoteDate)) : '';
  // B.8: card itself is clickable → opens itemised proposal modal.
  var openAttr = p.email
    ? ' style="cursor:pointer;" onclick="openProposalModal(\'' + escAttr(p.email) + '\')"'
    : '';
  var revisionBadge = (p.revisionCount && Number(p.revisionCount) > 1)
    ? '<span title="' + escAttr(String(p.revisionCount) + ' send events recorded for this bride') + '" style="display:inline-block;margin-left:0.4rem;padding:0.12rem 0.5rem;font-size:0.62rem;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;background:#f6f1ee;color:#a9706c;border-radius:3rem;vertical-align:middle;">' +
        '· ' + escHtml(String(p.revisionCount)) + ' revisions' +
      '</span>'
    : '';
  var html = '<div class="proposal-card"' + openAttr + '>' +
    '<div class="proposal-icon ' + iconCls + '">' +
      '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' +
    '</div>' +
    '<div class="proposal-info">' +
      '<strong>' + escHtml(p.clientName || '—') + revisionBadge + '</strong>' +
      '<span>' + escHtml(p.email || '') + (dateStr ? ' · ' + dateStr : '') + '</span>' +
    '</div>' +
    '<span class="prop-status-chip ' + chipCls + '">' + chipLabel + '</span>' +
    '<div class="proposal-amount">' + amountStr + '</div>';
  if (p.id) {
    html += '<button class="btn btn-ghost" style="font-size:0.72rem;" onclick="event.stopPropagation();openDrawer(\'' + escHtml(String(p.id)) + '\')">View</button>';
  }
  if (JV_FEATURE_VOID_PROPOSAL && p.proposalToken && p.proposalStatus !== 'voided') {
    html += '<button class="btn btn-ghost" style="font-size:0.72rem;color:var(--danger);" onclick="event.stopPropagation();voidProposal(\'' + escHtml(p.clientName) + '\', this)">Void</button>';
  }
  html += '</div>';
  return html;
}

/* ============================================================
   PROPOSALS PENDING REVIEW
   ============================================================ */
function loadProposalsPendingView() {
  showLoader('proposals-pending');
  // TODO: Bridge route needed for: adminCrm_getProposals
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getProposals' })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      var list = document.getElementById('proposals-pending-list');
      // Awaiting response = the proposal-token status is 'sent' or 'viewed' (matching
      // Proposal Pipeline's own "Awaiting Response" KPI: summary.sent + summary.viewed,
      // sections/jv-proposal-pipeline.liquid:619). FIXED 2026-08-27
      // (RESULTS-admin-crm-full-shell-grade3-xray-2026-08-27.md, live confirmed 0 items
      // here vs Pipeline's "272 awaiting response"). The old filter (!p.proposalStatus)
      // meant "token status blank", a different, unreliable signal from "genuinely sent,
      // not yet responded to". Every row here already passed a sent/quoted eligibility
      // gate server-side (AdminCRMAPI.gs adminCrm_getProposals), so a blank token status
      // was never a real "not sent yet" case.
      var pending = (Array.isArray(data) ? data : []).filter(function(p) {
        var tokenStatus = (p.proposalStatus || '').toLowerCase();
        return (tokenStatus === 'sent' || tokenStatus === 'viewed') && (p.status || '').toLowerCase() !== 'booked';
      });

      if (pending.length === 0) {
        list.innerHTML = '<div class="empty-state"><div class="empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div><p>No proposals pending review.</p></div>';
      } else {
        list.innerHTML = pending.map(function(p) {
          var amountStr = p.proposalTotal ? '$' + Number(p.proposalTotal).toLocaleString('en-AU', {minimumFractionDigits:2}) : '—';
          var dateStr = p.quoteDate ? 'Sent ' + escHtml(formatDate(p.quoteDate)) : '';
          return '<div class="proposal-card">' +
            '<div class="proposal-icon out"><svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>' +
            '<div class="proposal-info">' +
              '<strong>' + escHtml(p.clientName || '—') + '</strong>' +
              '<span>' + escHtml(p.email || '') + (dateStr ? ' · ' + dateStr : '') + '</span>' +
            '</div>' +
            '<span class="prop-status-chip sent">Awaiting</span>' +
            '<div class="proposal-amount">' + amountStr + '</div>' +
            '<div style="display:flex;gap:0.4rem;">' +
              (p.id ? '<a class="btn btn-primary" style="font-size:0.72rem;" href="/pages/proposal-builder?bride=' + encodeURIComponent(p.email || '') + '" target="_blank" rel="noopener">Edit in Builder</a>' : '') +
            '</div>' +
          '</div>';
        }).join('');
      }
      showContent('proposals-pending');
    }; _h(res.data); } else { var _e = function(err){ showError('proposals-pending', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('proposals-pending', err.message || String(err)); });
}

/* ============================================================
   INVOICING VIEW
   ============================================================ */
var _invoicesData = [];

function loadInvoicingView() {
  // Ensure STATE.clients is populated so the new-invoice bride picker can search.
  if (!STATE.clients || !STATE.clients.length) {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients' })
      .then(function(r){ if (r.ok && Array.isArray(r.data)) STATE.clients = r.data; })
      .catch(function(){ /* non-fatal, search will show empty */ });
  }
  // CDN fast-path (2026-10-01, HANDOFF-admin-invoices-list-cache-2026-10-01.md): paint
  // from the admin_invoices_cache_json island first (zero GAS, ~0.3s) if present, same
  // stale-while-revalidate shape every sibling admin tab already uses (clients, stale
  // deals, analytics, partner list). Falls through to the loader + live call when the
  // island is empty/missing (cold cache, not yet warmed), no change to that path.
  var _liveRefresh = function() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoices', args: { skipXero: true } })
      .then(function(res) { if (res.ok) { var _h = function(data) {
        _invoicesData = Array.isArray(data) ? data : [];
        filterInvoicingView();
        showContent('invoicing');
      }; _h(res.data); } else if (!_invoicesData.length) { var _e = function(err){ showError('invoicing', err.message || String(err)); }; _e(res.error); } })
      .catch(function(err){ if (!_invoicesData.length) showError('invoicing', err.message || String(err)); });
  };
  adminCacheParseIsland_('jv-admin-invoices-cache', function(cached) {
    var list = cached && cached.success && Array.isArray(cached.data) ? cached.data : null;
    if (list) {
      _invoicesData = list;          // instant paint from island
      filterInvoicingView();
      showContent('invoicing');
    } else {
      showLoader('invoicing');       // no island, fall back to the loader + live call
    }
    _liveRefresh();                  // always verify/repair in the background
  });
}

function refreshInvoicingFromXero() {
  // 2026-07-31 (Jess decision: background reconcile): the old whole-list `refresh:true`
  // did a per-row Xero loop (N brides x 2 Xero API calls, cache-bypassed) synchronously
  // in one request, which reliably blew past the Cloudflare 30s cap on a real book of
  // business. A money list must NEVER hang. Now the button (1) kicks off a BACKGROUND
  // Xero reconcile (returns instantly, drains over the next few minutes writing fresh
  // Xero into the server cache), and (2) re-reads the list FAST from CRM columns so the
  // admin sees current values immediately. A moment later the list is Xero-fresh from the
  // warm cache on any normal reopen. Per-bride "Refresh from Xero" in the drawer is
  // unchanged (single bride, bounded, safe) for an on-demand live pull.
  showLoader('invoicing');
  // Fire-and-forget the background reconcile (never block the list on it).
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_invoiceXeroReconcileStart' })
    .then(function(r){
      try {
        var n = (r && r.ok && r.data && r.data.queued) ? r.data.queued : 0;
        if (typeof showToast === 'function' && n) {
          showToast('Syncing ' + n + ' invoices with Xero in the background. Reopen the list in a minute or two to see updated figures.');
        }
      } catch (e) {}
    })
    .catch(function(){ /* non-fatal: the fast read below still shows current CRM values */ });
  // Read the list FAST from CRM columns (never times out).
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoices', args: { skipXero: true } })
    .then(function(res) { if (res.ok) {
      _invoicesData = Array.isArray(res.data) ? res.data : [];
      filterInvoicingView();
      showContent('invoicing');
    } else { showError('invoicing', (res.error && res.error.message) || String(res.error)); } })
    .catch(function(err){ showError('invoicing', err.message || String(err)); });
}

function filterInvoicingView() {
  var searchQ  = (document.getElementById('inv-search')       || {}).value.toLowerCase().replace(/[''‚‛′‵`]/g, "'").trim();
  var contactF = (document.getElementById('inv-contact-type') || {}).value || '';
  var statusF  = (document.getElementById('inv-status')       || {}).value || '';
  var dateFrom = (document.getElementById('inv-date-from')    || {}).value || '';
  var dateTo   = (document.getElementById('inv-date-to')      || {}).value || '';
  var sortBy   = (document.getElementById('inv-sort')         || {}).value || 'wedding-asc';
  var groupBy  = (document.getElementById('inv-group')        || {}).value || '';

  var filtered = _invoicesData.filter(function(inv) {
    if (searchQ && !(inv.clientName||inv.clientEmail||'').toLowerCase().includes(searchQ)) return false;
    if (contactF && (inv.contactType||'').toLowerCase() !== contactF) return false;
    if (statusF  && (inv.status||'').toLowerCase() !== statusF) return false;
    if (dateFrom && inv.issueDate && inv.issueDate < dateFrom) return false;
    if (dateTo   && inv.issueDate && inv.issueDate > dateTo)   return false;
    return true;
  });

  filtered.sort(function(a, b) {
    if (sortBy === 'due-desc')   return String(b.dueDate||'').localeCompare(String(a.dueDate||''));
    if (sortBy === 'due-asc')    return String(a.dueDate||'').localeCompare(String(b.dueDate||''));
    if (sortBy === 'issue-desc') return String(b.issueDate||'').localeCompare(String(a.issueDate||''));
    if (sortBy === 'issue-asc')  return String(a.issueDate||'').localeCompare(String(b.issueDate||''));
    if (sortBy === 'status')     return String(a.status||'').localeCompare(String(b.status||''));
    return String(a.weddingDate||'').localeCompare(String(b.weddingDate||''));
  });

  var countEl = document.getElementById('inv-count');
  if (countEl) countEl.textContent = filtered.length + ' invoices';

  var wrap = document.getElementById('invoicing-list-wrap');
  if (!wrap) return;

  if (filtered.length === 0) {
    wrap.innerHTML = '<div class="empty-state"><div class="empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg></div><p>No invoices match these filters.</p></div>';
    return;
  }

  if (!groupBy) {
    wrap.innerHTML = renderInvoiceTable(filtered);
  } else {
    var groups = {};
    filtered.forEach(function(inv) {
      var key = groupBy === 'client' ? (inv.clientName || inv.clientEmail || '—') :
                (inv.type || inv.contactType || 'Other');
      if (!groups[key]) groups[key] = [];
      groups[key].push(inv);
    });
    var html = '';
    Object.keys(groups).sort().forEach(function(key) {
      html += '<div class="card-panel" style="margin-bottom:1rem;">';
      html += '<div class="comms-group-header"><span>' + escHtml(key) + '</span><span>' + groups[key].length + '</span></div>';
      html += renderInvoiceTable(groups[key]);
      html += '</div>';
    });
    wrap.innerHTML = html;
  }
}

/* --- Payment Records tab (Piece C, SCOPE-admin-invoice-log-ui-2026-09-04.md) ---
   jv-payment-service's own D1 payment-truth log, read via the 'invoice-list'
   App-Proxy relay entity (same transport as openInvoiceDetailModal_ above).
   Kept in its own panel inside the Invoicing view rather than a new top-level
   view: this view's existing #invoicing-loader/-content/-error triad is keyed
   to showLoader('invoicing')/showContent('invoicing') matching STATE.currentView
   (see showContent's own guard comment), so a second top-level view would need
   a second currentView value the switchView router does not have. A client-side
   tab toggle avoids that without touching the state machine. */
var _prData = [];
var _prTotal = 0;
var _prOffset = 0;
var _prPageSize = 50;
var _prLoadedOnce = false;

function switchInvoicingTab_(tab) {
  var xeroTab = document.getElementById('inv-tab-xero');
  var paymentsTab = document.getElementById('inv-tab-payments');
  var xeroPanel = document.getElementById('inv-panel-xero');
  var paymentsPanel = document.getElementById('inv-panel-payments');
  if (!xeroTab || !paymentsTab || !xeroPanel || !paymentsPanel) return;
  var showPayments = (tab === 'payments');
  xeroTab.classList.toggle('active', !showPayments);
  paymentsTab.classList.toggle('active', showPayments);
  xeroPanel.style.display = showPayments ? 'none' : '';
  paymentsPanel.style.display = showPayments ? '' : 'none';
  if (showPayments && !_prLoadedOnce) loadPaymentRecordsView();
}

function loadPaymentRecordsView() {
  _prLoadedOnce = true;
  _prOffset = 0;
  paymentRecordsFetch_();
}

function paymentRecordsPage_(direction) {
  var next = _prOffset + (direction * _prPageSize);
  if (next < 0) return;
  _prOffset = next;
  paymentRecordsFetch_();
}

function previewAddonInvoiceBackfill_() {
  var btn = document.getElementById('pr-addon-backfill-preview-btn');
  var statusEl = document.getElementById('pr-addon-backfill-preview');
  var base = window._jvAdminProxyBase;
  if (!btn || !statusEl) return;
  statusEl.style.display = 'block';
  statusEl.style.color = 'var(--text-light)';
  statusEl.textContent = 'Checking add-on invoices in Xero. This preview cannot write data.';
  if (!base) {
    statusEl.style.color = 'var(--danger)';
    statusEl.textContent = 'Preview unavailable: admin connection is not ready.';
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Checking...';
  var url = String(base).replace(/\/+$/, '') + '/partner/addon-invoice-backfill/preview';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ dryRun: true })
  }).then(function (r) { return r.json(); }).then(function (res) {
    if (!res || res.ok === false || res.dryRun !== true) {
      statusEl.style.color = 'var(--danger)';
      statusEl.textContent = 'Preview could not run: ' + String((res && res.error) || 'unexpected response');
      return;
    }
    var candidates = Number(res.candidateCount || 0);
    var duplicates = Number(res.deduplicatedRowCount || 0);
    var conflicts = Number(res.identityConflictCount || 0);
    var failures = Number(res.failedCount || 0);
    statusEl.style.color = conflicts || failures ? 'var(--warning)' : 'var(--success)';
    statusEl.textContent = candidates + ' invoice candidate' + (candidates === 1 ? '' : 's') +
      ' found. ' + duplicates + ' duplicate source row' + (duplicates === 1 ? '' : 's') +
      ' collapsed. ' + conflicts + ' identity conflict' + (conflicts === 1 ? '' : 's') +
      '. No data was written.';
  }).catch(function () {
    statusEl.style.color = 'var(--danger)';
    statusEl.textContent = 'Preview lost contact before a result returned. No apply request was sent.';
  }).finally(function () {
    btn.disabled = false;
    btn.textContent = 'Preview add-on sync';
  });
}

function paymentRecordsFetch_() {
  var loader = document.getElementById('pr-loader');
  var content = document.getElementById('pr-content');
  var errorEl = document.getElementById('pr-error');
  if (loader) loader.style.display = 'flex';
  if (content) content.style.display = 'none';
  if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }

  var base = window._jvAdminProxyBase;
  if (!base) {
    if (loader) loader.style.display = 'none';
    if (errorEl) { errorEl.style.display = 'block'; errorEl.textContent = 'Payment records are only available to admins.'; }
    return;
  }

  var searchQ = (document.getElementById('pr-search') || {}).value || '';
  var kindF = (document.getElementById('pr-kind') || {}).value || '';
  var statusF = (document.getElementById('pr-status') || {}).value || '';

  var url = String(base).replace(/\/+$/, '') + '/partner/invoice-list/list';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({
      brideEmail: searchQ.trim() || undefined,
      kind: kindF || undefined,
      status: statusF || undefined,
      limit: _prPageSize,
      offset: _prOffset
    })
  }).then(function (r) { return r.json(); }).then(function (res) {
    if (loader) loader.style.display = 'none';
    if (!res || res.ok === false || !Array.isArray(res.invoices)) {
      if (errorEl) { errorEl.style.display = 'block'; errorEl.textContent = (res && res.error) || 'Could not load payment records.'; }
      return;
    }
    _prData = res.invoices;
    _prTotal = Number(res.total) || 0;
    renderPaymentRecordsList_();
    if (content) content.style.display = '';
  }).catch(function () {
    if (loader) loader.style.display = 'none';
    if (errorEl) { errorEl.style.display = 'block'; errorEl.textContent = 'Could not load payment records.'; }
  });
}

// Client-side filters (search/kind/status) narrow the already-loaded page.
// Refresh re-fetches with these same values applied server-side. Search/kind
// controls originally only applied on Refresh, which made them appear broken
// vs the status filter that applied instantly. All three now narrow the
// loaded page on change, matching the trade-off the backend accepts for one
// page's worth of rows. See DIAGNOSTIC-b2-addon-invoice-backfill-e2e-2026-11-02
// §Payment Records filter defect, Sub-B2 slice S1 (2026-11-02).
function filterPaymentRecordsView() {
  renderPaymentRecordsList_();
}

function renderPaymentRecordsList_() {
  var wrap = document.getElementById('pr-list-wrap');
  var countEl = document.getElementById('pr-count');
  var prevBtn = document.getElementById('pr-prev');
  var nextBtn = document.getElementById('pr-next');
  if (!wrap) return;

  var searchF = ((document.getElementById('pr-search') || {}).value || '').trim().toLowerCase();
  var kindF = (document.getElementById('pr-kind') || {}).value || '';
  var statusF = (document.getElementById('pr-status') || {}).value || '';
  var rows = _prData;
  if (searchF) rows = rows.filter(function (r) { return String(r.brideEmail || '').toLowerCase().indexOf(searchF) !== -1; });
  if (kindF) rows = rows.filter(function (r) { return r.kind === kindF; });
  if (statusF) rows = rows.filter(function (r) { return r.status === statusF; });

  if (countEl) countEl.textContent = _prTotal + ' payment record' + (_prTotal === 1 ? '' : 's');
  if (prevBtn) prevBtn.disabled = (_prOffset <= 0);
  if (nextBtn) nextBtn.disabled = (_prOffset + _prPageSize >= _prTotal);

  if (!rows.length) {
    wrap.innerHTML = '<div class="empty-state"><p>No payment records match these filters.</p></div>';
    return;
  }

  var kindLabel = { deposit: 'Deposit', final: 'Final balance', enhancement: 'Enhancement', legacy: 'Legacy (Moxie)', other: 'Invoice' };
  var statusCls = { paid: 'paid', part_paid: 'sent', issued: 'draft', void: 'void' };

  var html = '<div class="card-panel" style="padding:0;">' +
    '<table class="data-table"><thead><tr>' +
    '<th>Bride</th><th>Kind</th><th>Total</th><th>Paid</th><th>Outstanding</th><th>Status</th><th>Issued</th>' +
    '</tr></thead><tbody>';

  rows.forEach(function (inv) {
    var driftBadge = inv.cacheDrift ? '<span class="pr-drift-badge">Drift</span>' : '';
    var cls = statusCls[inv.status] || 'draft';
    html += '<tr style="cursor:pointer;" onclick="openInvoiceDetailModal_(' + Number(inv.invoiceId) + ')">' +
      '<td>' + escHtml(inv.brideEmail || '&mdash;') + '</td>' +
      '<td>' + escHtml(kindLabel[inv.kind] || inv.kind || 'Invoice') + '</td>' +
      '<td>' + _jvInvoiceMoney_(inv.totalCents) + '</td>' +
      '<td>' + _jvInvoiceMoney_(inv.paidCents) + '</td>' +
      '<td>' + _jvInvoiceMoney_(inv.outstandingCents) + '</td>' +
      '<td><span class="inv-status-chip ' + cls + '">' + escHtml(inv.status || '') + '</span>' + driftBadge + '</td>' +
      '<td>' + escHtml(inv.issuedAt ? formatDate(inv.issuedAt) : '&mdash;') + '</td>' +
    '</tr>';
  });

  html += '</tbody></table></div>';
  wrap.innerHTML = html;
}

/**
 * Build the LOCAL branded invoice-snapshot URL for a new-system bride's invoice,
 * or '' if this invoice should NOT open locally (legacy/Moxie, or missing token).
 * Points at the existing bride-facing /pages/invoice-view page, token-authed.
 * type = deposit | final_balance (from the backend's localInvoiceType).
 * 2026-07-07.
 */
function invoiceLocalViewUrl_(inv) {
  if (!inv || !inv.isNewSystemInvoice) return '';
  var token = String(inv.shopifyPortalToken || '').trim();
  if (!token) return '';
  var type = (inv.localInvoiceType === 'final_balance') ? 'final_balance' : 'deposit';
  return '/pages/invoice-view?token=' + encodeURIComponent(token) + '&type=' + type;
}

function renderInvoiceTable(invoices) {
  var anyStale = invoices.some(function(i){ return i.xeroStale; });
  var allStale = invoices.length > 0 && invoices.every(function(i){ return i.xeroStale; });
  var banner = '';
  if (anyStale) {
    banner = '<div class="alert ' + (allStale ? 'warning' : 'info') + '" style="margin:0 0 0.6rem;display:flex;justify-content:space-between;align-items:center;gap:0.6rem;">' +
      '<span>' +
        (allStale
          ? 'Xero is unavailable — showing cached values from CRM. Status may not reflect current Xero state.'
          : 'Some rows could not refresh from Xero (cached values shown — look for the “Stale” badge).') +
      '</span>' +
      '<button class="btn btn-ghost" style="font-size:0.72rem;padding:0.3rem 0.7rem;" onclick="refreshInvoicingFromXero()">Refresh from Xero</button>' +
    '</div>';
  }
  var html = banner + '<div class="card-panel" style="padding:0;">' +
    '<table class="data-table"><thead><tr>' +
    '<th>Client</th><th>Wedding Date</th><th>Total</th><th>Deposit</th><th>Balance</th><th>Due</th><th>Status</th><th></th>' +
    '</tr></thead><tbody>';

  invoices.forEach(function(inv) {
    var statusCls = (inv.status||'draft').toLowerCase();
    var staleBadge = inv.xeroStale
      ? '<span class="inv-status-chip" style="background:#fff3e0;color:#9b4c1e;margin-left:0.4rem;font-size:0.66rem;" title="Xero data unavailable — value shown is from CRM cache.">Stale</span>'
      : '';
    html += '<tr>' +
      '<td><span class="action-link" onclick="openDrawer(\'' + escAttr(String(inv.clientId||inv.clientEmail||'')) + '\')">' + escHtml(inv.clientName||inv.clientEmail||'—') + '</span></td>' +
      '<td>' + escHtml(inv.weddingDate ? formatDate(inv.weddingDate) : '—') + '</td>' +
      '<td>' + escHtml(inv.total ? '$' + Number(inv.total).toFixed(2) : (inv.totalValue ? '$' + Number(inv.totalValue).toFixed(2) : '—')) + '</td>' +
      '<td>' + escHtml(inv.deposit ? '$' + Number(inv.deposit).toFixed(2) : (inv.depositPaid ? '$' + Number(inv.depositPaid).toFixed(2) : '—')) + '</td>' +
      '<td>' + escHtml(inv.balanceDue ? '$' + Number(inv.balanceDue).toFixed(2) : '—') + '</td>' +
      '<td>' + escHtml(inv.dueDate ? formatDate(inv.dueDate) : '—') + '</td>' +
      '<td><span class="inv-status-chip ' + statusCls + '">' + escHtml(inv.status||'Draft') + '</span>' + staleBadge + '</td>' +
      '<td style="white-space:nowrap;">' +
        (function() {
          var isDraft = (inv.status === 'Draft' || inv.status === 'DRAFT');
          var isSent  = (inv.status === 'Sent' || inv.status === 'Authorised' || inv.status === 'AUTHORISED');
          var btns = '';
          // Draft: Edit button opens inline editor modal
          if (isDraft && inv.xeroInvoiceId) {
            btns += '<button style="font-size:0.72rem;padding:3px 10px;border-radius:3rem;border:1px solid #c99591;background:#c99591;color:#fff;cursor:pointer;" onclick="invoiceOpenEditModal_(' + JSON.stringify(inv).replace(/"/g, '&quot;') + ')">Edit</button>';
          }
          // Sent/Authorised: Resend + Void
          if (isSent) {
            // 2026-07-30 fix: a partner-managed invoice was billed to the
            // partner, not the bride, the plain Resend button would email
            // the bride's own address (wrong recipient). Route to the
            // partner-aware resend for these rows instead.
            if (inv.isPartnerManaged) {
              btns += '<button style="font-size:0.72rem;padding:3px 10px;border-radius:3rem;border:1px solid #c99591;background:transparent;color:#c99591;cursor:pointer;margin-left:6px;" onclick="invoiceResendPartnerEmail_(' + JSON.stringify(inv).replace(/"/g, '&quot;') + ', this)">Resend to partner</button>';
            } else {
              btns += '<button style="font-size:0.72rem;padding:3px 10px;border-radius:3rem;border:1px solid #c99591;background:transparent;color:#c99591;cursor:pointer;margin-left:6px;" onclick="invoiceResendEmail_(' + JSON.stringify(inv).replace(/"/g, '&quot;') + ', this)">Resend</button>';
            }
            btns += '<button style="font-size:0.72rem;padding:3px 10px;border-radius:3rem;border:1px solid #c99591;background:transparent;color:#c99591;cursor:pointer;margin-left:6px;" onclick="invoiceVoid_(' + JSON.stringify(inv).replace(/"/g, '&quot;') + ')">Void</button>';
          }
          // Open link. For a NEW-SYSTEM bride (booked through our pipeline) the
          // primary Open goes to the LOCAL branded invoice snapshot
          // (/pages/invoice-view) instead of Xero, with a secondary "Xero" link
          // as the live-status escape hatch (2026-07-07). Legacy/Moxie brides keep
          // opening the Xero URL / PDF as before.
          if (!isDraft) {
            var localUrl = invoiceLocalViewUrl_(inv);
            var xeroUrl  = inv.invoiceUrl || inv.pdfUrl;
            if (!xeroUrl && inv.xeroInvoiceId) {
              xeroUrl = 'https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=' + encodeURIComponent(inv.xeroInvoiceId);
            }
            if (localUrl) {
              btns += '<a class="action-link" style="margin-left:6px;font-size:0.72rem;" href="' + escHtml(localUrl) + '" target="_blank">Open ↗</a>';
              if (xeroUrl) btns += '<a class="action-link" style="margin-left:6px;font-size:0.72rem;opacity:0.75;" href="' + escHtml(xeroUrl) + '" target="_blank" title="Live paid status in Xero">Xero ↗</a>';
            } else if (xeroUrl) {
              btns += '<a class="action-link" style="margin-left:6px;font-size:0.72rem;" href="' + escHtml(xeroUrl) + '" target="_blank">Open ↗</a>';
            }
          }
          return btns;
        })() +
      '</td>' +
    '</tr>';
  });

  html += '</tbody></table></div>';
  return html;
}

/* ============================================================
   CREATE NEW INVOICE
   ============================================================ */
var _invoiceLineItems = [];
var _invoiceClientId  = '';
var _invoiceServices  = null;  // cached from _BookingServices

// ── Init (called when pane opens) ─────────────────────────────
function invoiceNewInit_() {
  // Default issue date to today
  var issueEl = document.getElementById('inv-new-issue-date');
  if (issueEl && !issueEl.value) {
    issueEl.value = new Date().toISOString().slice(0, 10);
  }
  // Clear service search
  var svcEl = document.getElementById('inv-service-search');
  if (svcEl) svcEl.value = '';
  var sugEl = document.getElementById('inv-service-suggestions');
  if (sugEl) sugEl.innerHTML = '';
  // Clear line items container
  var liEl = document.getElementById('inv-line-items');
  if (liEl) liEl.innerHTML = '';
  // Pre-load services in background
  preloadInvoiceServices();
}

// ── Service catalog loader ─────────────────────────────────────
// CF SSoT primary (D1 booking_services via /services/catalog), GAS fallback.
function loadInvoiceServices_() {
  if (_invoiceServices) return Promise.resolve(_invoiceServices);
  // #2a: window.JV_INVOICE_SERVICES_NO_GAS === true (default OFF) removes the GAS fallback;
  // CF failure/empty then shows the picker's explicit "catalogue unavailable" state.
  var noGas = window.JV_INVOICE_SERVICES_NO_GAS === true;
  return loadInvoiceServicesCf_()
    .then(function(arr) {
      if (arr && arr.length) { _invoiceServices = arr; return arr; }
      return noGas ? [] : loadInvoiceServicesGas_();
    })
    .catch(function() { return noGas ? [] : loadInvoiceServicesGas_(); });
}

function loadInvoiceServicesCf_() {
  var base = window._jvAdminProxyBase;
  if (!base) return Promise.resolve(null);
  // The mirror's GET /services/catalog is NOT reachable through the Shopify App Proxy (relay 405s it),
  // so this reads the signed POST twin via the admin-services relay entity (same D1 booking_services,
  // active-only, same SERVICE_CATALOG_SSOT_ENABLED flag). Prices are INC-GST cents, matching the GAS contract.
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-services/catalog';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return new Promise(function(resolve) {
    var done = false;
    var timer = setTimeout(function() { if (!done) { done = true; resolve(null); } }, 5000);
    nf(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, credentials: 'same-origin', body: '{}' })
      .then(function(r) { return r.json(); })
      .then(function(body) {
        if (done) return;
        done = true; clearTimeout(timer);
        if (!body || !body.ok || !Array.isArray(body.services)) { resolve(null); return; }
        resolve(body.services.map(function(s) {
          return {
            name: s.serviceName || '',
            category: s.category || '',
            price: (s.priceCents || 0) / 100,
            description: s.description || '',
            source: 'cf_ssot'
          };
        }));
      })
      .catch(function() { if (!done) { done = true; clearTimeout(timer); resolve(null); } });
  });
}

function loadInvoiceServicesGas_() {
  return jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoiceServices' })
    .then(function(r) {
      var arr = (r && Array.isArray(r.data)) ? r.data
              : (r && r.data && Array.isArray(r.data.data)) ? r.data.data
              : null;
      if (arr) _invoiceServices = arr;
      return _invoiceServices || [];
    })
    .catch(function() { return []; });
}

// Pre-load on next tick when the invoice pane becomes active
function preloadInvoiceServices() {
  if (!_invoiceServices) loadInvoiceServices_();
}

// ── Service search autocomplete ────────────────────────────────
function invoiceServiceSearch() {
  var box = document.getElementById('inv-service-suggestions');
  var inp = document.getElementById('inv-service-search');
  var q   = inp ? inp.value.trim().toLowerCase().replace(/[''‚‛′‵`]/g, "'") : '';
  if (!box) return;
  if (q.length < 2) { box.innerHTML = ''; return; }

  var addRowHtml = '<div style="padding:0.45rem 0.75rem;cursor:pointer;font-size:0.82rem;color:var(--brand-primary-deep);border-top:1px solid var(--line);" ' +
    'onclick="jvInvoiceOpenAddServiceModal_(' + JSON.stringify(q).replace(/"/g, '&quot;') + ')">+ Add new service to the catalogue</div>';

  loadInvoiceServices_().then(function(services) {
    services = Array.isArray(services) ? services : [];

    // Catalogue itself loaded empty (sheet has no active rows, or the bridge
    // call failed and returned []). Kept distinct from a genuine no-match so
    // the empty/unavailable case is self-diagnosing rather than looking
    // identical to "your text matched nothing". (ISSUE 5, 2026-06-26)
    if (!services.length) {
      box.innerHTML = '<div class="card-panel" style="padding:0.25rem 0;position:absolute;z-index:100;width:100%;top:2px;">' +
        '<div style="padding:0.4rem 0.75rem;font-size:0.78rem;color:var(--text-light);">Service catalogue is empty or unavailable right now. Use "+ Add custom line item" below, or add a real one to the catalogue:</div>' +
        addRowHtml + '</div>';
      return;
    }

    var matches = services.filter(function(s) {
      // Guard against a row with a missing name so one bad catalogue entry
      // can never crash the whole autocomplete.
      return (String((s && s.name) || '').toLowerCase().indexOf(q) >= 0) ||
             (String((s && s.category) || '').toLowerCase().indexOf(q) >= 0);
    }).slice(0, 8);

    if (!matches.length) {
      box.innerHTML = '<div class="card-panel" style="padding:0.25rem 0;position:absolute;z-index:100;width:100%;top:2px;">' +
        '<div style="padding:0.4rem 0.75rem;font-size:0.78rem;color:var(--text-light);">No matching services. Use "+ Add custom line item" below, or add it to the catalogue for next time:</div>' +
        addRowHtml + '</div>';
      return;
    }

    var html = '<div class="card-panel" style="padding:0.25rem 0;position:absolute;z-index:100;width:100%;top:2px;">';
    matches.forEach(function(s, i) {
      html += '<div style="padding:0.45rem 0.75rem;cursor:pointer;font-size:0.82rem;display:flex;justify-content:space-between;align-items:center;" ' +
        'onclick="selectInvoiceService(' + i + ')" ' +
        'data-svc-idx="' + i + '">' +
        '<span>' + escHtml(s.name) +
          (s.category ? ' <span style="color:var(--text-light);font-size:0.72rem;">· ' + escHtml(s.category) + '</span>' : '') +
        '</span>' +
        '<span style="color:var(--text-light);font-size:0.78rem;margin-left:1rem;">$' + Number(s.price || 0).toFixed(2) + '</span>' +
        '</div>';
    });
    // "+ Add new service" is ALWAYS present, not just on a no-match, since a
    // missing service is most often found while typing a near-match that
    // isn't quite it, not only when nothing matches at all.
    html += addRowHtml + '</div>';

    // Store matches for selectInvoiceService to reference
    box.innerHTML = html;
    box._matches = matches;
  });
}

/* "+ Add new service" (2026-09-29, BUILD-service-manager-and-invoice-picker-
   2026-09-29.md). Saves through the SAME backend route the Service Manager
   screen uses (serviceConfig_adminSave, ServiceConfig.gs), no parallel write
   path. Unlike the old free-text custom line item, this actually persists to
   the catalogue, so the same gap doesn't get hit again next invoice. Modal is
   built and injected here rather than added to the frozen
   sections/jv-admin-crm.liquid markup (Rule 2, ui-guardrails.md); this page
   and the Service Manager tab (sections/jv-booking-admin.liquid) are two
   different Shopify sections/pages, so a literal shared DOM modal isn't
   possible, they share the backend route and field set instead. This
   quick-add form is intentionally a SUBSET of the Service Manager's full
   field list (name/type/price/category/duration); the full 16-field CRUD
   authority stays on the Service Manager screen, this exists to unblock the
   invoice in the moment without leaving the flow. */
var _jvInvAddSvcModalEl = null;
function jvInvoiceEnsureAddServiceModal_() {
  if (_jvInvAddSvcModalEl) return _jvInvAddSvcModalEl;
  var el = document.createElement('div');
  el.id = 'jv-inv-addsvc-modal';
  el.style.cssText = 'display:none;position:fixed;inset:0;z-index:9999;background:rgba(30,23,22,0.45);align-items:center;justify-content:center;';
  el.innerHTML =
    '<div style="background:#fff;border-radius:1.25rem;max-width:420px;width:92%;padding:1.5rem;max-height:88vh;overflow:auto;">' +
      '<h3 style="margin:0 0 0.9rem;font-size:1.05rem;">Add new service</h3>' +
      '<div style="display:flex;flex-direction:column;gap:0.65rem;">' +
        '<label style="font-size:0.78rem;color:var(--text-light);">Name<br>' +
          '<input type="text" id="jv-inv-addsvc-name" class="filter-select" style="width:100%;margin-top:2px;"></label>' +
        '<label style="font-size:0.78rem;color:var(--text-light);">Type<br>' +
          '<select id="jv-inv-addsvc-type" class="filter-select" style="width:100%;margin-top:2px;">' +
            '<option value="Hair">Hair</option><option value="Makeup">Makeup</option>' +
            '<option value="Other">Other</option><option value="Add-on">Add-on</option>' +
          '</select></label>' +
        '<label style="font-size:0.78rem;color:var(--text-light);">Price, inc GST, bridal<br>' +
          '<input type="number" id="jv-inv-addsvc-price" class="filter-select" style="width:100%;margin-top:2px;" min="0" step="0.01"></label>' +
        '<label style="font-size:0.78rem;color:var(--text-light);">Category (optional)<br>' +
          '<input type="text" id="jv-inv-addsvc-category" class="filter-select" style="width:100%;margin-top:2px;" placeholder="e.g. addon"></label>' +
        '<label style="font-size:0.78rem;color:var(--text-light);">Duration, minutes (optional)<br>' +
          '<input type="number" id="jv-inv-addsvc-duration" class="filter-select" style="width:100%;margin-top:2px;" min="0" step="5"></label>' +
        '<div style="font-size:0.72rem;color:var(--text-light);">More fields (availability, buffers, artist skill, non-bridal/partner pricing) are on the full Service Manager screen (Booking Settings &rsaquo; Service Manager).</div>' +
        '<div id="jv-inv-addsvc-msg" style="font-size:0.78rem;"></div>' +
      '</div>' +
      '<div style="display:flex;justify-content:flex-end;gap:0.5rem;margin-top:1.1rem;">' +
        '<button class="btn btn-ghost" onclick="jvInvoiceCloseAddServiceModal_()">Cancel</button>' +
        '<button class="btn btn-primary" id="jv-inv-addsvc-save" onclick="jvInvoiceSaveNewService_()">Save &amp; add to invoice</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(el);
  _jvInvAddSvcModalEl = el;
  return el;
}

function jvInvoiceOpenAddServiceModal_(prefillName) {
  var box = document.getElementById('inv-service-suggestions');
  if (box) box.innerHTML = '';
  var el = jvInvoiceEnsureAddServiceModal_();
  document.getElementById('jv-inv-addsvc-name').value = prefillName || '';
  document.getElementById('jv-inv-addsvc-type').value = 'Hair';
  document.getElementById('jv-inv-addsvc-price').value = '';
  document.getElementById('jv-inv-addsvc-category').value = '';
  document.getElementById('jv-inv-addsvc-duration').value = '';
  document.getElementById('jv-inv-addsvc-msg').textContent = '';
  el.style.display = 'flex';
}

function jvInvoiceCloseAddServiceModal_() {
  if (_jvInvAddSvcModalEl) _jvInvAddSvcModalEl.style.display = 'none';
}

/* name -> stable key, matching the same slug shape ServiceConfig.gs's
   serviceConfig_handle_ / the Service Manager screen's bkScSlugify_ use, so
   a service created from either surface reads sensibly on both. */
function jvInvSlugify_(name) {
  return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
}

function jvInvoiceSaveNewService_() {
  var name = (document.getElementById('jv-inv-addsvc-name').value || '').trim();
  var priceIncGst = parseFloat(document.getElementById('jv-inv-addsvc-price').value);
  var msg = document.getElementById('jv-inv-addsvc-msg');
  if (!name) { msg.textContent = 'Name is required.'; msg.style.color = 'var(--danger)'; return; }
  if (isNaN(priceIncGst) || priceIncGst < 0) { msg.textContent = 'Enter a valid price.'; msg.style.color = 'var(--danger)'; return; }
  var sid = jvInvSlugify_(name);
  if (!sid) { msg.textContent = 'Could not generate a service ID from that name.'; msg.style.color = 'var(--danger)'; return; }
  // The catalogue stores EX-GST (serviceConfig_adminSave's priceExGst); the
  // picker/invoice everywhere else works in INC-GST dollars (see
  // addInvoiceLineItem's own comment on serviceCatalog_listForInvoicing_'s
  // GST-parity contract), convert once here so the stored price matches
  // what every other service in the catalogue means by "price".
  var priceExGst = Math.round((priceIncGst / 1.1) * 100) / 100;
  var durationVal = document.getElementById('jv-inv-addsvc-duration').value;
  var btn = document.getElementById('jv-inv-addsvc-save');
  if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }
  msg.textContent = '';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'serviceConfig_adminSave', args: {
    serviceId: sid,
    name: name,
    type: document.getElementById('jv-inv-addsvc-type').value,
    priceExGst: priceExGst,
    category: (document.getElementById('jv-inv-addsvc-category').value || '').trim(),
    durationMin: durationVal === '' ? '' : Number(durationVal),
    role: 'all',
    active: 'YES'
  } }).then(function(res) {
    if (btn) { btn.disabled = false; btn.textContent = 'Save & add to invoice'; }
    var d = (res && res.data) || res;
    if (!res || res.ok === false || (d && d.ok === false)) {
      msg.textContent = (d && d.error) || (res && res.error) || 'Could not save this service.';
      msg.style.color = 'var(--danger)';
      return;
    }
    // Invalidate the in-memory catalogue cache so the NEXT search re-fetches
    // and includes this new service (loadInvoiceServices_ caches for the
    // page's lifetime otherwise).
    _invoiceServices = null;
    jvInvoiceCloseAddServiceModal_();
    jvToast('Service added to the catalogue.', 'success');
    addInvoiceLineItem({ name: name, price: priceIncGst });
  }).catch(function(e) {
    if (btn) { btn.disabled = false; btn.textContent = 'Save & add to invoice'; }
    msg.textContent = (e && e.message) || 'Could not save this service.';
    msg.style.color = 'var(--danger)';
  });
}

function selectInvoiceService(matchIdx) {
  var box = document.getElementById('inv-service-suggestions');
  if (!box || !box._matches) return;
  var svc = box._matches[matchIdx];
  if (!svc) return;
  box.innerHTML = '';
  var inp = document.getElementById('inv-service-search');
  if (inp) inp.value = '';
  addInvoiceLineItem(svc);
}

// ── Line item management ───────────────────────────────────────
function addInvoiceLineItem(service) {
  var idx  = _invoiceLineItems.length;
  var desc = service ? service.name  : '';
  var amt  = service ? Number(service.price || 0) : 0;
  /* gstMode:'inc', and the legacy `gst` flag is DELIBERATELY NOT SET.

     This is the single most load-bearing line in the GST fix. `service.price`
     comes from serviceCatalog_listForInvoicing_, which returns INC-GST dollars
     from both branches by design -- so a catalogue click produces an inc-GST
     amount and the line must say so.

     Setting `gst:false` here (the old code) would now resolve to 'free' under
     the legacy reading in invGstMode_, zeroing GST on every newly added line --
     i.e. reproducing the exact $0.00 bug this change exists to remove. The
     legacy branch is for records written BEFORE this shipped, and a line being
     created right now is not one of those. */
  _invoiceLineItems.push({ description: desc, amount: amt, gstMode: 'inc' });

  var container = document.getElementById('inv-line-items');
  var row = document.createElement('div');
  row.style.cssText = 'display:flex;gap:0.5rem;align-items:center;flex-wrap:nowrap;';
  row.innerHTML =
    '<input type="text" class="filter-select" style="flex:1;min-width:0;" placeholder="Description" ' +
      'value="' + escAttr(desc) + '" ' +
      'onchange="_invoiceLineItems[' + idx + '].description=this.value; updateInvoiceTotals();">' +
    /* Placeholder WAS "Excl. GST" -- actively wrong, and part of the bug. It
       told an admin to type a pre-GST figure into a field that catalogue
       clicks fill with an INC-GST price, so the same column held two different
       meanings. Now neutral, because the mode selector beside it states which
       one this line is. */
    '<input type="number" class="filter-select" style="width:96px;" placeholder="Amount" ' +
      'value="' + (amt || '') + '" min="0" step="0.01" ' +
      'oninput="_invoiceLineItems[' + idx + '].amount=parseFloat(this.value)||0; updateInvoiceTotals();">' +
    /* GST MODE per line (2026-09-16, Jess's decision), replacing a checkbox
       whose BOTH states were wrong for a catalogue line: unticked recorded
       $0.00, ticked recorded amount*0.1, and the right answer for an inc-GST
       price is amount/11. A two-state control could not express the right
       answer at all, which is why this is a selector and not a relabelled box.
       Default 'inc' matches the catalogue, which is the common case. */
    '<select class="filter-select" style="width:126px;flex-shrink:0;font-size:0.75rem;" ' +
      'title="Does this amount already include GST, or should GST be added?" ' +
      'onchange="_invoiceLineItems[' + idx + '].gstMode=this.value; updateInvoiceTotals();">' +
      '<option value="inc"' + (invGstMode_(_invoiceLineItems[idx]) === 'inc'  ? ' selected' : '') + '>Incl. GST</option>' +
      '<option value="add"' + (invGstMode_(_invoiceLineItems[idx]) === 'add'  ? ' selected' : '') + '>Add GST</option>' +
      '<option value="free"' + (invGstMode_(_invoiceLineItems[idx]) === 'free' ? ' selected' : '') + '>No GST</option>' +
    '</select>' +
    '<button class="btn btn-ghost" style="padding:0.3rem 0.6rem;font-size:0.75rem;flex-shrink:0;" ' +
      'onclick="removeInvoiceLineItem(this,' + idx + ')"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
  container.appendChild(row);
  updateInvoiceTotals();
}

function removeInvoiceLineItem(btn, idx) {
  _invoiceLineItems[idx] = null;
  btn.parentElement.remove();
  updateInvoiceTotals();
}

/* ── Per-line GST mode, browser mirror (2026-09-16) ────────────────────────
   Jess's decision: each line states whether its amount already includes GST or
   needs it added. The authoritative implementation is GAS-side in
   InvoiceGstMode_2026_09_16.gs; the browser cannot call it, so this is a
   deliberate mirror of the SAME three rules.

   KEPT IN STEP BY: identical mode names, identical legacy handling, identical
   arithmetic, and the GAS self-test (JV_invoiceGstMode_selfTest) covering the
   same cases. If either side changes, change both. This duplication is the
   price of the browser needing a live total before a save; it is NOT a second
   opinion about the arithmetic.

   Three modes:
     'inc'  amount already includes GST   -> gst = amount / 11
     'add'  amount is pre-GST             -> gst = amount * 0.1
     'free' GST-free supply               -> gst = 0
   Default 'inc' -- catalogue prices are inc-GST and are the common case.
   Legacy rows (gst true/false, no mode) are read under the OLD meaning:
   true -> 'add', false -> 'free'. Never under the new default, or an in-flight
   job would silently reprice. */
function invGstMode_(li) {
  if (!li) return 'inc';
  var raw = String(li.gstMode || '').trim().toLowerCase();
  if (raw === 'inc' || raw === 'add' || raw === 'free') return raw;
  if (li.gst === true)  return 'add';
  if (li.gst === false) return 'free';
  return 'inc';
}
function invGstForLine_(li) {
  var amt = Number(li && li.amount);
  if (isNaN(amt) || amt === 0) return 0;
  var m = invGstMode_(li);
  if (m === 'add')  return amt * 0.1;
  if (m === 'free') return 0;
  return amt / 11;               // 'inc' -- 110 inc-GST carries 10, not 11
}
function invIncGstForLine_(li) {
  var amt = Number(li && li.amount);
  if (isNaN(amt)) return 0;
  return invGstMode_(li) === 'add' ? amt + (amt * 0.1) : amt;
}
function invGstTotals_(lineItems) {
  var items = (Array.isArray(lineItems) ? lineItems : []).filter(Boolean);
  var gst = 0, totalInc = 0;
  for (var i = 0; i < items.length; i++) {
    gst      += invGstForLine_(items[i]);
    totalInc += invIncGstForLine_(items[i]);
  }
  // Round once at the end, not per line: per-line rounding can drift a cent
  // from the total the bride is actually asked to pay.
  gst      = Math.round(gst * 100) / 100;
  totalInc = Math.round(totalInc * 100) / 100;
  return { subtotalEx: Math.round((totalInc - gst) * 100) / 100, gst: gst, totalInc: totalInc };
}

function updateInvoiceTotals() {
  var items    = _invoiceLineItems.filter(Boolean);
  var _t       = invGstTotals_(items);
  var subtotal = _t.subtotalEx;   // EX-GST, so subtotal + gst = total
  var gst      = _t.gst;
  var total    = _t.totalInc;
  var deposit  = parseFloat((document.getElementById('inv-new-deposit')||{}).value) || 0;
  var balance  = Math.max(0, total - deposit);
  var preview  = document.getElementById('inv-totals-preview');
  var fmt      = function(n){ return '$' + Number(n).toFixed(2); };

  if (total > 0 || deposit > 0) {
    if (preview) preview.style.display = '';
    var sd = document.getElementById('inv-subtotal-display'); if (sd) sd.textContent = fmt(subtotal);
    var gd = document.getElementById('inv-gst-display');      if (gd) gd.textContent = fmt(gst);
    var td = document.getElementById('inv-total-display');    if (td) td.textContent = fmt(total);
    var dd = document.getElementById('inv-deposit-display');  if (dd) dd.textContent = fmt(deposit);
    var bd = document.getElementById('inv-balance-display');  if (bd) bd.textContent = fmt(balance);
  } else {
    if (preview) preview.style.display = 'none';
  }
}

// Payment terms → auto-fill due date from issue date
function invoicePaymentTermsChanged() {
  var terms     = parseInt((document.getElementById('inv-new-payment-terms')||{}).value) || 0;
  var issueVal  = (document.getElementById('inv-new-issue-date')||{}).value || '';
  var dueEl     = document.getElementById('inv-new-due-date');
  if (!terms || !issueVal || !dueEl) return;
  var d = new Date(issueVal);
  d.setDate(d.getDate() + terms);
  dueEl.value = d.toISOString().slice(0, 10);
}

function invoiceClientSearch() {
  var box = document.getElementById('inv-client-suggestions');
  var q = ((document.getElementById('inv-new-client')||{}).value || '').trim().toLowerCase();
  if (q.length < 2) { if (box) box.innerHTML = ''; return; }

  // Lazy-load STATE.clients if user landed here without visiting Clients tab
  if (!STATE.clients || !STATE.clients.length) {
    if (box) box.innerHTML = '<div style="padding:0.5rem 0.75rem;font-size:0.75rem;color:var(--text-light);">Loading clients…</div>';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients' })
      .then(function(r){ if (r.ok && Array.isArray(r.data)) { STATE.clients = r.data; invoiceClientSearch(); } })
      .catch(function(){ if (box) box.innerHTML = '<div style="padding:0.5rem 0.75rem;font-size:0.75rem;color:var(--danger);">Could not load clients.</div>'; });
    return;
  }

  var matches = STATE.clients.filter(function(c) {
    var name  = (c.name || ((c.firstName||'') + ' ' + (c.lastName||''))).toLowerCase();
    var email = (c.email || '').toLowerCase();
    var wd    = (c.weddingDate || '').toLowerCase();
    return name.indexOf(q) >= 0 || email.indexOf(q) >= 0 || wd.indexOf(q) >= 0;
  }).slice(0, 8);

  if (matches.length) {
    invoiceRenderClientSuggestions_(box, matches);
    return;
  }

  // FIX 2026-09-22 (BRIEFS/RESULTS-admin-crm-invoice-new-e2e-audit-2026-09-22.md):
  // STATE.clients is fetched ONCE with no query, so it only ever holds the
  // active-pipeline set -- adminCrm_getClients() unconditionally excludes
  // Completed/Archived/Closed/Lost stages when no search query reaches it
  // server-side (every bride whose wedding date has passed, permanently, by
  // design -- not a one-bride glitch). A zero-match search here previously
  // just said "No matching brides", even for a real, findable bride, with no
  // way to actually search past-wedding brides at all. Falls back to a fresh
  // server-side search (q reaches adminCrm_getClients this time, so its own
  // AdminCRMAPI.gs fix -- e39903e6 -- bypasses the exclusion) ONLY on a
  // genuine local miss -- this never changes the fast, cache-first common
  // case, only the "really isn't in the active list" case that used to
  // dead-end here.
  box.innerHTML = '<div class="card-panel" style="padding:0.5rem 0.75rem;position:absolute;z-index:100;width:100%;top:2px;font-size:0.78rem;color:var(--text-light);">Checking past-wedding brides…</div>';
  var searchToken = q;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients', args: { q: q, includeCompleted: true } })
    .then(function(r) {
      // The box may have moved on to a different query while this was in
      // flight -- never paint a stale result over what the admin is typing now.
      var currentQ = ((document.getElementById('inv-new-client')||{}).value || '').trim().toLowerCase();
      if (currentQ !== searchToken) return;
      var fallbackMatches = (r && r.ok && Array.isArray(r.data)) ? r.data.slice(0, 8) : [];
      if (!fallbackMatches.length) {
        box.innerHTML = '<div class="card-panel" style="padding:0.5rem 0.75rem;position:absolute;z-index:100;width:100%;top:2px;font-size:0.78rem;color:var(--text-light);">No matching brides.</div>';
        return;
      }
      invoiceRenderClientSuggestions_(box, fallbackMatches, /* pastWedding */ true);
    })
    .catch(function() {
      var currentQ = ((document.getElementById('inv-new-client')||{}).value || '').trim().toLowerCase();
      if (currentQ !== searchToken) return;
      box.innerHTML = '<div class="card-panel" style="padding:0.5rem 0.75rem;position:absolute;z-index:100;width:100%;top:2px;font-size:0.78rem;color:var(--text-light);">No matching brides.</div>';
    });
}

function invoiceRenderClientSuggestions_(box, matches, pastWedding) {
  var html = '<div class="card-panel" style="padding:0.25rem 0;position:absolute;z-index:100;width:100%;top:2px;">';
  matches.forEach(function(c) {
    var name = c.name || ((c.firstName||'') + ' ' + (c.lastName||'')).trim();
    html += '<div style="padding:0.5rem 0.75rem;cursor:pointer;font-size:0.82rem;" ' +
      'onclick="selectInvoiceClient(\'' + escAttr(String(c.id)) + '\',\'' + escAttr(name) + '\')">' +
      escHtml(name) +
      (c.email ? ' <span style="color:var(--text-light);font-size:0.72rem;">· ' + escHtml(c.email) + '</span>' : '') +
      (c.weddingDate ? ' <span style="color:var(--text-light);font-size:0.72rem;">· ' + escHtml(formatDate(c.weddingDate)) + '</span>' : '') +
      (pastWedding ? ' <span style="color:var(--text-light);font-size:0.72rem;">· past wedding</span>' : '') +
    '</div>';
  });
  html += '</div>';
  box.innerHTML = html;
}

function selectInvoiceClient(id, name) {
  _invoiceClientId = id;
  var inp = document.getElementById('inv-new-client');
  if (inp) inp.value = name;
  document.getElementById('inv-client-suggestions').innerHTML = '';
}

/* ============================================================
   INVOICE BUILDER — Partner Mode
   ============================================================ */
var _invoiceMode = 'bride';                 // 'bride' | 'partner'
var _invoicePartners = [];                  // populated from bridge_admin_listPartners
var _invoicePartnerRoster = [];             // populated from bridge_admin_getPartnerRoster
var _invoicePartnerSelectedEmail = '';      // currently selected partner email
var _invoicePartnerSelectedBrideClientId = ''; // CRM row index of selected bride

function invoiceModeChange_(mode) {
  _invoiceMode = (mode === 'partner') ? 'partner' : 'bride';
  // Toggle button visuals
  var brideBtn = document.getElementById('inv-mode-bride-btn');
  var partBtn  = document.getElementById('inv-mode-partner-btn');
  if (brideBtn) {
    brideBtn.classList.toggle('jv-active', _invoiceMode === 'bride');
  }
  if (partBtn) {
    partBtn.classList.toggle('jv-active', _invoiceMode === 'partner');
  }
  // Toggle panels
  var bridePanel        = document.getElementById('inv-bride-mode-panel');
  var partnerPanel      = document.getElementById('inv-partner-mode-panel');
  var lineItemsSection  = document.getElementById('inv-line-items-section');
  var depositSection    = document.getElementById('inv-deposit-section');
  var totalsPreview     = document.getElementById('inv-totals-preview');
  if (bridePanel)       bridePanel.style.display       = (_invoiceMode === 'bride') ? '' : 'none';
  if (partnerPanel)     partnerPanel.style.display     = (_invoiceMode === 'partner') ? '' : 'none';
  if (lineItemsSection) lineItemsSection.style.display = (_invoiceMode === 'bride') ? '' : 'none';
  if (depositSection)   depositSection.style.display   = (_invoiceMode === 'bride') ? '' : 'none';
  if (totalsPreview)    totalsPreview.style.display    = (_invoiceMode === 'bride') ? totalsPreview.style.display : 'none';
  // Lazy-load partner dropdown when entering partner mode
  if (_invoiceMode === 'partner' && !_invoicePartners.length) {
    invoiceLoadPartnerDropdown_();
  }
}

// 2026-08-18 (BRIEF-partner-list-lookup-timeout-5-surfaces-2026-08-18.md): read
// the shop-level `admin_partner_list_cache_json` island first (CDN-instant,
// zero GAS calls) before falling back to the live bridge_admin_listPartners
// call. Written by AdminPartnerListCache.gs on a daily+hourly warm schedule;
// payload.data is byte-identical to the `.partners` array the live route
// returns, so every caller's existing render/parse logic is unchanged either
// way. ONE shared helper for all 5 call sites of bridge_admin_listPartners in
// this file (invoice partner dropdown, invoice partner sub-picker not
// applicable here -- that's the roster route, see jvAdminPartnerRoster_getCached_
// below -- Add Partner Managed Bride modal, Add Client modal's optional
// Partner Manager dropdown, Partners tab), so a future 6th call site can reuse
// it instead of re-introducing the same uncached-full-sheet-scan gap.
//
// 2026-08-20 (root-caused the "=>" Ruby-hash corruption bug): this used to
// call JSON.parse(raw) directly on the island's textContent. Every OTHER
// admin cache write in this project forces gzip encoding (adminCache_writeShopMetafield_
// in AdminCacheGzip.gs, see its own doc comment) specifically because a raw
// un-gzipped object stored in a `json`-type Shopify metafield renders in
// Liquid's bare {{ }} output as a Ruby hash ("=>" instead of ":"), which
// JSON.parse cannot read. AdminPartnerListCache.gs was the one cache that
// never adopted the shared write helper -- now fixed there too. This reader
// must now match every sibling's async, gzip-aware read pattern
// (adminCacheParseIsland_), since a forced-gzip payload can only be inflated
// asynchronously (DecompressionStream). Callers now take a callback instead
// of a return value.
function jvAdminPartnerList_getCached_(cb) {
  adminCacheParseIsland_('jv-admin-partner-list-cache', function(parsed) {
    var arr = parsed && Array.isArray(parsed.data) ? parsed.data : null;
    cb((arr && arr.length) ? arr : null);
  });
}
// Back-compat alias -- kept so this specific already-shipped call site name
// still resolves; new code should call jvAdminPartnerList_getCached_ directly.
function invoicePartnersFromShopIsland_(cb) { return jvAdminPartnerList_getCached_(cb); }

function invoiceRenderPartnerOptions_(sel, partners, preselectEmail) {
  // Capture the selection BEFORE rebuilding -- innerHTML wipes it, and a
  // background live-refresh repainting an already-open dropdown must not
  // silently reset the admin's in-progress selection or re-fire
  // invoicePartnerChange_()'s side effects (it clears the bride sub-picker)
  // when nothing has actually changed for her (2026-08-18).
  var prevValue = sel.value || '';
  var opts = '<option value="">Choose a partner…</option>';
  partners.forEach(function(p) {
    opts += '<option value="' + escAttr(p.email) + '">' +
      escHtml(p.businessName || p.email) +
      (p.role ? ' · ' + escHtml(p.role) : '') +
      ' (' + (p.rosterCount || 0) + ' brides)' +
      '</option>';
  });
  sel.innerHTML = opts;
  var targetValue = preselectEmail ? String(preselectEmail).toLowerCase() : prevValue;
  if (targetValue) sel.value = targetValue;
  if (targetValue && targetValue !== prevValue) invoicePartnerChange_();
}

function invoiceLoadPartnerDropdown_(preselectEmail) {
  var sel = document.getElementById('inv-partner-select');
  if (!sel) return;
  sel.innerHTML = '<option value="">Loading partners…</option>';

  // Paint instantly from the CDN island when available -- this is the actual
  // fix for the reported timeout: partner mode no longer waits on a live,
  // uncached full-CRM-sheet scan to show anything. A stale island (a
  // brand-new partner not yet warmed) is corrected by the background
  // live-refresh below within the same session. 2026-08-20: island read is
  // now async (gzip-safe) -- see jvAdminPartnerList_getCached_'s own note.
  invoicePartnersFromShopIsland_(function(islandPartners) {
    if (islandPartners) {
      _invoicePartners = islandPartners;
      invoiceRenderPartnerOptions_(sel, islandPartners, preselectEmail);
    }

    jvBridge.callAdmin('bridge_admin_listPartners', {})
      .then(function(res) {
        if (!res || res.success === false) {
          // Only replace the UI with an error state if the island didn't already
          // paint something usable -- a failed background refresh must never
          // erase a correct, already-visible list.
          if (!islandPartners) {
            sel.innerHTML = '<option value="">' + escHtml((res && res.error) || 'Failed to load partners') + '</option>';
          }
          return;
        }
        var livePartners = res.partners || [];
        if (!livePartners.length) {
          if (!islandPartners) sel.innerHTML = '<option value="">No partner rows in CRM</option>';
          return;
        }
        _invoicePartners = livePartners;
        invoiceRenderPartnerOptions_(sel, livePartners, preselectEmail);
      })
      .catch(function(err) {
        if (!islandPartners) {
          sel.innerHTML = '<option value="">Error: ' + escHtml(err.message || String(err)) + '</option>';
        }
      });
  });
}

// 2026-08-18 (BRIEF-partner-roster-cdn-fastpath-invoice-panel-2026-08-18.md,
// surface #5 of BRIEF-partner-list-lookup-timeout-5-surfaces-2026-08-18.md):
// partner_profile_cache already exists, already warms, and already has a
// working Storefront-fastpath reader on the admin-bride-profile page
// (abpTryPartnerCdnFastPath_ in assets/jv-admin-bride-profile-v2.js). This
// ports that pattern into this file, reusing the machinery this file already
// has for the drawer_bundle metaobject (_drawerSfToken_/_drawerCacheSalt_/
// _drawerSha256Hex_ above, same shared JV_CACHE_HANDLE_SALT secret, confirmed
// in PartnerProfileCache_2026_08_10.gs's own comment that it deliberately
// reuses the SAME salt scheme as drawer_bundle/bride_profile_cache rather
// than a second one).
//
// Handle: SHA-256(lowercased-trimmed-email + '|' + salt), prefix
// 'partner-profile-', mirrors GAS partnerProfileCache_handle_ byte-for-byte.
// Single metaobject field 'profile' holds {ok, cached_at, partner, brides,
// summary} as plain JSON or gzip'd (JVGZ_ prefix) above roughly 50KB via the
// same adminCache_encodeForStore_ encoder every other admin cache uses.
function invoicePartnerRosterCacheHandle_(email) {
  var salt = _drawerCacheSalt_();
  var key  = String(email || '').trim().toLowerCase();
  if (!salt || !key || !(window.crypto && window.crypto.subtle)) return Promise.resolve(null);
  return _drawerSha256Hex_(key + '|' + salt).then(function (hex) {
    return hex ? ('partner-profile-' + hex) : null;
  });
}

// Inflate a metaobject field value that is either plain JSON or a JSON string
// literal "JVGZ_<base64gzip>". Mirrors the pipeline island inflate above
// (adminCacheParseIsland_) but takes a raw string directly rather than
// reading a DOM element, since this value comes from a live GraphQL response.
function invoicePartnerRosterInflate_(raw) {
  return new Promise(function (resolve) {
    try {
      if (!raw) { resolve(null); return; }
      var s = String(raw).trim();
      var marker = s;
      if (marker.charAt(0) === '"' && marker.charAt(marker.length - 1) === '"') {
        try { marker = JSON.parse(s); } catch (e) { marker = s.slice(1, -1); }
      }
      if (typeof marker === 'string' && marker.indexOf('JVGZ_') === 0) {
        if (typeof DecompressionStream === 'undefined') { resolve(null); return; }
        var b64 = marker.slice(5);
        var bin = atob(b64);
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        var ds = new DecompressionStream('gzip');
        new Response(new Blob([bytes]).stream().pipeThrough(ds)).text()
          .then(function (txt) { try { resolve(JSON.parse(txt)); } catch (e) { resolve(null); } })
          .catch(function () { resolve(null); });
        return;
      }
      resolve(JSON.parse(s));
    } catch (e) { resolve(null); }
  });
}

// Returns a Promise resolving to the partner's brides array from the CDN
// metaobject, or null on any miss, missing token, or error (caller then uses
// the live bridge_admin_getPartnerRoster call, exactly as before this fix
// existed).
function invoicePartnerRosterFromCdn_(email) {
  var tok = _drawerSfToken_();
  if (!tok || !email) return Promise.resolve(null);
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return invoicePartnerRosterCacheHandle_(email).then(function (handle) {
    if (!handle) return null;
    var q = 'query($h:MetaobjectHandleInput!){ metaobject(handle:$h){ ' +
            'p: field(key:"profile"){ value } } }';
    var body = { query: q, variables: { h: { type: 'partner_profile_cache', handle: handle } } };
    return nf('https://' + _SF_DRAWER_SHOP + '/api/' + _SF_DRAWER_VER + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var mo = d && d.data && d.data.metaobject;
      var profileRaw = mo && mo.p && mo.p.value;
      if (!profileRaw) return null;
      return invoicePartnerRosterInflate_(profileRaw);
    })
    .then(function (profile) {
      return (profile && Array.isArray(profile.brides)) ? profile.brides : null;
    })
    .catch(function () { return null; });
  });
}

function invoiceRenderPartnerRosterOptions_(brideSel, brides) {
  var opts = '<option value="">Choose a bride…</option>';
  if (!brides.length) {
    opts = '<option value="">No brides yet, use "+ Add new bride" below</option>';
  } else {
    brides.forEach(function(b) {
      opts += '<option value="' + escAttr(String(b.row)) + '">' +
        escHtml(b.brideName) +
        (b.weddingDate ? ' · ' + escHtml(formatDate(b.weddingDate)) : '') +
        (b.brideEmail ? ' · ' + escHtml(b.brideEmail) : '') +
        '</option>';
    });
  }
  brideSel.innerHTML = opts;
}

function invoicePartnerChange_() {
  var sel = document.getElementById('inv-partner-select');
  var email = (sel && sel.value) || '';
  _invoicePartnerSelectedEmail = email;
  _invoicePartnerSelectedBrideClientId = '';
  // Reset the partner rate card whenever the selection changes, so a previous
  // partner's prices can never leak into this one's invoice. Any package lines
  // already added belonged to the OLD partner and are cleared for the same
  // reason. Then pre-warm the new partner's card so the first search is instant
  // and the "no rate card" state is known before the admin starts typing.
  _partnerRateCardServices = null;
  _partnerRateCardEmail    = '';
  _partnerRateCardMissing  = false;
  // Start in the LOADING state, not the failure state. The label is painted
  // synchronously below, before the fetch resolves, so without this every
  // partner selection immediately displayed "Couldn't load ... Check before
  // sending" for the 19-30s the call actually takes: a false warning about
  // money, shown while nothing had gone wrong.
  _partnerRateCardLoading  = !!email;
  _partnerPackageLines     = [];
  renderPartnerPackageLines_();
  if (email) loadPartnerRateCardServices_(email).then(function () { updatePartnerRatesSourceLabel_(); });
  updatePartnerRatesSourceLabel_();
  var amtWrap = document.getElementById('inv-partner-amount-wrap');
  var pkgWrap = document.getElementById('inv-partner-package-wrap');
  var modeWrap = document.getElementById('inv-partner-amount-mode-wrap');
  var brideWrap = document.getElementById('inv-partner-bride-wrap');
  if (amtWrap) amtWrap.style.display = 'none';
  if (pkgWrap) pkgWrap.style.display = 'none';
  if (modeWrap) modeWrap.style.display = 'none';
  if (!email) {
    if (brideWrap) brideWrap.style.display = 'none';
    return;
  }
  if (brideWrap) brideWrap.style.display = '';
  var brideSel = document.getElementById('inv-partner-bride-select');
  if (brideSel) brideSel.innerHTML = '<option value="">Loading brides…</option>';

  // Try the CDN fast path first. On a hit, paint immediately, then still run
  // the live call in the background to self-heal a stale cache (matching
  // every other surface's paint-then-verify pattern in this fix), but a
  // background failure must never clobber an already-correct fast-path
  // paint, and a background success should only repaint if the partner
  // selection hasn't changed underneath it (the admin may have picked a
  // different partner while the live call was in flight).
  var requestedEmail = email;
  invoicePartnerRosterFromCdn_(email).then(function (cdnBrides) {
    var stillCurrent = _invoicePartnerSelectedEmail === requestedEmail;
    if (cdnBrides && stillCurrent && brideSel) {
      _invoicePartnerRoster = cdnBrides;
      invoiceRenderPartnerRosterOptions_(brideSel, cdnBrides);
    }
    jvBridge.callAdmin('bridge_admin_getPartnerRoster', { partnerEmail: email })
      .then(function(res) {
        if (_invoicePartnerSelectedEmail !== requestedEmail) return; // admin moved on
        if (!res || res.success === false) {
          if (!cdnBrides && brideSel) {
            brideSel.innerHTML = '<option value="">' + escHtml((res && res.error) || 'Failed to load roster') + '</option>';
          }
          return;
        }
        // RATE CARD FROM THE ROSTER RESPONSE (2026-09-12, Cloudflare-first).
        //
        // Jess: "it should be loading pretty instantly as it should be on
        // cloudflare". The rate card is currently a SEPARATE blocking GAS call
        // (bridge_admin_getPartnerRateCard) measured live at 26.6s, while this
        // roster call for the SAME partner, at the SAME moment, already goes to
        // D1 and returns in well under a second.
        //
        // D1 partners.rate_card_json exists (005_partners.sql:68) and is already
        // populated by D1PartnerSync_2026_08_10.gs, so this needs no new table,
        // sync or route -- only adding that column to /partner-roster's existing
        // SELECT (jv-crm-mirror/worker.js:5433, Cloudflare/Edge's file, verified
        // absent from the SELECT today).
        //
        // READ OPPORTUNISTICALLY, SO THIS SHIPS SAFELY BEFORE THE WORKER CHANGE.
        // Until that column is in the SELECT, res.rateCard is simply absent,
        // everything below is skipped, and the existing GAS path is untouched.
        // It starts working the moment the column lands, with no coordinated
        // cutover and nothing to flip.
        //
        // MUST NOT REINTRODUCE THE 19-30s FALSE-FAILURE LABEL (fixed 1a74c654):
        // that bug was updatePartnerRatesSourceLabel_ falling through to the
        // FAILURE copy while a fetch was still in flight. On a HIT here we
        // resolve _partnerRateCardLoading to false and repaint, so the label
        // goes straight to the success state. On a MISS we touch none of that
        // state and leave the in-flight GAS fetch to settle it exactly as
        // before, so the loading state still says "Loading..." rather than
        // failing early.
        try {
          // CORRECTED 2026-09-12 after reading the DEPLOYED Worker rather than
          // assuming the shape. The /partner-roster response nests the card
          // under `partner`, not at the top level:
          //   json({ partner: { ..., rateCard: <parsed object|null> }, brides: [...] })
          // (jv-crm-mirror/worker.js: partner object ~:5491, rateCard ~:5547).
          //
          // My first version read only res.rateCard, which is ALWAYS undefined
          // here, so the fast path would have silently never fired and every
          // partner would have kept paying the 26.6s GAS call. Correct, deployed
          // Worker work sitting unused because the consumer looked in the wrong
          // place -- exactly the defect class this session has been cataloguing,
          // one layer up. It would have presented as "the Cloudflare move didn't
          // help", not as a bug.
          //
          // Reads the nested path FIRST, keeping the top-level and snake_case
          // spellings as tolerant fallbacks so a future shape change on their
          // side degrades to the GAS path rather than breaking outright.
          var rcPartner = (res && res.partner) ? res.partner : null;
          var rcRaw = (rcPartner && (rcPartner.rateCard || rcPartner.rate_card_json || rcPartner.rateCardJson)) ||
                      res.rateCard || res.rate_card_json || res.rateCardJson;
          if (rcRaw && _invoicePartnerSelectedEmail === requestedEmail) {
            var rcObj = (typeof rcRaw === 'string') ? JSON.parse(rcRaw) : rcRaw;
            var rcFlat = partnerRateCardToServices_(rcObj);
            // Only adopt a card that actually priced something. An empty flatten
            // means the stored JSON held no usable rates, which is NOT the same
            // as "this partner has no rate card" -- leaving it to the GAS path
            // keeps that distinction honest rather than asserting a miss.
            if (rcFlat && rcFlat.length) {
              _partnerRateCardEmail    = requestedEmail;
              _partnerRateCardServices = rcFlat;
              _partnerRateCardMissing  = false;
              _partnerRateCardLoading  = false;
              updatePartnerRatesSourceLabel_();
            }
          }
        } catch (_) { /* malformed card: leave the GAS path to answer */ }

        var liveBrides = res.brides || [];
        _invoicePartnerRoster = liveBrides;
        if (brideSel) invoiceRenderPartnerRosterOptions_(brideSel, liveBrides);
      })
      .catch(function(err) {
        if (_invoicePartnerSelectedEmail !== requestedEmail) return;
        if (!cdnBrides && brideSel) {
          brideSel.innerHTML = '<option value="">Error: ' + escHtml(err.message || String(err)) + '</option>';
        }
      });
  });
}

function invoicePartnerBrideChange_() {
  var brideSel = document.getElementById('inv-partner-bride-select');
  var rowId = (brideSel && brideSel.value) || '';
  _invoicePartnerSelectedBrideClientId = rowId;
  var modeWrap = document.getElementById('inv-partner-amount-mode-wrap');
  if (modeWrap) modeWrap.style.display = rowId ? '' : 'none';
  // Reset to Free amount every time a new bride is picked, so a leftover
  // package selection from a prior bride can never silently attach to this one.
  partnerBillModeChange_('free');
}

/* ============================================================
   INVOICE BUILDER, Partner Mode: Free Amount vs Service Package
   Per BRIEFS/HANDOFF-bill-partner-service-picker-frontend-to-admin-crm-2026-09-06.md.
   Reuses the exact loadInvoiceServices_/search/select pattern the regular
   Create Invoice flow already uses (see ~line 8041), scoped to its own state
   array so it can never collide with _invoiceLineItems (bride mode).
   ============================================================ */
var _partnerBillMode = 'free';   // 'free' | 'package'
var _partnerPackageLines = [];   // [{ name, category, price, qty, rateCardPrice }], price is INC-GST dollars, same shape loadInvoiceServices_ returns

/* PARTNER RATE CARD ON THE INVOICING TAB (2026-09-11).
   Jess: "the invoicing page pulls up OUR usual pricing list, not the
   partner's. Once EBM is selected, THEIR specific pricing list needs to
   render", editable, with a manual override.

   ROOT CAUSE this fixes: invoicePartnerChange_ loaded the partner's BRIDES
   but never fetched their rate card at all, so the package picker fell
   through to loadInvoiceServices_ -> adminCrm_getInvoiceServices ->
   serviceCatalog_listForInvoicing_(), which is JV's own catalogue and is
   partner-blind by construction.

   SECOND DEFECT, which would have defeated a naive fix: loadInvoiceServices_
   caches into a module-level _invoiceServices and early-returns forever
   after, so even a corrected fetch would never re-switch when the admin
   picked a different partner. Hence a SEPARATE per-partner variable here
   rather than reusing that cache.

   SCOPE, Jess's explicit decision 2026-09-11 when asked whether editing a
   price should change just this invoice or update the partner's saved rates:
   "Just this invoice." So this reads the rate card and NEVER writes to it.
   There is no path here that can modify PARTNER_RATE_CARD_JSON. Editing a
   price affects the invoice being built and nothing else. Do not add a
   save-back without asking her again, it is a different feature with an
   audit requirement (who changed the partner's rates, when, from what).

   The rate card is a NESTED pricing object (bride/party/trial/travel, with
   the nested mother/guest/flowergirl roles added 2026-09-11), not a flat
   searchable list, so it is flattened into the same {name, category, price}
   shape the existing search UI already renders. */
var _partnerRateCardServices = null;  // flattened rate card for the CURRENT partner, or null
var _partnerRateCardEmail    = '';    // which partner _partnerRateCardServices belongs to
var _partnerRateCardMissing  = false; // true when the partner genuinely has no rate card
var _partnerRateCardLoading  = false; // true WHILE the fetch is in flight, so "still loading" is never reported as "failed"

// Mirrors PARTNER_MANAGED_SERVICE_LABELS_ (PartnerManagedCore.gs). Reused for
// the flattened line names so they read the same as they do everywhere else.
var PARTNER_RC_SERVICE_LABELS_ = {
  hairAndMakeup: 'Hair & Makeup',
  hairOnly:      'Hair',
  makeupOnly:    'Makeup',
  maleGrooming:  'Male Grooming',
  mother:        'Mother',
  guest:         'Guest',
  flowergirl:    'Flowergirl'
};

/* Flattens a partner rate card into the flat {name, category, price} shape the
   package search box already renders.

   GST: rate-card values are EX-GST (PartnerManagedCore.gs pushes them as
   line-item amounts with gst:true, and buildPartnerServiceLinesPayload_ below
   divides by 1.1 on the way back out because the CATALOGUE is inc-GST). So
   these are converted to inc-GST here, exactly once, to match the catalogue
   shape this list is standing in for. Getting this wrong in either direction
   is a 10% billing error, so it is done in one place and commented. */
function partnerRateCardToServices_(rc) {
  if (!rc || typeof rc !== 'object') return [];
  var out = [];
  var NESTED = { mother: 1, guest: 1, flowergirl: 1 };
  function push(name, category, exGst) {
    var v = Number(exGst);
    if (!v || isNaN(v) || v <= 0) return;
    out.push({ name: name, category: category, price: Math.round(v * 1.1 * 100) / 100 });
  }
  function label(k) { return PARTNER_RC_SERVICE_LABELS_[k] || k; }

  ['bride', 'party', 'trial'].forEach(function (group) {
    var g = rc[group];
    if (!g || typeof g !== 'object') return;
    var groupLabel = group.charAt(0).toUpperCase() + group.slice(1);
    Object.keys(g).forEach(function (key) {
      var val = g[key];
      if (val && typeof val === 'object') {
        // Nested party role (mother/guest/flowergirl) -> one entry per service.
        if (group === 'party' && NESTED[key]) {
          Object.keys(val).forEach(function (svc) {
            push(groupLabel + ' ' + label(key) + ' ' + label(svc), groupLabel, val[svc]);
          });
        }
        return;
      }
      push(groupLabel + ' ' + label(key), groupLabel, val);
    });
  });

  var tr = rc.travel;
  if (tr && typeof tr === 'object') {
    push('Travel, Jessica Vegas', 'Travel', tr.jess);
    push('Travel, Pro Team artist', 'Travel', tr.proTeamPerArtist);
    push('Trial travel (per km)', 'Travel', tr.trialPerKm);
  }
  return out;
}

/* Loads the selected partner's rate card and flattens it. Resolves to an array
   (possibly empty). Never throws, never writes. Keyed per-partner so switching
   partners genuinely re-fetches, unlike loadInvoiceServices_'s global cache. */
function loadPartnerRateCardServices_(partnerEmail) {
  var email = String(partnerEmail || '').trim().toLowerCase();
  if (!email) { _partnerRateCardServices = null; _partnerRateCardEmail = ''; _partnerRateCardMissing = false; _partnerRateCardLoading = false; return Promise.resolve([]); }
  if (_partnerRateCardEmail === email && _partnerRateCardServices) return Promise.resolve(_partnerRateCardServices);
  // In flight from here until one of the two branches below settles it. Without
  // this the label had no "loading" state and fell through to the FAILURE copy
  // for the 19-30s the call actually takes, telling the admin the prices were
  // wrong while they were merely not back yet.
  _partnerRateCardLoading = true;
  return jvBridge.callAdmin('bridge_admin_getPartnerRateCard', { partnerEmail: email })
    .then(function (res) {
      // Clear the in-flight flag even when the admin has moved on, so a stale
      // response can never leave the label stuck on "Loading..." for a partner
      // who is no longer selected.
      _partnerRateCardLoading = false;
      if (_invoicePartnerSelectedEmail !== email) return [];  // admin moved on

      var rc = (res && res.success !== false) ? res.rateCard : null;
      var flat = rc ? partnerRateCardToServices_(rc) : [];

      // RACE GUARD (2026-09-12). The D1 fast path in invoicePartnerChange_ reads
      // the same partner's rate card off the /partner-roster response, which
      // returns in well under a second while THIS call takes 19-30s. Both are in
      // flight together, so this slower response lands LAST and would otherwise
      // overwrite good D1 data.
      //
      // The damaging case is specific: if GAS returns nothing (Xero hiccup,
      // transient miss) AFTER D1 already supplied real prices, the lines below
      // would blank _partnerRateCardServices and set _partnerRateCardMissing --
      // flipping a working picker to "no rate card stored" with correct prices
      // already on screen. Losing a partner's rates 25 seconds after they
      // appeared is worse than never showing them at all.
      //
      // So this response only WINS if it actually found something, or if nothing
      // is currently loaded. A genuine "this partner has no rate card" still
      // lands correctly, because in that case D1 supplied nothing either and
      // there is no good data to protect.
      if (!flat.length && _partnerRateCardEmail === email &&
          _partnerRateCardServices && _partnerRateCardServices.length) {
        return _partnerRateCardServices;  // keep the D1 result
      }

      _partnerRateCardEmail    = email;
      _partnerRateCardServices = flat.length ? flat : null;
      _partnerRateCardMissing  = !flat.length;
      return flat;
    })
    .catch(function () {
      _partnerRateCardLoading = false;
      if (_invoicePartnerSelectedEmail !== email) return [];
      // A FAILED FETCH IS NOT THE SAME AS "no rate card". Leave
      // _partnerRateCardMissing false so the UI says the rates could not be
      // loaded rather than asserting this partner has none, which would be a
      // wrong statement about their account.
      _partnerRateCardEmail = email;
      _partnerRateCardServices = null;
      return [];
    });
}

function partnerBillModeChange_(mode) {
  _partnerBillMode = (mode === 'package') ? 'package' : 'free';
  var freeBtn = document.getElementById('inv-partner-amountmode-free-btn');
  var pkgBtn  = document.getElementById('inv-partner-amountmode-package-btn');
  if (freeBtn) freeBtn.classList.toggle('jv-active', _partnerBillMode === 'free');
  if (pkgBtn)  pkgBtn.classList.toggle('jv-active', _partnerBillMode === 'package');
  var amtWrap = document.getElementById('inv-partner-amount-wrap');
  var pkgWrap = document.getElementById('inv-partner-package-wrap');
  if (amtWrap) amtWrap.style.display = (_partnerBillMode === 'free') ? '' : 'none';
  if (pkgWrap) pkgWrap.style.display = (_partnerBillMode === 'package') ? '' : 'none';
}

function partnerServiceSearch_() {
  var box = document.getElementById('inv-partner-service-suggestions');
  var inp = document.getElementById('inv-partner-service-search');
  var q   = inp ? inp.value.trim().toLowerCase().replace(/[''‚‛′‵`]/g, "'") : '';
  if (!box) return;
  if (q.length < 2) { box.innerHTML = ''; return; }

  // PARTNER RATES FIRST (2026-09-11). When the selected partner has a rate
  // card, search THEIR prices, not JV's general catalogue, which is the whole
  // point of this fix. Falls back to the general catalogue when the partner
  // genuinely has no rate card, so a partner without one still bills normally
  // rather than being unable to add any line at all.
  var partnerFirst = _partnerRateCardServices
    ? Promise.resolve(_partnerRateCardServices)
    : loadPartnerRateCardServices_(_invoicePartnerSelectedEmail).then(function (flat) {
        return (flat && flat.length) ? flat : loadInvoiceServices_();
      });

  partnerFirst.then(function(services) {
    services = Array.isArray(services) ? services : [];
    if (!services.length) {
      box.innerHTML = '<div class="card-panel" style="padding:0.4rem 0.75rem;position:absolute;z-index:100;width:100%;top:2px;font-size:0.78rem;color:var(--text-light);">Service catalogue is empty or unavailable right now.</div>';
      return;
    }
    var matches = services.filter(function(s) {
      return (String((s && s.name) || '').toLowerCase().indexOf(q) >= 0) ||
             (String((s && s.category) || '').toLowerCase().indexOf(q) >= 0);
    }).slice(0, 8);
    if (!matches.length) {
      box.innerHTML = '<div class="card-panel" style="padding:0.4rem 0.75rem;position:absolute;z-index:100;width:100%;top:2px;font-size:0.78rem;color:var(--text-light);">No matching services.</div>';
      return;
    }
    var html = '<div class="card-panel" style="padding:0.25rem 0;position:absolute;z-index:100;width:100%;top:2px;">';
    matches.forEach(function(s, i) {
      html += '<div style="padding:0.45rem 0.75rem;cursor:pointer;font-size:0.82rem;display:flex;justify-content:space-between;align-items:center;" ' +
        'onclick="selectPartnerService_(' + i + ')" ' +
        'data-svc-idx="' + i + '">' +
        '<span>' + escHtml(s.name) +
          (s.category ? ' <span style="color:var(--text-light);font-size:0.72rem;">&middot; ' + escHtml(s.category) + '</span>' : '') +
        '</span>' +
        '<span style="color:var(--text-light);font-size:0.78rem;margin-left:1rem;">$' + Number(s.price || 0).toFixed(2) + '</span>' +
        '</div>';
    });
    html += '</div>';
    box.innerHTML = html;
    box._matches = matches;
  });
}

function selectPartnerService_(matchIdx) {
  var box = document.getElementById('inv-partner-service-suggestions');
  if (!box || !box._matches) return;
  var svc = box._matches[matchIdx];
  if (!svc) return;
  box.innerHTML = '';
  var inp = document.getElementById('inv-partner-service-search');
  if (inp) inp.value = '';
  addPartnerPackageLine_(svc);
}

function addPartnerPackageLine_(service) {
  var idx = _partnerPackageLines.length;
  var basePrice = Number(service.price || 0);
  _partnerPackageLines.push({
    name:     service.name || '',
    category: service.category || '',
    price:    basePrice,   // INC-GST dollars, matches loadInvoiceServices_
    // rateCardPrice is the price this line STARTED at, kept so an edited price
    // is distinguishable from an untouched one. Without it, an overridden line
    // and a rate-card line look identical and nobody can tell later what was
    // deliberate. Per-invoice only, never written back to the partner's card.
    rateCardPrice: basePrice,
    qty:      1
  });
  renderPartnerPackageLines_();
}

function removePartnerPackageLine_(idx) {
  _partnerPackageLines[idx] = null;
  renderPartnerPackageLines_();
}

function updatePartnerPackageLineQty_(idx, qty) {
  var line = _partnerPackageLines[idx];
  if (!line) return;
  line.qty = Math.max(1, parseInt(qty, 10) || 1);
  updatePartnerPackageLineTotals_(idx);
  updatePartnerPackageTotal_();
}

/* Tells the admin WHOSE prices are on screen. Three genuinely different states,
   deliberately not collapsed into two: the partner's own rates; a partner with
   no rate card at all (JV's general catalogue is used, which is correct and
   billable, just not partner-specific); and a rate card that failed to LOAD.
   Reporting the third as the second would be a false statement about the
   partner's account, and would send someone looking for a missing rate card
   that actually exists. */
function updatePartnerRatesSourceLabel_() {
  var el = document.getElementById('inv-partner-rates-source');
  if (!el) return;
  if (!_invoicePartnerSelectedEmail) { el.textContent = ''; return; }
  var sel  = document.getElementById('inv-partner-select');
  var name = (sel && sel.selectedOptions && sel.selectedOptions[0]) ? sel.selectedOptions[0].textContent.trim() : 'this partner';
  if (_partnerRateCardServices && _partnerRateCardServices.length) {
    el.textContent = 'Showing ' + name + "'s own rates. Editing a price changes this invoice only.";
  } else if (_partnerRateCardMissing) {
    el.textContent = 'No rate card stored for ' + name + ', showing the standard catalogue. Prices are still editable.';
  } else if (_partnerRateCardLoading) {
    // FOUR states, not three (fixed 2026-09-12, Jess via the 1 verification
    // pass). This function previously had no way to say "still loading", so the
    // FAILURE message was shown as the INITIAL state and sat there for the
    // 19-30s the fetch actually takes. On a money screen the admin was told the
    // prices were wrong while they were merely not back yet.
    //
    // Worth keeping even once this call moves to Cloudflare and returns in
    // under a second: a wrong initial state is wrong at any speed, and a fast
    // path can still fail.
    el.textContent = "Loading " + name + "'s rates...";
  } else {
    el.textContent = "Couldn't load " + name + "'s rates, showing the standard catalogue. Check before sending.";
  }
}

/* True when this line's price has been edited away from what it started at.
   Tolerance is half a cent, so float noise never shows a phantom "edited". */
function partnerLineIsOverridden_(line) {
  if (!line || line.rateCardPrice == null) return false;
  return Math.abs(Number(line.price) - Number(line.rateCardPrice)) > 0.005;
}

/* Per-invoice price override (2026-09-11, Jess: "Just this invoice").
   Writes ONLY to the in-memory line. There is deliberately no path from here
   to PARTNER_RATE_CARD_JSON, so editing a price can never silently re-price
   the partner's future invoices. */
function updatePartnerPackageLinePrice_(idx, price) {
  var line = _partnerPackageLines[idx];
  if (!line) return;
  var v = parseFloat(price);
  // A blank or invalid box means "no change yet", not zero. Zeroing a line
  // because the admin cleared the field mid-edit would silently drop it from
  // the invoice (buildPartnerServiceLinesPayload_ rounds to 0 cents, and the
  // backend skips non-positive lines).
  if (isNaN(v) || v < 0) return;
  line.price = v;
  // Deliberately does NOT re-render the whole list: that would destroy focus
  // and caret position while the admin is still typing the number, same reason
  // the qty handler above patches in place.
  updatePartnerPackageLineTotals_(idx);
  updatePartnerPackageMarker_(idx);
  updatePartnerPackageTotal_();
}

/* Patches one row's line-total cell in place (no re-render). */
function updatePartnerPackageLineTotals_(idx) {
  var line = _partnerPackageLines[idx];
  var container = document.getElementById('inv-partner-package-lines');
  if (!line || !container) return;
  var row = container.querySelector('[data-pkg-idx="' + idx + '"]');
  if (!row) return;
  var cell = row.querySelector('[data-pkg-line-total]');
  if (cell) cell.textContent = '$' + Number(line.price * line.qty).toFixed(2);
}

/* Shows/hides the "edited" marker in place, so it appears the moment the price
   diverges rather than only after the next full render. */
function updatePartnerPackageMarker_(idx) {
  var line = _partnerPackageLines[idx];
  var container = document.getElementById('inv-partner-package-lines');
  if (!line || !container) return;
  var row = container.querySelector('[data-pkg-idx="' + idx + '"]');
  if (!row) return;
  var slot = row.querySelector('[data-pkg-override-slot]');
  if (!slot) return;
  if (partnerLineIsOverridden_(line)) {
    slot.setAttribute('title', 'Overridden from $' + Number(line.rateCardPrice).toFixed(2) + ' (this invoice only)');
    slot.style.cssText = 'font-size:0.68rem;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:var(--brand-primary-deep);flex-shrink:0;';
    slot.textContent = 'edited';
  } else {
    slot.removeAttribute('title');
    slot.style.cssText = 'width:38px;flex-shrink:0;';
    slot.textContent = '';
  }
}

function renderPartnerPackageLines_() {
  var container = document.getElementById('inv-partner-package-lines');
  if (!container) return;
  var lines = _partnerPackageLines;
  container.innerHTML = '';
  lines.forEach(function(line, idx) {
    if (!line) return;
    var row = document.createElement('div');
    // Stamp the ARRAY index on the row. removePartnerPackageLine_ nulls entries
    // in place rather than splicing, and this renderer skips nulls, so after any
    // removal the DOM position no longer equals the array index. The in-place
    // patch helpers below must look the row up by this attribute, never by
    // container.children[idx], or they silently patch the wrong line.
    row.setAttribute('data-pkg-idx', String(idx));
    row.style.cssText = 'display:flex;gap:0.5rem;align-items:center;flex-wrap:nowrap;';
    row.innerHTML =
      '<span style="flex:1;min-width:0;font-size:0.82rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escHtml(line.name) +
        (line.category ? ' <span style="color:var(--text-light);font-size:0.72rem;">&middot; ' + escHtml(line.category) + '</span>' : '') +
      '</span>' +
      '<input type="number" class="filter-select" style="width:64px;" min="1" step="1" value="' + line.qty + '" ' +
        'oninput="updatePartnerPackageLineQty_(' + idx + ', this.value)" title="Quantity">' +
      // EDITABLE UNIT PRICE (2026-09-11). Inc-GST dollars, same units the
      // catalogue and rate card are presented in on this screen. Editing it
      // changes THIS INVOICE ONLY, per Jess's explicit decision, never the
      // partner's stored rates.
      '<input type="number" class="filter-select" style="width:84px;" min="0" step="0.01" value="' + Number(line.price).toFixed(2) + '" ' +
        'oninput="updatePartnerPackageLinePrice_(' + idx + ', this.value)" title="Unit price (inc GST). Editing changes this invoice only.">' +
      // Override marker. Shown only when the price actually differs from what
      // the line started at, and it names the original, so after the fact it is
      // obvious what was changed and from what. A silent override is the thing
      // this exists to prevent.
      (partnerLineIsOverridden_(line)
        ? '<span data-pkg-override-slot title="Overridden from $' + Number(line.rateCardPrice).toFixed(2) + ' (this invoice only)" ' +
            'style="font-size:0.68rem;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:var(--brand-primary-deep);flex-shrink:0;">edited</span>'
        : '<span data-pkg-override-slot style="width:38px;flex-shrink:0;"></span>') +
      '<span data-pkg-line-total style="width:88px;text-align:right;font-size:0.82rem;color:var(--text-light);">$' + Number(line.price * line.qty).toFixed(2) + '</span>' +
      '<button class="btn btn-ghost" style="padding:0.3rem 0.6rem;font-size:0.75rem;flex-shrink:0;" ' +
        'onclick="removePartnerPackageLine_(' + idx + ')"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    container.appendChild(row);
  });
  updatePartnerPackageTotal_();
}

function updatePartnerPackageTotal_() {
  var total = _partnerPackageLines.filter(Boolean).reduce(function(s, l) { return s + (l.price * l.qty); }, 0);
  var wrap = document.getElementById('inv-partner-package-total');
  var disp = document.getElementById('inv-partner-package-total-display');
  if (wrap) wrap.style.display = total > 0 ? '' : 'none';
  if (disp) disp.textContent = '$' + Number(total).toFixed(2);
}

/* Converts the collected package lines into the serviceLines payload shape
   the backend expects (PartnerManagedAdminAPI.gs shopifyBridge_adminBillPartner,
   commit a176242c). price is INC-GST dollars from the catalogue, the backend
   wants EX-GST integer cents per unit, same conversion the handoff spec
   names explicitly, do not change this formula without re-checking that file. */
function buildPartnerServiceLinesPayload_() {
  return _partnerPackageLines.filter(Boolean).map(function(line) {
    return {
      serviceId:       '',   // catalogue has no stable ID field today, per the handoff
      description:      line.name,
      qty:               line.qty,
      unitAmountCents:  Math.round((line.price / 1.1) * 100),
      category:          line.category || ''
    };
  });
}

function openAddBrideForCurrentPartner_() {
  if (!_invoicePartnerSelectedEmail) {
    alert('Pick a partner first.');
    return;
  }
  openAddPartnerManagedBrideModal(_invoicePartnerSelectedEmail, function(result) {
    // Auto-refresh the partner's roster + select the newly-created bride
    _invoicePartnerSelectedBrideClientId = String(result.rowIndex);
    // Reload the dropdown and pre-select the new bride
    invoicePartnerChange_();
    setTimeout(function() {
      var brideSel = document.getElementById('inv-partner-bride-select');
      if (brideSel) brideSel.value = String(result.rowIndex);
      invoicePartnerBrideChange_();
      var statusEl = document.getElementById('inv-partner-status');
      if (statusEl) statusEl.textContent = 'New bride created (row ' + result.rowIndex + '). Enter the invoice amount below.';
    }, 800);
  });
}

function submitPartnerInvoice_() {
  var statusEl = document.getElementById('inv-partner-status');
  var dueDate  = (document.getElementById('inv-new-due-date')      || {}).value || '';
  var notes    = (document.getElementById('inv-new-notes')         || {}).value || '';
  var termsDays = (document.getElementById('inv-new-payment-terms') || {}).value || '';

  if (!_invoicePartnerSelectedEmail)         { if (statusEl) statusEl.textContent = 'Pick a partner.'; return; }
  if (!_invoicePartnerSelectedBrideClientId) { if (statusEl) statusEl.textContent = 'Pick or add a bride for this partner.'; return; }

  // Package mode (2026-09-06, HANDOFF-bill-partner-service-picker-frontend-to-admin-crm):
  // build the serviceLines payload instead of a single amount. Backend spec
  // (PartnerManagedAdminAPI.gs shopifyBridge_adminBillPartner, commit a176242c)
  // via buildPartnerServiceLinesPayload_() above.
  var amount = 0;
  var serviceLines = null;
  if (_partnerBillMode === 'package') {
    serviceLines = buildPartnerServiceLinesPayload_();
    if (!serviceLines.length) {
      if (statusEl) statusEl.textContent = 'Add at least one service to the package.';
      return;
    }
  } else {
    amount = parseFloat((document.getElementById('inv-partner-amount') || {}).value || '0');
    if (!amount || isNaN(amount) || amount <= 0) {
      if (statusEl) statusEl.textContent = 'Enter an amount greater than zero (dollars, GST-inclusive).';
      return;
    }
  }

  // Map payment-terms-days input to the backend's terms enum
  var terms = 'net_14';
  var td = parseInt(termsDays, 10);
  if (td === 0)  terms = 'due_on_receipt';
  else if (td === 7)  terms = 'net_7';
  else if (td === 14) terms = 'net_14';
  else if (td === 30) terms = 'net_30';

  if (statusEl) statusEl.textContent = 'Sending to Xero via Pabbly... (3-10 seconds)';

  // Disable-on-click (2026-09-06, HANDOFF-partner-invoice-disable-on-click):
  // first line of defence against a double-click firing two invoice-creation
  // calls, same pattern as confirmCreateAndSend_/saveAndSendInvoice_ elsewhere
  // in this file. The backend idempotency guard (adminInvoiceIdem_run_) is the
  // real protection; this is UX, not the only thing standing in the way.
  var btn = document.getElementById('inv-create-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

  var payload = {
    clientId: _invoicePartnerSelectedBrideClientId,
    terms:    terms,
    dueDate:  dueDate,
    notes:    notes
  };
  if (serviceLines) {
    payload.serviceLines = serviceLines;
  } else {
    payload.amount = amount;
  }

  jvBridge.callAdmin('bridge_admin_billPartner', payload)
    .then(function(res) {
      if (btn) { btn.disabled = false; btn.textContent = 'Create & Send'; }
      if (!res || res.success === false) {
        var msg = (res && res.message) || (res && res.error) || 'unknown error';
        if (statusEl) statusEl.textContent = 'Error: ' + msg;
        return;
      }
      var lines = [];
      lines.push('Invoiced ' + (res.billedTo || 'partner') + ' $' + Number(res.amount || 0).toFixed(2) + ' for ' + (res.forBride || 'bride') + '.');
      if (res.invoiceNumber) lines.push('Xero invoice: ' + res.invoiceNumber);
      if (res.dueDate)       lines.push('Due: ' + res.dueDate);
      if (res.onlineInvoiceUrl) {
        lines.push('<a href="' + res.onlineInvoiceUrl + '" target="_blank" rel="noopener" style="color:var(--brand-primary-deep);font-weight:600;">Open in Xero &#8599;</a>');
      }
      // 2026-07-30 fix: this flow previously never sent an email at all, only
      // created the Xero invoice. Now it does, surface the result unambiguously.
      if (res.emailSent) {
        lines.push('<span style="color:#1f6b46;font-weight:600;">Email sent to ' + escHtml(res.billedToEmail || '') + '.</span>');
      } else {
        lines.push('<span style="color:#b32727;font-weight:700;">EMAIL FAILED TO SEND: ' + escHtml(res.emailError || 'unknown reason') + '. Use "Resend invoice email" from the invoice list.</span>');
      }
      if (statusEl) statusEl.innerHTML = lines.join('<br>');
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Create & Send'; }
      if (statusEl) statusEl.textContent = 'Error: ' + (err.message || String(err));
    });
}

function buildInvoicePayload(status) {
  var items    = _invoiceLineItems.filter(Boolean);
  // Same mirror the on-screen totals use (2026-09-16), so what an admin reads
  // and what gets submitted can never be two different numbers. The backend
  // recomputes from the SAME rules via invoiceGst_totals_ and ignores these
  // figures for the Xero payload -- they are sent for the CRM record and for
  // the preview to compare against.
  var _t       = invGstTotals_(items);
  var subtotal = _t.subtotalEx;
  var gst      = _t.gst;
  var total    = _t.totalInc;
  var deposit  = parseFloat((document.getElementById('inv-new-deposit')||{}).value) || 0;
  return {
    clientId:         _invoiceClientId,
    lineItems:        items,
    subtotal:         subtotal,
    gstTotal:         gst,
    total:            total,
    deposit:          deposit,
    balanceDue:       Math.max(0, total - deposit),
    issueDate:        (document.getElementById('inv-new-issue-date')||{}).value || '',
    dueDate:          (document.getElementById('inv-new-due-date')||{}).value || '',
    paymentTermsDays: (document.getElementById('inv-new-payment-terms')||{}).value || '',
    notes:            (document.getElementById('inv-new-notes')||{}).value || '',
    status:           status
  };
}

/* Two-step send: first call returns a preview from the server (no Pabbly hit, no
   CRM write). User must confirm in a modal; only the second call carries
   confirmed:true. Keeps UI bugs from silently invoicing on first click. */

function saveInvoiceDraft() {
  if (_invoiceMode === 'partner') {
    alert('Partner invoices are created as AUTHORISED (not draft). Use "Create & Send" instead.');
    return;
  }
  if (!_invoiceClientId) { alert('Please select a client.'); return; }
  invoicePreviewThenConfirm_('draft');
}

function saveAndSendInvoice() {
  if (_invoiceMode === 'partner') {
    submitPartnerInvoice_();
    return;
  }
  if (!_invoiceClientId) { alert('Please select a client.'); return; }
  invoicePreviewThenConfirm_('sent');
}

function invoicePreviewThenConfirm_(status) {
  /* EMPTY-INVOICE GUARD (2026-09-16).
     WAS: neither saveInvoiceDraft nor saveAndSendInvoice inspected the line-item
     array -- both checked only _invoiceClientId -- so an invoice with zero lines
     could be created and SENT to a bride for $0.00. Found by Cowork's invoice
     e2e assessment, relayed via Cloudflare/Edge
     (state/findings/HANDOFF-invoice-gst-bug-non-partner-to-admin-crm-2026-09-15.md).

     Guarded HERE, in the shared path, rather than in the two callers: both
     entry points funnel through this function, so one check covers both and a
     future third caller cannot bypass it by forgetting to copy the guard. That
     is the same reasoning the shared-helper fix used for the BBS charge-line
     writes, where four copies of a check had already drifted apart.

     Deliberately counts lines with a real amount, not just array length: a row
     the admin added and never filled in is still an empty invoice in every way
     that matters to the bride receiving it. A negative amount IS allowed --
     that is a legitimate discount/adjustment line, not an empty one. */
  var guardItems = (typeof _invoiceLineItems !== 'undefined' && Array.isArray(_invoiceLineItems))
    ? _invoiceLineItems.filter(Boolean) : [];
  var guardPriced = guardItems.filter(function (i) {
    return Number(i && i.amount) !== 0 && !isNaN(Number(i && i.amount));
  });
  if (!guardPriced.length) {
    var gWhy = guardItems.length
      ? 'Every line on this invoice has no amount. Add a price before creating it.'
      : 'This invoice has no line items. Add at least one before creating it.';
    /* Toast, with alert as a REAL fallback rather than a decorative one.
       jvToast is a bare function declaration (not on window) and, more
       importantly, RETURNS SILENTLY if #jv-toast-container is absent -- so
       calling it alone could swallow this guard's only feedback and leave the
       admin clicking a button that appears to do nothing. Verified .jv-toast
       .error IS styled in jv-admin-crm.css, so when the container exists the
       message is genuinely visible; this is about the case where it does not.
       A blocking alert is the wrong default on this page (132 of them are being
       removed) but it is the right last resort for a guard that must never be
       the thing that fails silently. */
    var gShown = false;
    try {
      if (typeof jvToast === 'function' && document.getElementById('jv-toast-container')) {
        jvToast(gWhy, 'error');
        gShown = true;
      }
    } catch (gErr) { gShown = false; }
    if (!gShown) alert(gWhy);
    return;
  }

  var payload = buildInvoicePayload(status);  // confirmed flag NOT set
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_createInvoice', args: payload })
    .then(function(res) {
      if (!res.ok) { alert('Error: ' + ((res.error && res.error.message) || String(res.error))); return; }
      var data = res.data || {};
      if (!data.preview) {
        // Server returned a non-preview response on first call — abort & log.
        alert('Unexpected server response (expected preview). Aborting.');
        return;
      }
      showInvoiceConfirmModal_(data, payload, status);
    })
    .catch(function(err){ alert('Error: ' + (err.message || String(err))); });
}

function showInvoiceConfirmModal_(preview, basePayload, status) {
  if (status === 'sent') {
    // 2026-07-30 fix (FIX-invoice-create-and-send-must-actually-send-2026-07-30.md
    // Item 1): "Create & Send" must genuinely send in one action, not gate the real
    // send behind a second, easy-to-miss preview-overlay click. Show ONE confirm
    // step (this modal), then fire the server-side create+send chain atomically.
    // Reviewing/editing the email before it goes out is still possible, that is the
    // separate "Create & Preview" action (createInvoiceAsPreviewFlow_), not this one.
    showCreateAndSendConfirmModal_(preview, basePayload);
    return;
  }
  showSimpleInvoiceConfirmModal_(preview, basePayload, status);
}

function showCreateAndSendConfirmModal_(preview, basePayload) {
  var existing = document.getElementById('inv-confirm-modal');
  if (existing) existing.remove();

  var bride = preview.bride || {};
  var match = preview.contactMatch || {};
  var p     = preview.payload || {};
  var warns = preview.warnings || [];

  var matchLine = match.matchedBy
    ? 'Client record matched: <strong>' + escHtml(match.contactName || 'Unnamed') + '</strong>'
        + (match.contactEmail ? ' (' + escHtml(match.contactEmail) + ')' : '')
    : '<span style="color:#9b4c1e;">No existing client record, a new one will be created in accounting.</span>';

  var warnHtml = warns.length
    ? '<div class="alert warning" style="margin-top:0.6rem;font-size:0.78rem;">' + warns.map(escHtml).join('<br>') + '</div>'
    : '';

  var modal = document.createElement('div');
  modal.id = 'inv-confirm-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div class="card-panel" style="max-width:520px;width:100%;padding:1.5rem;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;">Confirm Create &amp; Send</div>' +
      '<div style="font-size:0.82rem;color:var(--text-light);margin-bottom:0.9rem;">' +
        'For <strong>' + escHtml(bride.name || 'this bride') + '</strong>' +
        (bride.email ? ' &lt;' + escHtml(bride.email) + '&gt;' : '') +
      '</div>' +
      '<div style="font-size:0.82rem;line-height:1.6;">' +
        matchLine +
        '<div style="margin-top:0.5rem;">' +
          (p.subtotal !== undefined && p.gstTotal !== undefined
            ? '<strong>Subtotal:</strong> $' + Number(p.subtotal||0).toFixed(2) +
              ' &nbsp;&middot;&nbsp; <strong>GST:</strong> $' + Number(p.gstTotal||0).toFixed(2) +
              ' &nbsp;&middot;&nbsp; '
            : '') +
          '<strong>Total:</strong> $' + Number(p.total||0).toFixed(2) +
          ' &nbsp;&middot;&nbsp; <strong>Deposit:</strong> $' + Number(p.deposit||0).toFixed(2) +
          ' &nbsp;&middot;&nbsp; <strong>Balance:</strong> $' + Number(p.balanceDue||0).toFixed(2) +
        '</div>' +
        (p.issueDate ? '<div><strong>Issue date:</strong> ' + escHtml(formatDate(p.issueDate)) + '</div>' : '') +
        (p.dueDate ? '<div><strong>Due:</strong> ' + escHtml(formatDate(p.dueDate)) + '</div>' : '') +
        (p.paymentTermsDays ? '<div><strong>Payment terms:</strong> ' + escHtml(String(p.paymentTermsDays)) + ' days</div>' : '') +
        '<div><strong>Action:</strong> Create the Xero invoice and send the branded email immediately, no further click needed.</div>' +
      '</div>' +
      warnHtml +
      '<div id="inv-create-send-result" style="margin-top:0.8rem;"></div>' +
      '<div style="display:flex;gap:0.5rem;margin-top:1.2rem;justify-content:space-between;">' +
        '<button class="btn btn-ghost" id="inv-confirm-preview-btn" onclick="createInvoiceAsPreviewFlow_()" ' +
          'title="Create the invoice but review/edit the email before it sends">Create &amp; Preview instead</button>' +
        '<div style="display:flex;gap:0.5rem;">' +
          '<button class="btn btn-ghost" onclick="closeInvoiceConfirmModal_()">Cancel</button>' +
          '<button class="btn btn-primary" id="inv-confirm-send-btn" onclick="confirmCreateAndSend_()">Create &amp; Send</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
  modal._payload = basePayload;
  modal._preview = preview;
}

function confirmCreateAndSend_() {
  var modal = document.getElementById('inv-confirm-modal');
  if (!modal || !modal._payload) { alert('Confirm modal lost state, please retry.'); return; }
  var btn = document.getElementById('inv-confirm-send-btn');
  var previewBtn = document.getElementById('inv-confirm-preview-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Creating & sending...'; }
  if (previewBtn) previewBtn.disabled = true;

  var payload = Object.assign({}, modal._payload, { confirmed: true, status: 'sent' });
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_createAndSendInvoice', args: payload })
    .then(function(res) {
      var d = (res && res.data) || {};
      // RE-CLICK GUARD (2026-08-04): a concurrent identical submission is still
      // running. Say so plainly and do NOT present it as a failure, because a
      // "failed" message here is exactly what makes an admin click a third time
      // and risk a duplicate invoice. See AdminInvoiceIdempotency_2026_08_04.gs.
      // This check stays synchronous - the idempotency guard's in-flight block
      // returns instantly, before the deferred create is even enqueued.
      if (d.inProgress) {
        closeInvoiceConfirmModal_();
        alert('ALREADY IN PROGRESS\n\n' + (d.error || 'This invoice is already being created by your previous click.') +
          '\n\nDo not click Create & Send again. Check the invoice list in a moment.');
        switchView('invoicing');
        return;
      }
      if (!res.ok || d.success === false) {
        closeInvoiceConfirmModal_();
        alert('Xero invoice creation failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
        return;
      }
      // A replayed result means the FIRST click already did the work (its response
      // was lost to a timeout). Report the true end state, never "sent" a 2nd time.
      // This can arrive either synchronously (replay hit immediately) or after a
      // poll (the replayed result IS the final async result) - handle both here.
      if (d.idempotentReplay) {
        closeInvoiceConfirmModal_();
        confirmCreateAndSend_reportFinal_(d);
        return;
      }
      if (!d.pending || !d.jobKey) {
        // Fail-safe fallback path already resolved synchronously (deferred infra
        // was unavailable) - same end state as before this change.
        closeInvoiceConfirmModal_();
        confirmCreateAndSend_reportFinal_(d);
        return;
      }
      // 2026-08-19: the real Xero create + email send now runs in the background.
      // Keep the confirm modal up (buttons already disabled) and poll for the
      // real result rather than reporting success before either exists.
      showInvoiceCreatingSpinner_('Creating invoice and sending email...');
      invPollCreateStatus_(d.jobKey, function (finalResult) {
        hideInvoiceCreatingSpinner_();
        closeInvoiceConfirmModal_();
        confirmCreateAndSend_reportFinal_(finalResult);
      });
    })
    .catch(function(err) {
      closeInvoiceConfirmModal_();
      alert('Error: ' + (err.message || String(err)));
    });
}

/* Shared final-state reporting for confirmCreateAndSend_ - same three outcomes
   (failed / emailSent / created-but-email-failed) whether the result arrived
   synchronously (replay, or fallback) or via invPollCreateStatus_. */
function confirmCreateAndSend_reportFinal_(d) {
  d = d || {};
  if (d.success === false) {
    alert('Xero invoice creation failed: ' + (d.error || 'Unknown error'));
    return;
  }
  if (d.emailSent) {
    alert('Invoice sent to ' + (d.to || (d.bride && d.bride.email) || 'the client') + '. A JV-branded email has been delivered.');
    switchView('invoicing');
    return;
  }
  // Invoice created but the email genuinely failed, unambiguous, cannot be missed.
  // A dismissed alert() still leaves the invoicing list showing the invoice with a
  // clear "Resend invoice email" recovery action, so nothing is silently lost.
  alert('INVOICE CREATED BUT EMAIL FAILED TO SEND\n\n' +
    (d.emailError || 'The invoice exists in Xero (ID ' + (d.xeroInvoiceId || 'unknown') + ') but the email did not go out.') +
    '\n\nUse "Resend invoice email" from the invoice list to deliver it. Jess has also been alerted via admin Chat.');
  switchView('invoicing');
}

// "Create & Preview instead", the explicit opt-in for reviewing/editing the email
// before it sends. Keeps the original create -> preview -> manual-send-overlay flow
// available, but only when the admin deliberately chooses it, never as the silent
// default behind a button labelled "Create & Send".
function createInvoiceAsPreviewFlow_() {
  var modal = document.getElementById('inv-confirm-modal');
  if (!modal || !modal._payload) { alert('Confirm modal lost state, please retry.'); return; }
  var basePayload = modal._payload;
  var preview = modal._preview || {};
  closeInvoiceConfirmModal_();

  showInvoiceCreatingSpinner_();
  var createPayload = Object.assign({}, basePayload, {
    confirmed:        true,
    skipPendingEmail: true   // the admin will review/edit then send via the preview overlay
  });
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_createInvoice',
    args: createPayload
  }).then(function(createRes) {
    var d = (createRes && createRes.data) || {};
    if (!createRes.ok || d.success === false) {
      hideInvoiceCreatingSpinner_();
      alert('Xero invoice creation failed: ' + (d.error || (createRes.error && createRes.error.message) || 'Unknown error'));
      return;
    }
    if (!d.pending || !d.jobKey) {
      // Fail-safe fallback path already resolved synchronously (deferred infra
      // was unavailable) - go straight to the preview build with the real result.
      createInvoicePreviewFlow_afterCreate_(d, basePayload, preview);
      return;
    }
    // 2026-08-19: the real Xero create now runs in the background. Poll for it
    // before building the email preview, since the preview needs the real URL.
    invPollCreateStatus_(d.jobKey, function (finalResult) {
      if (!finalResult || finalResult.success === false) {
        hideInvoiceCreatingSpinner_();
        alert('Xero invoice creation failed: ' + ((finalResult && finalResult.error) || 'Unknown error'));
        return;
      }
      createInvoicePreviewFlow_afterCreate_(finalResult, basePayload, preview);
    });
  }).catch(function(err) {
    hideInvoiceCreatingSpinner_();
    alert('Xero invoice creation failed: ' + (err.message || String(err)));
  });
}

/* Second half of createInvoiceAsPreviewFlow_ - runs once the real Xero create
   result is known (either immediately, from the rare synchronous fallback, or
   after invPollCreateStatus_ resolves). Builds the email preview with the real
   invoice URL and opens the review/edit overlay. */
function createInvoicePreviewFlow_afterCreate_(d, basePayload, preview) {
  var realUrl = d.invoiceUrl || d.pdfUrl || '';
  var xeroInvoiceId = d.xeroInvoiceId || '';
  var bride = d.bride || (preview && preview.bride) || {};

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getInvoiceEmailPreview',
    args: Object.assign({}, basePayload, { invoiceUrl: realUrl })
  }).then(function(res) {
    hideInvoiceCreatingSpinner_();
    if (res.ok && res.data && res.data.bodyHtml) {
      var emailData = res.data;
      emailData._xeroInvoiceId = xeroInvoiceId;
      emailData._invoiceUrl    = realUrl;
      emailData._firstName     = bride.firstName || (bride.name || '').split(' ')[0] || '';
      emailData._balanceDue    = (preview && preview.payload && preview.payload.balanceDue) || 0;
      emailData._dueDate       = (preview && preview.payload && preview.payload.dueDate) || '';
      emailData._clientId      = basePayload.clientId || '';
      renderInvoiceEmailPreviewModal_(emailData, basePayload, preview);
    } else {
      alert('Invoice created in Xero (id ' + xeroInvoiceId + ') but email preview failed. Use "Resend invoice email" from the list to deliver it.');
    }
  }).catch(function(prevErr) {
    hideInvoiceCreatingSpinner_();
    alert('Invoice created in Xero (id ' + xeroInvoiceId + ') but email preview failed: ' + (prevErr.message || prevErr) + '. Use "Resend invoice email" from the list to deliver it.');
  });
}

function showInvoiceCreatingSpinner_(msg) {
  var existing = document.getElementById('inv-creating-overlay');
  if (existing) {
    var body = existing.querySelector('[data-inv-creating-msg]');
    if (body && msg) body.textContent = msg;
    return;
  }
  var o = document.createElement('div');
  o.id = 'inv-creating-overlay';
  o.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9998;display:flex;align-items:center;justify-content:center;';
  o.innerHTML = '<div class="card-panel" style="padding:1.5rem 2rem;font-size:0.9rem;" data-inv-creating-msg>' + (msg || 'Creating invoice in Xero...') + '</div>';
  document.body.appendChild(o);
}
function hideInvoiceCreatingSpinner_() {
  var o = document.getElementById('inv-creating-overlay');
  if (o) o.remove();
}

/* ============================================================
   INVOICE-CREATE POLLING (2026-08-19, write-path-timeouts-local-first)
   adminCrm_createInvoice's confirmed SEND step is now async, it returns
   {success:true, pending:true, jobKey} immediately instead of the real
   xeroInvoiceId/invoiceUrl (which used to make this route time out at GAS's
   55s relay ceiling). This polls adminApi_getInvoiceCreateStatus for the real
   result. Never silent: shows a clear "still working" state while pending,
   and a definitive success/failure once resolved, the admin is looking at
   the screen waiting for a real invoice link to email a real person.
   ============================================================ */
var INV_CREATE_POLL_INTERVAL_MS_ = 2000;
var INV_CREATE_POLL_MAX_ATTEMPTS_ = 30; // ~60s, generous, this covers a cold GAS instance plus a live Xero round-trip

function invPollCreateStatus_(jobKey, onDone) {
  var attempts = 0;
  function tick() {
    attempts++;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getInvoiceCreateStatus', args: { jobKey: jobKey } })
      .then(function (res) {
        var d = (res && res.data) || {};
        if (d.state === 'pending') {
          if (attempts >= INV_CREATE_POLL_MAX_ATTEMPTS_) {
            onDone({ success: false, error: 'Still creating after 60s. It may still complete in the background, check the invoice list in a moment before retrying, retrying now could create a duplicate invoice.', stillPending: true });
            return;
          }
          showInvoiceCreatingSpinner_('Creating invoice in Xero... (' + attempts + ')');
          setTimeout(tick, INV_CREATE_POLL_INTERVAL_MS_);
          return;
        }
        if (d.state === 'unknown') {
          onDone({ success: false, error: 'Lost track of this invoice creation (poll expired). Check the invoice list before retrying.' });
          return;
        }
        // 'done' or 'failed', d itself carries the real result shape.
        onDone(d);
      })
      .catch(function (err) {
        if (attempts >= INV_CREATE_POLL_MAX_ATTEMPTS_) {
          onDone({ success: false, error: 'Lost connection while checking invoice status: ' + (err.message || err) + '. Check the invoice list before retrying.' });
          return;
        }
        setTimeout(tick, INV_CREATE_POLL_INTERVAL_MS_);
      });
  }
  tick();
}

function showSimpleInvoiceConfirmModal_(preview, basePayload, status) {
  var existing = document.getElementById('inv-confirm-modal');
  if (existing) existing.remove();

  var bride   = preview.bride || {};
  var match   = preview.contactMatch || {};
  var p       = preview.payload || {};
  var warns   = preview.warnings || [];

  var matchLine = match.matchedBy
    ? 'Client record matched: <strong>' + escHtml(match.contactName || '—') + '</strong>'
        + (match.contactEmail ? ' (' + escHtml(match.contactEmail) + ')' : '')
    : '<span style="color:#9b4c1e;">No existing client record — a new one will be created in accounting.</span>';

  var warnHtml = warns.length
    ? '<div class="alert warning" style="margin-top:0.6rem;font-size:0.78rem;">' + warns.map(escHtml).join('<br>') + '</div>'
    : '';

  var modal = document.createElement('div');
  modal.id = 'inv-confirm-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div class="card-panel" style="max-width:520px;width:100%;padding:1.5rem;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;">Confirm invoice ' + (status === 'sent' ? 'send' : 'draft') + '</div>' +
      '<div style="font-size:0.82rem;color:var(--text-light);margin-bottom:0.9rem;">' +
        'For <strong>' + escHtml(bride.name || '—') + '</strong>' +
        (bride.email ? ' &lt;' + escHtml(bride.email) + '&gt;' : '') +
      '</div>' +
      '<div style="font-size:0.82rem;line-height:1.6;">' +
        matchLine +
        '<div style="margin-top:0.5rem;">' +
          (p.subtotal !== undefined && p.gstTotal !== undefined
            ? '<strong>Subtotal:</strong> $' + Number(p.subtotal||0).toFixed(2) +
              ' &nbsp;·&nbsp; <strong>GST:</strong> $' + Number(p.gstTotal||0).toFixed(2) +
              ' &nbsp;·&nbsp; '
            : '') +
          '<strong>Total:</strong> $' + Number(p.total||0).toFixed(2) +
          ' &nbsp;·&nbsp; <strong>Deposit:</strong> $' + Number(p.deposit||0).toFixed(2) +
          ' &nbsp;·&nbsp; <strong>Balance:</strong> $' + Number(p.balanceDue||0).toFixed(2) +
        '</div>' +
        (p.issueDate ? '<div><strong>Issue date:</strong> ' + escHtml(formatDate(p.issueDate)) + '</div>' : '') +
        (p.dueDate ? '<div><strong>Due:</strong> ' + escHtml(formatDate(p.dueDate)) + '</div>' : '') +
        (p.paymentTermsDays ? '<div><strong>Payment terms:</strong> ' + escHtml(String(p.paymentTermsDays)) + ' days</div>' : '') +
        '<div><strong>Action:</strong> Save as draft — no email sent</div>' +
      '</div>' +
      warnHtml +
      '<div style="display:flex;gap:0.5rem;margin-top:1.2rem;justify-content:flex-end;">' +
        '<button class="btn btn-ghost" onclick="closeInvoiceConfirmModal_()">Cancel</button>' +
        '<button class="btn btn-primary" id="inv-confirm-send-btn" ' +
          'onclick="confirmInvoiceSend_(' + JSON.stringify(status).replace(/"/g, '&quot;') + ')">' +
          'Save as draft' +
        '</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
  modal._payload = basePayload;
}

function closeInvoiceConfirmModal_() {
  var m = document.getElementById('inv-confirm-modal');
  if (m) m.remove();
}

// ─── Cancel Wedding (2026-09-04, BUILD-cancel-wedding-admin-crm-button-2026-09-04.md) ────
// Two-call preview-then-confirm, same pattern as
// openSendPartnerWelcomeModal_ below. Wired to adminCrm_cancelWedding
// (AdminCRMAPI.gs), which reuses the existing JV_cancelBrideFully logic and
// (Payments Agent's half) stops any live payment plan / voids open Xero
// invoices / cancels a pending GoCardless mandate.
// 2026-10-19 (Issue #1): Cancel Wedding is Cloudflare-native. GAS path retired, NO fallback -- adminCrm_cancelWedding and
// bridge_admin_generic are no longer called from this file. Relay entity admin-cancel-wedding (preview / confirm / resume / status)
// runs the whole cancel synchronously on jv-crm-mirror behind CANCEL_WEDDING_CF_ENABLED.
// Cancel Wedding cutover gate (2026-10-19). false (default) = today's direct GAS cancel (adminCrm_cancelWedding), unchanged.
// true = Cloudflare-native admin-cancel-wedding relay entity ONLY, no GAS fallback. Cutover = flip this and delete the old functions.
var JV_CANCEL_WEDDING_CF = false;
var _jvCancelWedding_ = { hash: null, key: null, runId: null };
function _jvCancelProxy_(action, body) {
  var base = window._jvAdminProxyBase;
  if (!base) return Promise.resolve({ ok: false, error: 'proxy_unavailable' });
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-cancel-wedding/' + action;
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body || {}) })
    .then(function (r) { return r.json(); })
    .catch(function () { return { ok: false, error: 'network_error' }; });
}
function _jvCancelErr_(res) {
  var e = (res && res.error) || 'Unknown error';
  var map = {
    route_disabled: 'Cancel Wedding is not switched on yet.',
    state_changed_since_preview: 'Something changed since the dialog opened. Close it and open it again.',
    flags_not_ready: 'Cancelling is not fully enabled yet (' + ((res && res.blockers) || []).join(', ') + ').',
    safe_mode: 'Safe mode is on.',
    run_in_progress: 'A cancellation for this bride is already running.',
    not_a_bride: 'This contact is not a bride.',
    partner_managed_refused: 'Partner-managed booking: cannot be cancelled here.',
    network_error: 'Lost contact with the server.'
  };
  return map[e] || e;
}
function openCancelWeddingModalCf_(clientId, brideEmail, brideName) {
  _jvCancelProxy_('preview', { email: brideEmail, expectedEmail: brideEmail }).then(function (d) {
    if (!d || d.ok === false) {
      alert('Could not prepare cancellation: ' + _jvCancelErr_(d));
      return;
    }
    if (!d.flagsReady) {
      alert('Cancelling is not fully enabled yet (' + (d.blockers || []).join(', ') + '). Nothing can be cancelled until that is switched on.');
      return;
    }
    _jvCancelWedding_ = { hash: d.previewHash, key: 'crm-cancel|' + brideEmail + '|' + Date.now() + '|' + Math.random().toString(36).slice(2), runId: null };
    renderCancelWeddingModal_(clientId, d);
  }).catch(function (err) {
    alert('Error: ' + (err.message || String(err)));
  });
}

function openCancelWeddingModal_(clientId, brideEmail, brideName) {
  if (JV_CANCEL_WEDDING_CF) { return openCancelWeddingModalCf_(clientId, brideEmail, brideName); }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_cancelWedding',
    args: { clientId: clientId, expectedEmail: brideEmail, preview: true }
  }).then(function (res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      alert('Could not prepare cancellation: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    renderCancelWeddingModal_(clientId, d);
  }).catch(function (err) {
    alert('Error: ' + (err.message || String(err)));
  });
}

function renderCancelWeddingModal_(clientId, preview) {
  var existing = document.getElementById('cancel-wedding-modal');
  if (existing) existing.remove();

  var willHappen = [];
  willHappen.push('Comms stopped and hub access revoked permanently.');
  if (preview.willCancelPaymentPlan) {
    willHappen.push('Her active payment plan will be cancelled, no further instalments will be charged.');
  }
  if (preview.xeroInvoicesToVoid && preview.xeroInvoicesToVoid.length) {
    willHappen.push(preview.xeroInvoicesToVoid.length + ' Xero invoice' +
      (preview.xeroInvoicesToVoid.length > 1 ? 's' : '') +
      ' will be checked and voided if still open/unpaid. Any amount already paid is NOT reversed, she forfeits it.');
  }
  // Wording fix (2026-09-08, Finding 3): the confirm step already handles
  // legacy GoCardless AND Stripe PayTo correctly (gc_cancelMandateForBride_,
  // GoCardlessAPI.gs) -- this was purely a preview-text bug, naming
  // whichever provider is actually in play instead of a hardcoded
  // "GoCardless" that's wrong for the more common current PayTo case.
  if (preview.willCancelGoCardless && preview.willCancelStripePayTo) {
    willHappen.push('Her pending GoCardless mandate AND Stripe PayTo mandate will both be cancelled.');
  } else if (preview.willCancelStripePayTo) {
    willHappen.push('Her Stripe PayTo mandate will be cancelled.');
  } else if (preview.willCancelGoCardless) {
    willHappen.push('Her pending GoCardless mandate will be cancelled.');
  }
  if (preview.calendarEventsToRemove) {
    willHappen.push(preview.calendarEventsToRemove + ' wedding-day calendar event' +
      (preview.calendarEventsToRemove > 1 ? 's' : '') + ' will be removed.');
  }

  // Extension hire visibility (2026-09-08, BUILD-extension-hire-remaining-
  // gaps-and-cancel-close-path-confusion-2026-09-08.md Item 4). Distinct
  // block, not folded into willHappen, because this is explicitly what will
  // NOT happen automatically.
  var extWarning = '';
  if (preview.openExtensionHire && preview.openExtensionHire.bondId) {
    var extBondId = preview.openExtensionHire.bondId;
    extWarning = '<div style="margin-top:0.7rem;padding:0.6rem 0.75rem;border-radius:var(--radius-small);' +
      'background:rgba(179,39,39,0.08);color:var(--danger,#b32727);font-size:0.78rem;">' +
      'She has a Hair Extension Hire on record (status: ' + escHtml(preview.openExtensionHire.status || 'open') + '). ' +
      'This will NOT be cancelled or flagged automatically. ' +
      '<a href="/pages/extension-inventory?bond=' + encodeURIComponent(extBondId) + '" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Check Extension Inventory</a>.</div>';
  }

  var modal = document.createElement('div');
  modal.id = 'cancel-wedding-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div class="card-panel" style="max-width:520px;width:100%;padding:1.5rem;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;color:var(--danger,#b32727);">Cancel Wedding: ' + escHtml(preview.name || preview.email || '') + '</div>' +
      '<div style="font-size:0.82rem;line-height:1.7;">' +
        willHappen.map(function (line) { return '<div>&bull; ' + escHtml(line) + '</div>'; }).join('') +
      '</div>' +
      extWarning +
      '<label style="display:block;margin-top:0.9rem;font-size:0.78rem;color:var(--muted);">Notes (optional):</label>' +
      '<textarea id="cancel-wedding-notes" placeholder="Reason for cancellation..." style="width:100%;min-height:60px;margin-top:0.3rem;"></textarea>' +
      '<div style="display:flex;gap:0.5rem;margin-top:1.2rem;justify-content:flex-end;">' +
        '<button class="btn btn-ghost" onclick="closeCancelWeddingModal_()">Keep booking</button>' +
        '<button class="btn btn-primary" id="cancel-wedding-confirm-btn" style="background:var(--danger,#b32727);" ' +
          'onclick="confirmCancelWedding_(\'' + escHtml(clientId) + '\', \'' + escAttr(preview.email || '') + '\')">Confirm Cancellation</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
}

function closeCancelWeddingModal_() {
  var m = document.getElementById('cancel-wedding-modal');
  if (m) m.remove();
}

function confirmCancelWeddingCf_(clientId, brideEmail) {
  var notesEl = document.getElementById('cancel-wedding-notes');
  var note = notesEl ? notesEl.value.trim() : '';
  var btn = document.getElementById('cancel-wedding-confirm-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Cancelling...'; }

  var call_ = _jvCancelWedding_.runId
    ? _jvCancelProxy_('resume', { email: brideEmail, expectedEmail: brideEmail, runId: _jvCancelWedding_.runId })
    : _jvCancelProxy_('confirm', { email: brideEmail, expectedEmail: brideEmail, note: note, previewHash: _jvCancelWedding_.hash, idempotency_key: _jvCancelWedding_.key });
  call_.then(function (d) {
    if (d && d.ok === false && d.error === 'network_error') {
      // Ambiguous: it may have landed. Read the stored run rather than guessing.
      return _jvCancelProxy_('status', { email: brideEmail, idempotency_key: _jvCancelWedding_.key }).then(function (st) {
        return (st && st.ok === true && st.found) ? st : d;
      });
    }
    return d;
  }).then(function (d) {
    closeCancelWeddingModal_();
    if (d && d.runId) _jvCancelWedding_.runId = d.runId;
    if (d && d.status === 'already_cancelled') { jvToast('This wedding was already cancelled.', 'success'); return; }
    if (!d || d.ok === false) {
      alert('Cancellation failed: ' + _jvCancelErr_(d));
      return;
    }
    // Fail-loud: surface any step that did NOT complete, even though the CRM close (which stops comms/hub access) went through.
    var labels = { close: 'closing the booking', plan: 'stopping the payment plan', mandate: 'cancelling the mandate', xero: 'voiding the Xero invoice',
      shopify: 'removing portal access tags', calendar: 'removing the calendar event', notify: 'notifying the team', mirror: 'syncing the spreadsheet' };
    var warnings = [];
    var st = d.stepStatuses || {};
    Object.keys(st).forEach(function (k) {
      if (st[k] === 'failed') warnings.push(labels[k] + ' failed');
      else if (st[k] === 'held') warnings.push(labels[k] + ' was HELD (an earlier money step failed)');
      else if (st[k] === 'warn') warnings.push(labels[k] + ' needs checking');
    });
    if (d.steps && d.steps.goCardless && d.steps.goCardless.manualRequired) warnings.push('a legacy GoCardless mandate must be cancelled manually in GoCardless');
    if (warnings.length) {
      jvToast('Wedding cancelled, but ' + warnings.join('; ') + '. ' + 'Check manually, or ask for the cancel to be resumed (it is recorded and can be retried).', 'error');
    } else {
      jvToast('Wedding cancelled.', 'success');
    }
    // Reopen the same drawer so it re-fetches fresh state (Cancel Wedding
    // button disappears now that stage is Closed) -- same reopen-after-async
    // pattern already used elsewhere on this page (see the send-proposal
    // success handler above).
    if (typeof openDrawer === 'function' && clientId) { try { openDrawer(clientId); } catch (e) {} }
  }).catch(function (err) {
    closeCancelWeddingModal_();
    alert('Error: ' + (err.message || String(err)));
  });
}

function confirmCancelWedding_(clientId, brideEmail) {
  if (JV_CANCEL_WEDDING_CF) { return confirmCancelWeddingCf_(clientId, brideEmail); }
  var notesEl = document.getElementById('cancel-wedding-notes');
  var note = notesEl ? notesEl.value.trim() : '';
  var btn = document.getElementById('cancel-wedding-confirm-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Cancelling...'; }

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_cancelWedding',
    args: { clientId: clientId, expectedEmail: brideEmail, note: note }
  }).then(function (res) {
    closeCancelWeddingModal_();
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      alert('Cancellation failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    // Fail-loud per the brief: surface any money step that did NOT succeed,
    // even though the overall CRM close (the part that matters most for
    // stopping comms/hub-access) already went through.
    var steps = d.steps || {};
    var warnings = [];
    if (steps.paymentPlan && steps.paymentPlan.ok === false && steps.paymentPlan.reason !== 'not_available') {
      warnings.push('payment plan stop failed');
    }
    if (steps.xero && steps.xero.ok === false && steps.xero.reason !== 'not_available') {
      warnings.push('Xero invoice void failed');
    }
    if (steps.goCardless && steps.goCardless.ok === false && steps.goCardless.reason !== 'not_available') {
      // Wording fix (2026-09-08, Finding 3): gc_cancelMandateForBride_ handles
      // legacy GoCardless AND Stripe PayTo under one call/step, with no
      // separate per-provider ok/fail signal returned here to distinguish
      // which one actually failed -- "mandate" stays provider-neutral rather
      // than assuming/hardcoding GoCardless for what may be a PayTo failure.
      warnings.push('mandate cancel failed (GoCardless or PayTo)');
    }
    if (steps.calendar && steps.calendar.ok === false) {
      warnings.push('calendar event removal failed');
    }
    if (warnings.length) {
      jvToast('Wedding cancelled, but ' + warnings.join(', ') + '. Check manually.', 'error');
    } else {
      jvToast('Wedding cancelled.', 'success');
    }
    // Reopen the same drawer so it re-fetches fresh state (Cancel Wedding
    // button disappears now that stage is Closed) -- same reopen-after-async
    // pattern already used elsewhere on this page (see the send-proposal
    // success handler above).
    if (typeof openDrawer === 'function' && clientId) { try { openDrawer(clientId); } catch (e) {} }
  }).catch(function (err) {
    closeCancelWeddingModal_();
    alert('Error: ' + (err.message || String(err)));
  });
}

// ─── Invoice detail/inspect panel (2026-09-04, SCOPE-admin-invoice-log-ui-2026-09-04.md) ────
// Shared modal, opened from BOTH the bride-profile Invoices panel extension
// AND the main invoice log (once built) -- one implementation, not two, per
// this project's "second engine that can silently disagree" rule. Reads
// jv-payment-service (Cloudflare + D1) via the SAME App-Proxy-verified relay
// pattern the Publish Integrity card already proved live yesterday
// (adminPublishIntegrity_init above), NOT a raw fetch to the payment
// service directly -- that Worker requires a secret admin key header
// (authOk() in its own worker.js), which must never reach the browser.
// Entity names CONFIRMED against the live relay registry (2026-09-07,
// DEPOLYMENT/cloudflare-cors-relay/worker.js PROXY_ENTITIES): three separate
// entities, not one shared "invoices" entity as originally assumed here --
// 'invoice-list' (action 'list'), 'invoice-detail' (actions 'get'/
// 'corrections'), 'invoice-manual-payment' (action 'record'). The
// _jvInvoiceProxyPath_ helper below is the ONE place this mapping lives.
var JV_INVOICE_ACTION_ENTITY_ = { list: 'invoice-list', get: 'invoice-detail', corrections: 'invoice-detail', 'manual-payment': 'invoice-manual-payment' };
function _jvInvoiceProxyPath_(action) {
  var base = window._jvAdminProxyBase;
  if (!base) return null;
  var entity = JV_INVOICE_ACTION_ENTITY_[action] || 'invoice-detail';
  var routedAction = (action === 'manual-payment') ? 'record' : action;
  return String(base).replace(/\/+$/, '') + '/partner/' + entity + '/' + routedAction;
}
function _jvInvoiceMoney_(cents) {
  var n = Number(cents || 0) / 100;
  return '$' + n.toFixed(2);
}
function _jvInvoiceCall_(action, method, body) {
  var url = _jvInvoiceProxyPath_(action);
  if (!url) return Promise.resolve({ ok: false, error: 'proxy_unavailable' });
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(url, {
    method: method || 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(body || {})
  }).then(function (r) { return r.json(); }).catch(function () {
    return { ok: false, error: 'network_error' };
  });
}

function openInvoiceDetailModal_(invoiceId) {
  var existing = document.getElementById('invoice-detail-modal');
  if (existing) existing.remove();

  var modal = document.createElement('div');
  modal.id = 'invoice-detail-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div class="card-panel" style="max-width:560px;width:100%;padding:1.5rem;max-height:85vh;overflow-y:auto;">' +
      '<div id="invoice-detail-body" style="font-size:0.85rem;color:var(--muted);">Loading invoice...</div>' +
      '<div style="display:flex;justify-content:flex-end;margin-top:1rem;">' +
        '<button class="btn btn-ghost" onclick="closeInvoiceDetailModal_()">Close</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  // Fix (2026-09-10, Invoice/Token Surfaces re-verify after 0e79b05d only
  // partially fixed this class of bug on the bride-profile copy): the
  // /invoice ('get') route requires `id`, /corrections requires `invoiceId`
  // -- same mismatch, this file's own call site was missed the first time.
  Promise.all([
    _jvInvoiceCall_('get', 'POST', { id: invoiceId }),
    _jvInvoiceCall_('corrections', 'POST', { invoiceId: invoiceId })
  ]).then(function (results) {
    var invRes = results[0], corrRes = results[1];
    if (!invRes || invRes.ok === false) {
      renderInvoiceDetailError_(invRes && invRes.error);
      return;
    }
    // Response-unwrap fix (2026-09-10): the real Worker response is
    // {ok:true, invoice:{...}}, not the invoice fields at the top level --
    // confirmed against DEPOLYMENT/jv-payment-service/worker.js's own
    // GET /invoice handler. Passing invRes straight through as `inv` left
    // renderInvoiceDetailBody_ reading inv.cacheDrift/status/totalCents etc.
    // off the WRONG object, always undefined, which is why the modal showed
    // blank/$0.00 even once the id-vs-invoiceId fix landed, and silently
    // hid a genuine cacheDrift:true warning on real invoices.
    renderInvoiceDetailBody_(invoiceId, invRes.invoice || invRes, (corrRes && corrRes.ok) ? corrRes : null);
  });
}

function closeInvoiceDetailModal_() {
  var m = document.getElementById('invoice-detail-modal');
  if (m) m.remove();
}

function renderInvoiceDetailError_(err) {
  var body = document.getElementById('invoice-detail-body');
  if (!body) return;
  body.innerHTML = '<div style="color:var(--danger,#b32727);">Could not load this invoice: ' +
    escHtml(String(err || 'Unknown error')) + '</div>';
}

function renderInvoiceDetailBody_(invoiceId, inv, corr) {
  var body = document.getElementById('invoice-detail-body');
  if (!body) return;

  var driftHtml = inv.cacheDrift
    ? '<div class="alert warning" style="margin-bottom:0.6rem;font-size:0.78rem;">This invoice\'s cached total does not match its actual payment history. Numbers below are the DERIVED (true) figures.</div>'
    : '';
  var voidHtml = String(inv.status).toLowerCase() === 'void'
    ? '<div style="margin-bottom:0.6rem;font-size:0.78rem;color:var(--muted);">This invoice is VOID.</div>'
    : '';

  var summaryHtml =
    '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;">Invoice #' + escHtml(String(invoiceId)) + '</div>' +
    '<div style="font-size:0.82rem;line-height:1.7;margin-bottom:0.8rem;">' +
      '<div><strong>Bride:</strong> ' + escHtml(inv.brideEmail || inv.bride_email || '') + '</div>' +
      '<div><strong>Kind:</strong> ' + escHtml(inv.kind || '') + '</div>' +
      '<div><strong>Status:</strong> ' + escHtml(inv.status || '') + '</div>' +
      '<div><strong>Total:</strong> ' + _jvInvoiceMoney_(inv.totalCents != null ? inv.totalCents : inv.total_cents) + '</div>' +
      '<div><strong>Paid:</strong> ' + _jvInvoiceMoney_(inv.paidCents != null ? inv.paidCents : inv.paid_cents) + '</div>' +
      '<div><strong>Outstanding:</strong> ' + _jvInvoiceMoney_(inv.outstandingCents) + '</div>' +
    '</div>';

  // Fix (2026-09-11): this block read corr.events, a field that does not
  // exist in the real /corrections response shape at all -- confirmed
  // against DEPOLYMENT/jv-payment-service/src/corrections.js's own
  // getCorrectionHistory: it returns {reversals:[...], totalCorrections:[...]},
  // never "events". This made the History block permanently dead, ALWAYS
  // showing "No corrections or manual events recorded" regardless of real
  // activity, not just for the payment-events case flagged separately. Same
  // fix applied to the sibling copy (assets/jv-admin-bride-profile-v2.js).
  // Honest scope, unchanged from before: /corrections only ever returns
  // reversal/correction events (its own D1 query filters amount_cents < 0),
  // never positive payment records -- a genuine manual payment allocated
  // via this same modal will still not appear here, that is a real,
  // separate, larger gap (this endpoint has no payment-event data to
  // return), not something this fix can close. Label reflects that
  // honestly rather than implying full payment history.
  var eventsHtml = '<div style="font-size:0.75rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;color:var(--muted);margin-bottom:0.4rem;">Corrections &amp; Reversals</div>';
  var events = (corr && Array.isArray(corr.reversals)) ? corr.reversals : [];
  eventsHtml += events.length
    ? events.map(function (e) {
        return '<div style="font-size:0.78rem;padding:0.3rem 0;border-bottom:1px solid var(--line);">' +
          escHtml(e.kind || e.method || 'event') + ' &middot; ' + _jvInvoiceMoney_(e.amount_cents != null ? e.amount_cents : e.amountCents) +
          ' &middot; ' + escHtml(String(e.occurred_at || e.occurredAt || '')) + '</div>';
      }).join('')
    : '<div style="font-size:0.78rem;color:var(--muted);">No corrections or reversals recorded.</div>';

  var actionsHtml = '';
  if (String(inv.status).toLowerCase() !== 'void') {
    actionsHtml =
      '<div style="margin-top:1rem;padding-top:0.8rem;border-top:1px solid var(--line);">' +
        '<div style="font-size:0.75rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;color:var(--muted);margin-bottom:0.5rem;">Record a manual payment</div>' +
        '<input type="text" id="jv-inv-manual-ref" placeholder="Reference (e.g. bank statement line, required)" style="width:100%;margin-bottom:0.4rem;">' +
        '<input type="number" id="jv-inv-manual-amount" placeholder="Amount ($)" step="0.01" min="0" style="width:100%;margin-bottom:0.4rem;">' +
        '<textarea id="jv-inv-manual-note" placeholder="Note (optional)" style="width:100%;min-height:44px;margin-bottom:0.4rem;"></textarea>' +
        '<button class="btn btn-primary" style="width:100%;" onclick="confirmRecordManualPayment_(' + Number(invoiceId) + ')">Allocate payment</button>' +
        '<div id="jv-inv-manual-msg" style="font-size:0.78rem;margin-top:0.4rem;"></div>' +
      '</div>';
  }

  body.innerHTML = driftHtml + voidHtml + summaryHtml + eventsHtml + actionsHtml;
}

function confirmRecordManualPayment_(invoiceId) {
  var refEl = document.getElementById('jv-inv-manual-ref');
  var amtEl = document.getElementById('jv-inv-manual-amount');
  var noteEl = document.getElementById('jv-inv-manual-note');
  var msgEl = document.getElementById('jv-inv-manual-msg');
  var ref = refEl ? refEl.value.trim() : '';
  var amount = amtEl ? Number(amtEl.value) : 0;
  var note = noteEl ? noteEl.value.trim() : '';

  if (!ref) { if (msgEl) { msgEl.textContent = 'A reference is required, it stops a double-click allocating the same transfer twice.'; msgEl.style.color = 'var(--danger,#b32727)'; } return; }
  if (!amount || amount <= 0) { if (msgEl) { msgEl.textContent = 'Enter a valid amount.'; msgEl.style.color = 'var(--danger,#b32727)'; } return; }

  if (msgEl) { msgEl.textContent = 'Allocating...'; msgEl.style.color = 'var(--muted)'; }

  _jvInvoiceCall_('manual-payment', 'POST', {
    invoiceId: invoiceId,
    amountCents: Math.round(amount * 100),
    correctionRef: ref,
    note: note
  }).then(function (res) {
    if (!res || res.ok === false) {
      // Overpay guard surfaces its own explicit message, per corrections.js's
      // recordManualPayment -- show it rather than a generic failure so the
      // admin can decide to retry with allowOverpay if it's genuinely correct.
      if (msgEl) { msgEl.textContent = (res && res.message) || (res && res.error) || 'Could not record this payment.'; msgEl.style.color = 'var(--danger,#b32727)'; }
      return;
    }
    /* THREE-STATE XERO SYNC (2026-09-15). Mirrors the identical fix on the bride
       profile (jv-admin-bride-profile-v2.js). Recording a payment writes to D1;
       pushing it to Xero is a SECOND, separate write that can fail on its own, so
       a payment that never reached Xero used to report as a clean success and the
       books silently disagreed. Both surfaces share this money path and have
       drifted apart three times this month, so they are fixed together. */
    // Accept BOTH casings, same reason as the bride profile: the response carries
    // xeroSyncState, the D1 column is xero_sync_state, and on a money path a casing
    // mismatch would silently degrade every payment to the "unknown" branch.
    var sync = String(res.xeroSyncState || res.xero_sync_state || '').toLowerCase();
    var already = res.duplicate
      ? 'This payment was already recorded, nothing was allocated twice. '
      : '';

    if (sync === 'failed') {
      var why = res.xeroSyncError ? (' ' + res.xeroSyncError) : '';
      var canRetry = (res.retryable !== false);
      jvToast(already + 'Recorded here, but it did NOT reach Xero.' + why +
        (canRetry ? ' Retry from the invoice, or add it in Xero manually.'
                  : ' Add it in Xero manually.'), 'error');
      if (msgEl) {
        msgEl.textContent = 'Recorded here, but not in Xero. Xero still shows this invoice unpaid.';
        msgEl.style.color = 'var(--danger,#b32727)';
      }
    } else if (sync === 'skipped') {
      jvToast(already + 'Recorded here. Xero was not updated, so it still shows this invoice unpaid.', 'info');
      if (msgEl) {
        msgEl.textContent = 'Recorded here only. Xero was not updated.';
        msgEl.style.color = 'var(--warning,#8a5c00)';
      }
    } else if (sync === 'synced') {
      jvToast(already + 'Payment allocated and sent to Xero.', 'success');
    } else {
      // No xeroSyncState: older backend or a shape change. Claim only what is
      // known, never upgrade an unknown Xero outcome into a confident "allocated".
      jvToast(already + 'Payment recorded. Xero status unknown, check the invoice in Xero.', 'info');
    }

    openInvoiceDetailModal_(invoiceId); // repaint with the new event in history
  });
}

// ─── Manual partner/EBM welcome-email trigger (2026-07-30 fix, Item 2) ────
// Wired to adminCrm_sendPartnerWelcomeEmail (AdminCRMAPI.gs), which itself
// calls the EXISTING partnerBooking_sendWelcomeEmail_, no new sender.

function openSendPartnerWelcomeModal_(clientId) {
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_sendPartnerWelcomeEmail',
    args: { clientId: clientId }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      alert('Could not prepare welcome email: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    renderSendPartnerWelcomeModal_(clientId, d);
  }).catch(function(err) {
    alert('Error: ' + (err.message || String(err)));
  });
}

function renderSendPartnerWelcomeModal_(clientId, preview) {
  var existing = document.getElementById('partner-welcome-modal');
  if (existing) existing.remove();

  var blockedHtml = !preview.bookable
    ? '<div class="alert warning" style="margin-top:0.6rem;font-size:0.78rem;">This send will be REFUSED by the existing safety guard: ' +
        escHtml(preview.blockedReason || 'blocked contact') + '</div>'
    : '';

  var modal = document.createElement('div');
  modal.id = 'partner-welcome-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div class="card-panel" style="max-width:480px;width:100%;padding:1.5rem;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;">Send welcome email</div>' +
      '<div style="font-size:0.82rem;line-height:1.6;">' +
        '<div><strong>To:</strong> ' + escHtml(preview.firstName || '') + ' &lt;' + escHtml(preview.toEmail || '') + '&gt;</div>' +
        '<div><strong>Partner:</strong> ' + escHtml(preview.partnerName || preview.partnerSlug || '') + '</div>' +
        '<div><strong>Template:</strong> ' + escHtml(preview.partnerSlug || '') + ' welcome email</div>' +
      '</div>' +
      blockedHtml +
      '<div style="display:flex;gap:0.5rem;margin-top:1.2rem;justify-content:flex-end;">' +
        '<button class="btn btn-ghost" onclick="closeSendPartnerWelcomeModal_()">Cancel</button>' +
        '<button class="btn btn-primary" id="partner-welcome-send-btn" ' +
          (preview.bookable ? '' : 'disabled ') +
          'onclick="confirmSendPartnerWelcome_(\'' + escHtml(clientId) + '\')">Send</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
}

function closeSendPartnerWelcomeModal_() {
  var m = document.getElementById('partner-welcome-modal');
  if (m) m.remove();
}

function confirmSendPartnerWelcome_(clientId) {
  var btn = document.getElementById('partner-welcome-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_sendPartnerWelcomeEmail',
    args: { clientId: clientId, confirmed: true }
  }).then(function(res) {
    closeSendPartnerWelcomeModal_();
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      alert('Send failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    if (d.sent) {
      jvToast('Welcome email sent to ' + (d.toEmail || 'the bride') + '.', 'success');
    } else {
      alert('Send did not complete: ' + (d.error || 'Unknown reason'));
    }
  }).catch(function(err) {
    closeSendPartnerWelcomeModal_();
    alert('Error: ' + (err.message || String(err)));
  });
}

// 2026-07-30 fix: find + link a Xero invoice that was created DIRECTLY in
// Xero (not via the CRM's own Create Invoice / Bill Partner flows), so it
// never got XERO_INVOICE_ID written onto the bride's CRM row. Checks both
// the bride's own Xero contact and, for partner-managed brides, her linked
// partner's Xero contact. Two-step preview-then-confirm, never auto-picks
// between multiple candidates.
function openFindUnlinkedInvoicesModal_(clientId) {
  var existing = document.getElementById('find-invoice-modal');
  if (existing) existing.remove();
  var loading = document.createElement('div');
  loading.id = 'find-invoice-modal';
  loading.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;';
  loading.innerHTML = '<div class="card-panel" style="padding:1.5rem 2rem;font-size:0.9rem;">Checking Xero for unlinked invoices...</div>';
  document.body.appendChild(loading);

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_findUnlinkedXeroInvoices',
    args: { clientId: clientId }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      closeFindUnlinkedInvoicesModal_();
      alert('Could not check Xero: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    renderFindUnlinkedInvoicesModal_(clientId, d);
  }).catch(function(err) {
    closeFindUnlinkedInvoicesModal_();
    alert('Error: ' + (err.message || String(err)));
  });
}

function renderFindUnlinkedInvoicesModal_(clientId, data) {
  var existing = document.getElementById('find-invoice-modal');
  if (existing) existing.remove();

  var bride = data.bride || {};
  var candidates = data.candidates || [];

  var modal = document.createElement('div');
  modal.id = 'find-invoice-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';

  var bodyHtml;
  if (!candidates.length) {
    bodyHtml = '<p class="abp-empty-state" style="margin:0;">No unlinked Xero invoices found for ' +
      escHtml(bride.name || 'this bride') +
      (bride.isPartnerManaged ? ' or her linked partner' : '') + '.</p>';
  } else {
    bodyHtml = '<div style="font-size:0.82rem;line-height:1.6;">' +
      candidates.map(function(c, i) {
        return '<div style="border:1px solid var(--line, #ece4e0);border-radius:0.6rem;padding:0.6rem 0.8rem;margin-bottom:0.5rem;">' +
          '<div><strong>' + escHtml(c.contactName || c.contactEmail) + '</strong>' +
            (c.source === 'partner' ? ' <span style="color:var(--muted, #8a7f7b);">(partner)</span>' : '') + '</div>' +
          '<div style="color:var(--muted, #8a7f7b);">Invoice ' + escHtml(c.invoiceNumber || '') + ' &middot; ' +
            escHtml(c.status || '') + ' &middot; $' + Number(c.total || 0).toFixed(2) +
            (c.date ? ' &middot; ' + escHtml(formatDate(c.date)) : '') + '</div>' +
          '<button class="btn btn-primary" style="font-size:0.72rem;margin-top:0.5rem;" ' +
            'onclick="confirmLinkXeroInvoice_(\'' + escHtml(clientId) + '\', \'' + escHtml(c.invoiceId) + '\', this)">Link this invoice</button>' +
        '</div>';
      }).join('') +
    '</div>';
  }

  modal.innerHTML =
    '<div class="card-panel" style="max-width:520px;width:100%;padding:1.5rem;max-height:80vh;overflow-y:auto;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.4rem;">Unlinked Xero invoices</div>' +
      '<div style="font-size:0.82rem;color:var(--text-light, #7a6e6c);margin-bottom:0.9rem;">For ' +
        escHtml(bride.name || 'this bride') + '</div>' +
      bodyHtml +
      '<div style="display:flex;justify-content:flex-end;margin-top:1rem;">' +
        '<button class="btn btn-ghost" onclick="closeFindUnlinkedInvoicesModal_()">Close</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
}

function closeFindUnlinkedInvoicesModal_() {
  var m = document.getElementById('find-invoice-modal');
  if (m) m.remove();
}

function confirmLinkXeroInvoice_(clientId, invoiceId, btnEl) {
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Linking...'; }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_linkXeroInvoiceToBride',
    args: { clientId: clientId, invoiceId: invoiceId, confirmed: true }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.success === false) {
      alert('Link failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Link this invoice'; }
      return;
    }
    closeFindUnlinkedInvoicesModal_();
    jvToast('Invoice linked. Reload the invoicing tab to see it.', 'success');
  }).catch(function(err) {
    alert('Error: ' + (err.message || String(err)));
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Link this invoice'; }
  });
}

// 2026-07-30 fix: on-demand priority warm for ONE bride's Admin Bride Profile
// CDN cache, jumps her to the front instead of waiting for the automatic
// historical backfill to drain the whole queue. Runs the full synchronous
// warm (build + write), no queue, so it can take a few seconds, this is
// expected, not a hang.
function priorityWarmBrideProfile_(clientId, btnEl) {
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Warming...'; }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_priorityWarmBrideProfile',
    args: { clientId: clientId }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.ok === false) {
      alert('Warm failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Warm profile page now'; }
      return;
    }
    jvToast('Warmed. Her Admin Bride Profile page should load instantly now.', 'success');
    if (btnEl) { btnEl.textContent = 'Warmed'; }
  }).catch(function(err) {
    alert('Error: ' + (err.message || String(err)));
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = 'Warm profile page now'; }
  });
}

function confirmInvoiceSend_(status) {
  var modal = document.getElementById('inv-confirm-modal');
  if (!modal || !modal._payload) { alert('Confirm modal lost state, please retry.'); return; }
  var btn = document.getElementById('inv-confirm-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  var payload = Object.assign({}, modal._payload, { confirmed: true });
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_createInvoice', args: payload })
    .then(function(res) {
      if (!res.ok) { closeInvoiceConfirmModal_(); alert('Error: ' + ((res.error && res.error.message) || String(res.error))); return; }
      var d = res.data || {};
      if (d.success === false) { closeInvoiceConfirmModal_(); alert('Error: ' + (d.error || 'Unknown error')); return; }
      if (!d.pending || !d.jobKey) {
        // Fail-safe fallback path already resolved synchronously (deferred infra
        // was unavailable), same end state as before this change.
        closeInvoiceConfirmModal_();
        alert(status === 'sent' ? 'Invoice sent, a JV-branded email has been delivered to the client.' : 'Draft invoice saved.');
        switchView('invoicing');
        return;
      }
      // 2026-08-19: the real Xero create now runs in the background. Keep the
      // confirm modal's spinner state and poll for the real result rather than
      // reporting success before the invoice actually exists.
      showInvoiceCreatingSpinner_('Creating invoice in Xero...');
      invPollCreateStatus_(d.jobKey, function (finalResult) {
        hideInvoiceCreatingSpinner_();
        closeInvoiceConfirmModal_();
        if (!finalResult || finalResult.success === false) {
          alert('Error: ' + ((finalResult && finalResult.error) || 'Unknown error'));
          return;
        }
        alert(status === 'sent' ? 'Invoice sent, a JV-branded email has been delivered to the client.' : 'Draft invoice saved.');
        switchView('invoicing');
      });
    })
    .catch(function(err){ closeInvoiceConfirmModal_(); alert('Error: ' + (err.message || String(err))); });
}

function renderInvoiceEmailPreviewModal_(emailData, basePayload, preview) {
  var existing = document.getElementById('inv-email-preview-overlay');
  if (existing) existing.remove();

  var bride = (preview && preview.bride) || {};
  var toEmail = emailData.toEmail || basePayload.clientEmail || '';
  var subject = emailData.subject || 'Your Invoice';
  var bodyHtml = emailData.bodyHtml || '';
  var bodyText = emailData.bodyText || '';

  var overlay = document.createElement('div');
  overlay.id = 'inv-email-preview-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.72);z-index:10000;display:flex;flex-direction:column;';
  overlay.innerHTML =
    '<div style="background:#1e1716;color:#f6f1ee;display:flex;align-items:center;justify-content:space-between;padding:0.75rem 1.25rem;flex-shrink:0;">' +
      '<div style="font-weight:700;font-size:0.95rem;letter-spacing:0.01em;">Invoice Email Preview</div>' +
      '<div style="display:flex;align-items:center;gap:0.75rem;">' +
        '<button class="btn btn-ghost" style="font-size:0.8rem;padding:4px 14px;" onclick="closeInvoiceEmailPreviewModal_()">Cancel</button>' +
        '<button class="btn btn-primary" id="inv-email-preview-send-btn" onclick="sendFromInvoiceEmailPreview_()">Send Invoice</button>' +
      '</div>' +
    '</div>' +
    '<div style="display:flex;align-items:center;gap:1rem;padding:0.6rem 1.25rem;background:#2f2524;border-bottom:1px solid rgba(201,149,145,0.2);flex-shrink:0;flex-wrap:wrap;">' +
      '<label style="font-size:0.78rem;color:#c99591;min-width:3.5rem;">To:</label>' +
      '<input id="inv-email-to" type="email" value="' + escHtml(toEmail) + '" style="flex:1;min-width:200px;background:rgba(255,255,255,0.07);border:1px solid rgba(201,149,145,0.3);border-radius:0.4rem;padding:4px 10px;color:#f6f1ee;font-size:0.82rem;">' +
    '</div>' +
    '<div style="display:flex;align-items:center;gap:1rem;padding:0.5rem 1.25rem;background:#2f2524;border-bottom:1px solid rgba(201,149,145,0.2);flex-shrink:0;">' +
      '<label style="font-size:0.78rem;color:#c99591;min-width:3.5rem;">Subject:</label>' +
      '<input id="inv-email-subject" type="text" value="' + escHtml(subject) + '" style="flex:1;background:rgba(255,255,255,0.07);border:1px solid rgba(201,149,145,0.3);border-radius:0.4rem;padding:4px 10px;color:#f6f1ee;font-size:0.82rem;">' +
    '</div>' +
    '<div style="display:flex;gap:0.5rem;padding:0.5rem 1.25rem;background:#2f2524;border-bottom:1px solid rgba(201,149,145,0.2);flex-shrink:0;">' +
      '<button onclick="setInvoiceEmailPreviewMode_(\'html\')" id="inv-email-tab-html" style="font-size:0.75rem;padding:3px 12px;border-radius:2rem;border:1px solid #c99591;background:#c99591;color:#fff;cursor:pointer;">HTML</button>' +
      '<button onclick="setInvoiceEmailPreviewMode_(\'text\')" id="inv-email-tab-text" style="font-size:0.75rem;padding:3px 12px;border-radius:2rem;border:1px solid rgba(201,149,145,0.4);background:transparent;color:#c99591;cursor:pointer;">Plain text</button>' +
    '</div>' +
    '<div style="background:#2f2524;padding:0.45rem 1.25rem;font-size:0.72rem;color:#f0c0a0;border-bottom:1px solid rgba(201,149,145,0.2);flex-shrink:0;">' +
      'Click anywhere in the email below to edit. The "View &amp; Pay Invoice" button URL is added automatically when Xero confirms the invoice.' +
    '</div>' +
    '<div style="flex:1;overflow:hidden;position:relative;">' +
      '<div id="inv-email-preview-html-pane" style="position:absolute;inset:0;">' +
        '<iframe id="inv-email-preview-frame" style="width:100%;height:100%;border:none;background:#fff;"></iframe>' +
      '</div>' +
      '<div id="inv-email-preview-text-pane" style="position:absolute;inset:0;display:none;padding:1rem;">' +
        '<textarea style="width:100%;height:100%;background:rgba(255,255,255,0.05);border:1px solid rgba(201,149,145,0.2);border-radius:0.5rem;padding:0.75rem;color:#f6f1ee;font-family:monospace;font-size:0.8rem;resize:none;" id="inv-email-preview-text-area">' + escHtml(bodyText) + '</textarea>' +
      '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  overlay._payload = basePayload;
  // Stash metadata from the create step so the Send button can call the direct-send route.
  overlay._emailMeta = {
    _xeroInvoiceId: emailData._xeroInvoiceId || '',
    _invoiceUrl:    emailData._invoiceUrl || '',
    _firstName:     emailData._firstName || '',
    _balanceDue:    emailData._balanceDue || 0,
    _dueDate:       emailData._dueDate || '',
    _clientId:      emailData._clientId || basePayload.clientId || ''
  };

  // Write HTML into iframe and make it directly editable.
  var frame = document.getElementById('inv-email-preview-frame');
  if (frame && bodyHtml) {
    try {
      var doc = frame.contentDocument || frame.contentWindow.document;
      doc.open(); doc.write(bodyHtml); doc.close();
      // Wait a tick for the document to finish parsing, then enable editing.
      setTimeout(function() {
        try {
          var d = frame.contentDocument || frame.contentWindow.document;
          if (d && d.body) {
            d.body.contentEditable = 'true';
            d.body.style.outline = 'none';
            // Subtle hover hint so it's obvious the email is editable.
            d.body.style.cursor = 'text';
          }
        } catch (e) { /* same-origin should hold; iframe wrote inline */ }
      }, 50);
    } catch(e) {}
  }
}

function setInvoiceEmailPreviewMode_(mode) {
  var htmlPane = document.getElementById('inv-email-preview-html-pane');
  var textPane = document.getElementById('inv-email-preview-text-pane');
  var htmlTab  = document.getElementById('inv-email-tab-html');
  var textTab  = document.getElementById('inv-email-tab-text');
  if (!htmlPane) return;
  if (mode === 'text') {
    htmlPane.style.display = 'none';
    if (textPane) textPane.style.display = 'block';
    if (htmlTab) { htmlTab.style.background = 'transparent'; htmlTab.style.color = '#c99591'; }
    if (textTab) { textTab.style.background = '#c99591'; textTab.style.color = '#fff'; }
  } else {
    htmlPane.style.display = 'block';
    if (textPane) textPane.style.display = 'none';
    if (htmlTab) { htmlTab.style.background = '#c99591'; htmlTab.style.color = '#fff'; }
    if (textTab) { textTab.style.background = 'transparent'; textTab.style.color = '#c99591'; }
  }
}

function closeInvoiceEmailPreviewModal_() {
  var o = document.getElementById('inv-email-preview-overlay');
  if (o) o.remove();
}

function sendFromInvoiceEmailPreview_() {
  var overlay = document.getElementById('inv-email-preview-overlay');
  if (!overlay || !overlay._payload) { alert('Preview lost state — please retry.'); return; }
  var meta = overlay._emailMeta || {};
  if (!meta._xeroInvoiceId) {
    alert('Cannot send — Xero invoice ID missing from preview state.');
    return;
  }

  var btn = document.getElementById('inv-email-preview-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  var toEl  = document.getElementById('inv-email-to');
  var subEl = document.getElementById('inv-email-subject');

  // Pull the edited HTML out of the iframe so any tweaks the admin made are sent.
  var editedHtml = '';
  try {
    var frame = document.getElementById('inv-email-preview-frame');
    if (frame) {
      var d = frame.contentDocument || frame.contentWindow.document;
      if (d && d.documentElement) {
        editedHtml = '<!DOCTYPE html>' + d.documentElement.outerHTML;
      }
    }
  } catch (e) { editedHtml = ''; }

  if (!editedHtml) {
    alert('Could not read edited email body. Aborting.');
    if (btn) { btn.disabled = false; btn.textContent = 'Send Invoice'; }
    return;
  }

  var sendArgs = {
    to:            toEl  ? toEl.value.trim()  : '',
    subject:       subEl ? subEl.value.trim() : '',
    bodyHtml:      editedHtml,
    invoiceUrl:    meta._invoiceUrl || '',
    firstName:     meta._firstName || '',
    xeroInvoiceId: meta._xeroInvoiceId,
    clientId:      meta._clientId || '',
    balanceDue:    meta._balanceDue || 0,
    dueDate:       meta._dueDate || ''
  };

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_sendInvoiceEmailDirect',
    args: sendArgs
  }).then(function(res) {
    closeInvoiceEmailPreviewModal_();
    var d = (res && res.data) || {};
    if (!res.ok || d.success === false) {
      alert('Send failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error') +
            '\n\nThe Xero invoice was created. You can resend the email from the invoice list.');
      return;
    }
    alert('Invoice sent to ' + (d.to || sendArgs.to) + '.');
    switchView('invoicing');
  }).catch(function(err) {
    closeInvoiceEmailPreviewModal_();
    alert('Send failed: ' + (err.message || String(err)) +
          '\n\nThe Xero invoice was created. You can resend the email from the invoice list.');
  });
}

function invoiceVoid_(inv) {
  if (!inv || !inv.xeroInvoiceId) { alert('No Xero invoice ID — cannot void.'); return; }
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(inv.xeroInvoiceId)) {
    alert('Invalid Xero invoice ID: "' + inv.xeroInvoiceId + '" — this CRM row has a corrupt value. Re-sync from Xero first (use the Sync from Xero button).');
    return;
  }
  if (!confirm('Void invoice for ' + (inv.clientName || inv.clientEmail) + '? This cannot be undone.')) return;
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_voidInvoice',
    args: { xeroInvoiceId: inv.xeroInvoiceId, clientId: inv.clientId, clientEmail: inv.clientEmail || inv.email }
  }).then(function(res) {
    if (!res.ok || !res.data || !res.data.success) {
      alert('Void failed: ' + ((res.data && res.data.error) || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    alert('Invoice voided.');
    loadInvoicingView();
  }).catch(function(err) { alert('Error: ' + (err.message || String(err))); });
}

function invoiceResendEmail_(inv, btnEl) {
  if (!inv || !inv.xeroInvoiceId) { jvToast('No Xero invoice ID — cannot resend.', 'error'); return; }
  if (!confirm('Resend JV-branded invoice email to ' + (inv.clientEmail || inv.email || inv.clientName) + '?')) return;
  var origLabel = btnEl ? btnEl.textContent : '';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Resending…'; }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_resendInvoiceEmail',
    args: {
      xeroInvoiceId: inv.xeroInvoiceId,
      clientId:      inv.clientId,
      clientEmail:   inv.clientEmail || inv.email,
      clientName:    inv.clientName,
      total:         inv.total,
      balanceDue:    inv.balanceDue,
      dueDate:       inv.dueDate
    }
  }).then(function(res) {
    if (!res.ok || !res.data || !res.data.success) {
      jvToast('Resend failed: ' + ((res.data && res.data.error) || (res.error && res.error.message) || 'Unknown error'), 'error');
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
      return;
    }
    jvToast('Invoice email resent.', 'success');
    if (btnEl) { btnEl.textContent = origLabel; btnEl.disabled = false; }
  }).catch(function(err) {
    jvToast('Error: ' + (err.message || String(err)), 'error');
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
  });
}

// 2026-07-30 fix: resend a partner-billed invoice to the PARTNER (never the
// bride, the plain resend above always targets clientEmail which is the
// bride's own address, wrong for a partner-managed invoice). Uses the
// already-created Xero invoice, no new invoice is created.
function invoiceResendPartnerEmail_(inv, btnEl) {
  if (!inv || !inv.xeroInvoiceId) { jvToast('No Xero invoice ID, cannot resend.', 'error'); return; }
  if (!confirm('Resend this invoice email to the partner who was billed for ' + (inv.clientName || 'this bride') + '?')) return;
  var origLabel = btnEl ? btnEl.textContent : '';
  if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Resending...'; }
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_resendPartnerInvoiceEmail',
    args: {
      xeroInvoiceId: inv.xeroInvoiceId,
      clientId:      inv.clientId,
      total:         inv.total,
      dueDate:       inv.dueDate
    }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.success === false) {
      jvToast('Resend failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'), 'error');
      if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
      return;
    }
    jvToast('Invoice email resent to ' + (d.billedTo || d.to || 'the partner') + '.', 'success');
    if (btnEl) { btnEl.textContent = origLabel; btnEl.disabled = false; }
  }).catch(function(err) {
    jvToast('Error: ' + (err.message || String(err)), 'error');
    if (btnEl) { btnEl.disabled = false; btnEl.textContent = origLabel; }
  });
}

// ─── Invoice Edit Modal ──────────────────────────────────────────

function invoiceOpenEditModal_(inv) {
  if (!inv || !inv.xeroInvoiceId) { alert('No Xero invoice ID.'); return; }
  var loadOverlay = document.createElement('div');
  loadOverlay.id = 'inv-edit-loading';
  loadOverlay.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.6);z-index:10001;display:flex;align-items:center;justify-content:center;';
  loadOverlay.innerHTML = '<div style="color:#f6f1ee;font-size:0.9rem;background:#2f2524;padding:1rem 1.5rem;border-radius:0.75rem;">Loading invoice…</div>';
  document.body.appendChild(loadOverlay);

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getInvoiceDraft',
    args: { xeroInvoiceId: inv.xeroInvoiceId, clientId: inv.clientId, clientEmail: inv.clientEmail || inv.email }
  }).then(function(res) {
    var lo = document.getElementById('inv-edit-loading');
    if (lo) lo.remove();
    if (!res.ok || !res.data || !res.data.ok) {
      alert('Could not load invoice: ' + ((res.data && res.data.error) || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    renderInvoiceEditModal_(res.data, inv);
  }).catch(function(err) {
    var lo = document.getElementById('inv-edit-loading');
    if (lo) lo.remove();
    alert('Error loading invoice: ' + (err.message || String(err)));
  });
}

function renderInvoiceEditModal_(invData, inv) {
  var existing = document.getElementById('inv-edit-overlay');
  if (existing) existing.remove();

  var lineRowsHtml = (invData.lineItems || []).map(function(li, i) {
    return invoiceEditLineRowHtml_(li, i);
  }).join('');

  var overlay = document.createElement('div');
  overlay.id = 'inv-edit-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.72);z-index:10000;display:flex;flex-direction:column;';
  overlay.innerHTML =
    '<div style="background:#1e1716;color:#f6f1ee;display:flex;align-items:center;justify-content:space-between;padding:0.75rem 1.25rem;flex-shrink:0;">' +
      '<div>' +
        '<div style="font-weight:700;font-size:0.95rem;">Edit Invoice' + (invData.invoiceNumber ? ' #' + escHtml(invData.invoiceNumber) : '') + '</div>' +
        '<div style="font-size:0.75rem;color:#c99591;margin-top:2px;">' + escHtml((inv.clientName||inv.clientEmail||'')) + '</div>' +
      '</div>' +
      '<div style="display:flex;gap:0.6rem;">' +
        '<button class="btn btn-ghost" style="font-size:0.8rem;" onclick="closeInvoiceEditModal_()">Cancel</button>' +
        '<button class="btn btn-primary" id="inv-edit-save-btn" onclick="saveInvoiceDraft_()">Save Changes</button>' +
        '<button class="btn btn-primary" id="inv-edit-send-btn" onclick="saveAndSendInvoice_()" style="background:var(--brand-gold);border-color:var(--brand-gold);">Save &amp; Send</button>' +
      '</div>' +
    '</div>' +
    '<div style="flex:1;overflow-y:auto;padding:1.5rem;background:#f6f1ee;">' +
      '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:1rem;margin-bottom:1.25rem;">' +
        '<div><label style="font-size:0.75rem;font-weight:600;display:block;margin-bottom:4px;">Issue Date</label>' +
          '<input type="date" id="inv-edit-issue-date" value="' + escHtml(invData.issueDate||'') + '" style="width:100%;padding:8px 10px;border:1px solid #e6dad4;border-radius:0.5rem;font-size:0.85rem;background:#fff;"></div>' +
        '<div><label style="font-size:0.75rem;font-weight:600;display:block;margin-bottom:4px;">Due Date</label>' +
          '<input type="date" id="inv-edit-due-date" value="' + escHtml(invData.dueDate||'') + '" style="width:100%;padding:8px 10px;border:1px solid #e6dad4;border-radius:0.5rem;font-size:0.85rem;background:#fff;"></div>' +
        '<div><label style="font-size:0.75rem;font-weight:600;display:block;margin-bottom:4px;">Reference</label>' +
          '<input type="text" id="inv-edit-reference" value="' + escHtml(invData.reference||'') + '" placeholder="Optional" style="width:100%;padding:8px 10px;border:1px solid #e6dad4;border-radius:0.5rem;font-size:0.85rem;background:#fff;"></div>' +
      '</div>' +
      '<div style="font-size:0.73rem;font-weight:700;letter-spacing:0.05em;text-transform:uppercase;color:#2f2524;margin-bottom:0.5rem;">Line Items</div>' +
      '<table style="width:100%;border-collapse:collapse;margin-bottom:0.75rem;">' +
        '<thead><tr style="background:#1e1716;color:#f6f1ee;">' +
          '<th style="padding:7px 10px;text-align:left;font-size:0.72rem;font-weight:600;">Description</th>' +
          '<th style="padding:7px 10px;text-align:right;font-size:0.72rem;font-weight:600;width:80px;">Qty</th>' +
          '<th style="padding:7px 10px;text-align:right;font-size:0.72rem;font-weight:600;width:110px;">Unit Price</th>' +
          '<th style="padding:7px 10px;text-align:right;font-size:0.72rem;font-weight:600;width:100px;">Amount</th>' +
          '<th style="width:36px;"></th>' +
        '</tr></thead>' +
        '<tbody id="inv-edit-lines-body">' + lineRowsHtml + '</tbody>' +
      '</table>' +
      '<button onclick="invoiceAddLineItem_()" style="font-size:0.75rem;padding:5px 14px;border-radius:3rem;border:1px solid #c99591;background:transparent;color:#c99591;cursor:pointer;">+ Add line item</button>' +
      '<div id="inv-edit-totals" style="margin-top:1.25rem;text-align:right;font-size:0.82rem;line-height:1.9;">' +
        invoiceEditTotalsHtml_(invData) +
      '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  overlay._invData = invData;
  overlay._inv     = inv;
}

function invoiceEditLineRowHtml_(li, i) {
  var qty  = parseFloat(li.quantity)   || 1;
  var unit = parseFloat(li.unitAmount) || 0;
  var amt  = qty * unit;
  return '<tr data-line-idx="' + i + '" style="background:#fff;border-bottom:1px solid #f0e8e4;">' +
    '<td style="padding:6px 8px;">' +
      '<input type="text" value="' + escHtml(li.description||'') + '" data-field="description" ' +
        'style="width:100%;border:1px solid #e6dad4;border-radius:4px;padding:5px 8px;font-size:0.82rem;">' +
      (li.lineItemId ? '<input type="hidden" data-field="lineItemId" value="' + escHtml(li.lineItemId) + '">' : '') +
    '</td>' +
    '<td style="padding:6px 8px;text-align:right;">' +
      '<input type="number" value="' + qty + '" data-field="quantity" min="0.01" step="0.01" ' +
        'style="width:60px;border:1px solid #e6dad4;border-radius:4px;padding:5px 6px;font-size:0.82rem;text-align:right;" ' +
        'oninput="invoiceEditRecalcTotals_()">' +
    '</td>' +
    '<td style="padding:6px 8px;text-align:right;">' +
      '<input type="number" value="' + unit.toFixed(2) + '" data-field="unitAmount" min="0" step="0.01" ' +
        'style="width:90px;border:1px solid #e6dad4;border-radius:4px;padding:5px 6px;font-size:0.82rem;text-align:right;" ' +
        'oninput="invoiceEditRecalcTotals_()">' +
    '</td>' +
    '<td class="inv-line-amt" style="padding:6px 8px;text-align:right;">$' + amt.toFixed(2) + '</td>' +
    '<td style="padding:4px;text-align:center;">' +
      '<button onclick="invoiceRemoveLineItem_(this)" style="background:none;border:none;color:#c99591;cursor:pointer;font-size:1.1rem;line-height:1;" title="Remove">×</button>' +
    '</td>' +
  '</tr>';
}

function invoiceEditTotalsHtml_(data) {
  var sub   = data.subTotal || 0;
  var tax   = data.totalTax || 0;
  var total = data.total    || 0;
  return '<div><span style="color:#6b6158;">Subtotal excl. GST:</span> $' + (sub - tax > 0 ? (sub - tax) : sub).toFixed(2) + '</div>' +
         '<div><span style="color:#6b6158;">GST (10%):</span> $' + Number(tax).toFixed(2) + '</div>' +
         '<div style="font-weight:700;font-size:0.92rem;border-top:1px solid #e6dad4;padding-top:4px;margin-top:4px;">Total: $' + Number(total).toFixed(2) + '</div>';
}

function invoiceAddLineItem_() {
  var tbody = document.getElementById('inv-edit-lines-body');
  if (!tbody) return;
  var i = tbody.querySelectorAll('tr').length;
  var tr = document.createElement('tr');
  tr.dataset.lineIdx = i;
  tr.style.cssText = 'background:#fff;border-bottom:1px solid #f0e8e4;';
  tr.innerHTML = invoiceEditLineRowHtml_({ description: '', quantity: 1, unitAmount: 0, lineItemId: '' }, i)
    .replace(/^<tr[^>]*>/, '').replace(/<\/tr>$/, '');
  tbody.appendChild(tr);
}

function invoiceRemoveLineItem_(btn) {
  var row = btn.closest('tr');
  if (row) { row.remove(); invoiceEditRecalcTotals_(); }
}

function invoiceEditRecalcTotals_() {
  var tbody = document.getElementById('inv-edit-lines-body');
  if (!tbody) return;
  var total = 0;
  tbody.querySelectorAll('tr').forEach(function(row) {
    var qty  = parseFloat((row.querySelector('[data-field="quantity"]')   || {}).value || 0);
    var unit = parseFloat((row.querySelector('[data-field="unitAmount"]') || {}).value || 0);
    var amt  = qty * unit;
    var cell = row.querySelector('.inv-line-amt');
    if (cell) cell.textContent = '$' + amt.toFixed(2);
    total += amt;
  });
  var tax = total / 11;
  var el = document.getElementById('inv-edit-totals');
  if (el) el.innerHTML =
    '<div><span style="color:#6b6158;">Subtotal excl. GST:</span> $' + (total - tax).toFixed(2) + '</div>' +
    '<div><span style="color:#6b6158;">GST (10%):</span> $' + tax.toFixed(2) + '</div>' +
    '<div style="font-weight:700;font-size:0.92rem;border-top:1px solid #e6dad4;padding-top:4px;margin-top:4px;">Total: $' + total.toFixed(2) + '</div>';
}

function invoiceEditCollectLineItems_() {
  var tbody = document.getElementById('inv-edit-lines-body');
  if (!tbody) return [];
  var items = [];
  tbody.querySelectorAll('tr').forEach(function(row) {
    var desc = (row.querySelector('[data-field="description"]') || {}).value || '';
    var qty  = parseFloat((row.querySelector('[data-field="quantity"]')   || {}).value || 1);
    var unit = parseFloat((row.querySelector('[data-field="unitAmount"]') || {}).value || 0);
    var lid  = (row.querySelector('[data-field="lineItemId"]')  || {}).value || '';
    if (desc || unit > 0) items.push({ description: desc, quantity: qty, unitAmount: unit, lineItemId: lid, accountCode: '200', taxType: 'OUTPUT' });
  });
  return items;
}

function closeInvoiceEditModal_() {
  var o = document.getElementById('inv-edit-overlay');
  if (o) o.remove();
}

function saveInvoiceDraft_() {
  var overlay = document.getElementById('inv-edit-overlay');
  if (!overlay || !overlay._invData) { alert('Modal lost state — retry.'); return; }
  var btn = document.getElementById('inv-edit-save-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
  var lineItems = invoiceEditCollectLineItems_();
  if (!lineItems.length) { alert('Add at least one line item.'); if (btn) { btn.disabled=false; btn.textContent='Save Changes'; } return; }
  var invData = overlay._invData;
  var inv     = overlay._inv;
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_updateInvoiceDraft',
    args: {
      xeroInvoiceId: invData.xeroInvoiceId,
      clientId:      inv.clientId,
      clientEmail:   inv.clientEmail || inv.email,
      lineItems:     lineItems,
      issueDate:     (document.getElementById('inv-edit-issue-date') || {}).value || invData.issueDate,
      dueDate:       (document.getElementById('inv-edit-due-date')   || {}).value || invData.dueDate,
      reference:     (document.getElementById('inv-edit-reference')  || {}).value || ''
    }
  }).then(function(res) {
    closeInvoiceEditModal_();
    if (!res.ok || !res.data || !res.data.success) {
      alert('Save failed: ' + ((res.data && res.data.error) || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    alert('Invoice updated. Total: $' + Number(res.data.total||0).toFixed(2));
    loadInvoicingView();
  }).catch(function(err) { closeInvoiceEditModal_(); alert('Error: ' + (err.message || String(err))); });
}

function saveAndSendInvoice_() {
  // 2026-07-30 fix (FIX-invoice-create-and-send-must-actually-send-2026-07-30.md
  // Item 1): the invoice-edit "Save & Send" button had the identical gap as the
  // general Create & Send flow, save succeeded, then a SEPARATE preview-overlay
  // click was needed to actually send. Now calls one atomic server orchestrator
  // (adminCrm_saveAndSendInvoice) that saves, builds the branded email with the
  // real Xero URL, and sends it in a single round trip.
  var overlay = document.getElementById('inv-edit-overlay');
  if (!overlay || !overlay._invData) { alert('Modal lost state, please retry.'); return; }
  var btn = document.getElementById('inv-edit-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Saving & sending...'; }
  var lineItems = invoiceEditCollectLineItems_();
  if (!lineItems.length) { alert('Add at least one line item.'); if (btn) { btn.disabled=false; btn.textContent='Save & Send'; } return; }
  var invData = overlay._invData;
  var inv     = overlay._inv;
  var dueDateVal = (document.getElementById('inv-edit-due-date') || {}).value || invData.dueDate;
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_saveAndSendInvoice',
    args: {
      xeroInvoiceId: invData.xeroInvoiceId,
      clientId:      inv.clientId,
      clientEmail:   inv.clientEmail || inv.email,
      clientName:    inv.clientName,
      lineItems:     lineItems,
      issueDate:     (document.getElementById('inv-edit-issue-date') || {}).value || invData.issueDate,
      dueDate:       dueDateVal,
      reference:     (document.getElementById('inv-edit-reference')  || {}).value || '',
      balanceDue:    invData.amountDue
    }
  }).then(function(res) {
    var d = (res && res.data) || {};
    if (!res.ok || d.success === false) {
      closeInvoiceEditModal_();
      alert('Save failed: ' + (d.error || (res.error && res.error.message) || 'Unknown error'));
      return;
    }
    closeInvoiceEditModal_();
    if (d.emailSent) {
      alert('Invoice saved and sent to ' + (d.to || inv.clientEmail || inv.email) + '. A JV-branded email has been delivered.');
      loadInvoicingView();
      return;
    }
    // Invoice saved but the email genuinely failed, unambiguous, cannot be missed.
    alert('INVOICE SAVED BUT EMAIL FAILED TO SEND\n\n' +
      (d.emailError || 'The invoice was saved in Xero but the email did not go out.') +
      '\n\nUse "Resend invoice email" from the invoice list to deliver it. Jess has also been alerted via admin Chat.');
    loadInvoicingView();
  }).catch(function(err) { closeInvoiceEditModal_(); alert('Error: ' + (err.message || String(err))); });
}

/* ============================================================
   RUNSHEETS VIEW
   ============================================================ */
var _runsheetsData = [];

function loadRunsheetsView() {
  showLoader('runsheets');
  // TODO: Bridge route needed for: adminCrm_getRunsheets
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getRunsheets' })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      _runsheetsData = Array.isArray(data) ? data : [];
      // Populate artist filter
      var artists = {};
      _runsheetsData.forEach(function(r) {
        if (r.assignedArtist) {
          String(r.assignedArtist).split(',').forEach(function(a) {
            var t = a.trim();
            if (t) artists[t] = true;
          });
        }
      });
      var artistSel = document.getElementById('rs-artist');
      if (artistSel) {
        var existing = artistSel.options[0];
        artistSel.innerHTML = '';
        artistSel.appendChild(existing || new Option('All Artists', ''));
        Object.keys(artists).sort().forEach(function(a) {
          artistSel.appendChild(new Option(a, a));
        });
      }
      filterRunsheetsView();
      showContent('runsheets');
    }; _h(res.data); } else { var _e = function(err){ showError('runsheets', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('runsheets', err.message || String(err)); });
}

function filterRunsheetsView() {
  var searchQ  = (document.getElementById('rs-search')    || {}).value.toLowerCase().trim();
  var statusF  = (document.getElementById('rs-status')    || {}).value || '';
  var artistF  = (document.getElementById('rs-artist')    || {}).value || '';
  var dateFrom = (document.getElementById('rs-date-from') || {}).value || '';
  var dateTo   = (document.getElementById('rs-date-to')   || {}).value || '';
  var sortBy   = (document.getElementById('rs-sort')      || {}).value || 'wedding-asc';
  var groupBy  = (document.getElementById('rs-group')     || {}).value || '';

  var filtered = _runsheetsData.filter(function(r) {
    if (searchQ && !(r.clientName||r.clientEmail||'').toLowerCase().includes(searchQ)) return false;
    if (statusF && (r.status||'').toLowerCase() !== statusF) return false;
    if (artistF && !(r.assignedArtist||'').toLowerCase().includes(artistF.toLowerCase())) return false;
    var wd = r.weddingDate || r.dueDate || '';
    if (dateFrom && wd && wd < dateFrom) return false;
    if (dateTo   && wd && wd > dateTo)   return false;
    return true;
  });

  filtered.sort(function(a, b) {
    var aw = a.weddingDate||a.dueDate||''; var bw = b.weddingDate||b.dueDate||'';
    if (sortBy === 'wedding-asc') return aw.localeCompare(bw);
    if (sortBy === 'due-desc')    return bw.localeCompare(aw);
    if (sortBy === 'due-asc')     return aw.localeCompare(bw);
    var ai = a.issueDate||''; var bi = b.issueDate||'';
    if (sortBy === 'issue-desc')  return bi.localeCompare(ai);
    if (sortBy === 'issue-asc')   return ai.localeCompare(bi);
    if (sortBy === 'status')      return (a.status||'').localeCompare(b.status||'');
    return aw.localeCompare(bw);
  });

  var countEl = document.getElementById('rs-count');
  if (countEl) countEl.textContent = filtered.length + ' runsheets';

  var wrap = document.getElementById('runsheets-list-wrap');
  if (!wrap) return;

  if (filtered.length === 0) {
    wrap.innerHTML = '<div class="empty-state"><div class="empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg></div><p>No runsheets match these filters.</p></div>';
    return;
  }

  if (!groupBy) {
    wrap.innerHTML = renderRunsheetTable(filtered);
  } else {
    var groups = {};
    filtered.forEach(function(r) {
      var key = groupBy === 'client' ? (r.clientName || r.clientEmail || '—') :
                groupBy === 'artist' ? (r.assignedArtist || 'Unassigned') :
                (r.type || 'Standard');
      if (!groups[key]) groups[key] = [];
      groups[key].push(r);
    });
    var html = '';
    Object.keys(groups).sort().forEach(function(key) {
      html += '<div class="card-panel" style="margin-bottom:1rem;">';
      html += '<div class="comms-group-header"><span>' + escHtml(key) + '</span><span>' + groups[key].length + '</span></div>';
      html += renderRunsheetTable(groups[key]);
      html += '</div>';
    });
    wrap.innerHTML = html;
  }
}

// Issue #10 / Sub-D, 2026-10-26: "Check booking-summary accuracy" button, Runsheets toolbar.
// Read-only drift check between every booked bride's saved bridal_booking_summary and her
// real published runsheet. Admin-session-gated via the relay entity
// admin-bbs-reconcile/check-all -> jv-crm-mirror POST /admin/bbs-reconcile/check-all
// (same App-Proxy-signature + jv-admin-tag chain as admin-trial-date/save above). No raw
// secret is ever read, stored, or sent from this page -- the relay injects it server-side.
function jvBbsReconcileCheckAll() {
  var btn = document.getElementById('bbs-recon-check-btn');
  var out = document.getElementById('bbs-recon-result');
  if (!out) return;
  var base = window._jvAdminProxyBase;
  if (!base) {
    out.style.display = 'block';
    out.innerHTML = '<div class="alert danger">Admin connection unavailable.</div>';
    return;
  }
  if (btn) { btn.disabled = true; btn.textContent = 'Checking…'; }
  out.style.display = 'block';
  out.innerHTML = '<div class="alert info"><div class="mini-spinner" style="display:inline-block;width:12px;height:12px;margin-right:6px;"></div>Checking every booked bride’s booking summary against her published runsheet…</div>';
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/admin-bbs-reconcile/check-all', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({})
  }).then(function (r) { return r.json(); }).then(function (r) {
    if (btn) { btn.disabled = false; btn.textContent = 'Check booking-summary accuracy'; }
    if (!r || r.ok !== true) {
      var errMsg = (r && r.error) || 'Unknown error';
      if (errMsg === 'route_disabled') errMsg = 'This check is not switched on yet.';
      out.innerHTML = '<div class="alert danger">Could not run the check: ' + escHtml(String(errMsg)) + '</div>';
      return;
    }
    var s = r.summary || {};
    var rows = Array.isArray(r.rows) ? r.rows : [];
    var html = '<div class="card-panel">';
    html += '<div style="font-weight:700;margin-bottom:0.4rem;">Booking-summary accuracy check</div>';
    html += '<div style="font-size:0.82rem;color:var(--text-light);margin-bottom:0.6rem;">';
    html += (s.bridesScanned || 0) + ' brides checked · ';
    html += '<strong style="color:' + ((s.bridesWithDrift || 0) > 0 ? 'var(--brand-error)' : 'inherit') + ';">' + (s.bridesWithDrift || 0) + ' with drift</strong> · ';
    html += (s.bridesInSync || 0) + ' in sync · ' + (s.bridesNotCompared || 0) + ' not comparable';
    html += '</div>';
    if (rows.length) {
      html += '<table class="data-table" style="width:100%;font-size:0.8rem;"><thead><tr><th>Bride</th><th>Wedding date</th><th>Status</th></tr></thead><tbody>';
      rows.forEach(function (row) {
        html += '<tr><td>' + escHtml(row.name || row.email || '') + '</td><td>' + escHtml(row.weddingDate || '') + '</td><td>' + escHtml(row.status || '') + '</td></tr>';
      });
      html += '</tbody></table>';
    } else {
      html += '<div style="font-size:0.82rem;color:var(--text-light);">No drift found.</div>';
    }
    html += '</div>';
    out.innerHTML = html;
  }).catch(function () {
    if (btn) { btn.disabled = false; btn.textContent = 'Check booking-summary accuracy'; }
    out.innerHTML = '<div class="alert danger">No reply from the server. Try again.</div>';
  });
}

function renderRunsheetTable(runsheets) {
  var html = '<div class="card-panel" style="padding:0;">' +
    '<table class="data-table"><thead><tr>' +
    '<th>Client</th><th>Wedding Date</th><th>Artist(s)</th><th>Status</th><th>Signed Off</th><th></th>' +
    '</tr></thead><tbody>';

  runsheets.forEach(function(r) {
    var statusCls = (r.status||'draft').toLowerCase().replace(/\s+/g,'-');
    var artists = r.assignedArtist
      ? String(r.assignedArtist).split(',').map(function(a){
          return '<span class="rs-artist-chip">' + escHtml(a.trim()) + '</span>';
        }).join(' ')
      : '<span style="color:var(--text-light);font-size:0.75rem;">—</span>';

    var rowId = r.id || r.clientId || r.clientEmail || '';
    html += '<tr>' +
      '<td><span class="action-link" onclick="openDrawer(\'' + escAttr(rowId) + '\')">' + escHtml(r.clientName||r.clientEmail||'—') + '</span></td>' +
      '<td>' + escHtml(r.weddingDate ? formatDate(r.weddingDate) : '—') + '</td>' +
      '<td>' + artists + '</td>' +
      '<td><span class="rs-status-chip ' + statusCls + '">' + escHtml(r.status||'Draft') + '</span></td>' +
      '<td>' + escHtml(r.signedOffDate ? formatDate(r.signedOffDate) : (r.runsheetSignedOff ? 'Yes' : '—')) + '</td>' +
      '<td>' +
        '<button class="action-link" onclick="openRunsheet(\'' + escAttr(rowId) + '\')">Open ↗</button>' +
      '</td>' +
    '</tr>';
  });

  html += '</tbody></table></div>';
  return html;
}

/* ============================================================
   COMMS VIEW
   ============================================================ */
var _commsData = [];

function loadCommsView() {
  showLoader('comms');
  var opts = getCommsFilterOpts();
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getAllComms', args: opts })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      _commsData = (data && data.entries) || [];
      renderCommsList(_commsData);
      showContent('comms');
      var countEl = document.getElementById('comms-count');
      if (countEl) countEl.textContent = _commsData.length + ' entries';
    }; _h(res.data); } else { var _e = function(err) { showError('comms', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err) { showError('comms', err.message || String(err)); });
}

function getCommsFilterOpts() {
  return {
    type:        (document.getElementById('comms-type')         || {}).value || 'all',
    contactType: (document.getElementById('comms-contact-type') || {}).value || 'all',
    dateFrom:    (document.getElementById('comms-date-from')    || {}).value || '',
    dateTo:      (document.getElementById('comms-date-to')      || {}).value || '',
    sortBy:      (document.getElementById('comms-sort')         || {}).value || 'date-desc'
  };
}

function applyCommsFilters() {
  loadCommsView();
}

function renderCommsList(entries) {
  var wrap = document.getElementById('comms-list-wrap');
  if (!wrap) return;
  if (!entries || entries.length === 0) {
    wrap.innerHTML = '<div class="empty-state"><div class="empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div><p>No communications found matching these filters.</p></div>';
    return;
  }

  var groupBy = (document.getElementById('comms-group') || {}).value || '';
  var html = '';

  if (!groupBy) {
    html += '<div class="card-panel" style="padding:0 1.5rem;">';
    entries.forEach(function(e) { html += renderCommsRow(e); });
    html += '</div>';
  } else if (groupBy === 'client') {
    // Group by contact with expandable thread cards
    var contactGroups = {};
    var contactOrder = [];
    entries.forEach(function(e) {
      var key = e.clientName || e.clientId || 'Unknown';
      if (!contactGroups[key]) { contactGroups[key] = []; contactOrder.push(key); }
      contactGroups[key].push(e);
    });
    // Sort contacts by most recent message (newest first)
    contactOrder.sort(function(a, b) {
      var aTs = contactGroups[a][0] && contactGroups[a][0].timestamp ? contactGroups[a][0].timestamp : '';
      var bTs = contactGroups[b][0] && contactGroups[b][0].timestamp ? contactGroups[b][0].timestamp : '';
      return bTs.localeCompare(aTs);
    });
    contactOrder.forEach(function(key) {
      var msgs = contactGroups[key];
      var latest = msgs[0] || {};
      var ch = latest.channel || 'note';
      var chLabel = ch === 'sms' ? 'SMS' : ch === 'email' ? 'Email' : ch === 'social' ? 'Social' :
                    ch === 'chat' ? 'Chat' : ch === 'form' ? 'Form' : 'Note';
      var preview = latest.message ? latest.message.substring(0, 80) : '';
      var ts = latest.timestamp ? formatDate(latest.timestamp, 'short') : '';
      var safeId = key.replace(/[^a-zA-Z0-9]/g, '-');
      html += '<div class="comms-contact-group">';
      html += '<div class="comms-contact-header" onclick="toggleContactThread(\'' + escAttr(safeId) + '\')">';
      html += '<span class="contact-name">' + escHtml(key) + '</span>';
      html += '<span class="comms-ch-badge ' + escHtml(ch) + '">' + escHtml(chLabel) + '</span>';
      html += '<span class="contact-preview">' + escHtml(preview) + '</span>';
      html += '<span class="contact-date">' + escHtml(ts) + '</span>';
      html += '<span class="contact-count">' + msgs.length + (msgs.length === 1 ? ' message' : ' messages') + '</span>';
      html += '<svg class="contact-chevron" viewBox="0 0 24 24" width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>';
      html += '</div>';
      html += '<div class="comms-contact-thread" id="thread-' + escAttr(safeId) + '">';
      msgs.forEach(function(e) { html += renderCommsRow(e); });
      html += '</div>';
      html += '</div>';
    });
  } else {
    // Group by channel
    var groups = {};
    entries.forEach(function(e) {
      var key = e.channel || 'note';
      if (!groups[key]) groups[key] = [];
      groups[key].push(e);
    });
    Object.keys(groups).sort().forEach(function(key) {
      html += '<div class="card-panel" style="padding:0.5rem 1.5rem;margin-bottom:0.75rem;">';
      html += '<div class="comms-group-header"><span>' + escHtml(key) + '</span><span>' + groups[key].length + '</span></div>';
      groups[key].forEach(function(e) { html += renderCommsRow(e); });
      html += '</div>';
    });
  }

  wrap.innerHTML = html;
}

function toggleContactThread(safeId) {
  var thread = document.getElementById('thread-' + safeId);
  if (!thread) return;
  var header = thread.previousElementSibling;
  var isOpen = thread.classList.contains('open');
  if (isOpen) {
    thread.classList.remove('open');
    if (header) header.classList.remove('open');
  } else {
    thread.classList.add('open');
    if (header) header.classList.add('open');
  }
}

function renderCommsRow(e) {
  var ch = e.channel || 'note';
  var chLabel = ch === 'sms' ? 'SMS' : ch === 'email' ? 'Email' : ch === 'social' ? 'Social' :
                ch === 'chat' ? 'Chat' : ch === 'form' ? 'Form' : 'Note';
  var tsDisplay = e.timestamp ? e.timestamp.slice(0, 16).replace('T', ' ') : '';
  var cid = e.clientId || '';
  var cname = e.clientName || cid;
  var msg = e.message || '';
  return '<div class="comms-row">' +
    '<span class="comms-ch-badge ' + escHtml(ch) + '">' + escHtml(chLabel) + '</span>' +
    '<div class="comms-body">' +
      '<div class="comms-client" onclick="openClientComms(' + escHtml(cid) + ')">' + escHtml(cname) + '</div>' +
      '<div class="comms-msg">' + escHtml(msg) + '</div>' +
    '</div>' +
    '<div class="comms-ts">' + escHtml(tsDisplay) + '</div>' +
    '<button class="comms-assign-btn" onclick="openAssignTaskDialog(' + escHtml(cid) + ',\'' +
      escHtml(cname).replace(/'/g, '&#39;') + '\',\'' + escHtml(msg.substring(0, 80)).replace(/'/g, '&#39;') + '\')" title="Create follow-up task">+ Task</button>' +
  '</div>';
}

function openAssignTaskDialog(clientId, clientName, context) {
  var task = window.prompt(
    'Create follow-up task for ' + clientName + ':\n(Enter task description)',
    'Follow up re: ' + String(context).substring(0, 60)
  );
  if (!task) return;

  function fallbackToGasTaskCrm() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_createFollowUpTask', args: { clientId: String(clientId), task: task, context: context } })
      .then(function(res) { if (res.ok) { alert('Task created.'); } else { var err = res.error; alert('Error: ' + (err && err.message || String(err))); } })
      .catch(function(err) { alert('Error: ' + (err.message || String(err))); });
  }

  // D1-first, insert mode (2026-08-29, per BRIEFS/HANDOFF-insert-mode-frontend-
  // wiring-to-admin-crm-2026-08-29.md). follow-up-task is an INSERT of a new
  // Internal Tasks row, not an update to a bride column. Fresh idempotency
  // key on every attempt, never reused on retry.
  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  var brideUid = (c && c.brideUid) || '';
  if (ADMIN_CLIENTS_D1_READ_ENABLED_) {
    if (!brideUid || !window._jvAdminProxyBase) {
      alert('Task was not saved. The Cloudflare bride identity is unavailable. Reload the client list and try again.');
      return;
    }
    // Canonical team_tasks write. One stable key for this click; transport ambiguity
    // is never retried through GAS because the D1 insert may already have landed.
    var directTaskKey = brideUid + '|admin-follow-up|' + Date.now() + '|' + Math.random().toString(36).slice(2);
    var directTaskUrl = String(window._jvAdminProxyBase).replace(/\/+$/, '') + '/partner/admin-task-create/create';
    var directTaskFetch = window._jvNativeFetch || window.fetch.bind(window);
    directTaskFetch(directTaskUrl, {
      method: 'POST', headers: { 'Content-Type': 'text/plain' }, credentials: 'include',
      body: JSON.stringify({ bride_uid: brideUid, bride_email: (c && c.email) || '', idempotency_key: directTaskKey, task_text: task, context: context })
    }).then(function(resp) {
      return resp.text().then(function(raw) {
        var data = null; try { data = JSON.parse(raw); } catch (_) {}
        if (resp.ok && data && data.ok === true && data.writtenTo === 'd1' && data.taskId) {
          alert('Task created.');
          return;
        }
        alert('Task was not saved. Cloudflare refused the write' + (data && data.error ? ': ' + data.error : '.') + ' Nothing was written through Apps Script.');
      });
    }).catch(function() {
      alert('Could not confirm the task save. It may already exist in Cloudflare. Check the task list before trying again. Nothing was written through Apps Script.');
    });
    return;
  }
  if (!brideUid) {
    fallbackToGasTaskCrm();
    return;
  }
  var idempotencyKey = brideUid + '|task|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  jvBridge.call('bridge_admin_createFollowUpTaskD1', {
    bride_uid: brideUid, bride_email: (c && c.email) || '',
    idempotency_key: idempotencyKey, record: { task: task, context: context }
  }).then(function(res) {
    if (res && res.ok && res.writtenTo === 'd1') {
      alert('Task created.');
    } else {
      fallbackToGasTaskCrm();
    }
  }).catch(function() {
    fallbackToGasTaskCrm();
  });
}

/* ============================================================
   COMPOSE SMS / EMAIL VIEWS
   ============================================================ */
var _composeClientCache = null;

/* ── Client search index — loaded once per session, filtered client-side ── */
var _jvClientIdx = null;
var _jvClientIdxLoading = false;
var _jvClientIdxCbs = [];

function _ensureClientIdx(onReady) {
  if (_jvClientIdx) { onReady(_jvClientIdx); return; }
  try {
    var raw = localStorage.getItem('jv_cidx');
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.ts && (Date.now() - parsed.ts < 1800000) && Array.isArray(parsed.d)) {
        _jvClientIdx = parsed.d;
        onReady(_jvClientIdx);
        return;
      }
    }
  } catch (_) {}
  _jvClientIdxCbs.push(onReady);
  if (_jvClientIdxLoading) return;
  _jvClientIdxLoading = true;
  window.jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientIndex' })
    .then(function(res) {
      _jvClientIdxLoading = false;
      var data = (res && res.ok && Array.isArray(res.data)) ? res.data : [];
      _jvClientIdx = data;
      try { localStorage.setItem('jv_cidx', JSON.stringify({ ts: Date.now(), d: data })); } catch (_) {}
      var cbs = _jvClientIdxCbs.splice(0);
      cbs.forEach(function(cb) { cb(data); });
    })
    .catch(function() {
      _jvClientIdxLoading = false;
      _jvClientIdx = [];
      var cbs = _jvClientIdxCbs.splice(0);
      cbs.forEach(function(cb) { cb([]); });
    });
}

function _searchClientIdx(q, limit) {
  if (!_jvClientIdx) return null;
  var qLow = q.toLowerCase().trim();
  if (!qLow) return [];
  limit = limit || 8;
  var results = [];
  for (var i = 0; i < _jvClientIdx.length && results.length < limit; i++) {
    var e = _jvClientIdx[i]; // [rowIndex, email, fullName, phone, booked, weddingIso, haystack]
    if (e[6].indexOf(qLow) === -1) continue;
    results.push({ rowIndex: e[0], email: e[1], name: e[2], phone: e[3], booked: e[4],
      weddingDateLabel: e[5] ? _fmtWeddingDate(e[5]) : '' });
  }
  return results;
}

function _fmtWeddingDate(iso) {
  try {
    var d = new Date(iso + 'T00:00:00');
    if (isNaN(d)) return iso;
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  } catch (_) { return iso; }
}

function _normaliseComposeClients(source) {
  var seen = {};
  return (source || []).map(function(c) {
    c = c || {};
    var name = c.name || c.clientName || ((c.firstName || '') + ' ' + (c.lastName || '')).trim() || c.email || '';
    var email = c.email || c.clientEmail || '';
    var id = c.clientId || c.id || c.rowIndex || '';
    return Object.assign({}, c, {
      id: id,
      clientId: id,
      name: name,
      clientName: name,
      email: email
    });
  }).filter(function(c) {
    var key = String(c.clientId || c.id || c.email || c.name || '').toLowerCase();
    if (!key || seen[key]) return false;
    seen[key] = true;
    return !!(c.name || c.email);
  });
}

function _getComposeClientsFromState() {
  var source = [];
  if (Array.isArray(STATE.clients) && STATE.clients.length) {
    source = source.concat(STATE.clients);
  }
  if (STATE.pipeline && Array.isArray(STATE.pipeline.items) && STATE.pipeline.items.length) {
    source = source.concat(STATE.pipeline.items);
  }
  if (STATE.pipeline && Array.isArray(STATE.pipeline.closedClients) && STATE.pipeline.closedClients.length) {
    source = source.concat(STATE.pipeline.closedClients);
  }
  return _normaliseComposeClients(source);
}

function _loadComposeClientList(cb) {
  if (_composeClientCache && _composeClientCache.length) { cb(_composeClientCache); return; }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients' })
    .then(function(res) {
      if (res && res.ok) {
        _composeClientCache = _normaliseComposeClients(res.data || []);
        cb(_composeClientCache);
      } else {
        jvToast('Could not load client names: ' + ((res && res.error) || 'Unknown error'), 'error');
        cb([]);
      }
    })
    .catch(function(err) {
      jvToast('Could not load client names: ' + (err && err.message ? err.message : 'network error'), 'error');
      cb([]);
    });
}

/* D1 recipient pickers (2026-10-06, Consolidator-approved). Flag OFF. When ON, the SMS and email
   recipient pickers search D1 (bride-search relay entity) with a 250ms debounce instead of
   filtering the Apps Script client index. Results carry brideUid + email and NO row number; the
   senders (bridge_admin_sendMessage / send_custom_email) now require and verify that identity,
   so a D1 result can never message a different bride. Closed/archived brides are not in D1, so
   they will not appear here (acceptable: they are not message targets). Failure is loud
   (watertight helper, Retry button), never a silent Apps Script fallback. Requires the
   bride-search staleness guard (e1c44c12c) deployed before this flag is flipped. */
var ADMIN_D1_RECIPIENT_PICKER_ENABLED_ = false;
function _recipientFromD1_(r) {
  return { name: r.fullName || ((r.firstName || '') + ' ' + (r.lastName || '')).trim() || r.email,
           email: r.email || '', phone: r.phone || '', brideUid: r.brideUid || '', rowIndex: '',
           weddingDateLabel: r.weddingDateLabel || '', booked: !!r.booked };
}
// Apps Script clients carry their sheet row as `id`; it is passed only as the legacy rowIndex input,
// which the sender verifies against email (and brideUid when present) before sending.
function _recipientFromGasClient_(c) {
  return { name: c.name || ((c.firstName || '') + ' ' + (c.lastName || '')).trim() || c.email,
           email: String(c.email || '').toLowerCase(), phone: c.phone || '', brideUid: c.brideUid || '',
           rowIndex: c.id || '', weddingDateLabel: c.weddingDate || '', booked: !!c.isBooked };
}
var _recipientPickerTimers_ = {};
function _d1RecipientSearch_(q, resultsId, inputId, onSelect) {
  clearTimeout(_recipientPickerTimers_[resultsId]);
  var w = document.getElementById(resultsId);
  if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);font-style:italic;">Searching\u2026</div>'; w.style.display = 'block'; }
  _recipientPickerTimers_[resultsId] = setTimeout(function() {
    adminD1SearchBrides_(q, true).then(function(res) {
      var cur = ((document.getElementById(inputId) || {}).value || '').trim();
      if (cur !== q) return; // admin kept typing; never paint a stale result
      if (!res.ok) {
        adminD1SearchShowUnavailable_(w, res.error, function() { _d1RecipientSearch_(q, resultsId, inputId, onSelect); });
        return;
      }
      var matches = (res.data || []).map(_recipientFromD1_);
      if (matches.length) { _renderRecipientResults(resultsId, matches, onSelect); return; }
      // Jess's rule (a), 2026-10-06: D1 had NO match, so (and only then, never on an error above)
      // ask Apps Script, which still holds closed/archived brides D1 does not mirror.
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClients', args: { q: q, includeCompleted: true } })
        .then(function(r) {
          var cur2 = ((document.getElementById(inputId) || {}).value || '').trim();
          if (cur2 !== q) return;
          if (!r || !r.ok || !Array.isArray(r.data)) {
            adminD1SearchShowUnavailable_(w, 'older-client search failed', function() { _d1RecipientSearch_(q, resultsId, inputId, onSelect); });
            return;
          }
          var older = r.data.slice(0, 8).map(_recipientFromGasClient_);
          if (!older.length) {
            if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);">No clients found for "' + escHtml(q) + '"</div>'; w.style.display = 'block'; }
          } else {
            _renderRecipientResults(resultsId, older, onSelect);
          }
        })
        .catch(function() {
          adminD1SearchShowUnavailable_(w, 'older-client search failed', function() { _d1RecipientSearch_(q, resultsId, inputId, onSelect); });
        });
    });
  }, 250);
}

function _renderRecipientResults(resultsId, matches, onSelect) {
  var wrap = document.getElementById(resultsId);
  if (!wrap) return;
  if (!matches || matches.length === 0) { wrap.innerHTML = ''; wrap.style.display = 'none'; return; }
  var html = '';
  matches.slice(0, 8).forEach(function(c, i) {
    html += '<div class="compose-ac-item" data-idx="' + i + '" onclick="' + onSelect + '(' + i + ')">' +
      escHtml(c.name || c.clientName || '') + ' <span style="color:var(--text-light);font-size:0.72rem;">' + escHtml(c.email || '') + '</span></div>';
  });
  wrap.innerHTML = html;
  wrap.style.display = 'block';
  wrap._matches = matches.slice(0, 8);
}

/* --- SMS Compose --- */
function initComposeSms() {
  _composeClientCache = null;
  smsSetMode('search');
  document.getElementById('sms-recipient').value = '';
  document.getElementById('sms-recipient-id').value = '';
  window._smsRecipientUid = '';
  var emEl = document.getElementById('sms-recipient-email');
  if (emEl) emEl.value = '';
  document.getElementById('sms-phone').value = '';
  document.getElementById('sms-body').value = '';
  var sel = document.getElementById('sms-template-select');
  if (sel) sel.value = '';
  var st = document.getElementById('sms-template-status');
  if (st) st.textContent = '';
  updateSmsCharCount();
  _ensureClientIdx(function() {}); // prefetch so first keystroke is instant
  _loadComposeSmsTemplates();
}

var _composeSmsTplCache = [];
function _loadComposeSmsTemplates() {
  var sel = document.getElementById('sms-template-select');
  if (!sel) return;
  jvBridge.callAdmin('comms_templatesLoadActive', { channel: 'SMS' })
    .then(function(res) {
      var rows = (res && res.data) || res || [];
      if (!Array.isArray(rows)) rows = [];
      _composeSmsTplCache = rows;
      sel.innerHTML = '<option value="">Load Template ▾</option>';
      rows.forEach(function(t) {
        var opt = document.createElement('option');
        opt.value = t.template_id;
        opt.textContent = t.name || '(unnamed)';
        sel.appendChild(opt);
      });
    })
    .catch(function(err) {
      console.error('SMS template load failed:', err);
      var st = document.getElementById('sms-template-status');
      if (st) st.textContent = 'Could not load templates: ' + (err.message || err);
    });
}

function applyComposeSmsTemplate() {
  var sel = document.getElementById('sms-template-select');
  var bodyEl = document.getElementById('sms-body');
  var st = document.getElementById('sms-template-status');
  if (!sel || !sel.value || !bodyEl) return;

  var tplId = sel.value;
  var tpl = _composeSmsTplCache.find(function(t) { return t.template_id === tplId; });
  var existing = (bodyEl.value || '').trim();
  if (existing && !confirm('Replace your current message with this template?')) {
    sel.value = '';
    return;
  }

  var email = (document.getElementById('sms-recipient-email') || {}).value || '';
  if (st) st.textContent = 'Loading template…';

  jvBridge.callAdmin('comms_resolveTemplate', { template_id: tplId, brideEmail: email })
    .then(function(res) {
      var data = (res && res.data) || res || {};
      if (!data || data.ok === false) throw new Error((data && data.error) || 'Failed to resolve template');
      bodyEl.value = data.body || '';
      updateSmsCharCount();
      if (st) {
        if (data.missing && data.missing.length) {
          st.textContent = 'Loaded. Unresolved: ' + data.missing.map(function(m){return '{{'+m+'}}';}).join(', ') +
            (!email ? ' (no recipient selected — pick a bride to resolve all tokens)' : '');
        } else {
          st.textContent = 'Template loaded' + (tpl ? ': ' + tpl.name : '') + '.';
        }
      }
    })
    .catch(function(err) {
      if (tpl) {
        bodyEl.value = tpl.body_template || '';
        updateSmsCharCount();
      }
      if (st) st.textContent = 'Tokens not resolved (' + (err.message || err) + '). Raw template loaded.';
    });
}

function clearComposeSmsTemplate() {
  var sel = document.getElementById('sms-template-select');
  var bodyEl = document.getElementById('sms-body');
  var st = document.getElementById('sms-template-status');
  if (sel) sel.value = '';
  if (bodyEl) { bodyEl.value = ''; updateSmsCharCount(); }
  if (st) st.textContent = '';
}

function searchComposeSmsRecipient(q) {
  var w = document.getElementById('sms-recipient-results');
  if (!q || q.length < 2) {
    if (w) { w.innerHTML = ''; w.style.display = 'none'; }
    return;
  }
  if (ADMIN_D1_RECIPIENT_PICKER_ENABLED_) { _d1RecipientSearch_(q, 'sms-recipient-results', 'sms-recipient', 'selectSmsRecipient'); return; }
  var instant = _searchClientIdx(q);
  if (instant !== null) {
    if (!instant.length) {
      if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);">No clients found for "' + escHtml(q) + '"</div>'; w.style.display = 'block'; }
    } else {
      _renderRecipientResults('sms-recipient-results', instant, 'selectSmsRecipient');
    }
    return;
  }
  if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);font-style:italic;">Loading contacts…</div>'; w.style.display = 'block'; }
  _ensureClientIdx(function() {
    var currentQ = (document.getElementById('sms-recipient') || {}).value || '';
    if (currentQ.trim() !== q) return;
    var matches = _searchClientIdx(q);
    if (!matches || !matches.length) {
      if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);">No clients found for "' + escHtml(q) + '"</div>'; w.style.display = 'block'; }
    } else {
      _renderRecipientResults('sms-recipient-results', matches, 'selectSmsRecipient');
    }
  });
}

function selectSmsRecipient(idx) {
  var wrap = document.getElementById('sms-recipient-results');
  if (!wrap || !wrap._matches) return;
  var c = wrap._matches[idx];
  document.getElementById('sms-recipient').value = c.name || c.clientName || '';
  document.getElementById('sms-recipient-id').value = c.rowIndex || '';
  window._smsRecipientUid = c.brideUid || '';
  var emEl = document.getElementById('sms-recipient-email');
  if (emEl) emEl.value = (c.email || c.clientEmail || '').toLowerCase();
  var phone = c.phone || c.mobile || '';
  document.getElementById('sms-phone').value = phone;
  wrap.innerHTML = ''; wrap.style.display = 'none';

  // If a template is already selected, re-resolve against the now-known bride.
  var tplSel = document.getElementById('sms-template-select');
  if (tplSel && tplSel.value) applyComposeSmsTemplate();
}

function updateSmsCharCount() {
  var body = document.getElementById('sms-body');
  var counter = document.getElementById('sms-compose-char');
  if (!body || !counter) return;
  var len = body.value.length;
  var msgs = Math.max(1, Math.ceil(len / 160));
  counter.textContent = len + ' / 160 (' + msgs + ' msg)';
  counter.className = 'sms-char-count' + (len > 160 ? ' warn' : '');
}

function smsSetMode(mode) {
  var searchSection = document.getElementById('sms-search-section');
  var expressSection = document.getElementById('sms-express-section');
  var btnSearch = document.getElementById('sms-mode-search');
  var btnExpress = document.getElementById('sms-mode-express');
  if (!searchSection) return; // not in SMS compose view yet
  if (mode === 'express') {
    searchSection.style.display = 'none';
    expressSection.style.display = '';
    if (btnSearch) btnSearch.classList.remove('active');
    if (btnExpress) btnExpress.classList.add('active');
    document.getElementById('sms-recipient').value = '';
    document.getElementById('sms-recipient-id').value = '';
    window._smsRecipientUid = '';
    var _smsEmEl = document.getElementById('sms-recipient-email');
    if (_smsEmEl) _smsEmEl.value = '';
    document.getElementById('sms-phone').value = '';
    var w = document.getElementById('sms-recipient-results');
    if (w) { w.innerHTML = ''; w.style.display = 'none'; }
  } else {
    searchSection.style.display = '';
    expressSection.style.display = 'none';
    if (btnSearch) btnSearch.classList.add('active');
    if (btnExpress) btnExpress.classList.remove('active');
    var ep = document.getElementById('sms-express-phone');
    if (ep) ep.value = '';
  }
}

function submitComposeSms() {
  var body = document.getElementById('sms-body').value.trim();
  if (!body) { jvToast('Message cannot be empty', 'error'); return; }
  var btnExpress = document.getElementById('sms-mode-express');
  var isExpress = btnExpress && btnExpress.classList.contains('active');
  var clientId, phone;
  if (isExpress) {
    phone = ((document.getElementById('sms-express-phone') || {}).value || '').trim();
    if (!phone) { jvToast('Enter a phone number to send to', 'error'); return; }
    clientId = '';
  } else {
    clientId = document.getElementById('sms-recipient-id').value;
    phone = document.getElementById('sms-phone').value.trim();
    if (!clientId && !window._smsRecipientUid) { jvToast('Select a recipient first', 'error'); return; }
    if (!phone) { jvToast('No phone number for this contact', 'error'); return; }
  }
  var btn = document.getElementById('sms-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  // Identity (2026-10-06): the server refuses a send whose email/brideUid does not match the row.
  var _smsEmEl = document.getElementById('sms-recipient-email');
  jvBridge.callAdmin('bridge_admin_sendMessage', {
      brideId: clientId, phone: phone, channel: 'sms', subject: '', body: body,
      email: isExpress ? '' : (((_smsEmEl || {}).value || '').toLowerCase()),
      brideUid: isExpress ? '' : (window._smsRecipientUid || '')
    })
    .then(function(res) {
      if (btn) { btn.disabled = false; btn.textContent = 'Send SMS'; }
      // P0.6 (2026-06-04): honest status, "queued/sent" only on a real send.
      var _smsSt = (res.data && res.data.status) ? String(res.data.status).toLowerCase() : '';
      if (_smsSt === 'blocked_safe_mode' || _smsSt === 'blocked') {
        jvToast('Blocked: safe mode is active. SMS not sent.', 'error');
      } else if (_smsSt === 'deferred' || _smsSt === 'blocked_quiet_hours') {
        jvToast('Deferred: outside contact hours. Will send after 8am Sydney.', 'warn');
        document.getElementById('sms-body').value = '';
        updateSmsCharCount();
        if (isExpress) { var epd = document.getElementById('sms-express-phone'); if (epd) epd.value = ''; }
      } else if (res.ok && res.data && res.data.ok && (_smsSt === 'sent' || _smsSt === 'queued' || !_smsSt)) {
        jvToast('SMS sent.');
        document.getElementById('sms-body').value = '';
        updateSmsCharCount();
        if (isExpress) { var ep = document.getElementById('sms-express-phone'); if (ep) ep.value = ''; }
      } else {
        jvToast('Send failed: ' + ((res.data && res.data.error) || (res.error && res.error.message) || 'Unknown error'), 'error');
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Send SMS'; }
      jvToast('Error: ' + (err.message || String(err)), 'error');
    });
}

/* --- Email Compose --- */
function initComposeEmail() {
  _composeClientCache = null;
  var recipientInput = document.getElementById('email-recipient');
  recipientInput.value = '';
  document.getElementById('email-recipient-id').value = '';
  window._emailRecipientUid = '';
  document.getElementById('email-recipient-addr').value = '';
  document.getElementById('email-to-display').value = '';
  document.getElementById('email-subject').value = '';
  document.getElementById('email-body').value = '';
  var tplPreview = document.getElementById('email-tpl-preview-wrap');
  if (tplPreview) tplPreview.style.display = 'none';
  if (window.emailBuilderInitQuill) window.emailBuilderInitQuill();
  if (window.emailBuilderPopulateTemplateSelects) window.emailBuilderPopulateTemplateSelects();
  if (window.emailBuilderSetQuillHtml) window.emailBuilderSetQuillHtml('');
  emailComposeSetMode('rich');
  recipientInput.onfocus = function() { searchComposeEmailRecipient(recipientInput.value || ''); };
  if (!ADMIN_D1_RECIPIENT_PICKER_ENABLED_) _ensureClientIdx(function() {}); // prefetch
}

function searchComposeEmailRecipient(q) {
  q = String(q || '').trim();
  var w = document.getElementById('email-recipient-results');
  if (q.length < 2) {
    if (w) { w.innerHTML = ''; w.style.display = 'none'; }
    return;
  }
  if (ADMIN_D1_RECIPIENT_PICKER_ENABLED_) { _d1RecipientSearch_(q, 'email-recipient-results', 'email-recipient', 'selectEmailRecipient'); return; }
  var instant = _searchClientIdx(q);
  if (instant !== null) {
    if (!instant.length) {
      if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);">No clients found for "' + escHtml(q) + '"</div>'; w.style.display = 'block'; }
    } else {
      _renderRecipientResults('email-recipient-results', instant, 'selectEmailRecipient');
    }
    return;
  }
  if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);font-style:italic;">Loading contacts…</div>'; w.style.display = 'block'; }
  _ensureClientIdx(function() {
    var currentQ = (document.getElementById('email-recipient') || {}).value || '';
    if (currentQ.trim() !== q) return;
    var matches = _searchClientIdx(q);
    if (!matches || !matches.length) {
      if (w) { w.innerHTML = '<div class="compose-ac-item" style="color:var(--text-mid);">No clients found for "' + escHtml(q) + '"</div>'; w.style.display = 'block'; }
    } else {
      _renderRecipientResults('email-recipient-results', matches, 'selectEmailRecipient');
    }
  });
}

function selectEmailRecipient(idx) {
  var wrap = document.getElementById('email-recipient-results');
  if (!wrap || !wrap._matches) return;
  var c = wrap._matches[idx];
  document.getElementById('email-recipient').value = c.name || c.clientName || '';
  document.getElementById('email-recipient-id').value = c.rowIndex || '';
  window._emailRecipientUid = c.brideUid || '';
  var email = c.email || '';
  document.getElementById('email-recipient-addr').value = email;
  document.getElementById('email-to-display').value = email;
  window._emailBuilderRecipient = c;
  wrap.innerHTML = ''; wrap.style.display = 'none';
}

function emailComposeSetMode(mode) {
  var quillWrap = document.getElementById('email-quill-editor');
  var rawEl     = document.getElementById('email-html-raw');
  var prevEl    = document.getElementById('email-body-preview');
  var bodyEl    = document.getElementById('email-body');
  // Sync content from current mode before switching
  if (window._emailComposeMode === 'html' && rawEl && bodyEl) {
    bodyEl.value = rawEl.value;
    if (window.emailBuilderSetQuillHtml) window.emailBuilderSetQuillHtml(rawEl.value);
  } else if (window.emailBuilderSyncQuillToTextarea) {
    window.emailBuilderSyncQuillToTextarea();
  }
  window._emailComposeMode = mode;
  ['rich','html','preview'].forEach(function(m) {
    var btn = document.getElementById('email-mode-' + m);
    if (btn) btn.classList.toggle('active', m === mode);
  });
  // Rich Text
  if (quillWrap) quillWrap.style.display = mode === 'rich' ? '' : 'none';
  // HTML raw editor
  if (rawEl) {
    if (mode === 'html') {
      rawEl.value = bodyEl ? bodyEl.value : '';
      rawEl.style.display = '';
    } else {
      rawEl.style.display = 'none';
    }
  }
  // Preview iframe
  if (prevEl) {
    if (mode === 'preview') {
      var html = bodyEl ? bodyEl.value : '';
      var doc = prevEl.contentDocument || (prevEl.contentWindow && prevEl.contentWindow.document);
      if (doc) { doc.open(); doc.write(html || '<p style="font-family:sans-serif;color:#999;padding:2rem;">No content yet.</p>'); doc.close(); }
      prevEl.style.display = '';
    } else {
      prevEl.style.display = 'none';
    }
  }
}

function submitComposeEmail() {
  var clientId = document.getElementById('email-recipient-id').value;
  var emailAddr = document.getElementById('email-recipient-addr').value.trim();
  var subject = document.getElementById('email-subject').value.trim();
  if (window.emailBuilderSyncQuillToTextarea) window.emailBuilderSyncQuillToTextarea();
  var body = document.getElementById('email-body').value.trim();
  if (!clientId && !window._emailRecipientUid) { jvToast('Select a recipient first', 'error'); return; }
  if (!emailAddr) { jvToast('No email address for this contact', 'error'); return; }
  if (!body) { jvToast('Message cannot be empty', 'error'); return; }
  if (window.emailBuilderReplaceTokens) {
    subject = window.emailBuilderReplaceTokens(subject, window._emailBuilderRecipient || {});
    body = window.emailBuilderReplaceTokens(body, window._emailBuilderRecipient || {});
  }
  // Build context fields so the server can perform authoritative token substitution
  var _r = window._emailBuilderRecipient || {};
  var _emailCtx = {
    firstName:     _r.firstName     || _r.first_name || '',
    lastName:      _r.lastName      || _r.last_name  || '',
    name:          _r.name          || _r.clientName || '',
    email:         _r.email         || emailAddr,
    weddingDate:   _r.weddingDate   || _r.wedding_date || '',
    weddingLocation: _r.weddingLocation || _r.wedding_location || '',
    trialDate:     _r.trialDate     || _r.trial_date || '',
    proposalLink:  _r.proposalLink  || _r.proposal_link  || '',
    runsheetLink:  _r.runsheetLink  || _r.runsheet_link  || _r.runsheetUrl || '',
    artistName:    _r.assignedArtist || _r.artist_name   || '',
    total:         _r.total         || '',
    depositAmount: _r.depositAmount || _r.deposit_amount || '',
    balanceAmount: _r.balanceAmount || _r.balance_amount || '',
    bookingDate:   _r.bookingDate   || _r.booking_date   || '',
    token_context:  _r
  };
  var btn = document.getElementById('email-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  jvBridge.callAdmin('send_custom_email', Object.assign({
      token: STATE.token, bride_id: clientId, bride_email: emailAddr, brideUid: window._emailRecipientUid || '',
      to: emailAddr, subject: subject, html: body
    }, _emailCtx))
    .then(function(res) {
      if (btn) { btn.disabled = false; btn.textContent = 'Send Email'; }
      // P2.4 (pipeline brief, H4): honest toast via the shared helper. The old code showed
      // "Email sent successfully" on bare res.ok, even in safe mode (blocked at doPost) or
      // when deferred/rate-limited. jvActionToast only claims success on a real send.
      var r = jvActionToast(res, { successMsg: 'Email sent.' });
      if (r.success) {
        document.getElementById('email-subject').value = '';
        document.getElementById('email-body').value = '';
        if (window.emailBuilderSetQuillHtml) window.emailBuilderSetQuillHtml('');
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Send Email'; }
      jvToast('Error: ' + (err.message || String(err)), 'error');
    });
}

/* ============================================================
   CALENDAR — INLINE MODULE
   ============================================================ */
var CAL = { date: new Date(), events: [], artists: [] };

/* Calendar first paint WITHOUT a GAS call (2026-10-07, C1). Order: (1) localStorage copy of the last LIVE result for this
   month (24h), (2) the CDN island jv-calendar-cache (custom.admin_calendar_cache_json, GAS-written hourly, ~90 days from
   today). Either paints via the normal calOnEventsLoaded, then the live GAS read below refreshes in the BACKGROUND and
   repaints; a background failure never replaces painted content with an error. The island has no unassigned/assigned
   wedding panels (those stay live), so those fill in when the live read lands. */
var CAL_CACHE_KEY_ = 'jv_cal_cache_v1';
var CAL_CACHE_TTL_MS_ = 24 * 60 * 60 * 1000;
function calMonthKey_() { return CAL.date.getFullYear() + '-' + ('0' + (CAL.date.getMonth() + 1)).slice(-2); }
function calCacheRead_() {
  try {
    var raw = localStorage.getItem(CAL_CACHE_KEY_);
    if (!raw) return null;
    var c = JSON.parse(raw);
    if (!c || c.month !== calMonthKey_() || !c.payload || !c.payload.events) return null;
    if (Date.now() - (c.at || 0) > CAL_CACHE_TTL_MS_) return null;
    return c.payload;
  } catch (e) { return null; }
}
function calCacheWrite_(payload) {
  try { localStorage.setItem(CAL_CACHE_KEY_, JSON.stringify({ month: calMonthKey_(), at: Date.now(), payload: payload })); } catch (e) {}
}
function calIslandCoversMonth_(cached) {
  // the island holds today..+90d: only use it when it fully covers the month on screen's start (today's month)
  try {
    var first = calMonthKey_() + '-01';
    return !!(cached && cached.rangeStart && cached.rangeEnd && cached.rangeStart <= (new Date().toISOString().slice(0, 10)) && first <= cached.rangeEnd && calMonthKey_() === new Date().toISOString().slice(0, 7));
  } catch (e) { return false; }
}
function calPaintFromCache_(done) {
  var local = calCacheRead_();
  if (local) { try { calOnEventsLoaded({ data: local }); done(true); } catch (e) { done(false); } return; }
  try {
    adminCacheParseIsland_('jv-calendar-cache', function(cached) {
      if (cached && cached.success && cached.data && cached.data.events && calIslandCoversMonth_(cached)) {
        try { calOnEventsLoaded(cached); done(true); return; } catch (e) {}
      }
      done(false);
    });
  } catch (e) { done(false); }
}

function loadCalendarView() {
  if (!CAL.events.length) {
    if (CAL._loading) return; // a boot-time switch and the payload-driven switch can both land here: one fetch only
    CAL._loading = true;
    calPaintFromCache_(function(painted) { calFetchEvents({ background: painted }); });
  } else {
    calRender();
    showContent('calendar');
  }
}

function calNavMonth(dir) {
  CAL.date.setMonth(CAL.date.getMonth() + dir);
  calFetchEvents();
}

function calGoToday() {
  CAL.date = new Date();
  calFetchEvents();
}

/* ============================================================
   C4: Admin Calendar unassigned/assigned panels CF read (2026-10-07,
   Team App lane).

   Reads upcoming bookings + confirmed artist assignments from Cloudflare
   /admin/team-dispatch (same backend the Team Dispatch board at
   /pages/team-availability already runs on, zero GAS). Derives the four
   calendar panel arrays (unassigned, unassignedUpcoming, assigned,
   assignedUpcoming) client-side via deriveCalendarPanelArrays_ and merges
   them over the GAS-sourced panels after calOnEventsLoaded has painted.

   CF-overrides-when-CF-has-an-answer self-heal (same as P6 availability
   badges): a null / 5xx / malformed response leaves the GAS panels
   untouched, so a Worker regression cannot blank the panels.

   Flag: const JV_ADMIN_CALENDAR_UNASSIGNED_CF_ENABLED_ (default false),
   OR'd with window.JV_ADMIN_CRM_CF_CONFIG.calendarUnassignedReadEnabled
   from the liquid shop metafield hook.

   Scope + shadow + known gaps: state/findings/SCOPE-admin-calendar-wedding-
   panels-cf-2026-10-07.md.
   ============================================================ */

/**
 * Fetch upcoming bookings + confirmed artist assignments from Cloudflare
 * /admin/team-dispatch for the admin calendar panels. Uses captured native
 * fetch so a third-party monkey-patch of window.fetch cannot turn this into
 * a non-simple preflight the backend cannot serve.
 *
 * Returns a Promise that resolves to the raw CF response body on 200, or
 * null on any transport error / non-200 / malformed shape (caller treats
 * null as "CF had nothing" and keeps the GAS-sourced panels, same self-heal
 * pattern as loadAvailabilityForBride_ in jv-runsheet-builder.js).
 *
 * `from` / `to` MUST be YYYY-MM-DD; the Worker clamps the range at 168 days.
 * 8s timeout, no retry on 5xx -- a transient dispatch failure must not be
 * hammered 3x on a hot admin workspace open.
 */
/**
 * Rollout flag for the CF admin-calendar panels. Default OFF.
 *
 * Flip plan (per DEPLOY-admin-calendar-panels-cf-2026-10-07.md): shadow pass per
 * state/findings/SCOPE-admin-calendar-wedding-panels-cf-2026-10-07.md §5, then
 * Jess flips shop metafield custom.admin_calendar_unassigned_cf_read to true.
 * Rollback: flip the metafield back to false; no theme push required.
 */
var JV_ADMIN_CALENDAR_UNASSIGNED_CF_ENABLED_ = false;

function adminCalendarUnassignedCFEnabled_() {
  if (JV_ADMIN_CALENDAR_UNASSIGNED_CF_ENABLED_) return true;
  try {
    var cfg = window.JV_ADMIN_CRM_CF_CONFIG || {};
    return cfg.calendarUnassignedReadEnabled === true || String(cfg.calendarUnassignedReadEnabled) === 'true';
  } catch (e) { return false; }
}

/**
 * Derive the four panel arrays (unassigned, unassignedUpcoming, assigned,
 * assignedUpcoming) that calOnEventsLoaded consumes, from the CF /admin/team-
 * dispatch bookings[] response. In-month = within [rangeStart, rangeEnd];
 * the *Upcoming variants cover the full 168-day CF window and only populate
 * when the admin's "All upcoming" toggle is on (matches the GAS payload shape).
 */
function deriveCalendarPanelArrays_(bookings, rangeStart, rangeEnd, allUpcoming) {
  var rows = Array.isArray(bookings) ? bookings : [];
  var inRange = function (b) { return b && b.date && b.date >= rangeStart && b.date <= rangeEnd; };
  var isUnassigned = function (b) { return !b.artists || b.artists.length === 0; };
  var isAssigned = function (b) { return b.artists && b.artists.length > 0; };
  var monthRows = rows.filter(inRange);
  return {
    unassigned:         monthRows.filter(isUnassigned),
    assigned:           monthRows.filter(isAssigned),
    unassignedUpcoming: allUpcoming ? rows.filter(isUnassigned) : [],
    assignedUpcoming:   allUpcoming ? rows.filter(isAssigned)   : []
  };
}

/**
 * CF-overrides-when-CF-has-an-answer: a successful CF response replaces the
 * four CAL panel arrays; a null / malformed body is a no-op so the GAS-sourced
 * panels remain. Same self-heal pattern as P1 (poll chips) + P6 (runsheet
 * badges). Re-renders the Unassigned panel only; `calRender()` runs on month
 * events so the grid doesn't double-paint.
 */
function mergeCFCalendarPanels_(cfBody, opts) {
  if (!cfBody || !cfBody.data || !Array.isArray(cfBody.data.bookings)) return;
  var panels = deriveCalendarPanelArrays_(cfBody.data.bookings, opts.start, opts.end, !!opts.allUpcoming);
  CAL.unassigned         = panels.unassigned;
  CAL.unassignedUpcoming = panels.unassignedUpcoming;
  CAL.assigned           = panels.assigned;
  CAL.assignedUpcoming   = panels.assignedUpcoming;
  try { calRenderUnassigned(); } catch (e) { /* non-fatal; next toggle re-renders */ }
}

function loadTeamDispatchForCalendar_(range) {
  var from = String(range && range.from || '').trim();
  var to = String(range && range.to || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to)) return Promise.resolve(null);
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var controller = (typeof AbortController === 'function') ? new AbortController() : null;
  var timeoutId = controller ? setTimeout(function () { try { controller.abort(); } catch (e) {} }, 8000) : null;
  var fetchOpts = { method: 'GET', credentials: 'include' };
  if (controller) fetchOpts.signal = controller.signal;
  var url = '/apps/jv-api-v2/partner/admin-team-dispatch/read?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to);
  return nf(url, fetchOpts)
    .then(function (r) {
      if (timeoutId) clearTimeout(timeoutId);
      if (!r || !r.ok) return null;
      return r.json();
    })
    .then(function (body) {
      if (!body || body.ok === false) return null;
      if (!body.data || !Array.isArray(body.data.bookings)) return null;
      return body;
    })
    .catch(function () { if (timeoutId) clearTimeout(timeoutId); return null; });
}

function calFetchEvents(opts) {
  var background = !!(opts && opts.background);
  if (!background) showLoader('calendar');
  var y = CAL.date.getFullYear(), m = CAL.date.getMonth();
  var start = new Date(y, m, 1).toISOString().split('T')[0];
  var end   = new Date(y, m + 1, 0).toISOString().split('T')[0];
  var allUpcomingToggle = document.getElementById('calAllUpcomingToggle');
  var allUpcoming = allUpcomingToggle ? allUpcomingToggle.checked : false;
  var monthAtSend = calMonthKey_();
  // noRetryOn5xx (C2, per-call opt-in): a relay 502/504 on this expensive read must not be re-run 2-3 more times on GAS.
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getCalendarEvents', args: { start: start, end: end, allUpcoming: allUpcoming, token: STATE.token || sessionStorage.getItem('jv_session_token') || '' } }, { noRetryOn5xx: true })
    .then(function(res) {
      CAL._loading = false;
      if (res.ok) {
        if (monthAtSend !== calMonthKey_()) return; // the admin navigated to another month meanwhile
        var inner = res.data && (res.data.data || res.data);
        if (!allUpcoming && inner && inner.events) calCacheWrite_(inner);
        calOnEventsLoaded(res.data);
        // C4: CF panels override. GAS panels are painted above; this fires only when the
        // flag is on, overrides the four CAL arrays on success, no-ops on null/5xx (GAS
        // panels stay). Guard against mid-flight month-nav on both sides of the async hop.
        if (adminCalendarUnassignedCFEnabled_()) {
          var _cfMonthAtFire = monthAtSend;
          loadTeamDispatchForCalendar_({ from: start, to: end }).then(function (cfBody) {
            if (!cfBody) return;
            if (_cfMonthAtFire !== calMonthKey_()) return; // calendar moved on
            mergeCFCalendarPanels_(cfBody, { start: start, end: end, allUpcoming: allUpcoming });
          });
        }
      } else if (!background) {
        showError('calendar', (res.error && res.error.message) || String(res.error));
      }
    })
    .catch(function(err) { CAL._loading = false; if (!background) showError('calendar', (err && err.message) || String(err)); });
}

function calOnEventsLoaded(result) {
  if (!result) { showError('calendar', 'No response received.'); return; }
  if (result.status === 'error' || result.success === false) {
    showError('calendar', result.message || result.error || 'Server error.');
    return;
  }
  var payload = result.data || result;
  if (!payload.events) { showError('calendar', 'Unexpected response format.'); return; }
  CAL.events = payload.events || [];
  CAL.unassigned = payload.unassigned || [];
  CAL.unassignedUpcoming = payload.unassignedUpcoming || [];
  // FIX 2 (2026-07-10): already-teamed weddings so the panel can offer "Edit team".
  CAL.assigned = payload.assigned || [];
  CAL.assignedUpcoming = payload.assignedUpcoming || [];

  // Merge this month's event artists with the static full roster so the filter
  // shows every artist even if they have no events in the current month.
  var fullRoster = ['Jessica','Alana','Belinda','Dani','Emma','Jessy','Jill','Kaelin','Krystel','Layne','Mia','Michelle','Sofia'];
  var merged = {};
  fullRoster.forEach(function(n) { merged[n] = true; });
  (payload.artists || []).forEach(function(n) { merged[n] = true; });
  CAL.artists = Object.keys(merged).sort();

  var sel = document.getElementById('calArtistFilter');
  if (sel) {
    var cur = sel.value;
    sel.innerHTML = '<option value="">All Artists</option>';
    CAL.artists.forEach(function(a) {
      sel.innerHTML += '<option value="' + escHtml(a) + '"' + (a === cur ? ' selected' : '') + '>' + escHtml(a) + '</option>';
    });
  }

  calRender();
  calRenderUnassigned();
  showContent('calendar');
}

/* Toggle the "Weddings needing staff" right-side panel */
function calTogglePanel() {
  var layout = document.querySelector('#view-calendar .cal-layout');
  var btn = document.getElementById('calPanelToggle');
  if (!layout) return;
  var collapsed = layout.classList.toggle('panel-collapsed');
  if (btn) btn.textContent = collapsed ? 'Show panel' : 'Hide panel';
}

/* Toggle between this-month-only and all upcoming unassigned weddings */
function calToggleAllUpcoming(checked) {
  calFetchEvents();
}

/* ===== UNASSIGNED WEDDINGS PANEL ===== */

function calRenderUnassigned() {
  var list = document.getElementById('calUnassignedList');
  var count = document.getElementById('calUnassignedCount');
  if (!list || !count) return;

  var allUpcomingToggle = document.getElementById('calAllUpcomingToggle');
  var useAllUpcoming = allUpcomingToggle && allUpcomingToggle.checked;
  var items = useAllUpcoming ? ((CAL && CAL.unassignedUpcoming) || []) : ((CAL && CAL.unassigned) || []);
  count.textContent = String(items.length);
  count.setAttribute('data-empty', items.length === 0 ? 'true' : 'false');

  if (items.length === 0) {
    list.innerHTML = '<div class="cal-unassigned-empty">All booked weddings this month have a team.</div>';
    return;
  }

  var html = items.map(function(b) {
    var venue = b.venueShort || b.venue || '';
    var dateLabel = b.weddingDateDisplay || b.weddingDate || '';
    return '' +
      '<div class="cal-unassigned-item" data-bride-id="' + escHtml(String(b.brideId)) + '">' +
        '<div class="cal-unassigned-date">' + escHtml(dateLabel) + '</div>' +
        '<div class="cal-unassigned-name">' + escHtml(b.brideName || 'Unknown') + '</div>' +
        (venue ? '<div class="cal-unassigned-venue">' + escHtml(venue) + '</div>' : '') +
        '<div class="cal-unassigned-actions">' +
          '<button class="cal-unassigned-btn secondary" onclick="calAssignOpen(' + b.brideId + ', \'poll\')">Run poll</button>' +
          '<button class="cal-unassigned-btn" onclick="calAssignOpen(' + b.brideId + ', \'assign\')">Assign team</button>' +
        '</div>' +
      '</div>';
  }).join('');

  // FIX 2 (2026-07-10): also list ALREADY-teamed weddings with an "Edit team"
  // action, so staff can be changed and re-invited from the calendar at any time.
  // Previously teamed brides vanished from this panel and could never be
  // re-allocated here.
  var assignedItems = useAllUpcoming ? ((CAL && CAL.assignedUpcoming) || []) : ((CAL && CAL.assigned) || []);
  if (assignedItems.length) {
    html += '<div class="cal-unassigned-subhead" style="margin-top:14px;padding-top:12px;border-top:1px solid var(--brand-border,#e6dad4);font-size:12px;font-weight:600;color:var(--brand-text-muted,#9a918a);text-transform:uppercase;letter-spacing:0.04em;">Assigned (change team)</div>';
    html += assignedItems.map(function(b) {
      var venue = b.venueShort || b.venue || '';
      var dateLabel = b.weddingDateDisplay || b.weddingDate || '';
      return '' +
        '<div class="cal-unassigned-item is-assigned" data-bride-id="' + escHtml(String(b.brideId)) + '">' +
          '<div class="cal-unassigned-date">' + escHtml(dateLabel) + '</div>' +
          '<div class="cal-unassigned-name">' + escHtml(b.brideName || 'Unknown') + '</div>' +
          (b.team ? '<div class="cal-unassigned-team" style="font-size:12px;color:var(--brand-primary-deep,#a9706c);">' + escHtml(b.team) + '</div>' : '') +
          (venue ? '<div class="cal-unassigned-venue">' + escHtml(venue) + '</div>' : '') +
          '<div class="cal-unassigned-actions">' +
            '<button class="cal-unassigned-btn secondary" onclick="calAssignOpen(' + b.brideId + ', \'poll\')">Run poll</button>' +
            '<button class="cal-unassigned-btn" onclick="calAssignOpen(' + b.brideId + ', \'assign\')">Edit team</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  list.innerHTML = html;
}

/* ===== ASSIGN DRAWER ===== */

var CAL_ASSIGN = { brideId: null, mode: 'assign', bride: null };

function calAssignOpen(brideId, mode) {
  var bride = ((CAL.unassigned || [])
    .concat(CAL.unassignedUpcoming || [])
    .concat(CAL.assigned || [])
    .concat(CAL.assignedUpcoming || []))
    .find(function(b) { return b.brideId === brideId; });
  if (!bride) return;

  CAL_ASSIGN.brideId = brideId;
  CAL_ASSIGN.mode = mode || 'assign';
  CAL_ASSIGN.bride = bride;

  var title = document.getElementById('calAssignTitle');
  var meta = document.getElementById('calAssignMeta');
  var result = document.getElementById('calAssignResult');
  var _dateLabel = escHtml(bride.weddingDateDisplay || bride.weddingDate || '');
  if (title) title.textContent = (mode === 'poll' ? 'Run availability poll' : 'Assign team') + ' — ' + (bride.brideName || '');
  if (meta) {
    meta.innerHTML =
      '<strong>' + _dateLabel + '</strong>' +
      (bride.venue ? '<br>' + escHtml(bride.venue) : '') +
      (bride.services ? '<br><span style="opacity:0.8">' + escHtml(bride.services) + '</span>' : '');
    // Always show date even when meta has no venue/services
    if (!_dateLabel) meta.innerHTML = '<span style="color:var(--brand-text-muted);font-size:12px;">Date not set</span>';
  }
  if (result) { result.className = 'cal-assign-result'; result.textContent = ''; }

  calAssignPopulateArtists();
  calAssignLoadPollStatus();

  var drawer = document.getElementById('calAssignDrawer');
  if (drawer) drawer.classList.add('open');

  var submitBtn = document.getElementById('calAssignSubmitBtn');
  var pollBtn = document.getElementById('calAssignPollBtn');
  if (mode === 'poll') {
    if (submitBtn) submitBtn.style.display = 'none';
    if (pollBtn) pollBtn.textContent = 'Fire availability poll';
  } else {
    if (submitBtn) { submitBtn.style.display = ''; submitBtn.disabled = true; submitBtn.style.opacity = '0.5'; submitBtn.style.cursor = 'not-allowed'; }
    if (pollBtn) pollBtn.textContent = 'Fire poll first';
  }
}

function calAssignClose() {
  var drawer = document.getElementById('calAssignDrawer');
  if (drawer) drawer.classList.remove('open');
  CAL_ASSIGN.brideId = null;
  CAL_ASSIGN.bride = null;
}

function calAssignPopulateArtists() {
  var leadSel = document.getElementById('calAssignLead');
  var assistWrap = document.getElementById('calAssignAssistants');
  if (!leadSel || !assistWrap) return;

  var names = (CAL && CAL.artists) ? CAL.artists.slice() : [];
  if (names.length === 0) {
    leadSel.innerHTML = '<option value="">Choose lead…</option>';
    assistWrap.innerHTML = '<p style="font-size:12px;color:var(--brand-text-muted);padding:4px 0;">Team list could not load. Refresh to try again.</p>';
    return;
  }
  names.sort();

  leadSel.innerHTML = '<option value="">Choose lead…</option>' + names.map(function(n) {
    return '<option value="' + escHtml(n) + '">' + escHtml(n) + '</option>';
  }).join('');
  leadSel.onchange = function() {
    var btn = document.getElementById('calAssignSubmitBtn');
    if (btn) {
      var hasLead = !!leadSel.value;
      btn.disabled = !hasLead;
      btn.style.opacity = hasLead ? '' : '0.5';
      btn.style.cursor = hasLead ? '' : 'not-allowed';
    }
  };

  assistWrap.innerHTML = names.map(function(n) {
    return '<label><input type="checkbox" value="' + escHtml(n) + '"> ' + escHtml(n) + '</label>';
  }).join('');
}

/* Poll SEND via the Worker (2026-10-07, availability-poll P4-B). Flag OFF. When ON (and the Worker's own flags allow it) the
   click goes to /partner/admin-poll-send/send, which records the poll + recipients in D1, applies quiet hours / closed /
   archived / safe mode, and only then asks GAS to deliver. FALLBACK RULE (never a double send): the page falls back to the GAS
   route ONLY when the Worker proves it did nothing (503 disabled, 400/404/409 bride not resolved). A network failure or any
   other error is shown as "could not confirm", never retried through GAS. Remaining GAS dependency: delivery itself. */
var ADMIN_POLL_SEND_WORKER_ENABLED_ = false;
function calSydneyDateIso_(isoLike) {
  try {
    var d = new Date(isoLike);
    if (isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  } catch (e) { return ''; }
}
function calAssignPollViaWorker_(resultEl) {
  var base = window._jvAdminProxyBase;
  var br = CAL_ASSIGN.bride || {};
  var weddingDate = calSydneyDateIso_(br.date);
  if (!ADMIN_POLL_SEND_WORKER_ENABLED_ || !base || !br.brideName || !weddingDate) return Promise.resolve({ fallback: true });
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var bucket = Math.floor(Date.now() / 300000); // a double click inside 5 minutes replays the same send
  return nf(String(base).replace(/\/+$/, '') + '/partner/admin-poll-send/send', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ brideName: br.brideName, weddingDate: weddingDate, idempotencyKey: 'pollsend:' + br.brideName + ':' + weddingDate + ':' + bucket })
  }).then(function(r) {
    return r.json().catch(function() { return null; }).then(function(b) { return { status: r.status, body: b }; });
  }).then(function(o) {
    var b = o.body || {};
    if (o.status === 503 || o.status === 400 || o.status === 404 || o.status === 409) return { fallback: true }; // Worker did nothing
    if (b.ok === true && b.sent) return { done: true, message: b.message || 'Availability poll sent to the team.' };
    if (b.ok === false && b.notSent) return { done: true, error: b.error || 'The poll was NOT sent.' };
    return { done: true, error: 'Could not confirm the poll was sent. Check the poll status below before sending again.' };
  }).catch(function() {
    return { done: true, error: 'Could not confirm the poll was sent. Check the poll status below before sending again.' };
  });
}

function calAssignFirePoll() {
  if (!CAL_ASSIGN.brideId) return;
  var resultEl = document.getElementById('calAssignResult');
  if (resultEl) { resultEl.className = 'cal-assign-result info'; resultEl.textContent = 'Firing availability poll…'; }

  calAssignPollViaWorker_(resultEl).then(function(w) {
    if (w && w.done) {
      if (resultEl) {
        resultEl.className = 'cal-assign-result ' + (w.error ? 'error' : 'success');
        resultEl.textContent = w.error || w.message;
      }
      calAssignLoadPollStatus();
      return;
    }
    calAssignFirePollViaGas_(resultEl);
  });
}

function calAssignFirePollViaGas_(resultEl) {
  jvBridge.callAdmin('bridge_admin_generic', {
    'function': 'adminCrm_assignWeddingTeam',
    args: { brideId: CAL_ASSIGN.brideId, action: 'poll' }
  }).then(function(res) {
    if (!res || !res.ok) {
      if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = (res && res.error) || 'Poll failed.'; }
      return;
    }
    var data = res.data || {};
    if (data.ok === false) {
      if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = data.error || 'Poll failed.'; }
      return;
    }
    if (resultEl) {
      resultEl.className = 'cal-assign-result success';
      resultEl.textContent = data.message || 'Availability poll sent to the team.';
    }
    // The assign endpoint already returns the current response shape,
    // so we can repaint the chips without an extra round-trip.
    if (data.pollState) {
      calAssignRenderPollStatus(data.pollState);
    } else {
      calAssignLoadPollStatus();
    }
  }).catch(function(err) {
    if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = (err && err.message) || String(err); }
  });
}

/* ============================================================
   POLL STATUS PANEL (admin assign drawer)
   Fetches the current availability responses for the open bride
   and paints a four-group chip layout above the Lead selector.
   ============================================================ */
/* Poll chips first paint from D1 (2026-10-07, availability-poll P1). Flag OFF. When ON, the chips paint from the
   admin-poll-status relay entity (jv-crm-mirror POST /admin/poll-status) the moment it returns, THEN the Apps Script
   sheet read still lands and overwrites it: the sheet is the truth and the sheet->D1 mirror is hourly, so a D1-only view
   could miss an answer given in the last hour. A D1 miss, a poll not mirrored yet, or a slower-than-GAS reply never
   paints. Remaining GAS dependency: the sheet read (truth) until the poll answer path is event-driven into D1.
   Metafield-gated 2026-10-26 (Sub-C), same pattern as ASSIGN_WARNINGS_POLL_CF_ENABLED_ below: driven by the
   Shopify shop metafield custom.admin_poll_status_d1_enabled, emitted by sections/jv-admin-crm.liquid as
   window.ADMIN_POLL_STATUS_D1_READ_FLAG_ BEFORE this asset loads. Default OFF (false) if the metafield is
   absent or anything other than true, behaviour unchanged until Jess explicitly flips it, no code deploy needed. */
var ADMIN_POLL_STATUS_D1_ENABLED_ = (window.ADMIN_POLL_STATUS_D1_READ_FLAG_ === true);
/* Assign-time availability warnings from CF (Sub-A2/Sub-C, 2026-10-21). Flag OFF. Driven by the Shopify shop metafield
   custom.team_cf_assign_warnings_poll_read, emitted by sections/jv-admin-crm.liquid as window.JV_ASSIGN_WARNINGS_POLL_CF_FLAG.
   ON: after the assign call succeeds, the "marked themselves NOT available" list is rebuilt from the jv-crm-mirror poll read
   (assets/jv-assign-warnings-poll.js, same text and rule as StudioScheduleAPI.gs). Anything unusable (no proxy base, asset not
   loaded, timeout, pollMirrored not true, bad shape) keeps the GAS-computed data.pollWarnings. Advisory only: the assignment
   has already succeeded, this never blocks or delays it by more than the 4s read timeout. */
var ASSIGN_WARNINGS_POLL_CF_ENABLED_ = (window.JV_ASSIGN_WARNINGS_POLL_CF_FLAG === true);
function calAssignResolvePollWarnings_(brideName, artistNames, gasWarnings) {
  var base = window._jvAdminProxyBase;
  var M = window.JVAssignWarningsPoll;
  if (!ASSIGN_WARNINGS_POLL_CF_ENABLED_ || !base || !brideName || !M || typeof M.resolveWarnings !== 'function') {
    return Promise.resolve(gasWarnings);
  }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var read = nf(String(base).replace(/\/+$/, '') + '/partner/admin-poll-status/read', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ brideName: brideName })
  }).then(function(r) { return r.json(); });
  var timeout = new Promise(function(resolve) { setTimeout(function() { resolve(null); }, 4000); });
  return Promise.race([read, timeout]).then(function(body) {
    return M.resolveWarnings(body, artistNames, gasWarnings);
  }).catch(function() { return gasWarnings; });
}
function calAssignLoadPollStatus() {
  if (!CAL_ASSIGN.brideId || !CAL_ASSIGN.bride) return;
  var brideName = CAL_ASSIGN.bride.brideName || '';
  if (!brideName) return;
  var forBride = CAL_ASSIGN.brideId;
  var gasPainted = false;

  var base = window._jvAdminProxyBase;
  if (ADMIN_POLL_STATUS_D1_ENABLED_ && base) {
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    nf(String(base).replace(/\/+$/, '') + '/partner/admin-poll-status/read', {
      method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ brideName: brideName })
    }).then(function(r) { return r.json(); }).then(function(b) {
      if (!b || b.ok !== true || b.pollMirrored === false || gasPainted || CAL_ASSIGN.brideId !== forBride) return;
      calAssignRenderPollStatus(b);
    }).catch(function() { /* silent: the sheet read below is the truth */ });
  }

  jvBridge.callAdmin('bridge_admin_generic', {
    'function': 'team_app_get_availability',
    args: { bride_name: brideName }
  }).then(function(res) {
    if (!res || !res.ok) return;
    if (CAL_ASSIGN.brideId !== forBride) return;
    gasPainted = true;
    var data = res.data || {};
    calAssignRenderPollStatus(data);
  }).catch(function() { /* silent */ });
}

function calAssignRenderPollStatus(state) {
  var panel = document.getElementById('calAssignPollStatus');
  if (!panel) return;

  var responses = (state && state.responses) || [];
  var pending = (state && state.pendingArtists) || [];
  var total = (state && state.totalArtists) || (responses.length + pending.length);

  if (responses.length === 0 && pending.length === 0) {
    panel.style.display = 'none';
    return;
  }

  var buckets = { AVAILABLE: [], MAYBE: [], UNAVAILABLE: [] };
  responses.forEach(function(r) {
    var key = String(r.response || '').toUpperCase();
    if (buckets[key]) buckets[key].push(r.artistName || '');
  });

  function paint(id, names, variant) {
    var el = document.getElementById(id);
    if (!el) return;
    if (!names.length) {
      el.innerHTML = '<span class="cal-poll-chip is-empty">—</span>';
      return;
    }
    el.innerHTML = names.map(function(n) {
      return '<span class="cal-poll-chip is-' + variant + '">' + escHtml(n) + '</span>';
    }).join('');
  }

  paint('calAssignPollAvailable', buckets.AVAILABLE, 'available');
  paint('calAssignPollMaybe', buckets.MAYBE, 'maybe');
  paint('calAssignPollUnavailable', buckets.UNAVAILABLE, 'unavailable');
  paint('calAssignPollPending', pending, 'pending');

  var summaryEl = document.getElementById('calAssignPollSummary');
  if (summaryEl) {
    summaryEl.textContent = responses.length + ' of ' + total + ' responded';
  }

  panel.style.display = '';
}

function calAssignSubmit() {
  if (!CAL_ASSIGN.brideId) return;
  var leadSel = document.getElementById('calAssignLead');
  var lead = leadSel ? leadSel.value : '';
  if (!lead) {
    var resultEl0 = document.getElementById('calAssignResult');
    if (resultEl0) { resultEl0.className = 'cal-assign-result error'; resultEl0.textContent = 'Please choose a lead artist.'; }
    return;
  }
  var assistants = [];
  document.querySelectorAll('#calAssignAssistants input[type="checkbox"]:checked').forEach(function(cb) {
    if (cb.value && cb.value.toLowerCase() !== lead.toLowerCase()) assistants.push(cb.value);
  });

  var resultEl = document.getElementById('calAssignResult');
  if (resultEl) { resultEl.className = 'cal-assign-result info'; resultEl.textContent = 'Assigning team and sending invites…'; }

  jvBridge.callAdmin('bridge_admin_generic', {
    'function': 'adminCrm_assignWeddingTeam',
    args: { brideId: CAL_ASSIGN.brideId, action: 'assign', leadArtist: lead, assistants: assistants }
  }).then(function(res) {
    if (!res || !res.ok) {
      if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = (res && res.error) || 'Assignment failed.'; }
      return;
    }
    var data = res.data || {};
    if (data.ok === false) {
      if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = data.error || 'Assignment failed.'; }
      return;
    }
    var gasPollWarnings = Array.isArray(data.pollWarnings) ? data.pollWarnings : [];
    var assignBrideName = (CAL_ASSIGN.bride && CAL_ASSIGN.bride.brideName) || '';
    return calAssignResolvePollWarnings_(assignBrideName, [lead].concat(assistants), gasPollWarnings).then(function(pollWarnings) {
    if (resultEl) {
      // FIX 3 (2026-07-10): honest reporting. If the calendar invite did not land
      // (calendarSynced === false), show a warning, not a green success.
      var calFailed = (data.calendarSynced === false);
      // Poll-advisory warning (2026-10-02, roadmap item 3 -- Jess's explicit
      // decision: warn, never hard-block). Non-blocking: the assignment above
      // has ALREADY succeeded by the time this paints -- this only tells the
      // admin to double-check, it never prevented the assign call itself.
      // calFailed (a real failure) still wins the colour if both are present.
      resultEl.className = calFailed
        ? 'cal-assign-result error'
        : (pollWarnings.length ? 'cal-assign-result warning' : 'cal-assign-result success');
      var msg = data.message || 'Team assigned.';
      if (data.runsheetBuilderUrl) {
        msg += ' <a href="' + escHtml(data.runsheetBuilderUrl) + '" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;font-weight:600;">Build runsheet now →</a>';
      }
      if (pollWarnings.length) {
        msg += '<br><strong>Availability check:</strong> ' + pollWarnings.map(escHtml).join(' ');
      }
      resultEl.innerHTML = msg;
    }
    setTimeout(function() {
      calFetchEvents();
    }, 900);
    });
  }).catch(function(err) {
    if (resultEl) { resultEl.className = 'cal-assign-result error'; resultEl.textContent = (err && err.message) || String(err); }
  });
}

function calPad(n) { return n < 10 ? '0' + n : '' + n; }

function calRender() {
  var y = CAL.date.getFullYear(), m = CAL.date.getMonth();
  var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  document.getElementById('calMonthLabel').textContent = months[m] + ' ' + y;

  var artistVal = document.getElementById('calArtistFilter').value;
  var typeVal   = document.getElementById('calTypeFilter').value;
  var filtered = CAL.events.filter(function(e) {
    if (artistVal) {
      // Match against the full artists array if present, fall back to single .artist
      var pool = (e.artists && e.artists.length) ? e.artists : (e.artist ? [e.artist] : []);
      var hit = false;
      for (var ai = 0; ai < pool.length; ai++) {
        if (pool[ai] === artistVal) { hit = true; break; }
      }
      if (!hit) return false;
    }
    if (typeVal && e.type !== typeVal) return false;
    return true;
  });

  var eventMap = {};
  filtered.forEach(function(e) {
    if (!eventMap[e.date]) eventMap[e.date] = [];
    eventMap[e.date].push(e);
  });

  var firstDay  = new Date(y, m, 1);
  var startDay  = (firstDay.getDay() + 6) % 7; // Monday = 0
  var daysInMo  = new Date(y, m + 1, 0).getDate();
  var now       = new Date();
  var todayStr  = now.getFullYear() + '-' + calPad(now.getMonth() + 1) + '-' + calPad(now.getDate());

  var cells = '';
  var total = Math.ceil((startDay + daysInMo) / 7) * 7;

  for (var i = 0; i < total; i++) {
    var dayNum = i - startDay + 1;
    var isOut  = dayNum < 1 || dayNum > daysInMo;
    var dateStr, display;

    if (!isOut) {
      dateStr = y + '-' + calPad(m + 1) + '-' + calPad(dayNum);
      display = dayNum;
    } else {
      var alt = new Date(y, m, dayNum);
      dateStr = alt.getFullYear() + '-' + calPad(alt.getMonth() + 1) + '-' + calPad(alt.getDate());
      display = alt.getDate();
    }

    var isToday = dateStr === todayStr;
    var cls = 'cal-day' + (isOut ? ' outside' : '') + (isToday ? ' today' : '');

    var chips = '';
    if (eventMap[dateStr]) {
      var dayEvts = eventMap[dateStr];
      var maxVisible = 2;
      var showEvts = dayEvts.slice(0, maxVisible);
      var hiddenCount = dayEvts.length - showEvts.length;
      showEvts.forEach(function(ev) {
        chips += '<div class="cal-event-chip ' + (ev.type || 'wedding') + '" onclick="calShowEvent(\'' + escHtml(ev.id) + '\')">' + escHtml(ev.title) + '</div>';
      });
      if (hiddenCount > 0) {
        chips += '<button class="event-chip-more" onclick="calShowDayEvents(\'' + dateStr + '\')">+ ' + hiddenCount + ' more</button>';
      }
    }

    cells += '<div class="' + cls + '"><div class="cal-day-num">' + display + '</div>' + chips + '</div>';
  }

  document.getElementById('calDays').innerHTML = cells;
}

/* Show all events for a given date (used by "+ N more" overflow chip) */
function calShowDayEvents(dateStr) {
  var evts = CAL.events.filter(function(e) { return e.date === dateStr; });
  if (!evts.length) return;
  // Reuse the existing event overlay but list all events for that day
  document.getElementById('calEventTitle').textContent = dateStr;
  var rows = evts.map(function(ev) {
    return '<div style="padding:0.4rem 0;border-bottom:1px solid var(--line);">' +
      '<strong style="font-size:0.85rem;">' + escHtml(ev.title) + '</strong>' +
      (ev.time ? '<span style="margin-left:0.5rem;font-size:0.75rem;color:var(--muted);">' + escHtml(ev.time) + '</span>' : '') +
      (ev.venue ? '<div style="font-size:0.75rem;color:var(--muted);">' + escHtml(ev.venue) + '</div>' : '') +
    '</div>';
  }).join('');
  document.getElementById('calEventRows').innerHTML = rows;
  document.getElementById('calEventOverlay').classList.add('open');
}

function calShowEvent(eventId) {
  var ev = CAL.events.find(function(e) { return e.id === eventId; });
  if (!ev) return;
  document.getElementById('calEventTitle').textContent = calStripTags_(ev.title);
  var rows = '';
  if (ev.brideName)    rows += calEdRow('Bride', ev.brideName);
  if (ev.date)         rows += calEdRow('Date', ev.date);
  if (ev.time)         rows += calEdRow('Time', ev.time);
  if (ev.venue)        rows += calEdRow('Venue', ev.venue);
  if (ev.assignedTeam) rows += calEdRow('Team', ev.assignedTeam);
  if (ev.artist)       rows += calEdRow('Artist', ev.artist);
  if (ev.type)         rows += calEdRow('Type', ev.type.charAt(0).toUpperCase() + ev.type.slice(1));
  document.getElementById('calEventRows').innerHTML = rows;
  document.getElementById('calEventOverlay').classList.add('open');
}

function calStripTags_(s) {
  if (!s) return '';
  var text = String(s)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/?(p|div|tr|li)[^>]*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return text;
}

function calEdRow(label, value) {
  var clean = calStripTags_(value);
  var LONG_THRESHOLD = 140;
  if (clean.length > LONG_THRESHOLD) {
    var rowId = 'calEdRow-' + Math.random().toString(36).slice(2, 9);
    return '<div class="cal-ed-row cal-ed-row--block">' +
      '<span class="cal-ed-label">' + escHtml(label) + '</span>' +
      '<div class="cal-ed-value cal-ed-value--clamp" id="' + rowId + '">' + escHtml(clean) + '</div>' +
      '<button class="cal-ed-more" onclick="calEdToggleMore(\'' + rowId + '\', this)">Show more</button>' +
      '</div>';
  }
  return '<div class="cal-ed-row"><span class="cal-ed-label">' + escHtml(label) + '</span><span class="cal-ed-value">' + escHtml(clean) + '</span></div>';
}

function calEdToggleMore(rowId, btn) {
  var el = document.getElementById(rowId);
  if (!el) return;
  var expanded = el.classList.toggle('cal-ed-value--expanded');
  if (btn) btn.textContent = expanded ? 'Show less' : 'Show more';
}

function calCloseEvent(e) { if (e.target === document.getElementById('calEventOverlay')) calCloseEventForce(); }
function calCloseEventForce() { document.getElementById('calEventOverlay').classList.remove('open'); }

/* ============================================================
   STUDIO SCHEDULE — TEAM DEPLOYMENT CALENDAR
   ============================================================ */
var SCHED = { view: 'day', date: null, data: null, hourStart: 5, hourEnd: 19 };

function loadStudioBookingView() {
  if (!SCHED.date) SCHED.date = new Date();
  schedFetchAndRender();
}

function schedSwitchView(v) {
  SCHED.view = v;
  document.querySelectorAll('.sched-toolbar .btn-group button').forEach(function(b){ b.classList.remove('active'); });
  var btn = document.getElementById('sched-btn-' + v);
  if (btn) btn.classList.add('active');
  schedFetchAndRender();
}

function schedNav(dir) {
  var d = new Date(SCHED.date);
  if (SCHED.view === 'day') d.setDate(d.getDate() + dir);
  else if (SCHED.view === 'week') d.setDate(d.getDate() + 7 * dir);
  else d.setMonth(d.getMonth() + dir);
  SCHED.date = d;
  schedFetchAndRender();
}

function schedGoToday() {
  SCHED.date = new Date();
  schedFetchAndRender();
}

function schedDateRange_() {
  var d = new Date(SCHED.date);
  if (SCHED.view === 'day') {
    return { start: schedFmt_(d), end: schedFmt_(d) };
  } else if (SCHED.view === 'week') {
    var dow = d.getDay(); var mon = new Date(d); mon.setDate(d.getDate() - ((dow + 6) % 7));
    var sun = new Date(mon); sun.setDate(mon.getDate() + 6);
    return { start: schedFmt_(mon), end: schedFmt_(sun) };
  } else {
    var first = new Date(d.getFullYear(), d.getMonth(), 1);
    var last = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return { start: schedFmt_(first), end: schedFmt_(last) };
  }
}

function schedFmt_(d) {
  return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
}

function schedUpdateLabel_() {
  var el = document.getElementById('sched-date-label');
  if (!el) return;
  var d = SCHED.date;
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  if (SCHED.view === 'day') {
    el.textContent = days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  } else if (SCHED.view === 'week') {
    var range = schedDateRange_();
    var s = new Date(range.start + 'T00:00:00'), e = new Date(range.end + 'T00:00:00');
    el.textContent = s.getDate() + ' ' + months[s.getMonth()] + ' – ' + e.getDate() + ' ' + months[e.getMonth()] + ' ' + e.getFullYear();
  } else {
    el.textContent = months[d.getMonth()] + ' ' + d.getFullYear();
  }
}

function schedFetchAndRender() {
  showLoader('studio-booking');
  schedUpdateLabel_();
  var range = schedDateRange_();
  // TODO: Bridge route needed for: adminApi_getStudioSchedule
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getStudioSchedule', args: { token: STATE.token, start: range.start, end: range.end, view: SCHED.view } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      SCHED.data = data;
      var el = document.getElementById('studio-booking-data');
      if (!data || !data.ok) {
        el.innerHTML = '<div class="alert info">' + escHtml((data && data.error) || 'No schedule data available.') + '</div>';
      } else if (SCHED.view === 'day') {
        el.innerHTML = schedRenderDay_(data);
      } else if (SCHED.view === 'week') {
        el.innerHTML = schedRenderWeek_(data);
      } else {
        el.innerHTML = schedRenderMonth_(data);
      }
      showContent('studio-booking');
    }; _h(res.data); } else { var _e = function(err){ showError('studio-booking', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('studio-booking', err.message || String(err)); });
}

/* ---- DAY VIEW ---- */
function schedRenderDay_(data) {
  var artists = data.artists || [];
  if (!artists.length) return schedEmptyHtml_('No team members found for this date.');
  var totalHours = SCHED.hourEnd - SCHED.hourStart;
  var hasBookings = artists.some(function(a){ return a.bookings && a.bookings.length > 0; });

  var html = '<div class="sched-day-grid">';
  // Header with hour markers
  html += '<div class="sched-header-row"><div class="sched-artist-col">Artist</div><div class="sched-timeline-col">';
  for (var h = SCHED.hourStart; h < SCHED.hourEnd; h++) {
    var lbl = h === 0 ? '12am' : h < 12 ? h + 'am' : h === 12 ? '12pm' : (h-12) + 'pm';
    html += '<div class="sched-hour-marker">' + lbl + '</div>';
  }
  html += '</div></div>';

  // Artist rows
  artists.forEach(function(artist) {
    html += '<div class="sched-artist-row">';
    html += '<div class="sched-artist-name"><span class="name">' + escHtml(artist.name) + '</span>';
    if (artist.role) html += '<span class="role">' + escHtml(artist.role) + '</span>';
    html += '</div>';
    html += '<div class="sched-timeline-track">';

    // Hour grid lines
    for (var h = SCHED.hourStart; h < SCHED.hourEnd; h++) {
      var pct = ((h - SCHED.hourStart) / totalHours) * 100;
      html += '<div class="sched-hour-line" style="left:' + pct + '%"></div>';
    }

    // Now line
    var now = new Date();
    if (schedFmt_(now) === schedFmt_(SCHED.date)) {
      var nowMins = now.getHours() * 60 + now.getMinutes();
      var startMins = SCHED.hourStart * 60;
      var endMins = SCHED.hourEnd * 60;
      if (nowMins >= startMins && nowMins <= endMins) {
        var nowPct = ((nowMins - startMins) / (endMins - startMins)) * 100;
        html += '<div class="sched-now-line" style="left:' + nowPct + '%"></div>';
      }
    }

    // Availability gaps
    if (artist.gaps) {
      artist.gaps.forEach(function(gap) {
        var pos = schedBlockPos_(gap.start, gap.end);
        if (pos.width < 1) return;
        var cls = gap.durationMinutes >= 120 ? 'large' : 'medium';
        var fitLabel = gap.canFit ? 'Could fit: ' + gap.canFit : '';
        html += '<div class="sched-gap ' + cls + '" style="left:' + pos.left + '%;width:' + pos.width + '%">';
        if (pos.width > 5) html += escHtml(fitLabel);
        html += '</div>';
      });
    }

    // Booking blocks
    if (artist.bookings) {
      artist.bookings.forEach(function(bk) {
        var pos = schedBlockPos_(bk.start, bk.end);
        var typeClass = bk.type || 'personal';
        html += '<div class="sched-block ' + escAttr(typeClass) + '" style="left:' + pos.left + '%;width:' + pos.width + '%"' +
          ' title="' + escAttr(bk.client + ' — ' + (bk.location || '') + '\n' + schedTimeStr_(bk.start) + ' – ' + schedTimeStr_(bk.end)) + '">';
        html += '<div class="block-title">' + escHtml(bk.client || bk.title || 'Booking') + '</div>';
        var meta = [];
        if (bk.location) meta.push(bk.location);
        if (bk.type) meta.push(bk.type.charAt(0).toUpperCase() + bk.type.slice(1));
        if (bk.partySize && bk.partySize > 1) meta.push(bk.partySize + ' people');
        html += '<div class="block-meta">' + escHtml(schedTimeStr_(bk.start) + ' – ' + schedTimeStr_(bk.end) + (meta.length ? ' · ' + meta.join(' · ') : '')) + '</div>';
        html += '</div>';
      });
    }

    // Travel blocks
    if (artist.travelBlocks) {
      artist.travelBlocks.forEach(function(tr) {
        var pos = schedBlockPos_(tr.departAt, tr.arriveBy);
        var cls = tr.durationMinutes < 30 ? 'short' : tr.durationMinutes <= 60 ? 'medium' : 'long';
        html += '<div class="sched-travel ' + cls + '" style="left:' + pos.left + '%;width:max(' + pos.width + '%,40px)">';
        html += '\uD83D\uDE97 ' + tr.durationMinutes + 'm';
        html += '</div>';
      });
    }

    html += '</div></div>';
  });

  html += '</div>';
  if (!hasBookings) {
    html += '<div class="sched-empty" style="margin-top:1rem;"><p>No bookings scheduled for this day.</p><p style="font-size:0.75rem;color:var(--text-light);margin-top:0.25rem;">All artists are available during their working hours.</p></div>';
  }
  return html;
}

function schedBlockPos_(startISO, endISO) {
  var s = new Date(startISO), e = new Date(endISO);
  var startMins = s.getHours() * 60 + s.getMinutes();
  var endMins = e.getHours() * 60 + e.getMinutes();
  var rangeStart = SCHED.hourStart * 60, rangeEnd = SCHED.hourEnd * 60;
  startMins = Math.max(startMins, rangeStart);
  endMins = Math.min(endMins, rangeEnd);
  var totalRange = rangeEnd - rangeStart;
  return {
    left: ((startMins - rangeStart) / totalRange) * 100,
    width: Math.max(((endMins - startMins) / totalRange) * 100, 0)
  };
}

function schedTimeStr_(iso) {
  var d = new Date(iso);
  var h = d.getHours(), m = d.getMinutes();
  var ampm = h >= 12 ? 'pm' : 'am';
  h = h % 12 || 12;
  return h + (m ? ':' + String(m).padStart(2,'0') : '') + ampm;
}

/* ---- WEEK VIEW ---- */
function schedRenderWeek_(data) {
  var artists = data.artists || [];
  if (!artists.length) return schedEmptyHtml_('No team members found.');
  var range = schedDateRange_();
  var startDate = new Date(range.start + 'T00:00:00');
  var days = [];
  for (var i = 0; i < 7; i++) {
    var dd = new Date(startDate); dd.setDate(startDate.getDate() + i);
    days.push(dd);
  }
  var dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  var html = '<div class="card-panel" style="padding:0;overflow:auto;"><table class="sched-week-table"><thead><tr><th>Artist</th>';
  days.forEach(function(dd) {
    var isToday = schedFmt_(dd) === schedFmt_(new Date());
    html += '<th' + (isToday ? ' style="color:var(--brand-primary)"' : '') + '>' + dayNames[dd.getDay()] + '<br>' + dd.getDate() + ' ' + months[dd.getMonth()] + '</th>';
  });
  html += '</tr></thead><tbody>';

  artists.forEach(function(artist) {
    html += '<tr><td>' + escHtml(artist.name) + '</td>';
    days.forEach(function(dd) {
      var dateStr = schedFmt_(dd);
      var dayBookings = (artist.bookings || []).filter(function(b) {
        return b.start && b.start.substring(0, 10) === dateStr;
      });
      html += '<td onclick="schedClickWeekCell(\'' + dateStr + '\')">';
      if (dayBookings.length) {
        dayBookings.forEach(function(b) {
          var typeClass = b.type || 'personal';
          var label = b.type ? b.type.charAt(0).toUpperCase() + b.type.slice(1) : 'Event';
          html += '<span class="sched-week-chip ' + escAttr(typeClass) + '" title="' + escAttr((b.client || '') + ' ' + schedTimeStr_(b.start)) + '">' + escHtml(label) + '</span> ';
        });
      } else {
        html += '<span style="color:var(--text-light);">—</span>';
      }
      html += '</td>';
    });
    html += '</tr>';
  });

  html += '</tbody></table></div>';
  return html;
}

function schedClickWeekCell(dateStr) {
  SCHED.date = new Date(dateStr + 'T00:00:00');
  schedSwitchView('day');
}

/* ---- MONTH VIEW ---- */
function schedRenderMonth_(data) {
  var d = SCHED.date;
  var firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
  var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  var startDow = (firstDay.getDay() + 6) % 7; // Monday-start
  var dayNames = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  var todayStr = schedFmt_(new Date());

  // Build lookup: dateStr -> array of bookings across all artists
  var bookingsByDate = {};
  (data.artists || []).forEach(function(artist) {
    (artist.bookings || []).forEach(function(b) {
      var ds = b.start ? b.start.substring(0, 10) : '';
      if (!ds) return;
      if (!bookingsByDate[ds]) bookingsByDate[ds] = [];
      bookingsByDate[ds].push({ type: b.type, artist: artist.name });
    });
  });

  var html = '<div class="sched-month-grid">';
  dayNames.forEach(function(dn) {
    html += '<div class="sched-month-hdr">' + dn + '</div>';
  });

  // Fill cells
  var cellDate = new Date(firstDay);
  cellDate.setDate(cellDate.getDate() - startDow);
  for (var row = 0; row < 6; row++) {
    for (var col = 0; col < 7; col++) {
      var ds = schedFmt_(cellDate);
      var outside = cellDate.getMonth() !== d.getMonth();
      var isToday = ds === todayStr;
      html += '<div class="sched-month-cell' + (outside ? ' outside' : '') + (isToday ? ' today' : '') + '" onclick="schedClickWeekCell(\'' + ds + '\')">';
      html += '<div class="day-num">' + cellDate.getDate() + '</div>';
      var dayBks = bookingsByDate[ds] || [];
      if (dayBks.length) {
        html += '<div>';
        dayBks.forEach(function(bk) {
          html += '<span class="sched-month-dot ' + escAttr(bk.type || 'personal') + '" title="' + escAttr(bk.artist) + '"></span>';
        });
        html += '</div>';
      }
      html += '</div>';
      cellDate.setDate(cellDate.getDate() + 1);
    }
    if (cellDate.getMonth() !== d.getMonth() && cellDate > lastDay) break;
  }
  html += '</div>';
  return html;
}

function schedEmptyHtml_(msg) {
  return '<div class="sched-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg><p>' + escHtml(msg) + '</p></div>';
}

/* ============================================================
   DISPATCH CENTRE (Studio Schedule Day / Week)
   ============================================================ */
var DISPATCH = {
  date: null,
  weekDate: null,
  data: null,
  weekData: null,
  hourStart: 4,
  hourEnd: 22,
  selectedJob: null,
  dragJobId: null,
  dragFromArtist: null,
  brideColours: {}
};

// Colour palette for bride bars
var DISPATCH_PALETTE = [
  'rgba(201,149,145,0.25)', 'rgba(155,178,196,0.25)', 'rgba(175,168,200,0.25)',
  'rgba(178,196,155,0.25)', 'rgba(196,175,155,0.25)', 'rgba(155,196,190,0.25)',
  'rgba(200,168,175,0.25)', 'rgba(168,180,200,0.25)'
];
var DISPATCH_BORDER_PALETTE = [
  '#c99591', '#7ba3be', '#9b8fc4', '#8fb87a', '#be9b7b', '#7bbeb5', '#c48b95', '#8b9fc4'
];

function dispatchBrideColour_(brideName) {
  if (DISPATCH.brideColours[brideName]) return DISPATCH.brideColours[brideName];
  var idx = Object.keys(DISPATCH.brideColours).length % DISPATCH_PALETTE.length;
  DISPATCH.brideColours[brideName] = { bg: DISPATCH_PALETTE[idx], border: DISPATCH_BORDER_PALETTE[idx] };
  return DISPATCH.brideColours[brideName];
}

function loadDispatchView(mode) {
  if (mode === 'week') {
    if (!DISPATCH.weekDate) DISPATCH.weekDate = new Date();
    dispatchWeekFetch();
  } else {
    if (!DISPATCH.date) DISPATCH.date = new Date();
    var picker = document.getElementById('dispatch-date-picker');
    if (picker) picker.value = dispatchFmt_(DISPATCH.date);
    dispatchFetch();
  }
}

function dispatchFmt_(d) {
  return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
}

function dispatchNav(dir) {
  var d = new Date(DISPATCH.date);
  d.setDate(d.getDate() + dir);
  DISPATCH.date = d;
  var picker = document.getElementById('dispatch-date-picker');
  if (picker) picker.value = dispatchFmt_(d);
  dispatchFetch();
}

function dispatchDatePicked(val) {
  if (!val) return;
  DISPATCH.date = new Date(val + 'T00:00:00');
  dispatchFetch();
}

function dispatchGoToday() {
  DISPATCH.date = new Date();
  var picker = document.getElementById('dispatch-date-picker');
  if (picker) picker.value = dispatchFmt_(DISPATCH.date);
  dispatchFetch();
}

function dispatchRefresh() {
  DISPATCH.brideColours = {};
  dispatchFetch();
}

function dispatchFetch() {
  showLoader('studio-schedule');
  DISPATCH.selectedJob = null;
  document.getElementById('dispatch-detail-panel').style.display = 'none';
  var dateStr = dispatchFmt_(DISPATCH.date);
  // Timeout guard: the day data call has been observed to hang server-side with
  // neither callback firing, leaving the loader spinning forever. Guarantee the
  // loader always resolves to content or an error.
  var _settled = false;
  var _timer = setTimeout(function() {
    if (_settled) return;
    _settled = true;
    showError('studio-schedule', 'Schedule took too long to load. Tap Refresh to retry.');
  }, 20000);
  // TODO: Bridge route needed for: adminCrm_getStudioSchedule
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getStudioSchedule', args: { token: STATE.token || sessionStorage.getItem('jv_session_token') || '', date: dateStr, view: 'day' } })
    .then(function(res) { if (_settled) return; _settled = true; clearTimeout(_timer); if (res.ok) { var _h = function(data) {
      DISPATCH.data = data;
      if (!data || !data.ok) {
        showError('studio-schedule', (data && data.error) || 'Failed to load schedule.');
        return;
      }
      dispatchRender();
      showContent('studio-schedule');
    }; _h(res.data); } else { var _e = function(err) {
      showError('studio-schedule', (err && err.message) || String(err) || 'Failed to load schedule.');
    }; _e(res.error); } })
    .catch(function(err) {
      if (_settled) return; _settled = true; clearTimeout(_timer);
      showError('studio-schedule', (err && err.message) || String(err) || 'Failed to load schedule.');
    });
}

function dispatchRender() {
  var data = DISPATCH.data;
  if (!data || !data.ok) return;

  var artists = data.artists || [];
  var unassigned = data.unassigned || [];
  var offStatuses = ['unavailable', 'not_working_day', 'leave', 'blocked'];
  var showUnavail = document.getElementById('dispatch-show-unavailable');
  var showAll = showUnavail && showUnavail.checked;

  if (!showAll) {
    artists = artists.filter(function(a) {
      return offStatuses.indexOf(a.availability) < 0 || a.jobs.length > 0;
    });
  }

  // Stats
  var onDuty = artists.filter(function(a) { return offStatuses.indexOf(a.availability) < 0 && a.jobs.length > 0; }).length;
  var totalJobs = 0;
  var tightCount = 0;
  artists.forEach(function(a) {
    totalJobs += a.jobs.length;
    a.jobs.forEach(function(j) {
      if (j.travelFromPrev && j.travelFromPrev.isTight) tightCount++;
    });
  });
  var statsEl = document.getElementById('dispatch-stats');
  var statsHtml = '<span class="stat-badge on-duty">' + onDuty + ' on duty</span>';
  statsHtml += '<span class="stat-badge jobs">' + totalJobs + ' jobs</span>';
  if (tightCount > 0) statsHtml += '<span class="stat-badge tight">' + tightCount + ' tight travel</span>';
  if (unassigned.length > 0) statsHtml += '<span class="stat-badge unassigned">' + unassigned.length + ' unassigned</span>';
  statsEl.innerHTML = statsHtml;

  // Gantt
  var totalHours = DISPATCH.hourEnd - DISPATCH.hourStart;
  var html = '<div class="dispatch-gantt">';

  // Header
  html += '<div class="gantt-header"><div class="gantt-artist-hdr">Artist</div><div class="gantt-time-hdr">';
  for (var h = DISPATCH.hourStart; h < DISPATCH.hourEnd; h++) {
    var lbl = h === 0 ? '12am' : h < 12 ? h + 'am' : h === 12 ? '12pm' : (h-12) + 'pm';
    html += '<div class="gantt-hour-mark">' + lbl + '</div>';
  }
  html += '</div></div>';

  // Artist rows
  artists.forEach(function(artist) {
    html += dispatchRenderArtistRow_(artist, data.date, totalHours, false);
  });

  // Unassigned row
  if (unassigned.length > 0) {
    html += '<div class="gantt-row unassigned-row" ondragover="dispatchDragOver(event)" ondrop="dispatchDropUnassigned(event)">';
    html += '<div class="gantt-artist-cell"><span class="artist-name" style="color:var(--danger);">Unassigned</span><span class="artist-meta">' + unassigned.length + ' wedding' + (unassigned.length > 1 ? 's' : '') + '</span></div>';
    html += '<div class="gantt-track">';
    html += dispatchRenderHourLines_(totalHours);
    html += dispatchRenderNowLine_(data.date, totalHours);
    unassigned.forEach(function(job) {
      html += dispatchRenderJobBar_(job, totalHours, true, null);
    });
    html += '</div></div>';
  }

  html += '</div>';

  // Availability legend
  html += '<div class="dispatch-legend">';
  html += '<span style="font-weight:600;">Legend:</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch avail"></span> Available</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch notwork"></span> Non-working day</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch leave"></span> Leave</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch blocked"></span> Blocked</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch unavail"></span> Unavailable</span>';
  html += '</div>';

  // Mobile list
  html += dispatchRenderMobileList_(artists, unassigned, data.date);

  document.getElementById('dispatch-timeline').innerHTML = html;
}

function dispatchRenderArtistRow_(artist, dateStr, totalHours, isWeek) {
  var html = '<div class="gantt-row" data-artist="' + escAttr(artist.name) + '" ondragover="dispatchDragOver(event)" ondrop="dispatchDrop(event, \'' + escAttr(artist.name) + '\')">';

  // Artist cell — apply status-specific CSS class
  var av = artist.availability || 'available';
  var cellCls = 'gantt-artist-cell';
  if (av === 'unavailable') cellCls += ' unavailable';
  else if (av === 'not_working_day') cellCls += ' not-working-day';
  else if (av === 'leave') cellCls += ' leave';
  else if (av === 'blocked') cellCls += ' blocked';
  html += '<div class="' + cellCls + '">';
  html += '<span class="artist-name">' + escHtml(artist.name) + '</span>';
  var meta = [];
  if (artist.suburb) meta.push(artist.suburb);
  if (artist.canLead) meta.push('<span class="lead-badge">Lead</span>');
  if (av === 'partial') meta.push('Partial');
  else if (av === 'not_working_day') meta.push('Non-working day');
  else if (av === 'leave') meta.push('Leave');
  else if (av === 'blocked') meta.push('Blocked');
  html += '<span class="artist-meta">' + meta.join(' · ') + '</span>';
  html += '</div>';

  // Track
  html += '<div class="gantt-track">';
  html += dispatchRenderHourLines_(totalHours);
  html += dispatchRenderNowLine_(dateStr, totalHours);

  var avReason = artist.availabilityReason ? ' — ' + escHtml(artist.availabilityReason) : '';
  if (av === 'unavailable') {
    html += '<div class="dispatch-unavail-bar" style="left:0;right:0">Unavailable' + avReason + '</div>';
  } else if (av === 'not_working_day') {
    html += '<div class="dispatch-notwork-bar" style="left:0;right:0">N/A' + avReason + '</div>';
  } else if (av === 'leave') {
    html += '<div class="dispatch-leave-bar" style="left:0;right:0">Leave' + avReason + '</div>';
  } else if (av === 'blocked') {
    html += '<div class="dispatch-blocked-bar" style="left:0;right:0">Blocked' + avReason + '</div>';
  } else if (artist.jobs.length === 0) {
    html += '<div class="dispatch-avail-bar" style="left:0;right:0">Available</div>';
  } else {
    artist.jobs.forEach(function(job) {
      html += dispatchRenderJobBar_(job, totalHours, false, artist.name);
    });
    // Travel chips
    artist.jobs.forEach(function(job) {
      if (job.travelFromPrev) {
        var tr = job.travelFromPrev;
        // Position travel chip between prev end and this start
        var prevIdx = artist.jobs.indexOf(job) - 1;
        if (prevIdx >= 0) {
          var prevEnd = dispatchTimeToMins_(artist.jobs[prevIdx].endTime);
          var thisStart = dispatchTimeToMins_(job.startTime);
          var midMins = (prevEnd + thisStart) / 2;
          var rangeStart = DISPATCH.hourStart * 60;
          var rangeEnd = DISPATCH.hourEnd * 60;
          var leftPct = ((midMins - rangeStart) / (rangeEnd - rangeStart)) * 100;
          var cls = tr.isTight ? 'danger' : (tr.travelWindow < tr.durationMin + 30 ? 'tight' : 'ok');
          html += '<div class="dispatch-travel ' + cls + '" style="left:' + leftPct + '%;transform:translate(-50%,-50%)">';
          html += tr.durationMin + 'm · ' + tr.distanceKm + 'km';
          html += '</div>';
        }
      }
    });
  }

  html += '</div></div>';
  return html;
}

function dispatchRenderJobBar_(job, totalHours, isUnassigned, artistName) {
  var startMins = dispatchTimeToMins_(job.startTime);
  var endMins = dispatchTimeToMins_(job.endTime);
  var rangeStart = DISPATCH.hourStart * 60;
  var rangeEnd = DISPATCH.hourEnd * 60;
  startMins = Math.max(startMins, rangeStart);
  endMins = Math.min(endMins, rangeEnd);
  var totalRange = rangeEnd - rangeStart;
  var leftPct = ((startMins - rangeStart) / totalRange) * 100;
  var widthPct = Math.max(((endMins - startMins) / totalRange) * 100, 2);

  var colour = dispatchBrideColour_(job.brideName);
  var cls = 'dispatch-job' + (isUnassigned ? ' unassigned' : '');
  var bg = isUnassigned ? '' : 'background:' + colour.bg + ';border-left:3px solid ' + colour.border + ';';

  var draggable = isUnassigned ? ' draggable="true" ondragstart="dispatchDragStart(event,' + job.brideId + ',\'\')"' : (artistName ? ' draggable="true" ondragstart="dispatchDragStart(event,' + job.brideId + ',\'' + escAttr(artistName) + '\')"' : '');

  var html = '<div class="' + cls + '" style="left:' + leftPct + '%;width:' + widthPct + '%;' + bg + '"' +
    ' data-bride-id="' + job.brideId + '"' +
    ' onclick="dispatchSelectJob(' + job.brideId + ')"' +
    draggable +
    ' title="' + escAttr(job.brideName + ' — ' + (job.venue || '') + '\n' + job.startTime + ' – ' + job.endTime) + '">';
  html += '<div class="job-title">' + escHtml(job.brideName) + '</div>';
  html += '<div class="job-meta">' + escHtml(job.startTime + '–' + job.endTime + (job.venueShort ? ' · ' + job.venueShort : '')) + '</div>';
  html += '</div>';
  return html;
}

function dispatchRenderHourLines_(totalHours) {
  var html = '';
  for (var h = DISPATCH.hourStart; h < DISPATCH.hourEnd; h++) {
    var pct = ((h - DISPATCH.hourStart) / totalHours) * 100;
    html += '<div class="gantt-hour-line" style="left:' + pct + '%"></div>';
  }
  return html;
}

function dispatchRenderNowLine_(dateStr, totalHours) {
  var now = new Date();
  if (dispatchFmt_(now) !== dateStr) return '';
  var nowMins = now.getHours() * 60 + now.getMinutes();
  var startMins = DISPATCH.hourStart * 60;
  var endMins = DISPATCH.hourEnd * 60;
  if (nowMins < startMins || nowMins > endMins) return '';
  var pct = ((nowMins - startMins) / (endMins - startMins)) * 100;
  return '<div class="gantt-now-line" style="left:' + pct + '%"></div>';
}

function dispatchRenderMobileList_(artists, unassigned, dateStr) {
  var html = '<div class="dispatch-mobile-list">';
  artists.forEach(function(a) {
    var mav = a.availability || 'available';
    var isOff = mav === 'unavailable' || mav === 'not_working_day' || mav === 'leave' || mav === 'blocked';
    if (isOff && !a.jobs.length) {
      // Show condensed card for off-duty artists
      html += '<div class="mobile-artist-card" style="opacity:0.55;">';
      html += '<div class="mobile-artist-name">' + escHtml(a.name);
      if (a.suburb) html += ' <span style="font-weight:400;font-size:0.72rem;color:var(--text-light);">' + escHtml(a.suburb) + '</span>';
      html += '</div>';
      var offLabel = mav === 'not_working_day' ? 'Non-working day' : mav === 'leave' ? 'Leave' : mav === 'blocked' ? 'Blocked' : 'Unavailable';
      var offColor = mav === 'leave' ? 'var(--warning)' : mav === 'blocked' ? 'var(--danger)' : 'var(--text-light)';
      html += '<div style="font-size:0.75rem;color:' + offColor + ';">' + offLabel;
      if (a.availabilityReason) html += ' — ' + escHtml(a.availabilityReason);
      html += '</div>';
      html += '</div>';
      return;
    }
    html += '<div class="mobile-artist-card">';
    html += '<div class="mobile-artist-name">' + escHtml(a.name);
    if (a.suburb) html += ' <span style="font-weight:400;font-size:0.72rem;color:var(--text-light);">' + escHtml(a.suburb) + '</span>';
    html += '</div>';
    if (!a.jobs.length) {
      html += '<div style="font-size:0.75rem;color:var(--success);">Available — no jobs</div>';
    }
    a.jobs.forEach(function(j) {
      if (j.travelFromPrev) {
        var trCls = j.travelFromPrev.isTight ? 'background:var(--danger-bg);color:var(--danger)' : 'background:var(--success-bg);color:var(--success)';
        html += '<div class="mobile-travel-chip" style="' + trCls + '">' + j.travelFromPrev.durationMin + 'min · ' + j.travelFromPrev.distanceKm + 'km' + (j.travelFromPrev.isTight ? ' — TIGHT' : '') + '</div>';
      }
      html += '<div class="mobile-job-item" onclick="dispatchSelectJob(' + j.brideId + ')">';
      html += '<span class="mobile-job-time">' + escHtml(j.startTime + '–' + j.endTime) + '</span> ';
      html += '<span class="mobile-job-bride">' + escHtml(j.brideName) + '</span>';
      if (j.venueShort) html += '<div class="mobile-job-venue">' + escHtml(j.venueShort) + '</div>';
      html += '</div>';
    });
    html += '</div>';
  });

  if (unassigned.length) {
    html += '<div class="mobile-artist-card" style="border-color:var(--danger);border-style:dashed;">';
    html += '<div class="mobile-artist-name" style="color:var(--danger);">Unassigned (' + unassigned.length + ')</div>';
    unassigned.forEach(function(j) {
      html += '<div class="mobile-job-item" onclick="dispatchSelectJob(' + j.brideId + ')">';
      html += '<span class="mobile-job-time">' + escHtml(j.startTime + '–' + j.endTime) + '</span> ';
      html += '<span class="mobile-job-bride">' + escHtml(j.brideName) + '</span>';
      if (j.venueShort) html += '<div class="mobile-job-venue">' + escHtml(j.venueShort) + '</div>';
      html += '</div>';
    });
    html += '</div>';
  }

  html += '</div>';
  return html;
}

/* ---- Dispatch: Select job / detail panel ---- */
function dispatchSelectJob(brideId) {
  DISPATCH.selectedJob = brideId;
  // Find the job in data
  var data = DISPATCH.data;
  if (!data) return;
  var job = null, artistName = null;
  (data.artists || []).forEach(function(a) {
    (a.jobs || []).forEach(function(j) {
      if (j.brideId === brideId) { job = j; artistName = a.name; }
    });
  });
  if (!job) {
    (data.unassigned || []).forEach(function(j) {
      if (j.brideId === brideId) { job = j; artistName = null; }
    });
  }
  if (!job) return;

  // Highlight bar
  document.querySelectorAll('.dispatch-job.selected').forEach(function(el) { el.classList.remove('selected'); });
  var bar = document.querySelector('.dispatch-job[data-bride-id="' + brideId + '"]');
  if (bar) bar.classList.add('selected');

  // Populate detail panel
  var panel = document.getElementById('dispatch-detail-panel');
  var body = document.getElementById('dispatch-detail-body');
  document.getElementById('dispatch-detail-title').textContent = job.brideName;

  var html = '';
  html += '<div class="detail-row"><div class="detail-label">Time</div><div class="detail-value">' + escHtml(job.startTime + ' – ' + job.endTime) + '</div></div>';
  if (job.callTime) html += '<div class="detail-row"><div class="detail-label">Call Time</div><div class="detail-value">' + escHtml(job.callTime) + '</div></div>';
  if (artistName) {
    html += '<div class="detail-row"><div class="detail-label">Assigned Artist</div><div class="detail-value">' + escHtml(artistName);
    if (job.isLead) html += ' <span style="background:var(--gold-bg);color:var(--gold-text);padding:0.05rem 0.3rem;border-radius:var(--radius-pill);font-size:0.62rem;font-weight:700;">Lead</span>';
    html += '</div></div>';
  }
  if (job.venue) {
    html += '<div class="detail-row"><div class="detail-label">Venue</div><div class="detail-value">';
    if (job.mapUrl) html += '<a href="' + escAttr(job.mapUrl) + '" target="_blank">' + escHtml(job.venue) + ' ↗</a>';
    else html += escHtml(job.venue);
    html += '</div></div>';
  }
  if (job.parking) html += '<div class="detail-row"><div class="detail-label">Parking</div><div class="detail-value">' + escHtml(job.parking) + '</div></div>';
  if (job.prepRoom) html += '<div class="detail-row"><div class="detail-label">Prep Room</div><div class="detail-value">' + escHtml(job.prepRoom) + '</div></div>';
  if (job.services && job.services.length) {
    html += '<div class="detail-row"><div class="detail-label">Services</div><div class="detail-value">' + job.services.map(function(s) { return escHtml(s); }).join('<br>') + '</div></div>';
  }
  if (job.travelFromPrev) {
    var tr = job.travelFromPrev;
    var trStyle = tr.isTight ? 'color:var(--danger);font-weight:700' : 'color:var(--success)';
    html += '<div class="detail-row"><div class="detail-label">Travel from Previous</div><div class="detail-value" style="' + trStyle + '">';
    html += tr.durationMin + ' min · ' + tr.distanceKm + ' km';
    if (tr.travelWindow !== null) html += ' (window: ' + tr.travelWindow + ' min)';
    if (tr.isTight) html += ' — TIGHT';
    html += '</div></div>';
  }
  if (job.travelFromHome) {
    html += '<div class="detail-row"><div class="detail-label">Travel from Home</div><div class="detail-value">' + job.travelFromHome.durationMin + ' min · ' + job.travelFromHome.distanceKm + ' km</div></div>';
  }

  // Multi-artist team picker
  var allArtists = (data.artists || []).filter(function(a) { return a.name; });
  var assignedArtists = [];
  // Collect all artists assigned to this job across all lanes
  (data.artists || []).forEach(function(a) {
    (a.jobs || []).forEach(function(j) {
      if (j.brideId === brideId && assignedArtists.indexOf(a.name) < 0) {
        assignedArtists.push(a.name);
      }
    });
  });
  // Current lead is first assigned, or the lane artist
  var currentLead = assignedArtists.length > 0 ? assignedArtists[0] : (artistName || '');
  var currentAssistants = assignedArtists.slice(1);

  html += '<div class="dispatch-reassign-wrap">';
  html += '<div class="detail-label">Update Team</div>';

  // Show current team as pills
  html += '<div class="team-picker-pills" id="team-picker-pills">';
  if (currentLead) {
    html += '<span class="team-picker-pill lead">' + escHtml(currentLead) + ' (Lead)</span>';
  }
  currentAssistants.forEach(function(a) {
    html += '<span class="team-picker-pill">' + escHtml(a) + ' <span class="pill-remove" onclick="dispatchRemoveAssistant(\'' + escAttr(a) + '\')">&times;</span></span>';
  });
  if (!currentLead && !currentAssistants.length) {
    html += '<span style="font-size:0.7rem;color:var(--text-light);">No artists assigned</span>';
  }
  html += '</div>';

  // Lead artist selector
  html += '<div class="team-picker-section">';
  html += '<div class="detail-label">Lead Artist</div>';
  html += '<div class="team-picker-checks">';
  allArtists.forEach(function(a) {
    var unavail = a.availability === 'unavailable';
    var cls = unavail ? ' class="artist-unavail"' : '';
    var checked = a.name === currentLead ? ' checked' : '';
    var disabled = unavail ? ' disabled' : '';
    html += '<label' + cls + '><input type="radio" name="team-lead" value="' + escAttr(a.name) + '"' + checked + disabled + '> ' + escHtml(a.name);
    if (a.suburb) html += ' <span class="artist-suburb">' + escHtml(a.suburb) + '</span>';
    html += '</label>';
  });
  html += '</div></div>';

  // Assistants checkboxes
  html += '<div class="team-picker-section">';
  html += '<div class="detail-label">Assistants</div>';
  html += '<div class="team-picker-checks">';
  allArtists.forEach(function(a) {
    var unavail = a.availability === 'unavailable';
    var cls = unavail ? ' class="artist-unavail"' : '';
    var checked = currentAssistants.indexOf(a.name) >= 0 ? ' checked' : '';
    var disabled = unavail ? ' disabled' : '';
    html += '<label' + cls + '><input type="checkbox" class="team-assist-cb" value="' + escAttr(a.name) + '"' + checked + disabled + '> ' + escHtml(a.name);
    if (a.suburb) html += ' <span class="artist-suburb">' + escHtml(a.suburb) + '</span>';
    html += '</label>';
  });
  html += '</div></div>';

  // Hidden fields for the handler
  html += '<input type="hidden" id="team-picker-bride-id" value="' + brideId + '">';
  html += '<input type="hidden" id="team-picker-wedding-date" value="' + escAttr(job.weddingDate || '') + '">';
  html += '<input type="hidden" id="team-picker-venue" value="' + escAttr(job.venue || '') + '">';
  html += '<input type="hidden" id="team-picker-start" value="' + escAttr(job.startTime || '') + '">';
  html += '<input type="hidden" id="team-picker-end" value="' + escAttr(job.endTime || '') + '">';

  html += '<button class="btn btn-primary" onclick="dispatchUpdateTeam()">Update Team</button>';
  html += '</div>';

  // Open in drawer link
  html += '<div style="margin-top:0.75rem;text-align:center;"><a href="#" onclick="openDrawer(\'' + brideId + '\'); return false;" style="font-size:0.75rem;color:var(--brand-primary);">Open Client Drawer →</a></div>';

  body.innerHTML = html;
  panel.style.display = '';
}

function dispatchCloseDetail() {
  document.getElementById('dispatch-detail-panel').style.display = 'none';
  document.querySelectorAll('.dispatch-job.selected').forEach(function(el) { el.classList.remove('selected'); });
  DISPATCH.selectedJob = null;
}

/* ---- Dispatch: Update Team (multi-artist) ---- */
function dispatchUpdateTeam() {
  var brideId = Number(document.getElementById('team-picker-bride-id').value);
  var weddingDate = document.getElementById('team-picker-wedding-date').value;
  var venue = document.getElementById('team-picker-venue').value;
  var startTime = document.getElementById('team-picker-start').value;
  var endTime = document.getElementById('team-picker-end').value;

  // Get selected lead
  var leadRadio = document.querySelector('input[name="team-lead"]:checked');
  if (!leadRadio) { jvToast('Select a lead artist.', 'warning'); return; }
  var leadArtist = leadRadio.value;

  // Get selected assistants (exclude lead)
  var assistants = [];
  document.querySelectorAll('.team-assist-cb:checked').forEach(function(cb) {
    if (cb.value !== leadArtist) assistants.push(cb.value);
  });

  jvToast('Updating team...', 'info');
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_updateWeddingTeam',
    args: {
      token: STATE.token || sessionStorage.getItem('jv_session_token') || '',
      brideId: brideId,
      leadArtist: leadArtist,
      assistants: assistants,
      weddingDate: weddingDate,
      venue: venue,
      startTime: startTime,
      endTime: endTime
    }
  })
  .then(function(res) {
    if (res.ok && res.data && res.data.ok) {
      jvToast(res.data.message || 'Team updated -- calendar invites sent.', 'success');
      dispatchRefresh();
    } else {
      jvToast('Update failed: ' + ((res.data && res.data.error) || res.error || 'Unknown error'), 'error');
    }
  })
  .catch(function(err) {
    jvToast('Error: ' + (err.message || String(err)), 'error');
  });
}

function dispatchRemoveAssistant(name) {
  // Uncheck the corresponding assistant checkbox
  document.querySelectorAll('.team-assist-cb').forEach(function(cb) {
    if (cb.value === name) cb.checked = false;
  });
  // Remove the pill
  var pills = document.getElementById('team-picker-pills');
  if (pills) {
    var spans = pills.querySelectorAll('.team-picker-pill');
    spans.forEach(function(s) {
      if (s.textContent.indexOf(name) >= 0 && !s.classList.contains('lead')) {
        s.remove();
      }
    });
  }
}

/* ---- Dispatch: Reassign (legacy single-artist, kept for drag-drop) ----
   Cross-lane edit, 2026-09-21 (AUDIT-2026-09-19-surface-opportunities/
   TEAMAPP-02-NOTIFICATIONS-AND-PUSH.md §6.7/§6.8 item 9, Admin CRM/Clients
   Agent's own lane, stood down for the night when this was made -- scoped
   to ONLY the quiet-hours warning below, nothing else in this function
   touched). The spec's own words: "a schedule change made at 21:00 for a
   06:00 start cannot be pushed or texted until 08:00... the CRM must tell
   Jess, at the moment she makes such a change, this is inside quiet
   hours, the artist will not be contacted until 08:00, ring her." This is
   that guard -- client-side Sydney-time check, no backend change. Does
   NOT block the reassignment (Jess can still make the change), it makes
   the consequence explicit before she does, since a human phone call is
   the only genuinely quiet-hours-exempt channel (§6.7 rung 5). */
function dispatchIsWithinQuietHoursSydney_() {
  try {
    var sydNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
    var hour = sydNow.getHours();
    return hour >= 20 || hour < 8;
  } catch (e) { return false; } // never block a real action on a broken time check
}

/* ---- Dispatch: CF shadow-write for artist reassignment (Issue #10, A2 continuation of
   Sub-D's relay-entity build, commit d5985e094 -- see
   BRIEFS/HANDOFF-runsheet-artist-reassign-frontend-wire-to-admin-crm-2026-10-27.md). Fires
   ALONGSIDE the GAS write below, never instead of it, never blocking it, never shown to the
   admin. GAS stays the one and only live path. The Worker's own flag
   (RUNSHEET_ARTIST_REASSIGN_ENABLED) defaults OFF, so today every shadow call comes back
   {ok:false, error:'reassign_disabled', httpStatus:503} -- a pure no-op server-side. Purpose:
   let a later pass compare GAS vs CF outcomes side-by-side before that flag is ever
   considered for flipping. Best-effort only -- if brideUid (via findClientById(), needs the
   pipeline/clients cache loaded this session) or teamMemberId (via _teamRosterRaw, needs the
   Team tab opened this session) can't be resolved, it skips silently rather than guessing at
   either id. The client-side flag below is this shadow call's OWN kill switch, independent
   of and in addition to the Worker's flag. */
var RUNSHEET_ARTIST_REASSIGN_SHADOW_ENABLED_ = true;

function dispatchShadowReassignTeamMemberId_(artistName) {
  var name = String(artistName || '').trim().toLowerCase();
  if (!name || !Array.isArray(_teamRosterRaw)) return null;
  for (var i = 0; i < _teamRosterRaw.length; i++) {
    var m = _teamRosterRaw[i];
    var dn = String((m && m.displayName) || '').trim().toLowerCase();
    if (dn && dn === name) return Number(m.teamMemberId) || null;
  }
  return null;
}

function dispatchShadowReassignArtist_(brideId, toArtist, source) {
  try {
    if (!RUNSHEET_ARTIST_REASSIGN_SHADOW_ENABLED_) return;
    var base = window._jvAdminProxyBase;
    if (!base) return;
    var client = (typeof findClientById === 'function') ? findClientById(brideId) : null;
    var brideUid = (client && client.brideUid) ? String(client.brideUid) : '';
    var teamMemberId = dispatchShadowReassignTeamMemberId_(toArtist);
    if (!brideUid || !teamMemberId) {
      console.info('[dispatch shadow reassign] skipped (brideUid=' + (brideUid || 'none') + ', teamMemberId=' + (teamMemberId || 'none') + ')');
      return;
    }
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    var idempotencyKey = 'reassign:' + brideUid + ':' + teamMemberId + ':' + Math.floor(Date.now() / 300000);
    nf(String(base).replace(/\/+$/, '') + '/partner/runsheet-reassign/reassign-artist', {
      method: 'POST', headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        brideUid: brideUid,
        assignments: [{ teamMemberId: teamMemberId, role: 'lead' }],
        source: source || 'manual',
        idempotencyKey: idempotencyKey
      })
    }).then(function(r) { return r.json ? r.json().catch(function() { return null; }) : null; })
      .then(function(body) { console.info('[dispatch shadow reassign] CF result', body); })
      .catch(function(err) { console.info('[dispatch shadow reassign] CF call failed (non-fatal)', err && err.message); });
  } catch (e) { /* shadow call must never affect the real reassignment */ }
}

function dispatchDoReassign(brideId, fromArtist) {
  var sel = document.getElementById('dispatch-reassign-select');
  var toArtist = sel ? sel.value : '';
  if (!toArtist) { jvToast('Select an artist first.', 'warning'); return; }

  if (dispatchIsWithinQuietHoursSydney_()) {
    var proceedInQuietHours = confirm(
      'It\'s currently inside quiet hours (8pm-8am Sydney). ' + toArtist +
      ' will NOT be notified of this change until 8am -- if this affects tomorrow morning, ' +
      'ring ' + toArtist + ' directly.\n\nProceed with the reassignment anyway?'
    );
    if (!proceedInQuietHours) return;
  }

  dispatchShadowReassignArtist_(brideId, toArtist, 'dispatcher');

  jvToast('Reassigning...', 'info');
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_reassignArtist', args: { token: STATE.token || sessionStorage.getItem('jv_session_token') || '', brideId: brideId, fromArtist: fromArtist, toArtist: toArtist, date: dispatchFmt_(DISPATCH.date) } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res && res.ok) {
        jvToast(res.message || 'Reassigned successfully.', 'success');
        dispatchRefresh();
      } else {
        jvToast('Reassign failed: ' + (res && res.error || 'Unknown error'), 'error');
      }
    }; _h(res.data); } else { var _e = function(err) {
      jvToast('Error: ' + (err.message || String(err)), 'error');
    }; _e(res.error); } })
    .catch(function(err) {
      jvToast('Error: ' + (err.message || String(err)), 'error');
    });
}

/* ---- Dispatch: Drag and Drop ---- */
function dispatchDragStart(event, brideId, fromArtist) {
  DISPATCH.dragJobId = brideId;
  DISPATCH.dragFromArtist = fromArtist;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/plain', String(brideId));
}

function dispatchDragOver(event) {
  event.preventDefault();
  var row = event.currentTarget;
  if (row) row.classList.add('drag-over');
}

function dispatchDrop(event, toArtist) {
  event.preventDefault();
  event.currentTarget.classList.remove('drag-over');
  var brideId = DISPATCH.dragJobId;
  var fromArtist = DISPATCH.dragFromArtist;
  if (!brideId || !toArtist) return;
  if (fromArtist === toArtist) return;

  // Same quiet-hours warning as dispatchDoReassign (the button path) above --
  // this drag-and-drop path fires the identical adminCrm_updateWeddingTeam
  // reassignment write and had ZERO check, found 2026-09-22 (Consolidator/
  // Cloudflare-Edge follow-up to the dispatchDoReassign quiet-hours fixes).
  if (dispatchIsWithinQuietHoursSydney_()) {
    var proceedInQuietHoursDrop = confirm(
      'It\'s currently inside quiet hours (8pm-8am Sydney). ' + toArtist +
      ' will NOT be notified of this change until 8am -- if this affects tomorrow morning, ' +
      'ring ' + toArtist + ' directly.\n\nProceed with the reassignment anyway?'
    );
    if (!proceedInQuietHoursDrop) return;
  }

  // Find the job to get wedding details
  var job = null;
  (DISPATCH.data.artists || []).forEach(function(a) {
    (a.jobs || []).forEach(function(j) {
      if (j.brideId === brideId) job = j;
    });
  });

  dispatchShadowReassignArtist_(brideId, toArtist, 'dispatcher');

  jvToast('Reassigning to ' + toArtist + '...', 'info');
  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_updateWeddingTeam',
    args: {
      token: STATE.token || sessionStorage.getItem('jv_session_token') || '',
      brideId: brideId,
      leadArtist: toArtist,
      assistants: [],
      weddingDate: job ? job.weddingDate : dispatchFmt_(DISPATCH.date),
      venue: job ? (job.venue || '') : '',
      startTime: job ? (job.startTime || '') : '',
      endTime: job ? (job.endTime || '') : ''
    }
  })
  .then(function(res) {
    if (res.ok && res.data && res.data.ok) {
      jvToast(res.data.message || 'Reassigned.', 'success');
      dispatchRefresh();
    } else {
      jvToast('Failed: ' + ((res.data && res.data.error) || res.error || 'Unknown error'), 'error');
    }
  })
  .catch(function(err) {
    jvToast('Error: ' + (err.message || String(err)), 'error');
  });
}

function dispatchDropUnassigned(event) {
  event.preventDefault();
  event.currentTarget.classList.remove('drag-over');
  // Dropping on unassigned row — no action needed
}

/* ---- Dispatch: Week View ---- */
function dispatchWeekNav(dir) {
  var d = new Date(DISPATCH.weekDate);
  d.setDate(d.getDate() + 7 * dir);
  DISPATCH.weekDate = d;
  dispatchWeekFetch();
}

function dispatchWeekToday() {
  DISPATCH.weekDate = new Date();
  dispatchWeekFetch();
}

function dispatchWeekFetch() {
  showLoader('studio-schedule-week');
  var dateStr = dispatchFmt_(DISPATCH.weekDate);

  // Update label
  var d = new Date(DISPATCH.weekDate);
  var dow = d.getDay();
  var mon = new Date(d); mon.setDate(d.getDate() - ((dow + 6) % 7));
  var sun = new Date(mon); sun.setDate(mon.getDate() + 6);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var lbl = document.getElementById('dispatch-week-label');
  if (lbl) lbl.textContent = mon.getDate() + ' ' + months[mon.getMonth()] + ' – ' + sun.getDate() + ' ' + months[sun.getMonth()] + ' ' + sun.getFullYear();

  // TODO: Bridge route needed for: adminCrm_getStudioSchedule
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getStudioSchedule', args: { token: STATE.token || sessionStorage.getItem('jv_session_token') || '', date: dateStr, view: 'week' } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      DISPATCH.weekData = data;
      if (!data || !data.ok) {
        showError('studio-schedule-week', (data && data.error) || 'Failed to load week data.');
        return;
      }
      dispatchRenderWeek_(data);
      showContent('studio-schedule-week');
    }; _h(res.data); } else { var _e = function(err) {
      showError('studio-schedule-week', err.message || String(err));
    }; _e(res.error); } })
    .catch(function(err) {
      showError('studio-schedule-week', err.message || String(err));
    });
}

function dispatchRenderWeek_(data) {
  var days = data.days || {};
  var dayKeys = Object.keys(days).sort();
  if (!dayKeys.length) {
    document.getElementById('dispatch-week-grid').innerHTML = '<div class="sched-empty"><p>No schedule data for this week.</p></div>';
    return;
  }

  var todayStr = dispatchFmt_(new Date());
  var dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  // Collect unique artists across all days (include all statuses)
  var artistSet = {};
  dayKeys.forEach(function(dk) {
    (days[dk].artists || []).forEach(function(a) {
      artistSet[a.name] = true;
    });
  });
  var artistNames = Object.keys(artistSet).sort();

  var html = '<div class="dispatch-week-grid">';

  // Header row
  html += '<div class="dispatch-week-hdr">Artist</div>';
  dayKeys.forEach(function(dk) {
    var dd = new Date(dk + 'T00:00:00');
    var isToday = dk === todayStr;
    html += '<div class="dispatch-week-hdr' + (isToday ? ' today' : '') + '">' + dayNames[dd.getDay()] + '<br>' + dd.getDate() + ' ' + months[dd.getMonth()] + '</div>';
  });

  // Artist rows
  artistNames.forEach(function(name) {
    html += '<div class="dispatch-week-artist">' + escHtml(name) + '</div>';
    dayKeys.forEach(function(dk) {
      var dayData = days[dk];
      var artistDay = null;
      (dayData.artists || []).forEach(function(a) {
        if (a.name === name) artistDay = a;
      });

      var jobs = artistDay ? artistDay.jobs : [];
      var dayAv = artistDay ? (artistDay.availability || 'available') : 'available';
      var hasTight = jobs.some(function(j) { return j.travelFromPrev && j.travelFromPrev.isTight; });
      var cls = 'dispatch-week-cell';
      if (hasTight) cls += ' has-tight';
      if (dayAv === 'not_working_day') cls += ' avail-not-working';
      else if (dayAv === 'leave') cls += ' avail-leave';
      else if (dayAv === 'blocked') cls += ' avail-blocked';
      else if (dayAv === 'unavailable') cls += ' avail-unavailable';

      var cellTitle = name + ' — ' + dk;
      if (artistDay && artistDay.availabilityReason) cellTitle += ' (' + artistDay.availabilityReason + ')';

      html += '<div class="' + cls + '" onclick="dispatchWeekDrillDown(\'' + dk + '\')" title="' + escAttr(cellTitle) + '">';
      if (jobs.length > 0) {
        jobs.forEach(function(j) {
          var colour = dispatchBrideColour_(j.brideName);
          var initials = j.brideName.split(/\s+/).map(function(w) { return w.charAt(0); }).join('').substring(0, 2).toUpperCase();
          html += '<span class="week-initials" style="background:' + colour.bg + ';color:' + colour.border + ';" title="' + escAttr(j.brideName + ' ' + j.startTime + '–' + j.endTime) + '">' + initials + '</span>';
        });
        html += '<span class="week-count">' + jobs.length + ' job' + (jobs.length > 1 ? 's' : '') + '</span>';
      } else if (dayAv === 'not_working_day') {
        html += '<span class="week-empty" style="color:var(--text-light);">N/A</span>';
      } else if (dayAv === 'leave') {
        html += '<span class="week-empty" style="color:var(--warning);">Leave</span>';
      } else if (dayAv === 'blocked') {
        html += '<span class="week-empty" style="color:var(--danger);">Blocked</span>';
      } else if (dayAv === 'unavailable') {
        html += '<span class="week-empty" style="color:var(--text-light);">N/A</span>';
      } else {
        html += '<span class="week-empty">—</span>';
      }
      html += '</div>';
    });
  });

  // Unassigned row
  var hasUnassigned = dayKeys.some(function(dk) { return (days[dk].unassigned || []).length > 0; });
  if (hasUnassigned) {
    html += '<div class="dispatch-week-artist" style="color:var(--danger);">Unassigned</div>';
    dayKeys.forEach(function(dk) {
      var ua = days[dk].unassigned || [];
      var cls = 'dispatch-week-cell' + (ua.length ? ' has-unassigned' : '');
      html += '<div class="' + cls + '" onclick="dispatchWeekDrillDown(\'' + dk + '\')">';
      if (ua.length) {
        html += '<span class="week-count" style="color:var(--danger);font-weight:700;">' + ua.length + '</span>';
      } else {
        html += '<span class="week-empty">—</span>';
      }
      html += '</div>';
    });
  }

  html += '</div>';

  // Availability legend for week view
  html += '<div class="dispatch-legend" style="margin-top:0.5rem;">';
  html += '<span style="font-weight:600;">Legend:</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch avail"></span> Available</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch notwork"></span> Non-working day</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch leave"></span> Leave</span>';
  html += '<span class="dispatch-legend-item"><span class="dispatch-legend-swatch blocked"></span> Blocked</span>';
  html += '</div>';

  document.getElementById('dispatch-week-grid').innerHTML = html;
}

function dispatchWeekDrillDown(dateStr) {
  DISPATCH.date = new Date(dateStr + 'T00:00:00');
  switchView('studio-schedule');
}

/* ---- Dispatch: Helpers ---- */
function dispatchTimeToMins_(timeStr) {
  if (!timeStr) return 0;
  var parts = timeStr.split(':');
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10);
}

/* ============================================================
   INTERNAL BOOKING VIEW
   ============================================================ */
/* ============================================================
   INTERNAL BOOKING (P1 rebuild 2026-06-12)
   Resource-aware + CRM-linked admin trial booker. Reuses the
   shared JvScheduler component + JV_Schedule engine via the
   adminCrm_getInternalAvailability* endpoints. No native date
   pickers, no fake "(busy)" window.
   ============================================================ */
var IB = {
  clientId: null, clientName: '', clientEmail: '',
  service: '', serviceObj: null, mode: 'Studio',
  date: '', time: '', scheduler: null, monthCache: {},
  // kind: 'trial' (the trial internal booker, default/locked) | 'service' (S.O. service booker).
  // The same panel + scheduler are reused; kind selects the routes, labels, and the
  // payment toggle. Trial mode behaviour is unchanged when kind === 'trial'.
  kind: 'trial', charge: false,
  // Cart (2026-09-22, BUILD-admin-booker-multiservice-cart-2026-09-22.md,
  // Phase 1). Each entry is a resolved args object PLUS a display label,
  // built by ibAddToCart_ from the same fields submitInternalBooking already
  // reads -- one entry per queued service for the SAME client. The
  // currently-configured form fields (IB.service/date/time/mode/kind etc.)
  // are the "being configured" line and are NOT part of this array until
  // "Add to booking" is clicked; final submit sends the cart PLUS whatever
  // is currently configured, so a single-service booking (nothing ever
  // added to cart) behaves exactly as before this build.
  //
  // ROW-NUMBER IDENTITY NOTE (updated 2026-09-24): the client resolved by
  // the picker/first booking call is reused across every call in one batch
  // submit (requirement #4 of the brief -- resolve/create once, reuse for
  // subsequent lines). This USED TO be IB.clientId, a GAS row number
  // (Jess's standing rule: "WE SHOULD NEVER RELY ON ROW NUMBERS - EVER") --
  // fixed to IB.clientEmail instead (see ibSelectClient's own comment for
  // the full trace confirming both backend booking functions already
  // resolve/dedupe by email natively, so this was a safe frontend-only
  // change). clientId itself is left on this object, always null, only for
  // any stray reader elsewhere on this page that might still check it --
  // no live code path sets or reads it as an identity any more.
  // Never persists outside this in-memory module state, never returned to
  // an external caller, never outlives the current browser session/page
  // load. Not written back into the cart array itself either -- each cart
  // entry keeps its own args object built at "Add to booking" time; the
  // resolved email is applied to those args only at final-submit time,
  // immediately before each call fires.
  cart: []
};

function ibTok_() { return STATE.token || sessionStorage.getItem('jv_session_token') || ''; }

function loadInternalBookingView() {
  IB.kind = 'trial'; IB.charge = false;
  // The S.O. entry point (#service-booking, old nav links/bookmarks) reuses this
  // DOM panel; switchView cannot auto-activate a non-existent
  // view-service-booking, so reveal the shared panel explicitly.
  var panel = document.getElementById('view-internal-booking');
  if (panel) panel.classList.add('active');
  showContent('internal-booking');
  IB.clientId = null; IB.clientName = ''; IB.clientEmail = '';
  IB.date = ''; IB.time = ''; IB.monthCache = {};
  ibClearClient(true);
  var st = document.getElementById('ib-status'); if (st) st.textContent = '';
  ibApplyKind_();
  ibSetSlotSummary('Choose a date to see available times.');
  ibLoadServices();
  ibLoadArtists_();
  ibPendingRender_();
}

/* UNIFIED (2026-10-06): "Book a Service" is no longer a separate booker. The
   old #service-booking route still works (bookmarks, old nav) and opens the
   same unified grid, where S.O. services are their own group. */
function loadServiceBookingView() {
  loadInternalBookingView();
}

/* Relabel the shared booking panel for the current kind + show/hide the payment
   toggle. Idempotent, safe to call on every view load. */
/* One table for everything that differs between the three internal-booking
   kinds. Adding a kind means adding a row here, not another branch in
   ibApplyKind_ and its callers. Behaviour per kind is unchanged. */
var IB_KIND_CONFIG_ = {
  trial:         { sectionLabel: 'Trial Service', confirmCopy: ' Send the client a trial confirmation (email + SMS). Quiet hours still apply.', showConfirm: true,  showPayment: false, showArtist: true,  showLocation: true  },
  service:       { sectionLabel: 'Service',       confirmCopy: ' Send the client a booking confirmation. Quiet hours still apply.',           showConfirm: true,  showPayment: true,  showArtist: false, showLocation: true  },
  free_styling:  { sectionLabel: 'Free Styling Session', confirmCopy: '', showConfirm: false, showPayment: false, showArtist: false, showLocation: false }
};

function ibApplyKind_() {
  var kc = IB_KIND_CONFIG_[IB.kind] || IB_KIND_CONFIG_.trial;
  // Service-section label lives in the card that owns #ib-service-grid.
  // Found via that stable child id, not a positional .ib-card index --
  // this card's position has shifted before (2026-10-01, a short-lived
  // "Booking Type" toggle card) and could again, a positional lookup
  // would silently grab the wrong card's label if it ever does.
  var svcGrid = document.getElementById('ib-service-grid');
  var svcCard = svcGrid ? svcGrid.closest('.ib-card') : null;
  if (svcCard) {
    var lbl = svcCard.querySelector('.ib-section-label');
    if (lbl) lbl.textContent = 'What are you booking?';
  }
  // Submit button label
  var btn = document.getElementById('ib-submit-btn');
  if (btn) btn.textContent = ibSubmitLabel_();
  // Confirmation-toggle copy. HIDDEN for Free Styling -- freeStyling_book
  // always emails the Zoom join link unconditionally (it's how the client
  // actually joins the call), there is no suppress-confirmation flag on that
  // engine, so showing a toggle that does nothing would be misleading.
  var confLbl = document.querySelector('label[for="ib-send-confirm"]');
  if (confLbl) {
    confLbl.style.display = kc.showConfirm ? '' : 'none';
    if (kc.showConfirm) {
      var cb = document.getElementById('ib-send-confirm');
      confLbl.innerHTML = '';
      if (cb) confLbl.appendChild(cb);
      confLbl.appendChild(document.createTextNode(kc.confirmCopy));
    }
  }
  // Payment toggle (service only). Markup is static in the liquid section,
  // hidden by default; this only shows/hides it and resets to free hold.
  var payCard = document.getElementById('ib-pay-card');
  if (payCard) payCard.style.display = kc.showPayment ? '' : 'none';
  if (kc.showPayment) {
    IB.charge = false; // default free hold each load
    var hold = document.getElementById('ib-pay-hold');
    var link = document.getElementById('ib-pay-link');
    if (hold) hold.classList.add('active');
    if (link) link.classList.remove('active');
  }
  // Assigned-artist picker is TRIAL ONLY (S.O. service + Free Styling bookings
  // don't invite a trial artist). Hide it for both other kinds.
  var artField = document.getElementById('ib-artist-field');
  if (artField) artField.style.display = kc.showArtist ? '' : 'none';
  // Studio/Mobile location is meaningless for a Zoom consult -- hide the whole
  // Location sub-section for Free Styling only (unchanged for trial + S.O.).
  var locSection = document.getElementById('ib-location-section');
  if (locSection) locSection.style.display = kc.showLocation ? '' : 'none';
  // Custom date & time entry (admin override) lives in all three bookers.
  ibInjectCustomDateTime_();
}

/* Inject the "custom date & time" override entry into the Date & Time card.
   Admin-only (the whole view is admin-gated). Lets Jess type ANY date (including
   the past) and ANY start time instead of being limited to the slot grid, for
   recording bookings that already happened or off-grid times. Idempotent. */
function ibInjectCustomDateTime_() {
  var summary = document.getElementById('ib-slot-summary');
  if (!summary) return;
  var existing = document.getElementById('ib-custom-dt');
  if (!existing) {
    var wrap = document.createElement('div');
    wrap.id = 'ib-custom-dt';
    wrap.style.marginTop = '12px';
    wrap.innerHTML =
      '<button type="button" class="ib-link-btn" id="ib-custom-toggle" onclick="ibToggleCustomDateTime_()">Enter a custom date &amp; time (override)</button>' +
      '<div id="ib-custom-fields" style="display:none;margin-top:10px;padding-top:12px;border-top:1px dashed var(--border-color,#e8e0dc);">' +
        '<div class="ib-field-row">' +
          '<div class="ib-field"><label>Custom Date</label><input type="date" id="ib-custom-date"></div>' +
          '<div class="ib-field"><label>Custom Start Time</label><input type="time" id="ib-custom-time"></div>' +
        '</div>' +
        '<button type="button" class="ib-mode-btn active" style="width:100%;" onclick="ibApplyCustomDateTime_()">Use this date &amp; time</button>' +
        '<div style="font-size:12px;color:var(--text-light,#8a7e7b);margin-top:8px;line-height:1.5;">' +
          'Admin override: any date (including the past) and any start time. Bypasses the slot grid above.' +
        '</div>' +
      '</div>';
    summary.parentNode.insertBefore(wrap, summary.nextSibling);
  }
  // Reset on each (re)load.
  var df = document.getElementById('ib-custom-date'); if (df) df.value = '';
  var tf = document.getElementById('ib-custom-time'); if (tf) tf.value = '';
  var fields = document.getElementById('ib-custom-fields'); if (fields) fields.style.display = 'none';
}

function ibToggleCustomDateTime_() {
  var fields = document.getElementById('ib-custom-fields');
  if (fields) fields.style.display = (fields.style.display === 'none' || !fields.style.display) ? 'block' : 'none';
}

/* Apply a free-form date + time to the booking, bypassing the slot grid.
   Sets the same IB.date / IB.time / hidden inputs the scheduler pick would. */
function ibApplyCustomDateTime_() {
  var df = document.getElementById('ib-custom-date');
  var tf = document.getElementById('ib-custom-time');
  var status = document.getElementById('ib-status');
  var dateVal = df ? String(df.value || '').trim() : '';   // YYYY-MM-DD
  var timeVal = tf ? String(tf.value || '').trim() : '';   // HH:MM (24h)
  if (!dateVal || !/^\d{4}-\d{2}-\d{2}$/.test(dateVal)) {
    if (status) { status.textContent = 'Pick a custom date.'; status.style.color = 'var(--brand-primary-deep,#a9706c)'; }
    return;
  }
  if (!timeVal || !/^\d{1,2}:\d{2}$/.test(timeVal)) {
    if (status) { status.textContent = 'Pick a custom start time.'; status.style.color = 'var(--brand-primary-deep,#a9706c)'; }
    return;
  }
  IB.date = dateVal;
  IB.time = ibHhmmToLabel_(timeVal);
  var hd = document.getElementById('ib-date'); if (hd) hd.value = IB.date;
  var ht = document.getElementById('ib-time'); if (ht) ht.value = IB.time;
  if (status) status.textContent = '';
  ibSetSlotSummary('Custom: <strong>' + ibLongDate_(IB.date) + ' at ' + IB.time + '</strong> (manual override)');
}

function ibSelectCharge(charge) {
  IB.charge = !!charge;
  var hold = document.getElementById('ib-pay-hold');
  var link = document.getElementById('ib-pay-link');
  if (hold) hold.classList.toggle('active', !charge);
  if (link) link.classList.toggle('active', !!charge);
  var btn = document.getElementById('ib-submit-btn');
  if (btn) btn.textContent = ibSubmitLabel_();
}

function ibSubmitLabel_() {
  if (IB.kind === 'service') return IB.charge ? 'Create Pay Link' : 'Confirm Booking';
  if (IB.kind === 'free_styling') return 'Confirm Free Styling Session';
  return 'Confirm Trial Booking';
}

/* UNIFIED BOOKER (2026-10-06, Booking Admin): ONE grid for everything an
   admin books on a client's behalf -- trials, S.O. services and the Free
   Styling Zoom consult -- replacing the old split between Internal Booking
   (trials) and Book a Service (S.O.). Both catalogues load in parallel; each
   keeps its own pre-existing fast path / timeout / retry behaviour inside
   ibFetchServiceList_, and a failure in one never hides the other. Every tile
   carries its own kind, so the cart can mix kinds exactly as before. */
// The "Loading services..." placeholder must never be a final state. Two
// independent guards (2026-10-08): the whole load runs inside try/catch so a
// synchronous throw (e.g. the bridge not yet on window) cannot leave the
// placeholder behind, and a watchdog repaints an explicit retry after 30s if
// the grid still holds nothing but the placeholder.
function ibLoadServices() {
  var grid0 = document.getElementById('ib-service-grid');
  if (!grid0) return;
  var wd = setTimeout(function() {
    var g = document.getElementById('ib-service-grid');
    if (g && !g.querySelector('[data-ib-group]')) ibServicesFailed_(g);
  }, 30000);
  try {
    ibLoadServicesInner_();
  } catch (e) {
    clearTimeout(wd);
    try { console.error('[ib] services load threw:', e); } catch (_) {}
    ibServicesFailed_(grid0);
  }
}

function ibServicesFailed_(grid) {
  grid.innerHTML = '';
  var note = document.createElement('div');
  note.className = 'ib-svc-btn';
  note.style.cssText = 'cursor:default;opacity:0.6;';
  note.textContent = 'Could not load services.';
  grid.appendChild(note);
  var retry = document.createElement('button');
  retry.type = 'button';
  retry.className = 'btn-ghost';
  retry.textContent = 'Retry';
  retry.addEventListener('click', function() { _ibD1Svc_ = null; ibLoadServices(); });
  grid.appendChild(retry);
}

function ibLoadServicesInner_() {
  var grid = document.getElementById('ib-service-grid');
  if (!grid) return;
  // Mount the calendar grid immediately, it needs no GAS data to draw (pure date
  // math), so a slow/failed services fetch must never block it from appearing.
  ibMountScheduler(true);
  // LOCAL-FIRST (2026-10-06, after browser QA): both groups paint from their
  // CDN islands with zero GAS calls. The S.O. island is a cache of EXACTLY
  // adminCrm_getBookingServices (admin_booking_services_cache_json); without it
  // that read took 15-29s and lost to the old 15s timeout on every load.
  var soIsland = ibReadServicesIsland_('jv-ib-so-services-cache');
  var trialIsland = ibReadServicesIsland_('jv-ib-trial-services-cache');
  var trialP = trialIsland ? Promise.resolve({ services: trialIsland, note: '' }) : ibFetchServiceList_(false);
  if (trialIsland) {
    ibRenderServices({ services: trialIsland, note: '' },
      soIsland ? { services: soIsland, note: '' } : { services: [], loading: true });
  } else {
    grid.innerHTML = '<div class="ib-svc-btn" style="cursor:default;opacity:0.6;">Loading services...</div>';
  }
  trialP.then(function(trialRes) {
    if (!trialIsland) {
      ibRenderServices(trialRes, soIsland ? { services: soIsland, note: '' } : { services: [], loading: true });
    }
    // Background live refresh of the S.O. list: the island may be up to a
    // day old, the live read is authoritative. Never blocks the page.
    ibRefreshSoServices_(!!soIsland, 0);
  });
}

function ibReadServicesIsland_(id) {
  try {
    var el = document.getElementById(id);
    if (!el || !el.textContent.trim()) return null;
    var parsed = JSON.parse(el.textContent);
    var list = (parsed && parsed.services) ? parsed.services : null;
    return (Array.isArray(list) && list.length) ? list : null;
  } catch (_) { return null; }   // malformed island: fall through to the live read
}

/* Live S.O. catalogue in the background. Long patience (55s, the relay's own
   slow-route ceiling) because nothing waits on it. One retry. If it still
   fails: with a cached list on screen, keep it quietly; with nothing on
   screen, say so with a Retry button. */
function ibRefreshSoServices_(haveCached, attempt) {
  ibFetchServiceList_(true, false, 55000).then(function(res) {
    var ok = res && res.services && res.services.length && !res.note;
    if (ok) { ibRenderSoGroup_(res); return; }
    if (attempt < 1) { setTimeout(function() { ibRefreshSoServices_(haveCached, attempt + 1); }, 3000); return; }
    if (!haveCached) ibRenderSoGroup_({ services: [], note: (res && res.note) || 'Could not load special occasion services.', retry: true });
  });
}

/* D1 FIRST (2026-10-08, Jess decision 1: D1 booking_services is the ONE source
   of truth for services, rates and durations). Reads the Worker's
   booking-services-list with purpose:'booker'. That route answers 404 until
   JV_BOOKING_PANEL_D1_ENABLED is on, and any failure, timeout or empty answer
   resolves null, so the caller falls straight back to the unchanged GAS read:
   shipping this with the flag off changes nothing the admin can see.
   One shared request serves both groups (trial + S.O. fire together). */
var _ibD1Svc_ = null;
function ibD1Services_() {
  var now = Date.now();
  if (_ibD1Svc_ && now - _ibD1Svc_.at < 60000) return _ibD1Svc_.p;
  var p = new Promise(function(resolve) {
    var done = false;
    var timer = setTimeout(function() { if (!done) { done = true; resolve(null); } }, 6000);
    adminTeamMemberRelayCall_('booking-services-list', { tenantId: 'jessica-vegas', purpose: 'booker' }).then(function(res) {
      if (done) return;
      done = true; clearTimeout(timer);
      var list = res && res.ok && res.data && res.data.services;
      if (!Array.isArray(list) || !list.length) { resolve(null); return; }
      var tiles = list.map(function(r) {
        return {
          name: r.serviceName, category: r.category || '', durationMin: r.durationMin,
          priceCents: r.priceCents, isUpgrade: !!r.isUpgrade, isBridal: !!r.isBridal, source: 'd1'
        };
      });
      resolve({
        trial: tiles.filter(function(t) { return t.category === 'Bridal Trial'; }),
        so: tiles.filter(function(t) { return t.category !== 'Bridal Trial' && t.category !== 'Consultation'; })
      });
    }).catch(function() { if (!done) { done = true; clearTimeout(timer); resolve(null); } });
  });
  _ibD1Svc_ = { at: now, p: p };
  p.then(function(v) { if (!v) _ibD1Svc_ = null; });
  return p;
}

function ibFetchServiceList_(isService, _isSuspiciousEmptyRetry, timeoutMs) {
  // Trial side keeps its instant CDN island when present (ibLoadServices paints
  // it before ever calling here); D1 is for the live read behind it.
  return ibD1Services_().then(function(d1) {
    var list = d1 ? (isService ? d1.so : d1.trial) : null;
    if (list && list.length) return { services: list, note: '' };
    return ibFetchServiceListGas_(isService, _isSuspiciousEmptyRetry, timeoutMs);
  }).catch(function() {
    return ibFetchServiceListGas_(isService, _isSuspiciousEmptyRetry, timeoutMs);
  });
}

/* Resolves {services:[], note:''} -- never rejects. note is a visible,
   honest per-group message when that catalogue could not be read. */
function ibFetchServiceListGas_(isService, _isSuspiciousEmptyRetry, timeoutMs) {
  var fnName = isService ? 'adminCrm_getBookingServices' : 'adminCrm_getInternalBookingServices';
  var fallback = isService ? [] : [{ name: 'Hair & Makeup Trial', durationMin: 120 }];

  // CDN FAST PATH, TRIAL CATALOGUE ONLY (2026-09-11).
  // BRIEFS/HANDOFF-artist-list-metaobject-fastpath-to-admin-crm-2026-09-11.md.
  //
  // adminCrm_getInternalBookingServices is a thin wrapper around
  // clientTrialBooking_getServices() (StudioScheduleAPI.gs:469), an uncached
  // scan of _BookingServices. shop.metafields.custom.trial_services_json caches
  // exactly that call (verified by reading the writer,
  // clientTrialBooking_writeServicesMetafield, which stores the same function's
  // return verbatim), self-heals on every _BookingServices edit plus a daily
  // 5am job, and is already consumed this way by the public trial page.
  //
  // THE S.O. CATALOGUE IS DELIBERATELY EXCLUDED. adminCrm_getBookingServices
  // reads the full non-trial catalogue and has NO equivalent metafield, so it
  // stays on GAS rather than inventing a new cache in this pass. Its careful
  // rate-limit/silent-empty retry logic below is untouched for the same reason.
  if (!isService && !_isSuspiciousEmptyRetry) {
    try {
      var svcIsland = document.getElementById('jv-ib-trial-services-cache');
      if (svcIsland && svcIsland.textContent.trim()) {
        var parsed = JSON.parse(svcIsland.textContent);
        var cachedSvcs = (parsed && parsed.services) ? parsed.services : null;
        if (Array.isArray(cachedSvcs) && cachedSvcs.length) return Promise.resolve({ services: cachedSvcs, note: '' });
      }
    } catch (_) { /* malformed island, fall through to the unchanged GAS path */ }
  }
  // HARD TIMEOUT (2026-10-06). The placeholder "Loading services..." must never be the
  // final state: if the bridge does not answer in time, reject into the catch below, which
  // paints the trial fallback or an explicit retry message.
  var SVC_TIMEOUT_MS = timeoutMs || 15000;
  var grid = document.getElementById('ib-service-grid');
  var svcCall = callAdminRetry_({
    function: fnName,
    args: { token: ibTok_() }
  }, {
    onBusy: function() {
      // Show a distinct "throttled, retrying" state so a rate-limit trip never
      // masquerades as "No active services found" (silent-failure fix, 2026-07-16).
      if (grid && !grid.querySelector('[data-ib-group]')) {
        grid.innerHTML = '<div class="ib-svc-btn" style="cursor:default;opacity:0.6;">Busy, retrying...</div>';
      }
    }
  });
  var svcTimeout = new Promise(function(_resolve, reject) {
    setTimeout(function() { reject(new Error('services_timeout')); }, SVC_TIMEOUT_MS);
  });
  return Promise.race([svcCall, svcTimeout]).then(function(res) {
    if (jvIsRateLimited_(res)) {
      // All retries exhausted while still throttled. Distinguish from genuinely empty.
      return { services: fallback, note: 'Busy right now, please try again in a moment.' };
    }
    var services = (res && res.ok && res.data && res.data.services) ? res.data.services : [];
    // 2026-08-18: the S.O. side (isService) has NO legitimate empty-fallback -- the
    // trial side's fallback below is a real UI default, but a live catalogue with
    // zero active S.O. services has never actually happened (16 confirmed live,
    // BRIEFS/RESULTS-service-booker-empty-services-network-capture-2026-08-18.md).
    // That capture proved the response shape/parsing here is correct and the
    // catalogue read genuinely can come back ok:true with services:[] under
    // concurrent cold-GAS load (documented GAS perf-wall behaviour, CLAUDE.md),
    // most likely a sheet read racing a not-yet-warm instance. One silent retry
    // before showing the dead-end message so a transient cold-read never reads as
    // "there are no services" to Jess. Retry only once (the flag prevents a loop)
    // and only for the S.O. side -- the trial side already has its own hardcoded
    // fallback array and has never shown this symptom.
    if (isService && !services.length && res && res.ok && !_isSuspiciousEmptyRetry) {
      return ibFetchServiceListGas_(true, true, timeoutMs);
    }
    if (!services.length && fallback.length) return { services: fallback, note: '' };
    return { services: services, note: services.length ? '' : 'No active services found.' };
  }).catch(function() {
    return fallback.length
      ? { services: fallback, note: '' }
      : { services: [], note: 'Could not load these services, retry when the connection is back.' };
  });
}

/* Populate the Assigned-Artist select from the live roster (same source the
   availability polls + calendar use, adminCrm_getArtistList). Jessica stays the
   first/default option (value '' so the backend applies its Lead-Owner then
   Jessica defaulting). Trial booker only. */
var _ibArtistsLoaded = false;
// Paints the dropdown from a roster array of {name, role}. Shared by the CDN
// island fast path and the GAS fallback so both produce an identical dropdown.
function ibPaintArtists_(sel, artists) {
  if (!sel || !artists || !artists.length) return false;
  var prev = sel.value;
  // Rebuild: Jessica default first, then every roster artist (deduped, no 2nd Jessica).
  sel.innerHTML = '<option value="">Jessica</option>';
  artists.forEach(function(a) {
    var name = String((a && a.name) || '').trim();
    if (!name || /^jess/i.test(name)) return;
    var opt = document.createElement('option');
    opt.value = name; opt.textContent = name + (a.role ? ' (' + a.role + ')' : '');
    sel.appendChild(opt);
  });
  if (prev) sel.value = prev;
  return true;
}

function ibLoadArtists_() {
  var sel = document.getElementById('ib-artist');
  if (!sel || _ibArtistsLoaded) return;

  // CDN FAST PATH (2026-09-11).
  // BRIEFS/HANDOFF-artist-list-metaobject-fastpath-to-admin-crm-2026-09-11.md.
  //
  // The island is rendered server-side in sections/jv-admin-crm.liquid from the
  // team_member metaobject, which is synced from the SAME _TeamOptions sheet
  // this GAS route scans, on every edit plus a daily cron. So the data is
  // already in the page: no round trip, and none of the ~7-10s GAS cold-start
  // floor that adminCrm_getArtistList (an uncached full sheet scan) pays just
  // to fill one dropdown.
  //
  // Deliberately NOT stale-while-revalidate. Every other cache on this page
  // paints-then-refreshes because its data is volatile (money, pipeline state).
  // The artist roster changes when Jess edits _TeamOptions, the metaobject is
  // re-synced on that same edit, and a wrong entry here is a dropdown option,
  // not a wrong number. Firing the GAS call anyway would spend the entire cost
  // this change exists to remove. When the island is present we trust it; when
  // it is absent or empty we fall through to the unchanged GAS route.
  try {
    var islandEl = document.getElementById('jv-ib-artists-cache');
    if (islandEl && islandEl.textContent.trim()) {
      var cached = JSON.parse(islandEl.textContent);
      if (Array.isArray(cached) && cached.length && ibPaintArtists_(sel, cached)) {
        _ibArtistsLoaded = true;
        return;
      }
    }
  } catch (_) { /* malformed island, fall through to GAS below */ }

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getArtistList',
    args: { token: ibTok_() }
  }).then(function(res) {
    var artists = (res && res.ok && res.data && res.data.artists) ? res.data.artists : [];
    if (!artists.length) return;
    _ibArtistsLoaded = true;
    ibPaintArtists_(sel, artists);
  }).catch(function() { /* roster fetch failed, Jessica default remains */ });
}

/* Default the artist select to the bride's Lead Owner when one is set, else
   Jessica. Called when a client is selected. The backend re-applies this same
   defaulting as a safety net, so a missing match is harmless. */
function ibDefaultArtistForClient_(client) {
  var sel = document.getElementById('ib-artist');
  if (!sel || !client) return;
  var ownerName = String(client.leadOwnerName || '').trim();
  if (!ownerName || /^jess/i.test(ownerName)) { sel.value = ''; return; }
  var matched = false;
  for (var i = 0; i < sel.options.length; i++) {
    if (sel.options[i].value && sel.options[i].value.toLowerCase() === ownerName.toLowerCase()) {
      sel.value = sel.options[i].value; matched = true; break;
    }
  }
  if (!matched) sel.value = '';
}

/* Grouped grid (2026-10-06 unified booker). trialRes / soRes are the
   {services, note} results of ibFetchServiceList_. Three groups, each tile
   carrying its own kind:
     Bridal trials        -> kind 'trial'
     Special occasion     -> kind 'service' (S.O.)
     Consultation         -> kind 'free_styling' (one fixed tile)
   A group whose catalogue could not be read shows its honest note in place,
   never an empty heading. */
function ibRenderServices(trialRes, soRes) {
  var grid = document.getElementById('ib-service-grid');
  if (!grid) return;
  grid.innerHTML = '';
  // UPGRADE EXCLUSION (2026-10-01, Jess's direct instruction): an upgrade
  // (e.g. Hollywood Waves, IS_UPGRADE='YES' in _BookingServices) is an add-on
  // layered onto a base service, not a stand-alone choice, so it must never
  // render as its own selectable tile. Filtered in ibServiceTiles_, the one
  // choke point every services array (live GAS call AND CDN island) passes.
  var trials = ibServiceTiles_((trialRes && trialRes.services) || [], false);

  ibGroupHeading_(grid, 'Bridal trials');
  var trialBox = ibGroupBox_(grid, 'ib-grp-trial');
  if (trials.length) trials.forEach(function(s) { ibServiceTile_(trialBox, s.name, 'trial', s); });
  else ibGroupNote_(trialBox, (trialRes && trialRes.note) || 'No trial services found.');

  ibGroupHeading_(grid, 'Special occasion services');
  ibGroupBox_(grid, 'ib-grp-so');
  ibRenderSoGroup_(soRes);

  // FREE STYLING TILE (2026-10-01, Jess's direct instruction): one more tile
  // in the same list, not a separate mode switch. Routes to the real
  // Zoom-meeting-creating engine via the free_styling kind.
  ibGroupHeading_(grid, 'Consultation');
  ibServiceTile_(ibGroupBox_(grid, 'ib-grp-fs'), 'Free Styling Session (15 min, Zoom)', 'free_styling', null);

  // Preselect the first real tile (trials first), same "the grid has no
  // nothing-selected state" behaviour as before.
  var first = grid.querySelector('button.ib-svc-btn');
  if (first) first.click();
  else ibMountScheduler(true);
}

/* Re-renders ONLY the S.O. group (the background live refresh lands here), so
   a refresh never resets the admin's current pick, date or time. If the
   selected tile was an S.O. service still in the new list, it stays selected. */
function ibRenderSoGroup_(soRes) {
  var box = document.getElementById('ib-grp-so');
  if (!box) return;
  // The S.O. catalogue can list the Free Styling row (own tile + own engine)
  // and upgrades (add-ons): neither renders as an S.O. tile.
  var so = ibServiceTiles_((soRes && soRes.services) || [], true);
  box.innerHTML = '';
  if (so.length) {
    so.forEach(function(s) {
      var btn = ibServiceTile_(box, s.name, 'service', s);
      if (IB.kind === 'service' && IB.service === s.name) { btn.classList.add('selected'); IB.serviceObj = s; }
    });
    return;
  }
  if (soRes && soRes.loading) { ibGroupNote_(box, 'Loading special occasion services...'); return; }
  ibGroupNote_(box, (soRes && soRes.note) || 'No special occasion services found.');
  if (soRes && soRes.retry) {
    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'btn-ghost';
    retry.style.cssText = 'flex:0 0 auto;';
    retry.textContent = 'Retry';
    retry.addEventListener('click', function() {
      ibRenderSoGroup_({ services: [], loading: true });
      ibRefreshSoServices_(false, 0);
    });
    box.appendChild(retry);
  }
}

function ibServiceTiles_(list, isSo) {
  return list.filter(function(s) {
    if (!s || s.isUpgrade) return false;
    return !isSo || String(s.name || '').trim().toLowerCase() !== 'free bridal styling session';
  });
}

function ibGroupHeading_(grid, text) {
  var h = document.createElement('div');
  h.className = 'ib-section-label';
  h.setAttribute('data-ib-group', '1');
  h.style.cssText = 'flex:1 1 100%;margin:10px 0 0;';
  h.textContent = text;
  grid.appendChild(h);
}

/* display:contents keeps the tiles flowing in the parent flex grid exactly as
   before, while giving each group its own replaceable container. */
function ibGroupBox_(grid, id) {
  var box = document.createElement('div');
  box.id = id;
  box.style.display = 'contents';
  grid.appendChild(box);
  return box;
}

function ibGroupNote_(box, text) {
  var n = document.createElement('div');
  n.className = 'ib-svc-btn';
  n.style.cssText = 'cursor:default;opacity:0.6;';
  n.textContent = text;
  box.appendChild(n);
}

function ibServiceTile_(box, label, kind, svc) {
  var btn = document.createElement('button');
  btn.className = 'ib-svc-btn';
  btn.type = 'button';
  btn.textContent = label;
  btn.setAttribute('data-ib-kind', kind);
  btn.addEventListener('click', function() {
    if (kind === 'free_styling') ibSelectFreeStylingTile_(btn);
    else ibSelectService(btn, svc, kind);
  });
  box.appendChild(btn);
  return btn;
}

/* Selecting the Free Styling tile from the shared service grid (2026-10-01).
   Mirrors ibSelectService's own selected-state handling, but sets IB.kind
   and the hardcoded single-service object instead of reading from a real
   catalogue row -- there is only ever ONE Free Styling service (a fixed
   15-min Zoom consult), same reasoning the removed ibRenderFreeStylingKind_
   already had. No availability restrictions, same as every other
   internal-booking kind -- this books on the admin's behalf, bypassing the
   public booker's availability rules entirely, per Jess's explicit
   confirmation when this was first built. */
function ibSelectFreeStylingTile_(btn) {
  var grid = document.getElementById('ib-service-grid');
  if (grid) grid.querySelectorAll('.ib-svc-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  IB.kind = 'free_styling'; IB.charge = false;
  IB.service = 'Free Bridal Styling Session';
  IB.serviceObj = { name: IB.service, durationMin: 15 };
  document.getElementById('ib-service').value = IB.service;
  ibApplyKind_();
  IB.date = ''; IB.time = ''; IB.monthCache = {};
  document.getElementById('ib-date').value = '';
  document.getElementById('ib-time').value = '';
  ibSetSlotSummary('Choose a date to see available times.');
  ibMountScheduler(true);
}

function ibSelectService(btn, svc, kind) {
  var grid = document.getElementById('ib-service-grid');
  if (grid) grid.querySelectorAll('.ib-svc-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  // Unified grid (2026-10-06): the tile carries its kind ('trial' | 'service'),
  // so picking any tile sets the booking route, relabels the panel and shows
  // or hides the kind-specific fields (payment, artist, location).
  IB.kind = (kind === 'service') ? 'service' : 'trial';
  IB.charge = false;
  ibApplyKind_();
  IB.service = (svc && svc.name) || btn.textContent.trim();
  IB.serviceObj = svc;
  document.getElementById('ib-service').value = IB.service;
  // Service drives duration/slots, so reset the pick and refresh availability.
  IB.date = ''; IB.time = ''; IB.monthCache = {};
  document.getElementById('ib-date').value = '';
  document.getElementById('ib-time').value = '';
  ibSetSlotSummary('Choose a date to see available times.');
  ibMountScheduler(true);
}

function ibSelectMode(btn, value) {
  document.querySelectorAll('.ib-mode-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  IB.mode = value;
  document.getElementById('ib-mode').value = value;
  var locRow = document.getElementById('ib-location-row');
  if (value === 'Mobile') locRow.classList.add('show'); else locRow.classList.remove('show');
}

function ibMountScheduler(forceRemount) {
  var host = document.getElementById('ib-scheduler');
  if (!host || !window.JvScheduler) return;
  if (forceRemount || !IB.scheduler) {
    host._jvSchedMounted = false;
    host.innerHTML = '';
    IB.scheduler = window.JvScheduler.mount(host, {
      mode: 'book', skin: 'admin',
      payload: { month: window.JvScheduler.sydneyToday().slice(0, 7), serviceName: 'Choose a date' },
      fetchMonth: ibFetchMonth,
      fetchDay: ibFetchDay,
      onPick: ibOnPick,
      onDaySelect: function() {
        IB.time = '';
        document.getElementById('ib-time').value = '';
      }
    });
  }
}

function ibFetchMonth(yyyyMm) {
  // S.O. booker: admin bypass means every (future) day is open, so synthesise the
  // month map client-side rather than hit a route. fetchDay (getBookingSlots bypass)
  // returns the real slot grid.
  if (IB.kind === 'service') {
    return Promise.resolve({ days: ibBuildOpenMonth_(yyyyMm) });
  }
  // Free Styling: shows Jessica's REAL Zoom-consult availability (unlike S.O.,
  // this booker has no admin bypass at the read layer -- see
  // FreeStylingAdminBooking_2026_10_01.gs's own comment). The "Enter a custom
  // date & time (override)" box injected by ibApplyKind_ is the override path
  // here, same as it already is conceptually for the other two kinds.
  if (IB.kind === 'free_styling') {
    return jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_getFreeStylingAvailabilityMonth',
      args: { token: ibTok_(), month: yyyyMm }
    }).then(function(res) {
      var d = (res && res.ok) ? res.data : null;
      var days = {};
      if (d && d.ok && d.dates) {
        Object.keys(d.dates).forEach(function(k) { if (d.dates[k]) days[k] = 'available'; });
      }
      return { days: days, _error: !!(d && d.availabilityError) };
    }).catch(function() { return { days: {}, _error: true }; });
  }
  var svc = IB.service || 'Hair & Makeup Trial';
  var key = svc + '|' + yyyyMm;
  if (IB.monthCache[key]) return Promise.resolve({ days: IB.monthCache[key] });
  return jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getInternalAvailabilityMonth',
    args: { token: ibTok_(), serviceType: svc, month: yyyyMm }
  }).then(function(res) {
    var d = (res && res.ok) ? res.data : null;
    if (d && d.ok && d.days && !d.availabilityError) {
      IB.monthCache[key] = d.days;
      return { days: d.days };
    }
    return { days: {}, _error: !!(d && d.availabilityError) };
  }).catch(function() { return { days: {}, _error: true }; });
}

/* Build a month availability map for the S.O. booker. Admin booker = no
   restrictions, so EVERY day (including past) is selectable: an admin can record
   a booking that already happened. The bypass slot grid returns times for any
   date. (2026-06-16: past dates unlocked per the override principle.) */
function ibBuildOpenMonth_(yyyyMm) {
  var days = {};
  var parts = String(yyyyMm || '').split('-');
  var y = parseInt(parts[0], 10), m = parseInt(parts[1], 10);
  if (!y || !m) return days;
  var daysInMonth = new Date(y, m, 0).getDate();
  for (var d = 1; d <= daysInMonth; d++) {
    var iso = parts[0] + '-' + ('0' + m).slice(-2) + '-' + ('0' + d).slice(-2);
    days[iso] = 'available';
  }
  return days;
}

function ibFetchDay(iso) {
  if (IB.kind === 'service') {
    return jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_getBookingSlots',
      args: { token: ibTok_(), date: iso, bypassMode: true }
    }).then(function(res) {
      var d = (res && res.ok) ? res.data : null;
      if (d && d.ok && d.slots) return { slots: d.slots };
      return { slots: [], _error: true };
    }).catch(function() { return { slots: [], _error: true }; });
  }
  if (IB.kind === 'free_styling') {
    return jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_getFreeStylingAvailabilityDay',
      args: { token: ibTok_(), date: iso }
    }).then(function(res) {
      var d = (res && res.ok) ? res.data : null;
      if (d && d.ok && d.slots) return { slots: d.slots };
      return { slots: [], _error: true };
    }).catch(function() { return { slots: [], _error: true }; });
  }
  var svc = IB.service || 'Hair & Makeup Trial';
  return jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getInternalAvailabilityDay',
    args: { token: ibTok_(), serviceType: svc, date: iso }
  }).then(function(res) {
    var d = (res && res.ok) ? res.data : null;
    if (d && d.ok && d.slots) return { slots: d.slots };
    return { slots: [], availabilityError: !!(d && d.availabilityError) };
  }).catch(function() { return { slots: [], _error: true }; });
}

function ibOnPick(pick) {
  IB.date = pick.date;
  IB.time = ibHhmmToLabel_(pick.time);
  document.getElementById('ib-date').value = IB.date;
  document.getElementById('ib-time').value = IB.time;
  ibSetSlotSummary('Selected: <strong>' + ibLongDate_(pick.date) + ' at ' + IB.time + '</strong>');
}

function ibSetSlotSummary(html) {
  var s = document.getElementById('ib-slot-summary');
  if (s) s.innerHTML = html;
}

function ibHhmmToLabel_(t) {
  var m = String(t || '').match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return t;
  var h = parseInt(m[1], 10), min = m[2];
  var ampm = h >= 12 ? 'PM' : 'AM';
  var h12 = h % 12; if (h12 === 0) h12 = 12;
  return h12 + ':' + min + ' ' + ampm;
}

function ibLongDate_(iso) {
  var p = String(iso).split('-');
  if (p.length !== 3) return iso;
  var dn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var mn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var dt = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
  return dn[dt.getUTCDay()] + ' ' + (+p[2]) + ' ' + mn[+p[1] - 1] + ' ' + p[0];
}

/* ---- Client picker (search-as-you-type, binds clientId) ---- */
var _ibSearchTimer = null;
var _ibSearchSeq = 0;
// Request-storm fix (2026-09-23/24, Cowork audit finding: "30+ retries and
// several 504s" on bridge_admin_searchBrides -- this IS the picker Cowork
// actually hit, confirmed by the Consolidator). SAME fix as jv-comms.js's
// commsDoSearch (see that function's own header comment for the full
// incident trace): the seq guard above only ever suppressed RENDERING a
// stale response, it never stopped the underlying fetch from firing, so
// typing a real name at normal speed under a slow GAS instance produced
// several genuinely concurrent in-flight requests, each independently
// eligible for jvBridge's own 1-retry-on-failure. Never let more than one
// search be in flight; a newer keystroke arriving while one is pending is
// remembered and fired the moment the in-flight one settles, so no
// keystroke's intent is ever silently dropped, only delayed.
var _ibSearchInFlight = false;
var _ibSearchPendingQuery = null;
function ibNameKeyup() {
  clearTimeout(_ibSearchTimer);
  var q = (document.getElementById('ib-name').value || '').trim();
  var results = document.getElementById('ib-search-results');
  if (!results) return;
  if (q.length < 2) { results.style.display = 'none'; return; }
  _ibSearchTimer = setTimeout(function() { _ibDoSearch(q); }, 300);
}
function _ibDoSearch(q) {
  var results = document.getElementById('ib-search-results');
  if (!results) return;
  if (_ibSearchInFlight) {
    _ibSearchPendingQuery = q;
    return;
  }
  _ibSearchInFlight = true;
  var seq = ++_ibSearchSeq;
  jvBridge.callAdmin('bridge_admin_searchBrides', { token: ibTok_(), query: q, limit: 8 })
    .then(function(res) {
      // Stale-response guard (2026-08-30): a slower response landing after a
      // newer one, or mid-click on an already-rendered row, would otherwise
      // wipe results.innerHTML out from under the user with no error and no
      // console signal, silently clicking nothing. Only the most recent
      // request may render.
      if (seq !== _ibSearchSeq) return;
      results.innerHTML = '';
      var list = (res && res.ok && Array.isArray(res.data)) ? res.data : [];
      if (!list.length) {
        var none = document.createElement('div');
        none.style.cssText = 'padding:10px 14px;font-size:12px;color:#8a7e7b;';
        none.textContent = 'No match. Use "Add them here" for a new client.';
        results.appendChild(none);
        results.style.display = 'block';
        return;
      }
      list.forEach(function(b) {
        var row = document.createElement('div');
        row.style.cssText = 'padding:10px 14px;cursor:pointer;font-size:13px;border-bottom:1px solid #f0ebe8;';
        var nm = b.fullName || ((b.firstName || '') + ' ' + (b.lastName || '')).trim() || b.email;
        row.innerHTML = '<strong>' + escHtml(nm) + '</strong>' +
          (b.weddingDateLabel ? '<span style="color:#8a7e7b;margin-left:8px;font-size:12px;">' + escHtml(b.weddingDateLabel) + '</span>' : '') +
          '<div style="color:#8a7e7b;font-size:11px;">' + escHtml(b.email || '') + '</div>';
        row.addEventListener('mouseenter', function() { this.style.background = '#faf6f4'; });
        row.addEventListener('mouseleave', function() { this.style.background = ''; });
        row.addEventListener('click', function() { ibSelectClient(b); });
        results.appendChild(row);
      });
      results.style.display = 'block';
    }).catch(function() {
      if (seq === _ibSearchSeq) results.style.display = 'none';
    }).then(function() {
      // Always runs (success, error, or stale-skip) -- the in-flight slot
      // must free up every time, same discipline as commsDoSearch's own.
      _ibSearchInFlight = false;
      if (_ibSearchPendingQuery !== null) {
        var next = _ibSearchPendingQuery;
        _ibSearchPendingQuery = null;
        _ibDoSearch(next);
      }
    });
}

function ibSelectClient(b) {
  // A different client picked mid-session means any queued cart lines
  // belonged to whoever was selected before -- never carry them over
  // (2026-09-22, cart Phase 1, same reasoning as ibClearClient).
  var newEmail = String(b.email || '').trim().toLowerCase();
  if (IB.clientEmail !== newEmail) ibClearCart_();
  // IDENTITY FIX (2026-09-24, per the Consolidator's follow-up to the search-
  // storm/D1 patch): this picker used to key EVERY downstream booking call on
  // b.rowIndex (a GAS sheet row number), the exact pattern Jess's standing
  // rule bans ("WE SHOULD NEVER RELY ON ROW NUMBERS - EVER"). Traced both
  // backend functions this picker submits to (adminCrm_internalBooking's
  // internalBooking_resolveClient_, adminCrm_serviceBooking's
  // serviceBooking_resolveClient_, both in their own .gs files) before
  // changing anything: BOTH already have a complete, already-live
  // email-based resolution path (dedupe-by-email via
  // JV_crm_findCanonicalRowByEmail when no clientId is supplied) -- the
  // rowIndex branch was only ever a same-call optimisation to skip that
  // lookup, never the sole identity path. So IB.clientEmail is now the
  // real, persisted, batch-reused identity; email replaces clientId in
  // every booking-submission arg below. rowIndex is used ONLY inside this
  // same synchronous selection (ibPrefillTrialAddress_ below), a same-call,
  // same-freshness lookup off the just-returned search result -- the
  // sanctioned "fine" case, never stored on IB or reused on a later call.
  IB.clientId = null; // retained on IB only for legacy reads elsewhere on this page; no longer the booking identity
  IB.clientName = b.fullName || ((b.firstName || '') + ' ' + (b.lastName || '')).trim() || b.email;
  IB.clientEmail = newEmail;
  document.getElementById('ib-client-id').value = IB.clientEmail || '';
  // Cosmetic fix (2026-10-01, BRIEFS/RESULTS-internal-booking-full-e2e-
  // and-ux-audit-2026-10-01.md finding 1): #ib-name is the search INPUT,
  // never written here before -- it kept whatever raw text the admin
  // typed to search (e.g. a phone number), displayed as the "client name"
  // if anything re-read this field later, even though the real booking
  // identity (email, set above) was always correct. Does not affect the
  // actual booking (the backend never reads this field, per
  // ibBuildCurrentLineArgs_ above), purely stops the stale search text
  // from looking like a wrong client name anywhere it might be displayed.
  var nameEl = document.getElementById('ib-name'); if (nameEl) nameEl.value = IB.clientName;
  var sr = document.getElementById('ib-search-results'); if (sr) sr.style.display = 'none';
  var nc = document.getElementById('ib-newclient'); if (nc) nc.classList.remove('show');
  document.getElementById('ib-picked-name').textContent = IB.clientName;
  document.getElementById('ib-picked-meta').textContent = (IB.clientEmail || '') + (b.weddingDateLabel ? '  /  ' + b.weddingDateLabel : '');
  document.getElementById('ib-picked').classList.add('show');
  document.getElementById('ib-search-field').style.display = 'none';
  // Best-effort: default the artist to the bride's Lead Owner if the search row
  // carried it. When absent the select stays on Jessica and the backend resolves
  // the real Lead Owner from the CRM row anyway.
  try { ibDefaultArtistForClient_(b); } catch (e) {}
  // Best-effort: prefill the mobile-trial address for a selected client (2026-07-22,
  // Jess). Additive, no booker logic changed. Priority: a trial-specific address she
  // submitted (TRIAL LOCATION) beats her home/postal address. Only fills #ib-location
  // when it is currently empty, so it never clobbers something the admin typed, and it
  // stays fully editable before booking. Passes b.rowIndex as a SAME-CALL-ONLY lookup
  // (see the comment above) plus expectedEmail so adminCrm_getClient self-heals to the
  // correct row if it somehow drifted between search and this click.
  try { ibPrefillTrialAddress_(b.rowIndex || null, newEmail); } catch (e) {}
}

/**
 * Fetch the selected client's best trial address and fill #ib-location if empty.
 * Reuses the existing adminCrm_getClient route (returns every CRM column on the row),
 * so no new backend. Priority: TRIAL LOCATION (a trial-specific address the bride
 * submitted, which happens occasionally) then her assembled postal/home address.
 * The field stays editable; we never overwrite a non-empty value.
 *
 * clientId here is a SAME-CALL, SAME-FRESHNESS lookup only (the row number from
 * the search result that was just clicked, fired synchronously off that click,
 * never stored on IB or reused on a later call) -- the sanctioned bounded-lookup
 * case, not the identity IB's booking-submission path relies on (that's
 * IB.clientEmail now, see ibSelectClient's own comment). expectedEmail is passed
 * alongside so adminCrm_getClient's own identity guard self-heals to the correct
 * row if it drifted in the moment between search and click, same pattern this
 * role already applied across AdminCRMAPI.gs tonight.
 */
function ibPrefillTrialAddress_(clientId, expectedEmail) {
  if (!clientId) return;
  var locEl = document.getElementById('ib-location');
  if (!locEl) return;
  // Do not clobber a value the admin has already typed.
  if (String(locEl.value || '').trim()) return;
  if (typeof jvBridge === 'undefined' || !jvBridge.callAdmin) return;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClient', args: { clientId: clientId, expectedEmail: expectedEmail || '' } })
    .then(function (res) {
      // The bridge wraps as { ok, data:<client> }; the client object spreads the raw
      // CRM columns, so TRIAL LOCATION / POSTAL ADDRESS / SUBURB are all present.
      var c = (res && res.data) ? res.data : res;
      if (!c) return;
      // Only fill if still empty (the admin may have typed while this was in flight).
      if (String(locEl.value || '').trim()) return;
      var addr = ibBestTrialAddress_(c);
      if (addr) locEl.value = addr;
    })
    .catch(function () {});
}

/** Build the best trial address string for a client: TRIAL LOCATION, else postal. */
function ibBestTrialAddress_(c) {
  var trialLoc = String(c['TRIAL LOCATION'] || '').trim();
  if (trialLoc) return trialLoc;
  var parts = [
    String(c['POSTAL ADDRESS 1'] || '').trim(),
    String(c['POSTAL ADDRESS 2'] || '').trim(),
    String(c['SUBURB'] || '').trim(),
    String(c['STATE'] || '').trim(),
    String(c['POSTCODE'] || '').trim()
  ].filter(function (p) { return p; });
  return parts.join(', ');
}

function ibClearClient(silent) {
  IB.clientId = null; IB.clientName = ''; IB.clientEmail = '';
  var idEl = document.getElementById('ib-client-id'); if (idEl) idEl.value = '';
  var picked = document.getElementById('ib-picked'); if (picked) picked.classList.remove('show');
  var sf = document.getElementById('ib-search-field'); if (sf) sf.style.display = '';
  var nameEl = document.getElementById('ib-name'); if (nameEl) nameEl.value = '';
  var nc = document.getElementById('ib-newclient'); if (nc) nc.classList.remove('show');
  // A new/cleared client identity means any queued lines belonged to a
  // DIFFERENT client -- never carry them over (2026-09-22, cart Phase 1).
  ibClearCart_();
}

/* ============================================================
   BOOKING CART (2026-09-22, BUILD-admin-booker-multiservice-cart-
   2026-09-22.md, Phase 1). One line per queued service for the SAME
   client, so an admin who intends to book a trial AND a spray tan for
   one bride sees both lines listed before confirming, instead of the
   pre-cart behaviour where clicking "Confirm" once silently only ever
   submitted whichever single service was on the form at that moment.
   ============================================================ */

function ibClearCart_() {
  IB.cart = [];
  ibRenderCart_();
}

/* Read the exact same fields submitInternalBooking() already validates and
   reads, but push the result onto the cart instead of submitting it
   immediately. Reuses that function's validation by design -- see the
   shared helper below -- so the two code paths can never drift apart on
   what counts as "ready to submit." */
function ibAddToCart_() {
  var status = document.getElementById('ib-status');
  function fail(msg) { status.textContent = msg; status.style.color = 'var(--brand-primary-deep,#a9706c)'; }

  var built = ibBuildCurrentLineArgs_(fail);
  if (!built) return; // validation failed, fail() already showed the message

  IB.cart.push(built);
  status.textContent = 'Added to booking. Configure the next service, or confirm the booking.';
  status.style.color = 'var(--brand-dark,#1e1716)';
  ibRenderCart_();
  ibResetCurrentLine_();
}

/* Shared by both ibAddToCart_ and submitInternalBooking (the "current line"
   is submitted as part of the batch too, same as the pre-cart single-submit
   path) -- the ONE place that reads form fields into an args object + kind
   label, so a validation rule added here applies identically whether the
   line goes straight to submit (no cart used, old behaviour unchanged) or
   through "Add to booking" first. */
function ibBuildCurrentLineArgs_(fail) {
  var args = { token: ibTok_() };
  var ncOpen = document.getElementById('ib-newclient').classList.contains('show');
  // email, not clientId (row number) -- see ibSelectClient's own comment.
  // Both backend functions this submits to (adminCrm_internalBooking /
  // adminCrm_serviceBooking) already resolve+dedupe an existing client by
  // email natively, confirmed by reading internalBooking_resolveClient_ /
  // serviceBooking_resolveClient_ before making this change.
  if (IB.clientEmail && !ncOpen) {
    args.email = IB.clientEmail;
  } else {
    var first = (document.getElementById('ib-nc-first').value || '').trim();
    var last = (document.getElementById('ib-nc-last').value || '').trim();
    var email = (document.getElementById('ib-nc-email').value || '').trim();
    var phone = (document.getElementById('ib-nc-phone').value || '').trim();
    var wedding = (document.getElementById('ib-nc-wedding').value || '').trim();
    if (!first) { fail('Pick an existing client, or fill in the new-client first name.'); return null; }
    if (!email) { fail('A client email is required to link and confirm the booking.'); return null; }
    args.newClient = { firstName: first, lastName: last, email: email, phone: phone, weddingDate: wedding };
  }

  if (!IB.service) { fail('Choose a trial service.'); return null; }
  if (!IB.date || !IB.time) { fail('Pick a date and time on the calendar.'); return null; }
  if (IB.mode === 'Mobile' && !(document.getElementById('ib-location').value || '').trim()) {
    fail('Add the mobile address for a mobile trial.'); return null;
  }

  args.serviceType = IB.service;
  args.trialDate = IB.date;
  args.trialTime = IB.time;
  args.trialMode = IB.mode;
  args.location = (document.getElementById('ib-location').value || '').trim();
  args.notes = (document.getElementById('ib-notes').value || '').trim();
  args.sendConfirmation = !!document.getElementById('ib-send-confirm').checked;
  // Assigned-artist picker is trial-only -- S.O. service and Free Styling
  // bookings don't invite a trial artist (the field is hidden for both).
  if (IB.kind === 'trial') {
    var artSel = document.getElementById('ib-artist');
    if (artSel && artSel.value) args.assignedArtist = artSel.value;
  }
  if (IB.kind === 'service') {
    args.date = IB.date;
    args.time = ibLabelToHhmm_(IB.time);
    args.mode = IB.mode;
    args.charge = !!IB.charge;
  }
  if (IB.kind === 'free_styling') {
    // adminCrm_bookFreeStylingSession reads bookingDate/bookingTime (already
    // covered by trialDate/trialTime above) -- nothing extra needed here.
    args.bookingDate = IB.date;
    args.bookingTime = ibLabelToHhmm_(IB.time);
  }
  // Stable per-line idempotency key, EVERY kind (2026-10-06): the server
  // dedupes on it, so re-submitting after a timeout returns the SAME booking,
  // never a second one. Same client + kind + date + time always reuses it.
  args.attemptToken = ibAttemptToken_(IB.kind, args, IB.date, IB.time);

  return {
    kind: IB.kind,
    args: args,
    // Display label for the cart list, e.g. "Bridal Trial, Hair and Makeup, 23 Sep 10:30am".
    label: (IB.kind === 'service' ? 'S.O. Service' : (IB.kind === 'free_styling' ? 'Free Styling Session' : 'Bridal Trial')) +
      ', ' + IB.service + ', ' + ibLongDate_(IB.date) + ' ' + IB.time
  };
}

/* Reset only service/date/time/mode/location/notes -- explicitly NOT client
   identity (requirement #2: the admin configures the next service for the
   SAME client without re-picking or re-entering them). Mirrors ibSelectService's
   own date/time reset, plus clears location/notes/mode back to defaults. */
function ibResetCurrentLine_() {
  IB.date = ''; IB.time = ''; IB.monthCache = {};
  var hd = document.getElementById('ib-date'); if (hd) hd.value = '';
  var ht = document.getElementById('ib-time'); if (ht) ht.value = '';
  ibSetSlotSummary('Choose a date to see available times.');

  IB.mode = 'Studio';
  var modeHidden = document.getElementById('ib-mode'); if (modeHidden) modeHidden.value = 'Studio';
  document.querySelectorAll('.ib-mode-btn').forEach(function(b, i) { b.classList.toggle('active', i === 0); });
  var locRow = document.getElementById('ib-location-row'); if (locRow) locRow.classList.remove('show');
  var locEl = document.getElementById('ib-location'); if (locEl) locEl.value = '';
  var notesEl = document.getElementById('ib-notes'); if (notesEl) notesEl.value = '';

  // Re-select the first service in the grid (the grid has no "nothing
  // selected" state -- ibRenderServices always auto-picks index 0 on load,
  // so a reset lands there too, matching what a fresh view load looks like).
  // ibSelectService already remounts the scheduler on click, so only fall
  // back to a direct remount here when there was no button to click (e.g.
  // services haven't finished loading yet) -- avoids a redundant double
  // mount on the normal path.
  var grid = document.getElementById('ib-service-grid');
  var firstBtn = grid ? grid.querySelector('button.ib-svc-btn') : null;
  if (firstBtn) firstBtn.click();
  else ibMountScheduler(true);
}

function ibRenderCart_() {
  var card = document.getElementById('ib-cart-card');
  var list = document.getElementById('ib-cart-list');
  if (!card || !list) return;
  if (!IB.cart.length) { card.style.display = 'none'; list.innerHTML = ''; return; }
  card.style.display = '';
  list.innerHTML = IB.cart.map(function(entry, i) {
    return '<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;' +
      (i > 0 ? 'border-top:1px solid var(--border-color,#e8e0dc);' : '') + '">' +
      '<span style="font-size:13px;color:var(--brand-dark,#1e1716);">' + escHtml(entry.label) + '</span>' +
      '<button type="button" onclick="ibRemoveCartLine_(' + i + ')" style="background:none;border:none;color:var(--brand-primary-deep,#a9706c);font-size:12px;font-weight:700;cursor:pointer;">Remove</button>' +
      '</div>';
  }).join('');
}

function ibRemoveCartLine_(index) {
  IB.cart.splice(index, 1);
  ibRenderCart_();
}

function ibToggleNewClient() {
  var nc = document.getElementById('ib-newclient');
  if (!nc) return;
  var open = !nc.classList.contains('show');
  nc.classList.toggle('show', open);
  if (open) {
    // Switching to "new client" means any queued cart lines belonged to
    // whichever existing client was selected before -- never carry them
    // over (2026-09-22, cart Phase 1).
    if (IB.clientEmail) ibClearCart_();
    IB.clientEmail = '';
    document.getElementById('ib-client-id').value = '';
    document.getElementById('ib-picked').classList.remove('show');
    document.getElementById('ib-search-field').style.display = '';
  }
}

/* BATCH SUBMIT (2026-09-22, cart Phase 1). Sends the queued cart lines PLUS
   whatever is currently configured on the form -- so a plain single-service
   booking (nothing ever added to the cart) is a one-line batch and behaves
   exactly as before this build, byte-identical outcome to the old
   single-submit path. The currently-configured line is validated the SAME
   way "Add to booking" validates a line (ibBuildCurrentLineArgs_), so a
   half-filled form can never silently submit as part of a batch that has
   real cart lines in it.
   Lines run SEQUENTIALLY, never in parallel: the slot-conflict override is
   a blocking UI modal (bookingOverride_confirmModal_) that cannot sanely
   represent two lines at once, and sequential calls let every line after
   the first reuse the SAME resolved client id (requirement #4) instead of
   each line re-resolving/re-creating the client independently. */
function submitInternalBooking() {
  var status = document.getElementById('ib-status');
  function fail(msg) { status.textContent = msg; status.style.color = 'var(--brand-primary-deep,#a9706c)'; }

  var lines = IB.cart.slice();
  // The currently-configured line only joins the batch if it is genuinely
  // filled in -- an admin who queued two lines and left the form blank
  // (nothing more to add) must be able to confirm just the queued lines,
  // not be blocked by "choose a trial service" for a line they don't want.
  var hasCurrentLineContent = !!(IB.service && IB.date && IB.time);
  if (hasCurrentLineContent) {
    var current = ibBuildCurrentLineArgs_(fail);
    if (!current) return; // validation failed on a line the admin clearly meant to submit
    lines.push(current);
  }
  if (!lines.length) { fail('Add at least one service before confirming.'); return; }

  ibRunBatch_(lines, 0, []);
}

/* Runs one line, waits for its real outcome (including any slot-conflict
   override the admin resolves), then either continues to the next line or
   shows the aggregate summary. results[] accumulates {label, ok, message}
   per line so the final summary reflects the WHOLE batch (requirement #6),
   never just the last call's result. */
function ibRunBatch_(lines, index, results) {
  var btn = document.getElementById('ib-submit-btn');
  var addBtn = document.getElementById('ib-add-to-booking-btn');
  var status = document.getElementById('ib-status');

  if (index >= lines.length) {
    btn.disabled = false; btn.textContent = ibSubmitLabel_();
    if (addBtn) addBtn.disabled = false;

    var okCount = results.filter(function(r) { return r.ok; }).length;
    // FIX (2026-10-01, BRIEFS/RESULTS-internal-booking-full-e2e-and-ux-
    // audit-2026-10-01.md findings 1+2): this used to clear client + cart +
    // current line UNCONDITIONALLY, success or failure. A failed booking
    // (e.g. a validation error, a network hiccup) wiped the whole form the
    // admin had just filled in -- re-entry cost real minutes on a slow
    // backend, and the wipe also emptied IB.cart, so the NEXT submit
    // attempt hit a completely different, more confusing error ("Add at
    // least one service") instead of the original failure reason. Only
    // clear on a FULLY successful batch now, same "preserve state so the
    // admin can retry without re-entering everything" principle the
    // cancelled/slot-conflict branch above this one already uses. On any
    // failure the client, cart, and current-line form are left exactly as
    // they were -- re-submitting WILL re-attempt every line including any
    // that already succeeded in this batch, same already-documented
    // no-idempotency risk ibRelayTimeoutMsg_'s own comment above already
    // tells the admin to check for before retrying, not a new risk this
    // introduces.
    if (okCount === results.length) {
      ibClearClient(); // also clears IB.cart via ibClearCart_
      ['ib-nc-first', 'ib-nc-last', 'ib-nc-email', 'ib-nc-phone', 'ib-nc-wedding'].forEach(function(id) {
        var e = document.getElementById(id); if (e) e.value = '';
      });
      ibResetCurrentLine_();
    }
    var summary = results.map(function(r) {
      return r.ok ? (r.message || (r.label + ' booked.')) : (r.label + ' failed: ' + r.message);
    }).join(' ');
    status.textContent = summary;
    status.style.color = okCount === results.length ? 'var(--brand-dark,#1e1716)' : 'var(--brand-primary-deep,#a9706c)';
    // Requirement #6: never a single generic "Booking confirmed" toast when
    // more than one line was submitted, or when any line in a batch failed.
    if (results.length === 1) {
      jvToast(summary, okCount === 1 ? 'success' : 'error');
    } else {
      jvToast(summary, okCount === results.length ? 'success' : (okCount > 0 ? 'warning' : 'error'));
    }
    return;
  }

  var line = lines[index];
  // Requirement #4: reuse the client resolved by an earlier line in this
  // SAME batch (same-session, in-memory only -- see the ROW-NUMBER IDENTITY
  // note on IB.cart above) so a new client is only ever created once, on
  // the batch's first call, never once per cart line. Reuses email, not
  // clientId (a row number) -- see ibSelectClient's own comment for the
  // full trace of why this was safe to change (both backend functions
  // already resolve/dedupe by email natively).
  if (IB.clientEmail) {
    line.args.email = IB.clientEmail;
    delete line.args.newClient;
  }

  btn.disabled = true; btn.textContent = 'Booking (' + (index + 1) + ' of ' + lines.length + ')...';
  if (addBtn) addBtn.disabled = true;

  ibSubmitWithArgs_(line.args, line.kind, function(outcome) {
    // outcome.resolvedEmail is set on ANY successful call (both
    // adminCrm_internalBooking and adminCrm_serviceBooking return email on
    // success) -- captured even for the FIRST line of a brand-new client,
    // so line 2 reuses it as the real, stable identity for the rest of the
    // batch, never a row number.
    if (outcome.resolvedEmail && !IB.clientEmail) IB.clientEmail = outcome.resolvedEmail;

    if (outcome.cancelled) {
      // The admin backed out of the slot-conflict override ("Pick another
      // time") on this line. Stop the WHOLE batch here -- do NOT proceed to
      // remaining lines, and do NOT clear client/cart/form, since the admin
      // almost certainly wants to reconsider this line's time, not have it
      // silently dropped or the rest of their queued work wiped. Any EARLIER
      // lines in this batch already succeeded server-side before this point
      // and are NOT undone -- their results are still shown.
      btn.disabled = false; btn.textContent = ibSubmitLabel_();
      if (addBtn) addBtn.disabled = false;
      var doneSoFar = results.map(function(r) {
        return r.ok ? (r.message || (r.label + ' booked.')) : (r.label + ' failed: ' + r.message);
      }).join(' ');
      var msg = (doneSoFar ? doneSoFar + ' ' : '') + line.label + ' not booked -- pick a different time and try again.';
      status.textContent = msg;
      status.style.color = 'var(--brand-primary-deep,#a9706c)';
      if (results.length) jvToast(msg, 'warning');
      return;
    }

    results.push({ label: line.label, ok: outcome.ok, message: outcome.message });
    ibRunBatch_(lines, index + 1, results);
  });
}

/* 'h:mm a' label (or HH:mm) back to 24h HH:mm for the service booking handler. */
function ibLabelToHhmm_(v) {
  var s = String(v || '').trim();
  var m = s.match(/^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/);
  if (m) {
    var h = parseInt(m[1], 10) % 12;
    if (/[Pp]/.test(m[3])) h += 12;
    return ('0' + h).slice(-2) + ':' + m[2];
  }
  var m24 = s.match(/^(\d{1,2}):(\d{2})$/);
  if (m24) return ('0' + m24[1]).slice(-2) + ':' + m24[2];
  return s;
}

/* The booking POST, split out so a slot-conflict can re-fire it with
   forceOverride:true after a deliberate "book anyway" confirm (2026-06-16).
   forceOverride is NEVER set on the first submit; it is only added inside the
   override modal's onConfirm below. */
// Relay-timeout copy fix (2026-09-09, AUDIT-bride-facing-copy-leaks-2026-09-09.md
// Finding 2, from Booking Admin lane). The internal booker showed the raw "Relay
// upstream error: upstream timed out (55s)" transport string verbatim to Jess when
// the booking may have actually succeeded server-side -- traced to today's Emily
// Devile incident reading as a silent failure. Unlike the proposal-signature flow's
// relay-timeout handling (assets/jv-proposal-v2-signature.js), this does NOT
// auto-retry: adminCrm_internalBooking/adminCrm_serviceBooking generate a fresh
// bookingId per call and have no "already accepted" idempotency guard, so a blind
// retry risks a genuine second booking rather than a safe no-op. Tell the admin to
// verify before retrying instead.
/* One attemptToken per cart line (client + kind + date + time), kept for the
   page session so a retry after a timeout or failure reuses it. */
function ibAttemptToken_(kind, args, date, time) {
  IB.lineTokens = IB.lineTokens || {};
  var who = String(args.email || (args.newClient && args.newClient.email) || args.clientId || '').toLowerCase();
  var key = kind + '|' + who + '|' + date + '|' + ibLabelToHhmm_(time);
  if (!IB.lineTokens[key]) {
    IB.lineTokens[key] = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : ('ab-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12));
  }
  return IB.lineTokens[key];
}

function ibRelayTimeoutMsg_(raw) {
  var s = String(raw || '');
  if (/relay upstream error/i.test(s) || /upstream timed out/i.test(s)) {
    return 'This is taking longer than the connection allows to confirm. The booking may still ' +
      'have completed on the server, check the client’s profile before trying again, so you ' +
      'don’t create a duplicate.';
  }
  return '';
}

/* The booking POST for ONE line. kind is the PER-LINE kind (requirement #7:
   a batch can mix a trial line and an S.O. service line for the same
   client), never read from the page-level IB.kind -- IB.kind only drives
   which view/labels are showing right now, not which route a given cart
   line uses.

   done(outcome) fires exactly once per line with
   {ok, message, resolvedClientId}. This function no longer does ANY of the
   old per-call success reset (client clear, field reset, scheduler remount)
   -- that now happens exactly once, after the WHOLE batch, in ibRunBatch_.
   The slot-conflict override still resolves entirely within this one line
   (recursing into itself on "book anyway") before done() ever fires, so a
   conflict on line 1 of 2 pauses the batch on that line's own override
   modal without touching line 2 at all -- exactly the per-line handling
   requirement #5 asks for. */
/* Conflict-check preflight (2026-10-05). OFF unless window.JV_CONFLICT_CHECK_ENABLED === true.
   Asks the jv-booking-conflict Worker for a same-request decision before the booking is written.
   Authorises with the admin's own CRM session token (the Worker verifies it against D1). Fails
   closed: a missing Worker URL, a network error or a refusal stops the booking. A logged admin
   override (reason >= 10 chars) proceeds with forceOverride. */
function ibConflictPreflight_(args, kind, proceed, done) {
  var status = document.getElementById('ib-status');
  function stop(msg) {
    status.textContent = msg; status.style.color = 'var(--brand-primary-deep,#a9706c)';
    done({ ok: false, message: msg });
  }
  var url = window.JV_CONFLICT_WORKER_URL;
  if (!url) return stop('Conflict check is not configured. Booking not saved.');
  // The booking args differ by kind (service: date/time, trial: trialDate/trialTime, free styling:
  // bookingDate/bookingTime) and never carried a duration, so derive all three here rather than
  // assume them. A missing value stops the booking with a plain reason (fail closed).
  var dateISO = args.date || args.trialDate || args.bookingDate || '';
  var startTime = ibLabelToHhmm_(args.time || args.trialTime || args.bookingTime || '');
  var dur = Number(args.durationMin) ||
    Number(kind === 'free_styling' ? 15 : (IB.serviceObj && IB.serviceObj.durationMin)) || 0;
  if (!dateISO || !startTime) return stop('Cannot check the slot: date or time missing. Booking not saved.');
  if (!dur) return stop('Cannot check the slot: this service has no duration. Booking not saved.');
  var body = { dateISO: dateISO, startTime: startTime, durationMin: dur };
  if (args.overrideReason) body.override = { reason: args.overrideReason };
  var send = (window._jvNativeFetch || window.fetch).bind(window);
  send(String(url).replace(/\/+$/, '') + '/admin/slot-conflict-check', {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + ibTok_() },
    body: JSON.stringify(body)
  }).then(function(r) { return r.json().then(function(j) { return { http: r.status, body: j }; }); })
    .then(function(res) {
      var rb = res.body || {};
      // Override rejected by the Worker (reason too short etc.): say so and let the admin retry.
      if (res.http === 400 && args.overrideReason) {
        delete args.overrideReason;
        return ibConflictOverrideDialog_(rb, dateISO, startTime, args, kind, proceed, done, stop, rb.error);
      }
      if (res.http !== 200 || !rb.ok && !rb.needsOverride) return stop('Conflict check failed (' + res.http + '). Booking not saved.');
      if (rb.overridden) {
        args.forceOverride = true;
        if (rb.logged === false) { try { jvToast('Override went through but could not be written to the audit log. Tell Jess.', 'warning'); } catch (_) {} }
        return proceed();
      }
      if (rb.refuse) {
        // The Worker says an admin may override this block (a clash, or calendar data that is
        // stale or missing). Ask once, with a written reason, never silently allow.
        if (rb.needsOverride) return ibConflictOverrideDialog_(rb, dateISO, startTime, args, kind, proceed, done, stop, '');
        return stop('That time clashes with an existing booking or is unverified. Booking not saved.');
      }
      proceed();
    })
    .catch(function() { stop('Conflict check unreachable. Booking not saved.'); });
}

/* ONE confirmation with a written reason (min 10 characters, enforced again by the Worker, which
   writes the audit row). Cancel leaves the booking unsaved; confirm re-runs the same check with
   the reason attached. Uses the same overlay look as the other booking override dialog. */
function ibConflictOverrideDialog_(rb, dateISO, startTime, args, kind, proceed, done, stop, errMsg) {
  pipelineLock_injectStyles_();
  var kinds = {
    conflict: 'That time clashes with an existing booking on the calendar.',
    unverified: 'One of the calendars could not be read, so the time cannot be confirmed as free.' +
      (rb.unverified && rb.unverified.length ? ' (' + rb.unverified.join(', ') + ')' : ''),
    unavailable: 'Google Calendar did not answer, so the time cannot be confirmed as free.'
  };
  var what = kinds[rb.overrideKind] || 'The calendar check could not confirm this time is free.';
  var overlay = document.createElement('div');
  overlay.className = 'jv-lock-overlay';
  overlay.innerHTML =
    '<div class="jv-lock-modal">' +
    '<h3>Calendar check blocked this booking.</h3>' +
    '<p class="jv-lock-sub">' + escHtml(dateISO) + ' at ' + escHtml(startTime) + '</p>' +
    '<p style="font-size:.92rem;line-height:1.55;color:var(--brand-dark,#1e1716);margin:0 0 .8rem">' + escHtml(what) +
      ' You can book anyway. Your name and the reason below are recorded in the audit log.</p>' +
    '<label style="display:block;font-size:.84rem;margin:0 0 .3rem">Why is it OK to book this? (at least 10 characters)</label>' +
    '<textarea id="jvCcReason" rows="3" style="width:100%;box-sizing:border-box;font:inherit;border-radius:.6rem;padding:.5rem"></textarea>' +
    '<div id="jvCcErr" style="color:var(--brand-primary-deep,#a9706c);font-size:.82rem;margin-top:.3rem;min-height:1em">' + escHtml(errMsg || '') + '</div>' +
    '<div class="jv-lock-footer">' +
    '<button class="jv-lock-cancel" id="jvCcCancel">Do not book</button>' +
    '<button class="jv-lock-confirm" id="jvCcConfirm" disabled>Book anyway (logged)</button>' +
    '</div></div>';
  document.body.appendChild(overlay);
  var reasonEl = overlay.querySelector('#jvCcReason');
  var confirmBtn = overlay.querySelector('#jvCcConfirm');
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  reasonEl.addEventListener('input', function() { confirmBtn.disabled = reasonEl.value.trim().length < 10; });
  overlay.addEventListener('click', function(e) {
    if (e.target.id === 'jvCcCancel') { close_(); stop('Booking not saved: the calendar check blocked it.'); return; }
    if (e.target.id === 'jvCcConfirm') {
      var reason = reasonEl.value.trim();
      if (reason.length < 10) return;
      close_();
      args.overrideReason = reason;
      ibConflictPreflight_(args, kind, proceed, done);
    }
  });
}

function ibSubmitWithArgs_(args, kind, done) {
  if (window.JV_CONFLICT_CHECK_ENABLED === true) {
    return ibConflictPreflight_(args, kind, function() { ibSubmitWithArgsDirect_(args, kind, done); }, done);
  }
  return ibSubmitWithArgsDirect_(args, kind, done);
}

/* D1-FIRST SUBMIT (2026-10-06, unified admin booker, Cloudflare-first).
   The relay writes ONE durable row to jv-admin-saves' admin_booking_outbox and
   answers in ~200ms; the GAS drain books it in the background and the page
   learns the real outcome from ibPendingTick_ (polling D1, never GAS).
   While the relay flag is off, the route answers {fallback:'gas'} and the
   line goes through the existing synchronous GAS routes unchanged.
   window.JV_ADMIN_BOOKING_D1 === false is a page-level kill switch. */
function ibSubmitWithArgsDirect_(args, kind, done) {
  if (window.JV_ADMIN_BOOKING_D1 === false) return ibLegacySubmit_(args, kind, done);
  ibD1Submit_(args, kind).then(function(d) {
    // Fall back to the existing GAS route when the outbox is switched off
    // ({fallback:'gas'}) AND when the relay does not know the route yet
    // ('Unknown route' from GAS): a theme shipped ahead of the relay must
    // degrade to the old booker, never break booking.
    if (!d || d.fallback || (!d.ok && !d.bookingRef && /unknown route/i.test(String(d.error || '')))) {
      return ibLegacySubmit_(args, kind, done);
    }
    if (!d.ok) {
      // jvBridge resolves (never rejects) on transport failure, with
      // {ok:false, error:'network'} or a relay timeout string. Those are NOT
      // refusals: the line is intact and retrying is safe, so say exactly that
      // instead of surfacing a raw transport word.
      var transport = !d.error || /network|relay|upstream|timed out|failed to fetch|load failed/i.test(String(d.error));
      done({ ok: false, message: transport ? IB_D1_UNREACHABLE_MSG_ : d.error, resolvedClientId: null });
      return;
    }
    if (d.state === 'done') {
      ibPendingShowResult_(d, args, kind);
      done({ ok: true, message: d.message, resolvedClientId: null, resolvedEmail: d.email || null });
      return;
    }
    ibPendingTrack_(d, args, kind);
    done({ ok: true, pending: true, message: d.message, resolvedClientId: null, resolvedEmail: d.email || null });
  }).catch(function() {
    done({ ok: false, message: IB_D1_UNREACHABLE_MSG_, resolvedClientId: null });
  });
}

var IB_D1_UNREACHABLE_MSG_ = 'Could not reach the booking service. Your booking is still here, press confirm again (safe, it will not double-book).';

function ibD1Submit_(args, kind) {
  return jvBridge.callAdmin('bridge_admin_bookingSubmitD1', {
    kind: kind,
    idempotency_key: args.attemptToken,
    forceOverride: !!args.forceOverride,
    admin_email: (window.jvAuth && window.jvAuth.email) || '',
    args: args
  }).then(ibD1Unwrap_);
}

/* The relay returns the Worker's JSON directly; tolerate a {data:...} wrap. */
function ibD1Unwrap_(res) {
  if (res && res.data && (res.data.bookingRef || res.data.fallback)) return res.data;
  return res || null;
}

/* ---- Background confirmation tracker -------------------------------------
   Every line saved to the outbox is tracked here until its real outcome is
   known. State shown per line, never collapsed into one "Loaded":
     Confirming  -> saved, the booking is being made
     Booked      -> confirmed by the engine (pay link shown when created)
     Needs your decision -> time clash; the existing "book anyway" modal opens
     Not booked  -> failed; Jess has an admin Chat alert too
   Polls D1 only (fast, no GAS). Stops tracking a line after 10 minutes and
   says so honestly: the drain keeps working and alerts Jess on failure. */
var IB_PENDING_POLL_MS_ = 5000;
var IB_PENDING_GIVEUP_MS_ = 10 * 60 * 1000;

function ibPendingLabel_(args, kind) {
  if (kind === 'free_styling') return 'Free Styling Session';
  return String(args.serviceType || (kind === 'trial' ? 'Bridal Trial' : 'Service'));
}

function ibPendingTrack_(d, args, kind) {
  IB.pending = IB.pending || {};
  IB.pending[d.bookingRef] = {
    ref: d.bookingRef, args: args, kind: kind, label: ibPendingLabel_(args, kind),
    date: d.bookingDate, time: d.bookingTime, state: 'confirming', message: d.message,
    startedAt: Date.now(), checkoutUrl: ''
  };
  ibPendingRender_();
  ibPendingSchedule_();
}

function ibPendingShowResult_(d, args, kind) {
  IB.pending = IB.pending || {};
  IB.pending[d.bookingRef] = {
    ref: d.bookingRef, args: args, kind: kind, label: ibPendingLabel_(args, kind),
    date: d.bookingDate, time: d.bookingTime, state: 'booked', message: d.message,
    startedAt: Date.now(), checkoutUrl: (d.result && d.result.checkoutUrl) || ''
  };
  ibPendingRender_();
}

function ibPendingSchedule_() {
  if (IB._pendingTimer) return;
  IB._pendingTimer = setTimeout(function() { IB._pendingTimer = null; ibPendingTick_(); }, IB_PENDING_POLL_MS_);
}

function ibPendingTick_() {
  var open = Object.keys(IB.pending || {}).map(function(k) { return IB.pending[k]; })
    .filter(function(p) { return p.state === 'confirming'; });
  if (!open.length) return;
  Promise.all(open.map(function(p) {
    if (Date.now() - p.startedAt > IB_PENDING_GIVEUP_MS_) {
      p.state = 'background';
      p.message = 'Still confirming in the background. Jess gets an admin Chat alert if it cannot be booked.';
      return null;
    }
    return jvBridge.callAdmin('bridge_admin_bookingStatusD1', { bookingRef: p.ref })
      .then(ibD1Unwrap_)
      .then(function(d) { if (d && d.ok) ibPendingApply_(p, d); })
      .catch(function() { /* keep the last known state, try again next tick */ });
  })).then(function() {
    ibPendingRender_();
    ibPendingSchedule_();
  });
}

function ibPendingApply_(p, d) {
  if (d.state === 'done') {
    p.state = 'booked';
    p.message = d.message;
    p.checkoutUrl = (d.result && d.result.checkoutUrl) || '';
    jvToast(d.message, (d.result && d.result.warning) ? 'warning' : 'success');
  } else if (d.state === 'failed') {
    p.state = 'failed';
    p.message = d.message;
    jvToast(p.label + ' for ' + d.email + ' was not booked. ' + d.message, 'error');
  } else if (d.state === 'conflict') {
    p.state = 'decision';
    p.message = d.message;
    ibPendingResolveConflict_(p);
  } else {
    p.message = d.message;   // still pending/running; may carry "(retrying: ...)"
  }
}

/* Conflict found by the drain: reuse the existing deliberate two-step
   "book anyway" modal. Confirm re-submits the SAME bookingRef with
   forceOverride, which re-arms that same outbox row (never a second one). */
function ibPendingResolveConflict_(p) {
  bookingOverride_confirmModal_({
    whatLabel: p.kind === 'service' ? (p.args.serviceType || 'service') : (p.kind === 'free_styling' ? 'Free Styling Session' : 'trial'),
    dateLabel: p.date, timeLabel: p.time
  }, function(choice) {
    p.args.forceOverride = true;
    if (p.kind !== 'free_styling') p.args.sendConfirmation = !!(choice && choice.sendConfirmation);
    p.state = 'confirming'; p.startedAt = Date.now();
    p.message = 'Booking anyway, confirming now.';
    ibPendingRender_();
    ibD1Submit_(p.args, p.kind).then(function(d) {
      if (d && d.ok) { ibPendingApply_(p, d); ibPendingRender_(); ibPendingSchedule_(); return; }
      p.state = 'failed'; p.message = (d && d.error) || 'Could not save the override. Try again.';
      ibPendingRender_();
    }).catch(function() {
      p.state = 'decision'; p.message = 'Could not reach the booking service. Open it again to retry.';
      ibPendingRender_();
    });
  }, function() {
    p.state = 'failed';
    p.message = 'Not booked: you chose another time for this one.';
    ibPendingRender_();
  });
}

var IB_PENDING_STATE_LABEL_ = { confirming: 'Confirming', booked: 'Booked', decision: 'Needs your decision', failed: 'Not booked', background: 'Confirming in background' };

function ibPendingRender_() {
  var host = document.getElementById('ib-pending');
  if (!host) {
    var status = document.getElementById('ib-status');
    if (!status || !status.parentNode) return;
    host = document.createElement('div');
    host.id = 'ib-pending';
    host.setAttribute('aria-live', 'polite');
    host.style.cssText = 'margin-top:12px;display:flex;flex-direction:column;gap:8px;';
    status.parentNode.insertBefore(host, status.nextSibling);
  }
  var items = Object.keys(IB.pending || {}).map(function(k) { return IB.pending[k]; })
    .sort(function(a, b) { return b.startedAt - a.startedAt; }).slice(0, 8);
  if (!items.length) { host.innerHTML = ''; return; }
  host.innerHTML = items.map(function(p) {
    var tone = p.state === 'booked' ? 'var(--brand-primary-deep,#a9706c)'
      : (p.state === 'failed' || p.state === 'decision') ? 'var(--status-action-text,#b32727)'
      : 'var(--text-light,#8a7e7b)';
    var pay = p.checkoutUrl
      ? ' <a href="' + escHtml(p.checkoutUrl) + '" target="_blank" rel="noopener" style="color:var(--brand-primary-deep,#a9706c);font-weight:700;">open / copy the client pay link</a>'
      : '';
    return '<div style="border:1px solid var(--border-color,#e8e0dc);border-radius:var(--radius-medium,1rem);padding:10px 14px;font-size:13px;background:var(--brand-bg-white,#fff);">' +
      '<span style="font-weight:800;color:' + tone + ';">' + escHtml(IB_PENDING_STATE_LABEL_[p.state] || p.state) + '</span>' +
      ' <span style="color:var(--brand-dark,#1e1716);">' + escHtml(p.label + ', ' + (p.date || '') + ' ' + (p.time || '')) + '</span>' +
      '<div style="color:var(--brand-text,#2f2524);margin-top:2px;">' + escHtml(p.message || '') + pay + '</div></div>';
  }).join('');
}

/* LEGACY synchronous GAS path (unchanged behaviour). Used only while the relay
   answers {fallback:'gas'} (outbox not yet armed) or the page kill switch is
   set. */
function ibLegacySubmit_(args, kind, done) {
  var status = document.getElementById('ib-status');
  function fail(msg) { status.textContent = msg; status.style.color = 'var(--brand-primary-deep,#a9706c)'; }

  var isService = kind === 'service';
  var isFreeStyling = kind === 'free_styling';
  var route = isService ? 'adminCrm_serviceBooking' : (isFreeStyling ? 'adminCrm_bookFreeStylingSession' : 'adminCrm_internalBooking');

  jvBridge.callAdmin('bridge_admin_generic', { function: route, args: args })
    .then(function(res) {
      var data = (res && res.ok) ? res.data : res;
      if (data && data.ok) {
        var okMsg = data.message || (isService ? 'Booking confirmed.' : (isFreeStyling ? 'Free Styling Session confirmed.' : 'Trial confirmed.'));
        // Free Styling acks fast and books in the background (2026-10-06).
        if (isFreeStyling && data.pending && !data.message) {
          okMsg = 'Saved. Confirming the booking now; the Zoom link goes to the client as soon as it is booked.';
        }
        // Pay-link path: surface the checkout URL so the admin can copy + send it.
        // Shown per-line (mid-batch) since a later line's summary must not
        // bury an earlier line's pay link.
        if (isService && data.checkoutUrl) {
          ibSetSlotSummary('Pay link ready: <a href="' + escHtml(data.checkoutUrl) +
            '" target="_blank" rel="noopener" style="color:var(--brand-primary-deep,#a9706c);font-weight:700;">open / copy the client pay link</a>');
        }
        if (data.overrideApplied) jvToast(okMsg, 'warning');
        // resolvedEmail added 2026-09-24 alongside resolvedClientId (kept,
        // unchanged, for any other reader) -- the real identity ibRunBatch_
        // now reuses for the rest of the batch is email, not the row
        // number. Both adminCrm_internalBooking and adminCrm_serviceBooking
        // return email on success (the latter's own return statement fixed
        // in this same change, see ServiceBookingAPI_2026_06_16.gs).
        done({ ok: true, message: okMsg, resolvedClientId: data.clientId || null, resolvedEmail: data.email || null });
      } else if (data && data.slotConflict && !args.forceOverride) {
        // The availability engine refused this slot. Offer the deliberate
        // two-step "book anyway" override (never auto-retried). Pauses THIS
        // line only -- done() does not fire until the admin resolves it,
        // so ibRunBatch_ never advances to the next line mid-conflict.
        //
        // "Pick another time" (Cancel) never called done() before this build
        // either (pre-existing bookingOverride_confirmModal_ behaviour) --
        // in the OLD single-line flow the button was already reset to idle
        // BEFORE this branch ran, so a stuck Cancel was invisible. In a
        // batch, done() is what advances ibRunBatch_ and resets the button,
        // so Cancel now needs an explicit signal or the button would stay
        // on "Booking (N of M)..." forever. done({ok:false, cancelled:true})
        // tells ibRunBatch_ to stop the WHOLE batch here (an admin backing
        // out of a conflict on line 2 almost certainly wants to reconsider,
        // not silently skip to line 3), not just this one line.
        fail('That time clashes with an existing booking.');
        bookingOverride_confirmModal_({
          whatLabel: isService ? (args.serviceType || 'service') : 'trial',
          dateLabel: args.trialDate || args.date,
          timeLabel: args.trialTime || args.time
        }, function(choice) {
          args.forceOverride = true;
          // Q4: confirmation defaults OFF for an override; admin opts back in via the modal.
          args.sendConfirmation = !!(choice && choice.sendConfirmation);
          ibSubmitWithArgs_(args, kind, done);
        }, function() {
          done({ ok: false, cancelled: true, message: 'Cancelled -- time clashes with an existing booking.', resolvedClientId: null });
        });
      } else {
        var rawErr = (data && data.error) || (res && res.error) || 'Booking failed.';
        var err = (isFreeStyling && ibRelayTimeoutMsg_(rawErr)) ? ibFsTimeoutMsg_() : (ibRelayTimeoutMsg_(rawErr) || rawErr);
        done({ ok: false, message: err, resolvedClientId: (data && data.clientId) || null });
      }
    }).catch(function(e) {
      var rawErr = (e && e.message) || 'Error creating booking.';
      var msg = (isFreeStyling && ibRelayTimeoutMsg_(rawErr)) ? ibFsTimeoutMsg_() : (ibRelayTimeoutMsg_(rawErr) || rawErr);
      done({ ok: false, message: msg, resolvedClientId: null });
    });
}

/* Free Styling retries are deduped server-side on attemptToken, so the
   timeout copy can say plainly that pressing confirm again is safe. */
function ibFsTimeoutMsg_() {
  return 'The connection was slow to answer. Press confirm again: it is safe and will not create a second booking.';
}

/* ============================================================
   AVAILABILITY OVERRIDE: deliberate two-step "book anyway" confirm
   (2026-06-16). Admin-only (the whole view is jv-admin gated, and the
   bridge/handler re-validate the admin token). Shared by the trial
   internal booker AND the S.O. service booker. The override is
   unreachable on a clean booking; this modal only renders AFTER the
   engine has refused a specific slot. The confirm button stays disabled
   until the "I understand this double-books" checkbox is ticked, so it
   can never be a reflexive double-tap.
   ============================================================ */
function bookingOverride_confirmModal_(detail, onConfirm, onCancel) {
  pipelineLock_injectStyles_();
  detail = detail || {};
  var what = escHtml(detail.whatLabel || 'booking');
  var when = escHtml((detail.dateLabel || '') + (detail.timeLabel ? ' at ' + detail.timeLabel : ''));
  var overlay = document.createElement('div');
  overlay.className = 'jv-lock-overlay';
  overlay.innerHTML =
    '<div class="jv-lock-modal">' +
    '<h3>This time isn\'t free.</h3>' +
    '<p class="jv-lock-sub">' + what.charAt(0).toUpperCase() + what.slice(1) + ' &middot; ' + (when || 'selected slot') + '</p>' +
    '<p style="font-size:.92rem;line-height:1.55;color:var(--brand-dark,#1e1716);margin:0 0 1rem">' +
      'The availability engine says <strong>' + (when || 'this slot') + '</strong> clashes with an existing booking. ' +
      'You can override and book anyway if you know your capacity allows it. ' +
      'A forced booking is recorded in the audit log, flagged on the calendar event, and pings the admin Chat.' +
    '</p>' +
    '<label style="display:flex;align-items:flex-start;gap:.6rem;font-size:.86rem;line-height:1.4;color:var(--brand-text,#2f2524);cursor:pointer;margin:0 0 .5rem">' +
      '<input type="checkbox" id="jvOvAck" style="width:auto;margin-top:.15rem;flex-shrink:0">' +
      '<span>I understand this double-books an artist.</span>' +
    '</label>' +
    '<label style="display:flex;align-items:flex-start;gap:.6rem;font-size:.82rem;line-height:1.4;color:var(--brand-text,#2f2524);opacity:.85;cursor:pointer;margin:0 0 .25rem">' +
      '<input type="checkbox" id="jvOvSendConf" style="width:auto;margin-top:.15rem;flex-shrink:0">' +
      '<span>Also send the client a confirmation (off by default for an override).</span>' +
    '</label>' +
    '<div class="jv-lock-footer">' +
    '<button class="jv-lock-cancel" id="jvOvCancel">Pick another time</button>' +
    '<button class="jv-lock-confirm" id="jvOvConfirm" disabled>Book anyway (override)</button>' +
    '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  var ack = overlay.querySelector('#jvOvAck');
  var sendConf = overlay.querySelector('#jvOvSendConf');
  var confirmBtn = overlay.querySelector('#jvOvConfirm');
  ack.addEventListener('change', function() { confirmBtn.disabled = !ack.checked; });
  overlay.addEventListener('click', function(e) {
    if (e.target.id === 'jvOvCancel') {
      close_();
      try { onCancel && onCancel(); } catch (_) {}
      return;
    }
    if (e.target.id === 'jvOvConfirm') {
      if (!ack.checked) return;
      close_();
      try { onConfirm && onConfirm({ sendConfirmation: !!sendConf.checked }); } catch (_) {}
    }
  });
}

/* Open the Internal Booking view pre-filled for a known client (drawer Book action). */
function ibOpenForClient(client) {
  if (typeof switchView === 'function') switchView('internal-booking');
  else loadInternalBookingView();
  setTimeout(function() {
    if (client && client.rowIndex) {
      ibSelectClient({
        rowIndex: client.rowIndex,
        fullName: client.fullName || client.name || '',
        firstName: client.firstName || '',
        lastName: client.lastName || '',
        email: client.email || '',
        weddingDateLabel: client.weddingDateLabel || ''
      });
    }
  }, 60);
}

/* ============================================================
   ANALYTICS VIEW
   ============================================================ */
function loadAnalyticsView() {
  showLoader('analytics');
  var period = parseInt(document.getElementById('analytics-period').value) || 90;
  STATE.reportPeriod = period;

  // Populate year selector for profitability if empty
  var yearSel = document.getElementById('profit-year');
  if (yearSel && yearSel.options.length === 0) {
    var curYear = new Date().getFullYear();
    for (var y = curYear; y >= curYear - 3; y--) {
      var opt = document.createElement('option');
      opt.value = y; opt.textContent = y;
      yearSel.appendChild(opt);
    }
  }

  // TODO: Bridge route needed for: adminApi_getAdvancedAnalytics
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getAdvancedAnalytics', args: { token: STATE.token, period: period } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      renderAnalytics(data);
      showContent('analytics');
    }; _h(res.data); } else { var _e = function(err){ showError('analytics', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('analytics', err.message || String(err)); });

  // Load additional sections in parallel
  loadPnlSection();
  loadKpiSection();
  loadProfitabilitySection();
  loadTrueMarginSection();
  loadArtistBillsSection();
}

function renderAnalytics(data) {
  if (!data) return;
  // Stats
  var statsEl = document.getElementById('analytics-stats');
  var statsHtml = '';
  if (data.stats) {
    data.stats.forEach(function(s) {
      statsHtml += '<div class="stat-tile"><div class="stat-value">' + escHtml(String(s.value || '—')) + '</div>';
      statsHtml += '<div class="stat-label">' + escHtml(s.label || '') + '</div>';
      if (s.sub) statsHtml += '<div style="font-size:0.68rem;color:var(--text-light);margin-top:0.2rem;">' + escHtml(s.sub) + '</div>';
      statsHtml += '</div>';
    });
  }
  statsEl.innerHTML = statsHtml;

  // Sources
  var srcEl = document.getElementById('analytics-sources');
  var srcHtml = '';
  if (data.sources) {
    var maxSrc = Math.max.apply(null, data.sources.map(function(s){ return s.count || 0; })) || 1;
    data.sources.forEach(function(s) {
      var pct = Math.round(((s.count || 0) / maxSrc) * 100);
      srcHtml += '<div class="bar-item"><span class="bar-label">' + escHtml(s.label || '') + '</span>';
      srcHtml += '<div class="bar-track"><div class="bar-fill" style="width:' + pct + '%"></div></div>';
      srcHtml += '<span class="bar-val">' + (s.count || 0) + '</span></div>';
    });
  }
  srcEl.innerHTML = srcHtml || '<p style="font-size:0.8rem;color:var(--text-light);">No data.</p>';

  // Services
  var svcEl = document.getElementById('analytics-services');
  var svcHtml = '';
  if (data.services) {
    var maxSvc = Math.max.apply(null, data.services.map(function(s){ return s.count || 0; })) || 1;
    data.services.forEach(function(s) {
      var pct = Math.round(((s.count || 0) / maxSvc) * 100);
      svcHtml += '<div class="bar-item"><span class="bar-label">' + escHtml(s.name || '') + '</span>';
      svcHtml += '<div class="bar-track"><div class="bar-fill" style="width:' + pct + '%"></div></div>';
      svcHtml += '<span class="bar-val">' + (s.count || 0) + '</span></div>';
    });
  }
  svcEl.innerHTML = svcHtml || '<p style="font-size:0.8rem;color:var(--text-light);">No data.</p>';
}

/* ────────────────────────────────────────────────────────────────
   ANALYTICS — P&L Section
   ──────────────────────────────────────────────────────────────── */
function loadPnlSection() {
  var period = document.getElementById('pnl-period').value || 'thisQuarter';
  var _pnlBg_ = function() {
    // TODO: Bridge route needed for: adminApi_getAnalyticsPnL
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getAnalyticsPnL', args: { token: STATE.token, period: period } })
      .then(function(res) { if (res.ok) renderPnl(res.data); else { var errFn = function(err) {
        document.getElementById('pnl-message').style.display = 'block';
        document.getElementById('pnl-message').textContent = 'Error loading P&L: ' + (err.message || err);
      }; errFn(res.error); } })
      .catch(function(err) {
        document.getElementById('pnl-message').style.display = 'block';
        document.getElementById('pnl-message').textContent = 'Error loading P&L: ' + (err.message || err);
      });
  };
  // T3 (Group B): paint from the analytics CDN island first, but ONLY when the selected
  // period equals the cached PnL default (pnl_period) so the numbers match the label.
  // Then always background-refresh live. Any other period -> live only (no island).
  adminCacheParseIsland_('jv-admin-analytics-cache', function(cached) {
    if (cached && cached.pnl && cached.pnl_period && period === cached.pnl_period) {
      renderPnl(cached.pnl);
    }
    _pnlBg_();
  });
}

function renderPnl(data) {
  if (!data) return;
  var msgEl = document.getElementById('pnl-message');
  var bodyEl = document.getElementById('pnl-body');

  if (data.error) {
    msgEl.textContent = data.error;
    msgEl.style.display = 'block';
    bodyEl.style.display = 'none';
    return;
  }

  if (data.message) {
    msgEl.textContent = data.message;
    msgEl.style.display = 'block';
    if (data.revenue === 0 && data.expenses === 0) { bodyEl.style.display = 'none'; return; }
  } else {
    msgEl.style.display = 'none';
  }
  bodyEl.style.display = '';

  var margin = (data.margin != null) ? data.margin : 0;

  // Tiles
  var tilesEl = document.getElementById('pnl-tiles');
  tilesEl.innerHTML =
    '<div class="stat-tile"><div class="stat-value">' + anFmtDollar(data.revenue) + '</div><div class="stat-label">Revenue</div>' +
      (data.source ? '<div style="font-size:0.62rem;color:var(--text-light);margin-top:0.15rem;">' + (data.source === 'xero' ? 'Xero-confirmed' : 'From XERO_PNL sheet') + '</div>' : '') +
    '</div>' +
    '<div class="stat-tile"><div class="stat-value">' + anFmtDollar(data.expenses) + '</div><div class="stat-label">Expenses</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + (data.netProfit >= 0 ? 'success' : 'danger') + '">' + anFmtDollar(data.netProfit) + '</div><div class="stat-label">Net Profit</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + (margin >= 40 ? 'success' : margin >= 20 ? 'warn' : 'danger') + '">' + margin + '%</div><div class="stat-label">Margin</div></div>';

  // Revenue breakdown
  var revEl = document.getElementById('pnl-rev-breakdown');
  revEl.innerHTML = anRenderBreakdownBars(data.revenueBreakdown);

  // Expense breakdown
  var expEl = document.getElementById('pnl-exp-breakdown');
  expEl.innerHTML = anRenderBreakdownBars(data.expenseBreakdown);

  // Trend
  renderPnlTrend(data.trend);
}

function anRenderBreakdownBars(items) {
  if (!items || !items.length) return '<p style="font-size:0.78rem;color:var(--text-light);">No data</p>';
  var max = Math.max.apply(null, items.map(function(i) { return i.amount; })) || 1;
  var html = '';
  items.forEach(function(item) {
    var pct = Math.round((item.amount / max) * 100);
    html += '<div class="bar-item"><span class="bar-label">' + escHtml(item.category) + '</span>';
    html += '<div class="bar-track"><div class="bar-fill" style="width:' + pct + '%"></div></div>';
    html += '<span class="bar-val">' + anFmtDollar(item.amount) + '</span></div>';
  });
  return html;
}


/* ===== TRUE MARGIN (BRIEF-02) ===== */
function loadTrueMarginSection() {
  var sel = document.getElementById('truemargin-period');
  var period = (sel && sel.value) || 'thisQuarter';
  var _tmBg_ = function() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getTrueMarginPnL', args: { token: STATE.token, period: period } })
      .then(function(res) { if (res.ok) renderTrueMargin(res.data); else renderTrueMarginMsg_(res.error && res.error.message || 'Could not load true margin.'); })
      .catch(function(err) { renderTrueMarginMsg_(err && err.message || String(err)); });
  };
  // T3 (Group B): paint True Margin from the analytics CDN island first, ONLY when the
  // selected period equals the cached default (pnl_period) so the money numbers match the
  // label. Then always background-refresh live. This is one of the two NEW panels that
  // tipped the tab past 30s, so caching it is the actual timeout cure.
  adminCacheParseIsland_('jv-admin-analytics-cache', function(cached) {
    if (cached && cached.trueMargin && cached.pnl_period && period === cached.pnl_period) {
      try { renderTrueMargin(cached.trueMargin); } catch (e) {}
    }
    _tmBg_();
  });
}

function renderTrueMarginMsg_(msg) {
  var m = document.getElementById('truemargin-message');
  var b = document.getElementById('truemargin-body');
  if (m) { m.style.display = 'block'; m.textContent = msg; }
  if (b) b.style.display = 'none';
}

function renderTrueMargin(data) {
  var m = document.getElementById('truemargin-message');
  var b = document.getElementById('truemargin-body');
  if (!data) { renderTrueMarginMsg_('No data.'); return; }
  if (data.message) { renderTrueMarginMsg_(data.message); return; }
  if (m) m.style.display = 'none';
  if (b) b.style.display = 'block';

  var estBadge = data.allEstimate
    ? '<span style="font-size:0.6rem;color:var(--text-light);border:1px solid var(--border);border-radius:999px;padding:0.05rem 0.4rem;margin-left:0.35rem;">Est.</span>'
    : '';
  var mp = data.trueMarginPct;
  var mpClass = mp >= 40 ? 'success' : mp >= 20 ? 'warn' : 'danger';
  var deltaHtml = '';
  if (data.marginDeltaPct !== null && typeof data.marginDeltaPct === 'number') {
    var sign = data.marginDeltaPct >= 0 ? '+' : '';
    deltaHtml = '<div style="font-size:0.62rem;color:var(--text-light);margin-top:0.15rem;">' + sign + data.marginDeltaPct + '% vs Xero booked</div>';
  }

  var tiles = document.getElementById('truemargin-tiles');
  tiles.innerHTML =
    '<div class="stat-tile"><div class="stat-value">' + anFmtDollar(data.revenue) + '</div><div class="stat-label">Booked Revenue</div></div>' +
    '<div class="stat-tile"><div class="stat-value danger">' + anFmtDollar(data.artistCost) + '</div><div class="stat-label">Artist Cost (pay + travel)</div>' +
      '<div style="font-size:0.62rem;color:var(--text-light);margin-top:0.15rem;">' + (data.counts.withActuals || 0) + ' of ' + (data.counts.withSnapshot || 0) + ' declared</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + (data.trueMargin >= 0 ? 'success' : 'danger') + '">' + anFmtDollar(data.trueMargin) + '</div><div class="stat-label">True Contribution Margin</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + mpClass + '">' + mp + '%' + estBadge + '</div><div class="stat-label">True Margin %</div>' + deltaHtml + '</div>';

  var lowest = document.getElementById('truemargin-lowest');
  if (!data.lowestMargin || !data.lowestMargin.length) {
    lowest.innerHTML = '<div style="font-size:0.75rem;color:var(--text-light);">No weddings with cost snapshots in this period.</div>';
  } else {
    var rows = data.lowestMargin.map(function(w) {
      var cls = w.marginPct >= 40 ? 'success' : w.marginPct >= 20 ? 'warn' : 'danger';
      var badge = w.isActuals ? '' : ' <span style="font-size:0.55rem;color:var(--text-light);">est</span>';
      return '<div style="display:flex;justify-content:space-between;align-items:center;padding:0.4rem 0;border-bottom:1px solid var(--border);font-size:0.78rem;">' +
        '<div><strong>' + escHtml(w.name) + '</strong>' + badge + '<div style="font-size:0.62rem;color:var(--text-light);">' + escHtml(w.date) + '</div></div>' +
        '<div style="text-align:right;">' + anFmtDollar(w.margin) + ' <span class="' + cls + '" style="font-weight:600;">' + w.marginPct + '%</span></div>' +
      '</div>';
    }).join('');
    lowest.innerHTML = rows;
  }
}

/* ===== ARTIST BILLS QUEUE (BRIEF-02) ===== */
/* ARTIST BILLS ON CLOUDFLARE (2026-10-06). The queue used to read the GAS staging
 * sheet + the whole CRM sheet and timed out at the relay ("Could not load bills.").
 * It now reads jv-payment-service D1 (schema 014) through the relay route
 * bridge_admin_artistBillList: zero GAS on load. GAS only stages what its Gmail
 * scan finds and posts it to D1. Errors say what failed, never a generic line. */
function artistBillErrText_(res, err) {
  var code = String((res && res.error) || (res && res.data && res.data.error) || (err && err.message) || err || '');
  if (/artist_bills_relay_disabled/.test(code)) return 'Artist bills are switched off on the relay (ARTIST_BILLS_RELAY_ENABLED).';
  if (/payment_service_unreachable/.test(code)) return 'The payment service did not answer. Try again in a minute.';
  if (/unauthori[sz]ed|forbidden|401/i.test(code)) return 'Your admin session was not accepted. Refresh the page and sign in again.';
  if (/no such table|staged_list_failed/i.test(code)) return 'The artist bills table is not set up yet (D1 schema 014). ' + code;
  if (/timeout|timed out|abort|504/i.test(code)) return 'The bills list timed out. Try again in a minute.';
  return code ? ('Could not load bills: ' + code) : 'Could not load bills: no response from the payment service.';
}
function artistBillUnwrapList_(res) {
  // The relay passes the payment-service JSON straight through.
  if (!res) return null;
  var d = (res.data && (res.data.bills || res.data.ok !== undefined)) ? res.data : res;
  return (d && d.ok !== false && Array.isArray(d.bills)) ? d : null;
}
function artistBillMatchClientId_(email) {
  // Drawer link: match the bride's email against the pipeline already in memory (no call).
  try {
    var e = String(email || '').toLowerCase();
    if (!e || !STATE || !Array.isArray(STATE.clients)) return null;
    for (var i = 0; i < STATE.clients.length; i++) {
      if (String(STATE.clients[i].email || '').toLowerCase() === e) return STATE.clients[i].id;
    }
  } catch (_) {}
  return null;
}
function loadArtistBillsSection() {
  var _abBg_ = function() {
    artistBillsCall_('list', 'bridge_admin_artistBillList', {})
      .then(function(res) {
        var d = artistBillUnwrapList_(res);
        if (!d) { renderArtistBillsMsg_(artistBillErrText_(res)); return; }
        window._artistBillsRoster = d.roster || window._artistBillsRoster || [];
        if (JV_ADMIN_B2_UI_ENABLED_) window._artistBillsRosterDetails = d.rosterDetails || window._artistBillsRosterDetails || [];
        var bills = d.bills.map(function (b) { b.clientId = artistBillMatchClientId_(b.brideEmail); return b; });
        renderArtistBills(bills);
        try { localStorage.setItem('jv_artist_bills_v1', JSON.stringify(JV_ADMIN_B2_UI_ENABLED_
          ? { at: Date.now(), bills: bills, roster: window._artistBillsRoster, rosterDetails: window._artistBillsRosterDetails }
          : { at: Date.now(), bills: bills, roster: window._artistBillsRoster })); } catch (_) {}
      })
      .catch(function(err) { renderArtistBillsMsg_(artistBillErrText_(null, err)); });
  };
  // Paint instantly from this browser's last good list, then refresh from D1.
  try {
    var last = JSON.parse(localStorage.getItem('jv_artist_bills_v1') || 'null');
    if (last && Array.isArray(last.bills)) { window._artistBillsRoster = last.roster || []; if (JV_ADMIN_B2_UI_ENABLED_) window._artistBillsRosterDetails = last.rosterDetails || []; renderArtistBills(last.bills); }
  } catch (_) {}
  // T3 (Group B): paint the Artist Bills queue from the analytics CDN island first (no
  // period), then background-refresh live. The other NEW panel behind the 30s timeout.
  adminCacheParseIsland_('jv-admin-analytics-cache', function(cached) {
    if (cached && cached.artistBills && Array.isArray(cached.artistBills.bills)) {
      try { renderArtistBills(cached.artistBills.bills); } catch (e) {}
    }
    _abBg_();
  });
  artistBillXero_loadPanel_();
  if (JV_ADMIN_B2_UI_ENABLED_) {
    artistBillLifecycle_loadPanel_();
    paytoLifecycle_loadPanel_();
  }
}

function renderArtistBillsMsg_(msg) {
  var m = document.getElementById('artistbills-message');
  var l = document.getElementById('artistbills-list');
  if (m) { m.style.display = 'block'; m.textContent = msg; }
  if (l) l.innerHTML = '';
}

function renderArtistBills(bills) {
  var m = document.getElementById('artistbills-message');
  var l = document.getElementById('artistbills-list');
  if (!bills.length) {
    if (m) { m.style.display = 'block'; m.textContent = 'No artist bills waiting. New ones appear here after they are read.'; }
    if (l) l.innerHTML = '';
    return;
  }
  if (m) m.style.display = 'none';
  window._artistBillsCache = {};
  l.innerHTML = bills.map(function(bd) {
    window._artistBillsCache[bd.billId] = bd;
    // Exact cents (2026-10-06): anFmtDollar rounds to whole dollars, which showed
    // $978.60 as $979. Money on a bill is always shown to the cent.
    var amt = (bd.amount != null && isFinite(Number(bd.amount))) ? ('$' + Number(bd.amount).toFixed(2)) : '(amount not read)';
    var bride = bd.brideGuess ? escHtml(bd.brideGuess) : '(bride not matched)';
    var artist = bd.artistGuess ? escHtml(bd.artistGuess) : '(artist not matched)';
    // Always offer the review step: the modal is where an unmatched artist,
    // amount or wedding gets corrected before anything is queued for Xero.
    var confirmBtn = '<button class="btn btn-primary" style="font-size:0.68rem;" onclick="artistBillReview_(\'' + escHtml(bd.billId) + '\')">Review and confirm</button>';
    return '<div class="card-panel" style="padding:0.85rem;margin-bottom:0.6rem;">' +
      '<div style="display:flex;justify-content:space-between;gap:0.75rem;flex-wrap:wrap;">' +
        '<div style="font-size:0.82rem;"><strong>' + artist + '</strong> paid ' + amt +
          '<div style="font-size:0.68rem;color:var(--text-light);">Wedding: ' + bride + ' &middot; via ' + escHtml(bd.source) + '</div></div>' +
        '<div style="display:flex;gap:0.4rem;align-items:flex-start;flex-wrap:wrap;">' +
          (bd.fileUrl ? '<a class="btn btn-ghost" style="font-size:0.68rem;" href="' + escHtml(bd.fileUrl) + '" target="_blank" rel="noopener">' + (/drive\.google\.com|docs\.google\.com/.test(bd.fileUrl) ? 'View file' : 'Open invoice') + '</a>' : '') +
          confirmBtn +
          '<button class="btn btn-ghost" style="font-size:0.68rem;" onclick="artistBillDismiss_(\'' + escHtml(bd.billId) + '\')">Dismiss</button>' +
        '</div>' +
      '</div>' +
      (bd.notes ? '<div style="font-size:0.66rem;margin-top:0.4rem;">' + escHtml(bd.notes) + '</div>' : '') +
      (bd.rawSnippet ? '<div style="font-size:0.62rem;color:var(--text-light);margin-top:0.4rem;max-height:2.6em;overflow:hidden;">' + escHtml(bd.rawSnippet) + '</div>' : '') +
    '</div>';
  }).join('');
}

/* ARTIST BILLS -> XERO STATUS (2026-10-06, Admin CRM, for Payments' ArtistBillXero_2026_10_06.gs).
   Lists confirmed bills with their Xero state: Confirmed (queued), In Xero (links the bill),
   Paid. Shown under the pending queue on Analytics, and filtered to one bride on her
   Profitability tab. Pending/Dismissed rows are left out (the queue above already shows
   Pending). Mark paid only appears on Confirmed / In Xero rows and needs a second click,
   because with Payments' payments flag on it records a real Xero payment. The Artist Bills
   section markup is in the frozen jv-admin-crm.liquid, so the container is injected here. */
var ARTIST_BILL_XERO_STATUS_TONE_ = { 'Confirmed': 'var(--text-light)', 'In Xero': 'var(--brand-primary-deep)', 'Paid': 'var(--brand-text)' };

function artistBillXero_rowsHtml_(bills, hostId) {
  var shown = (bills || []).filter(function (b) { return b.displayStatus !== 'Pending' && b.displayStatus !== 'Dismissed'; });
  if (!shown.length) return '<div style="font-size:0.7rem;color:var(--text-light);">No confirmed artist bills yet.</div>';
  return shown.slice().reverse().slice(0, 40).map(function (b) {
    var st = String(b.status || '').toUpperCase();
    var problem = (st === 'NEEDS_INFO' || st === 'FAILED') && b.error;
    var statusLabel = problem ? (st === 'NEEDS_INFO' ? 'Needs info' : 'Failed') : b.displayStatus;
    var statusHtml = escHtml(statusLabel);
    // View in Xero (2026-10-06): every bill that has a Xero InvoiceID, In Xero or Paid.
    var xeroLink = b.xeroBillUrl
      ? '<a class="btn btn-ghost" style="font-size:0.66rem;" href="' + escHtml(b.xeroBillUrl) + '" target="_blank" rel="noopener">View in Xero</a>'
      : '';
    var badge = function (txt) {
      return '<span style="display:inline-block;margin-top:0.25rem;padding:0.1rem 0.55rem;border-radius:var(--radius-pill);background:var(--brand-bg-soft);color:var(--brand-primary-deep);font-size:0.64rem;">' + escHtml(txt) + '</span>';
    };
    var notes = '';
    if (b.bankWarning) notes += '<div>' + badge(b.bankWarning) + '</div>';
    if (b.attachNote) notes += '<div>' + badge(b.attachStatus === 'NEEDS_RECONNECT' ? b.attachNote : 'PDF not attached: ' + b.attachNote) + '</div>';
    var paidLine = b.paidAt
      ? '<span style="color:var(--text-light);"> &middot; paid ' + escHtml(b.paidAt) +
        (b.paidAmount != null ? ' (' + anFmtDollar(b.paidAmount) + ')' : '') + '</span>'
      : '';
    var canPay = !problem && (b.displayStatus === 'Confirmed' || b.displayStatus === 'In Xero');
    var payBtn = canPay
      ? '<button type="button" class="btn btn-ghost" style="font-size:0.66rem;" data-abx-pay="' + escHtml(b.billId) + '" data-abx-host="' + escHtml(hostId) + '" ' +
        'data-abx-amount="' + escHtml(b.amount != null ? anFmtDollar(b.amount) : 'this bill') + '" onclick="artistBillXero_markPaidClick_(this)">Mark paid</button>'
      : '';
    return '<div style="display:flex;justify-content:space-between;align-items:center;gap:0.6rem;flex-wrap:wrap;padding:0.45rem 0;border-bottom:1px solid var(--brand-bg-soft);font-size:0.74rem;">' +
      '<div><strong>' + escHtml(b.artist || '(artist not matched)') + '</strong> ' +
        (b.amount != null ? anFmtDollar(b.amount) : '(no amount)') +
        paidLine +
        (problem ? '<div style="font-size:0.66rem;color:var(--brand-primary-deep);">' + escHtml(b.error) + '</div>' : '') +
        notes +
      '</div>' +
      '<div style="display:flex;gap:0.5rem;align-items:center;">' +
        '<span style="color:' + (ARTIST_BILL_XERO_STATUS_TONE_[b.displayStatus] || 'var(--text-light)') + ';">' + statusHtml + '</span>' + xeroLink + payBtn +
      '</div>' +
    '</div>';
  }).join('');
}

function artistBillXero_unwrap_(res) {
  if (!res) return {};
  if (res.data && typeof res.data === 'object' && (res.data.bills || res.data.error || res.data.ok !== undefined)) return res.data;
  return res;
}

function artistBillXero_load_(host, brideEmail) {
  if (!host) return;
  host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Loading Xero status...</div>';
  // Relay route -> jv-payment-service GET /artist-bills/status (2026-10-06: artist
  // bills moved off GAS). The relay returns the Worker JSON directly; tolerate a
  // {data:...} wrap, same as ibD1Unwrap_.
  var args = {};
  if (brideEmail) args.brideEmail = brideEmail;
  artistBillsCall_('status', 'bridge_admin_artistBillStatus', args)
    .then(function (res) {
      var d = artistBillXero_unwrap_(res);
      if (!res || res.ok === false || d.ok === false || d.error) {
        host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Xero status not available: ' + escHtml(String(d.error || (res && res.error) || 'no response')) + '</div>';
        return;
      }
      host.innerHTML = artistBillXero_rowsHtml_(d.bills || [], host.id);
    })
    .catch(function (err) {
      host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Xero status not available: ' + escHtml(String(err && err.message || err)) + '</div>';
    });
}

function artistBillXero_loadPanel_() {
  var list = document.getElementById('artistbills-list');
  if (!list || !list.parentNode) return;
  var wrap = document.getElementById('artistbills-xero-wrap');
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.id = 'artistbills-xero-wrap';
    wrap.style.marginTop = '1rem';
    wrap.innerHTML = '<div style="font-size:0.78rem;font-weight:600;margin-bottom:0.35rem;">Confirmed bills and Xero</div><div id="artistbills-xero"></div>';
    list.parentNode.insertBefore(wrap, list.nextSibling);
  }
  artistBillXero_load_(document.getElementById('artistbills-xero'), '');
}

function artistBillLifecycle_label_(code) {
  return ({
    admin_review_required: 'Waiting for review',
    confirmed_staging_missing_bill: 'Confirmed review is missing its liability record',
    wedding_date_mismatch: 'Wedding date does not match',
    wedding_link_conflict: 'Wedding identity conflict',
    wedding_unlinked: 'Not linked to a wedding',
    bill_needs_info: 'Artist, GST or amount information is missing',
    xero_create_failed: 'Xero bill creation failed',
    xero_creation_pending: 'Confirmed and waiting for Xero',
    xero_bill_id_missing: 'Xero bill ID is missing',
    xero_bill_not_payable: 'Xero says this bill is voided or deleted',
    local_paid_status_stale: 'Xero is paid but the local status has not caught up',
    paid_status_disagrees_with_xero: 'Paid status does not agree with Xero',
    attachment_no_file: 'Invoice file is missing',
    attachment_failed: 'Invoice attachment failed',
    attachment_needs_reconnect: 'Xero needs reconnection for attachments',
    attachment_too_large: 'Invoice file is too large to attach automatically',
    supplier_bank_details_missing: 'Supplier bank details are missing in Xero'
  })[code] || String(code || '').replace(/_/g, ' ');
}

function artistBillLifecycle_render_(host, data) {
  var bills = (data && Array.isArray(data.bills)) ? data.bills : [];
  var blocked = bills.filter(function (b) { return b.blockers && b.blockers.length; });
  if (!bills.length) {
    host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">No Team invoices have been recorded yet.</div>';
    return;
  }
  if (!blocked.length) {
    host.innerHTML = '<div style="font-size:0.7rem;color:var(--brand-primary-deep);">' + bills.length +
      ' invoice' + (bills.length === 1 ? '' : 's') + ' checked. No lifecycle blockers found.</div>';
    return;
  }
  host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);margin-bottom:0.55rem;">' + blocked.length +
    ' of ' + bills.length + ' invoice' + (bills.length === 1 ? '' : 's') + ' need attention. Read-only status, no repairs run here.</div>' +
    blocked.slice(0, 40).map(function (b) {
      var liability = b.liability || {};
      var ingest = b.ingestion || {};
      var title = liability.artistName || ingest.issuer || b.billId;
      var amount = liability.amountCents != null ? ('$' + (Number(liability.amountCents) / 100).toFixed(2)) : 'Amount not confirmed';
      var canRepairLink = (b.blockers || []).some(function (x) { return x === 'wedding_unlinked' || x === 'wedding_date_mismatch'; }) &&
        !(b.xero && b.xero.billId) && (liability.status === 'QUEUED' || liability.status === 'NEEDS_INFO');
      return '<div class="card-panel" style="padding:0.75rem;margin-bottom:0.5rem;">' +
        '<div style="display:flex;justify-content:space-between;gap:0.6rem;flex-wrap:wrap;font-size:0.74rem;">' +
          '<strong>' + escHtml(title) + '</strong><span>' + escHtml(amount) + '</span></div>' +
        '<div style="font-size:0.66rem;color:var(--text-light);margin-top:0.25rem;">' +
          escHtml((b.blockers || []).map(artistBillLifecycle_label_).join(' | ')) + '</div>' +
        '<div style="font-size:0.62rem;color:var(--text-light);margin-top:0.2rem;">Bill ' + escHtml(b.billId) +
          (liability.reference ? ' | ' + escHtml(liability.reference) : '') + '</div>' +
        (canRepairLink ? '<button type="button" class="btn btn-ghost" style="font-size:0.66rem;margin-top:0.45rem;" onclick="artistBillLinkRepairOpen_(\'' + escHtml(b.billId) + '\')">Review wedding link</button>' : '') +
        '</div>';
    }).join('');
}

function artistBillLinkRepairClose_() {
  var ov = document.getElementById('artistbill-link-repair-overlay');
  if (ov) ov.remove();
}
function artistBillLinkRepairOpen_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return;
  if (!window._jvAdminProxyBase) { try { jvToast && jvToast('A verified admin connection is required.', 'error'); } catch (_) {} return; }
  artistBillsCall_('link-candidates', '', { billId: billId, query: '' }).then(function (res) {
    var d = artistBillXero_unwrap_(res);
    if (!d || d.ok !== true || d.readOnly !== true || d.providerWrites !== false) throw new Error((d && d.error) || 'read-only evidence was not confirmed');
    if (d.bill && d.bill.providerLocked) throw new Error('This bill already has provider history and cannot be relinked here.');
    var options = '<option value="">Select the canonical booked wedding</option>' + (d.candidates || []).map(function (c) {
      var evidence = [c.exactEmail ? 'email matches' : '', c.exactDate ? 'date matches' : ''].filter(Boolean).join(', ');
      return '<option value="' + escHtml(c.brideId) + '" data-date="' + escHtml(c.weddingDate) + '">' +
        escHtml(c.brideName + ' | ' + c.weddingDate + ' | ' + c.brideEmail + (evidence ? ' | ' + evidence : '')) + '</option>';
    }).join('');
    var inputStyle = 'width:100%;padding:0.5rem 0.7rem;border:1px solid var(--line);border-radius:var(--radius-medium);font:inherit;font-size:0.78rem;';
    var html = '<div class="card-panel an-modal-panel" style="padding:1.25rem;">' +
      '<button class="an-modal-close" type="button" aria-label="Close" onclick="artistBillLinkRepairClose_()">&times;</button>' +
      '<div style="font-size:0.95rem;font-weight:600;margin-bottom:0.65rem;">Review wedding attribution</div>' +
      '<div style="font-size:0.7rem;color:var(--text-light);margin-bottom:0.75rem;">Bill evidence: ' + escHtml((d.bill.brideName || 'no bride') + ' | ' + (d.bill.brideEmail || 'no email') + ' | ' + (d.bill.weddingDate || 'no date')) + '<br>' + escHtml(d.bill.linkNote || d.bill.linkStatus || '') + '</div>' +
      '<select id="ablr-bride" style="' + inputStyle + '">' + options + '</select>' +
      '<label style="display:flex;gap:0.45rem;align-items:flex-start;font-size:0.72rem;margin:0.75rem 0;"><input type="checkbox" id="ablr-date-confirm">I checked the invoice context and confirm the selected wedding date is the correct service date.</label>' +
      '<div id="ablr-error" style="display:none;font-size:0.72rem;color:var(--brand-primary-deep);margin-bottom:0.5rem;"></div>' +
      '<div style="display:flex;justify-content:flex-end;gap:0.5rem;"><button class="btn btn-ghost" onclick="artistBillLinkRepairClose_()">Cancel</button>' +
      '<button class="btn btn-primary" id="ablr-save" onclick="artistBillLinkRepairSave_(\'' + escHtml(billId) + '\')">Confirm wedding link</button></div></div>';
    var ov = document.createElement('div'); ov.id = 'artistbill-link-repair-overlay'; ov.className = 'an-modal-overlay'; ov.innerHTML = html;
    ov.addEventListener('click', function (e) { if (e.target === ov) artistBillLinkRepairClose_(); }); document.body.appendChild(ov);
  }).catch(function (e) { try { jvToast && jvToast('Wedding evidence unavailable: ' + String(e && e.message || e), 'error'); } catch (_) {} });
}
function artistBillLinkRepairSave_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return;
  var sel = document.getElementById('ablr-bride'), checked = !!((document.getElementById('ablr-date-confirm') || {}).checked);
  var err = document.getElementById('ablr-error'), btn = document.getElementById('ablr-save');
  function fail(msg) { if (err) { err.style.display = 'block'; err.textContent = msg; } if (btn) { btn.disabled = false; btn.textContent = 'Confirm wedding link'; } }
  if (!sel || !sel.value) return fail('Select the canonical booked wedding.');
  if (!checked) return fail('Confirm that you checked the wedding-date context.');
  var opt = sel.options[sel.selectedIndex], reviewedDate = opt && opt.getAttribute('data-date');
  if (!reviewedDate) return fail('The selected wedding has no date and cannot be confirmed.');
  var idempotencyKey = 'link-' + billId + '-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }
  artistBillsCall_('link-repair', '', { billId: billId, brideId: Number(sel.value), reviewedWeddingDate: reviewedDate,
    dateContextConfirmed: true, idempotencyKey: idempotencyKey }).then(function (res) {
    var d = artistBillXero_unwrap_(res);
    if (!d || d.ok !== true || d.providerWrites !== false) return fail((d && (d.message || d.error)) || 'The link was not repaired.');
    artistBillLinkRepairClose_(); try { jvToast && jvToast('Wedding link reviewed. The bill is queued for the separate provider process.', 'success'); } catch (_) {}
    artistBillLifecycle_loadPanel_(); artistBillXero_loadPanel_();
  }).catch(function (e) { fail(String(e && e.message || e)); });
}

function artistBillLifecycle_loadPanel_() {
  if (!JV_ADMIN_B2_UI_ENABLED_) return;
  var xeroWrap = document.getElementById('artistbills-xero-wrap');
  if (!xeroWrap || !xeroWrap.parentNode) return;
  var wrap = document.getElementById('artistbills-lifecycle-wrap');
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.id = 'artistbills-lifecycle-wrap';
    wrap.style.marginTop = '1rem';
    wrap.innerHTML = '<div style="font-size:0.78rem;font-weight:600;margin-bottom:0.35rem;">Lifecycle checks</div>' +
      '<div id="artistbills-lifecycle" role="status" aria-live="polite"></div>';
    xeroWrap.parentNode.insertBefore(wrap, xeroWrap.nextSibling);
  }
  var host = document.getElementById('artistbills-lifecycle');
  if (!host) return;
  host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Checking current D1 and Xero read-back status...</div>';
  var base = window._jvAdminProxyBase;
  if (!base) { host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Lifecycle checks are unavailable: admin connection is not ready.</div>'; return; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/admin-artist-bill-lifecycle/read', {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ limit: 200 })
  }).then(function (r) { return r.json(); }).then(function (data) {
    if (!data || data.ok !== true || data.readOnly !== true || data.providerWrites !== false || data.repairWritesEnabled !== false) {
      throw new Error((data && data.error) || 'read-only contract was not confirmed');
    }
    artistBillLifecycle_render_(host, data);
  }).catch(function (err) {
    host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Lifecycle checks could not be confirmed: ' +
      escHtml(String(err && err.message || err)) + '. Existing bill controls are unchanged.</div>';
  });
}

function paytoLifecycle_label_(code) {
  return ({ cancelled_booking_open_obligation: 'Closed booking still has an open obligation', mandate_missing: 'PayTo mandate is missing',
    active_mandate_required: 'Active matching PayTo mandate required', linked_invoice_missing: 'Linked final invoice is missing',
    invoice_mirror_missing: 'Xero invoice mirror is missing', invoice_not_chargeable: 'Invoice is paid, voided or deleted',
    invoice_amount_changed: 'Invoice amount changed', charge_failed_terminal: 'Latest charge failed and needs review' })[code] || String(code || '').replace(/_/g, ' ');
}
function paytoLifecycle_loadPanel_() {
  if (!JV_ADMIN_B2_UI_ENABLED_) return;
  var anchor = document.getElementById('artistbills-lifecycle-wrap') || document.getElementById('artistbills-xero-wrap');
  if (!anchor || !anchor.parentNode) return;
  var wrap = document.getElementById('payto-lifecycle-wrap');
  if (!wrap) { wrap = document.createElement('div'); wrap.id = 'payto-lifecycle-wrap'; wrap.style.marginTop = '1rem';
    wrap.innerHTML = '<div style="font-size:0.78rem;font-weight:600;margin-bottom:0.35rem;">PayTo obligation lifecycle</div><div id="payto-lifecycle" role="status" aria-live="polite"></div>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling); }
  var host = document.getElementById('payto-lifecycle'); if (!host) return;
  host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">Checking D1 obligation, mandate, invoice and attempt truth...</div>';
  var base = window._jvAdminProxyBase;
  if (!base) { host.textContent = 'PayTo lifecycle is unavailable: admin connection is not ready.'; return; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/admin-payto-lifecycle/read', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ limit: 100 }) })
    .then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.ok !== true || d.readOnly !== true || d.repairWritesEnabled !== false || d.charges !== false) throw new Error((d && d.error) || 'read-only contract was not confirmed');
      var blocked = (d.obligations || []).filter(function (o) { return o.blockers && o.blockers.length; });
      if (!blocked.length) { host.innerHTML = '<div style="font-size:0.7rem;color:var(--brand-primary-deep);">' + Number(d.count || 0) + ' obligation' + (Number(d.count || 0) === 1 ? '' : 's') + ' checked. No lifecycle blockers found.</div>'; return; }
      host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);margin-bottom:0.5rem;">' + blocked.length + ' obligation' + (blocked.length === 1 ? '' : 's') + ' need review. Read-only status; no charge or repair runs here.</div>' +
        blocked.slice(0, 40).map(function (o) { return '<div class="card-panel" style="padding:0.7rem;margin-bottom:0.45rem;font-size:0.7rem;"><strong>' + escHtml(o.email || o.obligationKey) + '</strong> | ' + escHtml(o.status || '') +
          '<div style="color:var(--text-light);margin-top:0.2rem;">' + escHtml((o.blockers || []).map(paytoLifecycle_label_).join(' | ')) + '</div></div>'; }).join('');
    }).catch(function (e) { host.innerHTML = '<div style="font-size:0.7rem;color:var(--text-light);">PayTo lifecycle could not be confirmed: ' + escHtml(String(e && e.message || e)) + '.</div>'; });
}

function artistBillXero_markPaidClick_(btn) {
  if (!btn || btn.disabled) return;
  if (btn.getAttribute('data-abx-armed') !== '1') {
    btn.setAttribute('data-abx-armed', '1');
    btn.textContent = 'Confirm paid ' + btn.getAttribute('data-abx-amount') + '?';
    setTimeout(function () {
      if (btn.getAttribute('data-abx-armed') === '1' && !btn.disabled) { btn.removeAttribute('data-abx-armed'); btn.textContent = 'Mark paid'; }
    }, 6000);
    return;
  }
  btn.disabled = true;
  btn.textContent = 'Saving...';
  var billId = btn.getAttribute('data-abx-pay');
  var host = document.getElementById(btn.getAttribute('data-abx-host'));
  artistBillsCall_('mark-paid', 'bridge_admin_artistBillMarkPaid', { billId: billId })
    .then(function (res) {
      var d = artistBillXero_unwrap_(res);
      if (!res || res.ok === false || d.ok === false || d.error) {
        try { jvToast && jvToast('Not marked paid: ' + String(d.error || (res && res.error) || 'no response'), 'error'); } catch (_) {}
        btn.disabled = false; btn.removeAttribute('data-abx-armed'); btn.textContent = 'Mark paid';
        return;
      }
      try { jvToast && jvToast(d.recordedInXero ? 'Marked paid and recorded in Xero.' : 'Marked paid.', 'success'); } catch (_) {}
      if (host) artistBillXero_load_(host, host.getAttribute('data-bride-email') || '');
    })
    .catch(function (err) {
      try { jvToast && jvToast('Not marked paid: ' + String(err && err.message || err), 'error'); } catch (_) {}
      btn.disabled = false; btn.removeAttribute('data-abx-armed'); btn.textContent = 'Mark paid';
    });
}

function scanArtistBillsNow() {
  if (!JV_ADMIN_B2_UI_ENABLED_) return scanArtistBillsNowLegacy_();
  return scanArtistBillsNowCloudflare_();
}

// Exact pre-B2 live path. Keep this branch intact until the client gate is
// explicitly enabled after backend flags and semantic review are complete.
function scanArtistBillsNowLegacy_() {
  // Gmail lives in GAS, so the scan does too. It never blocks the list: the list stays
  // on screen, the scan runs in the background, then the list re-reads from D1.
  try { jvToast && jvToast('Scanning the inbox in the background. The list stays usable.', 'info'); } catch (_) {}
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_scanArtistBillsNow', args: { token: STATE.token } })
    .then(function(res) {
      // bridge_admin_generic wraps the GAS result in res.data. The bridge call can
      // succeed (res.ok) while the scan itself failed ({error}), so read the inner result.
      var d = (res && res.data) || {};
      var failed = !res || !res.ok || d.error || d.ok === false;
      var msg;
      if (failed) {
        msg = 'Scan failed: ' + ((d && d.error) || (res && res.error) || 'no response');
      } else {
        var skipped = Array.isArray(d.skipped) ? d.skipped : [];
        msg = 'Scanned ' + (d.scanned || 0) + ' email' + (d.scanned === 1 ? '' : 's') +
          ', staged ' + (d.staged || 0) + ' new' +
          (skipped.length ? (', ' + skipped.length + ' not staged (' + skipped.map(function (x) { return x.reason; }).join('; ') + ')') : '') + '.' +
          (d.moreRemaining ? ' More emails are waiting, click Scan now again.' : '');
      }
      try { jvToast && jvToast(msg, failed ? 'error' : (d.staged ? 'success' : 'info')); } catch (_) {}
      loadArtistBillsSection();
    })
    .catch(function(err) {
      // A timeout here does NOT mean nothing happened: the scan keeps running on the
      // server and stages what it finds. Say so, then re-read the queue shortly.
      var raw = String(err && err.message || err || '');
      var timedOut = /timeout|timed out|504|abort/i.test(raw);
      var msg = timedOut
        ? 'The scan is taking longer than usual and is still running. The list will refresh in about a minute.'
        : 'Scan failed: ' + (raw || 'no response');
      try { jvToast && jvToast(msg, timedOut ? 'info' : 'error'); } catch (_) {}
      loadArtistBillsSection();
      if (timedOut) setTimeout(loadArtistBillsSection, 60000);
    });
}

function scanArtistBillsNowCloudflare_() {
  if (!JV_ADMIN_B2_UI_ENABLED_) return scanArtistBillsNowLegacy_();
  var base = window._jvAdminProxyBase;
  if (!base) { try { jvToast && jvToast('A verified admin connection is required to scan Gmail.', 'error'); } catch (_) {} return; }
  try { jvToast && jvToast('Scanning the inbox in the background. The list stays usable.', 'info'); } catch (_) {}
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_scanArtistBillsNow', args: { token: STATE.token } })
    .then(function(res) {
      // bridge_admin_generic wraps the GAS result in res.data. The bridge call can
      // succeed (res.ok) while the scan itself failed ({error}), so read the inner result.
      var d = (res && res.data) || {};
      var failed = !res || !res.ok || d.error || d.ok === false;
      var msg;
      if (failed) {
        msg = 'Scan failed: ' + ((d && d.error) || (res && res.error) || 'no response');
      } else {
        var skipped = Array.isArray(d.skipped) ? d.skipped : [];
        msg = 'Scanned ' + (d.scanned || 0) + ' email' + (d.scanned === 1 ? '' : 's') +
          ', staged ' + (d.staged || 0) + ' new' +
          (skipped.length ? (', ' + skipped.length + ' not staged (' + skipped.map(function (x) { return x.reason; }).join('; ') + ')') : '') + '.' +
          (d.moreRemaining ? ' More emails are waiting, click Scan now again.' : '');
      }
      try { jvToast && jvToast(msg, failed ? 'error' : (d.staged ? 'success' : 'info')); } catch (_) {}
      loadArtistBillsSection();
    })
    .catch(function(err) {
      // A timeout here does NOT mean nothing happened: the scan keeps running on the
      // server and stages what it finds. Say so, then re-read the queue shortly.
      var raw = String(err && err.message || err || '');
      var timedOut = /timeout|timed out|504|abort/i.test(raw);
      var msg = timedOut
        ? 'The scan is taking longer than usual and is still running. The list will refresh in about a minute.'
        : 'Scan failed: ' + (raw || 'no response');
      try { jvToast && jvToast(msg, timedOut ? 'info' : 'error'); } catch (_) {}
      loadArtistBillsSection();
      if (timedOut) setTimeout(loadArtistBillsSection, 60000);
    });
}

function artistBillDismiss_(billId) {
  artistBillsCall_('dismiss', 'bridge_admin_artistBillDismiss', { billId: billId })
    .then(function(res) {
      var d = (res && res.data && res.data.ok !== undefined) ? res.data : res;
      if (!d || d.ok === false) { try { jvToast && jvToast('Not dismissed: ' + ((d && d.error) || (res && res.error) || 'no response'), 'error'); } catch (_) {} }
      loadArtistBillsSection();
    })
    .catch(function(e) { try { jvToast && jvToast('Not dismissed: ' + String(e && e.message || e), 'error'); } catch (_) {} });
}

/* ARTIST BILL REVIEW MODAL (2026-10-06).
 * "Review and confirm" used to call artistBillConfirm_ below, which opened the
 * bride drawer and polled for the old Profitability tab + Declare form. The drawer
 * now opens the Client Command Centre (openDrawer wrapper, CC.open), which never
 * exposes that form, so the poll silently gave up and Jess just landed on the
 * bride's profile. This modal is the review step for ONE invoice: file link,
 * issuer, invoice number, exact amount, GST shown on the invoice, wedding, account
 * 313, all correctable, and Confirm is the only thing that queues it for Xero.
 * Our own business is never accepted as the artist (server enforces it too). */
function artistBillReviewField_(label, inner) {
  return '<div class="an-form-group"><label>' + label + '</label>' + inner + '</div>';
}
function artistBillParseNotes_(bd) {
  var notes = String(bd.notes || '');
  var all = notes + ' ' + String(bd.rawSnippet || '');
  var inv = /#\s*([A-Z0-9-]{3,})/i.exec(notes) || /\b(INV-[A-Z0-9-]+)\b/i.exec(all);
  var iss = / from (.+?)(?:, due |\. )/.exec(notes);
  var gst = /GST[^$0-9]{0,20}\$\s*([\d,]+(?:\.\d{1,2})?)/i.exec(all);
  return { invoiceNo: inv ? inv[1] : '', issuer: iss ? iss[1] : '', gst: gst ? gst[1].replace(/,/g, '') : '' };
}
function artistBillRosterDetail_(name) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return null;
  var wanted = String(name || '').toLowerCase().replace(/\s+/g, ' ').trim();
  if (!wanted) return null;
  return (window._artistBillsRosterDetails || []).find(function (x) {
    return String(x && x.name || '').toLowerCase().replace(/\s+/g, ' ').trim() === wanted;
  }) || null;
}
function artistBillReviewGstState_() {
  if (!JV_ADMIN_B2_UI_ENABLED_) return;
  var artist = String((document.getElementById('abr-artist') || {}).value || '');
  var detail = artistBillRosterDetail_(artist);
  var host = document.getElementById('abr-gst-authority');
  if (!host) return;
  if (!detail) {
    host.textContent = 'Recorded status: unknown. Match the artist, check the team record, then make an explicit reviewed choice below.';
    return;
  }
  var state = detail.gstRegistered === 1 || detail.gstRegistered === true ? 'GST registered'
    : (detail.gstRegistered === 0 || detail.gstRegistered === false ? 'not GST registered' : 'unknown');
  var source = detail.gstSource === 'admin_review' ? 'admin reviewed'
    : (detail.gstSource === 'pay_rate' ? 'current pay rate' : 'no authoritative source');
  host.textContent = 'Recorded status: ' + state + ' (' + source + '). Review this against the printed invoice evidence. Your choice is not preselected.';
}
function artistBillReview_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return artistBillReviewLegacy_(billId);
  return artistBillReviewAudited_(billId);
}

function artistBillReviewLegacy_(billId) {
  var bd = window._artistBillsCache && window._artistBillsCache[billId];
  if (!bd) return;
  var meta = artistBillParseNotes_(bd);
  var old = document.getElementById('artistbill-review-overlay');
  if (old) old.remove();
  var roster = (window._artistBillsRoster || []).map(function (n) { return '<option value="' + escHtml(n) + '"></option>'; }).join('');
  var amtVal = (bd.amount != null && isFinite(Number(bd.amount))) ? Number(bd.amount).toFixed(2) : '';
  var inputStyle = 'width:100%;padding:0.5rem 0.7rem;border:1px solid var(--line);border-radius:var(--radius-medium);font:inherit;font-size:0.82rem;';
  var html =
    '<div class="card-panel an-modal-panel" style="padding:1.25rem;">' +
      '<button class="an-modal-close" type="button" aria-label="Close" onclick="artistBillReviewClose_()">&times;</button>' +
      '<div style="font-size:0.95rem;font-weight:600;margin-bottom:0.75rem;">Review artist bill</div>' +
      (bd.fileUrl ? '<div style="margin-bottom:0.85rem;"><a class="btn btn-ghost" style="font-size:0.72rem;" href="' + escHtml(bd.fileUrl) + '" target="_blank" rel="noopener">Open the invoice</a></div>' : '<div style="font-size:0.72rem;color:var(--text-light);margin-bottom:0.85rem;">No invoice file or link was found for this bill.</div>') +
      artistBillReviewField_('Issued by (on the invoice)', '<div style="font-size:0.82rem;">' + escHtml(meta.issuer || '(not read)') + (meta.invoiceNo ? ' &middot; Invoice ' + escHtml(meta.invoiceNo) : '') + '</div>') +
      artistBillReviewField_('Artist (who we pay)', '<input id="abr-artist" list="abr-roster" style="' + inputStyle + '" value="' + escHtml(bd.artistGuess || '') + '" placeholder="Pick the artist from the team"><datalist id="abr-roster">' + roster + '</datalist>') +
      artistBillReviewField_('Amount incl. GST (AUD)', '<input id="abr-amount" type="number" step="0.01" min="0.01" inputmode="decimal" style="' + inputStyle + '" value="' + escHtml(amtVal) + '">') +
      artistBillReviewField_('GST on the invoice', '<div style="font-size:0.82rem;">' + (meta.gst !== '' ? '$' + Number(meta.gst).toFixed(2) : '(not read, check the invoice)') + '</div><div style="font-size:0.66rem;color:var(--text-light);margin-top:0.2rem;">The Xero tax rate comes from the artist\'s GST status on her team record. If it does not match the invoice the bill is held for you, never guessed.</div>') +
      artistBillReviewField_('Wedding (bride)', '<input id="abr-bride-name" style="' + inputStyle + 'margin-bottom:0.4rem;" value="' + escHtml(bd.brideGuess || '') + '" placeholder="Bride name"><input id="abr-bride-email" type="email" style="' + inputStyle + '" value="' + escHtml(bd.brideEmail || '') + '" placeholder="Bride email">') +
      artistBillReviewField_('Xero account', '<div style="font-size:0.82rem;">313 COGS Subcontractors &middot; Pro Studio Group</div>') +
      '<div id="abr-error" style="display:none;font-size:0.74rem;color:var(--brand-primary-deep);margin-bottom:0.6rem;"></div>' +
      '<div style="display:flex;gap:0.5rem;justify-content:flex-end;flex-wrap:wrap;">' +
        '<button class="btn btn-ghost" type="button" onclick="artistBillReviewClose_()">Cancel</button>' +
        '<button class="btn btn-primary" type="button" id="abr-confirm" onclick="artistBillReviewConfirm_(\'' + escHtml(billId) + '\')">Confirm and send to Xero</button>' +
      '</div>' +
    '</div>';
  var ov = document.createElement('div');
  ov.id = 'artistbill-review-overlay';
  ov.className = 'an-modal-overlay';
  ov.innerHTML = html;
  ov.addEventListener('click', function (e) { if (e.target === ov) artistBillReviewClose_(); });
  document.body.appendChild(ov);
}

function artistBillReviewAudited_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return artistBillReviewLegacy_(billId);
  var bd = window._artistBillsCache && window._artistBillsCache[billId];
  if (!bd) return;
  var meta = artistBillParseNotes_(bd);
  var old = document.getElementById('artistbill-review-overlay');
  if (old) old.remove();
  var roster = (window._artistBillsRoster || []).map(function (n) { return '<option value="' + escHtml(n) + '"></option>'; }).join('');
  var amtVal = (bd.amount != null && isFinite(Number(bd.amount))) ? Number(bd.amount).toFixed(2) : '';
  var inputStyle = 'width:100%;padding:0.5rem 0.7rem;border:1px solid var(--line);border-radius:var(--radius-medium);font:inherit;font-size:0.82rem;';
  var html =
    '<div class="card-panel an-modal-panel" style="padding:1.25rem;">' +
      '<button class="an-modal-close" type="button" aria-label="Close" onclick="artistBillReviewClose_()">&times;</button>' +
      '<div style="font-size:0.95rem;font-weight:600;margin-bottom:0.75rem;">Review artist bill</div>' +
      (bd.fileUrl ? '<div style="margin-bottom:0.85rem;"><a class="btn btn-ghost" style="font-size:0.72rem;" href="' + escHtml(bd.fileUrl) + '" target="_blank" rel="noopener">Open the invoice</a></div>' : '<div style="font-size:0.72rem;color:var(--text-light);margin-bottom:0.85rem;">No invoice file or link was found for this bill.</div>') +
      artistBillReviewField_('Issued by (on the invoice)', '<div style="font-size:0.82rem;">' + escHtml(meta.issuer || '(not read)') + (meta.invoiceNo ? ' &middot; Invoice ' + escHtml(meta.invoiceNo) : '') + '</div>') +
      artistBillReviewField_('Artist (who we pay)', '<input id="abr-artist" list="abr-roster" style="' + inputStyle + '" value="' + escHtml(bd.artistGuess || '') + '" placeholder="Pick the artist from the team"><datalist id="abr-roster">' + roster + '</datalist>') +
      artistBillReviewField_('Amount incl. GST (AUD)', '<input id="abr-amount" type="number" step="0.01" min="0.01" inputmode="decimal" style="' + inputStyle + '" value="' + escHtml(amtVal) + '">') +
      artistBillReviewField_('GST on the invoice', '<div style="font-size:0.82rem;">' + (meta.gst !== '' ? '$' + Number(meta.gst).toFixed(2) : '(not read, check the invoice)') + '</div><div style="font-size:0.66rem;color:var(--text-light);margin-top:0.2rem;">The Xero tax rate comes from the artist\'s GST status on her team record. If it does not match the invoice the bill is held for you, never guessed.</div>') +
      artistBillReviewField_('Wedding (bride)', '<input id="abr-bride-name" style="' + inputStyle + 'margin-bottom:0.4rem;" value="' + escHtml(bd.brideGuess || '') + '" placeholder="Bride name"><input id="abr-bride-email" type="email" style="' + inputStyle + '" value="' + escHtml(bd.brideEmail || '') + '" placeholder="Bride email">') +
      artistBillReviewField_('Xero account', '<div style="font-size:0.82rem;">313 COGS Subcontractors &middot; Pro Studio Group</div>') +
      '<div id="abr-error" style="display:none;font-size:0.74rem;color:var(--brand-primary-deep);margin-bottom:0.6rem;"></div>' +
      '<div style="display:flex;gap:0.5rem;justify-content:flex-end;flex-wrap:wrap;">' +
        '<button class="btn btn-ghost" type="button" onclick="artistBillReviewClose_()">Cancel</button>' +
        '<button class="btn btn-primary" type="button" id="abr-confirm" onclick="artistBillReviewConfirm_(\'' + escHtml(billId) + '\')">Confirm and send to Xero</button>' +
      '</div>' +
    '</div>';
  var ov = document.createElement('div');
  ov.id = 'artistbill-review-overlay';
  ov.className = 'an-modal-overlay';
  ov.innerHTML = html;
  ov.addEventListener('click', function (e) { if (e.target === ov) artistBillReviewClose_(); });
  document.body.appendChild(ov);
}
function artistBillReviewClose_() {
  var ov = document.getElementById('artistbill-review-overlay');
  if (ov) ov.remove();
}
function artistBillIsSelfName_(name) {
  var n = String(name || '').toLowerCase().replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ').trim();
  return !!n && (/\bjessica vegas\b/.test(n) || /\bpro studio\b/.test(n) || /\bpro team\b/.test(n) || /^jessica( vegas)?$/.test(n) || /\bjv pro\b/.test(n));
}
/**
 * Artist Bills calls go through the VERIFIED admin path (Shopify App Proxy signature + jv-admin tag, key injected
 * server-side by the relay), NOT the shared-key bridge routes: the page key never matched the relay's, so those
 * silently rode the slow GAS fallback and 504'd (2026-10-07). Falls back to the old bridge call ONLY when the proxy
 * base is not configured on this page. Resolves the response body ({ok, ...} or {ok:false, error, message}).
 */
function artistBillsCall_(action, legacyRoute, body) {
  var base = window._jvAdminProxyBase;
  if (!base) return jvBridge.callAdmin(legacyRoute, body || {});
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(String(base).replace(/\/+$/, '') + '/partner/artist-bills/' + action, {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body || {})
  }).then(function (r) { return r.json(); })
    .catch(function () { return { ok: false, error: 'network_error', message: 'Could not reach the server. Check your connection and try again.' }; });
}

function artistBillReviewConfirm_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return artistBillReviewConfirmLegacy_(billId);
  return artistBillReviewConfirmAudited_(billId);
}

function artistBillReviewConfirmLegacy_(billId) {
  var err = document.getElementById('abr-error');
  var btn = document.getElementById('abr-confirm');
  function fail(msg) { if (err) { err.style.display = 'block'; err.textContent = msg; } if (btn) { btn.disabled = false; btn.textContent = 'Confirm and send to Xero'; } }
  var artist = String((document.getElementById('abr-artist') || {}).value || '').trim();
  var amount = Number((document.getElementById('abr-amount') || {}).value);
  var brideName = String((document.getElementById('abr-bride-name') || {}).value || '').trim();
  var brideEmail = String((document.getElementById('abr-bride-email') || {}).value || '').trim();
  if (!artist) return fail('Pick the artist who sent this invoice.');
  if (artistBillIsSelfName_(artist)) return fail('That is our own business. Pick the artist who sent the invoice.');
  if (!(amount > 0)) return fail('Enter the amount on the invoice, including cents.');
  amount = Math.round(amount * 100) / 100;
  if (btn) { btn.disabled = true; btn.textContent = 'Confirming...'; }
  // Confirm runs on Cloudflare (D1 + Xero queue), the only path that queues Xero.
  artistBillsCall_('confirm', 'bridge_admin_artistBillConfirm', {
    billId: billId, amount: amount, artistName: artist, brideName: brideName, brideEmail: brideEmail
  }).then(function (res) {
    var d = (res && res.data && res.data.ok !== undefined) ? res.data : (res || {});
    if (!d || d.ok === false || d.error) {
      var code = String((d && d.error) || (res && res.error) || 'no response');
      var nice = code === 'artist_is_own_business' ? 'That is our own business. Pick the artist who sent the invoice.'
        : (/^duplicate_of_confirmed_bill/.test(code) ? 'This invoice number from this issuer is already confirmed. Dismiss this copy.'
        : (code === 'amount_required' ? 'Enter the amount on the invoice, including cents.'
        : ((d && d.message) ? String(d.message) : code)));
      return fail('Not confirmed: ' + nice);
    }
    artistBillReviewClose_();
    try { jvToast && jvToast('Confirmed. $' + amount.toFixed(2) + ' to ' + artist + ' is queued for Xero.', 'success'); } catch (_) {}
    loadArtistBillsSection();
  }).catch(function (e) { fail('Not confirmed: ' + String(e && e.message || e)); });
}

function artistBillReviewConfirmAudited_(billId) {
  if (!JV_ADMIN_B2_UI_ENABLED_) return artistBillReviewConfirmLegacy_(billId);
  var err = document.getElementById('abr-error');
  var btn = document.getElementById('abr-confirm');
  function fail(msg) { if (err) { err.style.display = 'block'; err.textContent = msg; } if (btn) { btn.disabled = false; btn.textContent = 'Confirm and send to Xero'; } }
  var artist = String((document.getElementById('abr-artist') || {}).value || '').trim();
  var amount = Number((document.getElementById('abr-amount') || {}).value);
  var brideName = String((document.getElementById('abr-bride-name') || {}).value || '').trim();
  var brideEmail = String((document.getElementById('abr-bride-email') || {}).value || '').trim();
  if (!artist) return fail('Pick the artist who sent this invoice.');
  if (artistBillIsSelfName_(artist)) return fail('That is our own business. Pick the artist who sent the invoice.');
  if (!(amount > 0)) return fail('Enter the amount on the invoice, including cents.');
  amount = Math.round(amount * 100) / 100;
  if (btn) { btn.disabled = true; btn.textContent = 'Confirming...'; }
  // Confirm runs on Cloudflare (D1 + Xero queue), the only path that queues Xero.
  artistBillsCall_('confirm', 'bridge_admin_artistBillConfirm', {
    billId: billId, amount: amount, artistName: artist, brideName: brideName, brideEmail: brideEmail
  }).then(function (res) {
    var d = (res && res.data && res.data.ok !== undefined) ? res.data : (res || {});
    if (!d || d.ok === false || d.error) {
      var code = String((d && d.error) || (res && res.error) || 'no response');
      var nice = code === 'artist_is_own_business' ? 'That is our own business. Pick the artist who sent the invoice.'
        : (/^duplicate_of_confirmed_bill/.test(code) ? 'This invoice number from this issuer is already confirmed. Dismiss this copy.'
        : (code === 'amount_required' ? 'Enter the amount on the invoice, including cents.'
        : ((d && d.message) ? String(d.message) : code)));
      return fail('Not confirmed: ' + nice);
    }
    artistBillReviewClose_();
    try { jvToast && jvToast('Confirmed. $' + amount.toFixed(2) + ' to ' + artist + ' is queued for Xero.', 'success'); } catch (_) {}
    loadArtistBillsSection();
  }).catch(function (e) { fail('Not confirmed: ' + String(e && e.message || e)); });
}

function artistBillConfirm_(billId) {
  var bd = window._artistBillsCache && window._artistBillsCache[billId];
  if (!bd || !bd.clientId) { try { jvToast && jvToast('Open her drawer manually to declare.', 'warn'); } catch (_) {} return; }
  openDrawer(Number(bd.clientId));
  var tries = 0;
  var iv = setInterval(function() {
    tries++;
    var ready = _lastDrawerClient && String(_lastDrawerClient.id) === String(bd.clientId) && _lastDrawerClient.proteamProfitSnapshot;
    if (ready) {
      clearInterval(iv);
      try {
        if (typeof switchDrawerTab === 'function') switchDrawerTab('profitability', document.querySelector('.drawer-tab[data-pane="profitability"]'));
        if (typeof loadDrawerProfitability === 'function') loadDrawerProfitability(Number(bd.clientId));
        profitability_openDeclareForm_(Number(bd.clientId));
        setTimeout(function() {
          var host = document.getElementById('profit-declare-form-' + bd.clientId);
          if (host && bd.artistGuess && bd.amount != null) {
            var inputs = host.querySelectorAll('.profit-declare__amount');
            for (var i = 0; i < inputs.length; i++) {
              var a = (inputs[i].getAttribute('data-artist') || '').toLowerCase();
              if (a === String(bd.artistGuess).toLowerCase() || a.split(' ')[0] === String(bd.artistGuess).toLowerCase().split(' ')[0]) {
                inputs[i].value = Number(bd.amount).toFixed(2);
                break;
              }
            }
            var notes = host.querySelector('.profit-declare__notes');
            if (notes) notes.value = 'From artist bill (' + bd.source + ')';
          }
        }, 250);
      } catch (e) { /* fall back to manual */ }
      // 2026-10-06 (Admin CRM): do NOT mark the bill applied here. This runs when the
      // Declare form OPENS, before Jess has checked or saved any amount, and marking
      // applied now queues a Xero bill (ArtistBillXero) from the OCR guess. The bill
      // is marked applied in profitability_submitDeclare_, after a successful save,
      // with the amount she actually saved.
      window._jvPendingArtistBillApply = { billId: billId, clientId: String(bd.clientId), artistGuess: String(bd.artistGuess || '') };
    } else if (tries > 40) { clearInterval(iv); }
  }, 200);
}

function renderPnlTrend(trend) {
  var el = document.getElementById('pnl-trend');
  if (!trend || !trend.length) { el.innerHTML = '<p style="font-size:0.78rem;color:var(--text-light);">No trend data</p>'; return; }
  var maxVal = 1;
  trend.forEach(function(t) { maxVal = Math.max(maxVal, t.revenue, t.expenses); });
  var html = '';
  trend.forEach(function(t) {
    var revH = Math.round((t.revenue / maxVal) * 100);
    var expH = Math.round((t.expenses / maxVal) * 100);
    html += '<div class="an-trend-bar-group">';
    html += '<div class="an-trend-bars">';
    html += '<div class="an-trend-bar revenue" style="height:' + revH + '%" title="Revenue: ' + anFmtDollar(t.revenue) + '"></div>';
    html += '<div class="an-trend-bar expense" style="height:' + expH + '%" title="Expenses: ' + anFmtDollar(t.expenses) + '"></div>';
    html += '</div>';
    html += '<div class="an-trend-label">' + escHtml(t.month.substring(5)) + '</div>';
    html += '</div>';
  });
  // Legend
  html += '<div style="display:flex;gap:1rem;font-size:0.65rem;color:var(--text-light);margin-left:0.5rem;align-self:flex-end;">';
  html += '<span><span style="display:inline-block;width:8px;height:8px;background:var(--brand-primary);border-radius:2px;margin-right:3px;"></span>Revenue</span>';
  html += '<span><span style="display:inline-block;width:8px;height:8px;background:var(--line);border-radius:2px;margin-right:3px;"></span>Expenses</span>';
  html += '</div>';
  el.innerHTML = html;
}

/* ────────────────────────────────────────────────────────────────
   ANALYTICS — KPI Section
   ──────────────────────────────────────────────────────────────── */
function loadKpiSection() {
  var _kpiBg_ = function() {
    // TODO: Bridge route needed for: adminApi_getAnalyticsKPIs
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getAnalyticsKPIs', args: { token: STATE.token } })
      .then(function(res) { if (res.ok) renderKpis(res.data); else { var errFn = function(err) {
        document.getElementById('kpi-cards').innerHTML = '<p style="font-size:0.78rem;color:var(--danger);">Error: ' + escHtml(err.message || String(err)) + '</p>';
      }; errFn(res.error); } })
      .catch(function(err) {
        document.getElementById('kpi-cards').innerHTML = '<p style="font-size:0.78rem;color:var(--danger);">Error: ' + escHtml(err.message || String(err)) + '</p>';
      });
  };
  // T3 (Group B): paint KPIs from the analytics CDN island first (KPIs use the 90-day
  // default that the cache builds with), then background-refresh live.
  adminCacheParseIsland_('jv-admin-analytics-cache', function(cached) {
    if (cached && cached.kpis) { try { renderKpis(cached.kpis); } catch (e) {} }
    _kpiBg_();
  });
}

function renderKpis(data) {
  if (!data || !data.kpis) return;
  var el = document.getElementById('kpi-cards');
  var html = '';
  var colors = ['rose', 'gold', 'green', 'rose', 'gold', 'green'];
  data.kpis.forEach(function(k, idx) {
    var barColor = colors[idx % colors.length];
    if (k.pct >= 100) barColor = 'green';
    else if (k.pct < 40) barColor = 'warn';

    var displayActual = k.unit === '$' ? anFmtDollar(k.actual) : (k.actual + (k.unit === '%' ? '%' : ''));
    var displayTarget = k.unit === '$' ? anFmtDollar(k.target) : (k.target + (k.unit === '%' ? '%' : ''));

    html += '<div class="an-kpi-card">';
    html += '<div class="an-kpi-label">' + escHtml(k.label) + '</div>';
    html += '<div class="an-kpi-values"><strong>' + escHtml(displayActual) + '</strong> / ' + escHtml(displayTarget) + ' target</div>';
    html += '<div class="an-kpi-bar-bg"><div class="an-kpi-bar-fill ' + barColor + '" style="width:' + k.pct + '%"></div></div>';
    html += '<div class="an-kpi-period">' + escHtml(k.period) + '</div>';
    html += '</div>';
  });
  el.innerHTML = html || '<p style="font-size:0.78rem;color:var(--text-light);">No KPI data.</p>';
}

/* KPI Targets modal */
function openKpiTargetsModal() {
  document.getElementById('kpi-targets-overlay').style.display = 'flex';
  document.getElementById('kpi-save-status').textContent = '';
}
function closeKpiTargetsModal(e) {
  if (e && e.target !== e.currentTarget) return;
  document.getElementById('kpi-targets-overlay').style.display = 'none';
}
function submitKpiTargets() {
  var targets = {
    bookings_monthly:        parseFloat(document.getElementById('kpi-t-bookings').value) || 0,
    revenue_quarterly:       parseFloat(document.getElementById('kpi-t-revenue').value) || 0,
    conversion:              parseFloat(document.getElementById('kpi-t-conversion').value) || 0,
    trial_conversion_monthly:parseFloat(document.getElementById('kpi-t-trial').value) || 0,
    avg_value:               parseFloat(document.getElementById('kpi-t-avgval').value) || 0,
    reviews_monthly:         parseFloat(document.getElementById('kpi-t-reviews').value) || 0
  };
  document.getElementById('kpi-save-status').textContent = 'Saving...';
  // TODO: Bridge route needed for: adminApi_saveKpiTargets
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_saveKpiTargets', args: { token: STATE.token, targets: targets } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res.error) { document.getElementById('kpi-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(res.error) + '</span>'; return; }
      document.getElementById('kpi-save-status').innerHTML = '<span style="color:var(--success);">Saved!</span>';
      setTimeout(function() { closeKpiTargetsModal(); loadKpiSection(); }, 800);
    }; _h(res.data); } else { var _e = function(err) {
      document.getElementById('kpi-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(err.message || String(err)) + '</span>';
    }; _e(res.error); } })
    .catch(function(err) {
      document.getElementById('kpi-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(err.message || String(err)) + '</span>';
    });
}

/* ────────────────────────────────────────────────────────────────
   ANALYTICS — Wedding Profitability Section
   ──────────────────────────────────────────────────────────────── */
var _profitabilityWeddings = []; // cache for the Add Cost dropdown

function loadProfitabilitySection() {
  var year = parseInt(document.getElementById('profit-year').value) || new Date().getFullYear();
  // TODO: Bridge route needed for: adminApi_getWeddingProfitability
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getWeddingProfitability', args: { token: STATE.token, year: year } })
    .then(function(res) { if (res.ok) renderProfitability(res.data); else { var errFn = function(err) {
      document.getElementById('profit-tbody').innerHTML = '<tr><td colspan="8" style="color:var(--danger);text-align:center;">Error: ' + escHtml(err.message || String(err)) + '</td></tr>';
    }; errFn(res.error); } })
    .catch(function(err) {
      document.getElementById('profit-tbody').innerHTML = '<tr><td colspan="8" style="color:var(--danger);text-align:center;">Error: ' + escHtml(err.message || String(err)) + '</td></tr>';
    });
}

function renderProfitability(data) {
  if (!data) return;
  if (data.error) {
    document.getElementById('profit-summary').innerHTML = '<p style="color:var(--danger);">' + escHtml(data.error) + '</p>';
    return;
  }
  _profitabilityWeddings = data.weddings || [];
  var s = data.summary || {};
  var avgM = (s.avgMargin != null) ? s.avgMargin : 0;

  // Summary strip
  var sumEl = document.getElementById('profit-summary');
  var alertHtml = s.belowThreshold > 0
    ? '<div class="stat-tile danger-tile"><div class="stat-value danger">' + s.belowThreshold + '</div><div class="stat-label">Below ' + (s.threshold || 40) + '% margin</div></div>'
    : '<div class="stat-tile success"><div class="stat-value success">' + (s.count || 0) + '</div><div class="stat-label">All above target</div></div>';

  sumEl.innerHTML =
    '<div class="stat-tile"><div class="stat-value">' + anFmtDollar(s.totalRevenue) + '</div><div class="stat-label">Total Revenue</div></div>' +
    '<div class="stat-tile"><div class="stat-value">' + anFmtDollar(s.totalCosts) + '</div><div class="stat-label">Total Costs</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + (s.totalProfit >= 0 ? 'success' : 'danger') + '">' + anFmtDollar(s.totalProfit) + '</div><div class="stat-label">Total Profit</div></div>' +
    '<div class="stat-tile"><div class="stat-value ' + (avgM >= 40 ? 'success' : avgM >= 20 ? 'warn' : 'danger') + '">' + avgM + '%</div><div class="stat-label">Avg Margin</div></div>' +
    alertHtml;

  // Table rows
  var tbody = document.getElementById('profit-tbody');
  if (!data.weddings || data.weddings.length === 0) {
    tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:var(--text-light);padding:2rem;">No booked weddings for this year.</td></tr>';
    return;
  }

  var html = '';
  data.weddings.forEach(function(w, idx) {
    var costByType = {};
    (w.costs || []).forEach(function(c) {
      costByType[c.type] = (costByType[c.type] || 0) + c.amount;
    });
    var proTeam = costByType['Pro Team'] || 0;
    var travel  = costByType['Travel'] || 0;
    var other   = (w.totalCosts - proTeam - travel);
    if (other < 0) other = 0;

    var wMargin = (w.margin != null) ? w.margin : 0;
    var rowClass = (wMargin < (data.summary.threshold || 40) && w.revenue > 0) ? ' class="low-margin"' : '';
    var marginClass = wMargin >= 50 ? 'margin-good' : (wMargin >= 30 ? 'margin-warn' : 'margin-bad');

    html += '<tr' + rowClass + ' style="cursor:pointer;" onclick="toggleCostDetail(' + idx + ')">';
    html += '<td><div>' + escHtml(w.name) + '</div>';
    if (w.services || w.partySize) {
      html += '<div class="client-sub">' + escHtml((w.partySize ? w.partySize + ' ppl' : '') + (w.services ? ', ' + w.services : '')) + '</div>';
    }
    html += '</td>';
    html += '<td>' + escHtml(w.date ? formatDate(w.date) : '—') + '</td>';
    html += '<td class="num">' + anFmtDollar(w.revenue) + '</td>';
    html += '<td class="num cost-neg">' + (proTeam > 0 ? '-' + anFmtDollar(proTeam) : '—') + '</td>';
    html += '<td class="num cost-neg">' + (travel > 0 ? '-' + anFmtDollar(travel) : '—') + '</td>';
    html += '<td class="num cost-neg">' + (other > 0 ? '-' + anFmtDollar(other) : '—') + '</td>';
    html += '<td class="num profit-pos">' + anFmtDollar(w.profit) + '</td>';
    html += '<td class="num"><span class="margin-badge ' + marginClass + '">' + wMargin + '%</span></td>';
    html += '</tr>';

    // Hidden cost detail row
    html += '<tr class="an-cost-detail-row" id="cost-detail-' + idx + '" style="display:none;">';
    html += '<td colspan="8"><div class="an-cost-list">';
    if (w.costs && w.costs.length > 0) {
      w.costs.forEach(function(c) {
        html += '<div>' + escHtml(c.type) + ': ' + escHtml(c.description || '') + (c.artist ? ' (' + escHtml(c.artist) + ')' : '') + ' — <strong>$' + c.amount.toFixed(2) + '</strong></div>';
      });
    } else {
      html += '<div style="color:var(--text-light);">No costs entered yet. Click "+ Add Cost" to add.</div>';
    }
    if (w.artist) html += '<div style="margin-top:0.3rem;">Assigned artist: ' + escHtml(w.artist) + '</div>';
    if (w.venue) html += '<div>Venue: ' + escHtml(w.venue) + '</div>';
    html += '</div></td></tr>';
  });

  tbody.innerHTML = html;
}

function toggleCostDetail(idx) {
  var row = document.getElementById('cost-detail-' + idx);
  if (row) row.style.display = row.style.display === 'none' ? '' : 'none';
}

/* Add Cost modal */
/* ============================================================
   ADD SERVICE TO BOOKING (post-booking add-ons, admin-direct)
   Backend: adminApi_getAddonCatalog / adminApi_addAddonDirect.
   ============================================================ */
var _addonCatalog = null;

function openAddonAddModal(clientId, email) {
  var overlay = document.getElementById('addon-add-overlay');
  document.getElementById('addon-add-email').value = email || '';
  document.getElementById('addon-add-status').textContent = '';
  document.getElementById('addon-add-status').style.color = '';
  overlay.style.display = 'flex';
  if (!email) { document.getElementById('addon-add-status').textContent = 'This bride has no email on file, cannot add.'; document.getElementById('addon-add-status').style.color = 'var(--danger,#b32727)'; return; }
  // Reset fields
  document.getElementById('addon-add-type').value = 'extra_person';
  document.getElementById('addon-add-person-name').value = '';
  var svcSel = document.getElementById('addon-add-service'); svcSel.innerHTML = '<option>Loading prices...</option>';
  jvBridge.callAdmin('bridge_admin_getAddonCatalog', { email: email })
    .then(function(res) {
      // bridge_admin_getAddonCatalog returns {ok, roles, standalone, members} directly
      // on res (no res.data wrapper) -- confirmed live 2026-08-20 via
      // BRIEFS/RESULTS-verify-addon-catalog-modal-2026-08-20.md.
      var data = (res && res.ok) ? res : null;
      if (data && data.ok) { _addonCatalog = data; addonAddPopulate_(); addonAddTypeChanged(); }
      else { document.getElementById('addon-add-status').textContent = (data && data.error) || (res && res.error) || 'Could not load prices'; document.getElementById('addon-add-status').style.color = 'var(--danger,#b32727)'; }
    })
    .catch(function(err) { document.getElementById('addon-add-status').textContent = err && err.message || String(err); document.getElementById('addon-add-status').style.color = 'var(--danger,#b32727)'; });
}

function addonAddMoney_(cents) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }

function addonAddPopulate_() {
  if (!_addonCatalog) return;
  // Service dropdown = role x serviceType (for extra_person / extra_service).
  var svcSel = document.getElementById('addon-add-service');
  svcSel.innerHTML = '';
  (_addonCatalog.roles || []).forEach(function(r) {
    (r.rates || []).forEach(function(rt) {
      var opt = document.createElement('option');
      opt.value = JSON.stringify({ category: r.role, serviceType: rt.serviceType, priceCents: rt.priceCents });
      opt.textContent = r.role + ', ' + rt.serviceType + ' (' + addonAddMoney_(rt.priceCents) + ')';
      svcSel.appendChild(opt);
    });
  });
  // Standalone dropdown.
  var stSel = document.getElementById('addon-add-standalone');
  stSel.innerHTML = '';
  (_addonCatalog.standalone || []).forEach(function(s) {
    var opt = document.createElement('option');
    opt.value = JSON.stringify({ category: 'other', label: s.label, unitPriceCents: s.unitPriceCents });
    opt.textContent = s.label + ' (' + addonAddMoney_(s.unitPriceCents) + ')';
    stSel.appendChild(opt);
  });
  // Member dropdown (existing party) for extra_service.
  var mSel = document.getElementById('addon-add-member');
  mSel.innerHTML = '';
  (_addonCatalog.members || []).forEach(function(m) {
    var opt = document.createElement('option');
    opt.value = m.pmId;
    opt.textContent = (m.name || '(unnamed)') + (m.role ? ', ' + m.role : '');
    mSel.appendChild(opt);
  });
  if (!(_addonCatalog.members || []).length) {
    var optNone = document.createElement('option'); optNone.value = ''; optNone.textContent = '(no party members yet)'; mSel.appendChild(optNone);
  }
}

function addonAddTypeChanged() {
  var t = document.getElementById('addon-add-type').value;
  document.getElementById('addon-add-person-wrap').style.display    = (t === 'extra_person') ? '' : 'none';
  document.getElementById('addon-add-member-wrap').style.display    = (t === 'extra_service') ? '' : 'none';
  document.getElementById('addon-add-service-wrap').style.display   = (t === 'extra_person' || t === 'extra_service') ? '' : 'none';
  document.getElementById('addon-add-standalone-wrap').style.display = (t === 'standalone') ? '' : 'none';
  if (t === 'standalone') { addonAddStandaloneChanged_(); }
  else { extHireReset_(); }
}

// Hair Extension Rental reordered flow (2026-09-08).
// State for the inline extension-hire sub-panel inside the Add Service modal.
// Kept separate from _addonCatalog (which is the whole modal's price catalog)
// because this holds a specific bondId/set-list for the CURRENTLY selected
// standalone add-on, only relevant while "Hair Extension Rental" is picked.
var _extHireState = null; // { bondId, signed, sets, currentSetId, brideEmail }

function extHireReset_() {
  _extHireState = null;
  document.getElementById('ext-hire-panel').style.display = 'none';
  document.getElementById('ext-hire-body').style.display = 'none';
  document.getElementById('ext-hire-status').textContent = 'Loading hire details...';
  document.getElementById('ext-hire-status').style.display = '';
  document.getElementById('ext-hire-signed-banner').style.display = 'none';
  document.getElementById('ext-hire-send-btn').style.display = 'none';
  document.getElementById('ext-hire-copy-btn').style.display = 'none';
}

// Fired when the standalone dropdown's selection changes, and once on type
// change if 'standalone' is already active. Detects "Hair Extension Rental"
// by the exact label BookingAddonsAPI.gs uses server-side (bookingAddon_standaloneCents_).
function addonAddStandaloneChanged_() {
  var stSel = document.getElementById('addon-add-standalone');
  var raw = stSel && stSel.value;
  var isExtension = false;
  if (raw) {
    try { isExtension = (JSON.parse(raw).label === 'Hair Extension Rental'); } catch (e) {}
  }
  if (!isExtension) { extHireReset_(); return; }
  extHireLoadStep_();
}

function extHireLoadStep_() {
  var email = document.getElementById('addon-add-email').value;
  if (!email) return;
  document.getElementById('ext-hire-panel').style.display = '';
  extHireReset_();
  document.getElementById('ext-hire-panel').style.display = '';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_extensionHireStartStep', args: { brideEmail: email } })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (!data || !data.ok) {
        document.getElementById('ext-hire-status').textContent = (data && data.error) || (res && res.error) || 'Could not load hire details';
        document.getElementById('ext-hire-status').style.color = 'var(--danger,#b32727)';
        return;
      }
      _extHireState = { bondId: data.bondId, signed: !!data.signed, sets: data.sets || [], currentSetId: data.currentSetId || '', brideEmail: email };
      extHireRenderStep_();
    })
    .catch(function(err) {
      document.getElementById('ext-hire-status').textContent = err && err.message || String(err);
      document.getElementById('ext-hire-status').style.color = 'var(--danger,#b32727)';
    });
}

function extHireRenderStep_() {
  if (!_extHireState) return;
  document.getElementById('ext-hire-status').style.display = 'none';
  document.getElementById('ext-hire-body').style.display = '';

  var banner = document.getElementById('ext-hire-signed-banner');
  if (_extHireState.signed) {
    banner.textContent = 'Rental agreement already signed. Pick a set below, then Add to booking will charge and reserve it together.';
    banner.style.background = 'rgba(46,125,50,0.1)';
    banner.style.color = 'var(--status-ready-text, #1b5e20)';
    banner.style.display = '';
    document.getElementById('ext-hire-send-btn').style.display = 'none';
    document.getElementById('ext-hire-copy-btn').style.display = 'none';
  } else {
    banner.textContent = 'She needs to sign her rental agreement before this can be charged. Preview it below, then send it to her. You can still pick a set now so it is ready the moment she signs.';
    banner.style.background = 'rgba(179,39,39,0.08)';
    banner.style.color = 'var(--status-action-text, #b32727)';
    banner.style.display = '';
    document.getElementById('ext-hire-send-btn').style.display = '';
    document.getElementById('ext-hire-copy-btn').style.display = '';
  }

  var setSel = document.getElementById('ext-hire-set');
  setSel.innerHTML = '';
  var sets = _extHireState.sets || [];
  var availableCount = 0;
  sets.forEach(function(s) {
    var opt = document.createElement('option');
    opt.value = s.setId;
    var label = s.setId + ', ' + (s.colour || '') + (s.length ? ', ' + s.length : '');
    if (!s.availableForWindow) { label += ' (not available for her dates)'; opt.disabled = true; }
    else { availableCount++; }
    opt.textContent = label;
    if (s.setId === _extHireState.currentSetId) opt.selected = true;
    setSel.appendChild(opt);
  });
  var hint = document.getElementById('ext-hire-set-hint');
  if (!sets.length) { hint.textContent = 'No physical sets found in inventory.'; }
  else if (!availableCount) { hint.textContent = 'No sets are free for her return window, check Extension Inventory for conflicts.'; }
  else { hint.textContent = availableCount + ' of ' + sets.length + ' sets free for her dates.'; }
}

function extHirePreviewAgreement_() {
  if (!_extHireState || !_extHireState.bondId) return;
  var btn = document.getElementById('ext-hire-preview-btn');
  var originalLabel = btn.textContent;
  btn.disabled = true; btn.textContent = 'Loading...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_previewExtensionAgreement', args: { bondId: _extHireState.bondId } })
    .then(function(res) {
      btn.disabled = false; btn.textContent = originalLabel;
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) { showExtensionAgreementPreviewModal_(data); }
      else { jvToast((data && data.error) || (res && res.error) || 'Preview failed', 'error'); }
    })
    .catch(function(err) {
      btn.disabled = false; btn.textContent = originalLabel;
      jvToast(err && err.message || String(err), 'error');
    });
}

function extHireSendAgreement_() {
  if (!_extHireState || !_extHireState.bondId) return;
  var btn = document.getElementById('ext-hire-send-btn');
  var originalLabel = btn.textContent;
  btn.disabled = true; btn.textContent = 'Sending...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_sendExtensionAgreementLink', args: { brideEmail: _extHireState.brideEmail, bondId: _extHireState.bondId } })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        btn.textContent = data.deferred ? 'Queued (quiet hours)' : 'Sent!';
        jvToast(data.deferred ? 'Queued for after quiet hours' : 'Agreement link emailed to bride', 'success');
      } else {
        btn.disabled = false; btn.textContent = originalLabel;
        jvToast((data && data.error) || (res && res.error) || 'Send failed', 'error');
      }
    })
    .catch(function(err) {
      btn.disabled = false; btn.textContent = originalLabel;
      jvToast(err && err.message || String(err), 'error');
    });
}

function extHireCopyAgreementLink_() {
  if (!_extHireState || !_extHireState.bondId) return;
  var signUrl = window.location.origin + '/pages/extension-rental-agreement?bond=' + encodeURIComponent(_extHireState.bondId);
  var btn = document.getElementById('ext-hire-copy-btn');
  var originalLabel = btn.textContent;
  var done = function() { btn.textContent = 'Copied!'; setTimeout(function() { btn.textContent = originalLabel; }, 1800); };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(signUrl).then(done, function() { window.prompt('Copy this link:', signUrl); done(); });
  } else {
    window.prompt('Copy this link:', signUrl); done();
  }
}

function closeAddonAddModal(e) {
  if (e && e.target !== e.currentTarget) return;
  document.getElementById('addon-add-overlay').style.display = 'none';
  extHireReset_();
}

function submitAddonAdd() {
  var email = document.getElementById('addon-add-email').value;
  var type = document.getElementById('addon-add-type').value;
  var settle = document.getElementById('addon-add-settle').value;
  var statusEl = document.getElementById('addon-add-status');
  var btn = document.getElementById('addon-add-submit');
  statusEl.style.color = '';

  var payload = { brideEmail: email, addonType: type, settle: settle, services: [] };
  if (type === 'extra_person') {
    var name = (document.getElementById('addon-add-person-name').value || '').trim();
    if (!name) { statusEl.textContent = 'Enter the person\'s name.'; statusEl.style.color = 'var(--danger,#b32727)'; return; }
    payload.personName = name;
    payload.personRole = document.getElementById('addon-add-role').value;
    var svc = JSON.parse(document.getElementById('addon-add-service').value || '{}');
    payload.services = [{ label: payload.personRole + ' ' + svc.serviceType, category: svc.category, serviceType: svc.serviceType, qty: 1 }];
  } else if (type === 'extra_service') {
    var memberId = document.getElementById('addon-add-member').value;
    if (!memberId) { statusEl.textContent = 'No party member to add a service to.'; statusEl.style.color = 'var(--danger,#b32727)'; return; }
    payload.targetMemberId = memberId;
    var svc2 = JSON.parse(document.getElementById('addon-add-service').value || '{}');
    payload.services = [{ label: svc2.category + ' ' + svc2.serviceType, category: svc2.category, serviceType: svc2.serviceType, qty: 1 }];
  } else if (type === 'standalone') {
    var st = JSON.parse(document.getElementById('addon-add-standalone').value || '{}');
    payload.services = [{ label: st.label, category: 'other', unitPriceCents: st.unitPriceCents, qty: 1 }];
  }

  // Hair Extension Rental (2026-09-08 reorder): if the inline panel loaded a
  // hire step and she's already signed, block the submit until a set is
  // picked, so a charge can never land with no set reserved against it.
  // extInv_assignSet_ (via adminApi_extensionAssignSet) runs AFTER the
  // charge succeeds, not before -- a set-assignment failure must not undo a
  // real Stripe/Xero charge that already went through, so this is a
  // best-effort follow-up commit, not a single atomic transaction. If it
  // fails, the charge still stands and the admin is told plainly to finish
  // the set assignment on Extension Inventory herself.
  var extSetIdToAssign = '';
  if (_extHireState && _extHireState.signed) {
    var setSel = document.getElementById('ext-hire-set');
    extSetIdToAssign = (setSel && setSel.value) || '';
    if (!extSetIdToAssign) {
      statusEl.textContent = 'Pick a physical set before adding to booking.';
      statusEl.style.color = 'var(--danger,#b32727)';
      return;
    }
  }

  btn.disabled = true;
  statusEl.textContent = 'Adding...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_addAddonDirect', args: payload })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        if (!extSetIdToAssign) {
          if (data.settle === 'handled') { jvToast('Added to booking', 'success'); }
          else { jvToast('Added. Payment link sent to bride', 'success'); }
          closeAddonAddModal();
          return;
        }
        // Charge/invoice succeeded -- now commit the set reservation. Best-
        // effort: never rolls back the charge above, per the comment where
        // extSetIdToAssign is computed.
        jvBridge.callAdmin('bridge_admin_generic', {
          function: 'adminApi_extensionAssignSet',
          args: { bondId: _extHireState.bondId, setId: extSetIdToAssign, assignedBy: 'admin' }
        }).then(function(assignRes) {
          var assignData = (assignRes && assignRes.ok && assignRes.data) ? assignRes.data : null;
          if (assignData && assignData.ok) {
            jvToast((data.settle === 'handled' ? 'Added to booking' : 'Added, payment link sent') + ' and set ' + extSetIdToAssign + ' reserved', 'success');
          } else {
            jvToast('Charged, but the set reservation failed (' + ((assignData && assignData.error) || (assignRes && assignRes.error) || 'unknown error') + '). Assign the set manually on Extension Inventory.', 'error');
          }
          closeAddonAddModal();
        }).catch(function(err) {
          jvToast('Charged, but the set reservation failed (' + (err && err.message || String(err)) + '). Assign the set manually on Extension Inventory.', 'error');
          closeAddonAddModal();
        });
      } else if (data && data.needsAgreementSignature && data.bondId) {
        // 2026-08-19 (BRIEFS/HANDOFF-extension-hire-admin-modal-dead-end-2026-08-19.md):
        // adminApi_addAddonDirect refuses a hair extension rental until the bride has
        // signed her rental agreement. Previously this printed the bare backend error
        // string with no next step -- a dead end for the flow Jess is most likely to
        // use in practice (a phone call, adding extensions herself). Give her a
        // working copy-link button instead, same clipboard-then-prompt-fallback
        // pattern as copyBrideRunsheetLink.
        //
        // 2026-08-20 (Jess ask): the bride's OWN Experience Builder flow already
        // auto-redirects her to sign, no manual step. This admin path was the odd
        // one out -- Copy-link required Jess to leave the app and paste it into a
        // text/email herself. Added a one-click "Send to bride" button (email,
        // via the new bridge_admin_sendExtensionAgreementLink route -- role 4's
        // ExtensionRentalAgreement_2026_08_18.gs, uses JV_sendOrDefer_email_ so
        // quiet-hours/safe-mode are respected automatically, same as every other
        // comms send in this codebase). Copy-link KEPT as a fallback for when
        // Jess wants to hand-deliver it herself (phone call, in person, etc.).
        var signUrl = window.location.origin + '/pages/extension-rental-agreement?bond=' + encodeURIComponent(data.bondId);
        statusEl.innerHTML = '';
        var msg = document.createElement('p');
        msg.style.margin = '0 0 0.5rem';
        msg.textContent = 'She needs to sign her rental agreement first.';
        statusEl.appendChild(msg);
        var sendBtn = document.createElement('button');
        sendBtn.type = 'button';
        sendBtn.className = 'btn btn-primary';
        sendBtn.style.marginRight = '0.5rem';
        sendBtn.textContent = 'Send to bride';
        sendBtn.onclick = function() {
          var originalLabel = sendBtn.textContent;
          sendBtn.disabled = true;
          sendBtn.textContent = 'Sending...';
          jvBridge.callAdmin('bridge_admin_generic', {
            function: 'adminApi_sendExtensionAgreementLink',
            args: { brideEmail: email, bondId: data.bondId }
          }).then(function(sendRes) {
            var sendData = (sendRes && sendRes.ok && sendRes.data) ? sendRes.data : null;
            if (sendData && sendData.ok) {
              sendBtn.textContent = sendData.deferred ? 'Queued (quiet hours)' : 'Sent!';
              jvToast(sendData.deferred ? 'Queued for after quiet hours' : 'Agreement link emailed to bride', 'success');
            } else {
              sendBtn.disabled = false;
              sendBtn.textContent = originalLabel;
              jvToast((sendData && sendData.error) || (sendRes && sendRes.error) || 'Send failed', 'error');
            }
          }).catch(function(err) {
            sendBtn.disabled = false;
            sendBtn.textContent = originalLabel;
            jvToast(err && err.message || String(err), 'error');
          });
        };
        statusEl.appendChild(sendBtn);
        // Preview (2026-08-21, forensic-audit follow-up: the bride-facing
        // page correctly rejects an admin's own login as "not authorised
        // for this bond" -- confirmed as expected behaviour, not a bug --
        // but that left no way to see what a bride will actually see before
        // sending it. adminApi_previewExtensionAgreement is ADMIN-gated, a
        // deliberately separate route from the bride's own
        // bridge_extensionAgreement_get so a bug here can never let one
        // bride view another's contract.
        var previewBtn = document.createElement('button');
        previewBtn.type = 'button';
        previewBtn.className = 'btn btn-ghost';
        previewBtn.style.marginRight = '0.5rem';
        previewBtn.textContent = 'Preview';
        previewBtn.onclick = function() {
          var originalLabel = previewBtn.textContent;
          previewBtn.disabled = true;
          previewBtn.textContent = 'Loading...';
          jvBridge.callAdmin('bridge_admin_generic', {
            function: 'adminApi_previewExtensionAgreement',
            args: { bondId: data.bondId }
          }).then(function(previewRes) {
            previewBtn.disabled = false;
            previewBtn.textContent = originalLabel;
            var previewData = (previewRes && previewRes.ok && previewRes.data) ? previewRes.data : null;
            if (previewData && previewData.ok) {
              showExtensionAgreementPreviewModal_(previewData);
            } else {
              jvToast((previewData && previewData.error) || (previewRes && previewRes.error) || 'Preview failed', 'error');
            }
          }).catch(function(err) {
            previewBtn.disabled = false;
            previewBtn.textContent = originalLabel;
            jvToast(err && err.message || String(err), 'error');
          });
        };
        statusEl.appendChild(previewBtn);
        var copyBtn = document.createElement('button');
        copyBtn.type = 'button';
        copyBtn.className = 'btn btn-ghost';
        copyBtn.textContent = 'Copy agreement link';
        copyBtn.onclick = function() {
          var originalLabel = copyBtn.textContent;
          var done = function() {
            copyBtn.textContent = 'Copied!';
            setTimeout(function() { copyBtn.textContent = originalLabel; }, 1800);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(signUrl).then(done, function() {
              window.prompt('Copy this link:', signUrl);
              done();
            });
          } else {
            window.prompt('Copy this link:', signUrl);
            done();
          }
        };
        statusEl.appendChild(copyBtn);
        statusEl.style.color = 'var(--danger,#b32727)';
        btn.disabled = false;
      } else {
        statusEl.textContent = (data && data.error) || 'Could not add';
        statusEl.style.color = 'var(--danger,#b32727)';
        btn.disabled = false;
      }
    })
    .catch(function(err) { statusEl.textContent = err && err.message || String(err); statusEl.style.color = 'var(--danger,#b32727)'; btn.disabled = false; });
}

/**
 * Extension rental agreement preview (2026-08-21). Shows an admin exactly
 * what a bride will see on /pages/extension-rental-agreement, without
 * needing to be logged into her own Shopify account. Read-only -- no sign
 * action here, that stays exclusively on the bride's own page.
 */
function showExtensionAgreementPreviewModal_(data) {
  var existing = document.getElementById('ext-agreement-preview-modal');
  if (existing) existing.remove();

  var signedHtml = data.alreadySigned
    ? '<div class="alert info" style="margin-bottom:0.8rem;font-size:0.8rem;">Already signed by ' +
        escHtml(data.signedName || '') + ' on ' + escHtml(data.signedAt || '') + '.</div>'
    : '<div style="margin-bottom:0.8rem;font-size:0.8rem;color:var(--text-muted,#7a6e6c);">Not yet signed.</div>';

  var bodyHtml = String(data.body || '')
    .split('\n\n')
    .map(function (para) { return '<p style="margin:0 0 0.9rem;">' + escHtml(para).replace(/\n/g, '<br>') + '</p>'; })
    .join('');

  var modal = document.createElement('div');
  modal.id = 'ext-agreement-preview-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(30,23,22,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
  modal.innerHTML =
    '<div style="max-width:600px;width:100%;max-height:85vh;overflow-y:auto;background:#fff;border-radius:var(--radius-large,1.5rem);padding:1.5rem;">' +
      '<div style="font-size:1rem;font-weight:700;margin-bottom:0.2rem;">' + escHtml(data.title || 'Rental Agreement') + '</div>' +
      '<div style="font-size:0.78rem;color:var(--text-muted,#7a6e6c);margin-bottom:0.8rem;">' +
        'Admin preview for ' + escHtml(data.brideName || '') +
        (data.weddingDate ? ' &middot; wedding ' + escHtml(data.weddingDate) : '') +
      '</div>' +
      signedHtml +
      '<div style="font-size:0.82rem;line-height:1.6;">' + bodyHtml + '</div>' +
      '<div style="display:flex;gap:0.5rem;margin-top:1.2rem;justify-content:flex-end;">' +
        '<button class="btn-ghost" onclick="document.getElementById(\'ext-agreement-preview-modal\').remove()">Close</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
}

function openAddCostModal() {
  document.getElementById('add-cost-overlay').style.display = 'flex';
  document.getElementById('cost-save-status').textContent = '';
  // Populate wedding dropdown from cached data
  var sel = document.getElementById('cost-wedding-select');
  sel.innerHTML = '<option value="">Select wedding...</option>';
  _profitabilityWeddings.forEach(function(w) {
    sel.innerHTML += '<option value="' + escHtml(w.dateSortKey) + '" data-name="' + escHtml(w.name) + '">' + escHtml(w.name + ' — ' + w.date) + '</option>';
  });
  document.getElementById('cost-description').value = '';
  document.getElementById('cost-artist').value = '';
  document.getElementById('cost-amount').value = '';
}

function closeAddCostModal(e) {
  if (e && e.target !== e.currentTarget) return;
  document.getElementById('add-cost-overlay').style.display = 'none';
}

function submitAddCost() {
  var sel = document.getElementById('cost-wedding-select');
  var weddingDate = sel.value;
  var clientName = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].getAttribute('data-name') || '' : '';
  var costType = document.getElementById('cost-type-select').value;
  var desc = document.getElementById('cost-description').value.trim();
  var artist = document.getElementById('cost-artist').value.trim();
  var amount = document.getElementById('cost-amount').value;

  if (!weddingDate) { document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--danger);">Please select a wedding.</span>'; return; }
  if (!amount || parseFloat(amount) <= 0) { document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--danger);">Please enter an amount.</span>'; return; }

  document.getElementById('cost-save-status').textContent = 'Saving...';
  // TODO: Bridge route needed for: adminApi_addWeddingCost
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_addWeddingCost', args: {
      token: STATE.token,
      weddingDate: weddingDate,
      clientName: clientName,
      costType: costType,
      description: desc,
      artist: artist,
      amount: amount
    } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res.error) { document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(res.error) + '</span>'; return; }
      document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--success);">Cost saved!</span>';
      setTimeout(function() { closeAddCostModal(); loadProfitabilitySection(); }, 800);
    }; _h(res.data); } else { var _e = function(err) {
      document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(err.message || String(err)) + '</span>';
    }; _e(res.error); } })
    .catch(function(err) {
      document.getElementById('cost-save-status').innerHTML = '<span style="color:var(--danger);">' + escHtml(err.message || String(err)) + '</span>';
    });
}

/* Export CSV */
function exportProfitabilityCsv() {
  var year = parseInt(document.getElementById('profit-year').value) || new Date().getFullYear();
  // TODO: Bridge route needed for: adminApi_exportProfitabilityCsv
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_exportProfitabilityCsv', args: { token: STATE.token, year: year } })
    .then(function(res) { if (res.ok) { var _h = function(res) {
      if (res.error) { alert('Export error: ' + res.error); return; }
      // Download CSV via blob
      var blob = new Blob([res.csv], { type: 'text/csv' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = res.filename || 'profitability.csv';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }; _h(res.data); } else { var _e = function(err) { alert('Export failed: ' + (err.message || err)); }; _e(res.error); } })
    .catch(function(err) { alert('Export failed: ' + (err.message || err)); });
}

/* ── Shared analytics formatters ── */
function anFmtDollar(val) {
  if (val == null) return '$0';
  var num = parseFloat(val) || 0;
  if (num >= 1000) return '$' + (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return '$' + num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

/* ============================================================
   REPORTS VIEW
   ============================================================ */
function loadReportsView() {
  showLoader('reports');
  var el = document.getElementById('reports-data');
  el.innerHTML = '<div style="text-align:center;padding:2rem 1rem;">' +
    '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--brand-primary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin:0 auto 1rem;display:block;opacity:0.6;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>' +
    '<div style="font-weight:600;font-size:1rem;color:var(--brand-text);margin-bottom:0.4rem;">Reports, Coming Soon</div>' +
    '<div style="font-size:0.82rem;color:var(--text-light);max-width:360px;margin:0 auto;">Custom report generation is on the roadmap. In the meantime, use the <a href="#" onclick="switchView(\'analytics\'); return false;" style="color:var(--brand-primary);font-weight:500;">Analytics</a> dashboard for real-time insights.</div>' +
    '</div>';
  showContent('reports');
}

/* ============================================================
   AUTOMATIONS VIEW — Workflow Monitor
   ============================================================ */
var WF_DATA = null; // cached workflow monitor data

function loadAutomationsView() {
  showLoader('automations');
  // TODO: Bridge route needed for: adminApi_getWorkflowMonitor
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getWorkflowMonitor', args: { token: STATE.token } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      if (!data || !data.ok) {
        showError('automations', (data && data.error) || 'Failed to load workflow data.');
        return;
      }
      WF_DATA = data;
      renderWfSummary(data.summary);
      renderWfDefinitions(data.workflows);
      renderWfEngines(data.engines || []);
      populateWfFilters(data.workflows);
      renderWfQueue();
      renderWfSafeMode(data.safeMode);
      showContent('automations');
    }; _h(res.data); } else { var _e = function(err){ showError('automations', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('automations', err.message || String(err)); });
}

/* ---------- Summary Cards ---------- */
function renderWfSummary(s) {
  var cards = [
    { label: 'SEQUENCES RUNNING', value: s.running,        color: 'var(--brand-primary)', bg: '#fdf2f0' },
    { label: 'WAITING FOR ACTION', value: s.waiting,        color: 'var(--warning)',       bg: 'var(--warning-bg)' },
    { label: 'COMPLETED TODAY',   value: s.completedToday, color: 'var(--success)',       bg: 'var(--success-bg)' },
    { label: 'NEEDS REVIEW',     value: s.failed,          color: 'var(--danger)',        bg: 'var(--danger-bg)' }
  ];
  var html = '';
  cards.forEach(function(c) {
    html += '<div class="card-panel" style="text-align:center;padding:1rem 0.75rem;border-left:3px solid ' + c.color + ';background:' + c.bg + ';">';
    html += '<div style="font-size:1.5rem;font-weight:800;color:' + c.color + ';">' + c.value + '</div>';
    html += '<div style="font-size:0.62rem;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--text-light);margin-top:0.2rem;">' + c.label + '</div>';
    html += '</div>';
  });
  document.getElementById('wf-summary').innerHTML = html;
}

/* ---------- Workflow Definitions ---------- */
function renderWfDefinitions(workflows) {
  if (!workflows || !workflows.length) {
    document.getElementById('wf-definitions').innerHTML = '<div class="alert info">No workflow definitions found.</div>';
    return;
  }
  var html = '';
  workflows.forEach(function(wf) {
    var countBadge = wf.clientCount > 0
      ? '<span style="background:var(--brand-primary);color:#fff;font-size:0.65rem;font-weight:700;padding:0.1rem 0.45rem;border-radius:var(--radius-pill);margin-left:0.5rem;">' + wf.clientCount + '</span>'
      : '<span style="background:var(--line);color:var(--text-light);font-size:0.65rem;font-weight:700;padding:0.1rem 0.45rem;border-radius:var(--radius-pill);margin-left:0.5rem;">0</span>';
    html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:0.6rem 0;border-bottom:1px solid var(--line);cursor:pointer;" onclick="showWfDetail(\'' + escHtml(wf.id) + '\')">';
    html += '<div style="display:flex;align-items:center;">';
    html += '<span style="font-weight:600;font-size:0.82rem;color:var(--brand-dark);">' + escHtml(wf.name) + '</span>';
    html += countBadge;
    html += '</div>';
    html += '<div style="display:flex;align-items:center;gap:0.5rem;">';
    html += '<span style="font-size:0.7rem;color:var(--text-light);">' + wf.steps.length + ' steps</span>';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text-light)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    html += '</div></div>';
  });
  document.getElementById('wf-definitions').innerHTML = html;
}

/* ---------- Automation Engines ---------- */
function renderWfEngines(engines) {
  if (!engines || !engines.length) {
    document.getElementById('wf-engines').innerHTML = '<div style="font-size:0.78rem;color:var(--text-light);">No engine data available.</div>';
    return;
  }
  var html = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:0.5rem;">';
  engines.forEach(function(eng) {
    var dot = eng.enabled ? '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--success);margin-right:0.4rem;"></span>' : '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--text-light);margin-right:0.4rem;"></span>';
    html += '<div style="display:flex;align-items:center;padding:0.5rem 0;font-size:0.78rem;">';
    html += dot + '<span style="font-weight:600;color:var(--brand-dark);">' + escHtml(eng.name) + '</span>';
    if (eng.lastRun) html += '<span style="margin-left:auto;font-size:0.68rem;color:var(--text-light);">' + escHtml(eng.lastRun) + '</span>';
    html += '</div>';
  });
  html += '</div>';
  document.getElementById('wf-engines').innerHTML = html;
}

/* ---------- Filter population ---------- */
function populateWfFilters(workflows) {
  var sel = document.getElementById('wf-filter-type');
  // Keep first "All" option, remove rest
  while (sel.options.length > 1) sel.remove(1);
  (workflows || []).forEach(function(wf) {
    var opt = document.createElement('option');
    opt.value = wf.id;
    opt.textContent = wf.name;
    sel.appendChild(opt);
  });
}

/* ---------- Live Queue Table ---------- */
function renderWfQueue() {
  if (!WF_DATA || !WF_DATA.queue) return;
  var filterType   = document.getElementById('wf-filter-type').value;
  var filterStatus = document.getElementById('wf-filter-status').value;
  var searchTerm   = (document.getElementById('wf-search').value || '').toLowerCase();

  var items = WF_DATA.queue.filter(function(q) {
    if (filterType && q.workflow !== filterType) return false;
    if (filterStatus && q.status !== filterStatus) return false;
    if (searchTerm && q.client.toLowerCase().indexOf(searchTerm) === -1) return false;
    return true;
  });

  if (items.length === 0) {
    document.getElementById('wf-queue').innerHTML = '<div style="padding:1.5rem;text-align:center;color:var(--text-light);font-size:0.82rem;">No clients match the current filters.</div>';
    return;
  }

  var statusIcons = { active: '\u25CF', waiting: '\u23F3', scheduled: '\u23F0', completed: '\u2713', failed: '\u2717' };
  var statusColors = { active: 'var(--brand-primary)', waiting: 'var(--warning)', scheduled: 'var(--info)', completed: 'var(--success)', failed: 'var(--danger)' };

  var html = '<table class="data-table"><thead><tr>';
  html += '<th>Client</th><th>Workflow</th><th>Current Step</th><th>Status</th><th>Date</th>';
  html += '</tr></thead><tbody>';

  items.forEach(function(q) {
    var icon = statusIcons[q.status] || '';
    var color = statusColors[q.status] || 'var(--text-light)';
    html += '<tr style="cursor:pointer;" onclick="showClientWfDetail(\'' + escHtml(q.email) + '\')">';
    html += '<td><span style="font-weight:600;font-size:0.8rem;">' + escHtml(q.client) + '</span></td>';
    html += '<td><span style="font-size:0.75rem;color:var(--text-mid);">' + escHtml(q.workflowName) + '</span></td>';
    html += '<td><span style="font-size:0.78rem;">' + escHtml(q.currentStep) + '</span></td>';
    html += '<td><span style="color:' + color + ';font-weight:600;font-size:0.75rem;">' + icon + ' ' + escHtml(q.status.charAt(0).toUpperCase() + q.status.slice(1)) + '</span></td>';
    html += '<td><span style="font-size:0.72rem;color:var(--text-light);">' + escHtml(q.scheduledDate || q.daysInfo || '') + '</span></td>';
    html += '</tr>';
  });
  html += '</tbody></table>';
  document.getElementById('wf-queue').innerHTML = html;
}

/* ---------- Workflow Detail Overlay ---------- */
function showWfDetail(wfId) {
  if (!WF_DATA) return;
  var wf = null;
  WF_DATA.workflows.forEach(function(w) { if (w.id === wfId) wf = w; });
  if (!wf) return;

  var clients = WF_DATA.queue.filter(function(q) { return q.workflow === wfId; });

  var html = '<div style="margin-bottom:1rem;">';
  html += '<div style="font-family:Raleway,sans-serif;font-size:1rem;font-weight:300;color:var(--brand-dark);">' + escHtml(wf.name) + '</div>';
  html += '<div style="font-size:0.72rem;color:var(--text-light);margin-top:0.2rem;">' + wf.clientCount + ' client' + (wf.clientCount !== 1 ? 's' : '') + ' in this sequence</div>';
  html += '</div>';

  // Step sequence visualization
  html += '<div style="display:flex;align-items:center;gap:0;margin-bottom:1.25rem;overflow-x:auto;padding:0.5rem 0;">';
  wf.steps.forEach(function(step, idx) {
    if (idx > 0) html += '<div style="width:24px;height:2px;background:var(--line);flex-shrink:0;"></div>';
    html += '<div style="display:flex;flex-direction:column;align-items:center;flex-shrink:0;min-width:80px;">';
    html += '<div style="width:28px;height:28px;border-radius:50%;border:2px solid var(--brand-primary);display:flex;align-items:center;justify-content:center;font-size:0.65rem;font-weight:700;color:var(--brand-primary);background:var(--brand-bg-white);">' + (idx + 1) + '</div>';
    html += '<div style="font-size:0.65rem;color:var(--brand-text);margin-top:0.3rem;text-align:center;max-width:90px;">' + escHtml(step) + '</div>';
    html += '</div>';
  });
  html += '</div>';

  // Client list in this workflow
  if (clients.length > 0) {
    html += '<div class="eyebrow" style="margin-bottom:0.5rem;">Clients in Sequence</div>';
    html += '<div style="max-height:240px;overflow-y:auto;">';
    clients.forEach(function(c) {
      var statusColors = { active: 'var(--brand-primary)', waiting: 'var(--warning)', scheduled: 'var(--info)', completed: 'var(--success)', failed: 'var(--danger)' };
      var color = statusColors[c.status] || 'var(--text-light)';
      html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:0.4rem 0;border-bottom:1px solid var(--line);font-size:0.78rem;">';
      html += '<span style="font-weight:600;">' + escHtml(c.client) + '</span>';
      html += '<div style="display:flex;align-items:center;gap:0.5rem;">';
      html += '<span style="font-size:0.72rem;color:var(--text-light);">' + escHtml(c.currentStep) + '</span>';
      html += '<span style="color:' + color + ';font-weight:600;font-size:0.68rem;">' + escHtml(c.status.charAt(0).toUpperCase() + c.status.slice(1)) + '</span>';
      html += '</div></div>';
    });
    html += '</div>';
  } else {
    html += '<div style="font-size:0.78rem;color:var(--text-light);text-align:center;padding:1rem 0;">No clients currently in this workflow.</div>';
  }

  document.getElementById('wf-detail-body').innerHTML = html;
  document.getElementById('wf-detail-overlay').style.display = 'flex';
}

function showClientWfDetail(email) {
  if (!WF_DATA) return;
  var entries = WF_DATA.queue.filter(function(q) { return q.email === email; });
  if (!entries.length) return;

  var client = entries[0];
  var html = '<div style="margin-bottom:1rem;">';
  html += '<div style="font-family:Raleway,sans-serif;font-size:1rem;font-weight:300;color:var(--brand-dark);">' + escHtml(client.client) + '</div>';
  html += '<div style="font-size:0.72rem;color:var(--text-light);margin-top:0.2rem;">' + escHtml(client.email) + '</div>';
  html += '</div>';

  entries.forEach(function(entry) {
    // Find workflow steps
    var wf = null;
    WF_DATA.workflows.forEach(function(w) { if (w.id === entry.workflow) wf = w; });
    if (!wf) return;

    html += '<div class="eyebrow" style="margin:0.75rem 0 0.5rem;">' + escHtml(wf.name) + '</div>';

    // Step sequence with progress
    var currentIdx = -1;
    wf.steps.forEach(function(s, i) { if (s === entry.currentStep) currentIdx = i; });

    html += '<div style="display:flex;align-items:center;gap:0;margin-bottom:0.75rem;overflow-x:auto;padding:0.25rem 0;">';
    wf.steps.forEach(function(step, idx) {
      if (idx > 0) {
        var lineColor = idx <= currentIdx ? 'var(--success)' : 'var(--line)';
        html += '<div style="width:20px;height:2px;background:' + lineColor + ';flex-shrink:0;"></div>';
      }
      var isCompleted = idx < currentIdx;
      var isCurrent = idx === currentIdx;
      var bg, border, textColor, label;
      if (isCompleted) { bg = 'var(--success)'; border = 'var(--success)'; textColor = '#fff'; label = '\u2713'; }
      else if (isCurrent) { bg = entry.status === 'failed' ? 'var(--danger)' : 'var(--brand-primary)'; border = bg; textColor = '#fff'; label = entry.status === 'failed' ? '\u2717' : '\u25CF'; }
      else { bg = 'var(--brand-bg-white)'; border = 'var(--line)'; textColor = 'var(--text-light)'; label = (idx + 1); }

      html += '<div style="display:flex;flex-direction:column;align-items:center;flex-shrink:0;min-width:68px;">';
      html += '<div style="width:24px;height:24px;border-radius:50%;border:2px solid ' + border + ';background:' + bg + ';display:flex;align-items:center;justify-content:center;font-size:0.6rem;font-weight:700;color:' + textColor + ';">' + label + '</div>';
      html += '<div style="font-size:0.6rem;color:' + (isCurrent ? 'var(--brand-dark)' : 'var(--text-light)') + ';margin-top:0.2rem;text-align:center;max-width:80px;' + (isCurrent ? 'font-weight:600;' : '') + '">' + escHtml(step) + '</div>';
      html += '</div>';
    });
    html += '</div>';

    if (entry.daysInfo) html += '<div style="font-size:0.7rem;color:var(--text-light);">' + escHtml(entry.daysInfo) + '</div>';
    if (entry.scheduledDate) html += '<div style="font-size:0.7rem;color:var(--text-light);">Date: ' + escHtml(entry.scheduledDate) + '</div>';
  });

  document.getElementById('wf-detail-body').innerHTML = html;
  document.getElementById('wf-detail-overlay').style.display = 'flex';
}

function closeWfDetail(e) {
  if (e && e.target !== document.getElementById('wf-detail-overlay')) return;
  document.getElementById('wf-detail-overlay').style.display = 'none';
}

/* ---------- Safe Mode Banner ---------- */
function renderWfSafeMode(safeMode) {
  var slot = document.getElementById('wf-safe-mode-slot');
  if (safeMode) {
    slot.innerHTML = '<div class="safe-mode-banner" style="margin-bottom:1rem;"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> ' +
      'Safe Mode is ON — automations will not fire external actions. ' +
      '<button class="btn btn-ghost" style="margin-left:0.5rem;padding:0.25rem 0.5rem;font-size:0.72rem;" onclick="toggleSafeMode(false)">Disable</button></div>';
    STATE.safeModeActive = true;
  } else {
    slot.innerHTML = '';
  }
}

function toggleAutomation(id, enabled) {
  // TODO: Bridge route needed for: adminApi_toggleAutomation
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_toggleAutomation', args: { token: STATE.token, id: id, enabled: enabled } })
    .then(function(res) { if (res.ok) { var _h = function(res){ if (!res.success) alert('Failed to toggle automation.'); }; _h(res.data); } else { var _e = function(err){ alert('Error: ' + (err.message || String(err))); }; _e(res.error); } })
    .catch(function(err){ alert('Error: ' + (err.message || String(err))); });
}

function toggleSafeMode(enabled) {
  // TODO: Bridge route needed for: adminApi_setSafeMode
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_setSafeMode', args: { token: STATE.token, enabled: enabled } })
    .then(function(res) { if (res.ok) { var _h = function(res){ STATE.safeModeActive = res.safeMode; loadAutomationsView(); }; _h(res.data); } else { var _e = function(err){ alert('Error: ' + (err.message || String(err))); }; _e(res.error); } })
    .catch(function(err){ alert('Error: ' + (err.message || String(err))); });
}

/* ============================================================
   SETTINGS VIEW
   ============================================================ */
function loadSettingsView() {
  showLoader('settings');
  // TODO: Bridge route needed for: adminApi_getSettings
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getSettings', args: { token: STATE.token } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      var el = document.getElementById('settings-data');
      if (!data) { el.innerHTML = '<div class="alert info">Settings unavailable.</div>'; showContent('settings'); return; }
      var html = '<div class="card-panel">';
      Object.keys(data).forEach(function(k) {
        if (typeof data[k] === 'object') return;
        html += '<div class="info-row"><span class="info-label">' + escHtml(k) + '</span><span class="info-value">' + escHtml(String(data[k])) + '</span></div>';
      });
      html += '</div>';
      el.innerHTML = html;
      showContent('settings');
    }; _h(res.data); } else { var _e = function(err){ showError('settings', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('settings', err.message || String(err)); });
}

/* ============================================================
   AUDIT LOG VIEW
   ============================================================ */
// Shared render, used by both the island paint and the live response. The
// GAS handler returns { success, data: { entries, summary } }; the bridge
// wraps a live call to { ok, data: <above> }, so callers unwrap once before
// calling this with the inner { entries, summary } shape.
function _renderAuditLogEntries_(data) {
  var list = document.getElementById('audit-log-list');
  if (!data || !data.entries || data.entries.length === 0) {
    list.innerHTML = '<div class="empty-state"><p>No audit log entries found.</p></div>';
  } else {
    var OUTCOME_LABELS = { error: 'Error', warn: 'Warning', warning: 'Warning', ok: 'OK', info: 'Info' };
    var html = '';
    data.entries.forEach(function(e) {
      var outcome = (e.outcome || e.type || 'info').toLowerCase();
      var badgeClass = outcome === 'error' ? 'danger' : (outcome === 'warn' || outcome === 'warning' ? 'warn' : 'ok');
      var msg = e.action || e.message || '';
      if (e.detail || e.summary) msg += (msg ? ': ' : '') + (e.detail || e.summary);
      var ts = e.timestamp ? e.timestamp.replace('T', ' ').replace(/\.\d+Z$/, ' UTC') : '';
      html += '<div class="audit-row">';
      html += '<span class="audit-ts">' + escHtml(ts) + '</span>';
      html += '<span class="audit-type-badge audit-badge-' + badgeClass + '">' + escHtml(e.module || OUTCOME_LABELS[outcome] || outcome) + '</span>';
      html += '<span class="audit-msg">' + escHtml(msg) + '</span>';
      html += '</div>';
    });
    list.innerHTML = html;
    var total = (data.summary && data.summary.total) || data.entries.length;
    renderAuditPagination(total, 50, STATE.auditOffset);
  }
  showContent('audit-log');
}

// Admin-audit CF read (2026-10-07). Dark until the shadow parity probe
// clears for 7 consecutive days AND the metafield is flipped. Metafield-
// driven per the standing convention (established 2026-10-07 after the
// admin-clients bridge drift fix): the const resolves at module load from
// window.ADMIN_AUDIT_D1_READ_FLAG_ which is set by the Liquid assign +
// <script> inserted near the top of sections/jv-admin-crm.liquid. Jess
// flips shop.metafields.custom.admin_audit_d1_read -> next page load
// activates CF with zero code deploy. Transport matches every other
// /partner/<entity>/<action> relay call in this file -- native fetch
// escape, Content-Type: text/plain, same App-Proxy identity chain and
// jv-admin tag re-check as bbs-recon / admin-clients / admin-stale-deals.
// The CF path falls through to the existing GAS route silently on empty /
// error / unexpected shape -- three-tier stack: CDN island (Tier 0,
// unchanged) -> CF (Tier 1, new) -> GAS (Tier 2 fallback).
var ADMIN_AUDIT_D1_READ_ENABLED_ = (typeof window !== 'undefined' && window.ADMIN_AUDIT_D1_READ_FLAG_ === true);

function _tryAuditLogCf_(limit, offset) {
  var base = window._jvAdminProxyBase;
  if (!ADMIN_AUDIT_D1_READ_ENABLED_ || !base) return Promise.resolve(null);
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-audit/read';
  var body = {};
  if (Number.isFinite(limit)) body.limit = limit;
  if (Number.isFinite(offset)) body.offset = offset;
  return nf(url, {
    method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body)
  }).then(function(r) { return r.json(); }).then(function(b) {
    if (!b || b.success !== true || !b.data || !Array.isArray(b.data.entries)) return null;
    return b.data;
  }).catch(function() { return null; });
}

// Live fetch: runs as the primary load for any non-default call (a real
// offset, a real type filter), and as the background-refresh after a
// default-view island paint. painted=true suppresses the error UI and
// skips the loader.
//
// CF wire-up (2026-10-07, admin-audit CF slice): try D1 Worker first when
// ADMIN_AUDIT_D1_READ_ENABLED_ is true; fall through to the existing
// jvBridge.callAdmin -> adminApi_getAuditLog route on null (empty / error /
// unexpected shape). The island-first path above is unchanged; this only
// affects what happens after the island (or when the user clicks a non-
// default view/pagination).
function _auditLogLiveLoad_(typeFilter, painted) {
  if (!painted) showLoader('audit-log');

  var cfLimit = 50;
  var cfOffset = (STATE && Number.isFinite(STATE.auditOffset)) ? STATE.auditOffset : 0;
  var cfTried = false;

  function fallbackGas_() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getAuditLog', args: { token: STATE.token, limit: 50, offset: STATE.auditOffset, type: typeFilter } })
      .then(function(res) {
        if (res.ok) {
          var data = res.data;
          if (data && data.data && Array.isArray(data.data.entries)) data = data.data;
          _renderAuditLogEntries_(data);
        } else if (!painted) {
          showError('audit-log', (res.error && res.error.message) || String(res.error || 'Failed to load'));
        }
      })
      .catch(function(err) { if (!painted) showError('audit-log', err.message || String(err)); });
  }

  if (ADMIN_AUDIT_D1_READ_ENABLED_) {
    cfTried = true;
    _tryAuditLogCf_(cfLimit, cfOffset).then(function(cf) {
      if (cf) { _renderAuditLogEntries_(cf); return; }
      try { console.info('[admin-audit] CF path returned empty/error, falling back to GAS.'); } catch (e) {}
      fallbackGas_();
    });
    return;
  }
  fallbackGas_();
}

// Fast path: paint from the CDN island first (zero GAS), then background-
// refresh - but ONLY for the exact default view (offset 0, no type filter)
// the island was built from. adminApi_getAuditLog does not actually read
// its offset/type/limit params (every call currently returns the same
// last-7-days set regardless), so the island is safe to use for the
// default call today, but any real offset or type-filter selection is
// routed straight to live so a future fix to that filtering can never be
// silently masked by a stale cached default. Island written by
// AdminAuditLogCache.gs -> custom.admin_audit_log_cache_json, shape
// { success, data:{entries, summary} }. Falls straight to live when the
// island is absent.
function loadAuditLogView(offset) {
  STATE.auditOffset = offset || 0;
  var typeFilter = document.getElementById('audit-type-filter') ? document.getElementById('audit-type-filter').value : '';
  var isDefaultView = (STATE.auditOffset === 0) && !typeFilter;
  if (!isDefaultView) { _auditLogLiveLoad_(typeFilter, false); return; }
  adminCacheParseIsland_('jv-admin-audit-log-cache', function(cached) {
    var data = cached && cached.data;
    if (data && data.entries) {
      _renderAuditLogEntries_(data);       // instant paint
      _auditLogLiveLoad_(typeFilter, true); // background-refresh
    } else {
      _auditLogLiveLoad_(typeFilter, false); // no island -> live is the primary load
    }
  });
}

function renderAuditPagination(total, limit, offset) {
  var el = document.getElementById('audit-pagination');
  if (!total || total <= limit) { el.innerHTML = ''; return; }
  var pages = Math.ceil(total / limit);
  var current = Math.floor(offset / limit);
  var html = '';
  for (var i = 0; i < Math.min(pages, 10); i++) {
    var isActive = i === current;
    html += '<button class="btn ' + (isActive ? 'btn-primary' : 'btn-ghost') + '" style="padding:0.35rem 0.6rem;min-width:32px;" onclick="loadAuditLogView(' + (i * limit) + ')">' + (i+1) + '</button>';
  }
  el.innerHTML = html;
}

/* ============================================================
   SHOPIFY SYNC VIEW
   ============================================================ */
function loadShopifySyncView() {
  showLoader('shopify-sync');
  // TODO: Bridge route needed for: adminApi_getShopifySyncStatus
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getShopifySyncStatus', args: { token: STATE.token } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      var el = document.getElementById('shopify-sync-data');
      if (!data) { el.innerHTML = '<div class="alert info">No sync data available.</div>'; showContent('shopify-sync'); return; }
      var html = '<div class="card-panel">';
      if (data.lastSync) html += '<div class="info-row"><span class="info-label">Last Sync</span><span class="info-value">' + escHtml(String(data.lastSync)) + '</span></div>';
      if (data.status)   html += '<div class="info-row"><span class="info-label">Status</span><span class="info-value">' + escHtml(String(data.status)) + '</span></div>';
      if (data.errors && data.errors.length) {
        html += '<div class="alert danger" style="margin-top:0.75rem;">' + data.errors.map(function(e){ return escHtml(e); }).join('<br>') + '</div>';
      }
      html += '</div>';
      el.innerHTML = html;
      showContent('shopify-sync');
    }; _h(res.data); } else { var _e = function(err){ showError('shopify-sync', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('shopify-sync', err.message || String(err)); });
}

function triggerShopifySync() {
  if (!confirm('Trigger a Shopify sync now?')) return;
  // TODO: Bridge route needed for: adminApi_triggerShopifySync
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_triggerShopifySync', args: { token: STATE.token, scope: 'full' } })
    .then(function(res) { if (res.ok) { var _h = function(res){ alert(res && res.message ? res.message : 'Sync triggered.'); loadShopifySyncView(); }; _h(res.data); } else { var _e = function(err){ alert('Error: ' + (err.message || String(err))); }; _e(res.error); } })
    .catch(function(err){ alert('Error: ' + (err.message || String(err))); });
}

/* ============================================================
   MOXIE MIGRATION VIEW
   ============================================================ */
function loadMoxieMigrationView() {
  showLoader('moxie-migration');
  // TODO: Bridge route needed for: adminApi_getMoxieMigrationStatus
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getMoxieMigrationStatus', args: { token: STATE.token } })
    .then(function(res) { if (res.ok) { var _h = function(data) {
      var el = document.getElementById('moxie-migration-data');
      if (!data) { el.innerHTML = '<p style="font-size:0.82rem;color:var(--text-light);">No migration data.</p>'; showContent('moxie-migration'); return; }
      var html = '';
      Object.keys(data).forEach(function(k) {
        html += '<div class="info-row"><span class="info-label">' + escHtml(k) + '</span><span class="info-value">' + escHtml(String(data[k])) + '</span></div>';
      });
      el.innerHTML = html || '<p style="font-size:0.82rem;color:var(--text-light);">No migration data.</p>';
      showContent('moxie-migration');
    }; _h(res.data); } else { var _e = function(err){ showError('moxie-migration', err.message || String(err)); }; _e(res.error); } })
    .catch(function(err){ showError('moxie-migration', err.message || String(err)); });
}

/* ============================================================
   XERO REPAIR
   ============================================================ */
function runXeroRepair(action) {
  // TODO: Bridge route needed for: adminApi_callRepairRoute
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_callRepairRoute', args: { token: STATE.token, action: action } })
    .then(function(res) { if (res.ok) { var _h = function(res){ alert(res && res.ok ? 'Success: ' + JSON.stringify(res) : 'Error: ' + (res && res.error ? res.error : 'Unknown')); }; _h(res.data); } else { var _e = function(err){ alert('Error: ' + (err.message || String(err))); }; _e(res.error); } })
    .catch(function(err){ alert('Error: ' + (err.message || String(err))); });
}

/* ============================================================
   NOTIFICATIONS VIEW
   ============================================================ */
var _notificationsData = null;

function loadNotificationsView() {
  _notificationsData = null;

  // Paints a notifications payload ({notifications, counts}) into the view + bell.
  function _paintNotifications_(data) {
    _notificationsData = data;
    _bellNotifications = (data && data.notifications) || [];
    renderNotifications(data);
    showContent('notifications');
    var total = data && data.counts ? (data.counts.high + data.counts.medium + data.counts.low) : 0;
    var bellBadge = document.getElementById('bell-badge');
    if (bellBadge) bellBadge.textContent = total > 0 ? total : '';
    renderBellDropdown();
  }

  // Live fetch: notifications + proposed-closes in parallel. Runs as the primary
  // load when there's no island, and as the background-refresh after an island paint.
  // painted=true suppresses the error UI (the island already gave the user content).
  function _liveLoad_(painted) {
    var notifPromise  = jvBridge.callAdmin('bridge_admin_getNotifications', {});
    var closesPromise = jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getProposedCloses', args: {} });
    Promise.all([notifPromise, closesPromise])
      .then(function(results) {
        var res = results[0];
        var closesRes = results[1];
        if (res.ok) {
          _paintNotifications_(res.data);
        } else if (!painted) {
          showError('notifications', (res.error && res.error.message) || String(res.error || 'Failed to load notifications'));
          return;
        }
        // Render proposed closes (non-fatal if it fails)
        if (closesRes && closesRes.ok && closesRes.data) {
          renderProposedCloses(closesRes.data);
        } else {
          renderProposedCloses({ count: 0, items: [] });
        }
      })
      .catch(function(err) { if (!painted) showError('notifications', err.message || String(err)); });
  }

  // ── Fast path: paint from the CDN island first (zero GAS), then background-refresh ──
  // Island written by AdminNotificationsCache.gs -> custom.admin_notifications_cache_json,
  // shape { success, data:{notifications, counts} }. Fixes the standalone-getNotifications
  // cold-start timeout (Admin CRM's #1 real-user error). Live call below repaints + fetches
  // proposed-closes (which is not in the island). Falls straight to live when the island is absent.
  adminCacheParseIsland_('jv-admin-notifications-cache', function(cached) {
    var data = cached && (cached.data || (cached.notifications ? cached : null));
    if (data && data.notifications) {
      _paintNotifications_(data);   // instant paint
      _liveLoad_(true);             // background-refresh (also loads proposed-closes)
    } else {
      showLoader('notifications');  // no island -> live is the primary load
      _liveLoad_(false);
    }
  });
}

function renderProposedCloses(data) {
  var section = document.getElementById('proposed-closes-section');
  if (!section) return;
  var items = (data && data.items) || [];
  if (items.length === 0) { section.innerHTML = ''; return; }

  var html = '<div class="notif-group-label" style="margin-bottom:0.5rem;">' +
    'Proposed Closes' +
    '<span class="notif-badge" style="background:var(--brand-primary);color:#fff;border-radius:2rem;padding:0.1em 0.55em;font-size:0.65rem;font-weight:700;margin-left:0.4rem;">' +
    items.length + '</span>' +
    '</div>';

  items.forEach(function(item) {
    var pct = Math.round((item.confidence || 0) * 100);
    var reasonLabel = escHtml(item.closeReason || 'Declined');
    var channelLabel = escHtml(item.channel || '');
    var snippet = item.snippet ? escHtml(item.snippet) : '';
    var reasoning = item.reasoning ? escHtml(item.reasoning) : '';
    var rowNum = item.rowNum;
    var clientId = item.clientId || '';

    html += '<div class="notif-item proposed-close-item" id="pc-item-' + escAttr(String(rowNum)) + '" style="border-left:3px solid var(--brand-primary);margin-bottom:0.5rem;">' +
      '<div class="notif-icon" style="background:rgba(201,149,145,0.12);color:var(--brand-primary);">' +
        '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:2;"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</div>' +
      '<div class="notif-body">' +
        '<div class="notif-title">' + escHtml(item.brideName || item.brideEmail || '') + '</div>' +
        '<div class="notif-detail" style="margin-bottom:0.25rem;">' +
          reasonLabel + (channelLabel ? ' &middot; via ' + channelLabel : '') + ' &middot; ' + pct + '% confidence' +
        '</div>' +
        (snippet ? '<div class="notif-detail" style="font-style:italic;margin-bottom:0.2rem;">"' + snippet + '"</div>' : '') +
        (reasoning ? '<div class="notif-detail" style="font-size:0.72rem;color:var(--text-light);">' + reasoning + '</div>' : '') +
        '<div class="notif-actions" style="margin-top:0.6rem;">' +
          '<button class="btn-primary" style="font-size:0.72rem;padding:0.4rem 1.1rem;letter-spacing:0.04em;" ' +
            'onclick="confirmProposedClose(' + rowNum + ',\'' + escAttr(String(clientId)) + '\')">Close lead</button>' +
          '<button class="btn-ghost" style="font-size:0.72rem;padding:0.4rem 1.1rem;letter-spacing:0.04em;" ' +
            'onclick="dismissProposedClose(' + rowNum + ')">Keep open</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  });

  html += '<div style="height:0.75rem;"></div>';
  section.innerHTML = html;
}

function confirmProposedClose(rowNum, clientId) {
  var btn = event && event.target;
  if (btn) btn.disabled = true;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_confirmProposedClose', args: { rowNum: rowNum } })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) {
        jvToast(res.data.message || 'Lead closed', 'success');
        // Remove proposed-close card
        var card = document.getElementById('pc-item-' + rowNum);
        if (card) { card.style.opacity = '0'; card.style.transition = 'opacity 0.3s'; setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); }, 320); }
        // Also remove from kanban if visible
        if (clientId) {
          var kcard = document.getElementById('kcard-' + clientId);
          if (kcard) {
            kcard.style.opacity = '0'; kcard.style.transition = 'opacity 0.35s';
            setTimeout(function() { if (kcard.parentNode) kcard.parentNode.removeChild(kcard); updateColCounts(); }, 350);
          }
        }
      } else {
        jvToast((res.data && res.data.message) || (res.error && res.error.message) || 'Failed to close lead', 'error');
        if (btn) btn.disabled = false;
      }
    })
    .catch(function(err) { jvToast(err.message || String(err), 'error'); if (btn) btn.disabled = false; });
}

function dismissProposedClose(rowNum) {
  var btn = event && event.target;
  if (btn) btn.disabled = true;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_dismissProposedClose', args: { rowNum: rowNum } })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) {
        jvToast('Kept open', 'success');
        var card = document.getElementById('pc-item-' + rowNum);
        if (card) { card.style.opacity = '0'; card.style.transition = 'opacity 0.3s'; setTimeout(function() { if (card.parentNode) card.parentNode.removeChild(card); }, 320); }
      } else {
        jvToast((res.data && res.data.message) || (res.error && res.error.message) || 'Failed to dismiss', 'error');
        if (btn) btn.disabled = false;
      }
    })
    .catch(function(err) { jvToast(err.message || String(err), 'error'); if (btn) btn.disabled = false; });
}

/* ============================================================
   ADD-ON APPROVALS QUEUE (post-booking "Add to my booking")
   Backend: BookingAddonsAPI.gs via bridge_admin_generic.
   ============================================================ */

// Live fetch: runs as the primary load when there's no island, and as the
// background-refresh after an island paint. painted=true suppresses the
// error UI (the island already gave the user content) and skips the loader.
function _addOnsQueueLiveLoad_(painted) {
  if (!painted) showLoader('addons-queue');
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_getPendingAddons', args: {} })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        renderAddOnsQueue(data.addons || []);
        showContent('addons-queue');
      } else if (!painted) {
        showError('addons-queue', (data && data.error) || (res && res.error && res.error.message) || 'Could not load add-on requests');
      }
    })
    .catch(function(err) { if (!painted) showError('addons-queue', err && err.message || String(err)); });
}

// Fast path: paint from the CDN island first (zero GAS), then background-
// refresh. Island written by AdminAddonsQueueCache.gs -> custom.
// admin_addons_queue_cache_json, shape { success, data:{addons} }. This is a
// worklist (approve/decline) so the live refresh always follows the island
// paint immediately rather than skipping it, matching the Notifications
// pattern: the island is for perceived speed, never for the action's data
// source. Falls straight to live when the island is absent.
function loadAddOnsQueueView() {
  adminCacheParseIsland_('jv-admin-addons-queue-cache', function(cached) {
    var data = cached && cached.data;
    if (data && data.addons) {
      renderAddOnsQueue(data.addons || []);
      showContent('addons-queue');   // instant paint
      _addOnsQueueLiveLoad_(true);   // background-refresh
    } else {
      _addOnsQueueLiveLoad_(false);  // no island -> live is the primary load
    }
  });
}

function addOn_fmtMoney_(cents) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }

function addOn_typeLabel_(t) {
  var map = { extra_person: 'Extra person', extra_service: 'Extra service', upgrade: 'Upgrade', standalone: 'Add-on' };
  return map[t] || t || 'Add-on';
}

function renderAddOnsQueue(addons) {
  var wrap = document.getElementById('addons-queue-content');
  if (!wrap) return;
  if (!addons.length) {
    wrap.innerHTML = '<div class="empty-state"><div class="empty-icon"></div>' +
      '<p>No add-on requests waiting. When a bride requests an add-on from her hub, it will appear here for you to approve.</p></div>';
    return;
  }
  var html = '<div class="card-panel" style="padding:1rem 1.1rem;">' +
    '<div style="display:flex;align-items:center;gap:0.5rem;margin-bottom:0.9rem;">' +
    '<strong style="font-size:1.05rem;">Pending add-on requests</strong>' +
    '<span class="notif-badge">' + addons.length + '</span></div>';

  addons.forEach(function(a) {
    var id = escAttr(String(a.addonId || ''));
    var lines = Array.isArray(a.lines) ? a.lines : [];
    var lineHtml = lines.map(function(l) {
      return '<div style="display:flex;justify-content:space-between;gap:1rem;font-size:0.9rem;color:var(--brand-text);">' +
        '<span>' + escHtml(l.label || '') + (l.qty > 1 ? ' &times;' + l.qty : '') + '</span>' +
        '<span>' + addOn_fmtMoney_(l.totalCents) + '</span></div>';
    }).join('');
    var who = a.personName ? (escHtml(a.personName) + (a.personRole ? ' (' + escHtml(a.personRole) + ')' : '')) : '';
    var isInvoiced = (a.status === 'invoiced');
    var actions;
    if (isInvoiced) {
      actions = '<span class="stage-badge" style="background:rgba(232,160,48,0.14);color:#9b6a1e;">Awaiting payment</span>' +
        (a.paymentUrl ? '<a href="' + escHtml(a.paymentUrl) + '" target="_blank" class="action-link" style="font-size:0.82rem;">Open pay link &#8599;</a>' : '') +
        '<button class="btn-ghost" style="padding:0.4rem 0.9rem;font-size:0.85rem;" onclick="cancelAddOn(\'' + id + '\')">Cancel</button>';
    } else {
      actions = '<button class="btn-primary" style="padding:0.4rem 0.9rem;font-size:0.85rem;" onclick="approveAddOn(\'' + id + '\')">Approve &amp; invoice</button>' +
        '<button class="btn-ghost" style="padding:0.4rem 0.9rem;font-size:0.85rem;" onclick="declineAddOn(\'' + id + '\')">Decline</button>';
    }
    html += '<div class="notif-item" id="addon-item-' + id + '" style="margin-bottom:0.7rem;">' +
      '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:1rem;flex-wrap:wrap;">' +
        '<div>' +
          '<div style="font-weight:600;">' + escHtml(a.brideName || a.brideEmail || '') + '</div>' +
          '<div style="font-size:0.82rem;color:var(--brand-text-soft,#7e706c);">' + escHtml(a.weddingDate || '') + '</div>' +
        '</div>' +
        '<span class="stage-badge">' + escHtml(addOn_typeLabel_(a.type)) + '</span>' +
      '</div>' +
      (who ? '<div style="font-size:0.9rem;margin-top:0.35rem;">' + who + '</div>' : '') +
      '<div style="margin-top:0.5rem;border-top:1px solid var(--border,#e6dad4);padding-top:0.5rem;">' + lineHtml +
        '<div style="display:flex;justify-content:space-between;gap:1rem;font-weight:700;margin-top:0.35rem;">' +
          '<span>Total</span><span>' + addOn_fmtMoney_(a.priceCents) + '</span></div>' +
      '</div>' +
      '<div class="notif-actions" style="margin-top:0.7rem;display:flex;gap:0.5rem;align-items:center;flex-wrap:wrap;">' +
        actions +
      '</div>' +
    '</div>';
  });
  html += '</div>';
  wrap.innerHTML = html;
}

function approveAddOn(addonId) {
  var btn = event && event.target;
  if (!confirm('Approve this add-on? This raises a Xero invoice and emails the bride a payment link.')) return;
  if (btn) btn.disabled = true;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_approveAddon', args: { addonId: addonId } })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        jvToast('Approved. Invoice sent to bride', 'success');
        addOn_removeCard_(addonId);
      } else {
        jvToast((data && data.error) || 'Could not approve add-on', 'error');
        if (btn) btn.disabled = false;
      }
    })
    .catch(function(err) { jvToast(err && err.message || String(err), 'error'); if (btn) btn.disabled = false; });
}

function declineAddOn(addonId) {
  var btn = event && event.target;
  var note = prompt('Decline this add-on? Optional note for your records:');
  if (note === null) return; // cancelled
  if (btn) btn.disabled = true;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_declineAddon', args: { addonId: addonId, note: note } })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        jvToast('Add-on declined', 'success');
        addOn_removeCard_(addonId);
      } else {
        jvToast((data && data.error) || 'Could not decline add-on', 'error');
        if (btn) btn.disabled = false;
      }
    })
    .catch(function(err) { jvToast(err && err.message || String(err), 'error'); if (btn) btn.disabled = false; });
}

function cancelAddOn(addonId) {
  var btn = event && event.target;
  if (!confirm('Cancel this add-on? This voids the Xero invoice so the bride can no longer pay it.')) return;
  if (btn) btn.disabled = true;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_cancelAddon', args: { addonId: addonId } })
    .then(function(res) {
      var data = (res && res.ok && res.data) ? res.data : null;
      if (data && data.ok) {
        jvToast('Add-on cancelled, invoice voided', 'success');
        addOn_removeCard_(addonId);
      } else {
        jvToast((data && data.error) || 'Could not cancel add-on', 'error');
        if (btn) btn.disabled = false;
      }
    })
    .catch(function(err) { jvToast(err && err.message || String(err), 'error'); if (btn) btn.disabled = false; });
}

function addOn_removeCard_(addonId) {
  var card = document.getElementById('addon-item-' + addonId);
  if (card) {
    card.style.opacity = '0'; card.style.transition = 'opacity 0.3s';
    setTimeout(function() {
      if (card.parentNode) card.parentNode.removeChild(card);
      // If the queue is now empty, re-render the empty state.
      var remaining = document.querySelectorAll('#addons-queue-content .notif-item[id^="addon-item-"]');
      if (!remaining.length) renderAddOnsQueue([]);
    }, 320);
  }
}

function renderNotifications(data) {
  var items = (data && data.notifications) || [];
  var counts = (data && data.counts) || { high: 0, medium: 0, low: 0 };

  var summary = document.getElementById('notif-summary');
  if (summary) {
    summary.textContent = counts.high + ' high · ' + counts.medium + ' medium · ' + counts.low + ' low';
  }

  ['high','medium','low'].forEach(function(sev) {
    var container = document.getElementById('notifications-' + sev);
    if (!container) return;
    var sevItems = items.filter(function(n){ return n.severity === sev; });
    if (sevItems.length === 0) { container.innerHTML = ''; return; }

    var label = sev === 'high' ? 'High Priority' : sev === 'medium' ? 'Medium' : 'Low Priority';
    var html = '<div class="notif-group-label">' + label + ' <span class="notif-badge" style="background:' +
      (sev==='high' ? 'var(--danger)' : sev==='medium' ? '#e8a030' : 'var(--info)') + '">' +
      sevItems.length + '</span></div>';
    sevItems.forEach(function(n) {
      html += renderNotifItem(n);
    });
    container.innerHTML = html;
  });
}

function renderNotifItem(n) {
  var iconSvg = {
    runsheet: '<svg viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
    trial:    '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    payment:  '<svg viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>',
    action:   '<svg viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>'
  }[n.type] || '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  var RUNSHEET_TASK_CODES_FE = { BUILD_RUNSHEET:1, REVIEW_RUNSHEET:1, PUBLISH_RUNSHEET:1, CONFIRM_RUNSHEET:1 };
  var actions = '';
  if (n.clientId) {
    if (n.type === 'task') {
      if (RUNSHEET_TASK_CODES_FE[n.taskCode]) {
        actions += '<button class="notif-action-btn" onclick="openRunsheet(\'' + escAttr(n.clientId) + '\')">Open Runsheet</button>';
      } else if (n.taskCode === 'REVIEW_PROPOSAL') {
        actions += '<button class="notif-action-btn" onclick="openDrawer(\'' + escAttr(n.clientId) + '\')">View Proposal</button>';
      } else {
        actions += '<button class="notif-action-btn" onclick="openDrawer(\'' + escAttr(n.clientId) + '\')">View Client</button>';
      }
    } else {
      actions += '<button class="notif-action-btn" onclick="openDrawer(\'' + escAttr(n.clientId) + '\')">View Client</button>';
      if (n.type === 'runsheet') actions += '<button class="notif-action-btn" onclick="openRunsheet(\'' + escAttr(n.clientId) + '\')">Open Runsheet</button>';
      if (n.type === 'trial') actions += '<button class="notif-action-btn" onclick="openDrawer(\'' + escAttr(n.clientId) + '\')">Book Trial</button>';
    }
  }

  return '<div class="notif-item ' + escHtml(n.severity) + '" data-type="' + escHtml(n.type) + '" data-severity="' + escHtml(n.severity) + '">' +
    '<div class="notif-icon ' + escHtml(n.severity) + '">' + iconSvg + '</div>' +
    '<div class="notif-body">' +
      '<div class="notif-title">' + escHtml(n.title) + '</div>' +
      (n.detail ? '<div class="notif-detail">' + escHtml(n.detail) + '</div>' : '') +
      (actions ? '<div class="notif-actions">' + actions + '</div>' : '') +
    '</div>' +
  '</div>';
}

function filterNotifications() {
  var sevF = document.getElementById('notif-sev-filter').value;
  var typeF = document.getElementById('notif-type-filter').value;
  document.querySelectorAll('.notif-item').forEach(function(el) {
    var sev = el.dataset.severity;
    var type = el.dataset.type;
    var show = (!sevF || sev === sevF) && (!typeF || type === typeF);
    el.style.display = show ? '' : 'none';
  });
  // Hide empty group headers
  ['high','medium','low'].forEach(function(s) {
    var grp = document.getElementById('notifications-' + s);
    if (!grp) return;
    var visible = grp.querySelectorAll('.notif-item:not([style*="none"])').length;
    grp.style.display = visible > 0 ? '' : 'none';
  });
}

/* ============================================================
   GREETING
   ============================================================ */
function setGreeting() {
  var h = new Date().getHours();
  var g = h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
  var el = document.getElementById('header-greeting');
  if (el) el.textContent = g + ', Jess.';
}

/* ============================================================
   NOTIFICATION BELL (HEADER)
   ============================================================ */
var _bellNotifications = [];
var _bellNotifInterval = null;

// Returns a promise resolving TRUE on a successful fetch, FALSE on any failure.
// Failures stay silent in the UI (this is background polling), but the poller needs
// the signal to back off instead of retrying at full cadence through a 504 storm.
// Callers that ignore the return value are unaffected.
function loadBellNotifications() {
  return jvBridge.callAdmin('bridge_admin_getNotifications', {})
    .then(function(res) { if (res.ok) { var _h = function(data) {
      if (!data || !data.notifications) return false;
      _bellNotifications = data.notifications || [];
      var counts = data.counts || { high: 0, medium: 0, low: 0 };
      var total = counts.high + counts.medium + counts.low;
      var badge = document.getElementById('bell-badge');
      if (badge) badge.textContent = total > 0 ? total : '';
      renderBellDropdown();
      return true;
    }; return _h(res.data); } else { var _e = function() { /* silent fail for polling */ return false; }; return _e(res.error); } })
    .catch(function() { /* silent fail for polling */ return false; });
}

function renderBellDropdown() {
  var list = document.getElementById('notif-dropdown-list');
  if (!list) return;
  if (_bellNotifications.length === 0) {
    list.innerHTML = '<div class="notif-dropdown-empty">No notifications</div>';
    return;
  }
  // Show up to 8 most recent
  var items = _bellNotifications.slice(0, 8);
  var html = '';
  items.forEach(function(n) {
    var dotClass = n.read ? 'read' : (n.severity || 'low');
    var unreadClass = n.read ? '' : ' unread';
    var RUNSHEET_TASK_CODES = { BUILD_RUNSHEET:1, REVIEW_RUNSHEET:1, PUBLISH_RUNSHEET:1, CONFIRM_RUNSHEET:1 };
    var clickAction;
    if (n.type === 'task' && n.clientId) {
      clickAction = RUNSHEET_TASK_CODES[n.taskCode]
        ? 'openRunsheet(\'' + escAttr(n.clientId) + '\'); closeNotifDropdown();'
        : 'openDrawer(\'' + escAttr(n.clientId) + '\'); closeNotifDropdown();';
    } else if (n.type === 'task') {
      clickAction = 'switchView(\'notifications\'); closeNotifDropdown();';
    } else {
      clickAction = n.clientId
        ? 'openDrawer(\'' + escAttr(n.clientId) + '\'); closeNotifDropdown();'
        : 'closeNotifDropdown();';
    }
    html += '<div class="notif-dropdown-item' + unreadClass + '" onclick="' + clickAction + '">' +
      '<div class="notif-dropdown-dot ' + escHtml(dotClass) + '"></div>' +
      '<div class="notif-dropdown-text">' +
        '<div class="notif-dropdown-title">' + escHtml(n.title || '') + '</div>' +
        '<div class="notif-dropdown-body">' + escHtml(n.detail || '') + '</div>' +
        (n.timeAgo ? '<div class="notif-dropdown-time">' + escHtml(n.timeAgo) + '</div>' : '') +
      '</div>' +
    '</div>';
  });
  list.innerHTML = html;
}

function toggleNotifDropdown(e) {
  e.stopPropagation();
  var dd = document.getElementById('notif-dropdown');
  if (!dd) return;
  var isOpen = dd.classList.contains('open');
  if (isOpen) {
    dd.classList.remove('open');
  } else {
    dd.classList.add('open');
    loadBellNotifications(); // refresh on open
  }
}

function closeNotifDropdown() {
  var dd = document.getElementById('notif-dropdown');
  if (dd) dd.classList.remove('open');
}

function markAllNotificationsRead(e) {
  e.stopPropagation();
  _bellNotifications.forEach(function(n) { n.read = true; });
  var badge = document.getElementById('bell-badge');
  if (badge) badge.textContent = '';
  renderBellDropdown();
}

function viewAllNotifications(e) {
  e.stopPropagation();
  closeNotifDropdown();
  switchView('notifications');
}

// Close dropdown when clicking outside
document.addEventListener('click', function(e) {
  var bell = document.getElementById('header-notif-bell');
  if (bell && !bell.contains(e.target)) {
    closeNotifDropdown();
  }
});

// Notification polling (2026-07-18 load-shed fix).
// PREVIOUS behaviour was a self-inflicted DoS: bridge_admin_getNotifications is a
// slow (~13-16s) GAS call, and every open admin-crm tab fired it every 60s FOREVER
// plus again on every tab-switch. With several tabs open (a normal workflow) that
// stacked dozens of slow doPosts on GAS, starving every other call. Fixes:
//   1. Only poll while the tab is VISIBLE (hidden tabs stop hitting GAS entirely).
//   2. Interval 60s -> 5min (notifications are not real-time-critical).
//   3. On tab-focus, refresh at most once per 2min (debounced), not every switch.
var _NOTIF_POLL_MS_ = 300000;      // 5 minutes
var _NOTIF_MIN_REFRESH_MS_ = 120000; // don't re-fetch on focus more than once / 2min
var _lastNotifFetchTs_ = 0;

//   4. Failure backoff (2026-08-09). Without it a 504 storm was retried at full
//      cadence, turning brief GAS strain into sustained load. On failure the delay
//      doubles 5 -> 10 -> 20min (capped); any success resets it to 5min.
var _NOTIF_POLL_MAX_MS_ = 1200000;  // 20 minutes
var _notifPollDelayMs_ = _NOTIF_POLL_MS_;

function _loadBellNotificationsTracked_() {
  _lastNotifFetchTs_ = Date.now();
  return Promise.resolve(loadBellNotifications())
    .then(function (ok) {
      _notifPollDelayMs_ = ok
        ? _NOTIF_POLL_MS_
        : Math.min(_notifPollDelayMs_ * 2, _NOTIF_POLL_MAX_MS_);
      return ok;
    })
    .catch(function () {
      _notifPollDelayMs_ = Math.min(_notifPollDelayMs_ * 2, _NOTIF_POLL_MAX_MS_);
      return false;
    });
}

// Self-rescheduling so the delay can vary (setInterval is fixed-rate). The handle
// stays on _bellNotifInterval so existing clear logic keeps working.
function _notifPollTick_() {
  // Skip the fetch when the tab is in the background; the visibilitychange
  // handler will refresh it (debounced) when the user returns. A skipped tick
  // must not count as a failure, so the delay is left untouched.
  if (document.hidden) { _scheduleNotifPoll_(); return; }
  _loadBellNotificationsTracked_().then(_scheduleNotifPoll_, _scheduleNotifPoll_);
}

function _scheduleNotifPoll_() {
  if (_bellNotifInterval) clearTimeout(_bellNotifInterval);
  _bellNotifInterval = setTimeout(_notifPollTick_, _notifPollDelayMs_);
}

// skipFirstPoll=true when notifications were already delivered via the initial payload.
function startNotifPolling(skipFirstPoll) {
  if (_bellNotifInterval) { clearTimeout(_bellNotifInterval); clearInterval(_bellNotifInterval); }
  _notifPollDelayMs_ = _NOTIF_POLL_MS_;
  if (!skipFirstPoll) _loadBellNotificationsTracked_();
  _scheduleNotifPoll_();
}

// Refresh on page focus, but debounced: switching between several open tabs must
// not fire a slow notifications call on every switch.
document.addEventListener('visibilitychange', function() {
  if (document.hidden) return;
  if (Date.now() - _lastNotifFetchTs_ < _NOTIF_MIN_REFRESH_MS_) return;
  _loadBellNotificationsTracked_();
});

/* ============================================================
   ESC KEY — close drawer
   ============================================================ */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeDrawer();
    if (typeof closePartnerDetailDrawer_ === 'function') closePartnerDetailDrawer_();
  }
});

/* ============================================================
   INIT — AuthBridge pattern
   ============================================================ */
(function init() {
  setGreeting();
  restoreIntelStrip();
  restorePublishIntegrityStrip();

  // Extract token from URL if present
  try {
    var urlParams = new URLSearchParams(window.location.search);
    var urlToken = urlParams.get('token');
    if (urlToken) STATE.token = urlToken;
  } catch(e) {}

  // Poll for jvBridge — the portal shell defines it via an inline script which runs
  // before this deferred script, but poll briefly in case of any render delay.
  var _pollAttempts = 0;
  var _maxPollMs = 3000;
  var _pollInterval = 100;

  function _checkBridgeAndStart() {
    var hasBridge = (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callAdmin === 'function');
    var inGAS = (typeof google !== 'undefined' && typeof google.script !== 'undefined') || hasBridge;

    if (!inGAS && _pollAttempts * _pollInterval < _maxPollMs) {
      _pollAttempts++;
      setTimeout(_checkBridgeAndStart, _pollInterval);
      return;
    }

    if (!inGAS) {
      // Demo mode — no bridge and no GAS runtime after timeout
      var banner = document.getElementById('demo-banner');
      if (banner) { banner.style.display = 'block'; document.body.classList.add('has-banner'); }
      var appRoot = document.getElementById('app-root');
      if (appRoot) appRoot.classList.add('ready');
      hideLoader();
      // Respect the URL hash view even in demo mode (bridge did not connect in time, e.g.
      // GAS 504 saturation). A Book-Trial deep link (#internal-booking) must NOT get bounced
      // to the pipeline board; show whatever valid view the hash asked for.
      var _demoHash_ = '';
      try { _demoHash_ = location.hash ? location.hash.substring(1) : ''; } catch (e) {}
      var _demoHashRecognised_ = !!(_demoHash_ && VIEW_META[_demoHash_]);
      // 2026-08-16: same fix as the main boot path below (skipHash), so demo mode
      // does not push "#pipeline" into a clean /pages/admin-crm URL either.
      switchView(_demoHashRecognised_ ? _demoHash_ : 'pipeline', !_demoHashRecognised_);
      var pipelineLoader = document.getElementById('pipeline-loader');
      if (pipelineLoader) pipelineLoader.style.display = 'none';
      var board = document.getElementById('kanban-board');
      if (board) { board.style.display = 'flex'; board.innerHTML = '<div class="card-panel" style="padding:2rem;text-align:center;color:var(--text-light);flex:1;">Demo mode — connect to Google Apps Script to load live data.</div>'; }
      return;
    }

    _startWithBridge();
  }

  function _startWithBridge() {

  // Hide demo banner when bridge is connected
  var demoBanner = document.getElementById('demo-banner');
  if (demoBanner) demoBanner.style.display = 'none';

  // Determine initial view from URL hash (default: pipeline)
  var _initialView = 'pipeline';
  // 2026-08-16: true only when the URL genuinely arrived WITHOUT a recognised
  // hash (plain /pages/admin-crm, or an unrecognised/garbage hash). Every
  // switchView(_initialView) boot-path call below passes this as skipHash so
  // a fresh visit does not have "#pipeline" silently pushed into the address
  // bar and browser history. Previously EVERY boot call omitted skipHash, so
  // switchView's own history.pushState (line ~577) ran unconditionally on
  // every load, permanently rewriting a clean /pages/admin-crm into
  // /pages/admin-crm#pipeline the instant the page finished booting. The
  // 2026-08-11 and 2026-08-13 fixes near these same call sites (search
  // "_stillOnBootView_") stopped the admin's CONTENT snapping back to
  // Pipeline after a fast navigation; they never addressed the URL bar
  // itself being rewritten, which is what this fixes. When the hash WAS
  // present and recognised, skipHash stays false so switchView still
  // records that real navigation in history as before, unaffected.
  var _initialViewHadNoRealHash_ = true;
  try {
    var _hash = location.hash ? location.hash.substring(1) : '';
    // 2026-08-06: strip a deep-link query (e.g. #clients?type=partner) before
    // matching the view name, otherwise the whole string is looked up in
    // VIEW_META, misses, and silently falls back to the pipeline. That would
    // make the sidebar's Partners entry open the wrong view entirely.
    if (_hash.indexOf('?') !== -1) _hash = _hash.substring(0, _hash.indexOf('?'));
    if (_hash && VIEW_META[_hash]) { _initialView = _hash; _initialViewHadNoRealHash_ = false; }
  } catch(e) {}

  // Book-Trial deep link (2026-07-22, race fix 2026-07-22): the bride profile page links
  // "Book Trial" to /pages/admin-crm?bride=<email>&book=trial#internal-booking. The admin
  // must land on the internal booker IMMEDIATELY, preloaded with her, and must NOT flash
  // the pipeline first while the (possibly frozen-cache-slow, 30s+504) pipeline loads.
  //
  // Fix: this is now DECOUPLED from the pipeline payload. `_ccBookTrialArm_` runs at the
  // very top of onAppReady, switches to the booker view at once (so the pipeline never
  // shows), then POLLS for STATE.clients (populated by pipeline_syncStateClients_ off
  // either the fast island OR the slow live load) and preloads the bride the instant she
  // resolves. Additive; reuses ibOpenForClient; no booker logic changed.
  var _ccBookTrialDeepLinkDone_ = false;
  function _ccBookTrialParams_() {
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return null; }
    var email = (params.get('bride') || '').trim().toLowerCase();
    var wantBooker = (params.get('book') === 'trial') ||
                     (location.hash && location.hash.substring(1) === 'internal-booking');
    return (email && wantBooker) ? { email: email } : null;
  }
  function _ccBookTrialTryPreload_(email) {
    if (_ccBookTrialDeepLinkDone_) return true;
    var match = null;
    try {
      var all = (STATE && STATE.clients && STATE.clients.forEach) ? STATE.clients : null;
      if (all) all.forEach(function (c) { if (!match && c && String(c.email || '').trim().toLowerCase() === email) match = c; });
    } catch (e) {}
    if (!match || typeof ibOpenForClient !== 'function') return false;
    _ccBookTrialDeepLinkDone_ = true;
    ibOpenForClient({
      rowIndex: match.id || match.rowIndex || match.clientId,
      fullName: match.name || '',
      email: match.email || '',
      weddingDateLabel: (match.weddingDate && typeof formatDate === 'function') ? formatDate(match.weddingDate) : ''
    });
    return true;
  }
  // Arm the deep link: switch to the booker NOW (no pipeline flash), then poll for the
  // client list and preload the bride as soon as it is available. Polls up to ~40s so it
  // still preloads even when the pipeline falls to the slow 30s live path.
  function _ccBookTrialArm_() {
    var dl = _ccBookTrialParams_();
    if (!dl) return false;
    // Show the booker immediately so the pipeline never flashes.
    try { if (typeof switchView === 'function') switchView('internal-booking'); } catch (e) {}
    // Preload now if clients already resolved (fast island path), else poll.
    if (_ccBookTrialTryPreload_(dl.email)) return true;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (_ccBookTrialTryPreload_(dl.email) || tries > 200) clearInterval(iv); // 200 * 200ms = 40s
    }, 200);
    return true;
  }
  // Back-compat shim: applyInitialPayload_ still calls _ccBookTrialDeepLink_(); route it
  // through the (idempotent) preload attempt so the fast island path preloads promptly.
  function _ccBookTrialDeepLink_() {
    var dl = _ccBookTrialParams_();
    if (dl) _ccBookTrialTryPreload_(dl.email);
  }

  // Apply an initial payload object to STATE and re-render.
  // fromCache=true: render immediately but do not hide loader or start polling yet.
  // fromCache=false: fresh GAS data — finalize the UI.
  function applyInitialPayload_(payload, fromCache) {
    if (payload.stages && payload.stages.ok) {
      STATE.stageConfig = payload.stages.stages;
      STATE.pipelineStages = payload.stages.stages.map(function(s) { return s.name; });
      STATE.stageColours = {};
      payload.stages.stages.forEach(function(s) { STATE.stageColours[s.name] = s.colour; });
    }
    if (payload.pipeline) STATE.pipeline = payload.pipeline;
    if (payload.notifications) {
      _bellNotifications = payload.notifications.notifications || [];
      var counts = payload.notifications.counts || { high: 0, medium: 0, low: 0 };
      var total = counts.high + counts.medium + counts.low;
      var badge = document.getElementById('bell-badge');
      if (badge) badge.textContent = total > 0 ? total : '';
      renderBellDropdown();
    }
    // 2026-08-11: this function runs TWICE per load, once synchronously from cache
    // (fromCache=true, before the admin can have clicked anywhere) and once again
    // when the background GAS refresh resolves (fromCache=false, often 10-20s+
    // later per the documented cold-start floor). The second run must not force the
    // admin back to _initialView if they have already navigated elsewhere in the
    // meantime, that is the exact bug Cowork reproduced live 2026-08-11: the
    // Aug-11 showContent() guard closed the Pipeline-nav-click path but missed this
    // boot-time path entirely, since onPipelineLoaded() also writes kanban-board's
    // display directly, bypassing showContent(). Skip both calls once the admin has
    // genuinely moved away; STATE and notifications/KPI above are still applied so
    // the data is fresh whenever they do return to that view.
    var _stillOnBootView_ = !_switchViewRanOnce_ || STATE.currentView === _initialView;
    if (_stillOnBootView_) {
      // 2026-08-16: skipHash on the first boot call when the URL had no real
      // hash, so this success path does not push "#pipeline" into a clean
      // /pages/admin-crm URL (see _initialViewHadNoRealHash_ above).
      switchView(_initialView, _initialViewHadNoRealHash_);
      if (_initialView === 'pipeline' && payload.pipeline) {
        onPipelineLoaded(payload.pipeline);
      }
    }
    // Deep-link into the internal booker preloaded with a bride (2026-07-22): the
    // full-screen bride profile page links "Book Trial" to
    // /pages/admin-crm?bride=<email>&book=trial#internal-booking. The hash already
    // opens the (empty) booker via switchView; this resolves the bride from the
    // ?bride= param and calls the EXISTING ibOpenForClient preload path so her
    // details / entitlement / trial address load in. Additive; no booker logic
    // changed. Fires once per load, only when the params are present.
    if (_initialView === 'internal-booking' && payload.pipeline) {
      try { _ccBookTrialDeepLink_(); } catch (e) {}
    }
    // KPI number-tile strip: render from the payload whenever it carries KPI. This now
    // includes the CACHED island path (the pipeline cache carries `kpi` as of 2026-07-17),
    // so the strip paints instantly on load instead of waiting on a live getKpiOverview.
    // Only fall back to the live KPI fetch when the payload has no KPI (older/cold island).
    // On the cache path we do NOT fire the live fetch: the background getInitialPayload
    // refresh below re-runs applyInitialPayload_ with fresh KPI and repaints if needed.
    if (payload.kpi && Array.isArray(payload.kpi.cards)) {
      renderKpiOverview(payload.kpi.cards);
    } else if (!fromCache) {
      loadKpiOverview(true);
    }
    // Hide the "Syncing Ecosystem" loader as soon as we have painted, whether from CACHE
    // or fresh (2026-07-18 fix). Previously the loader hide was gated on !fromCache, so a
    // cache paint rendered the kanban behind the scenes but left the loader up until the
    // slow background GAS refresh returned (up to 30-90s under load). The whole point of
    // the CDN island is instant paint, so the loader must clear on the cache path too; the
    // GAS refresh continues silently and repaints if anything changed.
    hideLoader();
    // startNotifPolling arms the 5-min interval. skipFirstPoll=true when notifications
    // arrived in THIS payload (fresh or a warm cache) so we skip an immediate slow poll.
    startNotifPolling(!!(payload.notifications && payload.notifications.notifications));
  }

  function onAppReady() {
    var appRoot = document.getElementById('app-root');
    appRoot.classList.add('ready');

    // Book-Trial deep link: if we arrived at #internal-booking?book=trial&bride=..., switch
    // to the booker IMMEDIATELY (before any pipeline paint) and arm the bride preload. This
    // must run first so the pipeline never flashes while it loads (which, on a frozen-cache
    // slow load, could be 30s+). Decoupled from the pipeline payload entirely.
    var _ccBookTrialArmed_ = false;
    try { _ccBookTrialArmed_ = _ccBookTrialArm_(); } catch (e) {}

    // ── STALE-WHILE-REVALIDATE: render from the fastest cached source instantly ──
    // Priority: localStorage (device-fresh, set on last successful GAS fetch)
    //   -> shop metafield CDN payload (_PIPELINE_INLINE_, baked into page HTML by
    //      Liquid; always present after warming, works on first visit + every device).
    // Either path renders the kanban with zero wait. GAS then refreshes below.
    var cachedPayload = jvPayloadCache_get();
    if (cachedPayload) {
      applyInitialPayload_(cachedPayload, true /* fromCache */);
    } else {
      // No localStorage payload -> paint from the inline island. The island is usually
      // ready synchronously (plain JSON); if it is a gzip payload still inflating, wait
      // for it via the ready callback rather than missing the fast paint. The live GAS
      // refresh below runs in parallel regardless, so this never blocks the fresh data.
      var _paintFromInline_ = function() {
        if (_PIPELINE_INLINE_ && _PIPELINE_INLINE_.ok) {
          cachedPayload = _PIPELINE_INLINE_;
          applyInitialPayload_(cachedPayload, true /* fromCache */);
        }
      };
      if (_PIPELINE_INLINE_READY_) {
        _paintFromInline_();
      } else {
        _onPipelineInlineReady_ = _paintFromInline_; // fires when async inflation resolves
      }
    }

    // C3 (2026-10-07): with #calendar and no cached pipeline payload, the Calendar used to wait for the slow
    // getInitialPayload before even starting. It needs nothing from that payload, so start it now (the later
    // payload-driven switchView re-enters loadCalendarView, which is a no-op while the first fetch is in flight).
    if (!cachedPayload && _initialView === 'calendar') {
      try { hideLoader(); switchView('calendar', _initialViewHadNoRealHash_); } catch (e) {}
    }

    // Preload the client search index in the background so the search box is
    // instant on first keystroke. Deferred 2.5s so the main payload fetch below
    // warms a GAS instance first — this call then reuses the warm instance
    // (fast) rather than paying a second cold-start. No-op if already cached.
    setTimeout(function() {
      try { if (typeof _ensureClientIdx === 'function') _ensureClientIdx(function() {}); } catch (e) {}
    }, _initialView === 'calendar' ? 12000 : 2500); // C3: do not compete with the calendar read for Apps Script

    // Always fetch fresh data from GAS (background refresh if we had cached data)
    jvBridge.callAdmin('bridge_admin_getInitialPayload', { token: STATE.token })
      .then(function(res) {
        var payload = res.ok ? res.data : null;
        if (!payload || !payload.ok) {
          if (!cachedPayload) {
            hideLoader();
            // 2026-08-13 (BRIEFS/URGENT-admin-crm-nav-reverts-to-pipeline-2026-08-13.md):
            // this branch used to force switchView(_initialView) unconditionally, same
            // bug class as the 2026-08-11 applyInitialPayload_ guard two functions above
            // (_stillOnBootView_) fixed for the SUCCESS path -- but this no-payload
            // failure branch and the catch() below were never covered by that fix. A
            // slow/failed cold-load response landing after the admin has already clicked
            // to a different view silently snapped them back to Pipeline. Reusing the
            // exact same guard variable/condition, not a new mechanism.
            var _stillOnBootView_ = !_switchViewRanOnce_ || STATE.currentView === _initialView;
            // 2026-08-16: skipHash so this no-payload failure path also does not push
            // "#pipeline" into a clean /pages/admin-crm URL (see _initialViewHadNoRealHash_).
            if (_stillOnBootView_) switchView(_initialView, _initialViewHadNoRealHash_);
            startNotifPolling();
          }
          return;
        }
        jvPayloadCache_set(payload);
        applyInitialPayload_(payload, false /* fresh */);
      })
      .catch(function() {
        if (!cachedPayload) {
          hideLoader();
          // 2026-08-13, same fix as the branch above (see its comment) -- the network-
          // error path had the identical unguarded revert-to-boot-view bug.
          var _stillOnBootView_ = !_switchViewRanOnce_ || STATE.currentView === _initialView;
          // 2026-08-16: skipHash, same reasoning as the branch above.
          if (_stillOnBootView_) switchView(_initialView, _initialViewHadNoRealHash_);
          startNotifPolling();
        }
      });
  }

  // Shopify auth: window.jvAuth is set by jv-app-auth snippet
  // Session token comes from Shopify customer login, not GAS AuthBridge
  if (window.jvAuth && window.jvAuth.loggedIn) {
    STATE.token = window.jvAuth.email || '';
    onAppReady();
  } else {
    // Fallback: show app anyway (auth gate in Liquid handles access control)
    onAppReady();
  }
  } // end _startWithBridge

  _checkBridgeAndStart();
})();

function hideLoader() {
  var overlay = document.getElementById('loading-overlay');
  overlay.style.opacity = '0';
  setTimeout(function(){ overlay.style.display = 'none'; }, 800);
}

/* ===================================================================
   EMAIL TEMPLATES MODULE
   Routes: comms_templatesLoadActive, comms_templateSave, comms_templateToggle
   All calls use jvBridge.callAdmin() — same pattern as the rest of the CRM.
   =================================================================== */
(function() {
  'use strict';

  /* ---- module state ---- */
  var _templates = [];      // cached list from last server fetch
  var _activeBodyEl = null; // textarea currently focused for token insertion
  var _cacheTemplates = null;
  var _grapesEditor = null;
  var _quillEditor = null;

  function readTemplateCache() {
    if (_cacheTemplates) return _cacheTemplates;
    var el = document.getElementById('crm-template-cache');
    if (!el) { _cacheTemplates = []; return _cacheTemplates; }
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      if (typeof parsed === 'string') parsed = JSON.parse(parsed || '[]');
      _cacheTemplates = Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      _cacheTemplates = [];
    }
    return _cacheTemplates;
  }

  function normaliseTemplate(t) {
    return {
      template_id: t.template_id || t.templateId || t.id || '',
      name: t.name || t.title || 'Untitled template',
      subject_template: t.subject_template || t.subject || '',
      body_template: t.body_template || t.html || t.body || '',
      tags: t.tags || '',
      active: t.active !== false
    };
  }

  window.emailBuilderPopulateTemplateSelects = function() {
    var select = document.getElementById('email-template-select');
    if (!select) return;
    var cached = readTemplateCache().map(normaliseTemplate);
    if (cached.length) {
      select.innerHTML = '<option value="">Start from a blank email</option>' +
        cached.map(function(t, idx) {
          return '<option value="' + idx + '">' + escHtml(t.name || 'Untitled template') + '</option>';
        }).join('');
      return;
    }
    // Metafield cache empty — fetch live from GAS
    jvBridge.callAdmin('comms_templatesLoadActive', { channel: 'EMAIL' }).then(function(res) {
      var raw = (res && res.ok && res.data) ? res.data : (res && Array.isArray(res.templates) ? res.templates : []);
      if (res && Array.isArray(res.templates)) raw = res.templates;
      if (Array.isArray(raw)) {
        _cacheTemplates = raw;
        var tpls = raw.map(normaliseTemplate);
        select.innerHTML = '<option value="">Start from a blank email</option>' +
          tpls.map(function(t, idx) {
            return '<option value="' + idx + '">' + escHtml(t.name || 'Untitled template') + '</option>';
          }).join('');
      }
    }).catch(function() {});
  };

  window.applyEmailTemplateFromCache = function(value) {
    var previewWrap = document.getElementById('email-tpl-preview-wrap');
    if (value === '') {
      if (previewWrap) previewWrap.style.display = 'none';
      return;
    }
    var tpl = readTemplateCache().map(normaliseTemplate)[Number(value)];
    if (!tpl) return;
    document.getElementById('email-subject').value = window.emailBuilderReplaceTokens(tpl.subject_template || '', window._emailBuilderRecipient || {});
    var html = window.emailBuilderReplaceTokens(tpl.body_template || '', window._emailBuilderRecipient || {});
    document.getElementById('email-body').value = html;
    if (window.emailBuilderSetQuillHtml) window.emailBuilderSetQuillHtml(html);
    // Show rendered template preview
    var iframe = document.getElementById('email-tpl-preview-iframe');
    if (previewWrap && iframe && tpl.body_template) {
      var rawHtml = tpl.body_template;
      var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
      if (doc) { doc.open(); doc.write(rawHtml); doc.close(); }
      previewWrap.style.display = '';
    }
  };

  window.emailBuilderInitQuill = function() {
    if (_quillEditor || typeof Quill === 'undefined') return;
    var el = document.getElementById('email-quill-editor');
    if (!el) return;
    _quillEditor = new Quill(el, {
      theme: 'snow',
      modules: { toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']] }
    });
  };

  window.emailBuilderSetQuillHtml = function(html) {
    if (!_quillEditor && window.emailBuilderInitQuill) window.emailBuilderInitQuill();
    if (_quillEditor) _quillEditor.root.innerHTML = html || '';
  };

  window.emailBuilderSyncQuillToTextarea = function() {
    if (_quillEditor) {
      var bodyEl = document.getElementById('email-body');
      if (bodyEl) bodyEl.value = _quillEditor.root.innerHTML || '';
    }
  };

  /* ----------------------------------------------------------------
     JV BRAND CONSTANTS — email-safe inline CSS values
  ---------------------------------------------------------------- */
  var JV_EMAIL_BRAND = {
    primary:      '#c99591',
    primaryDeep:  '#a9706c',
    dark:         '#1e1716',
    text:         '#2f2524',
    softBg:       '#f6f1ee',
    white:        '#ffffff',
    muted:        '#7e706c',
    line:         '#e6dad4',
    headingFont:  "'Raleway', Georgia, serif",
    bodyFont:     "'Plus Jakarta Sans', Arial, sans-serif"
  };

  /* ----------------------------------------------------------------
     DEFAULT SCAFFOLD — loaded into GrapesJS for new templates
  ---------------------------------------------------------------- */
  var JV_EMAIL_DEFAULT_SCAFFOLD = (function() {
    var B = JV_EMAIL_BRAND;
    return [
      '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:' + B.softBg + ';padding:40px 20px;font-family:' + B.bodyFont + ';">',
      '<tr><td align="center">',
      '<table width="600" cellpadding="0" cellspacing="0" border="0" style="max-width:600px;background-color:' + B.white + ';border-radius:12px;overflow:hidden;">',
      '<!-- Header -->',
      '<tr><td style="background-color:' + B.dark + ';padding:32px 40px;text-align:center;">',
      '<p style="margin:0 0 6px;font-family:' + B.headingFont + ';font-size:11px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;color:' + B.primary + ';">Jessica Vegas Pro Team</p>',
      '<h1 style="margin:0;font-family:' + B.headingFont + ';font-size:28px;font-weight:300;color:' + B.white + ';line-height:1.3;">Your Heading Here</h1>',
      '</td></tr>',
      '<!-- Body -->',
      '<tr><td style="padding:40px 40px 24px;">',
      '<p style="margin:0 0 16px;font-family:' + B.bodyFont + ';font-size:16px;color:' + B.text + ';line-height:1.7;">Hi [FirstName],</p>',
      '<p style="margin:0 0 32px;font-family:' + B.bodyFont + ';font-size:16px;color:' + B.text + ';line-height:1.7;">Write your message here. Keep it warm and personal.</p>',
      '<table cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;">',
      '<tr><td style="border-radius:50px;background-color:' + B.primary + ';">',
      '<a href="#" style="display:inline-block;padding:14px 36px;font-family:' + B.headingFont + ';font-size:13px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:' + B.white + ';text-decoration:none;border-radius:50px;">View Your Details</a>',
      '</td></tr></table>',
      '</td></tr>',
      '<!-- Divider -->',
      '<tr><td style="padding:0 40px;"><hr style="border:none;border-top:1px solid ' + B.line + ';margin:0;" /></td></tr>',
      '<!-- Footer -->',
      '<tr><td style="padding:24px 40px 32px;text-align:center;">',
      '<p style="margin:0;font-family:' + B.bodyFont + ';font-size:13px;color:' + B.muted + ';line-height:1.6;">With love,<br><strong style="font-family:' + B.headingFont + ';font-weight:600;color:' + B.text + ';">Jessica Vegas Pro Team</strong></p>',
      '</td></tr>',
      '</table>',
      '</td></tr></table>'
    ].join('');
  }());

  /* ----------------------------------------------------------------
     BRAND BLOCK LIBRARY — curated GrapesJS blocks
  ---------------------------------------------------------------- */
  function addJVBrandBlocks(editor) {
    var bm = editor.BlockManager;
    var B = JV_EMAIL_BRAND;

    bm.add('jv-intro-header', {
      label: 'JV Header',
      category: 'JV Brand',
      content: [
        '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:' + B.dark + ';padding:32px 40px;text-align:center;">',
        '<tr><td>',
        '<p style="margin:0 0 6px;font-family:' + B.headingFont + ';font-size:11px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;color:' + B.primary + ';">Jessica Vegas Pro Team</p>',
        '<h1 style="margin:0;font-family:' + B.headingFont + ';font-size:28px;font-weight:300;color:' + B.white + ';line-height:1.3;">Your Heading Here</h1>',
        '</td></tr></table>'
      ].join('')
    });

    bm.add('jv-text-section', {
      label: 'JV Text Block',
      category: 'JV Brand',
      content: [
        '<table width="100%" cellpadding="0" cellspacing="0" border="0">',
        '<tr><td style="padding:32px 40px;">',
        '<p style="margin:0 0 16px;font-family:' + B.bodyFont + ';font-size:16px;color:' + B.text + ';line-height:1.7;">Hi [FirstName],</p>',
        '<p style="margin:0;font-family:' + B.bodyFont + ';font-size:16px;color:' + B.text + ';line-height:1.7;">Write your message here.</p>',
        '</td></tr></table>'
      ].join('')
    });

    bm.add('jv-cta-button', {
      label: 'JV CTA Button',
      category: 'JV Brand',
      content: [
        '<table cellpadding="0" cellspacing="0" border="0" width="100%" style="padding:16px 40px;">',
        '<tr><td align="center">',
        '<table cellpadding="0" cellspacing="0" border="0">',
        '<tr><td style="border-radius:50px;background-color:' + B.primary + ';">',
        '<a href="#" style="display:inline-block;padding:14px 36px;font-family:' + B.headingFont + ';font-size:13px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:' + B.white + ';text-decoration:none;border-radius:50px;">View Details</a>',
        '</td></tr></table>',
        '</td></tr></table>'
      ].join('')
    });

    bm.add('jv-detail-summary', {
      label: 'JV Detail List',
      category: 'JV Brand',
      content: [
        '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="padding:16px 40px;">',
        '<tr><td style="background-color:' + B.softBg + ';border-radius:8px;padding:24px 28px;">',
        '<table width="100%" cellpadding="0" cellspacing="0" border="0">',
        '<tr>',
        '<td style="font-family:' + B.bodyFont + ';font-size:13px;font-weight:600;color:' + B.muted + ';padding-bottom:10px;width:40%;">Wedding Date</td>',
        '<td style="font-family:' + B.bodyFont + ';font-size:14px;color:' + B.text + ';padding-bottom:10px;">[WeddingDate]</td>',
        '</tr><tr>',
        '<td style="font-family:' + B.bodyFont + ';font-size:13px;font-weight:600;color:' + B.muted + ';padding-bottom:10px;">Location</td>',
        '<td style="font-family:' + B.bodyFont + ';font-size:14px;color:' + B.text + ';padding-bottom:10px;">[WeddingLocation]</td>',
        '</tr><tr>',
        '<td style="font-family:' + B.bodyFont + ';font-size:13px;font-weight:600;color:' + B.muted + ';">Trial Date</td>',
        '<td style="font-family:' + B.bodyFont + ';font-size:14px;color:' + B.text + ';">[TrialDate]</td>',
        '</tr>',
        '</table>',
        '</td></tr></table>'
      ].join('')
    });

    bm.add('jv-divider', {
      label: 'JV Divider',
      category: 'JV Brand',
      content: '<table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding:8px 40px;"><hr style="border:none;border-top:1px solid ' + B.line + ';margin:0;" /></td></tr></table>'
    });

    bm.add('jv-signature-footer', {
      label: 'JV Signature',
      category: 'JV Brand',
      content: [
        '<table width="100%" cellpadding="0" cellspacing="0" border="0">',
        '<tr><td style="padding:24px 40px 32px;text-align:center;">',
        '<p style="margin:0;font-family:' + B.bodyFont + ';font-size:13px;color:' + B.muted + ';line-height:1.6;">With love,<br><strong style="font-family:' + B.headingFont + ';font-weight:600;color:' + B.text + ';">Jessica Vegas Pro Team</strong></p>',
        '</td></tr></table>'
      ].join('')
    });

    bm.add('jv-link-cta', {
      label: 'JV Link CTA',
      category: 'JV Brand',
      content: [
        '<table width="100%" cellpadding="0" cellspacing="0" border="0" style="padding:16px 40px;">',
        '<tr><td style="border-left:3px solid ' + B.primary + ';padding:12px 20px;background-color:' + B.softBg + ';border-radius:0 8px 8px 0;">',
        '<p style="margin:0 0 6px;font-family:' + B.bodyFont + ';font-size:12px;font-weight:600;color:' + B.muted + ';letter-spacing:0.05em;text-transform:uppercase;">View Online</p>',
        '<a href="#" style="font-family:' + B.bodyFont + ';font-size:15px;color:' + B.primaryDeep + ';text-decoration:underline;">Your Proposal / Runsheet Link</a>',
        '</td></tr></table>'
      ].join('')
    });
  }

  /* ----------------------------------------------------------------
     BRAND HTML NORMALISER — frontend sanitisation before save
     (server-side validation is a separate layer — Brief 507)
  ---------------------------------------------------------------- */
  window.emailBuilderNormaliseBrandHtml = function(html) {
    if (!html) return html;
    var out = String(html);
    // Remove script tags and contents
    out = out.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
    // Remove form tags (keep inner content)
    out = out.replace(/<\/?form\b[^>]*>/gi, '');
    // Remove inline event handlers
    out = out.replace(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');
    // Replace javascript: hrefs
    out = out.replace(/(href\s*=\s*["']?)\s*javascript:[^"'\s>]*/gi, '$1#');
    // Remove data: URI src/href (XSS vector)
    out = out.replace(/((?:src|href)\s*=\s*["']?)\s*data:[^"'\s>]*/gi, '$1""');
    return out;
  };

  function initGrapesEditor() {
    if (_grapesEditor || typeof grapesjs === 'undefined') return _grapesEditor;
    var el = document.getElementById('etb-grapesjs');
    if (!el) return null;
    _grapesEditor = grapesjs.init({
      container: '#etb-grapesjs',
      height: '520px',
      storageManager: false,
      plugins: ['grapesjs-preset-newsletter'],
      pluginsOpts: { 'grapesjs-preset-newsletter': {} }
    });
    addJVBrandBlocks(_grapesEditor);
    return _grapesEditor;
  }

  window.toggleEmailBuilderMode = function(mode) {
    var grapesWrap = document.getElementById('etb-grapesjs');
    var bodyEl = document.getElementById('etb-body');
    var marketing = mode !== 'simple';
    if (grapesWrap) grapesWrap.style.display = marketing ? '' : 'none';
    if (bodyEl) bodyEl.style.display = marketing ? 'none' : '';
    if (marketing) initGrapesEditor();
  };

  function setBuilderHtml(html) {
    var editor = initGrapesEditor();
    if (editor) editor.setComponents(html || '');
    var bodyEl = document.getElementById('etb-body');
    if (bodyEl) bodyEl.value = html || '';
  }

  function getBuilderHtml() {
    var modeEl = document.getElementById('etb-builder-mode');
    if (modeEl && modeEl.value === 'simple') {
      var bodyEl = document.getElementById('etb-body');
      return bodyEl ? bodyEl.value.trim() : '';
    }
    var editor = initGrapesEditor();
    if (editor) return editor.runCommand('gjs-get-inlined-html') || editor.getHtml();
    var fallback = document.getElementById('etb-body');
    return fallback ? fallback.value.trim() : '';
  }

  // NOTE: Frontend token replacement is for PREVIEW only.
  // The authoritative substitution is performed server-side in EmailTemplateTokens.gs
  // before the email is dispatched. Context fields are passed in the send payload.
  window.emailBuilderReplaceTokens = function(input, recipient) {
    recipient = recipient || {};
    var fullName = String(recipient.name || recipient.clientName || '').trim();
    var parts = fullName.split(/\s+/);
    var customerData = {
      '[FirstName]':       recipient.firstName || recipient.first_name || parts[0] || '',
      '[LastName]':        recipient.lastName  || recipient.last_name  || parts.slice(1).join(' ') || '',
      '[Email]':           recipient.email || '',
      '[WeddingDate]':     recipient.weddingDate    || recipient.wedding_date    || '',
      '[WeddingLocation]': recipient.weddingLocation || recipient.wedding_location || '',
      '[TrialDate]':       recipient.trialDate  || recipient.trial_date  || '',
      '[ProposalLink]':    recipient.proposalLink   || recipient.proposal_link   || '',
      '[BookingDate]':     recipient.bookingDate    || recipient.booking_date    || '',
      '[ArtistName]':      recipient.assignedArtist || recipient.artist_name     || '',
      '[Total]':           recipient.total          || '',
      '[DepositAmount]':   recipient.depositAmount  || recipient.deposit_amount  || '',
      '[BalanceAmount]':   recipient.balanceAmount  || recipient.balance_amount  || '',
      '[RunsheetLink]':    recipient.runsheetLink   || recipient.runsheet_link   || recipient.runsheetUrl || ''
    };
    var output = String(input || '');
    Object.keys(customerData).forEach(function(key) {
      var escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      output = output.replace(new RegExp(escaped, 'g'), customerData[key] || '');
    });
    return output;
  };

  /* ----------------------------------------------------------------
     PUBLIC ENTRY — called by lazyLoadView('comms-templates')
  ---------------------------------------------------------------- */
  window.loadCommsTemplatesView = function() {
    closeTemplateEditor();
    showLoader('comms-templates');
    _templates = readTemplateCache().map(normaliseTemplate);
    window.emailBuilderPopulateTemplateSelects();
    if (_templates.length) {
      showContent('comms-templates');
      renderTemplateList(_templates);
    }
    jvBridge.callAdmin('comms_templatesLoadActive', { token: STATE.token, channel: 'EMAIL' })
      .then(function(res) {
        if (res && res.ok) {
          _templates = Array.isArray(res.data) ? res.data : [];
          showContent('comms-templates');
          renderTemplateList(_templates);
        } else {
          showError('comms-templates', (res && res.error) || 'Failed to load templates.');
        }
      })
      .catch(function(err) {
        showError('comms-templates', err && err.message ? err.message : String(err));
      });
  };

  /* ----------------------------------------------------------------
     RENDER LIST
  ---------------------------------------------------------------- */
  function renderTemplateList(templates) {
    var listEl = document.getElementById('comms-templates-list');
    var emptyEl = document.getElementById('comms-templates-empty');
    if (!listEl) return;
    if (!templates || templates.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    listEl.innerHTML = templates.map(function(t) {
      var activeClass = t.active ? 'etb-row--active' : 'etb-row--inactive';
      var activeLbl = t.active ? 'Active' : 'Inactive';
      var activePillClass = t.active ? 'etb-pill--active' : 'etb-pill--inactive';
      var toggleLabel = t.active ? 'Deactivate' : 'Activate';
      var tagHtml = t.tags ? t.tags.split(',').filter(Boolean).map(function(tag) {
        return '<span class="etb-tag">' + escHtml(tag.trim()) + '</span>';
      }).join('') : '';
      return [
        '<div class="etb-row ' + activeClass + '" data-template-id="' + escAttr(t.template_id) + '">',
        '  <div class="etb-row-main">',
        '    <div class="etb-row-name">' + escHtml(t.name || '(Untitled)') + '</div>',
        '    <div class="etb-row-subject">' + escHtml(t.subject_template || '') + '</div>',
        '    <div class="etb-row-tags">' + tagHtml + '</div>',
        '  </div>',
        '  <div class="etb-row-actions">',
        '    <span class="etb-pill ' + activePillClass + '">' + activeLbl + '</span>',
        '    <button class="btn btn-ghost etb-btn-sm" onclick="openTemplateEditor(\'' + escAttr(t.template_id) + '\')">Edit</button>',
        '    <button class="btn btn-ghost etb-btn-sm" onclick="submitTemplateToggle(\'' + escAttr(t.template_id) + '\', this)">' + toggleLabel + '</button>',
        '  </div>',
        '</div>'
      ].join('');
    }).join('');
  }

  /* ----------------------------------------------------------------
     OPEN EDITOR
  ---------------------------------------------------------------- */
  window.openTemplateEditor = function(templateId) {
    var editorEl = document.getElementById('comms-template-editor');
    var titleEl = document.getElementById('etb-editor-title');
    var idEl = document.getElementById('etb-template-id');
    var nameEl = document.getElementById('etb-name');
    var subjectEl = document.getElementById('etb-subject');
    var tagsEl = document.getElementById('etb-tags');
    var bodyEl = document.getElementById('etb-body');
    var statusEl = document.getElementById('etb-save-status');
    if (!editorEl) return;

    if (statusEl) statusEl.textContent = '';

    if (!templateId) {
      // New template
      if (titleEl) titleEl.textContent = 'New Template';
      if (idEl) idEl.value = '';
      if (nameEl) nameEl.value = '';
      if (subjectEl) subjectEl.value = '';
      if (tagsEl) tagsEl.value = '';
      if (bodyEl) bodyEl.value = '';
      setBuilderHtml(JV_EMAIL_DEFAULT_SCAFFOLD);
      toggleEmailBuilderMode('marketing');
    } else {
      // Edit existing — find from cache
      var tpl = null;
      for (var i = 0; i < _templates.length; i++) {
        if (_templates[i].template_id === templateId) { tpl = _templates[i]; break; }
      }
      if (!tpl) { jvToast('Template not found.', 'warn'); return; }
      if (titleEl) titleEl.textContent = 'Edit Template';
      if (idEl) idEl.value = tpl.template_id || '';
      if (nameEl) nameEl.value = tpl.name || '';
      if (subjectEl) subjectEl.value = tpl.subject_template || '';
      if (tagsEl) tagsEl.value = tpl.tags || '';
      if (bodyEl) bodyEl.value = tpl.body_template || '';
      setBuilderHtml(tpl.body_template || '');
      toggleEmailBuilderMode('marketing');
    }

    // Track active textarea for token insertion
    if (bodyEl) {
      _activeBodyEl = bodyEl;
      bodyEl.addEventListener('focus', function() { _activeBodyEl = bodyEl; }, { once: false });
    }

    editorEl.style.display = '';
    editorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    if (nameEl) nameEl.focus();
  };

  /* ----------------------------------------------------------------
     CLOSE EDITOR
  ---------------------------------------------------------------- */
  window.closeTemplateEditor = function() {
    var editorEl = document.getElementById('comms-template-editor');
    if (editorEl) editorEl.style.display = 'none';
    _activeBodyEl = null;
  };

  /* ----------------------------------------------------------------
     INSERT TOKEN AT CURSOR
  ---------------------------------------------------------------- */
  window.insertToken = function(token) {
    var el = _activeBodyEl || document.getElementById('etb-body');
    if (!el) return;
    var start = el.selectionStart;
    var end = el.selectionEnd;
    var val = el.value;
    el.value = val.slice(0, start) + token + val.slice(end);
    var newPos = start + token.length;
    el.setSelectionRange(newPos, newPos);
    el.focus();
  };

  /* ----------------------------------------------------------------
     SAVE TEMPLATE
  ---------------------------------------------------------------- */
  window.submitTemplateSave = function() {
    var idEl = document.getElementById('etb-template-id');
    var nameEl = document.getElementById('etb-name');
    var subjectEl = document.getElementById('etb-subject');
    var tagsEl = document.getElementById('etb-tags');
    var bodyEl = document.getElementById('etb-body');
    var saveBtn = document.getElementById('etb-save-btn');
    var statusEl = document.getElementById('etb-save-status');

    var name = nameEl ? nameEl.value.trim() : '';
    var subject = subjectEl ? subjectEl.value.trim() : '';
    var body = window.emailBuilderNormaliseBrandHtml(getBuilderHtml());
    var tags = tagsEl ? tagsEl.value.trim() : '';
    var templateId = idEl ? idEl.value.trim() : '';

    if (!name) { jvToast('Please enter a template name.', 'warn'); if (nameEl) nameEl.focus(); return; }
    if (!subject) { jvToast('Please enter a subject line.', 'warn'); if (subjectEl) subjectEl.focus(); return; }
    if (!body) { jvToast('Please enter a message body.', 'warn'); if (bodyEl) bodyEl.focus(); return; }

    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }
    if (statusEl) statusEl.textContent = '';

    var payload = {
      token: STATE.token,
      name: name,
      channel: 'EMAIL',
      subject_template: subject,
      body_template: body,
      tags: tags,
      active: true
    };
    if (templateId) payload.template_id = templateId;

    jvBridge.callAdmin('save_template', payload)
      .then(function(res) {
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save Template'; }
        if (res && (res.status === 'created' || res.status === 'updated' || res.ok)) {
          var verb = (res.status === 'created' || !templateId) ? 'created' : 'updated';
          jvToast('Template ' + verb + '.', 'success');
          if (statusEl) statusEl.textContent = 'Saved.';
          closeTemplateEditor();
          loadCommsTemplatesView();
        } else {
          jvToast((res && res.error) || 'Save failed.', 'error');
          if (statusEl) statusEl.textContent = 'Error saving.';
        }
      })
      .catch(function(err) {
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save Template'; }
        jvToast(err && err.message ? err.message : 'Save failed.', 'error');
      });
  };

  /* ----------------------------------------------------------------
     TOGGLE TEMPLATE ACTIVE/INACTIVE
  ---------------------------------------------------------------- */
  window.submitTemplateToggle = function(templateId, btnEl) {
    if (!templateId) return;
    if (btnEl) { btnEl.disabled = true; btnEl.textContent = '…'; }
    jvBridge.callAdmin('comms_templateToggle', { token: STATE.token, template_id: templateId })
      .then(function(res) {
        if (res && res.ok) {
          var isNowActive = !!res.active;
          jvToast('Template ' + (isNowActive ? 'activated' : 'deactivated') + '.', 'success');
          // Update local cache
          for (var i = 0; i < _templates.length; i++) {
            if (_templates[i].template_id === templateId) {
              _templates[i].active = isNowActive;
              break;
            }
          }
          renderTemplateList(_templates);
        } else {
          if (btnEl) { btnEl.disabled = false; }
          jvToast((res && res.error) || 'Toggle failed.', 'error');
        }
      })
      .catch(function(err) {
        if (btnEl) { btnEl.disabled = false; }
        jvToast(err && err.message ? err.message : 'Toggle failed.', 'error');
      });
  };

})(); /* end Email Templates Module */

/* ============================================================
   PIPELINE SEARCH
   ============================================================ */
function filterPipelineSearch() {
  var q = (document.getElementById('pipeline-search').value || '').toLowerCase().replace(/[''‚‛′‵`]/g, "'").trim();
  document.querySelectorAll('.kanban-card').forEach(function(card) {
    if (!q) {
      card.style.display = '';
      return;
    }
    var name = (card.dataset.name || (card.querySelector('.kc-name') || {}).textContent || '');
    card.style.display = name.toLowerCase().indexOf(q) !== -1 ? '' : 'none';
  });
  // Update visible counts per column
  document.querySelectorAll('.kanban-col').forEach(function(col) {
    var total = col.querySelectorAll('.kanban-card').length;
    var visible = col.querySelectorAll('.kanban-card:not([style*="display: none"])').length;
    var countEl = col.querySelector('.col-count');
    if (countEl) countEl.textContent = q ? visible + '/' + total : total;
  });
  // Reliability fix (2026-09-08, BUILD-extension-hire-workflow-reorder-and-profile-
  // entry-2026-09-08.md Finding 3, companion brief's own cross-reference): the DOM
  // filter above only ever searches cards ALREADY rendered for the active stage
  // filter -- a bride under a different stage, Closed, or archived is invisible to
  // it no matter what she's called. _searchClientIdx already indexes EVERY bride
  // with an email (no stage/close/archive filter, confirmed 2026-08-10 truncation
  // fix -- see AdminCRMAPI.gs adminCrm_getCachedSearchIndex_), so reuse it as a
  // fallback surface for whatever the DOM filter couldn't find, rather than writing
  // a second search implementation.
  pipelineSearchFallback_(q);
}

function pipelineSearchFallback_(q) {
  var panel = document.getElementById('pipeline-search-fallback');
  if (!panel) return;
  if (!q || q.length < 2) { panel.style.display = 'none'; panel.innerHTML = ''; return; }
  _ensureClientIdx(function() {
    var matches = _searchClientIdx(q, 8);
    if (matches === null) { panel.style.display = 'none'; return; }
    // Only show a match here if she is NOT already visible as a rendered kanban
    // card matching the same query -- this panel exists for the gap, not to
    // duplicate a bride the admin can already see on the board.
    var visibleCards = document.querySelectorAll('.kanban-card:not([style*="display: none"])');
    var visibleNames = {};
    visibleCards.forEach(function(c) {
      var n = (c.dataset.name || (c.querySelector('.kc-name') || {}).textContent || '').toLowerCase().trim();
      if (n) visibleNames[n] = true;
    });
    var hidden = matches.filter(function(m) { return !visibleNames[(m.name || '').toLowerCase().trim()]; });
    if (!hidden.length) { panel.style.display = 'none'; panel.innerHTML = ''; return; }
    // Copy fix (2026-09-09, RESULTS-COWORK-extension-hire-cancel-wedding-full-e2e-
    // grade3-xray-2026-09-09.md, Part A1 defect P3): "different stage, closed, or
    // archived" was factually wrong for the commonest case -- a bride ON the
    // current board but not yet paginated into view (lazy-paged columns). Say
    // what's actually true instead of guessing a reason.
    var html = '<div style="font-size:0.72rem;opacity:0.6;padding:0.4rem 0.6rem;">Not visible on the board right now (different stage, closed/archived, or simply not loaded into view yet):</div>';
    hidden.forEach(function(m) {
      // 2026-09-18 identity-mismatch fix (duplicate-email CDN collision, see
      // BRIEFS/HANDOFF-*-2026-09-18): pass the row too, same pattern as the
      // other admin-bride-profile link sites, so a duplicate-email bride opens
      // the exact row clicked, not whichever the resolver happens to prefer.
      var profileUrl = '/pages/admin-bride-profile?bride=' + encodeURIComponent(m.email) +
        (m.rowIndex ? '&row=' + encodeURIComponent(m.rowIndex) : '');
      html += '<a href="' + profileUrl + '" style="display:block;padding:0.5rem 0.6rem;border-radius:var(--radius-small);text-decoration:none;color:var(--brand-text);" ' +
        'onmouseover="this.style.background=\'var(--brand-bg-soft)\'" onmouseout="this.style.background=\'\'">' +
        '<strong>' + (m.name || m.email) + '</strong>' +
        (m.weddingDateLabel ? ' &middot; ' + m.weddingDateLabel : '') +
        (m.booked ? ' &middot; Booked' : '') +
        '</a>';
    });
    panel.innerHTML = html;
    panel.style.display = '';
  });
}

/* ============================================================
   ADD CLIENT MODAL
   ============================================================ */
var ADD_CLIENT_CATEGORIES = ['Bridal', 'Non-Bridal', 'Vendor', 'Wedding Planner', 'Other'];

function openAddClientModal() {
  if (document.getElementById('add-client-overlay')) return;
  var overlay = document.createElement('div');
  overlay.className = 'add-client-overlay';
  overlay.id = 'add-client-overlay';
  overlay.innerHTML =
    '<div class="add-client-modal" role="dialog" aria-label="Add new client">' +
      '<div class="acm-header">' +
        '<h3>Add Client</h3>' +
        '<button class="acm-close" onclick="closeAddClientModal()" aria-label="Close">&times;</button>' +
      '</div>' +
      '<form id="add-client-form" onsubmit="submitAddClient(event)" novalidate>' +

        // Contact type toggle
        '<div class="acm-type-toggle">' +
          '<button type="button" class="acm-type-btn active" id="acm-type-individual" onclick="acmSetType(\'Individual\')">Individual</button>' +
          '<button type="button" class="acm-type-btn" id="acm-type-business" onclick="acmSetType(\'Business\')">Business</button>' +
        '</div>' +
        '<input type="hidden" id="acm-contact-type" value="Individual">' +

        // Business section (hidden by default)
        '<div id="acm-business-section" style="display:none;">' +
          '<div class="acm-section-label">Business Details</div>' +
          '<div class="acm-field">' +
            '<label>Business Name <span class="acm-req">*</span></label>' +
            '<input type="text" id="acm-business-name" autocomplete="organization">' +
          '</div>' +
          '<div class="acm-row">' +
            '<div class="acm-field">' +
              '<label>ABN</label>' +
              '<input type="text" id="acm-abn" placeholder="e.g. 12 345 678 901" maxlength="14">' +
            '</div>' +
            '<div class="acm-field">' +
              '<label>Website</label>' +
              '<input type="url" id="acm-website" placeholder="https://">' +
            '</div>' +
          '</div>' +
          '<div class="acm-section-label">Socials</div>' +
          '<div class="acm-row">' +
            '<div class="acm-field">' +
              '<label><span class="acm-social-icon acm-ig"></span> Instagram</label>' +
              '<input type="url" id="acm-instagram" placeholder="https://instagram.com/…">' +
            '</div>' +
            '<div class="acm-field">' +
              '<label><span class="acm-social-icon acm-fb"></span> Facebook</label>' +
              '<input type="url" id="acm-facebook" placeholder="https://facebook.com/…">' +
            '</div>' +
          '</div>' +
          '<div class="acm-field" style="max-width:50%;">' +
            '<label><span class="acm-social-icon acm-tt"></span> TikTok</label>' +
            '<input type="url" id="acm-tiktok" placeholder="https://tiktok.com/@…">' +
          '</div>' +
          '<div class="acm-section-label">Contact Person</div>' +
        '</div>' +

        // Core contact fields
        '<div class="acm-row">' +
          '<div class="acm-field">' +
            '<label>First Name <span class="acm-req">*</span></label>' +
            '<input type="text" id="acm-firstname" autocomplete="given-name" required>' +
          '</div>' +
          '<div class="acm-field">' +
            '<label>Last Name <span class="acm-req">*</span></label>' +
            '<input type="text" id="acm-lastname" autocomplete="family-name" required>' +
          '</div>' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Email <span class="acm-req">*</span></label>' +
          '<input type="email" id="acm-email" autocomplete="email" required>' +
        '</div>' +
        '<div class="acm-row">' +
          '<div class="acm-field">' +
            '<label>Phone</label>' +
            '<input type="tel" id="acm-phone" autocomplete="tel">' +
          '</div>' +
          '<div class="acm-field">' +
            '<label>Category <span class="acm-req">*</span></label>' +
            '<select id="acm-category" onchange="acmOnCategoryChange()" required>' +
              ADD_CLIENT_CATEGORIES.map(function(c) {
                return '<option value="' + escAttr(c) + '">' + escHtml(c) + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
        '</div>' +
        '<div class="acm-field" id="acm-wedding-row" style="display:none;">' +
          '<label>Wedding Date <span class="acm-req">*</span> <span class="acm-hint">(DD/MM/YYYY)</span></label>' +
          '<input type="text" id="acm-wedding-date" placeholder="e.g. 14/02/2027" maxlength="10">' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Lead Source</label>' +
          '<input type="text" id="acm-lead-source" placeholder="Instagram, Referral, etc.">' +
        '</div>' +

        // Optional partner-manager link (attribution only, not the managed-bride flow)
        '<div class="acm-field">' +
          '<label>Partner Manager <span class="acm-hint">(optional)</span></label>' +
          '<select id="acm-partner">' +
            '<option value="">None (direct client)</option>' +
          '</select>' +
        '</div>' +

        '<div id="acm-error" class="acm-error" style="display:none;"></div>' +
        '<div class="acm-actions">' +
          '<button type="button" class="btn btn-ghost" onclick="closeAddClientModal()">Cancel</button>' +
          '<button type="submit" class="btn btn-primary" id="acm-submit-btn">Add Client</button>' +
        '</div>' +
      '</form>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeAddClientModal(); });
  document.getElementById('acm-firstname').focus();
  acmLoadPartners();
  acmOnCategoryChange();
}

// 2026-08-11: tracks whether the partner list fetch below is still in flight.
// Lyndall Wennekes was created with NO partner link despite being intended as
// partner-managed: the <select> starts with only a hard-coded "None" option
// while bridge_admin_listPartners loads in the background (can take many
// seconds under the documented GAS cold-start floor), and nothing stopped
// submission during that window. The admin picked a name from a dropdown
// that had not populated yet, submitted, and the request silently carried an
// empty partnerEmail, exactly as if "None" had been chosen on purpose. No
// error anywhere. submitAddClient checks this flag before allowing submit.
var _acmPartnersLoading = false;

// Populate the optional Partner Manager dropdown from the existing partner list
// endpoint. Partner link is optional, so any failure leaves just the "None"
// option and never blocks the form.
//
// 2026-08-18 (BRIEF-partner-list-lookup-timeout-5-surfaces-2026-08-18.md,
// surface #3): this is the EXACT call site the Lyndall Wennekes incident
// happened on (_acmPartnersLoading below documents it) -- the admin picked a
// name from a dropdown that hadn't finished populating yet under the
// documented GAS cold-start floor, and the request silently carried an empty
// partnerEmail. The submit-blocking flag was a mitigation added afterward;
// this island-first paint is the actual fix for the underlying slowness that
// caused the race window to exist at all. On a warm cache the dropdown is
// populated before the admin can plausibly click into it.
// 2026-08-20: island read is now async (gzip-safe) -- see
// jvAdminPartnerList_getCached_'s own note. Callback fires with true/false
// (painted or not) instead of returning synchronously.
function acmPartnersFromShopIsland_(sel, cb) {
  jvAdminPartnerList_getCached_(function(partners) {
    if (!partners) { cb(false); return; }
    partners.forEach(function(p) {
      if (!p || !p.email) return;
      var name = (p.businessName || ((p.firstName || '') + ' ' + (p.lastName || '')).trim() || p.email);
      var label = p.role ? (name + ' (' + p.role + ')') : name;
      var opt = document.createElement('option');
      opt.value = p.email;
      opt.textContent = label;
      sel.appendChild(opt);
    });
    cb(true);
  });
}

function acmLoadPartners() {
  var sel = document.getElementById('acm-partner');
  if (!sel) return;
  _acmPartnersLoading = true;

  // Show the loading placeholder immediately (island read is now async, so
  // there is a brief window before either branch below resolves) -- the
  // Lyndall Wennekes incident this flag guards against was exactly an
  // unguarded window where the select looked ready but wasn't, so this
  // placeholder must be present from the very first paint, not just after
  // the island read comes back empty.
  var loading = document.createElement('option');
  loading.value = '';
  loading.disabled = true;
  loading.textContent = 'Loading partners...';
  sel.appendChild(loading);

  function clearLoading() {
    if (loading && loading.parentNode) loading.parentNode.removeChild(loading);
    _acmPartnersLoading = false;
  }

  acmPartnersFromShopIsland_(sel, function(paintedFromIsland) {
    if (paintedFromIsland) {
      // Island already painted real options; the live call below is a silent
      // background refresh, so the loading flag can clear immediately -- no
      // race window exists once real options are already in the DOM.
      clearLoading();
    }

    var call;
    try { call = jvBridge.callAdmin('bridge_admin_listPartners', {}); }
    catch (e) { clearLoading(); return; }
    if (!call || typeof call.then !== 'function') { clearLoading(); return; }

    call.then(function(res) {
      clearLoading();
      // If the island already painted, do NOT re-append the live result on top --
      // that would duplicate every option. The island is byte-identical data to
      // what this live call returns (same source route), so a silent live
      // success after an island paint has nothing new to add; only a genuinely
      // different (post-cache-warm) result would need a repaint, which is out
      // of scope for this fix -- this dropdown's selection has no equivalent
      // "already selected, don't reset" concern the invoice panel had, since a
      // fresh modal open always starts blank, but avoiding duplicate options is
      // still required correctness, not just a nicety.
      if (paintedFromIsland) return;
      var partners = (res && res.success && res.partners) ? res.partners : [];
      partners.forEach(function(p) {
        if (!p || !p.email) return;
        var name = (p.businessName || ((p.firstName || '') + ' ' + (p.lastName || '')).trim() || p.email);
        var label = p.role ? (name + ' (' + p.role + ')') : name;
        var opt = document.createElement('option');
        opt.value = p.email;
        opt.textContent = label;
        sel.appendChild(opt);
      });
    }).catch(function() {
      clearLoading();
    });
  });
}


function closeAddClientModal() {
  var el = document.getElementById('add-client-overlay');
  if (el) el.remove();
}

function acmSetType(type) {
  document.getElementById('acm-contact-type').value = type;
  document.getElementById('acm-type-individual').classList.toggle('active', type === 'Individual');
  document.getElementById('acm-type-business').classList.toggle('active', type === 'Business');
  document.getElementById('acm-business-section').style.display = type === 'Business' ? '' : 'none';
  // Auto-set category to Vendor when switching to Business
  if (type === 'Business') {
    var cat = document.getElementById('acm-category');
    if (cat && cat.value === 'Bridal') cat.value = 'Vendor';
  }
  acmOnCategoryChange();
}

function acmOnCategoryChange() {
  var cat = (document.getElementById('acm-category') || {}).value;
  var row = document.getElementById('acm-wedding-row');
  if (row) row.style.display = cat === 'Bridal' ? '' : 'none';
}

// The legacy Add Client write lands in the sheet first, while Admin Bride
// Profile v6 reads D1 only. Resolve the exact sheet row that was just created
// (or the exact duplicate on a safe retry), then mirror its stable identity to
// D1 before reporting the operation complete. This is deliberately loud on a
// mirror failure: a sheet-only success is not profile-ready.
function acmResolveClientForD1Mirror_(email, rowIndex) {
  function loadOne(id) {
    return jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_getClient',
      args: Number(id)
    }).then(function(r) {
      if (!r || !r.ok || !r.data) throw new Error((r && r.error) || 'Could not read the saved client row.');
      return r.data;
    });
  }

  if (rowIndex) return loadOne(rowIndex);

  return jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_getClients',
    args: { q: email, includeCompleted: true }
  }).then(function(r) {
    var rows = (r && r.ok && Array.isArray(r.data)) ? r.data : [];
    var wanted = String(email || '').trim().toLowerCase();
    var exact = rows.find(function(c) {
      return String((c && c.email) || '').trim().toLowerCase() === wanted;
    });
    if (!exact || !exact.id) throw new Error('Could not resolve the saved client by email.');
    return loadOne(exact.id);
  });
}

function acmMirrorClientToD1_(email, rowIndex) {
  return acmResolveClientForD1Mirror_(email, rowIndex).then(function(client) {
    var base = String(window._jvAdminProxyBase || '').replace(/\/+$/, '');
    if (!base) throw new Error('Cloudflare relay is not configured.');
    var nativeFetch = (typeof window._jvNativeFetch === 'function')
      ? window._jvNativeFetch.bind(window)
      : window.fetch.bind(window);
    var firstName = String(client['FIRST NAME'] || '').trim();
    var lastName = String(client['LAST NAME'] || '').trim();
    var stableUid = String(client.BRIDE_UID || client.brideUid || '').trim();
    if (!stableUid) throw new Error('Saved client has no stable bride UID.');
    return nativeFetch(base + '/partner/admin-booking/client', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      credentials: 'same-origin',
      body: JSON.stringify({
        name: (firstName + ' ' + lastName).trim(),
        email: String(client.email || client.EMAIL || email || '').trim().toLowerCase(),
        phone: String(client.phone || client.PHONE || '').trim(),
        wedding_date: client.weddingDate || null,
        category: String(client.category || client.CLIENT_CATEGORY || 'Bridal').trim(),
        brideUid: stableUid,
        actor: 'admin_crm_add_client_propagation'
      })
    }).then(function(resp) {
      return resp.json().catch(function() { return {}; }).then(function(body) {
        if (!resp.ok || !body.ok) throw new Error(body.error || ('Cloudflare mirror failed (' + resp.status + ').'));
        return body;
      });
    });
  });
}

function submitAddClient(e) {
  e.preventDefault();
  var firstName    = (document.getElementById('acm-firstname').value   || '').trim();
  var lastName     = (document.getElementById('acm-lastname').value    || '').trim();
  var email        = (document.getElementById('acm-email').value       || '').trim();
  var phone        = (document.getElementById('acm-phone').value       || '').trim();
  var category     = (document.getElementById('acm-category').value    || '').trim();
  var contactType  = (document.getElementById('acm-contact-type').value|| 'Individual').trim();
  var weddingDate  = (document.getElementById('acm-wedding-date').value || '').trim();
  var leadSource   = (document.getElementById('acm-lead-source').value || '').trim();
  var partnerEmail = ((document.getElementById('acm-partner') || {}).value || '').trim();
  var businessName = contactType === 'Business' ? (document.getElementById('acm-business-name').value || '').trim() : '';
  var abn          = contactType === 'Business' ? (document.getElementById('acm-abn').value || '').trim() : '';
  var website      = contactType === 'Business' ? (document.getElementById('acm-website').value || '').trim() : '';
  var instagram    = contactType === 'Business' ? (document.getElementById('acm-instagram').value || '').trim() : '';
  var facebook     = contactType === 'Business' ? (document.getElementById('acm-facebook').value || '').trim() : '';
  var tiktok       = contactType === 'Business' ? (document.getElementById('acm-tiktok').value || '').trim() : '';

  document.getElementById('acm-error').style.display = 'none';

  if (!firstName) { acmShowError('First name is required.'); return; }
  if (!lastName)  { acmShowError('Last name is required.');  return; }
  if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { acmShowError('A valid email is required.'); return; }
  if (contactType === 'Business' && !businessName) { acmShowError('Business name is required.'); return; }
  if (category === 'Bridal' && !weddingDate) { acmShowError('Wedding date is required for Bridal clients.'); return; }
  if (weddingDate && !/^\d{2}\/\d{2}\/\d{4}$/.test(weddingDate)) { acmShowError('Wedding date must be DD/MM/YYYY.'); return; }
  // 2026-08-11: the Partner Manager list can still be loading (a real, live GAS
  // call, not instant). Submitting before it resolves silently sends an empty
  // partnerEmail, identical to choosing "None" on purpose, no error, no
  // indication anything was skipped. Block submit instead and say why.
  if (_acmPartnersLoading) {
    acmShowError('Still loading the partner list, one more moment before adding.');
    return;
  }

  var btn = document.getElementById('acm-submit-btn');
  btn.disabled = true;
  btn.textContent = 'Adding…';

  var payload = { firstName: firstName, lastName: lastName, email: email, category: category, contactType: contactType };
  if (phone)        payload.phone        = phone;
  if (weddingDate)  payload.weddingDate  = weddingDate;
  if (leadSource)   payload.leadSource   = leadSource;
  if (partnerEmail) payload.partnerEmail = partnerEmail;
  if (businessName) payload.businessName = businessName;
  if (abn)          payload.abn          = abn;
  if (website)      payload.website      = website;
  if (instagram || facebook || tiktok) {
    payload.socialLinks = {};
    if (instagram) payload.socialLinks.instagram = instagram;
    if (facebook)  payload.socialLinks.facebook  = facebook;
    if (tiktok)    payload.socialLinks.tiktok    = tiktok;
  }

  jvBridge.callAdmin('bridge_admin_createClient', payload)
    .then(function(res) {
      var canMirror = res && (res.ok || res.error === 'duplicate');
      if (!canMirror) return res;
      return acmMirrorClientToD1_(email, res.rowIndex).then(function(mirror) {
        res._d1Mirrored = true;
        res._d1Mirror = mirror;
        return res;
      });
    })
    .then(function(res) {
      if (res && (res.ok || res._d1Mirrored)) {
        closeAddClientModal();
        var name = businessName || (firstName + ' ' + lastName);
        // 2026-08-19 (write-path-timeouts-local-first): the CRM row now saves
        // instantly and the Shopify/Xero linking happens in the background
        // (deferred) rather than on this request, so there is no xeroContactId
        // to report yet, say so plainly instead of implying it already synced.
        var extra = res.deferred ? ' - linking to Shopify/Xero in the background' : (res.xeroContactId ? ' - synced to Xero' : '');
        var wasDuplicate = res.error === 'duplicate';
        jvToast(wasDuplicate
          ? (name + ' already existed. Bride Profile identity is now synced.')
          : (name + ' added successfully.' + extra), 'success');
        // STALE-DROPDOWN FIX (2026-09-28, DISCOVERY-invoice-new-bride-dropdown-stale):
        // STATE.clients is lazy-loaded once per page session by invoiceClientSearch /
        // loadInvoicingView (they only fetch when the in-memory list is empty) and was
        // never invalidated on a successful create, so a brand-new client/bride stayed
        // invisible to the invoice bride-picker for the rest of the browser session,
        // however long that was, until a full page reload. Clearing it here (not just
        // when the Clients tab happens to be open) makes the next read of either
        // surface re-fetch fresh. Paired with the server-side CLIENTS_ALL_v2 cache
        // fix in adminCrm_createClient_ (AdminCRMAPI.gs) so the re-fetch itself is not
        // also serving stale data.
        STATE.clients = null;
        if (document.getElementById('view-clients').classList.contains('active')) {
          loadClientsView(true);   // just added a client: force a live refresh
        }
        // 2026-08-11: partner-managed brides created via THIS modal (Path A) get NO
        // onboarding comms at all, unlike the EBM-email path (Path B), which fires a
        // full welcome sequence automatically. Nothing in the UI signalled this gap.
        // Lyndall Wennekes was the live example: created here, no comms, no
        // indication anything was missing. Follow-up prompt, explicit and never
        // automatic, offering to send now. Only for partner-managed creates
        // (partnerEmail was set on this submission), a direct client sees nothing.
        if (partnerEmail && res.rowIndex) {
          acmOfferPartnerWelcome_(res.rowIndex, name);
        }
      } else {
        var msg = (res && res.error) || 'Failed to add client.';
        if (res && res.error === 'duplicate') {
          msg = 'A client with this email already exists' + (res.existingName ? ' (' + res.existingName + ')' : '') + '.';
        }
        acmShowError(msg);
        btn.disabled = false;
        btn.textContent = 'Add Client';
      }
    })
    .catch(function(err) {
      // 2026-08-11: a relay timeout is NOT proof the create failed, only that the
      // relay's 30s cap gave up waiting on GAS before GAS itself returned. The
      // documented cold-start floor is 7-10s per request, and adminCrm_createClient
      // does a Shopify customer create + Xero contact upsert on top of the CRM
      // write, so it can genuinely take longer than 30s while still succeeding.
      // Telling the admin this "failed" trains exactly the wrong instinct (retry a
      // write that may have worked); adminCrm_createClient's own duplicate-email
      // guard means a retry cannot create a second row, so the honest message is
      // "unknown, go check" rather than "failed, try again".
      var errText = String((err && err.message) || err || '');
      var isTimeout = /timed out|timeout/i.test(errText);
      if (isTimeout) {
        acmShowError('This is taking longer than usual. The save may have already completed, ' +
          'search for ' + (firstName || 'the client') + ' ' + (lastName || '') +
          ' in All Clients before adding again.');
      } else {
        acmShowError('Error: ' + errText);
      }
      btn.disabled = false;
      btn.textContent = 'Add Client';
    });
}

function acmShowError(msg) {
  var el = document.getElementById('acm-error');
  if (!el) return;
  el.textContent = msg;
  el.style.display = 'block';
}

/* ============================================================
   ADD TEAM MEMBER (2026-09-25, transport fixed 2026-09-29)
   Calls the Cloudflare relay entity 'admin-create-team-member'
   (actions 'create'/'list') directly on jv-next-pilot, bypassing GAS
   entirely -- same shape as adminD1SearchBrides_ above (captured
   native fetch, text/plain, JSON body, window._jvAdminProxyBase).
   Flag-gated OFF server-side (JV_TEAM_MEMBER_CREATE_ENABLED /
   JV_TEAM_MEMBER_LIST_ENABLED) -- ships dark, no live-behaviour risk
   until the backend flags flip. See
   state/findings/HANDOFF-add-team-member-ui-diff-to-admin-crm-2026-09-25.md
   and state/findings/HANDOFF-team-roster-tab-backend-to-admin-crm-2026-09-29.md
   for the full request/response contract. Modelled on
   openAddClientModal/submitAddClient above -- reuses the shared
   add-client-overlay/add-client-modal/.acm-* chrome classes (pure
   structural/visual, already reused across two other modals, no JS/state
   binding), fresh atm-* ids to keep this form's own state isolated.

   BUG FIXED 2026-09-29: submitAddTeamMember previously called
   jvBridge.callAdmin('bridge_admin_createTeamMember', payload) -- a GAS
   admin-bridge route name that does not exist anywhere in the live GAS
   CRM project (grepped, zero matches), so the call would have failed
   every time it was ever reachable. It was also the wrong transport
   regardless: this feature is Cloudflare + Shopify only, no GAS, per
   BRIEFS/STARTPROMPT-admin-crm-team-roster-tab-ui-2026-09-29.md. Fixed
   to call adminTeamMemberRelayCall_('create', payload) below instead.
   ============================================================ */
var TEAM_MEMBER_ROLES = ['lead', 'support'];

/**
 * Direct relay call to the 'admin-create-team-member' proxy entity.
 * action = 'create' | 'list'. Returns a Promise resolving to
 * { ok, data, error } -- never rejects, so callers can treat every
 * outcome (success, partial/207, network error) uniformly.
 */
function adminTeamMemberRelayCall_(action, payload) {
  var base = window._jvAdminProxyBase;
  if (!base) return Promise.resolve({ ok: false, error: { message: 'Admin session unavailable.' } });
  var url = String(base).replace(/\/+$/, '') + '/partner/admin-create-team-member/' + action;
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  return nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(payload || {})
  })
    .then(function (r) {
      return r.json().then(function (body) {
        // A 207 (partial success) is still in fetch's r.ok 2xx range, but the
        // envelope's own top-level `ok` reflects "every step succeeded" --
        // treat body.ok===false as a failure while still passing body.data
        // through, so a partial-success teamMemberId is never lost.
        if (!r.ok || !body || body.ok === false) {
          var msg = (body && body.error && (body.error.message || body.error)) || ('http_' + r.status);
          return { ok: false, error: { message: String(msg) }, data: body && body.data };
        }
        return { ok: true, data: body.data };
      });
    })
    .catch(function (err) {
      return { ok: false, error: { message: 'network_error: ' + String((err && err.message) || err) } };
    });
}

function openAddTeamMemberModal() {
  if (document.getElementById('add-team-member-overlay')) return;
  var overlay = document.createElement('div');
  overlay.className = 'add-client-overlay';
  overlay.id = 'add-team-member-overlay';
  overlay.innerHTML =
    '<div class="add-client-modal" role="dialog" aria-label="Add team member">' +
      '<div class="acm-header">' +
        '<h3>Add Team Member</h3>' +
        '<button type="button" class="acm-close" onclick="closeAddTeamMemberModal()" aria-label="Close">&times;</button>' +
      '</div>' +
      '<form id="add-team-member-form" onsubmit="submitAddTeamMember(event)" novalidate>' +
        '<div class="acm-row">' +
          '<div class="acm-field">' +
            '<label>Full Name <span class="acm-req">*</span></label>' +
            '<input type="text" id="atm-displayname" autocomplete="name" required>' +
          '</div>' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Email <span class="acm-req">*</span></label>' +
          '<input type="email" id="atm-email" autocomplete="email" required>' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Role <span class="acm-req">*</span></label>' +
          '<select id="atm-role" onchange="atmOnRoleChange()" required>' +
            '<option value="lead">Lead Artist</option>' +
            '<option value="support">Support Artist</option>' +
          '</select>' +
        '</div>' +
        '<div class="acm-section-label">Skills</div>' +
        '<div class="acm-row">' +
          '<label class="acm-skill-label"><input type="checkbox" id="atm-canlead" disabled> Can lead a wedding <span class="acm-hint">(set by role)</span></label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="atm-canhair"> Hair</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="atm-canmakeup"> Makeup</label>' +
        '</div>' +
        '<div class="acm-row">' +
          '<div class="acm-field">' +
            '<label>Suburb <span class="acm-hint">(optional)</span></label>' +
            '<input type="text" id="atm-suburb">' +
          '</div>' +
          '<div class="acm-field">' +
            '<label>Home/studio address <span class="acm-hint">(optional, feeds travel fees)</span></label>' +
            '<input type="text" id="atm-location">' +
          '</div>' +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Bio <span class="acm-hint">(optional)</span></label>' +
          '<textarea id="atm-bio" rows="2"></textarea>' +
        '</div>' +
        '<div id="atm-error" class="acm-error" style="display:none;"></div>' +
        '<div class="acm-actions">' +
          '<button type="button" class="btn btn-ghost" onclick="closeAddTeamMemberModal()">Cancel</button>' +
          '<button type="submit" class="btn btn-primary" id="atm-submit-btn">Add Team Member</button>' +
        '</div>' +
      '</form>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeAddTeamMemberModal(); });
  document.getElementById('atm-displayname').focus();
  atmOnRoleChange();
}

function atmOnRoleChange() {
  var role = document.getElementById('atm-role').value;
  var canLeadBox = document.getElementById('atm-canlead');
  // Role is authoritative (2026-10-06 QA bug: the box stayed ticked after
  // switching to Support, saving her as Lead). The box mirrors the role and
  // is locked; the backend (effectiveCanLead) enforces the same rule.
  if (canLeadBox) canLeadBox.checked = role === 'lead';
}

function closeAddTeamMemberModal() {
  var overlay = document.getElementById('add-team-member-overlay');
  if (overlay) overlay.remove();
}

function atmShowError(msg) {
  var el = document.getElementById('atm-error');
  if (!el) return;
  el.textContent = msg;
  el.style.display = 'block';
}

function submitAddTeamMember(e) {
  e.preventDefault();
  var displayName = (document.getElementById('atm-displayname').value || '').trim();
  var email = (document.getElementById('atm-email').value || '').trim();
  var role = (document.getElementById('atm-role').value || 'support').trim();
  var canLead = document.getElementById('atm-canlead').checked;
  var canHair = document.getElementById('atm-canhair').checked;
  var canMakeup = document.getElementById('atm-canmakeup').checked;
  var suburb = (document.getElementById('atm-suburb').value || '').trim();
  var artistLocation = (document.getElementById('atm-location').value || '').trim();
  var bio = (document.getElementById('atm-bio').value || '').trim();

  document.getElementById('atm-error').style.display = 'none';

  if (!displayName) { atmShowError('Full name is required.'); return; }
  if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { atmShowError('A valid email is required.'); return; }
  if (TEAM_MEMBER_ROLES.indexOf(role) === -1) { atmShowError('Pick a role.'); return; }

  var btn = document.getElementById('atm-submit-btn');
  btn.disabled = true;
  btn.textContent = 'Adding…';

  var payload = { tenantId: 'jessica-vegas', displayName: displayName, email: email, role: role, canLead: canLead, canHair: canHair, canMakeup: canMakeup };
  if (suburb) payload.suburb = suburb;
  if (artistLocation) payload.artistLocation = artistLocation;
  if (bio) payload.bio = bio;

  adminTeamMemberRelayCall_('create', payload)
    .then(function(res) {
      var data = (res && res.data) || {};
      if (res && res.ok && data.ok) {
        closeAddTeamMemberModal();
        // BUG FIX 2026-09-29 (live-tested by Cowork -- state/findings/
        // RESULTS-admin-crm-team-roster-e2e-LATEST-findings-2026-09-29.md /
        // BRIEFS/RESULTS-admin-crm-team-roster-e2e-LATEST-findings-2026-09-29.md):
        // a real artist (Tara, admin@solunarstudios.au) was created -- D1
        // confirmed her row genuinely landed -- but never appeared in the
        // roster, even after clicking Refresh, because this handler closed
        // the modal and showed a toast without EVER calling
        // loadTeamRosterView(). Refresh worked in isolation (it calls the
        // same function); the create flow itself just never triggered a
        // reload, so the admin was looking at the pre-create list the whole
        // time. Reload unconditionally on any outcome where a row is known
        // to exist (both branches below), matching this route's own "don't
        // let 207 silently mean nothing happened" discipline already
        // applied to the toast message -- it was never applied to the data
        // reload.
        loadTeamRosterView();
        jvToast(displayName + ' added to the team. A welcome email has been sent.', 'success');
      } else {
        // Partial success (207): the artist likely EXISTS now (teamMemberId
        // set) even though not every mirror step landed -- say so rather
        // than implying nothing happened, matching submitAddClient's own
        // "don't train the wrong retry instinct" discipline. Uses the
        // 'info' toast variant, not 'warning' -- .jv-toast.warning has no
        // CSS background defined (only success/error/info do), so a
        // warning toast would render invisible. Found and fixed during
        // review, not assumed from the draft.
        var failedSteps = (data.steps || []).filter(function(s) { return !s.ok; }).map(function(s) { return s.step; });
        if (data.teamMemberId && failedSteps.length) {
          closeAddTeamMemberModal();
          loadTeamRosterView(); // see the BUG FIX comment above -- same missing-reload bug, this branch too
          jvToast(displayName + ' was added, but ' + failedSteps.join(', ') + ' needs attention (will self-heal, or re-run Add Team Member with the same email to retry).', 'info');
        } else {
          var msg = (res && res.error && res.error.message) || (data.steps && data.steps[0] && data.steps[0].error) || 'Failed to add team member.';
          atmShowError(msg);
          btn.disabled = false;
          btn.textContent = 'Add Team Member';
        }
      }
    })
    .catch(function(err) {
      var errText = String((err && err.message) || err || '');
      var isTimeout = /timed out|timeout/i.test(errText);
      if (isTimeout) {
        atmShowError('This is taking longer than usual. Re-running Add Team Member with the SAME email is safe (it updates rather than duplicates) -- check the team roster before assuming it failed.');
      } else {
        atmShowError('Error: ' + errText);
      }
      btn.disabled = false;
      btn.textContent = 'Add Team Member';
    });
}

/* ============================================================
   TEAM / ROSTER TAB (2026-09-29)
   Lists every current artist. Reads GET-shaped (query params only,
   POSTed as a relay body per the shared text/plain-body convention,
   no side effects) from the SAME relay entity the Add Team Member
   modal above writes to: 'admin-create-team-member' action 'list'.
   D1-direct on jv-next-pilot, no GAS -- see
   state/findings/HANDOFF-team-roster-tab-backend-to-admin-crm-2026-09-29.md
   for the full response contract. Cloudflare-first per CLAUDE.md's
   2026-09-19 escalation; zero GAS added for this tab.
   ============================================================ */
var _teamRosterRaw = []; // unfiltered members[] from the last successful load

function loadTeamRosterView() {
  showLoader('team');
  adminTeamMemberRelayCall_('list', { tenantId: 'jessica-vegas' })
    .then(function (res) {
      if (!res || !res.ok || !res.data || !Array.isArray(res.data.members)) {
        var msg = (res && res.error && res.error.message) || 'Could not load the team roster.';
        showError('team', msg);
        return;
      }
      _teamRosterRaw = res.data.members;
      filterTeamRosterView();
      showContent('team');
      _teamRosterRefreshOnboardingOnce_();
    })
    .catch(function () {
      showError('team', 'Could not load the team roster.');
    });
}

// Pulls each in-progress artist's onboarding state into D1 (the GAS wizard
// never writes D1 itself), then re-lists only if something changed. Once per
// page load; silent on any failure (flag off, network) so the roster never
// breaks because of it.
var _teamRosterOnboardingRefreshed_ = false;
function _teamRosterRefreshOnboardingOnce_() {
  if (_teamRosterOnboardingRefreshed_) return;
  _teamRosterOnboardingRefreshed_ = true;
  adminTeamMemberRelayCall_('onboarding-refresh', { tenantId: 'jessica-vegas' }).then(function (res) {
    if (res && res.ok && res.data && res.data.changed > 0) loadTeamRosterView();
  }).catch(function () {});
}

function filterTeamRosterView() {
  var q = ((document.getElementById('team-search') || {}).value || '').trim().toLowerCase();
  var roleF = (document.getElementById('team-role') || {}).value || '';
  var statusF = (document.getElementById('team-status') || {}).value || '';

  var rows = _teamRosterRaw.filter(function (m) {
    if (roleF && m.role !== roleF) return false;
    if (statusF === 'active' && !m.active) return false;
    if (statusF === 'inactive' && m.active) return false;
    if (q) {
      var hay = (String(m.displayName || '') + ' ' + String(m.email || '')).toLowerCase();
      if (hay.indexOf(q) === -1) return false;
    }
    return true;
  });

  renderTeamRosterList_(rows);
}

var TEAM_ROSTER_SKILL_LABELS_ = {
  hairBasic: 'Hair (basic)',
  hairAdvanced: 'Hair (advanced)',
  hollywoodWaves: 'Hollywood Waves',
  makeup: 'Makeup',
  flowergirl: 'Flowergirl',
  brideFullHmu: 'Bride full HMU',
  assisting: 'Assisting'
};

// BUG FIX 2026-09-29 (live-tested, findings file: RESULTS-admin-crm-team-
// roster-e2e-LATEST-findings-2026-09-29.md item 3): this block's dash
// fallbacks were built as the literal HTML-entity strings '&mdash;'/
// '&ndash;', then piped through escHtml(), which escapes the leading '&' to
// '&amp;' -- so the browser rendered the literal text "&mdash;"/"&ndash;"
// on screen instead of a dash glyph. These are static, non-user-supplied
// literals (no XSS surface), so the fix is to stop routing them through
// escHtml -- returned/inlined raw, the entity resolves to a real dash.
function _teamRosterSkillChips_(skills) {
  if (!skills) return '&mdash;';
  var chips = Object.keys(TEAM_ROSTER_SKILL_LABELS_)
    .filter(function (k) { return !!skills[k]; })
    .map(function (k) { return '<span class="inv-status-chip draft">' + escHtml(TEAM_ROSTER_SKILL_LABELS_[k]) + '</span>'; });
  return chips.length ? chips.join(' ') : '<span style="color:var(--text-light);">None set</span>';
}

// Hours are rendered as opaque text, not parsed as a strict 24-hour time --
// live data has at least one row stored 12-hour ("5:00 AM") per the backend's
// own handoff note. Never reformat/parse this field.
function _teamRosterHoursText_(m) {
  var start = m.earliestStart, finish = m.latestFinish;
  if (!start && !finish) return '&mdash;';
  return escHtml(start || '?') + ' &ndash; ' + escHtml(finish || '?');
}

// Engagement type / lifecycle status / WWCC / PLI / contract / service-rates
// chips (2026-09-30, team-staff-mgmt piece 4, full doc section 7.1).
// CORRECTED 2026-10-12 (state/findings/FINDING-admin-crm-stale-team-roster-
// comment-2026-10-02.md): this comment previously claimed POST
// /admin/team-members/list did not select/return engagement_type/
// lifecycle_status/welcome_email_status/etc. -- confirmed by direct read of
// teamMemberListHttp.ts + teamMemberRepo.ts (TEAM_MEMBER_LIST_COLUMNS) that
// this is no longer true: the list route has returned these camelCased since
// the 2026-09-30 extension. The roster table + the Profile tab below now
// read `m.engagementType`/`m.lifecycleStatus`/etc. directly as real data.
// WWCC/PLI are the one part of the old claim still genuinely true: no
// backend read route exists for those two fields at all, so their chips
// still correctly fall through to the "not synced yet" unknownLabel branch.
function _teamRosterChip_(value, trueLabel, falseLabel, unknownLabel) {
  if (value === true) return '<span class="inv-status-chip paid">' + escHtml(trueLabel) + '</span>';
  if (value === false) return '<span class="inv-status-chip void">' + escHtml(falseLabel) + '</span>';
  return '<span class="inv-status-chip draft" title="Not read from the backend yet">' + escHtml(unknownLabel) + '</span>';
}

var TEAM_ENGAGEMENT_LABELS_ = { subcontractor: 'Subcontractor', employee: 'Employee' };
var TEAM_LIFECYCLE_LABELS_ = {
  invited: 'Invited', onboarding: 'Onboarding', compliance_pending: 'Compliance pending',
  contract_pending: 'Contract pending', active: 'Active', deactivated: 'Deactivated'
};

/* Contract column (2026-10-06, Team Portal Identity). Derived from the
   lifecycle the onboarding/refresh route keeps in step: invited = still
   onboarding (shows n/9 steps). Countersign is optional paperwork (Jess,
   2026-10-06), so it never shows as a blocker here; contract_pending only
   appears if countersign is ever made a gate again. */
function _teamRosterContractChip_(m) {
  var st = m.lifecycleStatus;
  var steps = Number(m.onboardingStep);
  if (st === 'contract_pending') return '<span class="inv-status-chip draft">Needs countersign</span>';
  if (st === 'invited' || st === 'onboarding') {
    return '<span class="inv-status-chip draft">Onboarding' + (isFinite(steps) && steps > 0 ? ' ' + steps + '/9' : '') + '</span>';
  }
  return '&mdash;';
}

// "Service rates" column. Was a hardcoded "None" for every artist (the piece-5
// placeholder). Now reads compensationLineCount from the roster list: how many
// current service rates she has in the v2 table. null/absent = unknown (the
// Compensation flag is off or the count failed) -> an honest dash, not "None".
function _teamRosterRatesChip_(m) {
  var n = m.compensationLineCount;
  if (n === null || n === undefined || isNaN(Number(n))) return '&mdash;';
  n = Number(n);
  if (n > 0) return '<span class="inv-status-chip paid">' + n + ' set</span>';
  return '<span class="inv-status-chip draft">None</span>';
}

function renderTeamRosterList_(rows) {
  var wrap = document.getElementById('team-list-wrap');
  var countEl = document.getElementById('team-count');
  if (!wrap) return;

  if (countEl) countEl.textContent = rows.length + ' team member' + (rows.length === 1 ? '' : 's');

  if (!rows.length) {
    wrap.innerHTML = '<div class="empty-state"><p>No team members match these filters.</p></div>';
    return;
  }

  var roleLabel = { lead: 'Lead Artist', support: 'Support Artist' };

  var html = '<div class="card-panel" style="padding:0;">' +
    '<table class="data-table"><thead><tr>' +
    '<th>Name</th><th>Role</th><th>Engagement</th><th>Status</th><th>WWCC</th><th>PLI</th>' +
    '<th>Contract</th><th>Service rates</th><th></th>' +
    '</tr></thead><tbody>';

  rows.forEach(function (m) {
    // lifecycleStatus not yet returned by the list route -- fall back to the
    // active boolean this page has always had, so Status never goes blank.
    var lifecycleChip = m.lifecycleStatus
      ? '<span class="inv-status-chip ' + (m.lifecycleStatus === 'active' ? 'paid' : (m.lifecycleStatus === 'deactivated' ? 'void' : 'draft')) + '">' +
          escHtml(TEAM_LIFECYCLE_LABELS_[m.lifecycleStatus] || m.lifecycleStatus) + '</span>'
      : (m.active
          ? '<span class="inv-status-chip paid">Active</span>'
          : '<span class="inv-status-chip void">Deactivated</span>');
    var engagementLabel = m.engagementType ? (TEAM_ENGAGEMENT_LABELS_[m.engagementType] || m.engagementType) : '&mdash;';
    var toggleLabel = m.active ? 'Deactivate' : 'Reactivate';

    html += '<tr>' +
      '<td style="cursor:pointer;" onclick="openTeamMemberDrawer(' + Number(m.teamMemberId) + ')">' +
        '<span style="color:var(--brand-primary);font-weight:600;">' + (m.displayName ? escHtml(m.displayName) : '&mdash;') + '</span>' +
        '<div style="font-size:0.72rem;color:var(--text-light);">' + escHtml(m.email || '') + '</div>' +
      '</td>' +
      '<td>' + (roleLabel[m.role] || m.role ? escHtml(roleLabel[m.role] || m.role) : '&mdash;') + '</td>' +
      '<td>' + (engagementLabel === '&mdash;' ? engagementLabel : escHtml(engagementLabel)) + '</td>' +
      '<td>' + lifecycleChip + '</td>' +
      '<td>' + _teamRosterChip_(m.wwccValid, 'Valid', 'Expired/missing', 'Not synced yet') + '</td>' +
      '<td>' + _teamRosterChip_(m.pliValid, 'Valid', 'Expired/missing', 'Not synced yet') + '</td>' +
      // Contract/rates chips are DELIBERATELY always the honest "not built
      // yet" state right now -- piece 5 (rates) and 6.7 (contracts) are not
      // built, per this piece's own scope note. Never fake a count here.
      '<td>' + _teamRosterContractChip_(m) + '</td>' +
      '<td>' + _teamRosterRatesChip_(m) + '</td>' +
      '<td style="white-space:nowrap;">' +
        '<button type="button" class="btn btn-ghost" style="font-size:0.72rem;padding:0.3rem 0.6rem;" onclick="openTeamMemberDrawer(' + Number(m.teamMemberId) + ')" title="View/edit ' + escAttr(m.displayName || '') + '">View</button> ' +
        '<button type="button" class="btn btn-ghost" style="font-size:0.72rem;padding:0.3rem 0.6rem;" onclick="teamMemberToggleActive_(' + Number(m.teamMemberId) + ', ' + (!m.active) + ')">' + toggleLabel + '</button>' +
      '</td>' +
    '</tr>';
  });

  html += '</tbody></table></div>';
  wrap.innerHTML = html;
}

/* ============================================================
   EDIT / DEACTIVATE TEAM MEMBER (2026-09-29, CRUD completion)
   Per BRIEFS/BUILD-team-roster-crud-complete-2026-09-29.md +
   state/findings/HANDOFF-team-roster-update-route-to-admin-crm-2026-09-29.md.
   Calls the new relay action 'update' (POST /admin/team-members/update once
   the relay wiring + flag land -- ships dark until then, same pattern the
   create/list routes used). Reuses the SAME modal chrome + field set as
   openAddTeamMemberModal, pre-filled from the row already in _teamRosterRaw
   (no extra GAS/relay read needed to open the form). "Delete" for this
   entity is soft (active:false) via teamMemberToggleActive_ below, per the
   build brief's own recommendation -- there is no hard-delete route.
   ============================================================ */
function _teamRosterFindMember_(teamMemberId) {
  for (var i = 0; i < _teamRosterRaw.length; i++) {
    if (Number(_teamRosterRaw[i].teamMemberId) === Number(teamMemberId)) return _teamRosterRaw[i];
  }
  return null;
}

// The Worker (teamMemberRepo.emailChangeBlocker) only accepts an email change
// while she is still `invited` with no onboarding progress; every other state
// is refused with a readable reason. Mirror that here so the field is only
// editable when it can work, but the Worker stays the authority: anything it
// refuses is shown to the admin verbatim.
function _etmEmailEditable_(m) {
  var life = m.lifecycleStatus || 'invited';
  var step = Number(m.onboardingStep || 0);
  return life === 'invited' && !(isFinite(step) && step > 0);
}

function openEditTeamMemberModal(teamMemberId) {
  if (document.getElementById('edit-team-member-overlay')) return;
  var m = _teamRosterFindMember_(teamMemberId);
  if (!m) { jvToast('Could not find that team member -- try refreshing the list.', 'error'); return; }

  var overlay = document.createElement('div');
  overlay.className = 'add-client-overlay';
  overlay.id = 'edit-team-member-overlay';
  var skills = m.skills || {};
  overlay.innerHTML =
    '<div class="add-client-modal" role="dialog" aria-label="Edit team member">' +
      '<div class="acm-header">' +
        '<h3>Edit Team Member</h3>' +
        '<button type="button" class="acm-close" onclick="closeEditTeamMemberModal()" aria-label="Close">&times;</button>' +
      '</div>' +
      '<form id="edit-team-member-form" onsubmit="submitEditTeamMember(event)" novalidate>' +
        '<input type="hidden" id="etm-id" value="' + escAttr(String(m.teamMemberId)) + '">' +
        '<div class="acm-field">' +
          '<label>Full Name <span class="acm-req">*</span></label>' +
          '<input type="text" id="etm-displayname" autocomplete="name" required value="' + escAttr(m.displayName || '') + '">' +
        '</div>' +
        '<div class="acm-field">' +
          (_etmEmailEditable_(m)
            ? '<label>Email <span class="acm-hint">(editable until she starts onboarding; use it to fix a mistyped invite)</span></label>' +
              '<input type="email" id="etm-email" autocomplete="off" value="' + escAttr(m.email || '') + '">'
            : '<label>Email <span class="acm-hint">(locked once onboarding has started)</span></label>' +
              '<input type="email" value="' + escAttr(m.email || '') + '" disabled>') +
        '</div>' +
        '<div class="acm-field">' +
          '<label>Role <span class="acm-req">*</span></label>' +
          '<select id="etm-role" required>' +
            '<option value="lead"' + (m.role === 'lead' ? ' selected' : '') + '>Lead Artist</option>' +
            '<option value="support"' + (m.role === 'support' ? ' selected' : '') + '>Support Artist</option>' +
          '</select>' +
        '</div>' +
        '<div class="acm-section-label">Skills</div>' +
        '<div class="acm-row">' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-hairbasic"' + (skills.hairBasic ? ' checked' : '') + '> Hair (basic)</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-hairadvanced"' + (skills.hairAdvanced ? ' checked' : '') + '> Hair (advanced)</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-hollywoodwaves"' + (skills.hollywoodWaves ? ' checked' : '') + '> Hollywood Waves</label>' +
        '</div>' +
        '<div class="acm-row">' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-makeup"' + (skills.makeup ? ' checked' : '') + '> Makeup</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-flowergirl"' + (skills.flowergirl ? ' checked' : '') + '> Flowergirl</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-bridefullhmu"' + (skills.brideFullHmu ? ' checked' : '') + '> Bride full HMU</label>' +
          '<label class="acm-skill-label"><input type="checkbox" id="etm-assisting"' + (skills.assisting ? ' checked' : '') + '> Assisting</label>' +
        '</div>' +
        '<div class="acm-row">' +
          '<div class="acm-field">' +
            '<label>Home/studio address <span class="acm-hint">(optional, feeds travel fees)</span></label>' +
            '<input type="text" id="etm-homeaddress" value="' + escAttr(m.homeAddress || '') + '">' +
          '</div>' +
          '<div class="acm-field">' +
            '<label>Seniority <span class="acm-hint">(optional)</span></label>' +
            '<input type="number" id="etm-seniority" value="' + escAttr(m.seniority != null ? String(m.seniority) : '') + '">' +
          '</div>' +
        '</div>' +
        '<div id="etm-error" class="acm-error" style="display:none;"></div>' +
        '<div class="acm-actions">' +
          '<button type="button" class="btn btn-ghost" onclick="closeEditTeamMemberModal()">Cancel</button>' +
          '<button type="submit" class="btn btn-primary" id="etm-submit-btn">Save Changes</button>' +
        '</div>' +
      '</form>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeEditTeamMemberModal(); });
  document.getElementById('etm-displayname').focus();
}

function closeEditTeamMemberModal() {
  var overlay = document.getElementById('edit-team-member-overlay');
  if (overlay) overlay.remove();
}

function etmShowError_(msg) {
  var el = document.getElementById('etm-error');
  if (!el) return;
  el.textContent = msg;
  el.style.display = 'block';
}

function submitEditTeamMember(e) {
  e.preventDefault();
  var teamMemberId = Number(document.getElementById('etm-id').value);
  var displayName = (document.getElementById('etm-displayname').value || '').trim();
  var role = (document.getElementById('etm-role').value || '').trim();

  document.getElementById('etm-error').style.display = 'none';
  if (!displayName) { etmShowError_('Full name is required.'); return; }
  if (TEAM_MEMBER_ROLES.indexOf(role) === -1) { etmShowError_('Pick a role.'); return; }

  var payload = {
    tenantId: 'jessica-vegas',
    teamMemberId: teamMemberId,
    displayName: displayName,
    role: role,
    skillHairBasic: document.getElementById('etm-hairbasic').checked,
    skillHairAdvanced: document.getElementById('etm-hairadvanced').checked,
    skillHollywoodWaves: document.getElementById('etm-hollywoodwaves').checked,
    skillMakeup: document.getElementById('etm-makeup').checked,
    skillFlowergirl: document.getElementById('etm-flowergirl').checked,
    skillBrideFullHmu: document.getElementById('etm-bridefullhmu').checked,
    skillAssisting: document.getElementById('etm-assisting').checked
  };
  // Email only when the field exists (invited members) AND it was actually
  // changed, so an untouched save never sends an email the Worker would have
  // to re-validate.
  var emailEl = document.getElementById('etm-email');
  if (emailEl) {
    var newEmail = String(emailEl.value || '').trim().toLowerCase();
    var cur = _teamRosterFindMember_(teamMemberId);
    var oldEmail = String((cur && cur.email) || '').trim().toLowerCase();
    if (!newEmail) { etmShowError_('Email is required.'); return; }
    if (newEmail !== oldEmail) payload.email = newEmail;
  }
  var homeAddress = (document.getElementById('etm-homeaddress').value || '').trim();
  var seniorityRaw = document.getElementById('etm-seniority').value;
  if (homeAddress) payload.homeAddress = homeAddress;
  if (seniorityRaw !== '') payload.seniority = Number(seniorityRaw);

  var btn = document.getElementById('etm-submit-btn');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  adminTeamMemberRelayCall_('update', payload)
    .then(function (res) {
      // Same 207-vs-200 contract as submitAddTeamMember above -- data.ok
      // reflects EVERY step, not just HTTP status. See
      // state/findings/RESULTS-admin-create-team-member-404-and-207-2026-09-29.md
      // for why treating any non-error HTTP status as success is the bug
      // this pattern exists to avoid.
      var data = (res && res.data) || {};
      if (res && res.ok && data.ok && data.row) {
        _teamRosterApplyUpdatedRow_(data.row);
        closeEditTeamMemberModal();
        jvToast(displayName + ' updated.', 'success');
      } else if (data.row) {
        // D1 step (the load-bearing one) succeeded but a best-effort step
        // (the Shopify role-tag swap) failed -- the edit itself is real,
        // say so rather than implying nothing happened.
        _teamRosterApplyUpdatedRow_(data.row);
        closeEditTeamMemberModal();
        jvToast(displayName + ' was updated, but a follow-up step needs attention (safe to re-save).', 'info');
      } else {
        var msg = (res && res.error && res.error.message) ||
          (data.steps && data.steps[0] && data.steps[0].error) || 'Failed to update team member.';
        etmShowError_(msg);
        btn.disabled = false;
        btn.textContent = 'Save Changes';
      }
    })
    .catch(function (err) {
      etmShowError_('Error: ' + String((err && err.message) || err || ''));
      btn.disabled = false;
      btn.textContent = 'Save Changes';
    });
}

// Merges the update route's raw D1 row shape (snake_case, 0|1 booleans --
// see the route's own contract doc) into the list's camelCase shape already
// held in _teamRosterRaw, then repaints from local state -- no full list
// reload, matching this codebase's optimistic/local-first doctrine.
function _teamRosterApplyUpdatedRow_(row) {
  var existing = _teamRosterFindMember_(row.id);
  if (!existing) { loadTeamRosterView(); return; }
  existing.displayName = row.display_name;
  if (row.email) existing.email = row.email;
  existing.active = row.active === 1;
  existing.role = row.can_lead === 1 ? 'lead' : 'support';
  existing.homeAddress = row.home_address;
  existing.postalAddress = row.postal_address;
  existing.engagementType = row.engagement_type;
  existing.startDate = row.start_date;
  existing.seniority = row.seniority;
  existing.skills = {
    hairBasic: row.skill_hair_basic === 1,
    hairAdvanced: row.skill_hair_advanced === 1,
    hollywoodWaves: row.skill_hollywood_waves === 1,
    makeup: row.skill_makeup === 1,
    flowergirl: row.skill_flowergirl === 1,
    brideFullHmu: row.skill_bride_full_hmu === 1,
    assisting: row.skill_assisting === 1
  };
  filterTeamRosterView();
}

// One-click deactivate/reactivate, per the build brief's soft-delete
// recommendation -- no confirmation dialog for reactivate (harmless,
// reversible either way), but deactivate is confirmed since it's the
// closer thing to a "remove" action an admin has for this entity.
function teamMemberToggleActive_(teamMemberId, newActive) {
  var m = _teamRosterFindMember_(teamMemberId);
  if (!m) return;
  if (!newActive && !confirm('Deactivate ' + (m.displayName || 'this team member') + '? She will show as Deactivated but her history is kept -- you can reactivate any time.')) {
    return;
  }
  adminTeamMemberRelayCall_('update', { tenantId: 'jessica-vegas', teamMemberId: teamMemberId, active: newActive })
    .then(function (res) {
      var data = (res && res.data) || {};
      if (data.row) {
        _teamRosterApplyUpdatedRow_(data.row);
        jvToast((m.displayName || 'Team member') + (newActive ? ' reactivated.' : ' deactivated.'), 'success');
      } else {
        jvToast('Could not update ' + (m.displayName || 'this team member') + ' -- try again.', 'error');
      }
    })
    .catch(function () {
      jvToast('Could not update ' + (m.displayName || 'this team member') + ' -- try again.', 'error');
    });
}

/* ============================================================
   TEAM MEMBER DETAIL DRAWER (2026-09-30, team-staff-mgmt piece 4)
   Per BRIEFS/HANDOFF-team-staff-mgmt-3-roster-and-drawer-ui-2026-09-30.md +
   the full-doc BRIEFS/HANDOFF-team-staff-management-full-build-to-
   consolidator-2026-09-30.md section 7.2. Replaces openEditTeamMemberModal
   as the row's primary action (that function is left in place, unused, in
   case a follow-up session wants the quicker single-field-change path back
   -- not deleted, since nothing else calls it and removing it risks nothing
   either way).

   Two of the six tabs (Profile, Scheduling) render real, editable D1 data.
   CORRECTED 2026-10-12 (state/findings/FINDING-admin-crm-stale-team-roster-
   comment-2026-10-02.md): this comment originally claimed /admin/team-
   members/list and /update carried none of the 2026-09-30 columns (phone,
   postal_address, engagement_type, lifecycle_status, welcome_email_status,
   last_activity_at, etc.) -- confirmed by a fresh direct read of
   teamMemberListHttp.ts/teamMemberUpdateHttp.ts that this was stale: they
   have carried these camelCased since that migration. Profile now shows and
   saves postalAddress/engagementType/startDate (home address + name were
   already live); Contract also moved on since this comment was written --
   it reads real onboarding-status data (2026-10-06), not a placeholder.
   Still genuinely NOT built, confirmed again today: Compliance (no WWCC/PLI/
   ABN read route at all), Service rates v1 tab (superseded by the
   Compensation tab, which IS live), and Activity (the activity-list/
   resend-welcome relay actions aren't wired through yet, see that tab's own
   comment). Those three correctly still render their "not built yet" state.
   ============================================================ */
var _tmdCurrent = null; // the team member row the drawer is currently showing

function openTeamMemberDrawer(teamMemberId) {
  var m = _teamRosterFindMember_(teamMemberId);
  if (!m) { jvToast('Could not find that team member -- try refreshing the list.', 'error'); return; }
  _tmdCurrent = m;
  _tmdCompRenderedFor_ = null; // the previous artist's pane is invalid until THIS member's renders

  document.getElementById('tmd-name').textContent = m.displayName || '(no name)';
  document.getElementById('tmd-meta').textContent = m.email || '';

  _tmdRenderProfile_(m);
  _tmdRenderScheduling_(m);
  _tmdRenderComingSoon_('tmd-compliance',
    'Compliance (WWCC, PLI, ABN, emergency contact) is view-only once the admin identity read is wired. ' +
    'Not reachable from this page yet -- coming soon.');
  _tmdLoadContract_(m);
  _tmdLoadRates_(m);
  _tmdLoadPayRates_(m);
  try { _tmdApplyCompensationFlag_(); _tmdLoadCompensation_(m); } catch (e) { try { console.error('[tmd] Compensation tab load failed:', e); } catch (_) {} }
  _tmdLoadActivity_(m);

  // Reset to the Profile tab every open, same convention as the bride drawer.
  switchTeamDrawerTab_('tmd-profile', document.querySelector('#tmd-tabs .drawer-tab[data-pane="tmd-profile"]'));

  document.getElementById('team-member-drawer').classList.add('open');
  document.getElementById('tmd-overlay').classList.add('show');
}

function closeTeamMemberDrawer() {
  document.getElementById('team-member-drawer').classList.remove('open');
  document.getElementById('tmd-overlay').classList.remove('show');
  _tmdCurrent = null;
  // Never leave one artist's rate forms sitting in the DOM for the next open.
  _tmdCompRenderedFor_ = null;
  var compPane = document.getElementById('tmd-compensation');
  if (compPane) compPane.innerHTML = '';
}

// Scoped to #team-member-drawer ONLY -- never touches the bride drawer's own
// .drawer-tab/.drawer-pane elements elsewhere in the page (see the CSS
// comment on #team-member-drawer for why a shared switchDrawerTab() would be
// wrong here: that function's querySelectorAll calls are global).
function switchTeamDrawerTab_(pane, tabEl) {
  var root = document.getElementById('team-member-drawer');
  if (!root) return;
  root.querySelectorAll('.drawer-tab').forEach(function (t) { t.classList.remove('active'); });
  root.querySelectorAll('.drawer-pane').forEach(function (p) { p.classList.remove('active'); });
  if (tabEl) tabEl.classList.add('active');
  var paneEl = document.getElementById(pane);
  if (paneEl) paneEl.classList.add('active');
}

function _tmdRenderComingSoon_(paneId, copy) {
  var el = document.getElementById(paneId);
  if (el) el.innerHTML = '<div class="tmd-comingsoon">' + escHtml(copy) + '</div>';
}

/* ---- Contract tab (2026-10-06, Team Portal Identity) --------------------
   Onboarding progress, the artist's signature on the Contractor Agreement
   (wizard step 7) and Jess's countersign. Backend:
   REBUILD-CLOUDFLARE/src/domains/team/teamContractCountersign.ts via relay
   actions onboarding-status / contract-countersign. The company named on the
   record comes from the server (legal entity setting), never this file.
   Any failure (flag off, network) collapses to the same coming-soon copy as
   the other tabs. ------------------------------------------------------ */
var TMD_CONTRACT_COMING_SOON_ = 'Contract status is not available yet.';
var _tmdContractData_ = null;
var TMD_STEP_LABELS_ = {
  personal: 'Personal details', bank: 'Bank details', tax: 'ABN', emergency: 'Emergency contact',
  pli: 'Public liability insurance', wwcc: 'Working with children check', contract: 'Contractor Agreement signed',
  policies: 'Policies acknowledged (optional)', complete: 'Onboarding submitted'
};

function _tmdLoadContract_(m) {
  var el = document.getElementById('tmd-contract');
  if (el) el.innerHTML = '<div class="tmd-comingsoon">Loading…</div>';
  adminTeamMemberRelayCall_('onboarding-status', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(m.teamMemberId)
  }).then(function (res) {
    if (_tmdCurrent && Number(_tmdCurrent.teamMemberId) !== Number(m.teamMemberId)) return;
    if (res && res.ok && res.data && res.data.progress) _tmdRenderContract_(res.data);
    else _tmdRenderComingSoon_('tmd-contract', TMD_CONTRACT_COMING_SOON_);
  }).catch(function () {
    _tmdRenderComingSoon_('tmd-contract', TMD_CONTRACT_COMING_SOON_);
  });
}

function _tmdRenderContract_(d) {
  var el = document.getElementById('tmd-contract');
  if (!el) return;
  var p = d.progress || {};
  var a = d.agreement || {};
  _tmdContractData_ = d;
  var c = d.countersign || {};
  var done = {};
  (p.done || []).forEach(function (k) { done[k] = true; });

  // Label + value rows use the drawer's own .tmd-field / .tmd-value styles
  // (the first version used classes with no CSS, so it rendered as huge
  // default text, QA 2026-10-06).
  function row(label, valueHtml, testid) {
    return '<div class="tmd-field"><label>' + escHtml(label) + '</label>' +
      '<div class="tmd-value"' + (testid ? ' data-testid="' + testid + '"' : '') + '>' + valueHtml + '</div></div>';
  }
  var statusRow = row('Status', escHtml(TEAM_LIFECYCLE_LABELS_[d.lifecycleStatus] || d.lifecycleStatus || ''), 'tmd-lifecycle');

  // Long-standing active artists predate the checklist: say so instead of a
  // misleading 0% (Browser QA, 2026-10-06).
  if (d.legacyOnboarding) {
    el.innerHTML = '<div data-testid="tmd-contract-panel">' + statusRow +
      row('Onboarding', 'Onboarded before the checklist existed.', 'tmd-legacy') +
      '<div id="tmd-sched1"></div></div>';
    // Her rates still live here: a long-standing artist can be issued her first per-artist contract.
    if (_tmdCurrent) _tmdLoadSchedule1_(_tmdCurrent);
    return;
  }

  var pct = Math.max(0, Math.min(100, Number(p.percent) || 0));
  var html = '<div data-testid="tmd-contract-panel">' + statusRow +
    '<div class="tmd-section-label">Onboarding</div>' +
    '<div class="tmd-value" data-testid="tmd-progress">' +
      escHtml(String(p.stepsDone || 0)) + ' of ' + escHtml(String(p.stepsTotal || 9)) + ' steps (' + escHtml(String(pct)) + '%)</div>' +
    '<div class="tmd-bar" role="presentation"><span style="width:' + pct + '%"></span></div>' +
    '<ul class="tmd-steps">';
  Object.keys(TMD_STEP_LABELS_).forEach(function (k) {
    html += '<li class="' + (done[k] ? 'done' : '') + '">' + escHtml(TMD_STEP_LABELS_[k]) + '</li>';
  });
  html += '</ul>';

  html += '<div class="tmd-section-label">Contractor Agreement</div>' +
    row('Artist signature',
      (a.signedAt
        ? 'Signed by ' + escHtml(a.signedName || '') + ' on ' + escHtml(_tmdFmtTs_(a.signedAt)) + ' (version ' + escHtml(a.signedVersion || '') + ')'
        : 'Not signed yet') +
      (a.correction ? '<div class="tmd-field-hint">Corrected from ' + escHtml(a.correction.originalSignedName || '') +
        ' on ' + escHtml(_tmdFmtTs_(a.correction.correctedAt)) + '. Original signed evidence preserved. Reason: ' + escHtml(a.correction.reason || '') + '</div>' : '') +
      (a.needsResign ? '<div class="tmd-field-hint">Version ' + escHtml(a.currentVersion) + ' is now current. She needs to re-sign.</div>' : '') +
      (a.signedAt ? '<div class="acm-actions" style="justify-content:flex-start;margin-top:0.6rem;">' +
        '<button type="button" class="btn btn-ghost" onclick="_tmdOpenSignoffCorrection_()">Correct signer name</button></div>' : ''),
      'tmd-artist-signature');

  var cs = '';
  if (c.countersignedAt) {
    cs = 'Countersigned by ' + escHtml(c.countersignedName || '') + ' on ' + escHtml(_tmdFmtTs_(c.countersignedAt)) +
      (c.entityName ? ' for ' + escHtml(c.entityName) + (c.entityAbn ? ' (ABN ' + escHtml(c.entityAbn) + ')' : '') : '') +
      '<div class="tmd-field-hint">' +
        (c.driveBackedUpAt ? 'Backed up to Drive ' + escHtml(_tmdFmtTs_(c.driveBackedUpAt)) : 'Drive backup runs overnight.') +
      '</div>';
  } else if (c.canCountersign) {
    cs = '<div class="tmd-field-hint" style="margin:0 0 0.5rem;">' +
        (c.required ? 'Type your full name to countersign. This makes her active and bookable.' : 'Optional: countersign for your records. She is already active.') + '</div>' +
      '<input type="text" id="tmd-countersign-name" autocomplete="name" aria-label="Your full name" placeholder="Your full name" data-testid="tmd-countersign-name">' +
      '<div class="acm-actions" style="justify-content:flex-start;margin-top:0.6rem;">' +
        '<button type="button" class="btn btn-primary" id="tmd-countersign-btn" data-testid="tmd-countersign-btn" onclick="_tmdCountersign_()">Countersign agreement</button>' +
      '</div>';
  } else {
    cs = c.required ? escHtml(c.blockedReason || 'Waiting on the artist.') : 'Not countersigned (optional).';
  }
  html += '<div class="tmd-field"><label>Countersign</label><div class="tmd-value tmd-countersign" data-testid="tmd-countersign-state">' + cs + '</div></div>';
  html += '<div id="tmd-sched1"></div>';
  html += '</div>';
  el.innerHTML = html;
  if (_tmdCurrent) _tmdLoadSchedule1_(_tmdCurrent);
}

function _tmdOpenSignoffCorrection_() {
  if (!_tmdCurrent) return;
  var agreement = (_tmdContractData_ && _tmdContractData_.agreement) || {};
  var expected = agreement.correction ? String(agreement.correction.originalSignedName || '') : String(agreement.signedName || '');
  var old = document.getElementById('tmd-signoff-correction-modal');
  if (old) old.remove();
  var ov = document.createElement('div');
  ov.id = 'tmd-signoff-correction-modal';
  ov.className = 'add-client-overlay';
  ov.innerHTML = '<div class="add-client-modal" role="dialog" aria-modal="true" aria-labelledby="tmd-correction-title">' +
    '<button type="button" class="acm-close" aria-label="Close" onclick="document.getElementById(\'tmd-signoff-correction-modal\').remove()">&times;</button>' +
    '<h2 id="tmd-correction-title">Correct signer name</h2>' +
    '<p class="tmd-field-hint">The original signed evidence will be preserved. This adds an audited correction only.</p>' +
    '<div class="tmd-field"><label for="tmd-corrected-name">Correct signer name</label><input id="tmd-corrected-name" type="text" value="' + escHtml(expected) + '"></div>' +
    '<div class="tmd-field"><label for="tmd-correction-reason">Reason for correction</label><textarea id="tmd-correction-reason" rows="3">Typed test name during authorised testing</textarea></div>' +
    '<div id="tmd-correction-error" class="tmd-s1-error" role="alert" style="display:none;"></div>' +
    '<div class="acm-actions"><button type="button" class="btn btn-ghost" onclick="document.getElementById(\'tmd-signoff-correction-modal\').remove()">Cancel</button>' +
    '<button type="button" class="btn btn-primary" id="tmd-correction-submit" onclick="_tmdSubmitSignoffCorrection_()">Record correction</button></div></div>';
  ov.addEventListener('click', function (e) { if (e.target === ov) ov.remove(); });
  document.body.appendChild(ov);
  var input = document.getElementById('tmd-corrected-name');
  if (input) { input.focus(); input.select(); }
}

function _tmdSubmitSignoffCorrection_() {
  if (!_tmdCurrent) return;
  var agreement = (_tmdContractData_ && _tmdContractData_.agreement) || {};
  var expected = agreement.correction ? String(agreement.correction.originalSignedName || '') : String(agreement.signedName || '');
  var corrected = String((document.getElementById('tmd-corrected-name') || {}).value || '').trim();
  var reason = String((document.getElementById('tmd-correction-reason') || {}).value || '').trim();
  var error = document.getElementById('tmd-correction-error');
  var button = document.getElementById('tmd-correction-submit');
  if (corrected.length < 2 || reason.length < 10) {
    if (error) { error.textContent = 'Enter a valid signer name and a reason of at least 10 characters.'; error.style.display = 'block'; }
    return;
  }
  if (button) { button.disabled = true; button.textContent = 'Recording...'; }
  adminTeamMemberRelayCall_('contract-signoff-correct', {
    tenantId: 'jessica-vegas', teamMemberId: Number(_tmdCurrent.teamMemberId),
    docVersion: String(agreement.signedVersion || ''), expectedSignedName: expected,
    correctedSignedName: corrected, reason: reason,
    idempotencyKey: 'signoff-correction-' + Number(_tmdCurrent.teamMemberId) + '-' + Date.now()
  }).then(function (res) {
    if (!res || !res.ok) {
      if (error) { error.textContent = (res && res.error && res.error.message) || 'Correction failed.'; error.style.display = 'block'; }
      if (button) { button.disabled = false; button.textContent = 'Record correction'; }
      return;
    }
    var modal = document.getElementById('tmd-signoff-correction-modal');
    if (modal) modal.remove();
    _tmdLoadContract_(_tmdCurrent);
  });
}

/* ── Per-artist Schedule 1 (2026-10-06, flag JV_TEAM_SCHEDULE1_ENABLED on the Worker) ───────────────────────────
   The standard rates table is the base; this panel stores only HER overrides. GST wording follows her own GST
   registration automatically. "Issue contract" sends her the new rates; she signs them in her wizard and signing puts
   them in force (there is no separate Rate Variation any more). When the Worker flag is off, schedule1-get answers
   "not found" and this whole panel stays empty, so the old tabs are unchanged. */
var _tmdS1 = null;       // last server answer
var _tmdS1Edits = {};    // key -> dollars string (what the admin typed); absent = standard

function _tmdS1Dollars_(cents) { return '$' + (Number(cents) / 100).toFixed(2).replace(/\.00$/, ''); }

function _tmdS1Gst_(gst, registered) {
  if (gst === 'n/a') return '';
  if (!registered) return ' (GST does not apply)';
  return gst === 'incl' ? ' inc GST' : ' plus GST';
}

function _tmdLoadSchedule1_(m) {
  var host = document.getElementById('tmd-sched1');
  if (!host) return;
  host.innerHTML = '<div class="tmd-field-hint">Loading her rates...</div>';
  adminTeamMemberRelayCall_('schedule1-get', { tenantId: 'jessica-vegas', teamMemberId: Number(m.teamMemberId) }).then(function (res) {
    if (_tmdCurrent && Number(_tmdCurrent.teamMemberId) !== Number(m.teamMemberId)) return;
    if (!(res && res.ok && res.data)) {
      // Worker flag off: stay empty so the old tabs are unchanged. Anything else: say so plainly.
      if (res && res.error && res.error.code === 'TEAM_SCHEDULE1_DISABLED') { host.innerHTML = ''; return; }
      _tmdS1LoadError_(host, (res && res.error && res.error.message) || '');
      return;
    }
    _tmdS1Apply_(res.data);
  }).catch(function (e) { _tmdS1LoadError_(host, String((e && e.message) || '')); });
}

function _tmdS1LoadError_(host, msg) {
  host.innerHTML = '<div class="tmd-section-label">Rates in her agreement (Schedule 1)</div>' +
    '<div class="tmd-s1-error" role="alert" data-testid="tmd-s1-error">Could not load her rates' + (msg ? ': ' + escHtml(msg) : '.') +
    ' <button type="button" class="btn btn-ghost" onclick="_tmdCurrent && _tmdLoadSchedule1_(_tmdCurrent)">Try again</button></div>';
}

function _tmdS1Apply_(data) {
  _tmdS1 = data;
  _tmdS1Edits = {};
  (data.rates || []).forEach(function (r) {
    var c = r.draftCents != null ? r.draftCents : (r.awaitingCents != null ? r.awaitingCents : r.activeCents);
    if (c != null) _tmdS1Edits[r.key] = String(c / 100);
  });
  _tmdRenderSchedule1_();
}

function _tmdS1Cents_(v) {
  var n = Math.round(parseFloat(String(v).replace(/[^0-9.]/g, '')) * 100);
  return isFinite(n) && n > 0 ? n : null;
}

function _tmdS1GstHint_(d) {
  var reg = !!d.gstRegistered;
  return d.identityFound
    ? (reg ? 'She is GST registered: amounts read "plus GST".' : 'She is not GST registered: amounts read "GST does not apply".')
    : 'She has not entered her GST status yet, so amounts read "GST does not apply" until she does.';
}

function _tmdS1Note_(d) {
  if (d.neverSigned) return 'She has not signed yet. She will sign these rates.';
  if (d.resignOnIssue) return 'She signed different rates. Issuing means she has to sign again before they apply.';
  if (!d.hasUnissuedChanges) return 'These rates are what she has signed.';
  return 'You have changes that are not issued yet.';
}

/* Drawer summary + the editor modal (2026-10-07). Both repaint from _tmdS1 / _tmdS1Edits. */
function _tmdRenderSchedule1_() {
  var host = document.getElementById('tmd-sched1');
  var d = _tmdS1;
  if (host && d) {
    var std = d.standard || [];
    var n = std.filter(function (s) { return s.overridable && _tmdS1Edits[s.key] !== undefined; }).length;
    host.innerHTML = '<div class="tmd-section-label">Rates in her agreement (Schedule 1)</div>' +
      '<div class="tmd-s1-summary" data-testid="tmd-s1-summary">' +
        '<div class="tmd-field-hint">' + (n ? n + ' of her rates differ from standard.' : 'Standard rates. Nothing changed for her.') + ' ' + escHtml(_tmdS1Note_(d)) + '</div>' +
        '<button type="button" class="btn btn-primary" data-testid="tmd-s1-open" onclick="_tmdS1Open_()">Edit her rates</button>' +
      '</div>';
  }
  if (document.getElementById('tmd-s1-modal')) _tmdS1RenderModal_();
}

function _tmdS1Open_() {
  if (!_tmdS1) return;
  var ov = document.getElementById('tmd-s1-modal');
  if (!ov) {
    ov = document.createElement('div');
    ov.id = 'tmd-s1-modal';
    ov.className = 'tmd-s1-overlay';
    ov.setAttribute('data-testid', 'tmd-s1-modal');
    ov.addEventListener('click', function (e) { if (e.target === ov) _tmdS1Close_(); });
    document.body.appendChild(ov);
    document.addEventListener('keydown', _tmdS1Key_);
  }
  _tmdS1RenderModal_();
  var first = ov.querySelector('select, input, button');
  if (first) { try { first.focus(); } catch (e) {} }
}

function _tmdS1Key_(e) { if (e.key === 'Escape') _tmdS1Close_(); }

function _tmdS1Close_() {
  var ov = document.getElementById('tmd-s1-modal');
  if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
  document.removeEventListener('keydown', _tmdS1Key_);
}

function _tmdS1PreviewHtml_() {
  var d = _tmdS1, reg = !!d.gstRegistered;
  return (d.standard || []).map(function (s) {
    var typed = s.overridable ? _tmdS1Cents_(_tmdS1Edits[s.key]) : null;
    var cents = typed != null ? typed : s.amountCents;
    var cell = cents == null ? (s.text || '') : (_tmdS1Dollars_(cents) + ' ' + s.suffix + _tmdS1Gst_(s.gst, reg));
    return '<div class="tmd-s1-prow' + (typed != null && typed !== s.amountCents ? ' is-changed' : '') + '"><span>' + escHtml(s.label) + '</span><span>' + escHtml(cell) + '</span></div>';
  }).join('');
}

function _tmdS1RenderModal_() {
  var ov = document.getElementById('tmd-s1-modal');
  var d = _tmdS1;
  if (!ov || !d) return;
  var std = d.standard || [];
  var name = (_tmdCurrent && (_tmdCurrent.displayName || _tmdCurrent.name)) || 'her';
  var free = std.filter(function (s) { return s.overridable && _tmdS1Edits[s.key] === undefined; });

  var rows = std.map(function (s) {
    var stdCell = s.amountCents == null ? (s.text || '') : (_tmdS1Dollars_(s.amountCents) + ' ' + s.suffix);
    var mine = s.overridable && _tmdS1Edits[s.key] !== undefined;
    var her;
    if (!s.overridable) her = '<span class="tmd-field-hint">Fixed</span>';
    else if (mine) her = '<span class="tmd-s1-dollar">$</span><input type="number" min="0" step="0.01" inputmode="decimal" class="tmd-s1-input" aria-label="Her rate for ' + escHtml(s.label) + '" data-key="' + escHtml(s.key) + '" value="' + escHtml(_tmdS1Edits[s.key]) + '" oninput="_tmdS1Input_(this)">' +
      '<button type="button" class="btn btn-ghost" aria-label="Use standard rate for ' + escHtml(s.label) + '" onclick="_tmdS1Remove_(\'' + escHtml(s.key) + '\')">Use standard</button>';
    else her = '<span class="tmd-field-hint">Standard</span>';
    return '<div class="tmd-s1-line' + (mine ? ' is-mine' : '') + '">' +
      '<div class="tmd-s1-line-name">' + escHtml(s.label) + '<span class="tmd-field-hint">Standard ' + escHtml(stdCell) + '</span></div>' +
      '<div class="tmd-s1-line-her">' + her + '</div></div>';
  }).join('');

  var add = free.length
    ? '<div class="tmd-s1-add">' +
        '<select id="tmd-s1-add-service" aria-label="Service" data-testid="tmd-s1-service"><option value="">Choose a service...</option>' +
        free.map(function (s) { return '<option value="' + escHtml(s.key) + '">' + escHtml(s.label + ' (standard ' + _tmdS1Dollars_(s.amountCents) + ')') + '</option>'; }).join('') +
        '</select><input type="number" min="0" step="0.01" inputmode="decimal" id="tmd-s1-add-amount" aria-label="Her rate in dollars" placeholder="Her rate $">' +
        '<button type="button" class="btn btn-ghost" data-testid="tmd-s1-add" onclick="_tmdS1Add_()">Add</button></div>'
    : '<div class="tmd-field-hint">Every service already has her own rate.</div>';

  ov.innerHTML = '<div class="tmd-s1-modal" role="dialog" aria-modal="true" aria-labelledby="tmd-s1-title">' +
    '<div class="tmd-s1-head"><h3 id="tmd-s1-title">Her rates: ' + escHtml(name) + '</h3>' +
      '<button type="button" class="btn btn-ghost" aria-label="Close" onclick="_tmdS1Close_()">Close</button></div>' +
    '<div class="tmd-s1-body">' +
      '<div class="tmd-field-hint">' + escHtml(_tmdS1GstHint_(d)) + '</div>' +
      '<div class="tmd-section-label">Add a rate for her</div>' + add +
      '<div class="tmd-section-label">Every Schedule 1 line</div>' +
      '<div class="tmd-s1-lines" data-testid="tmd-s1-overrides">' + rows + '</div>' +
      '<div class="tmd-section-label">What she will sign</div>' +
      '<div class="tmd-s1-preview" id="tmd-s1-preview" data-testid="tmd-s1-preview">' + _tmdS1PreviewHtml_() + '</div>' +
      '<div class="tmd-field-hint" data-testid="tmd-s1-note">' + escHtml(_tmdS1Note_(d)) + '</div>' +
    '</div>' +
    '<div class="tmd-s1-foot">' +
      '<button type="button" class="btn btn-ghost" data-testid="tmd-s1-standard" onclick="_tmdS1Standard_()">Reset all to standard</button>' +
      '<button type="button" class="btn btn-ghost" data-testid="tmd-s1-save" id="tmd-s1-save" onclick="_tmdS1Save_(false)">Save draft</button>' +
      '<button type="button" class="btn btn-primary" data-testid="tmd-s1-issue" id="tmd-s1-issue" onclick="_tmdS1Save_(true)">Issue contract</button>' +
    '</div></div>';
}

function _tmdS1Input_(el) {
  _tmdS1Edits[el.getAttribute('data-key')] = el.value;
  // repaint only the preview so typing is never interrupted
  var p = document.getElementById('tmd-s1-preview');
  if (p) p.innerHTML = _tmdS1PreviewHtml_();
}
function _tmdS1Remove_(key) { delete _tmdS1Edits[key]; _tmdRenderSchedule1_(); }
function _tmdS1Standard_() { _tmdS1Edits = {}; _tmdRenderSchedule1_(); }
function _tmdS1Add_() {
  var key = (document.getElementById('tmd-s1-add-service') || {}).value;
  var amt = (document.getElementById('tmd-s1-add-amount') || {}).value;
  if (!key) { jvToast('Choose a service first.', 'error'); return; }
  if (_tmdS1Cents_(amt) == null) { jvToast('Type the rate in dollars.', 'error'); return; }
  _tmdS1Edits[key] = amt;
  _tmdRenderSchedule1_();
  var inp = document.querySelector('.tmd-s1-input[data-key="' + key + '"]');
  if (inp) { try { inp.focus(); } catch (e) {} }
}

function _tmdS1Save_(issue) {
  if (!_tmdCurrent || !_tmdS1) return;
  var member = _tmdCurrent;
  var overrides = [];
  for (var i = 0; i < (_tmdS1.standard || []).length; i++) {
    var s = _tmdS1.standard[i];
    if (!s.overridable) continue;
    if (_tmdS1Edits[s.key] === undefined) { overrides.push({ key: s.key, amountCents: null }); continue; }
    var c = _tmdS1Cents_(_tmdS1Edits[s.key]);
    if (c == null) { jvToast('Check the rate for ' + s.label + '.', 'error'); return; }
    overrides.push({ key: s.key, amountCents: c });
  }
  if (issue) {
    var who = member.displayName || member.name || 'She';
    if (!window.confirm('Issue this contract? ' + who + ' will be emailed to sign these rates in her onboarding. They apply once she signs.')) return;
  }
  var btn = document.getElementById(issue ? 'tmd-s1-issue' : 'tmd-s1-save');
  if (btn) { btn.disabled = true; btn.textContent = issue ? 'Issuing...' : 'Saving...'; }
  var base = { tenantId: 'jessica-vegas', teamMemberId: Number(member.teamMemberId) };
  adminTeamMemberRelayCall_('schedule1-save', Object.assign({}, base, { overrides: overrides })).then(function (res) {
    if (!(res && res.ok)) throw new Error((res && res.error && res.error.message) || 'Could not save the rates.');
    return issue ? adminTeamMemberRelayCall_('schedule1-issue', base) : res;
  }).then(function (res) {
    if (!(res && res.ok && res.data)) throw new Error((res && res.error && res.error.message) || 'Could not issue the contract.');
    jvToast(issue ? 'Contract issued. She signs it in her onboarding.' : 'Draft saved.', 'success');
    if (issue) _tmdS1Close_();
    if (_tmdCurrent && Number(_tmdCurrent.teamMemberId) === Number(member.teamMemberId)) _tmdS1Apply_(res.data);
  }).catch(function (e) {
    jvToast(String((e && e.message) || e), 'error');
    if (btn) { btn.disabled = false; btn.textContent = issue ? 'Issue contract' : 'Save draft'; }
  });
}

function _tmdCountersign_() {
  if (!_tmdCurrent) return;
  var input = document.getElementById('tmd-countersign-name');
  var name = input ? input.value.trim() : '';
  if (name.length < 2) { jvToast('Type your full name to countersign.', 'error'); return; }
  var btn = document.getElementById('tmd-countersign-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Countersigning…'; }
  var member = _tmdCurrent;
  adminTeamMemberRelayCall_('contract-countersign', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(member.teamMemberId),
    typedName: name
  }).then(function (res) {
    if (res && res.ok) {
      jvToast('Agreement countersigned.', 'success');
      _tmdLoadContract_(member);
      loadTeamRosterView();
    } else {
      jvToast((res && res.error && res.error.message) || 'Could not countersign.', 'error');
      if (btn) { btn.disabled = false; btn.textContent = 'Countersign agreement'; }
    }
  }).catch(function () {
    jvToast('Could not countersign.', 'error');
    if (btn) { btn.disabled = false; btn.textContent = 'Countersign agreement'; }
  });
}

var TMD_ACTIVITY_COMING_SOON_ =
  'Welcome-email outcome, last activity and an edit/change log aren’t tracked yet, coming soon.';
var TMD_RATES_COMING_SOON_ =
  'No rates configured yet, coming soon. Per-service pay rates need their own signed document ' +
  'before they take effect once this ships.';

function _tmdFmtTs_(iso) {
  if (!iso) return '';
  // D1 datetime('now') is UTC but has no zone marker ("2026-10-06 01:43:00"),
  // and browsers read a zone-less string as LOCAL time -- that was the QA
  // "1:43 am instead of 12:43 pm" bug. Mark such strings as UTC first.
  var raw = String(iso).trim();
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(raw)) raw = raw.replace(' ', 'T') + 'Z';
  var d = new Date(raw);
  if (isNaN(d.getTime())) return String(iso);
  // Always Sydney time, whatever the viewing browser's own timezone (QA saw UTC).
  return d.toLocaleString('en-AU', { timeZone: 'Australia/Sydney', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/* ---- Activity tab (2026-09-30, team-staff-mgmt piece 5) -----------------
   Per BRIEFS/HANDOFF-team-staff-mgmt-activity-and-rates-tab-wiring-to-admin-
   crm-2026-09-30.md. Backend routes (Team Portal Identity, REBUILD-CLOUDFLARE/
   src/domains/team/teamMemberActivityHttp.ts + teamMemberResendWelcomeHttp.ts)
   are built and merged but not yet reachable end-to-end -- the relay hasn't
   learned the 'activity-list'/'resend-welcome' action names yet (owed from
   Cloudflare/Edge), and the Worker-side flags default off even once it has.
   Every failure mode (unknown action, flag off, network error) is
   deliberately collapsed to the SAME "coming soon" render -- per the
   handoff's own instruction, the person looking at the screen doesn't need
   to know WHY it's not available, and distinguishing the reasons client-side
   just adds branches that can't be tested until the chain is live anyway.
   The moment the relay + flag are live, this starts rendering real data with
   zero further frontend change. ---------------------------------------- */
var TEAM_ACTIVITY_LABELS_ = {
  member_created: 'Added to the team',
  member_updated: 'Details updated',
  welcome_email_sent: 'Welcome email sent',
  welcome_email_deferred: 'Welcome email deferred (quiet hours)',
  welcome_email_blocked: 'Welcome email blocked',
  welcome_email_failed: 'Welcome email failed to send',
  welcome_email_resent: 'Welcome email resent',
  deactivated: 'Deactivated',
  reactivated: 'Reactivated',
  lifecycle_changed: 'Status changed',
  contract_countersigned: 'Contractor Agreement countersigned'
};

function _tmdLoadActivity_(m) {
  var el = document.getElementById('tmd-activity');
  if (el) el.innerHTML = '<div class="tmd-comingsoon">Loading…</div>';
  adminTeamMemberRelayCall_('activity-list', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(m.teamMemberId)
  }).then(function (res) {
    var data = (res && res.data) || {};
    if (res && res.ok && Array.isArray(data.events)) {
      _tmdRenderActivity_(data.events);
    } else {
      _tmdRenderComingSoon_('tmd-activity', TMD_ACTIVITY_COMING_SOON_);
    }
  }).catch(function () {
    _tmdRenderComingSoon_('tmd-activity', TMD_ACTIVITY_COMING_SOON_);
  });
}

function _tmdRenderActivity_(events) {
  var el = document.getElementById('tmd-activity');
  if (!el) return;
  var html = '<div class="acm-actions" style="justify-content:flex-end;margin-bottom:0.9rem;">' +
    '<button type="button" class="btn btn-ghost" id="tmd-resend-btn" onclick="_tmdResendWelcome_()">Resend welcome email</button>' +
  '</div>';
  if (!events.length) {
    html += '<div class="empty-state"><p>No activity recorded yet.</p></div>';
  } else {
    events.forEach(function (e) {
      var label = TEAM_ACTIVITY_LABELS_[e.eventType] || e.eventType || 'Event';
      html += '<div class="timeline-item">' +
        '<div class="timeline-dot note"></div>' +
        '<div class="timeline-content">' +
          '<div class="timeline-msg">' + escHtml(label) + (e.detail ? ' (' + escHtml(e.detail) + ')' : '') + '</div>' +
          '<div class="timeline-ts">' + escHtml(_tmdFmtTs_(e.createdAt)) + (e.createdBy ? ' · ' + escHtml(e.createdBy) : '') + '</div>' +
        '</div>' +
      '</div>';
    });
  }
  el.innerHTML = html;
}

function _tmdResendWelcome_() {
  if (!_tmdCurrent) return;
  var btn = document.getElementById('tmd-resend-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  adminTeamMemberRelayCall_('resend-welcome', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId)
  }).then(function (res) {
    var data = (res && res.data) || {};
    var step = data.step || {};
    if (res && res.ok && step.ok) {
      jvToast('Welcome email resent.', 'success');
      // Re-fetch so the newly-logged resend event appears -- per the handoff,
      // no separate refresh mechanism needed.
      _tmdLoadActivity_(_tmdCurrent);
    } else {
      jvToast(step.error || step.detail || (res && res.error && res.error.message) || 'Could not resend the welcome email, not available yet.', 'error');
      if (btn) { btn.disabled = false; btn.textContent = 'Resend welcome email'; }
    }
  }).catch(function () {
    jvToast('Could not resend the welcome email, not available yet.', 'error');
    if (btn) { btn.disabled = false; btn.textContent = 'Resend welcome email'; }
  });
}

/* ---- Service rates tab (2026-09-30, team-staff-mgmt piece 5) -------------
   Same "collapse every failure to coming-soon" discipline as Activity above.
   The amount IS a real currency figure here, deliberately -- per the
   handoff, this is the one legitimate place in the whole drawer where
   showing a dollar figure is correct (Jess viewing her own artists' pay
   rates is not a bride-facing or cross-artist-leaking surface). Never log
   these amounts to the console or a toast -- DOM only. ------------------- */
var TEAM_RATE_UNIT_LABELS_ = { per_service: 'per service', per_hour: 'per hour', per_day: 'per day', per_km: 'per km' };
var TEAM_RATE_STATUS_LABELS_ = { draft: 'Draft', awaiting_signature: 'Awaiting signature', active: 'Active', superseded: 'Superseded' };
var TEAM_RATE_STATUS_CHIP_CLASS_ = { active: 'paid', superseded: 'void', awaiting_signature: 'draft', draft: 'draft' };

function _tmdLoadRates_(m) {
  var el = document.getElementById('tmd-rates');
  if (el) el.innerHTML = '<div class="tmd-comingsoon">Loading…</div>';
  var memberPayload = { tenantId: 'jessica-vegas', teamMemberId: Number(m.teamMemberId) };
  // Current pay rate (read-only context above the service list, step 1 of
  // the Pay Rates merge). A failure here only hides this block; it never
  // replaces the service list with coming-soon copy.
  var payP = adminTeamMemberRelayCall_('pay-rates-list', memberPayload).then(function (res) {
    var d = (res && res.data) || {};
    return (res && res.ok && d.active) ? d.active : null;
  }).catch(function () { return null; });
  var svcP = adminTeamMemberRelayCall_('service-rates-list', memberPayload).then(function (res) {
    var data = (res && res.data) || {};
    return (res && res.ok && Array.isArray(data.rates)) ? data.rates : null;
  }).catch(function () { return null; });
  Promise.all([svcP, payP]).then(function (out) {
    if (out[0]) {
      _tmdRenderRates_(out[0], out[1]);
    } else {
      _tmdRenderComingSoon_('tmd-rates', TMD_RATES_COMING_SOON_);
    }
  });
}

var _tmdRateRows = [];
var _tmdEditingRateId = null;

function _tmdRenderRates_(rates, payActive) {
  var el = document.getElementById('tmd-rates');
  if (!el) return;
  _tmdRateRows = rates || [];

  // Group by service key -- each group's rows already newest-first within
  // the group per the backend's own ordering, so a superseded chain reads
  // as history under its current row.
  var groups = {}, order = [];
  // Schedule 1 rows are managed in the Contract tab (per-artist agreement), not as free-text service rates.
  rates = rates.filter(function (r) { return !/^sched1\./.test(String(r.serviceKey || '')); });
  rates.forEach(function (r) {
    var k = r.serviceKey || '(unknown service)';
    if (!groups[k]) { groups[k] = []; order.push(k); }
    groups[k].push(r);
  });

  var html = '';
  if (payActive) {
    html += '<div class="tmd-section-label">Current pay rate (read-only)</div>' +
      _tmdRenderPayRateCard_(payActive, true);
  }
  var hasDraft = false;
  if (!order.length) {
    html += '<div class="empty-state"><p>No rates configured yet.</p></div>';
  } else {
    order.forEach(function (k) {
      html += '<div class="tmd-section-label">' + escHtml(k) + '</div>';
      groups[k].forEach(function (r) {
        var amount = '$' + (Number(r.amountCents || 0) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 });
        var unitLabel = TEAM_RATE_UNIT_LABELS_[r.unit] || r.unit || '';
        var statusLabel = TEAM_RATE_STATUS_LABELS_[r.status] || r.status || '';
        var chipClass = TEAM_RATE_STATUS_CHIP_CLASS_[r.status] || 'draft';
        var isDraft = r.status === 'draft';
        if (isDraft) hasDraft = true;
        var checkbox = isDraft
          ? '<input type="checkbox" class="tmd-r-select" data-rate-id="' + escHtml(String(r.id)) + '" style="margin-right:0.5rem;">'
          : '';
        var rowActions = '<button type="button" class="btn btn-ghost" style="font-size:0.7rem;" onclick="_tmdEditServiceRate_(' + escHtml(String(r.id)) + ')">Edit</button>' +
          (isDraft ? ' <button type="button" class="btn btn-ghost" style="font-size:0.7rem;" onclick="_tmdDeleteDraftRate_(' + escHtml(String(r.id)) + ')">Delete draft</button>' : '');
        html += '<div class="info-row">' +
          '<span class="info-label">' + checkbox + escHtml(amount + ' ' + unitLabel) + '</span>' +
          '<span class="info-value"><span class="inv-status-chip ' + chipClass + '">' + escHtml(statusLabel) + '</span> ' + rowActions + '</span>' +
        '</div>';
        if (r.note) html += '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' + escHtml(r.note) + '</div>';
      });
    });
  }

  html += '<div id="tmd-r-sig-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;margin-bottom:1rem;">' +
      '<button type="button" class="btn btn-ghost" id="tmd-r-prep-pay" onclick="_tmdPreparePayRates_()">Prepare pay rates for contract</button>' +
    '</div>';

  html += '<div class="tmd-section-label">Add a service rate</div>' +
    '<div class="tmd-field-hint" style="margin-bottom:0.6rem;">Adding a rate creates a draft. Rate agreements are signed as Schedule 1 in the onboarding wizard.</div>' +
    '<div class="tmd-field"><label>Service key</label><input type="text" id="tmd-r-servicekey" placeholder="e.g. hair_basic"></div>' +
    '<div class="tmd-field"><label>Amount (AUD)</label><input type="number" id="tmd-r-amount" min="0" step="0.01" placeholder="e.g. 150.00"></div>' +
    '<div class="tmd-field"><label>Unit</label><select id="tmd-r-unit">' +
      '<option value="per_service">Per service</option><option value="per_hour">Per hour</option><option value="per_day">Per day</option><option value="per_km">Per km</option>' +
    '</select></div>' +
    '<div class="tmd-field"><label>GST treatment</label><select id="tmd-r-gst">' +
      '<option value="n/a" selected>Not applicable</option><option value="excl">Excludes GST</option><option value="incl">Includes GST</option>' +
    '</select></div>' +
    '<div class="tmd-field"><label>Note (optional)</label><input type="text" id="tmd-r-note"></div>' +
    '<div id="tmd-r-edit-hint" class="tmd-field-hint" style="display:none;"></div>' +
    '<div id="tmd-r-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-primary" id="tmd-r-save" onclick="_tmdSaveServiceRate_()">Add rate</button>' +
    '</div>';

  el.innerHTML = html;
}

/* ---- Request signature (2026-10-03, Jess's "finish it" instruction) ----
   Bundles the checked DRAFT rows into a new rate-variation contract via
   jv-team-contracts (REBUILD-CLOUDFLARE's new request-signature route).
   contractType is read from the roster row's own engagementType (set at
   Add Team Member time, defaults 'subcontractor' per teamMemberRepo.ts's
   own convention) -- there is no separate UI for it here, the artist's
   existing employment relationship doesn't change just because her rate
   did. Dark until JV_TEAM_SERVICE_RATE_SIGNATURE_ENABLED is flipped on
   jv-next-pilot; until then this 404s/503s and the error path below
   renders exactly like every other "not available yet" failure on this
   tab (collapsed, no stack trace, per this tab's own discipline). -------- */
/* Update + delete for service rates (2026-10-03, approved). Edit pre-fills the
   add form from the row. Saving then creates a NEW draft revision through the
   revise route (the source row is never written). Delete is offered on DRAFT
   rows only; the server refuses anything else. ----------------------------- */
function _tmdEditServiceRate_(rateId) {
  var row = (_tmdRateRows || []).filter(function (r) { return String(r.id) === String(rateId); })[0];
  if (!row) return;
  _tmdEditingRateId = row.id;
  document.getElementById('tmd-r-servicekey').value = row.serviceKey || '';
  document.getElementById('tmd-r-amount').value = (Number(row.amountCents || 0) / 100).toFixed(2);
  document.getElementById('tmd-r-unit').value = row.unit || 'per_service';
  document.getElementById('tmd-r-gst').value = row.gstTreatment || 'n/a';
  document.getElementById('tmd-r-note').value = row.note || '';
  var btn = document.getElementById('tmd-r-save');
  if (btn) btn.textContent = 'Save as new draft revision';
  var hint = document.getElementById('tmd-r-edit-hint');
  if (hint) { hint.textContent = 'Editing creates a new draft. The row you started from is not changed.'; hint.style.display = 'block'; }
}

function _tmdDeleteDraftRate_(rateId) {
  if (!_tmdCurrent) return;
  var errEl = document.getElementById('tmd-r-sig-error');
  if (errEl) errEl.style.display = 'none';
  adminTeamMemberRelayCall_('service-rates-delete', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId),
    rateId: Number(rateId)
  }).then(function (res) {
    if (res && res.ok) {
      jvToast('Draft deleted.', 'success');
      _tmdLoadRates_(_tmdCurrent);
    } else if (errEl) {
      errEl.textContent = (res && res.error && res.error.message) || 'Could not delete that rate.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    if (errEl) { errEl.textContent = 'Error: ' + String((err && err.message) || err || ''); errEl.style.display = 'block'; }
  });
}

/* Pay card edit (2026-10-03, approved): pre-fills the "Set a new rate" form
   from the current card. Saving writes a NEW pay row through the existing
   set route. There is no delete: pay history is append-only. -------------- */
var _tmdPayActive = null;
function _tmdEditPayRateCurrent_() {
  if (!_tmdPayActive) return;
  TMD_PAY_RATE_FIELDS_.forEach(function (f) {
    var el = document.getElementById('tmd-pr-' + f.key);
    if (el) el.value = (_tmdPayActive[f.key] === null || _tmdPayActive[f.key] === undefined) ? '' : (Number(_tmdPayActive[f.key]) / 100).toFixed(2);
  });
  var gst = document.getElementById('tmd-pr-gst');
  if (gst) gst.value = _tmdPayActive.gstRegistered ? 'true' : 'false';
  var note = document.getElementById('tmd-pr-note');
  if (note) note.value = _tmdPayActive.note || '';
  var hint = document.getElementById('tmd-pr-edit-hint');
  if (hint) { hint.textContent = 'Set a new effective date below. This creates a new rate and keeps the current one in history.'; hint.style.display = 'block'; }
}

/* Step 2 Option B: copy the member's current pay card into draft rate rows so
   those pay lines can be ticked into the same contract as the service rates.
   Idempotent on the server; the pay card itself is only read. */
function _tmdPreparePayRates_() {
  if (!_tmdCurrent) return;
  var btn = document.getElementById('tmd-r-prep-pay');
  var errEl = document.getElementById('tmd-r-sig-error');
  if (errEl) errEl.style.display = 'none';
  if (btn) { btn.disabled = true; btn.textContent = 'Preparing...'; }
  adminTeamMemberRelayCall_('service-rates-prepare-pay-rates', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId)
  }).then(function (res) {
    if (res && res.ok) {
      jvToast('Pay rates are ready to tick.', 'success');
      _tmdLoadRates_(_tmdCurrent);
    } else {
      if (btn) { btn.disabled = false; btn.textContent = 'Prepare pay rates for contract'; }
      if (errEl) {
        errEl.textContent = (res && res.error && res.error.message) || 'Could not prepare pay rates, not available yet.';
        errEl.style.display = 'block';
      }
    }
  }).catch(function (err) {
    if (btn) { btn.disabled = false; btn.textContent = 'Prepare pay rates for contract'; }
    if (errEl) { errEl.textContent = 'Error: ' + String((err && err.message) || err || ''); errEl.style.display = 'block'; }
  });
}

/* RET1 (2026-10-19, Jess poll): the admin 'Request signature' button and its handler are RETIRED
   (Schedule 1 signed in the onboarding wizard replaced them). Removed so nobody can create a stranded
   rate_variation contract. Server route answers 410 TEAM_RATE_VARIATION_RETIRED. */

function _tmdSaveServiceRate_() {
  if (!_tmdCurrent) return;
  var serviceKey = (document.getElementById('tmd-r-servicekey').value || '').trim();
  var amountRaw = document.getElementById('tmd-r-amount').value;
  var unit = document.getElementById('tmd-r-unit').value;
  var gstTreatment = document.getElementById('tmd-r-gst').value;
  var note = (document.getElementById('tmd-r-note').value || '').trim();
  var errEl = document.getElementById('tmd-r-error');
  errEl.style.display = 'none';

  if (!serviceKey) { errEl.textContent = 'Service key is required.'; errEl.style.display = 'block'; return; }
  var amountDollars = parseFloat(amountRaw);
  if (!(amountDollars > 0)) { errEl.textContent = 'Enter a positive amount.'; errEl.style.display = 'block'; return; }
  var amountCents = Math.round(amountDollars * 100);

  var btn = document.getElementById('tmd-r-save');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  var payload = {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId),
    serviceKey: serviceKey,
    unit: unit,
    gstTreatment: gstTreatment,
    amountCents: amountCents,
    // Fresh per submission -- a resubmit carrying the SAME value (e.g. a
    // double-click before the button disables) returns the already-created
    // draft instead of creating a duplicate.
    idempotencyKey: 'tmd-' + Date.now() + '-' + Math.random().toString(36).slice(2)
  };
  if (note) payload.note = note;

  var editing = _tmdEditingRateId;
  var call = editing
    ? adminTeamMemberRelayCall_('service-rates-revise', Object.assign({}, payload, { rateId: Number(editing) }))
    : adminTeamMemberRelayCall_('service-rates-add', payload);
  call.then(function (res) {
    var data = (res && res.data) || {};
    btn.disabled = false;
    btn.textContent = editing ? 'Save as new draft revision' : 'Add rate';
    if (res && res.ok && data.rate) {
      jvToast(editing ? 'New draft revision saved.' : 'Rate added as a draft.', 'success');
      _tmdEditingRateId = null;
      _tmdLoadRates_(_tmdCurrent);
    } else {
      errEl.textContent = (res && res.error && res.error.message) || 'Could not add the rate, not available yet.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = 'Add rate';
    errEl.textContent = 'Error: ' + String((err && err.message) || err || '');
    errEl.style.display = 'block';
  });
}

/* ---- Pay rate card tab (2026-10-01) ---------------------------------
   DISTINCT from the Service rates tab above -- that one is contract-bound,
   per-SERVICE rates (team_member_service_rates, draft/awaiting_signature/
   active/superseded). This is a much simpler flat per-artist card (hair/
   makeup/travel/hourly, no contracts, no signature workflow), backed by a
   SEPARATE D1 table (team_member_pay_rates). Per
   state/findings/HANDOFF-team-pay-rates-admin-crm-tab-2026-10-01.md --
   own element id (tmd-pay-rates), own load/render/save functions, so the
   two features never conflate in this UI the way they're kept separate on
   the backend. Relay wiring (pay-rates-list/pay-rates-set actions on the
   admin-create-team-member entity) is owed from Cloudflare/Edge -- same
   "collapse every failure to Not available yet" discipline as every other
   not-yet-wired tab on this page, so this renders correctly today and
   starts showing real data the moment the relay + Jess's flag land, with
   zero further frontend change.
   Same "real currency figure, DOM only, never console/toast-logged" rule
   as the Service rates tab -- Jess viewing her own artists' pay rates is
   the one legitimate place in this drawer to show a dollar amount. ----- */
var TMD_PAY_RATES_COMING_SOON_ =
  'No pay rate set yet, coming soon. This becomes reachable once the relay wiring for this feature lands.';
var TMD_PAY_RATE_FIELDS_ = [
  { key: 'brideHairCents', label: 'Bride hair' },
  { key: 'brideMakeupCents', label: 'Bride makeup' },
  { key: 'partyHairCents', label: 'Party hair' },
  { key: 'partyMakeupCents', label: 'Party makeup' },
  { key: 'hourlyRateCents', label: 'Hourly rate' },
  { key: 'travelPerKmCents', label: 'Travel (per km)' }
];

function _tmdLoadPayRates_(m) {
  var el = document.getElementById('tmd-pay-rates');
  if (el) el.innerHTML = '<div class="tmd-comingsoon">Loading…</div>';
  adminTeamMemberRelayCall_('pay-rates-list', {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(m.teamMemberId)
  }).then(function (res) {
    var data = (res && res.data) || {};
    if (res && res.ok && Array.isArray(data.rates)) {
      _tmdRenderPayRates_(data.rates, data.active || null);
    } else {
      _tmdRenderComingSoon_('tmd-pay-rates', TMD_PAY_RATES_COMING_SOON_);
    }
  }).catch(function () {
    _tmdRenderComingSoon_('tmd-pay-rates', TMD_PAY_RATES_COMING_SOON_);
  });
}

function _tmdFmtPayRateAmount_(cents) {
  if (cents === null || cents === undefined || cents === '') return 'Not offered';
  return '$' + (Number(cents) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 });
}

function _tmdRenderPayRateCard_(rate, isCurrent) {
  var html = '<div class="tmd-section-label">' + (isCurrent ? 'Current rate' : 'Previous rate') + '</div>';
  TMD_PAY_RATE_FIELDS_.forEach(function (f) {
    html += '<div class="info-row">' +
      '<span class="info-label">' + escHtml(f.label) + '</span>' +
      '<span class="info-value">' + escHtml(_tmdFmtPayRateAmount_(rate[f.key])) + '</span>' +
    '</div>';
  });
  html += '<div class="info-row">' +
    '<span class="info-label">GST registered</span>' +
    '<span class="info-value">' + (rate.gstRegistered ? 'Yes' : 'No') + '</span>' +
  '</div>';
  html += '<div class="info-row">' +
    '<span class="info-label">Effective</span>' +
    '<span class="info-value">' + escHtml(rate.effectiveFrom || '') +
      (rate.effectiveTo ? ' to ' + escHtml(rate.effectiveTo) : (isCurrent ? ' to current' : '')) + '</span>' +
  '</div>';
  if (rate.note) html += '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' + escHtml(rate.note) + '</div>';
  return html;
}

function _tmdRenderPayRates_(rates, active) {
  var el = document.getElementById('tmd-pay-rates');
  if (!el) return;
  _tmdPayActive = active || null;

  var html = '';
  if (active) {
    html += _tmdRenderPayRateCard_(active, true);
  } else {
    html += '<div class="empty-state"><p>No current pay rate set.</p></div>';
  }

  var history = (rates || []).filter(function (r) { return !active || r.id !== active.id; });
  if (history.length) {
    html += '<div class="tmd-section-label">History</div>';
    history.forEach(function (r) { html += _tmdRenderPayRateCard_(r, false); });
  }

  if (active) {
    html += '<div class="acm-actions" style="justify-content:flex-end;margin-bottom:0.6rem;">' +
      '<button type="button" class="btn btn-ghost" style="font-size:0.7rem;" onclick="_tmdEditPayRateCurrent_()">Edit current rate</button></div>';
  }
  html += '<div class="tmd-section-label">Set a new rate</div>' +
    '<div id="tmd-pr-edit-hint" class="tmd-field-hint" style="display:none;"></div>' +
    '<div class="tmd-field-hint" style="margin-bottom:0.6rem;">This becomes her current rate from the date below, her previous rate stays in history. Leave a field blank if she does not offer that service.</div>';
  TMD_PAY_RATE_FIELDS_.forEach(function (f) {
    html += '<div class="tmd-field"><label>' + escHtml(f.label) + ' (AUD)</label>' +
      '<input type="number" min="0" step="0.01" id="tmd-pr-' + f.key + '" placeholder="Not offered"></div>';
  });
  html += '<div class="tmd-field"><label>Effective from</label><input type="date" id="tmd-pr-effectivefrom"></div>' +
    '<div class="tmd-field"><label>GST registered</label><select id="tmd-pr-gst">' +
      '<option value="false" selected>No</option><option value="true">Yes</option>' +
    '</select></div>' +
    '<div class="tmd-field"><label>Note (optional)</label><input type="text" id="tmd-pr-note"></div>' +
    '<div id="tmd-pr-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-primary" id="tmd-pr-save" onclick="_tmdSavePayRate_()">Set rate</button>' +
    '</div>';

  el.innerHTML = html;
  // Default the effective-from date picker to today, same convention as
  // the handoff's suggested UI shape.
  var dateEl = document.getElementById('tmd-pr-effectivefrom');
  if (dateEl) dateEl.value = new Date().toISOString().slice(0, 10);
}

function _tmdSavePayRate_() {
  if (!_tmdCurrent) return;
  var errEl = document.getElementById('tmd-pr-error');
  errEl.style.display = 'none';

  var effectiveFrom = (document.getElementById('tmd-pr-effectivefrom').value || '').trim();
  if (!effectiveFrom) { errEl.textContent = 'Effective-from date is required.'; errEl.style.display = 'block'; return; }

  var payload = {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId),
    effectiveFrom: effectiveFrom,
    gstRegistered: document.getElementById('tmd-pr-gst').value === 'true',
    // Fresh per submission, same double-click protection as the Service
    // rates "Add" form.
    idempotencyKey: 'tmd-pr-' + Date.now() + '-' + Math.random().toString(36).slice(2)
  };

  var anyFieldSet = false;
  for (var i = 0; i < TMD_PAY_RATE_FIELDS_.length; i++) {
    var f = TMD_PAY_RATE_FIELDS_[i];
    var raw = document.getElementById('tmd-pr-' + f.key).value;
    if (raw === '' || raw === null || raw === undefined) continue; // blank = "not offered", omit the field entirely
    var dollars = parseFloat(raw);
    if (!(dollars >= 0)) { errEl.textContent = 'Enter a non-negative amount for ' + f.label + '.'; errEl.style.display = 'block'; return; }
    payload[f.key] = Math.round(dollars * 100);
    anyFieldSet = true;
  }
  if (!anyFieldSet) { errEl.textContent = 'Set at least one rate field.'; errEl.style.display = 'block'; return; }

  var note = (document.getElementById('tmd-pr-note').value || '').trim();
  if (note) payload.note = note;

  var btn = document.getElementById('tmd-pr-save');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  adminTeamMemberRelayCall_('pay-rates-set', payload).then(function (res) {
    var data = (res && res.data) || {};
    btn.disabled = false;
    btn.textContent = 'Set rate';
    if (res && res.ok && data.rate) {
      jvToast('Pay rate set.', 'success');
      _tmdLoadPayRates_(_tmdCurrent);
    } else {
      errEl.textContent = (res && res.error && res.error.message) || 'Could not set the rate, not available yet.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = 'Set rate';
    errEl.textContent = 'Error: ' + String((err && err.message) || err || '');
    errEl.style.display = 'block';
  });
}

/* ---- Compensation tab (Phase 1 shell, 2026-10-07) -------------------------
   Dark-shipped behind window.TMD_COMPENSATION_ENABLED_FLAG_, written by the
   {%- assign _tmd_compensation_mf -%} + inline <script> block in
   sections/jv-admin-crm.liquid (same convention as ADMIN_CLIENTS_D1_READ_FLAG_).
   Default OFF: tab button stays display:none, old Service rates + Pay rate
   card tabs render as today. When flag ON: tab button becomes visible, old
   tabs stay rendered too for the 1-week parallel soak before Phase 4
   removes them. Reads use v1 flat-table routes unchanged (pay-rates-list +
   service-rates-list via adminTeamMemberRelayCall_). Phase 2.5 later swaps
   the reads to v2 behind the same flag; this phase introduces NO new write
   paths. See BRIEFS/SCOPE-admin-drawer-compensation-ux-consolidation-2026-10-07.md.
--------------------------------------------------------------------------- */
var TMD_COMPENSATION_ENABLED_ = (typeof window !== 'undefined' && window.TMD_COMPENSATION_ENABLED_FLAG_ === true);

function _tmdApplyCompensationFlag_() {
  // Reveal the Compensation tab button when the flag is on. When the flag is
  // ON (Phase 2.5 + Phase 3 + Phase 4 bundled, 2026-10-07) ALSO hide the old
  // tmd-rates (Service rates) + tmd-pay-rates (Pay rate card) tab buttons --
  // bundled per Jess's explicit instruction 2026-10-07, overriding the
  // original §7 "soak clean for 1wk" gate on Phase 4. Single-flag rollback:
  // flip the flag OFF -> Compensation tab hides, old tabs re-appear.
  // Loaders for the old tabs are intact; only the tab buttons go
  // display:none. v1 data stays reachable via the Phase 2.5 cache-miss
  // resolver fallback -- nothing is deleted.
  var compBtn = document.querySelector('#tmd-tabs .drawer-tab[data-pane="tmd-compensation"]');
  if (compBtn) compBtn.style.display = TMD_COMPENSATION_ENABLED_ ? '' : 'none';
  var oldRatesBtn = document.querySelector('#tmd-tabs .drawer-tab[data-pane="tmd-rates"]');
  if (oldRatesBtn) oldRatesBtn.style.display = TMD_COMPENSATION_ENABLED_ ? 'none' : '';
  var oldPayBtn = document.querySelector('#tmd-tabs .drawer-tab[data-pane="tmd-pay-rates"]');
  if (oldPayBtn) oldPayBtn.style.display = TMD_COMPENSATION_ENABLED_ ? 'none' : '';
}

function _tmdLoadCompensation_(m) {
  if (!TMD_COMPENSATION_ENABLED_) return;
  var el = document.getElementById('tmd-compensation');
  if (!el) return;
  el.innerHTML = '<div class="tmd-comingsoon">Loading…</div>';
  var memberPayload = { tenantId: 'jessica-vegas', teamMemberId: Number(m.teamMemberId) };
  // Phase 2.5 + 3 parallel fetch: v2 service-type-aware pay rates (active +
  // history), per-artist fallback defaults, AND the canonical service-key
  // list from booking_services (migration 044, D1) for the Phase 3 picker.
  // All three go through adminTeamMemberRelayCall_ -> cors-relay
  // 'admin-create-team-member' entity's new actions (see cors-relay
  // ENTITY_ACTION_PATH_OVERRIDES additions dated 2026-10-07). Any single
  // failure collapses to a null -> renderer shows a sane empty state for
  // that sub-section; never a broken shell. Flag-gated so a mis-deployment
  // (route 404 while flag ON) still shows the explicit disabled error
  // rather than a wrong rate.
  var payV2P = adminTeamMemberRelayCall_('pay-rates-v2-list', memberPayload).then(function (res) {
    var d = (res && res.data) || {};
    if (res && res.ok) {
      return {
        active: Array.isArray(d.active) ? d.active : [],
        history: Array.isArray(d.history) ? d.history : []
      };
    }
    return null;
  }).catch(function () { return null; });
  var defaultsP = adminTeamMemberRelayCall_('pay-rates-defaults-get', memberPayload).then(function (res) {
    var d = (res && res.data) || {};
    if (res && res.ok) return d.defaults || null;
    return null;
  }).catch(function () { return null; });
  var svcListP = adminTeamMemberRelayCall_('booking-services-list', { tenantId: 'jessica-vegas' }).then(function (res) {
    var d = (res && res.data) || {};
    if (res && res.ok && Array.isArray(d.services)) return d.services;
    return [];
  }).catch(function () { return []; });

  Promise.all([payV2P, defaultsP, svcListP]).then(function (out) {
    // Drop a late response unless the drawer is STILL open on this same member.
    // (Pre-2026-10-08 this only dropped on a different member, so a response
    // landing after the drawer was closed still rendered a stale pane and
    // rewrote the save context. See BUILD-admin-compensation-picker-wrong-
    // team-member-id-2026-10-08.)
    if (!_tmdCurrent || Number(_tmdCurrent.teamMemberId) !== Number(m.teamMemberId)) return;
    _tmdRenderCompensation_(out[0], out[1], out[2], m);
  });
}

// Cache the canonical service list so the inline "Set rate for <service_type>"
// form doesn't need a second round-trip when opened. Service list is small
// (< 50 rows) and changes infrequently; a drawer-open-scoped cache is enough.
var _tmdCompServiceList_ = [];
// Which member the Compensation pane was last RENDERED for. NOT a source of
// identity (that is always the open drawer, _tmdCurrent) -- only a stale-pane
// detector: a save is refused unless this equals the drawer's member.
var _tmdCompRenderedFor_ = null;

// The ONLY place a Compensation write gets its identity: the member the
// drawer is currently bound to. Returns null if the drawer is closed or the
// visible pane belongs to a different member (a stale pane must never save).
// teamMemberEmail is sent too so the Worker can verify id <-> email and
// refuse a mismatch server-side (belt and braces).
function _tmdCompIdentity_() {
  if (!_tmdCurrent) return null;
  var id = Number(_tmdCurrent.teamMemberId);
  if (!id || isNaN(id) || id < 1) return null;
  if (_tmdCompRenderedFor_ !== id) return null;
  var email = String(_tmdCurrent.email || '').trim();
  if (!email) return null;
  return { tenantId: 'jessica-vegas', teamMemberId: id, teamMemberEmail: email };
}

function _tmdRenderCompensation_(payData, defaults, serviceList, m) {
  var el = document.getElementById('tmd-compensation');
  if (!el) return;

  _tmdCompServiceList_ = Array.isArray(serviceList) ? serviceList : [];
  _tmdCompRenderedFor_ = m ? Number(m.teamMemberId) : null;

  var active = (payData && Array.isArray(payData.active)) ? payData.active : [];
  var history = (payData && Array.isArray(payData.history)) ? payData.history : [];
  // History excluding the currently-active rows (dedup by id). Keeps the
  // "Rate history" sub-section honest -- it is the SUPERSEDED entries only.
  var activeIds = {};
  active.forEach(function (r) { activeIds[r.id] = true; });
  history = history.filter(function (r) { return !activeIds[r.id]; });

  var html = '';

  // --- Sub-section 1: Current pay rates (per service_type) -----------------
  html += '<div class="tmd-section-label">Current pay rates' +
    (m && m.displayName ? ' for ' + escHtml(m.displayName) : '') + '</div>';
  html += '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
    'One row per service she provides. ' +
    'The resolver reads the rate active on the wedding date. Set a new rate to supersede.' +
  '</div>';
  if (active.length) {
    html += '<div class="tmd-comp-rate-list">';
    active.forEach(function (r) { html += _tmdRenderPayRateV2Row_(r); });
    html += '</div>';
  } else {
    html += '<div class="empty-state"><p>No service rates set yet.</p></div>';
  }
  html += '<div class="acm-actions" style="justify-content:flex-end;margin:0.4rem 0 0.9rem;">' +
    '<button type="button" class="btn btn-primary" style="font-size:0.72rem;" onclick="_tmdCompV2OpenAddForm_()">Set a rate for a service</button>' +
  '</div>';
  html += '<div id="tmd-comp-add-form" style="display:none;margin-bottom:0.9rem;"></div>';

  // --- Sub-section 2: Default fallback (hourly + travel) ------------------
  html += '<div class="tmd-section-label" style="margin-top:1rem;">Default fallback</div>';
  html += '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
    'Used when a bill does not match a specific service type above. Hourly is her generic hour-rate; travel is per-km.' +
  '</div>';
  html += _tmdRenderPayRateDefaultsBlock_(defaults);

  // --- Sub-section 3: Rate history ----------------------------------------
  html += '<div class="tmd-section-label" style="margin-top:1rem;">Rate history</div>';
  html += '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
    'Earlier rates that a newer one replaced. Most recent first.' +
  '</div>';
  if (history.length) {
    html += '<div class="tmd-comp-rate-list">';
    history.forEach(function (r) { html += _tmdRenderPayRateV2Row_(r); });
    html += '</div>';
  } else {
    html += '<div class="empty-state"><p>No earlier rates yet.</p></div>';
  }

  // --- Sub-section 4: Lock to contract (unchanged pointer) ----------------
  html += '<div class="tmd-section-label" style="margin-top:1rem;">Lock to contract</div>' +
    '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
      'A rate becomes CONTRACTUAL (vs operational) when written into a signed contract. ' +
      'The "Add ticked rates to new contract" flow still lives on the (now hidden) Service rates tab and will migrate here in a follow-up slice.' +
    '</div>';

  el.innerHTML = html;
}

// One row in the "Current pay rates" / "Rate history" list -- compact,
// read-mostly. Reuses existing .info-row / .info-label / .inv-status-chip
// classes already in jv-admin-crm.css (zero new CSS). Design-system
// compliance: no .btn-secondary, no new hex, no sharp corners (buttons
// inherit pill from .btn-primary / .btn-ghost).
function _tmdRenderPayRateV2Row_(r) {
  var amount = '$' + (Number(r.amountCents || 0) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 });
  var isActive = !r.effectiveTo;
  var statusChip = isActive
    ? '<span class="inv-status-chip active">Active</span>'
    : '<span class="inv-status-chip history">Superseded</span>';
  var periodLabel = isActive
    ? 'from ' + escHtml(r.effectiveFrom || '')
    : escHtml(r.effectiveFrom || '') + ' → ' + escHtml(r.effectiveTo || '');
  return '<div class="info-row" style="align-items:flex-start;">' +
    '<span class="info-label">' + escHtml(r.serviceType || '(unknown service)') + '</span>' +
    '<span class="info-value" style="text-align:right;">' +
      '<div><strong>' + escHtml(amount) + '</strong>' + (r.gstRegistered ? ' <small>(GST reg.)</small>' : '') + '</div>' +
      '<div class="tmd-field-hint" style="margin-top:0.15rem;">' + statusChip + ' ' + periodLabel + '</div>' +
    '</span>' +
  '</div>';
}

function _tmdRenderPayRateDefaultsBlock_(defaults) {
  var hourly = defaults && defaults.hourlyCents
    ? '$' + (Number(defaults.hourlyCents) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 }) + ' / hr'
    : '— not set —';
  var travel = defaults && defaults.travelCents
    ? '$' + (Number(defaults.travelCents) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2 }) + ' / km'
    : '— not set —';
  var html = '<div class="info-row">' +
    '<span class="info-label">Hourly fallback</span>' +
    '<span class="info-value">' + escHtml(hourly) + '</span>' +
  '</div>' +
  '<div class="info-row">' +
    '<span class="info-label">Travel per km</span>' +
    '<span class="info-value">' + escHtml(travel) + '</span>' +
  '</div>';
  html += '<div class="acm-actions" style="justify-content:flex-end;margin:0.4rem 0 0;">' +
    '<button type="button" class="btn btn-ghost" style="font-size:0.72rem;" onclick="_tmdCompV2OpenDefaultsForm_()">Edit default fallback</button>' +
  '</div>';
  html += '<div id="tmd-comp-defaults-form" style="display:none;margin-top:0.5rem;"></div>';
  return html;
}

// --- Inline "set rate for <service_type>" form (per-row add) ---------------
// Uses the Phase 3 service-key picker. The dropdown is populated from the
// booking_services D1 roster (migration 044) via booking-services-list; a
// typed service key not in the list is REJECTED with an inline error --
// forces alignment with the canonical service catalog, per SCOPE §5
// ("No service-key picker, Jess has to KNOW the canonical string"
// diagnosis).
function _tmdCompV2OpenAddForm_() {
  var form = document.getElementById('tmd-comp-add-form');
  if (!form) return;
  if (form.style.display === 'block') { form.style.display = 'none'; return; }
  var opts = '<option value="">— pick a service —</option>';
  _tmdCompServiceList_.forEach(function (s) {
    opts += '<option value="' + escAttr(s.serviceName) + '">' + escHtml(s.serviceName) +
      (s.category ? ' <small>(' + escHtml(s.category) + ')</small>' : '') + '</option>';
  });
  var today = (new Date()).toISOString().slice(0, 10);
  form.innerHTML =
    '<div class="tmd-section-label" style="margin-top:0;">Set a rate for ' + escHtml((_tmdCurrent && _tmdCurrent.displayName) || 'this artist') + '</div>' +
    '<div class="tmd-field">' +
      '<label>Service</label>' +
      '<select id="tmd-comp-add-service">' + opts + '</select>' +
      '<div class="tmd-field-hint">From the booking catalogue. Rename there, not here.</div>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Rate (dollars, GST-exclusive)</label>' +
      '<input type="number" step="0.01" min="0.01" id="tmd-comp-add-amount" placeholder="e.g. 150.00">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Effective from</label>' +
      '<input type="date" id="tmd-comp-add-from" value="' + escAttr(today) + '">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label><input type="checkbox" id="tmd-comp-add-gst"> She is GST-registered on this rate</label>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Note (optional)</label>' +
      '<input type="text" id="tmd-comp-add-note" placeholder="e.g. 2027 revise">' +
    '</div>' +
    '<div id="tmd-comp-add-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-ghost" onclick="_tmdCompV2CloseAddForm_()">Cancel</button>' +
      '<button type="button" class="btn btn-primary" onclick="_tmdCompV2SaveNewRate_()">Save rate</button>' +
    '</div>';
  form.style.display = 'block';
}

function _tmdCompV2CloseAddForm_() {
  var form = document.getElementById('tmd-comp-add-form');
  if (form) { form.innerHTML = ''; form.style.display = 'none'; }
}

function _tmdCompV2SaveNewRate_() {
  var errEl = document.getElementById('tmd-comp-add-error');
  function err(msg) { if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; } }
  var ident = _tmdCompIdentity_();
  if (!ident) return err('This panel is out of date. Close the drawer, reopen the team member, and try again.');
  var serviceType = (document.getElementById('tmd-comp-add-service').value || '').trim();
  var amountDollars = Number(document.getElementById('tmd-comp-add-amount').value);
  var effectiveFrom = (document.getElementById('tmd-comp-add-from').value || '').trim();
  var gst = document.getElementById('tmd-comp-add-gst').checked;
  var note = (document.getElementById('tmd-comp-add-note').value || '').trim();
  if (!serviceType) return err('Pick a service.');
  if (!(amountDollars > 0)) return err('Enter a positive dollar amount.');
  if (!effectiveFrom) return err('Enter an effective-from date.');
  var amountCents = Math.round(amountDollars * 100);
  // Idempotency: {tenant, member, service, effectiveFrom, cents, note hash} -- a
  // double-tap of Save on the same form submits the same key -> server returns
  // the already-inserted row rather than creating a duplicate.
  var idempotencyKey = 'ui-set-v2-' + ident.teamMemberId + '-' + serviceType.replace(/\s+/g, '_') +
    '-' + effectiveFrom + '-' + amountCents;
  var payload = Object.assign({}, ident, {
    serviceType: serviceType,
    amountCents: amountCents,
    gstRegistered: gst,
    effectiveFrom: effectiveFrom,
    note: note,
    idempotencyKey: idempotencyKey
  });
  adminTeamMemberRelayCall_('pay-rates-v2-set', payload).then(function (res) {
    if (!res || !res.ok) {
      var m = (res && res.error && res.error.message) || 'Save failed. Try again.';
      return err(m);
    }
    _tmdCompV2CloseAddForm_();
    // Re-render by reloading the whole Compensation tab -- simplest + honest,
    // guarantees the active list reflects the auto-close + new insert.
    if (_tmdCurrent) _tmdLoadCompensation_(_tmdCurrent);
  }).catch(function () { err('Network error. Try again.'); });
}

// --- Inline "edit default fallback" form -----------------------------------
function _tmdCompV2OpenDefaultsForm_() {
  var form = document.getElementById('tmd-comp-defaults-form');
  if (!form) return;
  if (form.style.display === 'block') { form.style.display = 'none'; return; }
  var today = (new Date()).toISOString().slice(0, 10);
  form.innerHTML =
    '<div class="tmd-field">' +
      '<label>Hourly fallback ($/hr, blank = not set)</label>' +
      '<input type="number" step="0.01" min="0" id="tmd-comp-def-hourly" placeholder="e.g. 75.00">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Travel per km ($/km, blank = ATO default)</label>' +
      '<input type="number" step="0.01" min="0" id="tmd-comp-def-travel" placeholder="e.g. 0.88">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Effective from</label>' +
      '<input type="date" id="tmd-comp-def-from" value="' + escAttr(today) + '">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label><input type="checkbox" id="tmd-comp-def-gst"> She is GST-registered on these fallbacks</label>' +
    '</div>' +
    '<div id="tmd-comp-def-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-ghost" onclick="_tmdCompV2CloseDefaultsForm_()">Cancel</button>' +
      '<button type="button" class="btn btn-primary" onclick="_tmdCompV2SaveDefaults_()">Save defaults</button>' +
    '</div>';
  form.style.display = 'block';
}

function _tmdCompV2CloseDefaultsForm_() {
  var form = document.getElementById('tmd-comp-defaults-form');
  if (form) { form.innerHTML = ''; form.style.display = 'none'; }
}

function _tmdCompV2SaveDefaults_() {
  var errEl = document.getElementById('tmd-comp-def-error');
  function err(msg) { if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; } }
  var ident = _tmdCompIdentity_();
  if (!ident) return err('This panel is out of date. Close the drawer, reopen the team member, and try again.');
  var hourlyRaw = document.getElementById('tmd-comp-def-hourly').value;
  var travelRaw = document.getElementById('tmd-comp-def-travel').value;
  var effectiveFrom = (document.getElementById('tmd-comp-def-from').value || '').trim();
  var gst = document.getElementById('tmd-comp-def-gst').checked;
  if (!effectiveFrom) return err('Enter an effective-from date.');
  function toCents(raw) {
    if (raw === '' || raw === null || raw === undefined) return null;
    var n = Number(raw);
    if (!(n > 0)) return 'ERR';
    return Math.round(n * 100);
  }
  var hourlyCents = toCents(hourlyRaw);
  if (hourlyCents === 'ERR') return err('Hourly must be a positive dollar amount, or left blank.');
  var travelCents = toCents(travelRaw);
  if (travelCents === 'ERR') return err('Travel must be a positive dollar amount, or left blank.');

  var payload = Object.assign({}, ident, {
    hourlyCents: hourlyCents,
    travelCents: travelCents,
    gstRegistered: gst,
    effectiveFrom: effectiveFrom
  });
  adminTeamMemberRelayCall_('pay-rates-defaults-set', payload).then(function (res) {
    if (!res || !res.ok) {
      var m = (res && res.error && res.error.message) || 'Save failed. Try again.';
      return err(m);
    }
    _tmdCompV2CloseDefaultsForm_();
    if (_tmdCurrent) _tmdLoadCompensation_(_tmdCurrent);
  }).catch(function () { err('Network error. Try again.'); });
}

// Deprecated Phase 1 helper. Kept as a no-op shim because the Phase 1 shell
// shipped it as a public attr-callback target in the drawer HTML. Removing
// outright would cause a ReferenceError if an old cached pane is still open
// in a tab somewhere during the deploy window. Phase 4+1 will remove it
// along with the hidden tmd-rates / tmd-pay-rates panes.
function _tmdCompensationEditCurrent_() {
  // Phase 2.5 moves rate editing INLINE on the Compensation tab via
  // _tmdCompV2OpenAddForm_(); no need to tab-switch back to a hidden pane.
  _tmdCompV2OpenAddForm_();
}

/* ---- Profile tab: name/email/role-adjacent identity + address ---- */
function _tmdRenderProfile_(m) {
  var el = document.getElementById('tmd-profile');
  if (!el) return;
  el.innerHTML =
    '<div class="tmd-section-label">Identity</div>' +
    '<div class="tmd-field">' +
      '<label>Full name</label>' +
      '<input type="text" id="tmd-p-name" value="' + escAttr(m.displayName || '') + '">' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Email <span class="acm-hint">(not editable here)</span></label>' +
      '<input type="text" value="' + escAttr(m.email || '') + '" disabled>' +
    '</div>' +
    '<div class="tmd-section-label">Contact &amp; engagement</div>' +
    '<div class="tmd-field">' +
      '<label>Home / studio address</label>' +
      '<input type="text" id="tmd-p-address" value="' + escAttr(m.homeAddress || '') + '" placeholder="Feeds travel fees">' +
      '<div class="tmd-field-hint">What she entered herself via her own onboarding, where available. Admin edits here are saved and logged.</div>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Postal address</label>' +
      '<input type="text" id="tmd-p-postal" value="' + escAttr(m.postalAddress || '') + '" placeholder="Not set yet">' +
      '<div class="tmd-field-hint">Admin edits here are saved and logged, same as the address above.</div>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Engagement type</label>' +
      '<select id="tmd-p-engagement">' +
        '<option value=""' + (!m.engagementType ? ' selected' : '') + '>&mdash; not set &mdash;</option>' +
        '<option value="subcontractor"' + (m.engagementType === 'subcontractor' ? ' selected' : '') + '>Subcontractor</option>' +
        '<option value="employee"' + (m.engagementType === 'employee' ? ' selected' : '') + '>Employee</option>' +
      '</select>' +
      '<div class="tmd-field-hint">Drives which Contractor Agreement wording applies at countersign.</div>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Start date</label>' +
      '<input type="date" id="tmd-p-startdate" value="' + escAttr(m.startDate || '') + '">' +
    '</div>' +
    '<div id="tmd-p-error" class="acm-error" style="display:none;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-primary" id="tmd-p-save" onclick="_tmdSaveProfile_()">Save</button>' +
    '</div>';
  /* Admin-authoritative GST status for Xero Bills (2026-10-07, Xero Bills
     lane coordination with jvbusiness-2026-63 per
     state/findings/CONTRACT-xero-supplier-field-requirements-2026-10-07.md).
     Called AFTER the innerHTML assignment above — placing it inside the string
     concat (as it was prior to the 2026-10-07 render-fix) caused the function
     to execute first and its insertAdjacentHTML to write into a DOM that the
     outer innerHTML= then wiped; its undefined return was also appended as
     the literal string "undefined". Try/catch so any future upstream failure
     cannot short-circuit Profile tab render. ----- */
  /* Phone display (Admin CRM Compensation tab Phase 2, 2026-10-07). Reads the
     artist's phone from her artist-identity blob on jv-next-pilot via the
     'admin-create-team-member' / get-phone cors-relay carve-out — zero new
     GAS, zero new sheet column, zero new cron. Positioned AFTER the identity
     block (via the innerHTML above) and BEFORE the GST block below, so the
     Profile tab reads: Identity → Phone → GST. Mirrors the GST relocation
     pattern (commit dd5cb472c): called AFTER the innerHTML assignment, inside
     try/catch, so a phone-side failure (network, legacy artist with no
     identity blob) never short-circuits Profile render or breaks drawer
     open. Informational / read-only — no write path. ----- */
  try { _tmdRenderAdminPhone_(m); } catch (e) { try { console.error('[tmd] Phone render failed:', e); } catch (_) {} }
  try { _tmdRenderAdminGst_(m); } catch (e) { try { console.error('[tmd] GST render failed:', e); } catch (_) {} }
  try { _tmdRenderSignedContract_(m); } catch (e) { try { console.error('[tmd] Signed contract render failed:', e); } catch (_) {} }
}

/* ---- Team Contracts v1.2: Signed Contract viewer (2026-10-07) ----
   Reads frozen signed-contract state from the artist-identity blob
   (codeOfConductSignedBody + codeOfConductSignedBodyRates + ...SignedAt
   + ...SignedName + ...VersionSigned, persisted at sign time by the
   v1.2 Team App flow). Read-only, zero new network call: reuses the
   SAME 'get-phone' relay carve-out the phone renderer already uses
   (hits /admin/artist-identity on jv-next-pilot, which returns the
   full identity blob — the phone renderer just picks the phone off
   it). The whole section + modal is wrapped in a gate on the
   shop-level 'team_cf_contracts_v12' flag emitted server-side as
   window.JV_TEAM_CONTRACTS_V12_ENABLED, so it stays invisible until
   the full v1.2 slice is activated. Every render path is defensively
   try/catch'd so a parse/network failure never kills drawer open.
   ----- */

/* Shared identity-blob promise cache so Phone/GST/Contract renderers
   share ONE /admin/artist-identity call per drawer open per email.
   Keyed by lowercase email, cleared when the drawer closes (teamMemberId
   switches). Lazily populated — the Phone renderer still runs its own
   call too (first in; this cache stores its promise), so no coordination
   change is required on existing call paths. */
var _tmdIdentityPromiseByEmail_ = Object.create(null);
function _tmdFetchIdentityOnce_(email) {
  var key = String(email || '').trim().toLowerCase();
  if (!key) return Promise.resolve({ ok: false });
  if (_tmdIdentityPromiseByEmail_[key]) return _tmdIdentityPromiseByEmail_[key];
  var p;
  try {
    p = adminTeamMemberRelayCall_('get-phone', { email: key }).catch(function (e) {
      try { console.warn('[tmd] identity fetch failed', e); } catch (_) {}
      return { ok: false };
    });
  } catch (e) {
    p = Promise.resolve({ ok: false });
  }
  _tmdIdentityPromiseByEmail_[key] = p;
  return p;
}

function _tmdRenderSignedContract_(m) {
  var gate = (typeof window !== 'undefined' && window.JV_TEAM_CONTRACTS_V12_ENABLED) ? window.JV_TEAM_CONTRACTS_V12_ENABLED : null;
  // Belt-and-braces: accept truthy string 'true'/'1' or boolean true. Anything else = hidden.
  var enabled = (gate === true || gate === 'true' || gate === '1' || gate === 1);
  if (!enabled) return;

  var profileEl = document.getElementById('tmd-profile');
  if (!profileEl) return;
  var email = String((m && m.email) || '').trim().toLowerCase();
  if (!email) return;

  // Reserve the DOM slot now so render order (after GST) is stable.
  var slot = document.createElement('div');
  slot.id = 'tmd-signed-contract-slot';
  slot.style.display = 'none';
  profileEl.appendChild(slot);

  _tmdFetchIdentityOnce_(email).then(function (resp) {
    try {
      if (!resp || resp.ok === false) return; // silent — honest default
      var d = (resp && resp.data && typeof resp.data === 'object') ? resp.data : (resp || {});
      var id = (d.identity && typeof d.identity === 'object') ? d.identity : d;
      var body = id && id.codeOfConductSignedBody ? String(id.codeOfConductSignedBody) : '';
      if (!body) return; // never signed → render nothing (brief requirement)

      var version = id.codeOfConductVersionSigned ? String(id.codeOfConductVersionSigned) : '';
      var signedName = id.codeOfConductSignedName ? String(id.codeOfConductSignedName) : '';
      var signedAtRaw = id.codeOfConductSignedAt ? String(id.codeOfConductSignedAt) : '';
      var signedAtPretty = _tmdFormatSydneyDate_(signedAtRaw);
      var ratesRaw = id.codeOfConductSignedBodyRates;

      // Stash the artifact on the slot element so the modal opener does
      // not need to re-read the promise (local-first after first paint).
      try {
        slot._contract = {
          version: version,
          body: body,
          ratesJson: ratesRaw,
          signedName: signedName,
          signedAt: signedAtRaw,
          signedAtPretty: signedAtPretty,
          artistName: (m && (m.displayName || m.name)) || signedName || 'this artist'
        };
      } catch (_) {}

      var label = 'Signed Contract' + (version ? (' (v' + escHtml(version) + ')') : '');
      var signerLine = '';
      if (signedName || signedAtPretty) {
        signerLine = 'Signed by: ' + escHtml(signedName || 'unknown')
                   + (signedAtPretty ? (', ' + escHtml(signedAtPretty)) : '');
      }

      slot.innerHTML =
        '<div class="tmd-section-label" style="margin-top:1rem;">' + label + '</div>' +
        '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
          'Frozen artifact from the Team App Code of Conduct sign step. ' +
          'Includes the exact rates the artist signed off on at that moment — ' +
          'tamper-proof, read-only here.' +
        '</div>' +
        (signerLine ? ('<div class="tmd-field" style="margin:0 0 .55rem;"><label style="font-size:.72rem;">' + signerLine + '</label></div>') : '') +
        '<div class="acm-actions" style="justify-content:flex-start;">' +
          '<button type="button" class="btn btn-ghost" id="tmd-sc-view">View full doc</button>' +
        '</div>';
      slot.style.display = '';

      var btn = slot.querySelector('#tmd-sc-view');
      if (btn) {
        btn.addEventListener('click', function () {
          try { _tmdSignedContractModal_show_(slot._contract); }
          catch (e) { try { console.error('[tmd] signed contract modal failed', e); } catch (_) {} }
        });
      }
    } catch (e) {
      try { console.error('[tmd] signed contract parse failed', e); } catch (_) {}
    }
  });
}

/* Australia/Sydney, "D MMM YYYY" (e.g. "7 Oct 2026") — matches jv-ui doctrine. */
function _tmdFormatSydneyDate_(iso) {
  if (!iso) return '';
  try {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    // Use Intl in en-AU with Australia/Sydney for the day/month/year parts.
    var fmt = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
    // en-AU with 'short' month returns e.g. "7 Oct 2026" already — no comma.
    return fmt.format(d).replace(/\./g, '');
  } catch (_) { return ''; }
}

function _tmdSignedContractModal_injectStyles_() {
  if (document.getElementById('jv-tmd-sc-styles')) return;
  var s = document.createElement('style');
  s.id = 'jv-tmd-sc-styles';
  s.textContent = [
    '.jv-tmd-sc-overlay{position:fixed;inset:0;background:rgba(30,23,22,.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;animation:jvLockFadeIn .18s ease}',
    '.jv-tmd-sc-modal{background:var(--brand-bg-white,#fff);border-radius:var(--radius-large,1.5rem);padding:1.75rem 2rem;max-width:720px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 20px 60px rgba(47,37,36,.18);font-family:"Plus Jakarta Sans",sans-serif;color:var(--brand-text,#2f2524)}',
    '.jv-tmd-sc-head{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:.4rem}',
    '.jv-tmd-sc-head h3{font-family:"Raleway",sans-serif;font-weight:300;font-size:1.3rem;color:var(--brand-dark,#1e1716);margin:0;letter-spacing:.01em}',
    '.jv-tmd-sc-close{background:transparent;border:none;font-size:1.6rem;line-height:1;color:#7e706c;cursor:pointer;padding:.1rem .55rem;border-radius:var(--radius-pill,3rem);transition:background .15s}',
    '.jv-tmd-sc-close:hover{background:var(--brand-bg-soft,#f6f1ee);color:var(--brand-dark,#1e1716)}',
    '.jv-tmd-sc-sub{font-size:.78rem;color:#7e706c;margin:0 0 1rem}',
    '.jv-tmd-sc-signer{display:flex;flex-direction:column;gap:.2rem;padding:.75rem 1rem;background:var(--brand-bg-soft,#f6f1ee);border-radius:var(--radius-medium,1rem);margin:0 0 1rem;font-size:.78rem;color:var(--brand-text,#2f2524)}',
    '.jv-tmd-sc-signer strong{font-weight:600;color:var(--brand-dark,#1e1716)}',
    '.jv-tmd-sc-doc{font-family:"Plus Jakarta Sans",sans-serif;font-size:.9rem;line-height:1.55;color:var(--brand-text,#2f2524);white-space:pre-wrap;word-wrap:break-word;padding:1rem 1.1rem;background:var(--brand-bg-white,#fff);border:1px solid #ede8e6;border-radius:var(--radius-medium,1rem);margin:0 0 1rem;max-height:50vh;overflow-y:auto}',
    '.jv-tmd-sc-rates{padding:1rem 1.1rem;background:#f9f5f3;border-radius:var(--radius-medium,1rem);margin:0 0 1rem}',
    '.jv-tmd-sc-rates-head{font-family:"Raleway",sans-serif;font-weight:500;font-size:.72rem;text-transform:uppercase;letter-spacing:.12em;color:var(--brand-primary-deep,#a9706c);margin:0 0 .5rem}',
    '.jv-tmd-sc-rates pre{margin:0;font-family:"Plus Jakarta Sans",monospace;font-size:.78rem;color:var(--brand-dark,#1e1716);white-space:pre-wrap;word-wrap:break-word}',
    '.jv-tmd-sc-rates-row{display:flex;justify-content:space-between;gap:.75rem;padding:.3rem 0;border-bottom:1px dashed #ede8e6;font-size:.82rem}',
    '.jv-tmd-sc-rates-row:last-child{border-bottom:none}',
    '.jv-tmd-sc-rates-key{color:var(--brand-text,#2f2524);font-weight:500}',
    '.jv-tmd-sc-rates-val{color:var(--brand-dark,#1e1716);font-weight:600}',
    '.jv-tmd-sc-footer{display:flex;gap:.75rem;justify-content:flex-end;margin-top:1rem;padding-top:1rem;border-top:1px solid #f0ebe9;flex-wrap:wrap}',
    '.jv-tmd-sc-footer .btn-ghost{background:transparent;border:1px solid #d1d5db;border-radius:var(--radius-pill,3rem);padding:.55rem 1.4rem;font-weight:600;font-size:.85rem;cursor:pointer;color:var(--brand-text,#2f2524)}',
    '.jv-tmd-sc-footer .btn-ghost:hover{background:var(--brand-bg-soft,#f6f1ee)}'
  ].join('');
  document.head.appendChild(s);
}

function _tmdSignedContractModal_renderRates_(ratesJson) {
  var parsed;
  if (ratesJson == null) return '';
  if (typeof ratesJson === 'string') {
    try { parsed = JSON.parse(ratesJson); } catch (_) { parsed = null; }
  } else if (typeof ratesJson === 'object') {
    parsed = ratesJson;
  }
  if (!parsed || typeof parsed !== 'object') {
    // Fall back to a pre-wrapped raw view (never fail the whole modal).
    return '<div class="jv-tmd-sc-rates">' +
      '<div class="jv-tmd-sc-rates-head">Signed rate snapshot</div>' +
      '<pre>' + escHtml(typeof ratesJson === 'string' ? ratesJson : JSON.stringify(ratesJson)) + '</pre>' +
      '</div>';
  }
  var rows = [];
  Object.keys(parsed).forEach(function (k) {
    var v = parsed[k];
    var display;
    if (v == null) display = '—';
    else if (typeof v === 'object') display = JSON.stringify(v);
    else display = String(v);
    rows.push(
      '<div class="jv-tmd-sc-rates-row">' +
        '<span class="jv-tmd-sc-rates-key">' + escHtml(k) + '</span>' +
        '<span class="jv-tmd-sc-rates-val">' + escHtml(display) + '</span>' +
      '</div>'
    );
  });
  if (!rows.length) return '';
  return '<div class="jv-tmd-sc-rates">' +
    '<div class="jv-tmd-sc-rates-head">Signed rate snapshot</div>' +
    rows.join('') +
    '</div>';
}

function _tmdSignedContractModal_show_(contract) {
  if (!contract || !contract.body) return;
  _tmdSignedContractModal_injectStyles_();

  var overlay = document.createElement('div');
  overlay.className = 'jv-tmd-sc-overlay';

  var versionLabel = contract.version ? ' (v' + escHtml(contract.version) + ')' : '';
  var signerHtml = '';
  if (contract.signedName || contract.signedAtPretty) {
    signerHtml =
      '<div class="jv-tmd-sc-signer">' +
        (contract.signedName ? '<div><strong>Signed by:</strong> ' + escHtml(contract.signedName) + '</div>' : '') +
        (contract.signedAtPretty ? '<div><strong>When:</strong> ' + escHtml(contract.signedAtPretty) + ' (Australia/Sydney)</div>' : '') +
      '</div>';
  }

  var ratesHtml = '';
  try { ratesHtml = _tmdSignedContractModal_renderRates_(contract.ratesJson); }
  catch (e) { try { console.warn('[tmd] rates render failed', e); } catch (_) {} ratesHtml = ''; }

  overlay.innerHTML =
    '<div class="jv-tmd-sc-modal" role="dialog" aria-modal="true" aria-label="Signed Contract">' +
      '<div class="jv-tmd-sc-head">' +
        '<h3>Signed Contract' + versionLabel + '</h3>' +
        '<button type="button" class="jv-tmd-sc-close" id="jv-tmd-sc-x" aria-label="Close">&times;</button>' +
      '</div>' +
      '<p class="jv-tmd-sc-sub">Frozen artifact. The rates below are the ones the artist signed off on at that moment — not the current rates.</p>' +
      signerHtml +
      '<div class="jv-tmd-sc-doc">' + escHtml(contract.body) + '</div>' +
      ratesHtml +
      '<div class="jv-tmd-sc-footer">' +
        '<button type="button" class="btn btn-ghost" id="jv-tmd-sc-done">Close</button>' +
      '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  function close_() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) { close_(); return; }
    if (e.target && (e.target.id === 'jv-tmd-sc-x' || e.target.id === 'jv-tmd-sc-done')) { close_(); return; }
  });
  // ESC to close — same ergonomics as the pricing modal
  var keyHandler = function (e) {
    if (e.key === 'Escape') { close_(); document.removeEventListener('keydown', keyHandler); }
  };
  document.addEventListener('keydown', keyHandler);
}

function _tmdRenderAdminPhone_(m) {
  var profileEl = document.getElementById('tmd-profile');
  if (!profileEl) return;
  var html =
    '<div class="tmd-section-label" style="margin-top:1rem;">Phone (admin read)</div>' +
    '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
      'Read from her own artist-identity record — what she entered via onboarding or her team profile. ' +
      'Admin view only here; she edits it from her side.' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Phone</label>' +
      '<input type="text" id="tmd-phone-display" value="" disabled placeholder="Loading…">' +
    '</div>';
  profileEl.insertAdjacentHTML('beforeend', html);

  // Populate from jv-next-pilot via the admin-create-team-member/get-phone
  // carve-out (reuses the existing adminTeamMemberRelayCall_ helper, same
  // transport pattern as every other admin-team-member read on this page —
  // native fetch, text/plain, JSON body, window._jvAdminProxyBase). Honest
  // defaults on every failure branch: a stale cors-relay deploy, a 404 on
  // a flag-gated downstream route, a legacy artist with no identity blob,
  // or a plain network error all show "Not on file" rather than a broken
  // empty input — never a false claim that a number is or isn't set.
  var email = String((m && m.email) || '').trim().toLowerCase();
  if (!email) {
    var input0 = document.getElementById('tmd-phone-display');
    if (input0) { input0.value = ''; input0.placeholder = 'No email on file'; }
    return;
  }
  try {
    adminTeamMemberRelayCall_('get-phone', { email: email }).then(function (resp) {
      var input = document.getElementById('tmd-phone-display');
      if (!input) return;
      // Accept both the sibling-route shape { data: { identity: { phone } } }
      // and a flatter { phone } / { data: { phone } } envelope — same
      // dual-shape tolerance as _tmdRenderAdminGst_, so an alignment skew
      // between lanes doesn't blank the display.
      var d = (resp && resp.data && typeof resp.data === 'object') ? resp.data : (resp || {});
      var phone = '';
      if (d.identity && typeof d.identity === 'object' && d.identity.phone) phone = String(d.identity.phone);
      else if (d.phone) phone = String(d.phone);
      if (!resp || resp.ok === false || !phone) {
        input.value = '';
        input.placeholder = 'Not on file';
        return;
      }
      input.value = phone;
      input.placeholder = '';
    }).catch(function (e) {
      try { console.warn('[tmd] Phone get failed, defaulting blank', e); } catch (_) {}
      var input = document.getElementById('tmd-phone-display');
      if (input) { input.value = ''; input.placeholder = 'Not on file'; }
    });
  } catch (e) {
    try { console.warn('[tmd] Phone get threw, defaulting blank', e); } catch (_) {}
    var input2 = document.getElementById('tmd-phone-display');
    if (input2) { input2.value = ''; input2.placeholder = 'Not on file'; }
  }
}

function _tmdRenderAdminGst_(m) {
  var profileEl = document.getElementById('tmd-profile');
  if (!profileEl) return;
  var abn = '';
  var html =
    '<div class="tmd-section-label" style="margin-top:1rem;">GST Status for Xero Bills (admin-authoritative)</div>' +
    '<div class="tmd-field-hint" style="margin:-0.3rem 0 0.6rem;">' +
      'Admin-set value used when this artist\'s bill arrives for Xero. ' +
      'Setting it here pre-approves her bills so they skip NEEDS_INFO on first arrival. ' +
      'Different from the Pay Rate Card tab\'s per-rate GST toggle (that\'s per rate-card version, this is her Xero-filing status).' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Is she GST registered?</label>' +
      '<select id="tmd-gst-registered">' +
        '<option value="" selected>— not set —</option>' +
        '<option value="true">Yes</option>' +
        '<option value="false">No</option>' +
      '</select>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>ABN (optional, saved alongside)</label>' +
      '<input type="text" id="tmd-gst-abn" value="' + escAttr(abn) + '" placeholder="e.g. 12 345 678 901">' +
    '</div>' +
    '<div id="tmd-gst-error" class="acm-error" style="display:none;"></div>' +
    '<div id="tmd-gst-success" class="acm-hint" style="display:none;color:var(--success,#1f6b46);"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-primary" id="tmd-gst-save" onclick="_tmdSaveAdminGst_()">Set GST status</button>' +
    '</div>' +
    '<div id="tmd-gst-meta" class="tmd-field-hint" style="margin-top:0.4rem;display:none;"></div>';
  profileEl.insertAdjacentHTML('beforeend', html);

  // Populate current value from jv-payment-service via the cors-relay carve-out.
  // Null / unknown response = "never set", leave the default blank so admin
  // sets it explicitly. Response-shape coordination with the Payments lane: we
  // accept both { data: { gst_registered, abn, set_by, set_at } } (the shape
  // sibling admin routes return) and a bare { gst_registered, ... } top-level
  // envelope, so an alignment skew between lanes doesn't blank the display.
  var email = String((m && m.email) || '').trim().toLowerCase();
  if (!email) return;
  try {
    artistBillsCall_('get-gst', 'adminApi_getArtistGst', { email: email }).then(function (resp) {
      var d = (resp && resp.data && typeof resp.data === 'object') ? resp.data : (resp || {});
      if (!resp || resp.ok === false) return; // honest-unchecked: leave blank
      if (d.gst_registered !== 1 && d.gst_registered !== 0 && d.gst_registered !== true && d.gst_registered !== false) return;
      var sel = document.getElementById('tmd-gst-registered');
      if (sel) sel.value = (d.gst_registered === 1 || d.gst_registered === true) ? 'true' : 'false';
      if (d.abn) {
        var abnEl = document.getElementById('tmd-gst-abn');
        if (abnEl && !abnEl.value) abnEl.value = String(d.abn);
      }
      if (d.set_by || d.set_at) {
        var meta = document.getElementById('tmd-gst-meta');
        if (meta) {
          var who = d.set_by ? String(d.set_by) : 'unknown';
          var when = d.set_at ? String(d.set_at) : '';
          meta.textContent = 'Last set by ' + who + (when ? (' on ' + when) : '') + '.';
          meta.style.display = 'block';
        }
      }
    }).catch(function (e) { try { console.warn('[tmd] GST get failed, defaulting blank', e); } catch (_) {} });
  } catch (e) { try { console.warn('[tmd] GST get threw, defaulting blank', e); } catch (_) {} }
}

function _tmdSaveAdminGst_() {
  if (!_tmdCurrent) return;
  var errEl = document.getElementById('tmd-gst-error');
  var okEl = document.getElementById('tmd-gst-success');
  errEl.style.display = 'none';
  okEl.style.display = 'none';

  var raw = document.getElementById('tmd-gst-registered').value;
  if (raw !== 'true' && raw !== 'false') {
    errEl.textContent = 'Pick Yes or No — leaving it blank keeps her bills in NEEDS_INFO.';
    errEl.style.display = 'block';
    return;
  }
  var email = String(_tmdCurrent.email || '').trim().toLowerCase();
  if (!email) {
    errEl.textContent = 'This artist has no email on file. Set her email first via Profile → Save.';
    errEl.style.display = 'block';
    return;
  }
  var abn = (document.getElementById('tmd-gst-abn').value || '').trim().replace(/\s+/g, '');
  if (abn && !/^\d{11}$/.test(abn)) {
    errEl.textContent = 'ABN should be 11 digits. Leave blank to skip.';
    errEl.style.display = 'block';
    return;
  }

  var btn = document.getElementById('tmd-gst-save');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  var payload = { email: email, gstRegistered: raw === 'true' };
  if (abn) payload.abn = abn;

  artistBillsCall_('set-gst', 'adminApi_setArtistGst', payload).then(function (res) {
    btn.disabled = false;
    btn.textContent = 'Set GST status';
    if (res && res.ok) {
      var requeued = Number((res.data && res.data.requeued) || res.requeued || 0);
      okEl.textContent = 'Saved. ' + (requeued > 0
        ? requeued + ' bill(s) re-queued for Xero on the next drain.'
        : 'No bills were waiting in NEEDS_INFO for her.');
      okEl.style.display = 'block';
    } else {
      errEl.textContent = (res && (res.message || (res.error && res.error.message) || res.error)) || 'Could not save GST status.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = 'Set GST status';
    errEl.textContent = 'Error: ' + String((err && err.message) || err || '');
    errEl.style.display = 'block';
  });
}

function _tmdSaveProfile_() {
  if (!_tmdCurrent) return;
  var name = (document.getElementById('tmd-p-name').value || '').trim();
  var address = (document.getElementById('tmd-p-address').value || '').trim();
  var postalEl = document.getElementById('tmd-p-postal');
  var postal = postalEl ? postalEl.value.trim() : '';
  var engagementEl = document.getElementById('tmd-p-engagement');
  var engagement = engagementEl ? engagementEl.value : '';
  var startDateEl = document.getElementById('tmd-p-startdate');
  var startDate = startDateEl ? startDateEl.value.trim() : '';
  var errEl = document.getElementById('tmd-p-error');
  errEl.style.display = 'none';
  if (!name) { errEl.textContent = 'Full name is required.'; errEl.style.display = 'block'; return; }

  var btn = document.getElementById('tmd-p-save');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  var payload = {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId),
    displayName: name,
    homeAddress: address,
    postalAddress: postal
  };
  // engagementType/startDate are validated server-side (teamMemberUpdateHttp.ts)
  // and reject an empty string -- omit the key entirely rather than sending ''
  // when the admin left either unset/cleared.
  if (engagement) payload.engagementType = engagement;
  if (startDate) payload.startDate = startDate;

  adminTeamMemberRelayCall_('update', payload).then(function (res) {
    var data = (res && res.data) || {};
    btn.disabled = false;
    btn.textContent = 'Save';
    if (res && res.ok && data.ok && data.row) {
      _teamRosterApplyUpdatedRow_(data.row);
      _tmdCurrent = _teamRosterFindMember_(_tmdCurrent.teamMemberId) || _tmdCurrent;
      document.getElementById('tmd-name').textContent = _tmdCurrent.displayName || '(no name)';
      jvToast('Profile saved.', 'success');
    } else {
      errEl.textContent = (res && res.error && res.error.message) || 'Failed to save.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = 'Save';
    errEl.textContent = 'Error: ' + String((err && err.message) || err || '');
    errEl.style.display = 'block';
  });
}

/* ---- Scheduling tab: today's edit-modal content, moved -- see brief 7.2#2 ---- */
function _tmdRenderScheduling_(m) {
  var el = document.getElementById('tmd-scheduling');
  if (!el) return;
  var skills = m.skills || {};
  el.innerHTML =
    '<div class="tmd-section-label">Role &amp; seniority</div>' +
    '<div class="tmd-field">' +
      '<label>Role</label>' +
      '<select id="tmd-s-role">' +
        '<option value="lead"' + (m.role === 'lead' ? ' selected' : '') + '>Lead Artist</option>' +
        '<option value="support"' + (m.role === 'support' ? ' selected' : '') + '>Support Artist</option>' +
      '</select>' +
    '</div>' +
    '<div class="tmd-field">' +
      '<label>Seniority</label>' +
      '<input type="number" id="tmd-s-seniority" value="' + escAttr(m.seniority != null ? String(m.seniority) : '') + '">' +
    '</div>' +
    '<div class="tmd-section-label">Skills</div>' +
    '<div class="tmd-skill-row">' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-hairbasic"' + (skills.hairBasic ? ' checked' : '') + '> Hair (basic)</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-hairadvanced"' + (skills.hairAdvanced ? ' checked' : '') + '> Hair (advanced)</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-hollywoodwaves"' + (skills.hollywoodWaves ? ' checked' : '') + '> Hollywood Waves</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-makeup"' + (skills.makeup ? ' checked' : '') + '> Makeup</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-flowergirl"' + (skills.flowergirl ? ' checked' : '') + '> Flowergirl</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-bridefullhmu"' + (skills.brideFullHmu ? ' checked' : '') + '> Bride full HMU</label>' +
      '<label class="tmd-skill-label"><input type="checkbox" id="tmd-s-assisting"' + (skills.assisting ? ' checked' : '') + '> Assisting</label>' +
    '</div>' +
    '<div class="tmd-section-label">Hours &amp; capacity <span class="acm-hint" style="text-transform:none;letter-spacing:0;font-weight:400;">(view only -- not editable here yet)</span></div>' +
    '<div class="info-row"><span class="info-label">Earliest start</span><span class="info-value">' + (m.earliestStart ? escHtml(m.earliestStart) : '&mdash;') + '</span></div>' +
    '<div class="info-row"><span class="info-label">Latest finish</span><span class="info-value">' + (m.latestFinish ? escHtml(m.latestFinish) : '&mdash;') + '</span></div>' +
    '<div class="info-row"><span class="info-label">Max mixed services</span><span class="info-value">' + (m.maxMixedServices != null ? escHtml(String(m.maxMixedServices)) : '&mdash;') + '</span></div>' +
    '<div class="info-row"><span class="info-label">Max single services</span><span class="info-value">' + (m.maxSingleServices != null ? escHtml(String(m.maxSingleServices)) : '&mdash;') + '</span></div>' +
    '<div id="tmd-s-error" class="acm-error" style="display:none;margin-top:0.75rem;"></div>' +
    '<div class="acm-actions" style="justify-content:flex-end;">' +
      '<button type="button" class="btn btn-primary" id="tmd-s-save" onclick="_tmdSaveScheduling_()">Save</button>' +
    '</div>';
}

function _tmdSaveScheduling_() {
  if (!_tmdCurrent) return;
  var role = document.getElementById('tmd-s-role').value;
  var seniorityRaw = document.getElementById('tmd-s-seniority').value;
  var errEl = document.getElementById('tmd-s-error');
  errEl.style.display = 'none';
  if (TEAM_MEMBER_ROLES.indexOf(role) === -1) { errEl.textContent = 'Pick a role.'; errEl.style.display = 'block'; return; }

  var payload = {
    tenantId: 'jessica-vegas',
    teamMemberId: Number(_tmdCurrent.teamMemberId),
    role: role,
    skillHairBasic: document.getElementById('tmd-s-hairbasic').checked,
    skillHairAdvanced: document.getElementById('tmd-s-hairadvanced').checked,
    skillHollywoodWaves: document.getElementById('tmd-s-hollywoodwaves').checked,
    skillMakeup: document.getElementById('tmd-s-makeup').checked,
    skillFlowergirl: document.getElementById('tmd-s-flowergirl').checked,
    skillBrideFullHmu: document.getElementById('tmd-s-bridefullhmu').checked,
    skillAssisting: document.getElementById('tmd-s-assisting').checked
  };
  if (seniorityRaw !== '') payload.seniority = Number(seniorityRaw);

  var btn = document.getElementById('tmd-s-save');
  btn.disabled = true;
  btn.textContent = 'Saving…';

  adminTeamMemberRelayCall_('update', payload).then(function (res) {
    var data = (res && res.data) || {};
    btn.disabled = false;
    btn.textContent = 'Save';
    if (res && res.ok && data.ok && data.row) {
      _teamRosterApplyUpdatedRow_(data.row);
      _tmdCurrent = _teamRosterFindMember_(_tmdCurrent.teamMemberId) || _tmdCurrent;
      jvToast('Scheduling saved.', 'success');
    } else {
      errEl.textContent = (res && res.error && res.error.message) || 'Failed to save.';
      errEl.style.display = 'block';
    }
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = 'Save';
    errEl.textContent = 'Error: ' + String((err && err.message) || err || '');
    errEl.style.display = 'block';
  });
}

/* ============================================================
   PARTNER-MANAGED WELCOME PROMPT (2026-08-11)
   Follow-up to a partner-managed create. Explicit, never automatic. See
   PartnerManagedWelcomePrompt_2026_08_11.gs for the backend design rationale.
   Re-triggerable: acmOfferPartnerWelcome_ can be called again later (e.g. from
   the client drawer) for a bride who was told "not now", so that choice is
   never a dead end.
   ============================================================ */
function acmOfferPartnerWelcome_(rowIndex, clientName) {
  if (document.getElementById('apw-overlay')) return;
  var overlay = document.createElement('div');
  overlay.className = 'add-client-overlay';
  overlay.id = 'apw-overlay';
  overlay.innerHTML =
    '<div class="add-client-modal" role="dialog" aria-label="Send partner-managed welcome">' +
      '<div class="acm-header">' +
        '<h3>Send welcome comms?</h3>' +
        '<button class="acm-close" onclick="acmClosePartnerWelcome_()" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div style="padding:0 0.2rem;">' +
        '<p style="font-size:0.85rem;color:var(--text-light);margin:0 0 1rem 0;">' +
          esc(clientName) + ' was added as a partner-managed client. She has not been sent any ' +
          'onboarding comms yet, unlike a booking that arrives by partner email, which sends ' +
          'automatically. Checking what would be sent before you decide.' +
        '</p>' +
        '<div id="apw-preview-loading" style="font-size:0.85rem;color:var(--text-light);">Checking…</div>' +
        '<div id="apw-preview-body" style="display:none;"></div>' +
        '<div id="apw-error" class="acm-error" style="display:none;"></div>' +
      '</div>' +
      '<div class="acm-actions">' +
        '<button type="button" class="btn btn-ghost" onclick="acmClosePartnerWelcome_()">Not now</button>' +
        '<button type="button" class="btn btn-primary" id="apw-send-btn" style="display:none;" onclick="acmConfirmPartnerWelcome_(' + rowIndex + ')">Send welcome</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) acmClosePartnerWelcome_(); });

  function esc(s) { return (typeof escHtml === 'function') ? escHtml(s) : String(s == null ? '' : s); }

  jvBridge.callAdmin('bridge_admin_partnerWelcomePreview', { rowIndex: rowIndex })
    .then(function(res) {
      var loadingEl = document.getElementById('apw-preview-loading');
      var bodyEl = document.getElementById('apw-preview-body');
      var sendBtn = document.getElementById('apw-send-btn');
      if (loadingEl) loadingEl.style.display = 'none';
      if (!res || !res.ok || !res.preview) {
        acmShowPartnerWelcomeError_((res && res.error) || 'Could not check what would be sent.');
        return;
      }
      var p = res.preview;
      if (!bodyEl) return;
      bodyEl.style.display = 'block';
      if (p.wouldSend) {
        // Say plainly what will be sent and to whom, before she confirms (brief
        // requirement, this is bride-facing outbound comms). Quiet hours (2026-08-11):
        // if it would defer rather than send now, say so up front too, not just after
        // confirming.
        var timingLine = p.wouldDefer
          ? '<div style="margin-top:0.4rem;color:var(--text-light);">Quiet hours: will send in the morning, not right now.</div>'
          : '';
        bodyEl.innerHTML =
          '<div style="background:var(--brand-bg-soft);border-radius:0.6rem;padding:0.85rem 1rem;font-size:0.85rem;">' +
            '<div style="margin-bottom:0.4rem;"><strong>Will send to:</strong> ' + esc(p.recipientEmail) + '</div>' +
            '<div><strong>Branded for:</strong> ' + esc(p.partnerName) + '</div>' +
            timingLine +
          '</div>';
        if (sendBtn) sendBtn.style.display = '';
      } else {
        bodyEl.innerHTML =
          '<div style="background:var(--brand-bg-soft);border-radius:0.6rem;padding:0.85rem 1rem;font-size:0.85rem;color:var(--text-light);">' +
            esc(p.blockedReason || 'This cannot be sent right now.') +
          '</div>';
      }
    })
    .catch(function(err) {
      var loadingEl = document.getElementById('apw-preview-loading');
      if (loadingEl) loadingEl.style.display = 'none';
      acmShowPartnerWelcomeError_('Error: ' + ((err && err.message) || String(err)));
    });
}

function acmShowPartnerWelcomeError_(msg) {
  var el = document.getElementById('apw-error');
  if (!el) return;
  el.textContent = msg;
  el.style.display = 'block';
}

function acmConfirmPartnerWelcome_(rowIndex) {
  var btn = document.getElementById('apw-send-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  jvBridge.callAdmin('bridge_admin_partnerWelcomeConfirm', { rowIndex: rowIndex })
    .then(function(res) {
      if (res && res.ok && res.sent) {
        jvToast('Welcome sent to ' + (res.recipientEmail || 'the client') + '.', 'success');
        acmClosePartnerWelcome_();
      } else if (res && res.ok && res.deferred) {
        // Quiet hours: if it defers, the UI must say "will send in the morning", not
        // "sent" (CLAUDE.md comms rule). Never claim success for a deferred send.
        jvToast('Quiet hours, the welcome will send in the morning for ' +
          (res.recipientEmail || 'the client') + '.', 'info');
        acmClosePartnerWelcome_();
      } else if (res && res.ok && !res.sent) {
        // Already-onboarded, an honest non-failure outcome.
        jvToast(res.error || 'Not sent, see details.', 'info');
        acmClosePartnerWelcome_();
      } else {
        acmShowPartnerWelcomeError_((res && res.error) || 'Failed to send.');
        if (btn) { btn.disabled = false; btn.textContent = 'Send welcome'; }
      }
    })
    .catch(function(err) {
      acmShowPartnerWelcomeError_('Error: ' + ((err && err.message) || String(err)));
      if (btn) { btn.disabled = false; btn.textContent = 'Send welcome'; }
    });
}

function acmClosePartnerWelcome_() {
  var el = document.getElementById('apw-overlay');
  if (el) el.remove();
}

/* ============================================================
   FORM SUBMISSIONS INBOX
   ============================================================ */

/* ============================================================
   FORM SUBMISSION MODAL — full-field view, print/PDF
   ============================================================ */

var _formSubModal = {};  // key -> submission obj

function _ensureFormModal() {
  if (document.getElementById('jv-fsm-overlay')) return;
  var overlay = document.createElement('div');
  overlay.id = 'jv-fsm-overlay';
  overlay.setAttribute('style', 'display:none;position:fixed;inset:0;z-index:9999;background:rgba(30,23,22,0.55);overflow-y:auto;padding:1.5rem 1rem;');
  overlay.onclick = function(e) { if (e.target === overlay) closeFormSubmissionModal(); };
  document.body.appendChild(overlay);
  // Print area
  var pa = document.createElement('div');
  pa.id = 'jv-fsm-print';
  pa.setAttribute('style', 'display:none;');
  document.body.appendChild(pa);
  // Print CSS
  var style = document.createElement('style');
  style.textContent = '@media print { body > *:not(#jv-fsm-print) { display: none !important; visibility: hidden !important; } #jv-fsm-print { display: block !important; visibility: visible !important; position: fixed; top: 0; left: 0; width: 100%; padding: 2rem; font-family: sans-serif; } }';
  document.head.appendChild(style);
}

function openFormSubmissionModal(key) {
  var sub = _formSubModal[key];
  if (!sub) return;
  _ensureFormModal();
  var cfg    = FORM_TYPE_CONFIG[sub.type] || { label: sub.label || sub.type, accent: 'var(--brand-primary)' };
  var accent = cfg.accent;
  var dateStr = sub.submittedAt ? formatDate(sub.submittedAt) : (sub.submittedAt === '' ? '' : '');

  // ── Modal HTML ─────────────────────────────────────────────────────────────
  var html = '<div style="max-width:660px;margin:0 auto;background:#fff;border-radius:var(--radius-large,1.5rem);overflow:hidden;box-shadow:0 16px 48px rgba(30,23,22,0.18);">';

  // Header
  html += '<div style="background:' + accent + '22;border-bottom:2px solid ' + accent + '33;padding:1.1rem 1.4rem;display:flex;align-items:flex-start;justify-content:space-between;gap:0.75rem;">';
  html += '<div>';
  html += '<div style="font-size:0.7rem;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:' + accent + ';margin-bottom:0.3rem;">' + escHtml(cfg.label) + '</div>';
  if (sub.submitterName || sub.submitter) {
    html += '<div style="font-size:1.05rem;font-weight:700;color:#2f2524;">' + escHtml(sub.submitterName || sub.submitter || '') + '</div>';
  }
  if (sub.submitterEmail) {
    html += '<div style="font-size:0.73rem;color:#7e706c;margin-top:0.1rem;">' + escHtml(sub.submitterEmail) + '</div>';
  }
  if (dateStr) {
    html += '<div style="font-size:0.7rem;color:#9a918a;margin-top:0.2rem;">Submitted ' + escHtml(dateStr) + '</div>';
  }
  html += '</div>';
  html += '<button onclick="closeFormSubmissionModal()" style="background:none;border:none;cursor:pointer;padding:0.2rem 0.35rem;font-size:1.2rem;color:#9a918a;line-height:1;" title="Close">✕</button>';
  html += '</div>';

  // Body — all fields in a clean table
  html += '<div style="padding:1.2rem 1.4rem;max-height:60vh;overflow-y:auto;">';
  if (sub.fields && sub.fields.length) {
    html += '<table style="width:100%;border-collapse:collapse;">';
    sub.fields.forEach(function(f) {
      html += '<tr style="border-bottom:1px solid #f0ebe8;">';
      html += '<td style="font-size:0.72rem;font-weight:600;color:#7e706c;padding:0.6rem 1rem 0.6rem 0;width:38%;vertical-align:top;white-space:nowrap;">' + escHtml(f.label) + '</td>';
      html += '<td style="font-size:0.8rem;color:#2f2524;padding:0.6rem 0;vertical-align:top;word-break:break-word;white-space:pre-wrap;">' + escHtml(f.value) + '</td>';
      html += '</tr>';
    });
    html += '</table>';
  } else {
    html += '<p style="color:#9a918a;font-size:0.8rem;">No fields recorded for this submission.</p>';
  }
  var validModalFiles = (sub.files || []).filter(function(u) { return /^https?:\/\//i.test(u); });
  if (validModalFiles.length) {
    html += '<div style="margin-top:1rem;padding-top:0.75rem;border-top:1px solid #f0ebe8;">';
    html += '<div style="font-size:0.7rem;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#7e706c;margin-bottom:0.45rem;">Attached Files</div>';
    html += '<div style="display:flex;flex-wrap:wrap;gap:0.4rem;">';
    validModalFiles.forEach(function(url, idx) {
      html += '<a href="' + escHtml(url) + '" target="_blank" rel="noopener" class="btn btn-ghost" style="font-size:0.72rem;" onclick="event.stopPropagation();">File ' + (idx + 1) + ' ↗</a>';
    });
    html += '</div></div>';
  }
  html += '</div>';

  // Footer
  html += '<div style="padding:0.9rem 1.4rem;border-top:1px solid #e6dad4;display:flex;justify-content:space-between;align-items:center;gap:0.5rem;">';
  html += '<span style="font-size:0.68rem;color:#9a918a;">Tip: choose <strong>Save as PDF</strong> in your print dialog to download.</span>';
  html += '<div style="display:flex;gap:0.5rem;">';
  html += '<button class="btn btn-ghost" style="font-size:0.75rem;" onclick="closeFormSubmissionModal()">Close</button>';
  html += '<button class="btn btn-primary" style="font-size:0.75rem;" onclick="printFormSubmission(\'' + key + '\')">Print / Save PDF</button>';
  html += '</div></div>';
  html += '</div>';

  var overlay = document.getElementById('jv-fsm-overlay');
  overlay.innerHTML = html;
  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';

  // Populate print area
  var printSub = sub;
  var printCfg = cfg;
  var pa = document.getElementById('jv-fsm-print');
  if (pa) {
    var ph = '<div style="font-family:sans-serif;max-width:720px;">';
    ph += '<h2 style="font-size:1rem;margin:0 0 0.2rem;color:' + printCfg.accent + ';">' + escHtml(printCfg.label) + '</h2>';
    if (printSub.submitterName || printSub.submitter) ph += '<div style="font-size:1.1rem;font-weight:700;margin-bottom:0.1rem;">' + escHtml(printSub.submitterName || printSub.submitter || '') + '</div>';
    if (printSub.submitterEmail) ph += '<div style="font-size:0.82rem;color:#666;">' + escHtml(printSub.submitterEmail) + '</div>';
    if (dateStr) ph += '<div style="font-size:0.78rem;color:#888;margin-bottom:1rem;">Submitted ' + escHtml(dateStr) + '</div>';
    ph += '<hr style="margin-bottom:1rem;border:none;border-top:1px solid #ccc;">';
    if (printSub.fields && printSub.fields.length) {
      ph += '<table style="width:100%;border-collapse:collapse;">';
      printSub.fields.forEach(function(f) {
        ph += '<tr><td style="padding:0.45rem 1rem 0.45rem 0;font-size:0.8rem;font-weight:600;width:38%;vertical-align:top;color:#555;">' + escHtml(f.label) + '</td>';
        ph += '<td style="padding:0.45rem 0;font-size:0.84rem;color:#222;vertical-align:top;white-space:pre-wrap;">' + escHtml(f.value) + '</td></tr>';
      });
      ph += '</table>';
    }
    var printFiles = (printSub.files || []).filter(function(u) { return /^https?:\/\//i.test(u); });
    if (printFiles.length) {
      ph += '<hr style="margin:1rem 0 0.5rem;border:none;border-top:1px solid #ccc;">';
      ph += '<div style="font-size:0.78rem;font-weight:600;color:#555;margin-bottom:0.3rem;">Attached Files</div>';
      printFiles.forEach(function(url, idx) {
        ph += '<div style="font-size:0.78rem;word-break:break-all;">' + (idx+1) + '. ' + escHtml(url) + '</div>';
      });
    }
    ph += '</div>';
    pa.innerHTML = ph;
  }
}

function closeFormSubmissionModal() {
  var overlay = document.getElementById('jv-fsm-overlay');
  if (overlay) overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function printFormSubmission(key) {
  window.print();
}

var _formsInboxData   = null;
var _formsInboxFilter = 'all';
var _formsInboxSearch = '';

var FORM_INBOX_TYPES = [
  { key: 'all',             label: 'All' },
  { key: 'bridal_enquiry',  label: 'Bridal Enquiry' },
  { key: 'contact_enquiry', label: 'Contact' },
  { key: 'inspiration',     label: 'Inspiration' },
  { key: 'trial_feedback',  label: 'Trial Feedback' },
  { key: 'runsheet_signoff',label: 'Runsheet Sign-off' },
  { key: 'trial_assist',    label: 'Trial Prep' },
  { key: 'onboarding',      label: 'Guest Onboarding' }
];

// Live fetch: runs as the primary load when there's no island (or bust is
// explicitly requested), and as the background-refresh after an island
// paint. painted=true suppresses the error UI and skips the loader (the
// island already gave the user content).
function _formsInboxLiveLoad_(bust, painted) {
  if (!painted) {
    var el0 = document.getElementById('forms-inbox-content');
    if (el0) el0.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading form submissions…</div>';
  }
  var args = bust ? { limit: 200, bust: true } : { limit: 200 };
  var _tfInboxP = tfD1Fetch_({ since: '2000-01-01', limit: 100, activeOnly: true });
  Promise.all([jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getAllFormSubmissions', args: args }), _tfInboxP])
    .then(function(pair) {
      var res = pair[0];
      if (res.ok && res.data && ADMIN_TRIAL_FEEDBACK_D1_ENABLED_) {
        var _items = pair[1];
        var _merged = tfMergeForms_(res.data.forms, _items === null ? null : tfToInboxForms_(_items), true);
        res.data = Object.assign({}, res.data, { forms: _merged, total: _merged.length });
      }
      if (res.ok) {
        _formsInboxData = res.data;
        _formsInboxFilter = 'all';
        _formsInboxSearch = '';
        renderFormsInbox();
      } else if (!painted) {
        var el = document.getElementById('forms-inbox-content');
        if (el) el.innerHTML = '<div class="alert danger">' + escHtml(String(res.error || 'Failed to load')) + '</div>';
      }
    })
    .catch(function(err) {
      if (!painted) {
        var el = document.getElementById('forms-inbox-content');
        if (el) el.innerHTML = '<div class="alert danger">' + escHtml(String(err)) + '</div>';
      }
    });
}

// Fast path: paint from the CDN island first (zero GAS), then background-
// refresh. Island written by AdminFormsInboxCache.gs -> custom.
// admin_forms_inbox_cache_json, shape { success, data:{forms, total} }. No
// admin actions live on this tab (view/print only), so this is a plain
// read-then-refresh pair, matching the Notifications pattern. An explicit
// bust always goes straight to live (bypasses the island the same way it
// already bypasses GAS's own script cache). Falls straight to live when the
// island is absent.
function loadFormsInbox(bust) {
  if (bust) { _formsInboxLiveLoad_(true, false); return; }
  adminCacheParseIsland_('jv-admin-forms-inbox-cache', function(cached) {
    var data = cached && cached.data;
    if (data && data.forms) {
      _formsInboxData = data;
      _formsInboxFilter = 'all';
      _formsInboxSearch = '';
      renderFormsInbox();          // instant paint
      _formsInboxLiveLoad_(false, true); // background-refresh
    } else {
      _formsInboxLiveLoad_(false, false); // no island -> live is the primary load
    }
  });
}

function renderFormsInbox() {
  var el = document.getElementById('forms-inbox-content');
  if (!el || !_formsInboxData) return;

  _formSubModal = {};  // reset lookup on each render
  var allForms = (_formsInboxData.forms) || [];
  var total    = _formsInboxData.total || allForms.length;

  // Apply type filter
  var filtered = _formsInboxFilter === 'all'
    ? allForms
    : allForms.filter(function(s) { return s.type === _formsInboxFilter; });

  // Apply search
  var q = _formsInboxSearch.toLowerCase().replace(/[''‚‛′‵`]/g, "'").trim();
  if (q) {
    filtered = filtered.filter(function(s) {
      return (s.submitterName  || '').toLowerCase().indexOf(q) !== -1
          || (s.submitterEmail || '').toLowerCase().indexOf(q) !== -1
          || (s.label          || '').toLowerCase().indexOf(q) !== -1;
    });
  }

  var html = '';

  // ── Toolbar ─────────────────────────────────────────────────────────────
  html += '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:0.5rem;margin-bottom:0.9rem;">';
  html += '<div style="font-size:0.72rem;color:var(--muted);">' + filtered.length + ' of ' + total + ' submissions</div>';
  html += '<div style="display:flex;gap:0.4rem;">';
  html += '<input id="forms-inbox-search" type="text" placeholder="Search name or email…" value="' + escAttr(_formsInboxSearch) + '" '
    + 'oninput="_formsInboxSearch=this.value;renderFormsInbox();" '
    + 'style="font-size:0.72rem;padding:0.25rem 0.6rem;border:1px solid #e6dad4;border-radius:var(--radius-medium);outline:none;width:180px;">';
  html += '<button class="btn btn-ghost" style="font-size:0.67rem;padding:0.18rem 0.6rem;" onclick="loadFormsInbox(true)">↻ Refresh</button>';
  html += '</div>';
  html += '</div>';

  // ── Filter pills ─────────────────────────────────────────────────────────
  html += '<div style="display:flex;flex-wrap:wrap;gap:0.3rem;margin-bottom:0.9rem;">';
  FORM_INBOX_TYPES.forEach(function(t) {
    var active = _formsInboxFilter === t.key;
    html += '<button onclick="_formsInboxFilter=\'' + t.key + '\';renderFormsInbox();" '
      + 'style="font-size:0.68rem;padding:0.2rem 0.65rem;border-radius:var(--radius-pill);border:1px solid '
      + (active ? 'var(--brand-primary)' : '#e6dad4') + ';background:'
      + (active ? 'var(--brand-primary)' : 'transparent') + ';color:'
      + (active ? '#fff' : 'var(--brand-text)') + ';cursor:pointer;font-weight:' + (active ? '600' : '400') + ';">'
      + escHtml(t.label) + '</button>';
  });
  html += '</div>';

  // ── Submissions list ──────────────────────────────────────────────────────
  if (filtered.length === 0) {
    html += '<div class="empty-state"><p>No submissions match.</p></div>';
    el.innerHTML = html;
    return;
  }

  var _fiIdx = 0;
  filtered.forEach(function(sub) {
    var key    = 'fi_' + (_fiIdx++);
    _formSubModal[key] = sub;
    var cfg    = FORM_TYPE_CONFIG[sub.type] || { label: sub.label || sub.type, accent: 'var(--brand-primary)' };
    var accent = cfg.accent;
    var dateStr = sub.submittedAt ? formatDate(sub.submittedAt) : '';

    html += '<div style="border:1px solid #e6dad4;border-radius:var(--radius-medium);margin-bottom:0.65rem;overflow:hidden;">';

    // Header row
    html += '<div style="background:' + accent + '1a;border-bottom:1px solid #e6dad4;padding:0.5rem 0.85rem;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:0.35rem;">';
    html += '<div style="display:flex;align-items:center;gap:0.5rem;flex-wrap:wrap;">';
    html += '<span style="font-size:0.72rem;font-weight:700;color:' + accent + ';">' + escHtml(cfg.label) + '</span>';
    if (sub.submitterName) html += '<span style="font-size:0.72rem;color:var(--brand-text);font-weight:500;">' + escHtml(sub.submitterName) + '</span>';
    if (sub.submitterEmail) html += '<span style="font-size:0.69rem;color:var(--muted);">' + escHtml(sub.submitterEmail) + '</span>';
    html += '</div>';
    html += '<div style="display:flex;align-items:center;gap:0.4rem;">';
    if (dateStr) html += '<span style="font-size:0.68rem;color:var(--muted);">' + escHtml(dateStr) + '</span>';
    html += '<button class="btn btn-ghost" style="font-size:0.65rem;padding:0.15rem 0.5rem;" onclick="openFormSubmissionModal(\'' + key + '\')">View Full ↗</button>';
    html += '</div></div>';

    // Body — preview (first 3 fields, truncated)
    if (sub.fields && sub.fields.length) {
      html += '<div style="padding:0.5rem 0.85rem;">';
      html += '<dl style="margin:0;display:grid;grid-template-columns:auto 1fr;gap:0.08rem 0.7rem;">';
      sub.fields.slice(0, 3).forEach(function(f) {
        html += '<dt style="font-size:0.69rem;font-weight:600;color:var(--brand-text);white-space:nowrap;padding:0.07rem 0;">' + escHtml(f.label) + '</dt>';
        html += '<dd style="font-size:0.7rem;color:var(--brand-text);margin:0;padding:0.07rem 0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:300px;">' + escHtml(f.value) + '</dd>';
      });
      html += '</dl>';
      if (sub.fields.length > 3) html += '<div style="font-size:0.67rem;color:var(--muted);margin-top:0.18rem;">+ ' + (sub.fields.length - 3) + ' more — click View Full</div>';
      html += '</div>';
    }

    html += '</div>';
  });

  el.innerHTML = html;
}

// ── Portal View drawer pane ────────────────────────────────────────────────────

function loadDrawerPortalPreview(clientId) {
  _cppSelectedClientId = clientId;
  _cppActiveTargetEl   = 'drawer-portal-preview-content';
  var el = document.getElementById('drawer-portal-preview-content');
  el.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading portal preview…</div>';
  getDrawerBundle_(clientId).then(function(b) {
    if (b && _bundleSectionReady_(b.portalPreview)) {
      renderPortalPreview(b.portalPreview, 'drawer-portal-preview-content', clientId);
      return;
    }
    _loadDrawerPortalPreview_legacy(clientId);
  });
}

function _loadDrawerPortalPreview_legacy(clientId) {
  var el = document.getElementById('drawer-portal-preview-content');
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientPortalPreview', args: { id: clientId } })
    .then(function(res) {
      if (res.ok && res.data && !res.data.error) {
        renderPortalPreview(res.data, 'drawer-portal-preview-content', clientId);
      } else {
        var msg = (res.data && res.data.error) || (res.error && (res.error.message || res.error)) || 'Failed to load';
        el.innerHTML = '<div class="alert danger">' + escHtml(String(msg)) + '</div>';
      }
    })
    .catch(function(err) {
      el.innerHTML = '<div class="alert danger">' + escHtml(String(err)) + '</div>';
    });
}

// ── Portal Preview — action helpers ──────────────────────────────────────────

function cppRefreshPreview() {
  if (!_cppSelectedClientId) return;
  var el = document.getElementById(_cppActiveTargetEl || 'cpp-preview');
  if (el) el.innerHTML = '<div class="view-loader" style="padding:2rem;"><div class="mini-spinner"></div> Refreshing…</div>';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientPortalPreview', args: { id: _cppSelectedClientId } })
    .then(function(res) {
      if (res.ok && res.data && !res.data.error) {
        renderPortalPreview(res.data, _cppActiveTargetEl || 'cpp-preview', _cppSelectedClientId);
      } else {
        var msg = (res.data && res.data.error) || (res.error && (res.error.message || res.error)) || 'Failed';
        if (el) el.innerHTML = '<div class="alert danger">' + escHtml(String(msg)) + '</div>';
      }
    });
}

function cppMarkTaskDoneBtn(btn) {
  var cid    = parseInt(btn.getAttribute('data-cid'), 10);
  var taskId = btn.getAttribute('data-task');
  // Row-position identity guard (adminCrm_updatePortalTaskStatus now accepts
  // expectedEmail and re-resolves a stale clientId, see AdminCRMAPI.gs).
  var expectedEmail = (STATE.drawerClient && STATE.drawerClient.email) || '';
  btn.disabled = true; btn.textContent = 'Saving…';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_updatePortalTaskStatus', args: { id: cid, taskId: taskId, value: 'done', expectedEmail: expectedEmail } })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) { cppRefreshPreview(); }
      else { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); jvToast((res.data && res.data.message) || 'Update failed', 'error'); }
    });
}

// Issue 6 / Sub-A: trial_book portal-task toggle D1-first on Cloudflare. Default OFF (GAS path unchanged until flipped).
var JV_ADMIN_TRIAL_DATE_CF = false;
function cppSetTrialDateBtn(btn) {
  var cid = parseInt(btn.getAttribute('data-cid'), 10);
  var d = prompt('Enter trial date (DD/MM/YYYY):');
  if (!d) return;
  d = d.trim();
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(d)) { jvToast('Use DD/MM/YYYY format', 'error'); return; }
  var expectedEmail = (STATE.drawerClient && STATE.drawerClient.email) || '';
  btn.disabled = true; btn.textContent = 'Saving…';
  // Cloudflare-native (flag JV_ADMIN_TRIAL_DATE_CF, default OFF): D1-first via App Proxy entity
  // admin-trial-date/save -> jv-crm-mirror POST /admin/trial-date. NO GAS fallback: a failure is
  // shown to the admin, never retried through GAS. Needs ADMIN_TRIAL_DATE_CF_ENABLED=1 on the mirror.
  if (JV_ADMIN_TRIAL_DATE_CF === true) {
    var tdBase = window._jvAdminProxyBase;
    var tdFail = function (msg) { btn.disabled = false; btn.textContent = 'Set trial date'; jvToast(msg || 'Update failed', 'error'); };
    if (!tdBase) { tdFail('Admin connection unavailable'); return; }
    var tdNf = (window._jvNativeFetch || window.fetch).bind(window);
    tdNf(String(tdBase).replace(/\/+$/, '') + '/partner/admin-trial-date/save', {
      method: 'POST', headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ expectedEmail: expectedEmail, brideUid: (STATE.drawerClient && STATE.drawerClient.brideUid) || '', trialDate: d })
    }).then(function (r) { return r.json(); }).then(function (r) {
      if (r && r.ok === true) { cppRefreshPreview(); return; }
      tdFail('Could not save: ' + ((r && r.error) || 'Unknown error'));
    }).catch(function () { tdFail('No reply from the server. The save may not have landed, reload and check before trying again.'); });
    return;
  }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_updatePortalTaskStatus', args: { id: cid, taskId: 'trial_book', value: d, expectedEmail: expectedEmail } })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) { cppRefreshPreview(); }
      else { btn.disabled = false; btn.textContent = 'Set trial date'; jvToast((res.data && res.data.message) || 'Update failed', 'error'); }
    });
}

function cppToggleSubmissionBtn(btn) {
  var cid    = parseInt(btn.getAttribute('data-cid'), 10);
  var taskId = btn.getAttribute('data-task');
  var panel  = btn.nextElementSibling;
  if (panel && panel.classList.contains('cpp-submission-panel')) {
    panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
    btn.textContent = panel.style.display === 'none' ? 'View submission' : 'Hide';
    return;
  }
  panel = document.createElement('div');
  panel.className = 'cpp-submission-panel';
  panel.style.cssText = 'margin-top:0.4rem;padding:0.6rem 0.8rem;background:#f6f1ee;border-radius:var(--radius-medium);font-size:0.71rem;';
  panel.innerHTML = '<div class="mini-spinner" style="display:inline-block;width:12px;height:12px;margin-right:4px;"></div>Loading…';
  btn.insertAdjacentElement('afterend', panel);
  btn.textContent = 'Hide';
  // Identity guard (2026-09-01): see the matching comment on _loadDrawerForms_legacy above.
  var _tfEm2 = jvExpectedEmailFor(cid);
  var _tfP2 = _tfEm2 ? tfD1Fetch_({ email: _tfEm2, limit: 50 }) : Promise.resolve(null);
  Promise.all([jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getFormSubmissions', args: { id: cid, expectedEmail: jvExpectedEmailFor(cid) } }), _tfP2])
    .then(function(pair2) {
      var res = pair2[0];
      if (!res.ok || !res.data) { panel.innerHTML = '<span style="color:var(--muted);">No data available.</span>'; return; }
      var forms = res.data.forms || [];
      if (ADMIN_TRIAL_FEEDBACK_D1_ENABLED_) forms = tfMergeForms_(forms, pair2[1] === null ? null : tfToDrawerForms_(pair2[1], ''), false);
      var typeMap = { vision_profile: 'vision_profile', trial_feedback: 'trial_feedback' };
      var form = forms.filter(function(f) { return f.type === typeMap[taskId]; })[0];
      if (!form) { panel.innerHTML = '<span style="color:var(--muted);">No submission on file.</span>'; return; }
      var h = '<strong style="display:block;margin-bottom:0.35rem;font-size:0.68rem;text-transform:uppercase;letter-spacing:0.06em;color:var(--muted);">' + escHtml(form.label || '') + '</strong>';
      (form.fields || []).filter(function(f) { return !!f.value; }).slice(0, 20).forEach(function(f) {
        h += '<div style="display:flex;gap:0.4rem;margin-bottom:0.18rem;">'
           + '<span style="min-width:7.5rem;color:var(--muted);flex-shrink:0;font-size:0.7rem;">' + escHtml(f.label || '') + '</span>'
           + '<span style="font-weight:600;font-size:0.7rem;">' + escHtml(String(f.value)) + '</span>'
           + '</div>';
      });
      panel.innerHTML = h;
    });
}

function cppRemovePartyMemberBtn(btn) {
  var cid       = parseInt(btn.getAttribute('data-cid'), 10);
  var member    = btn.getAttribute('data-member');
  var pmId      = btn.getAttribute('data-pmid') || '';
  var completed = btn.getAttribute('data-completed') === '1';

  // Review modal: lists every place this pm_id is referenced so admin can
  // assess impact before confirming. Bride-side cannot self-delete.
  var existing = document.getElementById('cpp-remove-member-modal');
  if (existing) existing.remove();

  var overlay = document.createElement('div');
  overlay.id = 'cpp-remove-member-modal';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(20,15,15,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:1.25rem';

  var safeName = String(member || 'this member').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  var safePmId = String(pmId || 'unknown').replace(/</g,'&lt;');

  var completedNote = completed
    ? '<p style="margin:0 0 1rem;padding:.5rem .75rem;background:#fff8f0;border:1px solid #f5d5a8;border-radius:8px;font-size:.85rem;color:#7a4a10">This member has submitted her form. Her profile data is preserved in the sheet but will be removed from all active surfaces.</p>'
    : '';

  var modal = document.createElement('div');
  modal.style.cssText = 'background:#fff;border-radius:14px;max-width:480px;width:100%;padding:1.5rem;box-shadow:0 12px 48px rgba(0,0,0,.25);font-family:inherit;max-height:90vh;overflow-y:auto';
  modal.innerHTML = [
    '<h3 style="margin:0 0 .35rem;font-size:1.05rem;font-weight:600;color:#1c1718">Remove party member</h3>',
    '<p style="margin:0 0 1rem;font-size:.85rem;color:#7e706c">',
      safeName,
      pmId ? ' &middot; <code style="font-size:.78rem;background:#f6f1ee;padding:.1rem .3rem;border-radius:4px">' + safePmId + '</code>' : '',
    '</p>',
    completedNote,
    '<p style="margin:0 0 .6rem;font-size:.88rem;font-weight:600;color:#1c1718">This ID is referenced in the following places. Review each before confirming.</p>',
    '<ul style="margin:0 0 1.1rem;padding:0 0 0 1.1rem;font-size:.84rem;line-height:1.7;color:#4a3f3d">',
      '<li><strong>_PartyMembers sheet</strong>: row soft-deleted (DELETED_AT set). Recoverable by clearing that cell.</li>',
      '<li><strong>Party blob + CRM column</strong> (BRIDAL_PARTY_ONBOARDING_JSON): member removed automatically on save.</li>',
      '<li><strong>Shopify metafield</strong> (custom.jv_party_members_json): updated automatically on save.</li>',
      '<li><strong>Published runsheet snapshot</strong>: NOT updated automatically. Re-publish the runsheet after removing.</li>',
      '<li><strong>Shopify metaobject</strong> (jv_bridal_party_member): record remains. Clean up in Shopify Admin if no longer needed.</li>',
      '<li><strong>Runsheet builder Step 2</strong>: reflects the removal on next workspace load.</li>',
    '</ul>',
    '<div style="display:flex;gap:.6rem;justify-content:flex-end;flex-wrap:wrap">',
      '<button type="button" id="cpp-remove-cancel" style="padding:.55rem 1rem;border:1px solid #d8cfcc;background:#fff;border-radius:8px;font-family:inherit;font-size:.9rem;cursor:pointer;color:#1c1718">Cancel</button>',
      '<button type="button" id="cpp-remove-confirm" style="padding:.55rem 1.1rem;border:1px solid #a64545;background:#a64545;color:#fff;border-radius:8px;font-family:inherit;font-size:.9rem;cursor:pointer">Remove member</button>',
    '</div>',
    '<p id="cpp-remove-status" style="margin:.75rem 0 0;font-size:.8rem;color:#a64545;min-height:1em" aria-live="polite"></p>'
  ].join('');

  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  var closeOverlay = function () { try { overlay.remove(); } catch (e) {} };
  document.getElementById('cpp-remove-cancel').addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
  document.addEventListener('keydown', function escFn(e) {
    if (e.key === 'Escape') { closeOverlay(); document.removeEventListener('keydown', escFn); }
  });

  document.getElementById('cpp-remove-confirm').addEventListener('click', function () {
    var confirmBtn = document.getElementById('cpp-remove-confirm');
    var cancelBtn  = document.getElementById('cpp-remove-cancel');
    var statusP    = document.getElementById('cpp-remove-status');
    confirmBtn.disabled = true; cancelBtn.disabled = true;
    statusP.textContent = 'Removing...';
    btn.disabled = true;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_upsertPartyMember', args: { clientId: cid, action: 'remove', memberName: member } })
      .then(function(res) {
        if (res.ok && res.data && res.data.ok) {
          closeOverlay();
          jvToast((res.data.message || 'Removed') + '. Re-publish runsheet if needed.', 'success');
          cppRefreshPreview();
        } else {
          confirmBtn.disabled = false; cancelBtn.disabled = false; btn.disabled = false;
          statusP.textContent = (res.data && res.data.error) || 'Remove failed';
        }
      });
  });
}

// 2026-05-25 admin party-member rename. Uses pm_id when available (stable
// across name changes), falls back to current name (legacy rows).
function cppEditPartyMemberBtn(btn) {
  var cid     = parseInt(btn.getAttribute('data-cid'), 10);
  var pmId    = btn.getAttribute('data-pmid') || '';
  var current = btn.getAttribute('data-member') || '';
  var fresh   = (window.prompt('Edit member name', current) || '').trim();
  if (!fresh || fresh === current) return;
  btn.disabled = true;
  var argsPayload = { clientId: cid, action: 'rename', newName: fresh };
  if (pmId) argsPayload.pm_id = pmId;
  else argsPayload.memberName = current;
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_upsertPartyMember', args: argsPayload })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) { jvToast(res.data.message || 'Renamed', 'success'); cppRefreshPreview(); }
      else { btn.disabled = false; jvToast((res.data && res.data.error) || 'Rename failed', 'error'); }
    });
}

function cppShowAddMemberFormBtn(btn) {
  var cid         = parseInt(btn.getAttribute('data-cid'), 10);
  var containerId = btn.getAttribute('data-container');
  var c = document.getElementById(containerId);
  if (!c) return;
  c.innerHTML = '<div style="display:flex;flex-direction:column;gap:0.35rem;padding:0.5rem;background:#fff;border:1px solid #e6dad4;border-radius:var(--radius-medium);margin-top:0.35rem;">'
    + '<input id="cppNewMemberName" placeholder="Name" style="font-size:0.8rem;padding:0.3rem 0.5rem;border:1px solid #e6dad4;border-radius:6px;">'
    + '<select id="cppNewMemberRole" style="font-size:0.8rem;padding:0.3rem 0.5rem;border:1px solid #e6dad4;border-radius:6px;">'
    + '<option>Bridesmaid</option><option>Flower Girl</option>'
    + '<option>Mother of the Bride</option><option>Mother of the Groom</option><option>Party Member</option>'
    + '</select>'
    + '<input id="cppNewMemberEmail" placeholder="Email (optional)" style="font-size:0.8rem;padding:0.3rem 0.5rem;border:1px solid #e6dad4;border-radius:6px;">'
    + '<div style="display:flex;gap:0.35rem;">'
    + '<button data-cid="' + cid + '" onclick="cppSaveNewMemberBtn(this)" style="flex:1;font-size:0.75rem;padding:0.3rem;background:var(--brand-primary);color:#fff;border:none;border-radius:6px;cursor:pointer;">Add</button>'
    + '<button onclick="document.getElementById(\'' + escHtml(containerId) + '\').innerHTML=\'\';" style="font-size:0.75rem;padding:0.3rem 0.6rem;background:var(--brand-bg-soft);border:1px solid #e6dad4;border-radius:6px;cursor:pointer;">Cancel</button>'
    + '</div></div>';
  document.getElementById('cppNewMemberName').focus();
}

function cppSaveNewMemberBtn(btn) {
  var cid   = parseInt(btn.getAttribute('data-cid'), 10);
  var name  = (document.getElementById('cppNewMemberName').value  || '').trim();
  var role  = (document.getElementById('cppNewMemberRole').value  || '').trim();
  var email = (document.getElementById('cppNewMemberEmail').value || '').trim();
  if (!name) { jvToast('Please enter a name', 'error'); return; }
  btn.disabled = true; btn.textContent = 'Saving…';

  function fallbackToGasCppAdd_() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_upsertPartyMember', args: { clientId: cid, action: 'add', memberName: name, memberRole: role, memberEmail: email } })
      .then(function(res) {
        if (res.ok && res.data && res.data.ok) { jvToast(res.data.message || 'Added', 'success'); cppRefreshPreview(); }
        else { btn.disabled = false; btn.textContent = 'Add'; jvToast((res.data && res.data.error) || 'Add failed', 'error'); }
      })
      .catch(function(err) {
        btn.disabled = false; btn.textContent = 'Add';
        jvToast('Add failed: ' + String(err && err.message || err), 'error');
      });
  }

  // D1-first (2026-09-09), same pattern + same brideUid source as
  // pmSaveNewMember_ above. Falls back to GAS when brideUid is unavailable.
  var c = (typeof findClientById === 'function') ? findClientById(cid) : null;
  var brideUid = (c && c.brideUid) || '';
  if (!brideUid) {
    fallbackToGasCppAdd_();
    return;
  }

  var idempotencyKey = brideUid + '|create|' + name.toLowerCase().replace(/\s+/g, '-') + '|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  jvBridge.call('bridge_runsheet_createPartyMemberD1', {
    payload: {
      bride_uid: brideUid,
      member_name: name,
      member_role: role,
      member_email: email || null,
      idempotency_key: idempotencyKey,
      bride_email: (c && c.email) || null
    }
  }).then(function(res) {
    if (res && res.ok && res.writtenTo === 'd1') {
      // Durable in D1, identity pending -- no pm_id yet. cppRefreshPreview()
      // re-reads the same roster this pending member won't appear in until
      // the GAS drain mints its pm_id (~1min), so don't call it here -- it
      // would just repaint the pre-add state and read as a silent failure.
      jvToast(name + ' is being added.', 'success');
      btn.disabled = false; btn.textContent = 'Add';
      var nameEl = document.getElementById('cppNewMemberName');
      if (nameEl) nameEl.value = '';
    } else {
      fallbackToGasCppAdd_();
    }
  }).catch(function() {
    fallbackToGasCppAdd_();
  });
}

// ── Admin party member inline edit cards (2026-05-28) ────────────────────────
// cppMemberData_ is keyed by cid and set in renderPortalPreview before innerHTML.
// Edit form toggles in-place; save calls adminCrm_upsertPartyMember update_profile.

function cppToggleMemberEditCard_(btn) {
  var cid    = parseInt(btn.getAttribute('data-cid'), 10);
  var idx    = parseInt(btn.getAttribute('data-idx'), 10);
  var viewEl = document.getElementById('cpp-mview-' + cid + '-' + idx);
  var editEl = document.getElementById('cpp-medit-' + cid + '-' + idx);
  if (!viewEl || !editEl) return;

  var members = window['cppMemberData_' + cid] || [];
  var m       = members[idx] || {};
  var pmId    = m.pm_id || '';

  // Canonical 5 hairstyles only (JV_HAIRSTYLE_OPTIONS, HairstyleOptions.gs). The old set
  // (Sleek & Straight / Elegant Updo / Braided Style) was off-canonical + non-priceable,
  // retired 2026-07-30. The save handler normalises anyway, but the picker offers only these.
  var HAIR_STYLES = ['', 'Soft Waves/Curls', '1/2 Updo', 'Updo', 'Hollywood Waves', 'Above Collar/Short Hair'];
  // Maid/Matron of Honour retired (Jess 2026-07-30): we only categorise as Bridesmaid.
  var ROLES       = ['Bridesmaid', 'Flower Girl', 'Mother of the Bride', 'Mother of the Groom', 'Junior Bridesmaid', 'Partner', 'Party Member'];

  function inp_(sfx, ph, val, type) {
    var pfx = 'cppmf-' + sfx + '-' + cid + '-' + idx;
    return '<input id="' + pfx + '" type="' + (type || 'text') + '" placeholder="' + escHtml(ph) + '" value="' + escHtml(val || '') + '" style="width:100%;font-size:0.77rem;padding:0.35rem 0.5rem;border:1px solid #e0d0cc;border-radius:6px;box-sizing:border-box;">';
  }
  function txta_(sfx, ph, val) {
    var pfx = 'cppmf-' + sfx + '-' + cid + '-' + idx;
    return '<textarea id="' + pfx + '" placeholder="' + escHtml(ph) + '" rows="2" style="width:100%;font-size:0.77rem;padding:0.35rem 0.5rem;border:1px solid #e0d0cc;border-radius:6px;resize:vertical;box-sizing:border-box;">' + escHtml(val || '') + '</textarea>';
  }
  function sel_(sfx, opts, selected) {
    var pfx = 'cppmf-' + sfx + '-' + cid + '-' + idx;
    var h   = '<select id="' + pfx + '" style="width:100%;font-size:0.77rem;padding:0.35rem 0.5rem;border:1px solid #e0d0cc;border-radius:6px;box-sizing:border-box;">';
    opts.forEach(function(o) { h += '<option' + (o === selected ? ' selected' : '') + '>' + escHtml(o) + '</option>'; });
    return h + '</select>';
  }
  function lbl_(t) { return '<div style="font-size:0.64rem;font-weight:700;color:var(--muted);margin-bottom:0.12rem;text-transform:uppercase;letter-spacing:0.04em;">' + t + '</div>'; }
  function row2_(a, b) { return '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0.4rem;">' + a + b + '</div>'; }
  function sec_(t) { return '<div style="font-size:0.65rem;font-weight:700;color:var(--brand-primary);text-transform:uppercase;letter-spacing:0.06em;margin-top:0.35rem;">' + t + '</div>'; }

  var h = '<div style="padding-top:0.5rem;border-top:1px solid #f0e8e4;display:flex;flex-direction:column;gap:0.45rem;">';
  h += sec_('Identity');
  h += row2_(
    '<div>' + lbl_('Name') + inp_('name', 'Full name', m.name) + '</div>',
    '<div>' + lbl_('Role') + sel_('role', ROLES, m.role) + '</div>'
  );
  h += row2_(
    '<div>' + lbl_('Email') + inp_('email', 'Email address', m.email) + '</div>',
    '<div>' + lbl_('Phone') + inp_('phone', 'Mobile', m.phone) + '</div>'
  );
  h += sec_('Beauty Profile');
  h += row2_(
    '<div>' + lbl_('Hairstyle') + sel_('hair', HAIR_STYLES, m.hair_style) + '</div>',
    '<div>' + lbl_('Colour Palette') + inp_('palette', 'e.g. nudes, plum', m.colour_palette) + '</div>'
  );
  h += row2_(
    '<div>' + lbl_('Allergies') + inp_('allergy', 'Any allergies', m.allergies) + '</div>',
    '<div>' + lbl_('Skin Concerns') + inp_('skin', 'Skin type / concerns', m.skin_concerns) + '</div>'
  );
  h += '<div>' + lbl_('Hair Notes') + txta_('hairnotes', 'Notes for the hair artist...', m.hair_notes) + '</div>';
  h += '<div>' + lbl_('Inspiration Notes') + txta_('inspnotes', 'Style preferences, references...', m.inspo_notes) + '</div>';
  h += '<div style="display:flex;gap:0.4rem;justify-content:flex-end;margin-top:0.1rem;">';
  h += '<button onclick="cppCancelMemberEditCard_(' + cid + ',' + idx + ')" style="font-size:0.75rem;padding:0.28rem 0.8rem;background:var(--brand-bg-soft);border:1px solid #ddd;border-radius:var(--radius-pill);cursor:pointer;color:var(--brand-text);">Cancel</button>';
  h += '<button id="cppmf-save-' + cid + '-' + idx + '" data-cid="' + cid + '" data-idx="' + idx + '" data-pmid="' + escHtml(pmId) + '" data-orig-name="' + escHtml(m.name || '') + '" onclick="cppSaveMemberProfileBtn(this)" style="font-size:0.75rem;padding:0.28rem 0.8rem;background:var(--brand-primary);color:#fff;border:none;border-radius:var(--radius-pill);cursor:pointer;">Save changes</button>';
  h += '</div></div>';

  viewEl.style.display = 'none';
  editEl.innerHTML = h;
  editEl.style.display = 'block';
  var firstInput = editEl.querySelector('input');
  if (firstInput) firstInput.focus();
}

function cppCancelMemberEditCard_(cid, idx) {
  var viewEl = document.getElementById('cpp-mview-' + cid + '-' + idx);
  var editEl = document.getElementById('cpp-medit-' + cid + '-' + idx);
  if (viewEl) viewEl.style.display = '';
  if (editEl) { editEl.style.display = 'none'; editEl.innerHTML = ''; }
}

function cppSaveMemberProfileBtn(btn) {
  var cid      = parseInt(btn.getAttribute('data-cid'), 10);
  var idx      = parseInt(btn.getAttribute('data-idx'), 10);
  var pmId     = btn.getAttribute('data-pmid') || '';
  var origName = btn.getAttribute('data-orig-name') || '';

  function g_(sfx) {
    var el = document.getElementById('cppmf-' + sfx + '-' + cid + '-' + idx);
    return el ? el.value.trim() : '';
  }

  var saveArgs = {
    clientId:       cid,
    action:         'update_profile',
    pm_id:          pmId,
    memberName:     origName,
    newName:        g_('name'),
    memberRole:     g_('role'),
    memberEmail:    g_('email'),
    memberPhone:    g_('phone'),
    hair_style:     g_('hair'),
    colour_palette: g_('palette'),
    allergies:      g_('allergy'),
    skin_concerns:  g_('skin'),
    hair_notes:     g_('hairnotes'),
    inspo_notes:    g_('inspnotes')
  };

  btn.disabled = true; btn.textContent = 'Saving...';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_upsertPartyMember', args: saveArgs })
    .then(function(res) {
      if (res.ok && res.data && res.data.ok) {
        jvToast(res.data.message || 'Saved', 'success');
        cppRefreshPreview();
      } else {
        btn.disabled = false; btn.textContent = 'Save changes';
        jvToast((res.data && res.data.error) || 'Save failed', 'error');
      }
    })
    .catch(function() {
      btn.disabled = false; btn.textContent = 'Save changes';
      jvToast('Network error', 'error');
    });
}

function renderPortalPreviewFeatureCard(title, statusText, color, active) {
  var bg = active ? '#fff' : 'var(--brand-bg-soft)';
  return '<div style="background:' + bg + ';border:1px solid #e6dad4;border-radius:var(--radius-medium);padding:0.6rem 0.75rem;">'
    + '<div style="font-size:0.7rem;font-weight:700;color:var(--brand-text);margin-bottom:0.25rem;">' + escHtml(title) + '</div>'
    + '<div style="font-size:0.7rem;color:' + color + ';font-weight:600;">' + escHtml(statusText) + '</div>'
    + '</div>';
}

function renderPortalPreview(data, targetElId, clientId) {
  var el = document.getElementById(targetElId || 'drawer-portal-preview-content');
  if (!data) { if (el) el.innerHTML = '<div class="alert danger">No preview data returned.</div>'; return; }

  var access = data.portalAccess     || {};
  var tasks  = data.tasks            || [];
  var feat   = data.features         || {};
  var rs     = feat.runsheet         || {};
  var tr     = feat.trial            || {};
  var bp     = feat.brialParty       || {};
  var files  = feat.files            || {};
  var bride  = data.bride            || {};
  var mf     = data.shopifyMetafields || null;
  var cid    = clientId || bride.id  || 0;

  function sectionLabel(text) {
    return '<div style="font-size:0.67rem;font-weight:700;letter-spacing:0.07em;color:var(--muted);text-transform:uppercase;margin:1rem 0 0.45rem;">' + escHtml(text) + '</div>';
  }

  var taskActionMap = {
    vision_profile:   { label: 'Mark complete',         handler: 'cppMarkTaskDoneBtn(this)',  extra: 'data-label="Mark complete"' },
    trial_book:       { label: 'Set trial date',         handler: 'cppSetTrialDateBtn(this)', extra: '' },
    trial_feedback:   { label: 'Mark feedback received', handler: 'cppMarkTaskDoneBtn(this)',  extra: 'data-label="Mark feedback received"' },
    runsheet_signoff: { label: 'Mark signed off',        handler: 'cppMarkTaskDoneBtn(this)',  extra: 'data-label="Mark signed off"' }
  };
  var viewableSubmission = { vision_profile: true, trial_feedback: true };

  // Shopify metafield keys that override CRM-derived task statuses
  var mfTaskMap = {
    inspo_upload:     { key: 'task_inspo_uploaded',   altKey: null },
    trial_book:       { key: 'task_trial_booked',     altKey: 'trial_opted_out' },
    trial_feedback:   { key: 'task_trial_feedback',   altKey: null },
    runsheet_signoff: { key: 'task_runsheet_signoff', altKey: null }
  };

  var html = '';

  // ── 1. Bride header strip ─────────────────────────────────────────
  html += '<div style="padding:0.65rem 0 0.4rem;">';
  html += '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:0.5rem;flex-wrap:wrap;">';
  html += '<div>';
  html += '<div style="font-size:1rem;font-weight:700;color:var(--brand-dark);">' + escHtml(bride.name || '—') + '</div>';
  if (bride.weddingDate) {
    html += '<div style="font-size:0.72rem;color:var(--muted);margin-top:0.1rem;">' + escHtml(bride.weddingDate) + (bride.weddingLocation ? ' · ' + escHtml(bride.weddingLocation) : '') + '</div>';
  }
  html += '</div>';
  if (bride.isBooked) {
    html += '<span style="font-size:0.65rem;font-weight:700;background:#e8f5e9;color:#1f6b46;border-radius:var(--radius-pill);padding:0.18rem 0.55rem;white-space:nowrap;">Booked</span>';
  } else if (bride.stage) {
    html += '<span style="font-size:0.65rem;font-weight:700;background:var(--brand-bg-soft);color:var(--brand-text);border-radius:var(--radius-pill);padding:0.18rem 0.55rem;white-space:nowrap;">' + escHtml(bride.stage) + '</span>';
  }
  html += '</div></div>';

  // ── 2. Portal access state ────────────────────────────────────────
  var accessOk = access.hasShopifyCustomer;
  var isBridalClient = mf ? (String(mf['is_bridal_client'] || '').toLowerCase() === 'true') : null;
  html += '<div style="background:' + (accessOk ? '#e8f5e9' : '#fff3e0') + ';border-radius:var(--radius-medium);padding:0.5rem 0.75rem;margin:0.5rem 0;display:flex;align-items:flex-start;gap:0.5rem;flex-wrap:wrap;">';
  html += '<span style="font-size:0.85rem;margin-top:0.05rem;">' + (accessOk ? '✓' : '⚠') + '</span>';
  html += '<div style="flex:1;min-width:0;">';
  html += accessOk
    ? '<span style="font-size:0.74rem;color:#1f6b46;font-weight:700;">Portal accessible</span><span style="font-size:0.72rem;color:var(--muted);margin-left:0.35rem;">· Shopify customer linked</span>'
    : '<span style="font-size:0.74rem;color:#9a4c1e;font-weight:700;">Portal may be inaccessible</span><span style="font-size:0.72rem;color:var(--muted);margin-left:0.35rem;">· No Shopify customer ID</span>';
  if (accessOk && isBridalClient === false) {
    html += '<div style="font-size:0.68rem;color:#e8a030;margin-top:0.18rem;">⚠ Bride flag not set — portal may not show bridal content</div>';
  }
  html += '</div>';
  html += '<a href="' + escHtml(access.portalUrl || '#') + '" target="_blank" rel="noopener" style="font-size:0.68rem;color:var(--brand-primary);text-decoration:none;white-space:nowrap;flex-shrink:0;">Open portal ↗</a>';
  html += '</div>';

  // ── 3. Task pills (matching bridal hub visual style) ──────────────
  var visibleTasks = tasks.filter(function(t) { return t.status !== 'not_applicable'; });
  if (visibleTasks.length) {
    html += sectionLabel('What she sees to do');
    visibleTasks.forEach(function(task) {
      var mfInfo = mf ? mfTaskMap[task.id] : null;
      var fromShopify = false;
      var effectiveStatus = task.status;

      if (mf && mfInfo) {
        var mfVal  = String(mf[mfInfo.key]              !== undefined ? mf[mfInfo.key]              : '').toLowerCase();
        var altVal = mfInfo.altKey && mf[mfInfo.altKey] !== undefined ? String(mf[mfInfo.altKey]).toLowerCase() : '';
        if (mf[mfInfo.key] !== undefined || (mfInfo.altKey && mf[mfInfo.altKey] !== undefined)) {
          fromShopify = true;
          if (effectiveStatus !== 'not_available' && effectiveStatus !== 'not_applicable') {
            effectiveStatus = (mfVal === 'true' || altVal === 'true') ? 'complete' : 'pending';
          }
        }
      }

      var isDone = effectiveStatus === 'complete';
      var isGray = effectiveStatus === 'not_available';
      var isNA   = effectiveStatus === 'not_applicable';

      var statusLabel, statusBg, statusColor;
      if (isDone)      { statusLabel = '✓ Done';     statusBg = '#e8f5e9'; statusColor = '#1f6b46'; }
      else if (isGray) { statusLabel = '⏳ Not yet'; statusBg = '#f6f1ee'; statusColor = '#9a918a'; }
      else if (isNA)   { statusLabel = '— N/A';      statusBg = '#f6f1ee'; statusColor = '#9a918a'; }
      else             { statusLabel = '● Pending';  statusBg = '#fff3e0'; statusColor = '#9a4c1e'; }

      html += '<div style="display:flex;align-items:flex-start;gap:0.5rem;padding:0.55rem 0.75rem;border-radius:var(--radius-medium);background:' + (isDone ? '#f0faf2' : '#faf8f7') + ';margin-bottom:0.4rem;border:1px solid ' + (isDone ? '#b9dfc4' : '#e6dad4') + ';">';
      html += '<div style="flex:1;min-width:0;">';
      html += '<div style="font-weight:600;font-size:0.82rem;color:var(--brand-dark);">' + escHtml(task.label) + '</div>';
      if (task.description) html += '<div style="font-size:0.72rem;color:var(--muted);margin-top:0.15rem;">' + escHtml(task.description) + '</div>';
      html += '<div style="font-size:0.62rem;color:var(--muted);margin-top:0.18rem;">' + (fromShopify ? 'Shopify ✓' : 'CRM') + '</div>';
      html += '</div>';
      html += '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:0.3rem;flex-shrink:0;">';
      html += '<span style="font-size:0.7rem;font-weight:700;border-radius:var(--radius-pill);padding:0.18rem 0.55rem;white-space:nowrap;background:' + statusBg + ';color:' + statusColor + ';">' + statusLabel + '</span>';

      var tAction = (!isDone && !isGray && !isNA) ? taskActionMap[task.id] : null;
      var canView = isDone && viewableSubmission[task.id];
      if (tAction) {
        html += '<button data-cid="' + cid + '" data-task="' + task.id + '" ' + tAction.extra + ' onclick="' + tAction.handler + '" style="font-size:0.65rem;padding:0.2rem 0.45rem;background:var(--brand-primary);color:#fff;border:none;border-radius:6px;cursor:pointer;white-space:nowrap;">' + escHtml(tAction.label) + '</button>';
      }
      if (canView) {
        html += '<button data-cid="' + cid + '" data-task="' + task.id + '" onclick="cppToggleSubmissionBtn(this)" style="font-size:0.65rem;padding:0.2rem 0.45rem;background:var(--brand-bg-soft);color:var(--brand-text);border:1px solid #e6dad4;border-radius:6px;cursor:pointer;white-space:nowrap;">View</button>';
      }
      html += '</div></div>';
    });
  }

  // ── 4. Pro team (lazy) ────────────────────────────────────────────
  var rl = feat.runsheetLive || {};
  var rsTimelineId = 'cpp-rs-timeline-' + cid;
  var rsProTeamId  = 'cpp-rs-proteam-' + cid;
  html += sectionLabel('Pro team');
  if (rl.runsheetState === 'published') {
    html += '<div id="' + rsProTeamId + '" style="font-size:0.75rem;color:var(--muted);padding:0.15rem 0 0.4rem;">Loading…</div>';
  } else {
    html += '<div style="font-size:0.75rem;color:var(--muted);padding:0.15rem 0 0.4rem;">Artists will appear here once the runsheet is finalised.</div>';
  }

  // ── 5. Wedding morning runsheet (lazy) ────────────────────────────
  html += sectionLabel('Wedding morning runsheet');
  if (rl.runsheetState === 'published') {
    html += '<div id="' + rsTimelineId + '" style="font-size:0.75rem;color:var(--muted);padding:0.15rem 0 0.4rem;">Loading runsheet…</div>';
  } else if (rl.runsheetState === 'draft') {
    html += '<div style="font-size:0.75rem;color:var(--muted);padding:0.15rem 0 0.4rem;">Runsheet is in draft — not yet published to bride.</div>';
  } else {
    html += '<div style="font-size:0.75rem;color:var(--muted);padding:0.15rem 0 0.4rem;">Runsheet not yet created.</div>';
  }

  // ── 6. Bridal party ───────────────────────────────────────────────
  var addFormId = 'cpp-add-form-' + cid;
  html += '<div style="display:flex;align-items:center;justify-content:space-between;margin:1rem 0 0.45rem;">'
    + '<div style="font-size:0.67rem;font-weight:700;letter-spacing:0.07em;color:var(--muted);text-transform:uppercase;">Bridal party (' + (bp.members ? bp.members.length : 0) + ')</div>'
    + '<button data-cid="' + cid + '" data-container="' + escHtml(addFormId) + '" onclick="cppShowAddMemberFormBtn(this)" style="font-size:0.7rem;padding:0.18rem 0.55rem;background:#fff;border:1px solid var(--brand-primary);border-radius:var(--radius-pill);cursor:pointer;color:var(--brand-primary);">+ Add member</button>'
    + '</div>';
  if (bp.members && bp.members.length) {
    html += '<div style="display:flex;flex-direction:column;gap:0.4rem;">';
    bp.members.forEach(function(m, idx) {
      var done        = String(m.formStatus || '').toLowerCase() === 'complete';
      var hasEmail    = !!(m.email && m.email.trim());
      var statusBg    = done ? '#e8f5e9' : hasEmail ? '#fff3e0' : '#f6f1ee';
      var statusColor = done ? '#1f6b46' : hasEmail ? '#9a4c1e' : '#9a918a';
      var statusLabel = done ? 'Onboarded' : hasEmail ? 'Invited' : 'Pending';
      var pmId        = m.pm_id || '';
      var picUrl      = m.profile_pic_url || '';
      var initials    = (m.name || 'M').split(' ').map(function(p) { return p.charAt(0); }).join('').slice(0, 2).toUpperCase();
      var cardId      = 'cpp-mcard-' + cid + '-' + idx;
      var viewId      = 'cpp-mview-' + cid + '-' + idx;
      var editId      = 'cpp-medit-' + cid + '-' + idx;
      // Inspo thumbnails (hair + makeup, up to 4 total)
      var thumbsHtml_ = '';
      var thumbUrls_  = [];
      String(m.hair_inspo_urls   || '').split(',').concat(
        String(m.makeup_inspo_urls || '').split(',')
      ).forEach(function(u) { u = u.trim(); if (u && thumbUrls_.length < 4) thumbUrls_.push(u); });
      if (thumbUrls_.length) {
        thumbsHtml_ = '<div style="display:flex;gap:0.2rem;flex-wrap:wrap;margin-top:0.3rem;">';
        thumbUrls_.forEach(function(u) {
          thumbsHtml_ += '<a href="' + escHtml(u) + '" target="_blank" rel="noopener">'
            + '<img src="' + escHtml(u) + '" style="width:34px;height:34px;object-fit:cover;border-radius:5px;display:block;" loading="lazy" onerror="this.style.display=\'none\'" alt="Inspo">'
            + '</a>';
        });
        thumbsHtml_ += '</div>';
      }
      // Beauty profile summary (shows below contact info)
      var summaryParts = [];
      if (m.hair_style)    summaryParts.push('Hair: <b>' + escHtml(m.hair_style) + '</b>');
      if (m.allergies)     summaryParts.push('Allergies: <b>' + escHtml(m.allergies) + '</b>');
      if (m.skin_concerns) summaryParts.push('Skin: <b>' + escHtml(m.skin_concerns) + '</b>');
      var profileSummary = summaryParts.length
        ? '<div style="margin-top:0.3rem;font-size:0.65rem;color:#7e706c;display:flex;flex-wrap:wrap;gap:0.25rem 0.6rem;">' + summaryParts.join('') + '</div>'
        : '';

      html += '<div id="' + escHtml(cardId) + '" style="background:#fff;border:1px solid #e6dad4;border-radius:var(--radius-medium);padding:0.6rem;">';
      // View state
      html += '<div id="' + escHtml(viewId) + '">';
      html += '<div style="display:flex;align-items:flex-start;gap:0.5rem;">';
      // Avatar
      html += '<div style="width:34px;height:34px;border-radius:50%;background:var(--brand-bg-soft);display:flex;align-items:center;justify-content:center;font-size:0.68rem;font-weight:700;color:var(--brand-primary);flex-shrink:0;overflow:hidden;">';
      html += picUrl
        ? '<img src="' + escHtml(picUrl) + '" style="width:100%;height:100%;object-fit:cover;" alt="' + escHtml(m.name || '') + '" onerror="this.parentNode.textContent=\'' + escHtml(initials) + '\'">'
        : escHtml(initials);
      html += '</div>';
      // Name, role, contact, profile summary
      html += '<div style="flex:1;min-width:0;">';
      html += '<div style="font-size:0.78rem;font-weight:700;color:var(--brand-dark);">' + escHtml(m.name || 'Unknown') + '</div>';
      if (m.role) html += '<div style="font-size:0.67rem;color:var(--muted);">' + escHtml(m.role) + '</div>';
      var contactParts = [m.email, m.phone].filter(Boolean);
      if (contactParts.length) html += '<div style="font-size:0.64rem;color:var(--muted);">' + escHtml(contactParts.join(' / ')) + '</div>';
      html += profileSummary + thumbsHtml_;
      html += '</div>';
      // Status chip + action buttons
      html += '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:0.3rem;flex-shrink:0;">';
      html += '<span style="font-size:0.6rem;font-weight:700;padding:0.1rem 0.45rem;border-radius:var(--radius-pill);background:' + statusBg + ';color:' + statusColor + ';white-space:nowrap;">' + escHtml(statusLabel) + '</span>';
      html += '<div style="display:flex;gap:0.25rem;">';
      html += '<button data-cid="' + cid + '" data-idx="' + idx + '" onclick="cppToggleMemberEditCard_(this)" style="font-size:0.68rem;padding:0.2rem 0.5rem;background:var(--brand-bg-soft);border:1px solid #ddd;border-radius:6px;cursor:pointer;color:var(--brand-primary);">Edit</button>';
      html += '<button data-cid="' + cid + '" data-pmid="' + escHtml(pmId) + '" data-member="' + escHtml(m.name || '') + '" data-completed="' + (done ? '1' : '0') + '" onclick="cppRemovePartyMemberBtn(this)" style="font-size:0.68rem;padding:0.2rem 0.5rem;background:#fff;border:1px solid #ffcdd2;border-radius:6px;cursor:pointer;color:#c0392b;">Remove</button>';
      html += '</div></div>';
      html += '</div></div>'; // end flex row + view state div
      // Edit state (empty; populated by cppToggleMemberEditCard_)
      html += '<div id="' + escHtml(editId) + '" style="display:none;"></div>';
      html += '</div>'; // end card
    });
    html += '</div>';
    html += '<div style="font-size:0.68rem;color:var(--muted);margin-top:0.35rem;">' + (bp.onboardedCount || 0) + '/' + (bp.memberCount || 0) + ' onboarded</div>';
  } else {
    html += '<div style="font-size:0.75rem;color:var(--muted);padding:0.1rem 0 0.3rem;">No members added yet.</div>';
  }
  html += '<div id="' + escHtml(addFormId) + '"></div>';

  // ── 7. Files & Links ──────────────────────────────────────────────
  html += sectionLabel('Files published to bride');
  html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0.4rem;">';
  var fileItems = [
    { label: 'Shared folder', has: files.hasFolder,      url: files.folderUrl },
    { label: 'Agreement',     has: files.hasAgreement,   url: files.agreementUrl },
    { label: 'Runsheet PDF',  has: files.hasRunsheetPdf, url: files.runsheetPdfUrl },
    { label: 'Invoices',      has: (files.invoiceCount || 0) > 0, url: null, count: files.invoiceCount }
  ];
  fileItems.forEach(function(f) {
    var isSet = !!f.has;
    html += '<div style="background:' + (isSet ? '#f0faf2' : '#faf8f7') + ';border:1px solid ' + (isSet ? '#b9dfc4' : '#e6dad4') + ';border-radius:var(--radius-medium);padding:0.5rem 0.65rem;display:flex;align-items:center;gap:0.4rem;">';
    html += '<span style="font-size:0.72rem;color:' + (isSet ? '#1f6b46' : '#9a918a') + ';">' + (isSet ? '&#10003;' : '&#9675;') + '</span>';
    html += '<div style="flex:1;min-width:0;">';
    html += '<div style="font-size:0.72rem;font-weight:600;color:' + (isSet ? '#1f6b46' : 'var(--muted)') + ';">' + escHtml(f.label) + (f.count > 1 ? ' (' + f.count + ')' : '') + '</div>';
    if (isSet && f.url) {
      html += '<a href="' + escHtml(f.url) + '" target="_blank" rel="noopener" style="font-size:0.62rem;color:var(--brand-primary);text-decoration:none;">Open ↗</a>';
    } else {
      html += '<div style="font-size:0.62rem;color:#9a918a;">' + (isSet ? 'Available' : 'Not set') + '</div>';
    }
    html += '</div></div>';
  });
  html += '</div>';

  // ── 8. Sync health footer ─────────────────────────────────────────
  var lastSynced  = data.shopifyLastSynced || '';
  var mfFetched   = mf !== null;
  var syncWarning = '';
  if (lastSynced) {
    var parts = lastSynced.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (parts) {
      var syncDate = new Date(parseInt(parts[3], 10), parseInt(parts[2], 10) - 1, parseInt(parts[1], 10));
      var daysDiff = Math.floor((Date.now() - syncDate.getTime()) / 86400000);
      if (daysDiff > 7) syncWarning = ' · ⚠ sync may be stale (' + daysDiff + 'd ago)';
    }
  }
  html += '<div style="margin-top:0.75rem;padding:0.45rem 0.7rem;background:var(--brand-bg-soft);border-radius:var(--radius-medium);font-size:0.65rem;color:var(--muted);">';
  html += lastSynced ? ('Last Shopify sync: ' + escHtml(lastSynced) + syncWarning) : 'No Shopify sync date recorded';
  html += ' · Metafields: ' + (mfFetched ? 'live (' + new Date().toLocaleTimeString() + ')' : 'unavailable — CRM data shown');
  html += '</div>';

  // ── 9. Vision & Party cards ────────────────────────────────────
  var _parseMetaJson = function(str) { try { return str ? JSON.parse(str) : null; } catch(e) { return null; } };
  var _brideProfile = mf ? _parseMetaJson(mf['bride_profile_json']) : null;
  var _brideBrief   = mf ? _parseMetaJson(mf['bride_brief_json'])   : null;
  var _brideInspo   = mf ? _parseMetaJson(mf['bride_inspo_photos']) : null;
  var _partyBlob    = mf ? _parseMetaJson(mf['jv_party_members_json']) : null;
  var _partyMembers = (_partyBlob && _partyBlob.members) || [];
  var _hasCards = _brideProfile || _brideBrief || _brideInspo || _partyMembers.length;

  if (_hasCards) {
    html += sectionLabel('Vision &amp; Party');
    html += jvPcRenderCards_(_brideProfile, _brideBrief, _brideInspo, _partyMembers, bride.name || '');
  }

  // Store member data for inline edit card access (keyed by cid)
  window['cppMemberData_' + cid] = (bp && bp.members) ? bp.members : [];

  if (el) el.innerHTML = html;
  if (_hasCards) {
    _jvPcCardData_ = {
      brideProfile: _brideProfile,
      brideBrief:   _brideBrief,
      brideInspo:   _brideInspo,
      partyMembers: _partyMembers,
      brideName:    bride.name || ''
    };
    jvPcInitCards_(targetElId || 'cpp-preview');
  }

  if (rl.runsheetState === 'published') {
    cppLoadRunsheetTimeline(cid, rsTimelineId, rsProTeamId, bride.name);
  }
}

// ── Vision & Party card helpers ──────────────────────────────────────────────

function jvPcEsc_(s) { return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

function jvPcThumbsHtml_(hairCsv, makeupCsv, limit) {
  var urls = [];
  (String(hairCsv || '').split(',').concat(String(makeupCsv || '').split(','))).forEach(function(u) {
    u = u.trim();
    if (u && urls.length < (limit || 4)) urls.push(u);
  });
  if (!urls.length) return '';
  return '<div class="jv-pc-thumb-strip">' +
    urls.map(function(u) {
      return '<a href="' + jvPcEsc_(u) + '" target="_blank" rel="noopener" class="jv-party-hub__thumb-link">' +
        '<img src="' + jvPcEsc_(u) + '" class="jv-party-hub__thumb" loading="lazy" alt="Inspiration">' +
        '</a>';
    }).join('') +
  '</div>';
}

function jvPcModalBodyForBride_(profile, brief, inspo, name) {
  var html = '<p class="jv-pc-modal__name">' + jvPcEsc_(name) + '</p>';
  html += '<p class="jv-pc-modal__role">Bride</p>';
  var words = (profile && profile.visionWords) || [];
  if (words.length) {
    html += '<p class="jv-party-hub__sub-heading">Wedding Vision</p>';
    html += '<div style="display:flex;flex-wrap:wrap;gap:0.4rem;margin-bottom:0.75rem;">';
    words.forEach(function(w) { html += '<span class="jv-vision-word-badge">' + jvPcEsc_(w) + '</span>'; });
    html += '</div>';
  }
  html += '<p class="jv-party-hub__sub-heading">Details</p><div class="jv-party-hub__detail-grid">';
  var rows = [
    ['Partner', profile && profile.partnerName],
    ['Beauty notes', profile && profile.beautyNotes],
    ['Hairstyle', brief && brief.hairstylePref],
    ['Makeup vibe', brief && brief.makeupVibe]
  ];
  rows.forEach(function(r) {
    if (!r[1]) return;
    html += '<div class="jv-party-hub__detail-row"><span class="jv-party-hub__detail-label">' + jvPcEsc_(r[0]) + '</span>' +
      '<span class="jv-party-hub__detail-value">' + jvPcEsc_(r[1]).replace(/\n/g,'<br>') + '</span></div>';
  });
  html += '</div>';
  var hairIds   = (inspo && inspo.hair)   || [];
  var makeupIds = (inspo && inspo.makeup) || [];
  if (hairIds.length) {
    html += '<p class="jv-party-hub__sub-heading">Hair Inspiration</p><div class="jv-pc-modal__inspo-grid">';
    hairIds.forEach(function(fid) {
      var url = 'https://lh3.googleusercontent.com/d/' + jvPcEsc_(fid);
      html += '<a href="' + url + '" target="_blank" rel="noopener"><img src="' + url + '" loading="lazy" alt="Hair inspiration"></a>';
    });
    html += '</div>';
  }
  if (makeupIds.length) {
    html += '<p class="jv-party-hub__sub-heading">Makeup Inspiration</p><div class="jv-pc-modal__inspo-grid">';
    makeupIds.forEach(function(fid) {
      var url = 'https://lh3.googleusercontent.com/d/' + jvPcEsc_(fid);
      html += '<a href="' + url + '" target="_blank" rel="noopener"><img src="' + url + '" loading="lazy" alt="Makeup inspiration"></a>';
    });
    html += '</div>';
  }
  return html;
}

function jvPcModalBodyForMember_(member) {
  var name = member.name || 'Party Member';
  var role = member.role || '';
  var html = '<p class="jv-pc-modal__name">' + jvPcEsc_(name) + '</p>';
  if (role) html += '<p class="jv-pc-modal__role">' + jvPcEsc_(role) + '</p>';
  var fields = [
    ['Hairstyle', member.hair_style || member.hairStyle],
    ['Colour palette', member.colour_palette || member.colourPalette],
    ['Skin concerns', member.skin_concerns || member.skinConcerns],
    ['Allergies', member.allergies],
    ['Notes', member.inspo_notes || member.inspoNotes]
  ];
  var hasDetails = fields.some(function(f) { return !!f[1]; });
  if (hasDetails) {
    html += '<p class="jv-party-hub__sub-heading">Details</p><div class="jv-party-hub__detail-grid">';
    fields.forEach(function(r) {
      if (!r[1]) return;
      html += '<div class="jv-party-hub__detail-row"><span class="jv-party-hub__detail-label">' + jvPcEsc_(r[0]) + '</span>' +
        '<span class="jv-party-hub__detail-value">' + jvPcEsc_(r[1]).replace(/\n/g,'<br>') + '</span></div>';
    });
    html += '</div>';
  }
  var hairUrls   = String(member.hair_inspo_urls || member.hairInspoUrls || '').split(',').map(function(u) { return u.trim(); }).filter(Boolean);
  var makeupUrls = String(member.makeup_inspo_urls || member.makeupInspoUrls || '').split(',').map(function(u) { return u.trim(); }).filter(Boolean);
  if (hairUrls.length) {
    html += '<p class="jv-party-hub__sub-heading">Hair Inspiration</p><div class="jv-pc-modal__inspo-grid">';
    hairUrls.forEach(function(u) { html += '<a href="' + jvPcEsc_(u) + '" target="_blank" rel="noopener"><img src="' + jvPcEsc_(u) + '" loading="lazy" alt="Hair inspiration"></a>'; });
    html += '</div>';
  }
  if (makeupUrls.length) {
    html += '<p class="jv-party-hub__sub-heading">Makeup Inspiration</p><div class="jv-pc-modal__inspo-grid">';
    makeupUrls.forEach(function(u) { html += '<a href="' + jvPcEsc_(u) + '" target="_blank" rel="noopener"><img src="' + jvPcEsc_(u) + '" loading="lazy" alt="Makeup inspiration"></a>'; });
    html += '</div>';
  }
  return html;
}

function jvPcRenderCards_(brideProfile, brideBrief, brideInspo, partyMembers, brideName) {
  var html = '';
  var brideInitials = (brideName || 'B').split(' ').map(function(p) { return p.charAt(0); }).join('').slice(0, 2).toUpperCase() || 'B';
  var bridePicUrl = brideProfile && brideProfile.profilePicUrl;
  var brideThumbsHtml = '';
  var brideHairIds   = (brideInspo && brideInspo.hair)   || [];
  var brideMakeupIds = (brideInspo && brideInspo.makeup) || [];
  var brideThumbUrls = brideHairIds.concat(brideMakeupIds).slice(0, 4).map(function(fid) {
    return 'https://lh3.googleusercontent.com/d/' + fid;
  });
  if (brideThumbUrls.length) {
    brideThumbsHtml = '<div class="jv-pc-thumb-strip">' +
      brideThumbUrls.map(function(u) {
        return '<a href="' + jvPcEsc_(u) + '" target="_blank" rel="noopener" class="jv-party-hub__thumb-link">' +
          '<img src="' + jvPcEsc_(u) + '" class="jv-party-hub__thumb" loading="lazy" alt="Inspiration"></a>';
      }).join('') + '</div>';
  }

  html += '<div class="jv-party-hub__card jv-pc-card" data-jv-pc-type="bride">';
  html += '<div class="jv-party-hub__card-header">';
  html += '<div class="jv-party-hub__avatar">' +
    (bridePicUrl ? '<img class="jv-party-hub__avatar-img" src="' + jvPcEsc_(bridePicUrl) + '" alt="' + jvPcEsc_(brideName) + '" loading="lazy">' : jvPcEsc_(brideInitials)) +
    '</div>';
  html += '<div class="jv-party-hub__card-identity"><p class="jv-party-hub__card-name">' + jvPcEsc_(brideName || 'Bride') + '</p><p class="jv-party-hub__card-role">Bride</p></div>';
  html += '<div class="jv-party-hub__card-meta">' + brideThumbsHtml +
    '<button type="button" class="jv-party-hub__expand-btn jv-pc-view-full" data-jv-pc-type="bride">View full</button></div>';
  html += '</div></div>';

  if (partyMembers.length) {
    html += '<div class="jv-party-hub__grid" style="margin-top:0.75rem;">';
    partyMembers.forEach(function(m, idx) {
      var name = m.name || 'Party Member';
      var role = m.role || '';
      var picUrl = m.profile_pic_url || m.profilePicUrl || '';
      var initials = (name).split(' ').map(function(p) { return p.charAt(0); }).join('').slice(0, 2).toUpperCase() || '?';
      var thumbsHtml = jvPcThumbsHtml_(m.hair_inspo_urls || m.hairInspoUrls, m.makeup_inspo_urls || m.makeupInspoUrls, 4);
      html += '<div class="jv-party-hub__card jv-pc-card" data-jv-pc-type="member" data-jv-pc-idx="' + idx + '">';
      html += '<div class="jv-party-hub__card-header">';
      html += '<div class="jv-party-hub__avatar">' +
        (picUrl ? '<img class="jv-party-hub__avatar-img" src="' + jvPcEsc_(picUrl) + '" alt="' + jvPcEsc_(name) + '" loading="lazy">' : jvPcEsc_(initials)) +
        '</div>';
      html += '<div class="jv-party-hub__card-identity"><p class="jv-party-hub__card-name">' + jvPcEsc_(name) + '</p>' +
        (role ? '<p class="jv-party-hub__card-role">' + jvPcEsc_(role) + '</p>' : '') + '</div>';
      html += '<div class="jv-party-hub__card-meta">' + thumbsHtml +
        '<button type="button" class="jv-party-hub__expand-btn jv-pc-view-full" data-jv-pc-type="member" data-jv-pc-idx="' + idx + '">View full</button></div>';
      html += '</div></div>';
    });
    html += '</div>';
  }

  return html;
}

var _jvPcCardData_ = null; // cache for current CPP bride+party data

function jvPcInitCards_(containerId) {
  var container = document.getElementById(containerId);
  if (!container) return;

  // Ensure modal exists
  if (!document.getElementById('jv-pc-modal')) {
    var backdrop = document.createElement('div');
    backdrop.className = 'jv-pc-modal-backdrop';
    backdrop.id = 'jv-pc-modal';
    backdrop.style.display = 'none';
    backdrop.innerHTML = '<div class="jv-pc-modal"><button class="jv-pc-modal__close" id="jv-pc-modal-close" aria-label="Close">&times;</button><div class="jv-pc-modal__body" id="jv-pc-modal-body"></div></div>';
    document.body.appendChild(backdrop);
    document.getElementById('jv-pc-modal-close').addEventListener('click', jvPcCloseModal_);
    backdrop.addEventListener('click', function(e) { if (e.target === backdrop) jvPcCloseModal_(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') jvPcCloseModal_(); });
  }

  container.querySelectorAll('.jv-pc-view-full').forEach(function(btn) {
    if (btn._jvPcWired) return;
    btn._jvPcWired = true;
    btn.addEventListener('click', function() {
      var type = btn.getAttribute('data-jv-pc-type');
      var bodyEl = document.getElementById('jv-pc-modal-body');
      if (!bodyEl || !_jvPcCardData_) return;
      var d = _jvPcCardData_;
      if (type === 'bride') {
        bodyEl.innerHTML = jvPcModalBodyForBride_(d.brideProfile, d.brideBrief, d.brideInspo, d.brideName);
      } else {
        var idx = parseInt(btn.getAttribute('data-jv-pc-idx') || '0', 10);
        var members = d.partyMembers || [];
        if (members[idx]) bodyEl.innerHTML = jvPcModalBodyForMember_(members[idx]);
      }
      document.getElementById('jv-pc-modal').style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  });
}

function jvPcCloseModal_() {
  var m = document.getElementById('jv-pc-modal');
  if (m) m.style.display = 'none';
  document.body.style.overflow = '';
}

function cppLoadRunsheetTimeline(clientId, timelineElId, proTeamElId, brideName) {
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getRunsheetTimeline', args: { id: clientId } })
    .then(function(res) {
      var d    = res && res.data;
      var tlEl = document.getElementById(timelineElId);
      var ptEl = document.getElementById(proTeamElId);

      if (!d || !d.ok) {
        if (tlEl) tlEl.textContent = 'Could not load runsheet.';
        if (ptEl) ptEl.textContent = 'Could not load.';
        return;
      }

      // Render pro team — rich cards when metaobject data is available, name pills as fallback
      if (ptEl) {
        var proMembers = d.proTeamMembers || [];
        var proNames   = d.proTeamNames   || [];
        var ptHtml = '';
        if (proMembers.length) {
          ptHtml = '<div style="display:flex;flex-wrap:wrap;gap:0.5rem;margin-bottom:0.5rem;">';
          proMembers.forEach(function(m) {
            ptHtml += '<div style="display:flex;align-items:center;gap:0.5rem;background:#faf8f7;border:1px solid #e6dad4;border-radius:var(--radius-medium);padding:0.45rem 0.65rem;min-width:140px;">';
            if (m.photoUrl) {
              ptHtml += '<img src="' + escHtml(m.photoUrl) + '" alt="" style="width:36px;height:36px;border-radius:50%;object-fit:cover;flex-shrink:0;" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'flex\'">';
              ptHtml += '<div style="display:none;width:36px;height:36px;border-radius:50%;background:var(--brand-primary);color:#fff;font-weight:700;font-size:0.75rem;align-items:center;justify-content:center;flex-shrink:0;">' + escHtml((m.name || '?').charAt(0).toUpperCase()) + '</div>';
            } else {
              ptHtml += '<div style="width:36px;height:36px;border-radius:50%;background:var(--brand-primary);color:#fff;font-weight:700;font-size:0.75rem;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' + escHtml((m.name || '?').charAt(0).toUpperCase()) + '</div>';
            }
            ptHtml += '<div style="min-width:0;">';
            ptHtml += '<div style="font-size:0.78rem;font-weight:700;color:var(--brand-dark);">' + escHtml(m.name || '—') + '</div>';
            if (m.role)      ptHtml += '<div style="font-size:0.67rem;color:var(--muted);">' + escHtml(m.role) + '</div>';
            if (m.instagram) ptHtml += '<div style="font-size:0.63rem;color:var(--brand-primary);">@' + escHtml(m.instagram.replace(/^@/, '')) + '</div>';
            ptHtml += '</div></div>';
          });
          ptHtml += '</div>';
        } else if (proNames.length) {
          ptHtml = '<div style="display:flex;flex-wrap:wrap;gap:0.35rem;margin-bottom:0.5rem;">';
          proNames.forEach(function(n) {
            ptHtml += '<span style="font-size:0.72rem;font-weight:600;padding:0.2rem 0.65rem;background:var(--brand-primary);color:#fff;border-radius:var(--radius-pill);">' + escHtml(n) + '</span>';
          });
          ptHtml += '</div>';
        } else {
          ptHtml = '<div style="font-size:0.75rem;color:var(--muted);padding:0.1rem 0 0.5rem;">Pro team not yet assigned.</div>';
        }
        ptEl.outerHTML = ptHtml;
      }

      // Render timeline
      if (tlEl) {
        if (d.services && d.services.length) {
          var html = '<div style="background:var(--brand-bg-soft);border-radius:var(--radius-medium);padding:0.55rem 0.75rem;margin-bottom:0.5rem;max-height:240px;overflow-y:auto;">';
          d.services.forEach(function(svc) {
            var timeStr = (svc.time || '') + (svc.endTime ? '–' + svc.endTime : '');
            html += '<div style="display:flex;gap:0.6rem;align-items:flex-start;padding:0.25rem 0;border-bottom:1px solid #e6dad4;font-size:0.72rem;">';
            html += '<span style="font-weight:700;color:var(--brand-primary);min-width:4.5rem;white-space:nowrap;">' + escHtml(timeStr) + '</span>';
            html += '<div style="flex:1;"><span style="font-weight:600;">' + escHtml(svc.service || svc.role || '') + '</span>';
            if (svc.artist) html += ' <span style="color:var(--muted);">— ' + escHtml(svc.artist) + '</span>';
            if (svc.client && svc.client !== brideName) html += ' <span style="font-size:0.65rem;color:var(--muted);">(' + escHtml(svc.client) + ')</span>';
            html += '</div></div>';
          });
          html += '</div>';
          tlEl.outerHTML = html;
        } else {
          tlEl.textContent = 'No service data in published runsheet.';
        }
      }
    })
    .catch(function() {
      var tlEl = document.getElementById(timelineElId);
      var ptEl = document.getElementById(proTeamElId);
      if (tlEl) tlEl.textContent = 'Could not load runsheet.';
      if (ptEl) ptEl.textContent = 'Could not load.';
    });
}

function cppOpenPreviewAsBride(clientId) {
  var btn = event && event.currentTarget;
  if (btn) { btn.disabled = true; btn.textContent = 'Generating…'; }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_generatePreviewToken', args: { id: clientId } })
    .then(function(res) {
      if (res && res.ok && res.data && res.data.previewUrl) {
        window.open(res.data.previewUrl, '_blank', 'noopener');
        jvToast('Bride preview opened in new tab (expires in 1 hour)', 'info');
      } else {
        var msg = (res && res.data && res.data.error) || 'Could not generate preview link';
        jvToast(msg, 'error');
      }
    })
    .catch(function() { jvToast('Failed to generate preview link', 'error'); })
    .finally(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Preview as bride'; }
    });
}

// ── Client Portal Preview — standalone view ───────────────────────────────────

var _cppIndex            = null;
var _cppSelectedClientId = null;
var _cppActiveTargetEl   = 'cpp-preview';
var _cppSearchTimer      = null;

function initClientPortalPreviewView() {
  // RETIRED 2026-07-31 (Jess): the Client Portal Preview standalone view rendered a live
  // bride hub and 30s-timed-out; hardly used. Neutered so it fires NO slow call. The
  // original body + all cpp* helpers + renderPortalPreview are kept ARCHIVED below (dead
  // code, no live caller) so it can be revived from the bride_profile_cache CDN later.
  showContent('client-portal-preview');
  var results = document.getElementById('cpp-results');
  if (results) {
    results.innerHTML = '<div style="padding:1rem 0.9rem;font-size:0.8rem;color:var(--muted);">' +
      'Portal Preview has been retired. To see a bride’s hub, open her bridal hub directly. ' +
      'It may return later served from the CDN cache.</div>';
  }
}

/* ARCHIVED 2026-07-31 (Jess): original initClientPortalPreviewView body, kept for revival.
function initClientPortalPreviewView_ARCHIVED() {
  showContent('client-portal-preview');
  document.getElementById('cpp-search').focus();
  if (_cppIndex) return;
  document.getElementById('cpp-results').innerHTML = '<div style="padding:0.6rem 0.9rem;font-size:0.75rem;color:var(--muted);">Loading clients...</div>';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientIndex' })
    .then(function(res) {
      _cppIndex = Array.isArray(res.data) ? res.data : [];
      document.getElementById('cpp-results').innerHTML = '';
      if ((document.getElementById('cpp-search').value || '').trim().length >= 2) cppSearch();
    })
    .catch(function() {
      document.getElementById('cpp-results').innerHTML = '<div class="alert danger">Failed to load client list</div>';
    });
}
*/

function cppSearch() {
  clearTimeout(_cppSearchTimer);
  _cppSearchTimer = setTimeout(function() {
    var q = (document.getElementById('cpp-search').value || '').trim();
    if (q.length < 2) { document.getElementById('cpp-results').innerHTML = ''; return; }
    if (!_cppIndex) { return; }
    var qLow = q.toLowerCase().replace(/[‘’‚‛′‵`]/g, "'");
    var matches = [];
    for (var i = 0; i < _cppIndex.length; i++) {
      var row = _cppIndex[i]; // [rowIdx, emailLow, fullName, phone, booked, weddingIso, haystack]
      if (((row[6] || '').indexOf(qLow) >= 0) || ((row[2] || '').toLowerCase().indexOf(qLow) >= 0)) {
        matches.push(row);
        if (matches.length >= 12) break;
      }
    }
    if (!matches.length) { document.getElementById('cpp-results').innerHTML = '<div style="padding:0.75rem;color:var(--muted);font-size:0.8rem;">No clients found</div>'; return; }
    var html = '';
    matches.forEach(function(row) {
      var cid   = row[0];
      var name  = row[2] || '—';
      var email = row[1] || '';
      var wd    = row[5] ? String(row[5]).slice(0, 10) : '';
      html += '<div class="cpp-result-row" data-cid="' + cid + '" data-name="' + escHtml(name) + '" onclick="cppSelectClientRow(this)" style="display:flex;align-items:center;gap:0.75rem;padding:0.55rem 0.9rem;cursor:pointer;border-bottom:1px solid #e6dad4;" onmouseover="this.style.background=\'var(--brand-bg-soft)\'" onmouseout="this.style.background=\'#fff\'">';
      html += '<div style="flex:1;min-width:0;">';
      html += '<div style="font-size:0.82rem;font-weight:600;">' + escHtml(name) + '</div>';
      html += '<div style="font-size:0.68rem;color:var(--muted);">' + escHtml(email) + (wd ? ' · ' + wd : '') + '</div>';
      html += '</div>';
      html += '<span style="font-size:0.65rem;color:var(--muted);">' + (row[4] ? 'Booked' : '') + '</span>';
      html += '</div>';
    });
    document.getElementById('cpp-results').innerHTML = '<div style="background:#fff;border:1px solid #e6dad4;border-radius:var(--radius-medium);overflow:hidden;">' + html + '</div>';
  }, 150);
}

function cppSelectClientRow(row) {
  cppSelectClient(parseInt(row.getAttribute('data-cid'), 10), row.getAttribute('data-name'));
}

function cppSelectClient(clientId, name) {
  _cppSelectedClientId = clientId;
  _cppActiveTargetEl   = 'cpp-preview';
  document.getElementById('cpp-search').value = name;
  document.getElementById('cpp-results').innerHTML = '';
  var hintEl = document.getElementById('cpp-hint');
  if (hintEl) hintEl.style.display = 'none';
  var previewEl = document.getElementById('cpp-preview');
  previewEl.innerHTML = '<div class="view-loader" style="padding:2rem;"><div class="mini-spinner"></div> Loading portal preview…</div>';
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientPortalPreview', args: { id: clientId } })
    .then(function(res) {
      if (res.ok && res.data && !res.data.error) {
        renderPortalPreview(res.data, 'cpp-preview', clientId);
      } else {
        var msg = (res.data && res.data.error) || (res.error && (res.error.message || res.error)) || 'Failed to load';
        previewEl.innerHTML = '<div class="alert danger">' + escHtml(String(msg)) + '</div>';
      }
    })
    .catch(function(err) {
      previewEl.innerHTML = '<div class="alert danger">' + escHtml(String(err)) + '</div>';
    });
}

/* ============================================================
   PRO TEAM PROFIT-PER-WEDDING — drawer tab (Session 3, 2026-05-27)
   Reads parsed `proteamProfitSnapshot` from client (Path A — embedded in
   adminCrm_getClient response, no separate GAS call). Falls back to a
   bundle re-fetch if missing.

   Locked design (Sessions 1+2):
   - "Contribution Margin" wording everywhere (NOT "Net Margin")
   - Actuals layer wins over estimate when declared
   - "Est." pill when isEstimate=true
   - "Declare actuals" button only when wedding date has passed AND
     isEstimate is true
   - Estimate layer NEVER overwritten by actuals form — backend enforces
   ============================================================ */
function ensureProfitabilityTab_() {
  if (document.getElementById('drawer-pane-profitability')) return;
  var tabs = document.querySelector('#detail-drawer .drawer-tabs');
  var paneHost = tabs ? document.querySelector('#detail-drawer') : null;
  if (!tabs || !paneHost) return;

  // Insert tab after Runsheet (or at end if Runsheet not found)
  var anchorTab = tabs.querySelector('.drawer-tab[data-pane="runsheet"]')
                  || tabs.querySelector('.drawer-tab[data-pane="invoices"]');
  var newTab = document.createElement('div');
  newTab.className = 'drawer-tab';
  newTab.setAttribute('data-pane', 'profitability');
  newTab.setAttribute('onclick', "switchDrawerTab('profitability', this)");
  newTab.textContent = 'Profitability';
  if (anchorTab && anchorTab.nextSibling) tabs.insertBefore(newTab, anchorTab.nextSibling);
  else tabs.appendChild(newTab);

  // Pane
  var lastPane = paneHost.querySelector('.drawer-pane:last-of-type');
  var pane = document.createElement('div');
  pane.id = 'drawer-pane-profitability';
  pane.className = 'drawer-pane';
  pane.innerHTML = '<div id="drawer-profitability-content"><div class="view-loader"><div class="mini-spinner"></div> Loading profitability…</div></div>';
  if (lastPane && lastPane.parentNode) lastPane.parentNode.insertBefore(pane, lastPane.nextSibling);
  else paneHost.appendChild(pane);
}

function loadDrawerProfitability(clientId) {
  ensureProfitabilityTab_();
  var mount = document.getElementById('drawer-profitability-content');
  if (!mount) return;
  mount.innerHTML = '<div class="view-loader"><div class="mini-spinner"></div> Loading profitability…</div>';

  // Prefer the embedded snapshot on the already-loaded client (Path A — zero GAS calls).
  if (_lastDrawerClient && (_lastDrawerClient.id === clientId || String(_lastDrawerClient.id) === String(clientId))) {
    mount.innerHTML = renderProfitabilityPanel_(_lastDrawerClient);
    profitability_loadArtistBills_();
    return;
  }
  // Fallback — fetch the bundle (which contains client.proteamProfitSnapshot).
  if (typeof getDrawerBundle_ === 'function') {
    getDrawerBundle_(clientId).then(function(b) {
      if (b && b.client && !b.client.error) {
        mount.innerHTML = renderProfitabilityPanel_(b.client);
        profitability_loadArtistBills_();
      } else {
        mount.innerHTML = '<div class="alert danger">Failed to load profitability.</div>';
      }
    }).catch(function(err) {
      mount.innerHTML = '<div class="alert danger">' + escHtml(String(err && err.message || err)) + '</div>';
    });
    return;
  }
  mount.innerHTML = '<div class="alert">Profitability data unavailable.</div>';
}

function profitability_loadArtistBills_() {
  var host = document.getElementById('profit-artist-bills');
  if (host && typeof artistBillXero_load_ === 'function') artistBillXero_load_(host, host.getAttribute('data-bride-email') || '');
}

function renderProfitabilityPanel_(client) {
  if (!client) return '<div class="alert">No client data.</div>';
  var snap = client.proteamProfitSnapshot;

  // Empty / missing snapshot
  if (!snap || snap._parseError) {
    var parseMsg = (snap && snap._parseError) ? (' Parse error: ' + escHtml(snap._parseError)) : '';
    return '<div class="profit-panel profit-panel--empty">' +
      '<div class="profit-panel__eyebrow">CONTRIBUTION MARGIN</div>' +
      '<div class="profit-panel__empty-title">No profitability snapshot yet</div>' +
      '<div class="profit-panel__empty-body">' +
        'Snapshot is built automatically when a bride hits BOOKED?=YES, or via ' +
        '<code>JV_proteamProfit_backfillSnapshots_APPLY</code> for back-book brides.' +
        parseMsg +
      '</div>' +
    '</div>';
  }

  var isEstimate = !!snap.isEstimate;
  var active = (snap.actuals && snap.actuals.declaredAt) ? snap.actuals : (snap.estimate || {});
  var grossDollars = (Number(snap.grossRevenueCents) || 0) / 100;
  var marginCents = Number(active.contributionMarginCents) || 0;
  var marginDollars = marginCents / 100;
  var marginPct = Number(active.contributionMarginPct) || 0;
  var artistCostCents = Number(active.artistCostCents) || 0;
  var artistCostDollars = artistCostCents / 100;
  var travelCents = isEstimate
    ? (Number(active.travelPaidCents) || 0)
    : (Number(active.travelActualCents) || 0);
  var travelDollars = travelCents / 100;

  // Pill — Actuals vs Est.
  var pillClass = isEstimate ? 'profit-panel__pill--est' : 'profit-panel__pill--actual';
  var pillLabel = isEstimate ? 'Est.' : 'Actuals';
  var pillTitle = isEstimate
    ? 'Calculated from rate-card snapshot at booking time. Declare actuals after the wedding to lock in real numbers.'
    : 'Declared from bank statement on ' + escHtml(String((snap.actuals && snap.actuals.declaredAt) || '').slice(0, 10));

  var html = '<div class="profit-panel" data-bride-row="' + escHtml(String(client.id || '')) + '">';
  // Hero
  html += '<div class="profit-panel__hero">';
  html += '<div class="profit-panel__hero-row">';
  html += '<div class="profit-panel__eyebrow">CONTRIBUTION MARGIN' +
    ' <span class="profit-panel__pill ' + pillClass + '" title="' + pillTitle + '">' + pillLabel + '</span></div>';
  html += '</div>';
  html += '<div class="profit-panel__value">' + escHtml(jvFormatMoney_(marginDollars)) + '</div>';
  html += '<div class="profit-panel__subvalue">' + marginPct.toFixed(1) + '% of $' + escHtml(jvFormatMoney_(grossDollars).replace('$', '')) + ' gross</div>';

  // Tier badge
  var tier = String(snap.tier || '').toLowerCase();
  if (tier) {
    var tierLabel = tier === 'jessica' ? 'Jess-led' : (tier === 'pro_team' ? 'Pro Team' : (tier === 'mixed' ? 'Mixed' : tier));
    html += '<div class="profit-panel__tier">Tier: <strong>' + escHtml(tierLabel) + '</strong>' +
      (snap.artistsAssigned && snap.artistsAssigned.length
        ? ' · ' + escHtml(snap.artistsAssigned.join(', '))
        : '') + '</div>';
  }
  html += '</div>';

  // Line breakdown (estimate's line items — the actuals form is sum-only)
  var estimateLines = (snap.estimate && Array.isArray(snap.estimate.lineItems)) ? snap.estimate.lineItems : [];
  if (estimateLines.length) {
    html += '<div class="profit-panel__section">';
    html += '<div class="profit-panel__section-title">' + (isEstimate ? 'Rate-card breakdown' : 'Estimate breakdown (for reference)') + '</div>';
    html += '<table class="profit-panel__table"><thead><tr>' +
      '<th>Artist</th><th>Person</th><th>Service</th><th class="num">Cost</th></tr></thead><tbody>';
    var lineSum = 0;
    estimateLines.forEach(function(li) {
      var cost = Number(li.costDollars) || (Number(li.totalCents) ? Number(li.totalCents) / 100 : 0);
      lineSum += cost;
      var person = li.person || (li.km != null ? ('Travel ' + (li.km || 0) + 'km') : '—');
      var svc = li.service || (li.km != null ? 'Travel' : '—');
      var hairstyle = li.hairstyle ? (' <span class="profit-panel__chip">' + escHtml(li.hairstyle) + '</span>') : '';
      html += '<tr>' +
        '<td>' + escHtml(li.artist || '—') + '</td>' +
        '<td>' + escHtml(person) + '</td>' +
        '<td>' + escHtml(svc) + hairstyle + (li.gstApplied ? ' <span class="profit-panel__chip profit-panel__chip--gst">+10% GST</span>' : '') + '</td>' +
        '<td class="num">' + escHtml(jvFormatMoney_(cost)) + '</td>' +
      '</tr>';
    });
    html += '<tr class="profit-panel__total-row">' +
      '<td colspan="3">Estimate subtotal (artist + travel)</td>' +
      '<td class="num">' + escHtml(jvFormatMoney_(lineSum)) + '</td></tr>';
    html += '</tbody></table>';

    if (snap.estimate.warnings && snap.estimate.warnings.length) {
      html += '<div class="profit-panel__warnings"><strong>Warnings:</strong><ul>';
      snap.estimate.warnings.forEach(function(w) { html += '<li>' + escHtml(w) + '</li>'; });
      html += '</ul></div>';
    }
    html += '</div>';
  }

  // Actuals — either show the declared form or the declare button
  html += '<div class="profit-panel__section">';
  if (snap.actuals && snap.actuals.declaredAt) {
    html += '<div class="profit-panel__section-title">Actuals · declared ' + escHtml(String(snap.actuals.declaredAt).slice(0, 10)) + '</div>';
    var pays = Array.isArray(snap.actuals.payments) ? snap.actuals.payments : [];
    html += '<table class="profit-panel__table"><thead><tr><th>Artist</th><th class="num">Paid</th></tr></thead><tbody>';
    pays.forEach(function(pmt) {
      html += '<tr><td>' + escHtml(pmt.artist || '—') + '</td>' +
        '<td class="num">' + escHtml(jvFormatMoney_((Number(pmt.amountCents) || 0) / 100)) + '</td></tr>';
    });
    html += '<tr class="profit-panel__total-row"><td>Total artist payout</td>' +
      '<td class="num">' + escHtml(jvFormatMoney_(artistCostDollars)) + '</td></tr>';
    html += '</tbody></table>';
    if (snap.actuals.notes) {
      html += '<div class="profit-panel__notes"><strong>Notes:</strong> ' + escHtml(snap.actuals.notes) + '</div>';
    }
  } else if (client.weddingHasPassed) {
    html += '<div class="profit-panel__section-title">Declare actuals</div>';
    html += '<div class="profit-panel__cta-body">' +
      'Wedding has passed. Paste the artist payments from your bank statement to lock in the real contribution margin.' +
    '</div>';
    var artists = (snap.artistsAssigned && snap.artistsAssigned.length) ? snap.artistsAssigned : [];
    html += '<button type="button" class="btn-primary profit-panel__declare-btn" ' +
      'onclick="profitability_openDeclareForm_(' + escHtml(String(client.id)) + ')">' +
      'Declare actuals (' + artists.length + ' artist' + (artists.length === 1 ? '' : 's') + ')' +
    '</button>';
    html += '<div id="profit-declare-form-' + escHtml(String(client.id)) + '" class="profit-panel__declare-form" hidden></div>';
  } else {
    html += '<div class="profit-panel__section-title">Actuals</div>';
    html += '<div class="profit-panel__cta-body">Not declared yet. The "Declare actuals" button will appear after the wedding date passes.</div>';
  }
  html += '</div>';

  // Artist bills for this bride, with their Xero state (filled in by artistBillXero_load_ after paint).
  if (client.email) {
    html += '<div class="profit-panel__section-title">Artist bills</div>';
    html += '<div id="profit-artist-bills" data-bride-email="' + escHtml(String(client.email)) + '"></div>';
  }

  // Footer — metadata
  html += '<div class="profit-panel__meta">';
  if (snap.snapshotAt) html += '<span>Snapshot: ' + escHtml(String(snap.snapshotAt).slice(0, 10)) + '</span>';
  if (snap.weddingDate) html += '<span>Wedding: ' + escHtml(String(snap.weddingDate).slice(0, 10)) + '</span>';
  if (snap.partySize) html += '<span>Party: ' + escHtml(String(snap.partySize)) + '</span>';
  html += '</div>';

  html += '</div>'; // .profit-panel
  return html;
}

function jvFormatMoney_(dollars) {
  var n = Number(dollars) || 0;
  var sign = n < 0 ? '-' : '';
  var abs = Math.abs(n);
  return sign + '$' + abs.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (abs % 1 !== 0 ? '.' + (abs.toFixed(2).split('.')[1]) : '');
}

function profitability_openDeclareForm_(clientId) {
  var formHost = document.getElementById('profit-declare-form-' + clientId);
  if (!formHost) return;
  if (formHost.hasAttribute('hidden')) formHost.removeAttribute('hidden');

  // Build the form from the cached client snapshot
  var client = (_lastDrawerClient && String(_lastDrawerClient.id) === String(clientId)) ? _lastDrawerClient : null;
  if (!client || !client.proteamProfitSnapshot) {
    formHost.innerHTML = '<div class="alert danger">Snapshot not loaded.</div>';
    return;
  }
  var snap = client.proteamProfitSnapshot;
  var artists = (snap.artistsAssigned && snap.artistsAssigned.length) ? snap.artistsAssigned : [];
  if (!artists.length) {
    formHost.innerHTML = '<div class="alert">No artists assigned in snapshot.</div>';
    return;
  }

  var rows = artists.map(function(name, i) {
    return '<div class="profit-declare__row">' +
      '<label class="profit-declare__label">' + escHtml(name) +
        '<input type="number" min="0" step="0.01" placeholder="0.00" ' +
        'class="profit-declare__amount" data-artist="' + escHtml(name) + '">' +
      '</label>' +
    '</div>';
  }).join('');

  formHost.innerHTML =
    '<div class="profit-declare">' +
      '<div class="profit-declare__intro">Enter the $AUD paid to each artist (includes travel reimbursement).</div>' +
      rows +
      '<div class="profit-declare__row">' +
        '<label class="profit-declare__label">Notes (optional)' +
          '<input type="text" class="profit-declare__notes" placeholder="e.g. Bank statement 2026-09-01" maxlength="200">' +
        '</label>' +
      '</div>' +
      '<div class="profit-declare__actions">' +
        '<button type="button" class="btn-ghost" onclick="profitability_cancelDeclare_(' + clientId + ')">Cancel</button>' +
        '<button type="button" class="btn-primary" onclick="profitability_submitDeclare_(' + clientId + ')">Save actuals</button>' +
      '</div>' +
      '<div id="profit-declare-status-' + clientId + '" class="profit-declare__status" aria-live="polite"></div>' +
    '</div>';
}

function profitability_cancelDeclare_(clientId) {
  var formHost = document.getElementById('profit-declare-form-' + clientId);
  if (!formHost) return;
  formHost.setAttribute('hidden', '');
  formHost.innerHTML = '';
}

/* Marks the artist bill that opened this Declare form as applied, with the
   CONFIRMED amount from the saved form (2026-10-06, Admin CRM). Only runs after
   adminCrm_declareProteamActuals succeeded. Picks the saved payment for the bill's
   artist; if the artist can't be matched and there is more than one payment, it
   does NOT guess: the bill stays Pending and Jess is told to confirm it by hand. */
function profitability_applyPendingArtistBill_(clientId, payments) {
  var pend = window._jvPendingArtistBillApply;
  if (!pend || String(pend.clientId) !== String(clientId)) return;
  window._jvPendingArtistBillApply = null;
  var guess = String(pend.artistGuess || '').toLowerCase();
  var match = null;
  for (var i = 0; i < payments.length; i++) {
    var a = String(payments[i].artist || '').toLowerCase();
    if (guess && (a === guess || a.split(' ')[0] === guess.split(' ')[0])) { match = payments[i]; break; }
  }
  if (!match && payments.length === 1) match = payments[0];
  if (!match) {
    try { jvToast && jvToast('Actuals saved, but the artist bill was not linked (artist not matched). Confirm it from Artist Bills.', 'warn'); } catch (_) {}
    return;
  }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminApi_markArtistBillApplied', args: {
    token: STATE.token, billId: pend.billId, amount: match.amountCents / 100, artistName: match.artist
  } }).then(function (res) {
    var d = (res && res.data) || {};
    if (d && d.xeroError) {
      try { jvToast && jvToast('Bill confirmed, but it was not sent to Xero yet: ' + d.xeroError, 'warn'); } catch (_) {}
    }
    if (typeof loadArtistBillsSection === 'function') loadArtistBillsSection();
  });
}

function profitability_submitDeclare_(clientId) {
  var formHost = document.getElementById('profit-declare-form-' + clientId);
  if (!formHost) return;
  var statusEl = document.getElementById('profit-declare-status-' + clientId);
  var inputs = formHost.querySelectorAll('.profit-declare__amount');
  var notesEl = formHost.querySelector('.profit-declare__notes');

  var payments = [];
  for (var i = 0; i < inputs.length; i++) {
    var artist = inputs[i].getAttribute('data-artist') || '';
    var rawAmount = String(inputs[i].value || '').trim();
    if (!artist || !rawAmount) continue;
    var dollars = Number(rawAmount);
    if (!isFinite(dollars) || dollars < 0) continue;
    payments.push({ artist: artist, amountCents: Math.round(dollars * 100) });
  }

  if (!payments.length) {
    if (statusEl) statusEl.textContent = 'Add at least one payment amount before saving.';
    return;
  }

  var brideEmail = (_lastDrawerClient && _lastDrawerClient.email) ? _lastDrawerClient.email : '';
  if (statusEl) statusEl.textContent = 'Saving…';

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_declareProteamActuals',
    args: {
      clientId: Number(clientId),
      brideEmail: brideEmail,
      payments: payments,
      travelActualCents: 0,
      notes: notesEl ? String(notesEl.value || '').trim() : '',
      declaredBy: '' // backend audit log gets it from admin session
    }
  }).then(function(res) {
    if (res && res.ok && res.data && res.data.success) {
      if (statusEl) statusEl.textContent = res.data.message || 'Saved.';
      try { jvToast && jvToast('Actuals saved.', 'success'); } catch (_) {}
      profitability_applyPendingArtistBill_(clientId, payments);
      // Refresh: refetch the drawer bundle (will surface new actuals) and re-render the tab
      if (typeof refreshDrawerBundle === 'function') {
        setTimeout(refreshDrawerBundle, 600);
      }
    } else {
      var errMsg = (res && res.data && res.data.message) || (res && res.error) || 'Save failed';
      if (statusEl) statusEl.textContent = 'Error: ' + String(errMsg);
    }
  }).catch(function(err) {
    if (statusEl) statusEl.textContent = 'Error: ' + String(err && err.message || err);
  });
}

/* ============================================================
   PARTY MEMBERS — admin drawer tab (PartyMemberAdminTools.gs)
   Inject tab dynamically so the frozen liquid tab list is untouched.
   Full sync on every operation: _PartyMembers → CRM blob → Shopify metafield → metaobject.
   Viewer patches immediately; PDF re-publish is batched via a sticky banner.
   ============================================================ */

var _pmDrawerClientId = null;
var _pmPendingRepublish = false;

// The drawer bundle carries partyMembers (since v1650), so any party mutation
// must drop the client-side cached bundle for this client. Otherwise a later
// tab switch re-renders the stale (pre-mutation) member list from cache. GAS
// invalidates its own CacheService copy in the same mutation.
function pmInvalidateClientBundle_() {
  try {
    if (typeof _drawerBundleCache !== 'undefined' && _pmDrawerClientId != null) {
      delete _drawerBundleCache[String(_pmDrawerClientId)];
    }
  } catch (_) {}
}

// bridge_admin_generic wraps the handler result in `.data` (the outer {ok} just
// means the bridge dispatched). Every party handler must read fields off the
// unwrapped result, or members/suggestions/pendingRepublish silently read as
// undefined. Returns the inner result, falling back to res itself.
function pmUnwrap_(res) {
  return (res && res.data) ? res.data : res;
}

function ensurePartyMembersTab_() {
  // Fold the legacy Runsheet tab into "Bridal party" (consolidated 2026-06-03).
  // Hide its tab; the consolidated roster now carries the runsheet timeline +
  // re-publish/PDF/builder/copy-link actions.
  var rsTab = document.querySelector('#detail-drawer .drawer-tab[data-pane="runsheet"]');
  if (rsTab) rsTab.style.display = 'none';

  if (document.getElementById('drawer-pane-party-members')) return;
  var tabs = document.querySelector('#detail-drawer .drawer-tabs');
  var drawer = document.getElementById('detail-drawer');
  if (!tabs || !drawer) return;

  var newTab = document.createElement('div');
  newTab.className = 'drawer-tab';
  newTab.setAttribute('data-pane', 'party-members');
  newTab.setAttribute('onclick', "switchDrawerTab('party-members', this)");
  newTab.textContent = 'Bridal party';
  // Sit where the Runsheet tab was, so it reads as the runsheet's replacement.
  if (rsTab && rsTab.parentNode) rsTab.parentNode.insertBefore(newTab, rsTab);
  else tabs.appendChild(newTab);

  var pane = document.createElement('div');
  pane.id = 'drawer-pane-party-members';
  pane.className = 'drawer-pane';
  pane.innerHTML = '<div id="drawer-party-members-content" style="padding:1rem 0"></div>';
  var lastPane = drawer.querySelector('.drawer-pane:last-of-type');
  if (lastPane && lastPane.parentNode) lastPane.parentNode.insertBefore(pane, lastPane.nextSibling);
  else drawer.appendChild(pane);
}

function loadDrawerPartyMembers(clientId) {
  ensurePartyMembersTab_();
  _pmDrawerClientId = clientId;
  var mount = document.getElementById('drawer-party-members-content');
  if (!mount) return;
  mount.innerHTML = '<p style="color:var(--brand-text);opacity:.6;padding:.5rem 0">Loading party members…</p>';

  // Use pre-warmed bundle as authoritative email source. _lastDrawerClient is only
  // set after renderDrawerOverview runs, so it can be null if the Party tab is
  // clicked before the overview finishes loading.
  getDrawerBundle_(clientId).then(function(b) {
    var email = (b && b.client && b.client.email)
      ? String(b.client.email).trim().toLowerCase()
      : (_lastDrawerClient && _lastDrawerClient.email ? String(_lastDrawerClient.email).trim().toLowerCase() : '');
    if (!email) { mount.innerHTML = '<p style="color:#c0392b">No email found for this client.</p>'; return; }
    // Use cached party members from drawer bundle (zero extra GAS call) ONLY if
    // it carries the runsheetSlots field. A bundle cached before that field was
    // added lacks it, so fall through to a fresh call rather than render a stale
    // "no runsheet published" panel that contradicts the member cards.
    if (b && b.partyMembers && b.partyMembers.ok && Array.isArray(b.partyMembers.members) && Array.isArray(b.partyMembers.runsheetSlots)) {
      pmRenderList_(mount, email, b.partyMembers);
      return;
    }
    // Bundle miss or pre-slots cache, fall back to a fresh direct call.
    // bridge_admin_generic wraps the handler result in `.data`, so unwrap it
    // (reading res.members directly silently yields undefined -> empty list).
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getPartyMembers', args: { brideEmail: email } })
      .then(function(res) {
        var d = (res && res.data) ? res.data : res;
        if (!d || !d.ok) {
          mount.innerHTML = '<p style="color:#c0392b">Could not load party members: ' + ((d && d.error) || (res && res.error) || 'unknown error') + '</p>';
          return;
        }
        pmRenderList_(mount, email, d);
      })
      .catch(function(err) {
        mount.innerHTML = '<p style="color:#c0392b">Error: ' + String(err && err.message || err) + '</p>';
      });
  }).catch(function(err) {
    mount.innerHTML = '<p style="color:#c0392b">Bundle error: ' + String(err && err.message || err) + '</p>';
  });
}

// People are grouped by onboarding status (what Jess acts on), NOT by runsheet
// slot matching. Slot assignment lives in the runsheet builder; this tab shows
// who has or has not onboarded, plus card cleanup.
var PM_PEOPLE_GROUPS = [
  { key: 'onboarded',     title: 'Onboarded',             blurb: 'Completed their beauty details.' },
  { key: 'invited',       title: 'Invited, awaiting form', blurb: 'Has an email on file but has not completed onboarding yet. A reminder can be sent.' },
  { key: 'needs_details', title: 'Needs contact details',  blurb: 'No email yet, so they cannot be invited. Add an email, or remove if it is a leftover placeholder.' }
];

function pmRenderList_(mount, brideEmail, payload) {
  payload = payload || {};
  var members    = Array.isArray(payload.members)       ? payload.members       : (mount._pmMembers || []);
  var slots      = Array.isArray(payload.runsheetSlots) ? payload.runsheetSlots : (mount._pmSlots || []);
  var header     = payload.runsheetHeader || mount._pmHeader || null;
  var brideInspo = payload.brideInspo     || mount._pmBrideInspo || [];
  // Stash for in-place re-renders (merge picker, patch).
  mount._pmMembers = members;
  mount._pmBrideEmail = brideEmail;
  mount._pmSlots = slots;
  mount._pmHeader = header;
  mount._pmBrideInspo = brideInspo;

  // Single consolidated bridal-party command centre: chronological runsheet
  // roster + expandable per-person details (onboarding + beauty + inspo) + match
  // + persistent footer actions. Replaces the old Runsheet + Party split.
  var html = pmRenderRoster_(slots, brideEmail, members, header, brideInspo, payload.partyOnboardingGate);

  // Post-match nudge banner (the footer also carries Re-publish).
  html += '<div id="pm-republish-banner" style="display:none;margin-top:1rem;padding:.75rem 1rem;background:#fff8e1;border:1px solid #f9a825;border-radius:var(--radius-medium);align-items:center;gap:.75rem">';
  html += '<span style="flex:1;font-size:.85rem;color:#5a4000">Names updated. Re-publish so the runsheet PDF + bride hub reflect the changes.</span>';
  html += '<button class="btn btn-primary" style="font-size:.8rem;white-space:nowrap" onclick="pmRepublishPdf(\'' + _esc(brideEmail) + '\')">Re-publish PDF</button>';
  html += '</div>';

  html += pmStyles_();
  mount.innerHTML = html;

  if (_pmPendingRepublish) {
    var banner = mount.querySelector('#pm-republish-banner');
    if (banner) banner.style.display = 'flex';
  }
}

// The consolidated bridal-party roster: one chronologically-sorted row per
// runsheet slot. Matched people link by pm_id (robust); each opens to onboarding
// + beauty + inspo detail. Unfilled placeholders show "Unassigned" + Match. The
// bride row opens to her own inspiration. Persistent footer: re-publish / view /
// edit-in-builder / copy link.
function pmRenderRoster_(slots, brideEmail, members, header, brideInspo, gate) {
  // Link slots to people by pm_id (the backend stamps each matched slot with its
  // person's id), with a name fallback. This is what makes EVERY matched person
  // reliably get a Details panel.
  var byPmId = {}, byName = {};
  (members || []).forEach(function(m) {
    if (!m) return;
    if (m.pm_id) byPmId[String(m.pm_id)] = m;
    if (m.name)  byName[String(m.name).trim().toLowerCase()] = m;
  });
  function memberForSlot(s) {
    if (s.isBride || s.isGeneric) return null;
    return (s.pmId && byPmId[String(s.pmId)]) || byName[String(s.label).trim().toLowerCase()] || null;
  }

  var html = '<div class="pm-slotspanel">';
  html += '<div class="pm-roster-head"><div class="pm-people-head" style="margin:0">Bridal party</div>';
  if (header && (header.location || header.readyBy)) {
    html += '<div class="pm-roster-sub">' +
      (header.location ? _esc(header.location) : '') +
      (header.location && header.readyBy ? ' &middot; ' : '') +
      (header.readyBy ? 'Ready by ' + _esc(header.readyBy) : '') + '</div>';
  }
  html += '</div>';

  // Onboarding progress (what Jess acts on). Shown whenever there are members.
  if (gate && gate.total > 0) {
    html += '<div style="display:flex;align-items:center;gap:.4rem;margin:.1rem 0 .6rem;font-size:.72rem;font-weight:600;color:' +
            (gate.allOnboarded ? 'var(--brand-primary-deep)' : 'var(--muted)') + ';">' +
            '<span style="width:.5rem;height:.5rem;border-radius:50%;background:' +
            (gate.allOnboarded ? 'var(--brand-primary)' : 'var(--muted)') + ';"></span>' +
            (gate.allOnboarded
              ? 'All ' + gate.total + ' party members onboarded'
              : gate.completed + ' of ' + gate.total + ' party members onboarded') +
            '</div>';
  }

  // No runsheet published yet: instead of a dead-end message, render the party
  // MEMBERS directly so each one is still clickable (Details) and manageable.
  // Previously this early-returned with zero rows, which is why members looked
  // un-clickable before a runsheet existed. (2026-07-01)
  if (!slots || !slots.length) {
    var realMembers = (members || []).filter(function(m) { return m && m.name && !m.is_placeholder; });
    if (realMembers.length) {
      html += '<div class="pm-group-blurb" style="margin-bottom:.5rem">No runsheet published yet, so these are not matched to wedding-day slots. You can still open each person and manage them.</div>';
      realMembers.forEach(function(m) { html += pmRenderMemberRow_(m, brideEmail); });
    } else {
      html += '<div class="pm-group-blurb">No party members added yet. Use Add party member below, or publish her runsheet to auto-provision slots.</div>';
    }
    html += pmRenderRosterFooter_(brideEmail, header);
    html += '</div>';
    return html;
  }

  var partySlots   = slots.filter(function(s) { return !s.isBride; });
  var pendingSlots = partySlots.filter(function(s) { return s.isGeneric; });
  var matchedNames = {};
  partySlots.forEach(function(s) { if (!s.isGeneric) matchedNames[String(s.label).trim().toLowerCase()] = true; });
  var unplaced = (members || []).filter(function(m) {
    return m && m.name && !m.is_placeholder && !matchedNames[String(m.name).trim().toLowerCase()];
  });

  if (pendingSlots.length) {
    html += '<div class="pm-roster-action">';
    html += '<div class="pm-roster-action-txt">' + pendingSlots.length + ' slot' + (pendingSlots.length === 1 ? '' : 's') +
            ' still awaiting a real name' +
            (unplaced.length ? ' &middot; ' + unplaced.length + ' onboarded ' + (unplaced.length === 1 ? 'person' : 'people') + ' to place' : '') + '</div>';
    html += '<div class="pm-roster-action-btns">';
    if (unplaced.length) html += '<button class="btn btn-primary" style="font-size:.78rem" onclick="pmAutoMatch(\'' + _esc(brideEmail) + '\')">Auto-match by role</button>';
    html += '<button class="btn btn-ghost" style="font-size:.78rem" onclick="pmOpenMatchTool(\'' + _esc(brideEmail) + '\')">Match manually</button>';
    html += '</div></div>';
  }

  slots.forEach(function(s) {
    var member    = memberForSlot(s);
    var onboarded = !!(member && member.onboardStatus === 'onboarded');
    var cls = s.isBride ? 'pm-srow-bride' : (s.isGeneric ? 'pm-srow-unassigned' : (onboarded ? 'pm-srow-assigned' : 'pm-srow-unassigned'));
    var detailId = s.isBride ? 'bride' : (member ? member.pm_id : '');

    html += '<div class="pm-srow-wrap">';
    html += '<div class="pm-srow ' + cls + '">';
    html += '<div style="flex:1;min-width:0">';
    html += '<div class="pm-srow-name">' + _esc(s.isBride ? (s.label + ' (you)') : s.label) + '</div>';
    (s.services || []).forEach(function(sv) {
      html += '<div class="pm-slot"><span class="pm-slot-time">' + _esc(sv.start_time || 'TBC') + '</span> ' +
              '<span class="pm-slot-svc">' + _esc(sv.service || 'Service') + '</span>' +
              (sv.artist ? ' <span class="pm-slot-artist">(' + _esc(sv.artist) + ')</span>' : '') + '</div>';
    });
    html += '</div>';

    html += '<div class="pm-srow-right">';
    if (s.isBride)         html += '<span class="pm-stag pm-stag-bride">You</span>';
    else if (s.isGeneric)  html += '<span class="pm-stag pm-stag-unassigned">Unassigned</span>';
    else if (onboarded)    html += '<span class="pm-stag pm-ob-done">Onboarded</span>';
    else                   html += '<span class="pm-stag pm-ob-wait">Pending onboarding</span>';

    if (s.isGeneric) {
      html += '<button class="btn btn-ghost pm-srow-act" onclick="pmOpenMatchTool(\'' + _esc(brideEmail) + '\')">Match</button>';
    } else if (detailId) {
      var pctTxt = s.isBride ? '' : (' · ' + ((member.progress && member.progress.pct) || 0) + '%');
      html += '<button class="btn btn-ghost pm-srow-act" onclick="pmToggleDetail_(\'' + _esc(detailId) + '\',this)">Details' + pctTxt + '</button>';
    }
    html += '</div>';
    html += '</div>';

    if (s.isBride)     html += pmRenderBrideDetail_(brideInspo);
    else if (member)   html += pmRenderMemberDetail_(member, brideEmail);
    html += '</div>';
  });

  // Onboarded people not yet placed on a slot: render them as their own clickable
  // rows so they're never invisible/un-clickable just because they aren't matched
  // to a runsheet slot yet. (2026-07-01) Previously `unplaced` was computed for the
  // count text but the people themselves were never rendered.
  if (unplaced.length) {
    html += '<div class="pm-group-blurb" style="margin:.6rem 0 .35rem">Onboarded, not yet placed on a runsheet slot:</div>';
    unplaced.forEach(function(m) { html += pmRenderMemberRow_(m, brideEmail); });
  }

  html += '</div>';

  // Gated PDF-republish prompt. Only surfaces once EVERY member is onboarded AND
  // the on-file PDF predates that completion (gate.recommendRepublishPdf). The
  // bride hub + interactive runsheet already auto-refreshed; this prompt is purely
  // about regenerating the heavy PDF so it reflects final details.
  if (gate && gate.recommendRepublishPdf) {
    html += '<div style="display:flex;align-items:center;gap:.75rem;margin:1rem 0 0;padding:.8rem 1rem;' +
            'background:var(--brand-bg-soft);border:1px solid var(--brand-primary);border-radius:var(--radius-medium);">' +
            '<span style="flex:1;font-size:.82rem;color:var(--brand-text);">' +
            'Everyone is onboarded since this runsheet was published. Re-publish the PDF so it reflects their final hairstyles and details.</span>' +
            '<button class="btn btn-primary" style="font-size:.78rem;white-space:nowrap" onclick="pmRepublishPdf(\'' + _esc(brideEmail) + '\')">Re-publish PDF</button>' +
            '</div>';
  }

  html += pmRenderRosterFooter_(brideEmail, header);
  html += '</div>';

  return html;
}

// A standalone party-member row (not tied to a runsheet slot): identity + status
// tag + a working Details toggle + the collapsible detail block. Used when there
// is no published runsheet, or for onboarded-but-unplaced people, so EVERY member
// is clickable regardless of slot-match state. (2026-07-01)
function pmRenderMemberRow_(m, brideEmail) {
  if (!m || !m.pm_id) return '';
  var onboarded = String(m.onboardStatus || '').toLowerCase() === 'onboarded';
  var cls = onboarded ? 'pm-srow-assigned' : 'pm-srow-unassigned';
  var role = m.role ? (' · ' + _esc(m.role)) : '';
  var pctTxt = ' · ' + ((m.progress && m.progress.pct) || 0) + '%';
  var html = '<div class="pm-srow-wrap">';
  html += '<div class="pm-srow ' + cls + '">';
  html += '<div style="flex:1;min-width:0"><div class="pm-srow-name">' + _esc(m.name) + role + '</div></div>';
  html += '<div class="pm-srow-right">';
  html += onboarded ? '<span class="pm-stag pm-ob-done">Onboarded</span>'
                    : '<span class="pm-stag pm-ob-wait">Pending onboarding</span>';
  html += '<button class="btn btn-ghost pm-srow-act" onclick="pmToggleDetail_(\'' + _esc(m.pm_id) + '\',this)">Details' + pctTxt + '</button>';
  html += '</div></div>';
  html += pmRenderMemberDetail_(m, brideEmail);
  html += '</div>';
  return html;
}

// Persistent footer actions for the party roster (folds in everything the old
// Runsheet tab had). Extracted so the no-runsheet path can render it too. Also
// mounts the inline add-member form container. (2026-07-01)
function pmRenderRosterFooter_(brideEmail, header) {
  var bn = (header && header.brideName) ? header.brideName : '';
  var html = '<div class="pm-roster-footer">';
  html += '<button class="btn btn-primary" style="font-size:.78rem" onclick="pmShowAddMemberForm_(\'' + _esc(brideEmail) + '\')">Add party member</button>';
  html += '<button class="btn btn-ghost" style="font-size:.78rem" onclick="pmRepublishPdf(\'' + _esc(brideEmail) + '\')">Re-publish</button>';
  if (header && header.pdfUrl) html += '<a class="btn btn-ghost" style="font-size:.78rem" href="' + _esc(header.pdfUrl) + '" target="_blank" rel="noopener">View runsheet</a>';
  if (bn) html += '<button class="btn btn-ghost" style="font-size:.78rem" onclick="openRunsheetBuilderForBride(\'' + _esc(bn.replace(/'/g, "\\'")) + '\')">Edit in builder</button>';
  if (bn) html += '<button class="btn btn-ghost" style="font-size:.78rem" data-runsheet-copy-link="' + _esc(bn) + '" onclick="copyBrideRunsheetLink(this)">Copy bride link</button>';
  html += '</div>';
  // Inline add-member form mounts here (hidden until "Add party member" clicked).
  html += '<div id="pm-add-member-form" style="margin-top:.6rem"></div>';
  return html;
}

// Admin: add a party member from the drawer party tab. Deliberately raises the
// bride's party slot cap (the proposal is the cap for BRIDES, but the admin is
// the authority who can expand it, e.g. after confirming/charging for an extra).
// Fills the "add button missing" gap the over-cap alert points at (alert says
// "bride drawer, Bridal Party, add"). Mirrors the proven cppSaveNewMemberBtn
// flow: adminCrm_upsertPartyMember action:'add' internally calls
// adminCrm_addPartySlot then claims the new slot. (2026-07-01)
function pmShowAddMemberForm_(brideEmail) {
  var c = document.getElementById('pm-add-member-form');
  if (!c) return;
  if (c.innerHTML) { c.innerHTML = ''; return; } // toggle off if already open
  c.innerHTML = '<div style="display:flex;flex-direction:column;gap:.4rem;padding:.75rem .85rem;background:#fff;border:1px solid #e6dad4;border-radius:var(--radius-medium)">'
    + '<div style="font-size:.8rem;font-weight:600;color:var(--brand-dark)">Add a party member (raises her party size)</div>'
    + '<input id="pmNewMemberName" placeholder="Name" style="font-size:.85rem;padding:.4rem .6rem;border:1px solid #e6dad4;border-radius:var(--radius-medium)">'
    + '<select id="pmNewMemberRole" style="font-size:.85rem;padding:.4rem .6rem;border:1px solid #e6dad4;border-radius:var(--radius-medium)">'
    + '<option>Bridesmaid</option><option>Flower Girl</option>'
    + '<option>Mother of the Bride</option><option>Mother of the Groom</option><option>Party Member</option>'
    + '</select>'
    + '<input id="pmNewMemberEmail" placeholder="Email (optional)" style="font-size:.85rem;padding:.4rem .6rem;border:1px solid #e6dad4;border-radius:var(--radius-medium)">'
    + '<div style="display:flex;gap:.4rem">'
    + '<button class="btn btn-primary" style="flex:1;font-size:.8rem" onclick="pmSaveNewMember_(\'' + _esc(brideEmail) + '\', this)">Add</button>'
    + '<button class="btn btn-ghost" style="font-size:.8rem" onclick="document.getElementById(\'pm-add-member-form\').innerHTML=\'\'">Cancel</button>'
    + '</div></div>';
  var nameEl = document.getElementById('pmNewMemberName');
  if (nameEl) nameEl.focus();
}

// UI-feedback timer for a jvBridge write whose underlying transport can take
// a genuinely long time to settle (2026-09-11, Cowork nightly-batch finding:
// pmSaveNewMember_ looked hung for 2+ minutes with zero console errors).
// ROOT CAUSE traced to jv-gas-bridge.liquid's own retry chain, not a bug in
// this file: fetch (150s timeout) -> XHR fallback (another 150s) -> one
// automatic retry of the same pair on transport failure -- worst case ~10
// minutes before makeRequest's promise ever resolves or rejects. That
// retry-on-transport-failure behaviour is deliberate and load-bearing
// elsewhere (added after the 2026-08-07 runsheet-publish double-send
// incident) and is NOT something to weaken here. bridge_runsheet_createPartyMemberD1
// is safe to retry regardless, idempotency_key is UNIQUE at the D1 layer
// (DEPOLYMENT/jv-admin-saves/worker.js) and is generated ONCE before the
// call, so a resend during the fallback/retry chain can never double-create
// the member. The actual bug is purely that the BUTTON gives no honest
// feedback while the transport is still working through that chain, this
// timer fixes that without touching the transport's retry policy at all.
function pmSaveStartWatchdog_(btn, label) {
  var fired = false;
  var timer = setTimeout(function () {
    fired = true;
    if (btn) btn.textContent = label || 'Still saving...';
    try { jvToast('Still trying to save, this can take a little longer than usual. Leave this open, it will confirm or show an error.', 'info'); } catch (_) {}
  }, 15000);
  return { clear: function () { if (!fired) clearTimeout(timer); } };
}

function pmSaveNewMember_(brideEmail, btn) {
  var name  = (document.getElementById('pmNewMemberName').value  || '').trim();
  var role  = (document.getElementById('pmNewMemberRole').value  || '').trim();
  var email = (document.getElementById('pmNewMemberEmail').value || '').trim();
  if (!name) { jvToast('Please enter a name', 'error'); return; }
  btn.disabled = true; btn.textContent = 'Saving...';
  var watchdog = pmSaveStartWatchdog_(btn, 'Still saving...');
  // clientId is what adminCrm_upsertPartyMember actually identifies the bride by
  // (it reads args.id || args.clientId and never consulted brideEmail), so this
  // form sending only brideEmail meant "Add party member" failed for EVERY bride
  // since it shipped. _pmDrawerClientId is the drawer's own bride id, already in
  // scope and already used on the success path below.
  var clientId = _pmDrawerClientId;

  function fallbackToGasAddMember_() {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_upsertPartyMember', args: { clientId: clientId, brideEmail: brideEmail, action: 'add', memberName: name, memberRole: role, memberEmail: email } })
      .then(function(res) {
        watchdog.clear();
        var d = (res && res.data) ? res.data : res;
        if (d && d.ok) {
          jvToast(d.message || (name + ' added'), 'success');
          try { if (typeof JV_invalidateDrawerBundleByEmail === 'function') JV_invalidateDrawerBundleByEmail(brideEmail); } catch (_) {}
          loadDrawerPartyMembers(clientId); // full re-render, picks up the new filled slot
        } else {
          btn.disabled = false; btn.textContent = 'Add';
          jvToast((d && d.error) || 'Add failed', 'error');
        }
      })
      .catch(function(err) {
        watchdog.clear();
        btn.disabled = false; btn.textContent = 'Add';
        jvToast('Add failed: ' + String(err && err.message || err), 'error');
      });
  }

  // D1-first (2026-09-09, matching the proven pattern already live in this file
  // for admin notes/tasks -- see the D1-first note-add ~line 3940 and follow-up
  // task ~line 10766 -- and in assets/jv-admin-bride-profile-v2.js's
  // abpSubmitAddPartyMember_). brideUid comes from the pipeline client object
  // (STATE.clients, findClientById), same source those two D1-first writes
  // already rely on. Falls back to the existing GAS path when brideUid is
  // unavailable (older cached client list, or a row minted before the
  // BRIDE_UID backfill) -- same discipline as every other D1-first write here.
  var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
  var brideUid = (c && c.brideUid) || '';
  if (!brideUid) {
    fallbackToGasAddMember_();
    return;
  }

  var idempotencyKey = brideUid + '|create|' + name.toLowerCase().replace(/\s+/g, '-') + '|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  jvBridge.call('bridge_runsheet_createPartyMemberD1', {
    payload: {
      bride_uid: brideUid,
      member_name: name,
      member_role: role,
      member_email: email || null,
      idempotency_key: idempotencyKey,
      bride_email: brideEmail || null
    }
  }).then(function(res) {
    if (res && res.ok && res.writtenTo === 'd1') {
      // Durable in D1, identity pending -- no pm_id yet, same as
      // abpSubmitAddPartyMember_'s own success path. The GAS drain
      // (PartyMemberOutboxDrain_2026_08_20.gs) mints the real pm_id within
      // about a minute; a manual refresh of the party tab after that resolves
      // to the real card. Do NOT call loadDrawerPartyMembers() immediately --
      // there is no row to show yet, a re-render now would just repaint the
      // same (pre-add) roster and read as "did that even work?".
      watchdog.clear();
      jvToast(name + ' is being added.', 'success');
      btn.disabled = false; btn.textContent = 'Add';
      var nameEl = document.getElementById('pmNewMemberName');
      if (nameEl) nameEl.value = '';
    } else {
      // fallback:'gas' (bride not yet in the D1 mirror) or any other non-ok --
      // the GAS write is the ONLY save in that case, run it now, not silently.
      fallbackToGasAddMember_();
    }
  }).catch(function() {
    // Network/relay failure on the D1 attempt. Same discipline: fall back to
    // GAS rather than leave the admin's click with no effect.
    fallbackToGasAddMember_();
  });
}

// Inspiration thumbnail grid. Reuses the canonical bride-hub markup
// (.jv-party-hub__thumb*) and the exact Drive-thumbnail URL pattern with the same
// onerror fallback chain the hub uses, so it renders identically. Drive fileId
// preferred; falls back to the stored thumbUrl.
function pmInspoThumbsHtml_(thumbs) {
  if (!thumbs || !thumbs.length) return '<p class="jv-party-hub__no-images">No inspiration images yet.</p>';
  var html = '<div class="jv-party-hub__thumb-grid">';
  thumbs.forEach(function(t) {
    var fid = t.fileId || '';
    var primary = fid ? ('https://drive.google.com/thumbnail?id=' + fid + '&sz=s400') : (t.thumbUrl || '');
    var view    = fid ? ('https://drive.google.com/file/d/' + fid + '/view') : (t.driveUrl || t.thumbUrl || '');
    var fb1     = fid ? ('https://drive.google.com/uc?export=view&id=' + fid) : '';
    var fb2     = fid ? ('https://lh3.googleusercontent.com/d/' + fid) : (t.thumbUrl || '');
    html += '<a class="jv-party-hub__thumb-link" href="' + _esc(view) + '" target="_blank" rel="noopener">' +
            '<img class="jv-party-hub__thumb" loading="lazy" alt="Inspiration" src="' + _esc(primary) + '"' +
            ' onerror="pmThumbFallback_(this,\'' + _esc(fb1) + '\',\'' + _esc(fb2) + '\')"></a>';
  });
  html += '</div>';
  return html;
}

function pmThumbFallback_(img, fb1, fb2) {
  if (!img._jvFb1 && fb1) { img._jvFb1 = true; img.src = fb1; return; }
  if (!img._jvFb2 && fb2) { img._jvFb2 = true; img.src = fb2; return; }
  img.onerror = null;
}

// Bride row detail: her own inspiration gallery, rendered in the canonical
// bride-hub card-body style (reused, not reinvented).
function pmRenderBrideDetail_(brideInspo) {
  var html = '<div class="pm-detail" id="pm-detail-bride" style="display:none">';
  html += '<p class="jv-party-hub__sub-heading">Inspiration Images</p>';
  html += pmInspoThumbsHtml_(brideInspo);
  html += '</div>';
  return html;
}

// Expandable per-person detail rendered in the canonical bride-hub card-body
// style (.jv-party-hub__*): Inspiration Images grid + Details rows. Same markup
// and classes the bride hub uses, so the admin shows the SAME card, not a
// parallel one. Onboarding progress + edit stay (admin-only affordances).
function pmRenderMemberDetail_(m, brideEmail) {
  var d = m.details || {};
  var html = '<div class="pm-detail" id="pm-detail-' + _esc(m.pm_id) + '" style="display:none">';

  // Inspiration images (Drive-aware, self-healing via InspirationStore).
  html += '<p class="jv-party-hub__sub-heading">Inspiration Images</p>';
  html += pmInspoThumbsHtml_(d.inspoThumbs || []);

  // Details rows (canonical card-body grid).
  function row(label, val) {
    return val ? '<div class="jv-party-hub__detail-row"><span class="jv-party-hub__detail-label">' + _esc(label) + '</span>' +
                 '<span class="jv-party-hub__detail-value">' + _esc(val) + '</span></div>' : '';
  }
  var rows = '';
  rows += row('Role', m.role);
  rows += row('Email', m.email || '');
  rows += row('Phone', m.phone || '');
  rows += row('Hair style', d.hairStyle);
  rows += row('Skin concerns', d.skinConcerns);
  rows += row('Allergies', d.allergies);
  rows += row('Colour palette', d.colourPalette);
  rows += row('Hair notes', d.hairNotes);
  rows += row('Inspiration notes', d.inspoNotes);
  html += '<p class="jv-party-hub__sub-heading">Details</p>';
  html += rows ? '<div class="jv-party-hub__detail-grid">' + rows + '</div>'
              : '<p class="jv-party-hub__no-images">Nothing submitted yet.</p>';

  // Admin-only: onboarding progress + edit.
  var p = m.progress || { done: 0, total: 4, pct: 0 };
  html += '<div class="pm-prog" style="margin-top:1rem"><div class="pm-prog-bar"><span style="width:' + (p.pct || 0) + '%"></span></div>' +
          '<span class="pm-prog-txt">Onboarding ' + (p.done || 0) + '/' + (p.total || 4) + '</span></div>';

  // "Invite sent" indicator: shows when their invite last went out (INVITED_AT,
  // re-stamped on every admin resend). Only for not-yet-onboarded members with an
  // email; once onboarded the invite history is moot.
  if (m.email && String(m.onboardStatus || '').toLowerCase() !== 'onboarded' && m.invite_sent_at) {
    var _sentTxt = '';
    try { var _sd = new Date(m.invite_sent_at); if (!isNaN(_sd.getTime())) _sentTxt = formatDate(_sd); } catch (_dateErr) {}
    if (!_sentTxt) _sentTxt = String(m.invite_sent_at).substring(0, 10);
    html += '<div style="margin-top:.55rem;font-size:.72rem;color:var(--success);display:flex;align-items:center;gap:.3rem">' +
            '<span style="width:.45rem;height:.45rem;border-radius:50%;background:var(--success);display:inline-block"></span>' +
            'Invite sent ' + _esc(_sentTxt) + '</div>';
  }

  var lbl = m.email ? 'Edit details' : 'Add email';
  html += '<div style="margin-top:.5rem;display:flex;gap:.4rem;flex-wrap:wrap">';
  html += '<button class="btn btn-ghost" style="font-size:.72rem" onclick="pmOpenEdit(\'' + _esc(m.pm_id) + '\',\'' + _esc(brideEmail) + '\')">' + lbl + '</button>';
  // Resend invite: only when there is an email to send to AND they have not
  // completed onboarding yet (no point re-inviting someone already done).
  if (m.email && String(m.onboardStatus || '').toLowerCase() !== 'onboarded') {
    html += '<button class="btn btn-ghost pm-resend-btn" style="font-size:.72rem" ' +
            'data-pmid="' + _esc(m.pm_id) + '" data-bride="' + _esc(brideEmail) + '" data-name="' + _esc(m.name || '') + '" ' +
            'onclick="pmResendInvite(this)">Resend invite</button>';
  }
  // Merge duplicate (restored 2026-09-10, RESULTS-shanice-bridesmaid-swap-retry-
  // 2026-09-10.md): pmOpenMergeDuplicate -> pmRenderMergePicker_ ->
  // pmSelectMergeSource -> adminCrm_mergePartyMembers was fully intact, but its
  // only caller was pmRenderCard_, a function no longer rendered anywhere once
  // the roster moved to pmRenderRoster_ -- the merge feature was unreachable by
  // clicking even though the whole backend chain worked. Real live case this
  // blocked: Shanice Pitty has both "Alana P" (holds the runsheet slot) and a
  // duplicate "Breayn Cullen" card with no way to merge them. Shown
  // unconditionally (no canMerge gate -- that parameter existed on the old
  // pmRenderCard_ but was never actually computed by any caller anywhere in
  // the codebase, confirmed by grep) since pmOpenMergeDuplicate resolves every
  // OTHER member as a possible merge target itself; the admin decides which
  // card is the real duplicate at merge time, not the render pass.
  html += '<button class="btn btn-ghost" style="font-size:.72rem" onclick="pmOpenMergeDuplicate(\'' + _esc(m.pm_id) + '\',\'' + _esc(brideEmail) + '\')" title="Use if this card is a duplicate of another party member already listed">Merge duplicate</button>';
  html += '</div>';

  html += '</div>';
  return html;
}

function pmToggleDetail_(pmId, btn) {
  var el = document.getElementById('pm-detail-' + pmId);
  if (!el) return;
  var open = el.style.display !== 'none';
  el.style.display = open ? 'none' : 'block';
  if (btn) btn.textContent = open ? btn.textContent.replace('Hide', 'Details') : btn.textContent.replace('Details', 'Hide');
}

// One party-person card. Retained for the merge/edit modals (pmOpenEdit etc.);
// no longer rendered in the main roster view.
function pmRenderCard_(m, brideEmail, canMerge) {
  var fs = String(m.form_status || '').toLowerCase();
  var statusColor = (fs === 'completed' || fs === 'complete') ? '#1a7a2a' : (fs === 'pending' ? '#8a6200' : '#555');

  var refTags = [];
  if (m.linkedSlotLabel)                refTags.push('<span class="pm-ref-tag pm-ref-runsheet">On runsheet</span>');
  if (m.refs.invite_token.found)        refTags.push('<span class="pm-ref-tag pm-ref-token">Invite token active</span>');
  if (m.refs.inspo_data.has_pics)       refTags.push('<span class="pm-ref-tag pm-ref-inspo">Has inspo</span>');

  var html = '<div class="pm-card" data-pmid="' + _esc(m.pm_id) + '">';
  html += '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:.5rem">';
  html += '<div style="flex:1;min-width:0">';
  html += '<div style="font-weight:600;font-size:.95rem;color:var(--brand-dark)">' + _esc(m.name || '(no name)') + '</div>';
  html += '<div style="font-size:.8rem;opacity:.65;margin-top:.15rem">' + _esc(m.role || '') + (m.email ? ' · ' + _esc(m.email) : ' · no email') + (m.phone ? ' · ' + _esc(m.phone) : '') + '</div>';
  html += '<div style="font-size:.75rem;color:' + statusColor + ';margin-top:.2rem">Form: ' + _esc(String(m.form_status || 'not sent').replace(/_/g, ' ')) + (m.completed_at ? ' · ' + _esc(m.completed_at.substring(0,10)) : '') + '</div>';

  if (m.slots && m.slots.length) {
    html += '<div class="pm-slots">';
    m.slots.forEach(function(s) {
      html += '<div class="pm-slot"><span class="pm-slot-time">' + _esc(s.start_time || 'TBC') + '</span> ' +
              '<span class="pm-slot-svc">' + _esc(s.service || 'Service') + '</span>' +
              (s.artist ? ' <span class="pm-slot-artist">(' + _esc(s.artist) + ')</span>' : '') + '</div>';
    });
    html += '</div>';
  }

  if (refTags.length) html += '<div style="display:flex;flex-wrap:wrap;gap:.3rem;margin-top:.4rem">' + refTags.join('') + '</div>';
  html += '</div>';

  html += '<div style="display:flex;flex-direction:column;gap:.4rem;flex-shrink:0;align-items:flex-end">';
  html += '<button class="btn btn-ghost" style="font-size:.75rem;padding:.25rem .6rem" onclick="pmOpenEdit(\'' + _esc(m.pm_id) + '\',\'' + _esc(brideEmail) + '\')">Edit</button>';
  if (canMerge) {
    html += '<button class="btn btn-ghost" style="font-size:.75rem;padding:.25rem .6rem" onclick="pmOpenMergeDuplicate(\'' + _esc(m.pm_id) + '\',\'' + _esc(brideEmail) + '\')" title="This card is a duplicate of another, merge it in">Merge duplicate</button>';
  }
  if (!m.linkedSlotLabel) {
    var delLabel = (m.onboardStatus === 'needs_details' && m.is_placeholder) ? 'Remove' : 'Delete';
    html += '<button class="btn btn-ghost" style="font-size:.75rem;padding:.25rem .6rem;color:#b32727" onclick="pmConfirmDelete(\'' + _esc(m.pm_id) + '\',\'' + _esc(m.name) + '\',\'' + _esc(brideEmail) + '\')">' + delLabel + '</button>';
  }
  html += '</div>';
  html += '</div>';
  html += '</div>';
  return html;
}

// Scoped styles for the party tab (shared across list + picker renders).
function pmStyles_() {
  return '<style>' +
    '.pm-people-head{font-weight:700;font-size:1rem;color:var(--brand-dark);margin:1.5rem 0 .5rem}' +
    '.pm-slotspanel{display:flex;flex-direction:column;gap:.4rem}' +
    '.pm-slot-warn{font-size:.8rem;line-height:1.45;color:#5a4000;background:#fff8e1;border:1px solid #f3d98a;border-radius:var(--radius-medium);padding:.55rem .75rem;margin-bottom:.25rem}' +
    '.pm-srow{display:flex;justify-content:space-between;align-items:flex-start;gap:.5rem;background:#fff;border:1px solid rgba(47,37,36,.1);border-radius:var(--radius-medium);padding:.6rem .85rem}' +
    '.pm-srow-unassigned{border-left:3px solid #c98a1e;background:#fffdf8}' +
    '.pm-srow-assigned{border-left:3px solid #1a7a2a}' +
    '.pm-srow-bride{border-left:3px solid #2a35a0}' +
    '.pm-srow-name{font-weight:600;font-size:.9rem;color:var(--brand-dark);text-transform:capitalize}' +
    '.pm-stag{font-size:.68rem;font-weight:700;padding:.12rem .5rem;border-radius:var(--radius-pill);letter-spacing:.02em}' +
    '.pm-stag-unassigned{background:#fff0d4;color:#8a5200}' +
    '.pm-stag-assigned{background:#e8f5e9;color:#1a6b2a}' +
    '.pm-stag-bride{background:#e8eaf6;color:#2a35a0}' +
    '.pm-ob-done{background:#e8f5e9;color:#1a6b2a}' +
    '.pm-ob-wait{background:#fff0d4;color:#8a5200}' +
    '.pm-ob-none{background:#efeceb;color:#6b6158}' +
    '.pm-srow-right{flex-shrink:0;display:flex;flex-direction:column;align-items:flex-end;gap:.35rem}' +
    '.pm-srow-act{font-size:.7rem;padding:.18rem .55rem;white-space:nowrap;opacity:.75}' +
    '.pm-roster-action{display:flex;flex-wrap:wrap;align-items:center;gap:.6rem;justify-content:space-between;background:#fff8e1;border:1px solid #f3d98a;border-radius:var(--radius-medium);padding:.6rem .85rem;margin-bottom:.35rem}' +
    '.pm-roster-action-txt{font-size:.8rem;color:#5a4000;flex:1;min-width:11rem}' +
    '.pm-roster-action-btns{display:flex;gap:.4rem;flex-shrink:0}' +
    '.pm-roster-head{display:flex;flex-direction:column;gap:.1rem;margin:0 0 .6rem}' +
    '.pm-roster-sub{font-size:.78rem;opacity:.6;color:var(--brand-text)}' +
    '.pm-roster-footer{display:flex;flex-wrap:wrap;gap:.4rem;margin-top:1rem;padding-top:.85rem;border-top:1px solid rgba(47,37,36,.1)}' +
    '.pm-inspo-grid{display:flex;flex-wrap:wrap;gap:.4rem;margin-top:.5rem}' +
    '.pm-inspo-thumb{width:62px;height:62px;object-fit:cover;border-radius:var(--radius-medium);border:1px solid rgba(47,37,36,.1);display:block}' +
    // Canonical bride-hub party-card body classes, mirrored from assets/jv-bridal-hub.css
    // so the admin renders the SAME card (single source of truth for the markup).
    '.jv-party-hub__sub-heading{font-family:Raleway,sans-serif;font-size:.68rem;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--brand-primary);margin:1.1rem 0 .6rem}' +
    '.jv-party-hub__thumb-grid{display:flex;flex-wrap:wrap;gap:.4rem;margin-bottom:.5rem}' +
    '.jv-party-hub__thumb{width:64px;height:64px;border-radius:var(--radius-medium);object-fit:cover;display:block}' +
    '.jv-party-hub__thumb-link{display:block;border-radius:var(--radius-medium);overflow:hidden}' +
    '.jv-party-hub__no-images{font-family:"Plus Jakarta Sans",sans-serif;font-size:.8125rem;color:var(--brand-text);opacity:.45;font-style:italic;margin:0 0 .5rem}' +
    '.jv-party-hub__detail-grid{display:flex;flex-direction:column;gap:.5rem}' +
    '.jv-party-hub__detail-row{display:grid;grid-template-columns:7.5rem 1fr;gap:.25rem;align-items:baseline}' +
    '.jv-party-hub__detail-label{font-family:"Plus Jakarta Sans",sans-serif;font-size:.75rem;font-weight:600;color:var(--brand-text);opacity:.45;text-transform:uppercase;letter-spacing:.04em}' +
    '.jv-party-hub__detail-value{font-family:"Plus Jakarta Sans",sans-serif;font-size:.875rem;color:var(--brand-text);word-break:break-word}' +
    '.pm-srow-wrap{display:flex;flex-direction:column}' +
    '.pm-detail{background:#fbfafa;border:1px solid rgba(47,37,36,.1);border-top:none;border-radius:0 0 var(--radius-medium) var(--radius-medium);margin:-.4rem 0 0;padding:.75rem .85rem .85rem}' +
    '.pm-prog{display:flex;align-items:center;gap:.6rem;margin-bottom:.5rem}' +
    '.pm-prog-bar{flex:1;height:6px;background:rgba(47,37,36,.1);border-radius:var(--radius-pill);overflow:hidden}' +
    '.pm-prog-bar span{display:block;height:100%;background:var(--brand-primary);border-radius:var(--radius-pill);transition:width .3s var(--ease-reveal)}' +
    '.pm-prog-txt{font-size:.72rem;font-weight:600;color:var(--brand-text);opacity:.7;white-space:nowrap}' +
    '.pm-prog-list{display:flex;flex-wrap:wrap;gap:.35rem .85rem;margin-bottom:.6rem}' +
    '.pm-prog-item{display:inline-flex;align-items:center;gap:.32rem;font-size:.75rem;color:var(--brand-text)}' +
    '.pm-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;box-sizing:border-box}' +
    '.pm-dot-on{background:#1a7a2a}' +
    '.pm-dot-off{background:transparent;border:1.5px solid #c0b8b4}' +
    '.pm-dl-wrap{display:flex;flex-direction:column;gap:.25rem;border-top:1px solid rgba(47,37,36,.07);padding-top:.55rem}' +
    '.pm-dl{display:flex;gap:.6rem;font-size:.78rem;line-height:1.4}' +
    '.pm-dl-k{flex-shrink:0;width:7.5rem;opacity:.55;color:var(--brand-text)}' +
    '.pm-dl-v{flex:1;min-width:0;color:var(--brand-dark);word-break:break-word}' +
    '.pm-dl-empty{font-size:.78rem;opacity:.55;border-top:1px solid rgba(47,37,36,.07);padding-top:.55rem}' +
    '.pm-manage{margin-top:1.5rem;border:1px solid rgba(47,37,36,.1);border-radius:var(--radius-medium);background:#fbfafa}' +
    '.pm-manage-sum{cursor:pointer;list-style:none;display:flex;align-items:center;gap:.5rem;padding:.8rem 1rem;font-weight:700;font-size:.92rem;color:var(--brand-dark)}' +
    '.pm-manage-sum::-webkit-details-marker{display:none}' +
    '.pm-manage-hint{font-weight:400;font-size:.75rem;opacity:.5;flex:1}' +
    '.pm-manage-chev{font-size:1.1rem;opacity:.5;transition:transform .2s var(--ease-reveal)}' +
    '.pm-manage[open] .pm-manage-chev{transform:rotate(90deg)}' +
    '.pm-manage[open] .pm-manage-sum{border-bottom:1px solid rgba(47,37,36,.08)}' +
    '.pm-manage .pm-groups{padding:1rem}' +
    '.pm-groups{display:flex;flex-direction:column;gap:1.25rem}' +
    '.pm-group{display:flex;flex-direction:column;gap:.5rem}' +
    '.pm-group-head{display:flex;align-items:center;gap:.5rem}' +
    '.pm-group-title{font-weight:700;font-size:.92rem;color:var(--brand-dark)}' +
    '.pm-group-count{font-size:.72rem;font-weight:600;opacity:.55;background:rgba(47,37,36,.06);border-radius:var(--radius-pill);padding:.05rem .5rem}' +
    '.pm-group-blurb{font-size:.78rem;opacity:.6;margin:-.15rem 0 .15rem;line-height:1.4}' +
    '.pm-group-dot{width:9px;height:9px;border-radius:50%;flex-shrink:0}' +
    '.pm-group-onboarded     .pm-group-dot{background:#1a7a2a}' +
    '.pm-group-invited       .pm-group-dot{background:#c98a1e}' +
    '.pm-group-needs_details .pm-group-dot{background:#9a9a9a}' +
    '.pm-card{background:#fff;border:1px solid rgba(47,37,36,.1);border-radius:var(--radius-medium);padding:.75rem 1rem}' +
    '.pm-group-invited       .pm-card{border-left:3px solid #c98a1e}' +
    '.pm-group-needs_details .pm-card{border-left:3px solid #cfcfcf;background:#fbfafa}' +
    '.pm-slots{margin-top:.45rem;display:flex;flex-direction:column;gap:.2rem}' +
    '.pm-slot{font-size:.8rem;color:var(--brand-dark)}' +
    '.pm-slot-time{font-weight:600}' +
    '.pm-slot-artist{opacity:.6}' +
    '.pm-ref-tag{font-size:.7rem;padding:.15rem .45rem;border-radius:var(--radius-pill);font-weight:600;letter-spacing:.01em}' +
    '.pm-ref-runsheet{background:#e8f5e9;color:#1a6b2a}' +
    '.pm-ref-token{background:#fff3e0;color:#8a5200}' +
    '.pm-ref-meta{background:#e8eaf6;color:#2a35a0}' +
    '.pm-ref-inspo{background:#fce4ec;color:#8a001a}' +
    '.pm-ref-placeholder{background:#f5f5f5;color:#666}' +
    '.pm-merge-source:hover,.pm-merge-target:hover{border-color:var(--brand-primary) !important}' +
    '.pm-dz{display:flex;justify-content:space-between;align-items:center;gap:.6rem;background:#fff;border:1px solid rgba(47,37,36,.12);border-radius:var(--radius-medium);padding:.55rem .8rem;margin-bottom:.45rem;cursor:pointer}' +
    '.pm-dz-armed{outline:2px dashed var(--brand-primary);outline-offset:2px}' +
    '.pm-dz-empty{font-size:.76rem;font-style:italic;opacity:.45;border:1px dashed rgba(47,37,36,.28);border-radius:var(--radius-pill);padding:.22rem .7rem;white-space:nowrap}' +
    '.pm-pool{display:flex;flex-wrap:wrap;gap:.5rem;min-height:52px;background:#faf8f7;border:1px dashed rgba(47,37,36,.22);border-radius:var(--radius-medium);padding:.65rem;align-items:flex-start}' +
    '.pm-chip{display:inline-flex;align-items:center;gap:.4rem;background:var(--brand-primary);color:#fff;border-radius:var(--radius-pill);padding:.32rem .75rem;font-size:.82rem;font-weight:600;cursor:grab;user-select:none}' +
    '.pm-chip:active{cursor:grabbing}' +
    '.pm-chip-placed{background:#1a7a2a}' +
    '.pm-chip-sel{outline:3px solid var(--brand-primary-deep);outline-offset:1px}' +
    '.pm-chip-x{cursor:pointer;opacity:.85;font-weight:700;padding-left:.15rem}' +
    '</style>';
}

// ── Edit inline ───────────────────────────────────────────────────────────────

function pmOpenEdit(pmId, brideEmail) {
  var mount = document.getElementById('drawer-party-members-content');
  var members = mount && mount._pmMembers || [];
  var m = members.filter(function(x) { return x.pm_id === pmId; })[0];
  if (!m) return;

  var html = '<div style="background:#fff;border:1px solid rgba(47,37,36,.1);border-radius:var(--radius-medium);padding:1rem;margin-bottom:.75rem">';
  html += '<div style="font-weight:600;margin-bottom:.75rem">Edit: ' + _esc(m.name || '—') + '</div>';
  html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem">';
  html += '<div><label style="font-size:.78rem;opacity:.7">Name</label><input id="pm-edit-name" class="jv-input" value="' + _esc(m.name) + '" style="width:100%;box-sizing:border-box"></div>';
  // Maid/Matron of Honour retired (Jess 2026-07-30): only Bridesmaid. A legacy record
  // still holding "Maid of Honour"/"Matron of Honour" shows Bridesmaid selected (and
  // saving normalises it), so the retired label never re-appears.
  var _mRole = (m.role==='Maid of Honour' || m.role==='Matron of Honour') ? 'Bridesmaid' : m.role;
  html += '<div><label style="font-size:.78rem;opacity:.7">Role</label><select id="pm-edit-role" class="jv-input" style="width:100%;box-sizing:border-box"><option' + (_mRole==='Bridesmaid'?' selected':'')+'>Bridesmaid</option><option'+(_mRole==='Mother of the Bride'?' selected':'')+'>Mother of the Bride</option><option'+(_mRole==='Mother of the Groom'?' selected':'')+'>Mother of the Groom</option><option'+(_mRole==='Flower Girl'?' selected':'')+'>Flower Girl</option><option'+(_mRole==='Junior Bridesmaid'?' selected':'')+'>Junior Bridesmaid</option><option'+(_mRole==='Partner'?' selected':'')+'>Partner</option><option'+(_mRole==='Party Member'?' selected':'')+'>Party Member</option></select></div>';
  html += '<div><label style="font-size:.78rem;opacity:.7">Email</label><input id="pm-edit-email" class="jv-input" value="' + _esc(m.email) + '" style="width:100%;box-sizing:border-box"></div>';
  html += '<div><label style="font-size:.78rem;opacity:.7">Phone</label><input id="pm-edit-phone" class="jv-input" value="' + _esc(m.phone) + '" style="width:100%;box-sizing:border-box"></div>';
  html += '</div>';
  html += '<div style="display:flex;gap:.5rem;margin-top:.75rem;justify-content:flex-end">';
  html += '<button class="btn btn-ghost" style="font-size:.8rem" onclick="loadDrawerPartyMembers(' + _pmDrawerClientId + ')">Cancel</button>';
  html += '<button class="btn btn-primary" style="font-size:.8rem" id="pm-edit-save-btn" onclick="pmSaveEdit(\'' + pmId + '\',\'' + _esc(brideEmail) + '\')">Save</button>';
  html += '</div>';
  html += '</div>';

  mount.innerHTML = html;
}

// Shared patch-in-place helper (2026-09-11, D1-first pmSaveEdit rewire,
// HANDOFF-party-member-update-profile-frontend-wiring-2026-09-10.md Piece 2).
// Extracted from pmSaveEdit's own pre-existing logic so the D1-success path
// and the GAS-fallback-success path share ONE implementation, not two
// copies that can drift apart -- factored out, not duplicated, per the
// handoff's own explicit instruction.
function pmPatchMemberInPlace_(pmId, brideEmail, fields) {
  var mount = document.getElementById('drawer-party-members-content');
  if (mount && mount._pmMembers) {
    mount._pmMembers = mount._pmMembers.map(function(m) {
      if (m.pm_id !== pmId) return m;
      var patched = Object.assign({}, m);
      if (fields.name  !== undefined) patched.name  = fields.name;
      if (fields.role  !== undefined) patched.role  = fields.role;
      if (fields.email !== undefined) patched.email = fields.email;
      if (fields.phone !== undefined) patched.phone = fields.phone;
      return patched;
    });
    pmRenderList_(mount, brideEmail, { members: mount._pmMembers });
  } else {
    loadDrawerPartyMembers(_pmDrawerClientId);
  }
}

function pmSaveEdit(pmId, brideEmail) {
  var nameEl  = document.getElementById('pm-edit-name');
  var roleEl  = document.getElementById('pm-edit-role');
  var emailEl = document.getElementById('pm-edit-email');
  var phoneEl = document.getElementById('pm-edit-phone');
  var btn     = document.getElementById('pm-edit-save-btn');
  if (!nameEl || !btn) return;
  btn.disabled = true; btn.textContent = 'Saving...';
  var watchdog = pmSaveStartWatchdog_(btn, 'Still saving...');

  var newName  = nameEl.value.trim();
  var newRole  = roleEl  ? roleEl.value         : undefined;
  var newEmail = emailEl ? emailEl.value.trim() : undefined;
  var newPhone = phoneEl ? phoneEl.value.trim() : undefined;

  function fallbackToGasSaveEdit_() {
    jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_updatePartyMember',
      args: { brideEmail: brideEmail, pmId: pmId, name: newName, role: newRole, email: newEmail, phone: newPhone }
    }).then(function(res) {
      watchdog.clear();
      var d = pmUnwrap_(res);
      if (d && d.ok) {
        if (d.pendingRepublish) _pmPendingRepublish = true;
        pmInvalidateClientBundle_();
        pmPatchMemberInPlace_(pmId, brideEmail, { name: newName, role: newRole, email: newEmail, phone: newPhone });
      } else {
        btn.disabled = false; btn.textContent = 'Save';
        alert('Save failed: ' + ((d && d.error) || 'unknown error'));
      }
    }).catch(function(err) {
      watchdog.clear();
      btn.disabled = false; btn.textContent = 'Save';
      alert('Error: ' + String(err && err.message || err));
    });
  }

  // D1-first (2026-09-11, matching pmSaveNewMember_'s own proven pattern a
  // few lines above this function). brideUid comes from the pipeline
  // client object, same source pmSaveNewMember_ already relies on. Falls
  // back to the existing GAS path when brideUid is unavailable, same
  // discipline as every other D1-first write in this file.
  var c = (typeof findClientById === 'function') ? findClientById(_pmDrawerClientId) : null;
  var brideUid = (c && c.brideUid) || '';
  if (!brideUid) {
    fallbackToGasSaveEdit_();
    return;
  }

  var idempotencyKey = brideUid + '|update|' + pmId + '|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  var payload = {
    bride_uid: brideUid,
    pm_id: pmId,
    idempotency_key: idempotencyKey,
    bride_email: brideEmail || null
  };
  // Field-presence discipline (per the handoff, matching the Worker route's
  // own contract): only include a field when the corresponding form field
  // actually supplied a value. A missing key means "not part of this edit,"
  // never "clear this field" -- sending an empty string would do the latter.
  if (newName  !== undefined) payload.member_name  = newName;
  if (newRole  !== undefined) payload.member_role  = newRole;
  if (newEmail !== undefined) payload.member_email = newEmail;
  if (newPhone !== undefined) payload.member_phone = newPhone;

  jvBridge.call('bridge_runsheet_updatePartyMemberD1', { payload: payload }).then(function(res) {
    if (res && res.ok && res.writtenTo === 'd1') {
      watchdog.clear();
      pmInvalidateClientBundle_();
      pmPatchMemberInPlace_(pmId, brideEmail, { name: newName, role: newRole, email: newEmail, phone: newPhone });
    } else {
      // fallback:'gas' (bride not yet in the D1 mirror, or the Worker
      // refused per its own REFUSE-DON'T-GUESS contract) or any other
      // non-ok -- the GAS write is the ONLY save in that case, run it now,
      // not silently.
      fallbackToGasSaveEdit_();
    }
  }).catch(function() {
    // Network/relay failure on the D1 attempt. Same discipline as every
    // other D1-first write here: fall back to GAS rather than leave the
    // admin's click with no effect.
    fallbackToGasSaveEdit_();
  });
}

// ── Merge duplicate cards ────────────────────────────────────────────────────
// De-duplication only: when two cards represent the same real person, merge the
// duplicate (source) INTO the card you want to keep (target). The kept card's
// pm_id survives; the duplicate is soft-deleted and the runsheet renames to the
// kept name. Slot assignment is NOT done here, it lives in the runsheet builder.
function pmOpenMergeDuplicate(sourcePmId, brideEmail) {
  var mount   = document.getElementById('drawer-party-members-content');
  var members = (mount && mount._pmMembers) || [];
  var source  = members.filter(function(x) { return x.pm_id === sourcePmId; })[0];
  if (!source) return;
  var keepers = members.filter(function(x) { return x.pm_id !== sourcePmId; });
  if (!keepers.length) { alert('No other card to merge into.'); return; }

  pmRenderMergePicker_(mount, brideEmail, {
    heading:     'Merge duplicate: ',
    headingName: source.name,
    intro:       'Use this only when "' + (source.name || 'this card') + '" is a duplicate of another person already listed. Choose the card to KEEP. This duplicate is merged into it and then removed; the kept card keeps its runsheet slot.',
    keepPanel:   pmRefPanel_(source, 'Duplicate, will be removed after merge'),
    pickLabel:   'Choose the card to keep:',
    options:     keepers,
    optionLabel: 'Keep this one (duplicate merges into it)',
    onClick:     function(opt) { return "pmSelectMergeSource('" + _esc(sourcePmId) + "','" + _esc(opt.pm_id) + "','" + _esc(brideEmail) + "')"; }
  });
}

// Shared picker renderer for both guided merge directions.
function pmRenderMergePicker_(mount, brideEmail, cfg) {
  var html = '<div style="padding:.5rem 0">';
  html += '<div style="font-weight:700;font-size:1rem;margin-bottom:.5rem;color:var(--brand-dark)">' + _esc(cfg.heading) + '<span style="color:var(--brand-primary)">' + _esc(cfg.headingName || '(unnamed)') + '</span></div>';
  html += '<p style="font-size:.82rem;opacity:.7;margin-bottom:1rem">' + _esc(cfg.intro) + '</p>';
  html += cfg.keepPanel;
  html += '<div style="font-size:.82rem;font-weight:600;margin:.75rem 0 .4rem;opacity:.7">' + _esc(cfg.pickLabel) + '</div>';
  cfg.options.forEach(function(opt) {
    html += '<div class="pm-merge-target" style="cursor:pointer;margin-bottom:.5rem;border:2px solid transparent;border-radius:var(--radius-medium)" onclick="' + cfg.onClick(opt) + '">';
    html += pmRefPanel_(opt, cfg.optionLabel);
    html += '</div>';
  });
  html += '<div style="display:flex;gap:.5rem;margin-top:.75rem;justify-content:flex-end">';
  html += '<button class="btn btn-ghost" style="font-size:.8rem" onclick="loadDrawerPartyMembers(' + _pmDrawerClientId + ')">Cancel</button>';
  html += '</div>';
  html += '</div>';
  html += pmStyles_();
  mount.innerHTML = html;
}

function pmRefPanel_(m, label) {
  var refTags = [];
  if (m.refs.published_runsheet.found) {
    var nSlots = m.refs.published_runsheet.count || (m.slots ? m.slots.length : 1) || 1;
    refTags.push('<span class="pm-ref-tag pm-ref-runsheet">' + nSlots + ' runsheet slot' + (nSlots === 1 ? '' : 's') + '</span>');
  }
  if (m.refs.invite_token.found)        refTags.push('<span class="pm-ref-tag pm-ref-token">Token: ' + _esc(m.refs.invite_token.token_id) + '</span>');
  if (m.refs.shopify_metaobject.found)  refTags.push('<span class="pm-ref-tag pm-ref-meta">Metaobject</span>');
  if (m.refs.inspo_data.has_pics)       refTags.push('<span class="pm-ref-tag pm-ref-inspo">Has inspo pics</span>');
  if (m.is_placeholder)                 refTags.push('<span class="pm-ref-tag pm-ref-placeholder">Placeholder</span>');

  var html = '<div style="background:#faf8f7;border:1px solid rgba(47,37,36,.1);border-radius:var(--radius-medium);padding:.65rem .85rem">';
  html += '<div style="font-size:.7rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.5;margin-bottom:.3rem">' + _esc(label) + '</div>';
  html += '<div style="font-weight:600;font-size:.92rem">' + _esc(m.name || '—') + '</div>';
  html += '<div style="font-size:.78rem;opacity:.65;margin:.1rem 0">' + _esc(m.role) + (m.email ? ' · ' + _esc(m.email) : ' · no email') + '</div>';
  html += '<div style="font-size:.75rem;margin-top:.05rem;opacity:.65">Form: ' + _esc(m.form_status.replace('_', ' ')) + (m.completed_at ? ' · done ' + m.completed_at.substring(0,10) : '') + '</div>';
  if (refTags.length) html += '<div style="display:flex;flex-wrap:wrap;gap:.3rem;margin-top:.4rem">' + refTags.join('') + '</div>';
  html += '</div>';
  return html;
}

function pmSelectMergeSource(sourcePmId, targetPmId, brideEmail) {
  var mount   = document.getElementById('drawer-party-members-content');
  var members = mount && mount._pmMembers || [];
  var source  = members.filter(function(x) { return x.pm_id === sourcePmId; })[0];
  var target  = members.filter(function(x) { return x.pm_id === targetPmId; })[0];
  if (!source || !target) return;

  var confirmed = confirm(
    'Transfer all of ' + (source.name || 'this member') + '\'s data into the "' + (target.name || 'target') + '" slot?\n\n' +
    '• "' + (target.name || 'Target') + '" keeps its runsheet slot (pm_id)\n' +
    '• "' + (source.name || 'Source') + '" will be soft-deleted\n' +
    '• The runsheet viewer will update immediately\n' +
    '• You\'ll be prompted to re-publish the PDF when done'
  );
  if (!confirmed) return;

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_mergePartyMembers',
    args: { brideEmail: brideEmail, sourcePmId: sourcePmId, targetPmId: targetPmId }
  }).then(function(res) {
    var d = pmUnwrap_(res);
    if (d && d.ok) {
      if (d.pendingRepublish) _pmPendingRepublish = true;
      pmInvalidateClientBundle_();
      // A merge changes the lifecycle state of both cards (placeholder becomes
      // placed, orphan disappears), so reload from GAS to re-bucket correctly.
      loadDrawerPartyMembers(_pmDrawerClientId);
    } else {
      // Fix (2026-09-11, Cowork E2E finding): a merge that GENUINELY 504'd at
      // the Cloudflare relay's own 30s ceiling almost always still completed
      // server-side (GAS keeps running after the relay gives up on it), so a
      // retry after a timeout hits this SAME branch with the confusing
      // "Source party member not found" -- the source row is already
      // soft-deleted from attempt 1. Distinguish a genuine "this merge did
      // not happen" refusal from "we don't actually know, the relay gave up
      // waiting" so the admin isn't told a completed merge failed.
      var errMsg = (d && d.error) || 'unknown error';
      if (/not found/i.test(errMsg) || /already/i.test(errMsg)) {
        alert('This merge may have already completed on an earlier attempt ' +
          '(the source member is no longer found). Refresh the party list ' +
          'before retrying -- do not merge again without checking first.');
      } else {
        alert('Merge failed: ' + errMsg);
      }
    }
  }).catch(function(err) {
    // Same fix, the transport-level side: jvBridge surfaces the relay's own
    // 504 text here (e.g. "Relay upstream error: upstream timed out (30s)"),
    // which the trace confirmed is NOT proof the merge failed -- GAS keeps
    // running past the relay's own timeout and the write frequently lands
    // anyway. Never tell the admin outright it failed on a timeout shape.
    var msg = String(err && err.message || err);
    if (/timed out|timeout|504/i.test(msg)) {
      alert('The merge request timed out waiting for a response, but it may ' +
        'have completed anyway. Refresh the party list before retrying -- ' +
        'retrying an already-completed merge will show a confusing ' +
        '"not found" error, not a real failure.');
    } else {
      alert('Error: ' + msg);
    }
  });
}

// ── Delete ────────────────────────────────────────────────────────────────────

function pmConfirmDelete(pmId, name, brideEmail) {
  if (!confirm('Delete "' + name + '"?\n\nThis soft-deletes the record, revokes their invite token, and removes their Shopify metaobject. This cannot be undone easily.\n\nNote: if this member has a runsheet slot, you must Merge first.')) return;

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_deletePartyMember',
    args: { brideEmail: brideEmail, pmId: pmId }
  }).then(function(res) {
    var d = pmUnwrap_(res);
    if (d && d.ok) {
      pmInvalidateClientBundle_();
      // Patch in place to avoid a second GAS round-trip
      var mount = document.getElementById('drawer-party-members-content');
      if (mount && mount._pmMembers) {
        mount._pmMembers = mount._pmMembers.filter(function(m) { return m.pm_id !== pmId; });
        pmRenderList_(mount, brideEmail, { members: mount._pmMembers });
      } else {
        loadDrawerPartyMembers(_pmDrawerClientId);
      }
    } else if (d && d.blocked) {
      alert('Cannot delete: ' + d.reason);
    } else {
      alert('Delete failed: ' + ((d && d.error) || 'unknown error'));
    }
  }).catch(function(err) {
    alert('Error: ' + String(err && err.message || err));
  });
}

// Admin: resend a party member's onboarding invite (email + SMS if a phone is on
// file). Calls adminCrm_resendPartyInvite, the admin-side twin of the bride-hub
// resend route. Sends a real message (subject to safe-mode + quiet-hours), so it
// confirms first. (2026-07-23)
function pmResendInvite(btn) {
  var pmId       = btn.getAttribute('data-pmid');
  var brideEmail = btn.getAttribute('data-bride');
  var name       = btn.getAttribute('data-name') || 'this party member';
  if (!pmId || !brideEmail) return;
  if (!confirm('Resend the onboarding invite to "' + name + '"?\n\nThis sends them their profile link by email (and text if we have their mobile).')) return;

  var origText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Sending...';

  jvBridge.callAdmin('bridge_admin_generic', {
    function: 'adminCrm_resendPartyInvite',
    args: { brideEmail: brideEmail, pmId: pmId }
  }).then(function(res) {
    var d = pmUnwrap_(res);
    btn.disabled = false;
    btn.textContent = origText;
    if (d && d.ok) {
      alert(d.message || (d.deduped ? 'Already sent just now.' : 'Invite resent.'));
    } else {
      alert('Could not resend: ' + ((d && d.error) || 'unknown error'));
    }
  }).catch(function(err) {
    btn.disabled = false;
    btn.textContent = origText;
    alert('Error: ' + String(err && err.message || err));
  });
}

// ── Match to runsheet (auto-suggest + confirm) ───────────────────────────────
// Maps generic runsheet slot labels (Mum 1, Bridesmaid 2) to real party member
// cards. Suggestions come from the server (role + order); the admin confirms or
// swaps each one before it is applied. Applying writes a durable override that
// re-applies on every publish, so the rename sticks.

function pmOpenMatchTool(brideEmail) {
  var mount = document.getElementById('drawer-party-members-content');
  if (!mount) return;
  mount.innerHTML = '<p style="opacity:.6;padding:.5rem 0">Matching party members to runsheet slots…</p>';

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getRunsheetMatchSuggestions', args: { brideEmail: brideEmail } })
    .then(function(res) {
      var d = pmUnwrap_(res);
      if (!d || !d.ok) {
        mount.innerHTML = '<p style="color:#c0392b">Could not load suggestions: ' + ((d && d.error) || 'unknown') + '</p>';
        return;
      }
      pmRenderMatchTool_(mount, brideEmail, d.suggestions || [], d.allCards || []);
    })
    .catch(function(err) {
      mount.innerHTML = '<p style="color:#c0392b">Error: ' + String(err && err.message || err) + '</p>';
    });
}

// Drag-and-drop (+ tap-to-place) matcher state. Module-level so the inline
// drag/tap handlers can reach it.
var _pmMatch = null;

function pmRenderMatchTool_(mount, brideEmail, suggestions, allCards) {
  if (!suggestions.length) {
    mount.innerHTML = '<p style="opacity:.7;padding:.5rem 0">No unassigned runsheet slots to match.</p>' +
      '<button class="btn btn-ghost" style="font-size:.8rem" onclick="loadDrawerPartyMembers(' + _pmDrawerClientId + ')">Back</button>' + pmStyles_();
    return;
  }

  // Build matcher state. Pool = real people only (placeholders ARE the slots).
  var cards = {}, poolOrder = [];
  (allCards || []).forEach(function(c) {
    if (c.isPlaceholder) return;
    cards[c.pmId] = c;
    poolOrder.push(c.pmId);
  });
  var slotByLabel = {}, slotOrder = [], assignments = {};
  suggestions.forEach(function(s) {
    slotByLabel[s.slotLabel] = s;
    slotOrder.push(s.slotLabel);
    if (s.suggestedPmId && cards[s.suggestedPmId]) assignments[s.slotLabel] = s.suggestedPmId; // pre-fill confident matches
  });

  _pmMatch = {
    brideEmail: brideEmail,
    assignments: assignments, slotByLabel: slotByLabel, slotOrder: slotOrder,
    cards: cards, poolOrder: poolOrder, selectedPmId: null
  };
  pmMatchPaint_(mount);
}

// State-driven render of the two-zone matcher (slots on top, people pool below).
function pmMatchPaint_(mount) {
  var m = _pmMatch;
  if (!mount || !m) return;
  var placedBy = {}; // pmId -> slotLabel
  m.slotOrder.forEach(function(lbl) { if (m.assignments[lbl]) placedBy[m.assignments[lbl]] = lbl; });

  var html = '<div style="padding:.25rem 0">';
  html += '<div class="pm-people-head" style="margin-top:0">Match party to runsheet</div>';
  html += '<p style="font-size:.82rem;opacity:.7;margin-bottom:.75rem">Drag a person onto a slot, or tap a person then tap a slot. Pre-filled matches are a starting point, so check the times. Names stick on every re-publish.</p>';

  html += '<div style="font-size:.72rem;font-weight:700;letter-spacing:.05em;opacity:.5;margin:.25rem 0 .45rem">RUNSHEET SLOTS</div>';
  m.slotOrder.forEach(function(lbl) {
    var s = m.slotByLabel[lbl];
    var svc = (s.services || []).map(function(sv) { return (sv.start_time || 'TBC') + ' ' + (sv.service || ''); }).join(', ');
    var pmId = m.assignments[lbl];
    var armed = m.selectedPmId ? ' pm-dz-armed' : '';
    html += '<div class="pm-dz' + armed + '" ondragover="pmMatchAllowDrop_(event)" ondrop="pmMatchDrop_(event,\'' + _esc(lbl) + '\')" onclick="pmMatchTapSlot_(\'' + _esc(lbl) + '\')">';
    html += '<div style="flex:1;min-width:0"><div class="pm-srow-name">' + _esc(lbl) + '</div><div class="pm-slot" style="opacity:.7">' + _esc(svc) + '</div></div>';
    if (pmId && m.cards[pmId]) {
      html += '<span class="pm-chip pm-chip-placed" draggable="true" ondragstart="pmMatchDragStart_(event,\'' + _esc(pmId) + '\')" onclick="event.stopPropagation();pmMatchTapPerson_(\'' + _esc(pmId) + '\')">' + _esc(m.cards[pmId].name) + ' <span class="pm-chip-x" onclick="event.stopPropagation();pmMatchUnassign_(\'' + _esc(lbl) + '\')">&times;</span></span>';
    } else {
      html += '<span class="pm-dz-empty">drop a person here</span>';
    }
    html += '</div>';
  });

  var poolIds = m.poolOrder.filter(function(id) { return !placedBy[id]; });
  html += '<div style="font-size:.72rem;font-weight:700;letter-spacing:.05em;opacity:.5;margin:1rem 0 .45rem">UNPLACED PEOPLE</div>';
  html += '<div class="pm-pool" ondragover="pmMatchAllowDrop_(event)" ondrop="pmMatchDropPool_(event)">';
  if (!poolIds.length) {
    html += '<span style="opacity:.5;font-size:.82rem">Everyone with a slot is placed.</span>';
  } else {
    poolIds.forEach(function(id) {
      var c = m.cards[id];
      var sel = (m.selectedPmId === id) ? ' pm-chip-sel' : '';
      html += '<span class="pm-chip' + sel + '" draggable="true" ondragstart="pmMatchDragStart_(event,\'' + _esc(id) + '\')" onclick="pmMatchTapPerson_(\'' + _esc(id) + '\')">' + _esc(c.name) + (c.role ? ' <span style="opacity:.6;font-weight:500">· ' + _esc(c.role) + '</span>' : '') + '</span>';
    });
  }
  html += '</div>';

  html += '<div style="display:flex;gap:.5rem;margin-top:1rem;justify-content:flex-end">';
  html += '<button class="btn btn-ghost" style="font-size:.8rem" onclick="loadDrawerPartyMembers(' + _pmDrawerClientId + ')">Cancel</button>';
  html += '<button class="btn btn-primary" style="font-size:.8rem" id="pm-match-apply" onclick="pmApplyMatches()">Save assignments</button>';
  html += '</div>';
  html += '</div>';
  html += pmStyles_();
  mount.innerHTML = html;
}

// ── Matcher interactions (drag + tap) ────────────────────────────────────────
function pmMatchAllowDrop_(ev) { ev.preventDefault(); }
function pmMatchDragStart_(ev, pmId) { try { ev.dataTransfer.setData('text/plain', pmId); ev.dataTransfer.effectAllowed = 'move'; } catch (_) {} }
function pmMatchDrop_(ev, slotLabel) { ev.preventDefault(); var pmId = ev.dataTransfer ? ev.dataTransfer.getData('text/plain') : ''; if (pmId) pmMatchAssign_(slotLabel, pmId); }
function pmMatchDropPool_(ev) { ev.preventDefault(); var pmId = ev.dataTransfer ? ev.dataTransfer.getData('text/plain') : ''; if (pmId) pmMatchUnassignPerson_(pmId); }

function pmMatchAssign_(slotLabel, pmId) {
  if (!_pmMatch || !pmId) return;
  // A person can hold only one slot: remove from any current slot first.
  Object.keys(_pmMatch.assignments).forEach(function(l) { if (_pmMatch.assignments[l] === pmId) delete _pmMatch.assignments[l]; });
  _pmMatch.assignments[slotLabel] = pmId; // whoever was here returns to the pool automatically
  _pmMatch.selectedPmId = null;
  pmMatchPaint_(document.getElementById('drawer-party-members-content'));
}
function pmMatchUnassign_(slotLabel) {
  if (!_pmMatch) return;
  delete _pmMatch.assignments[slotLabel];
  pmMatchPaint_(document.getElementById('drawer-party-members-content'));
}
function pmMatchUnassignPerson_(pmId) {
  if (!_pmMatch) return;
  Object.keys(_pmMatch.assignments).forEach(function(l) { if (_pmMatch.assignments[l] === pmId) delete _pmMatch.assignments[l]; });
  _pmMatch.selectedPmId = null;
  pmMatchPaint_(document.getElementById('drawer-party-members-content'));
}
function pmMatchTapPerson_(pmId) {
  if (!_pmMatch) return;
  _pmMatch.selectedPmId = (_pmMatch.selectedPmId === pmId) ? null : pmId;
  pmMatchPaint_(document.getElementById('drawer-party-members-content'));
}
function pmMatchTapSlot_(slotLabel) {
  if (_pmMatch && _pmMatch.selectedPmId) pmMatchAssign_(slotLabel, _pmMatch.selectedPmId);
}

function pmApplyMatches() {
  if (!_pmMatch) return;
  var brideEmail = _pmMatch.brideEmail;
  // One entry per slot; empty pmId clears that slot's override (handles
  // removing a pre-filled suggestion too).
  var matches = _pmMatch.slotOrder.map(function(lbl) {
    return { slotLabel: lbl, pmId: _pmMatch.assignments[lbl] || '' };
  });

  var btn = document.getElementById('pm-match-apply');
  if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }

  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_applyRunsheetMatches', args: { brideEmail: brideEmail, matches: matches } })
    .then(function(res) {
      var d = pmUnwrap_(res);
      if (d && d.ok) {
        if (d.pendingRepublish) _pmPendingRepublish = true;
        _pmMatch = null;
        pmInvalidateClientBundle_();
        loadDrawerPartyMembers(_pmDrawerClientId);
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Save assignments'; }
        alert('Save failed: ' + ((d && d.error) || 'unknown error'));
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Save assignments'; }
      alert('Error: ' + String(err && err.message || err));
    });
}

// ── Auto-match by role ────────────────────────────────────────────────────────
// Fills every still-pending bridal-party slot with onboarded people of the same
// role, in one call. Never overwrites an existing assignment. Going forward this
// also runs automatically on publish + when a member onboards (GAS hooks), so the
// button is mainly for already-published brides.
function pmAutoMatch(brideEmail) {
  var btn = event && event.target;
  if (btn) { btn.disabled = true; btn.textContent = 'Matching…'; }
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_autoMatchRunsheet', args: { brideEmail: brideEmail } })
    .then(function(res) {
      var d = pmUnwrap_(res);
      if (d && d.ok) {
        if (d.pendingRepublish) _pmPendingRepublish = true;
        pmInvalidateClientBundle_();
        loadDrawerPartyMembers(_pmDrawerClientId);
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Auto-match by role'; }
        alert('Auto-match failed: ' + ((d && d.error) || 'unknown error'));
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Auto-match by role'; }
      alert('Error: ' + String(err && err.message || err));
    });
}

// ── Re-publish PDF ────────────────────────────────────────────────────────────

function pmRepublishPdf(brideEmail) {
  var btn = event && event.target;
  if (btn) { btn.disabled = true; btn.textContent = 'Publishing…'; }

  // Re-publish by email: regenerates the published snapshot from the runsheet tab
  // (refreshing the bride-facing viewer, metafield + bride-hub blob) with the
  // durable party-member overrides re-applied. bridge_runsheet_publish needs a
  // full builder payload (brideName + services) which this tab doesn't have, so
  // it silently failed before; adminCrm_republishRunsheet resolves the row and
  // republishes server-side. Result is wrapped in `.data` by bridge_admin_generic.
  jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_republishRunsheet', args: { brideEmail: brideEmail } })
    .then(function(res) {
      var d = pmUnwrap_(res);
      if (d && d.ok) {
        _pmPendingRepublish = false;
        var banner = document.getElementById('pm-republish-banner');
        if (banner) banner.style.display = 'none';
        if (btn) { btn.disabled = false; btn.textContent = 'Re-publish PDF'; }
        alert('Runsheet re-published. The viewer and bride hub now show the assigned names.');
        loadDrawerPartyMembers(_pmDrawerClientId);
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Re-publish PDF'; }
        alert('Re-publish failed: ' + ((d && d.error) || 'unknown error'));
      }
    })
    .catch(function(err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Re-publish PDF'; }
      alert('Re-publish failed: ' + String(err && err.message || err));
    });
}

function _esc(s) {
  return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// Inject Party Members tab whenever the drawer opens (same pattern as onboard-progress + profitability tabs).
(function() {
  var _orig = window.openDrawer;
  if (typeof _orig === 'function') {
    window.openDrawer = function(clientId) {
      _orig(clientId);
      ensurePartyMembersTab_();
    };
  }
})();

/* ============================================================
   CLIENT COMMAND CENTRE (P4b Part 2)
   Evolves the bride-detail drawer into a navigable per-facet module.
   Mobile-first: landing then facet then back. Desktop (drawer expanded):
   master-detail rail + detail. The LANDING renders from the cached drawer
   bundle (inline-CDN, zero GAS). Heavy facet detail hydrates with ONE lazy
   call to the fb_admin_client_detail contract (adminCrm_getClientDetail)
   with a bounded retry. Reuses existing actions (Book, send, invoice
   refresh) and delegates heavy CRUD to the legacy tabs via an injected
   "Command Centre" return tab. Soft Luxury / jv-ui. No emoji, no long dashes.
   ============================================================ */
var CC = (function () {
  'use strict';
  var state = { clientId: null, facet: null };

  var ICONS = {
    back: '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>',
    contact: '<svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    party: '<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>',
    runsheet: '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>',
    inspiration: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
    package: '<svg viewBox="0 0 24 24"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg>',
    invoices: '<svg viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    trial: '<svg viewBox="0 0 24 24"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    comms: '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/></svg>',
    check: '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>',
    info: '<svg viewBox="0 0 24 24"><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    phone: '<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    message: '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    calendar: '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/></svg>',
    plus: '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    folder: '<svg viewBox="0 0 24 24"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>',
    upload: '<svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    external: '<svg viewBox="0 0 24 24"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M21 14v7H3V3h7"/></svg>',
    send: '<svg viewBox="0 0 24 24"><path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4z"/></svg>',
    history: '<svg viewBox="0 0 24 24"><polyline points="12 8 12 12 14 14"/><path d="M3.05 11a9 9 0 1 1 .5 4m-.5-4V7m0 4h4"/></svg>'
  };

  var FACETS = [
    { key: 'contact', label: 'Contact', icon: 'contact' },
    { key: 'party', label: 'Bridal Party', icon: 'party' },
    { key: 'runsheet', label: 'Runsheet', icon: 'runsheet' },
    { key: 'inspiration', label: 'Inspiration', icon: 'inspiration' },
    { key: 'package', label: 'Package', icon: 'package' },
    { key: 'invoices', label: 'Invoices', icon: 'invoices' },
    { key: 'trial', label: 'Trial Photos', icon: 'trial' },
    { key: 'bookings', label: 'Bookings', icon: 'calendar' },
    { key: 'comms', label: 'Comms', icon: 'comms' },
    { key: 'history', label: 'History', icon: 'history' }
  ];

  /* helpers (reuse the file's escapers / formatters) */
  function esc(s) { return (typeof escHtml === 'function') ? escHtml(s == null ? '' : String(s)) : String(s == null ? '' : s); }
  function escA(s) { return (typeof escAttr === 'function') ? escAttr(s == null ? '' : String(s)) : String(s == null ? '' : s); }
  function el(id) { return document.getElementById(id); }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.\-]/g, '')); return isNaN(n) ? 0 : n; }
  function money(n) { return '$' + Math.round(num(n)).toLocaleString('en-AU'); }
  function truthy(v) { var s = String(v == null ? '' : v).trim().toLowerCase(); return v === true || s === 'true' || s === 'yes' || s === '1' || s === 'y'; }
  function initials(name) { var p = String(name || '').trim().split(/\s+/); return (((p[0] || '')[0] || '') + ((p[1] || '')[0] || '')).toUpperCase() || '?'; }
  function fdate(iso) { try { return (typeof formatDate === 'function') ? formatDate(iso) : String(iso || ''); } catch (e) { return String(iso || ''); } }
  function dShort(iso) { if (!iso) return ''; var d = new Date(iso); if (isNaN(d.getTime())) return String(iso); try { return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }); } catch (e) { return String(iso); } }
  function countdown(iso) { if (!iso) return null; var d = new Date(iso); if (isNaN(d.getTime())) return null; var t = new Date(); var ms = d - new Date(t.getFullYear(), t.getMonth(), t.getDate()); return Math.round(ms / 86400000); }
  function tierLabel(t) { t = String(t || '').toLowerCase(); if (t === 'jessica') return 'Jessica Vegas'; if (/pro.?team/.test(t)) return 'Pro Team'; return t ? (t.charAt(0).toUpperCase() + t.slice(1)) : ''; }
  // Issue 6 (2026-07-23): resolve the booking tier the SAME way the profile page does
  // (JV_bookingTier_resolve_ with an INVOICE_BOOKING_TYPE fallback), so the drawer
  // Package facet no longer shows "No proposal yet / TBC" for a bride who was invoiced
  // without a stored PROPOSAL_CALC_JSON (e.g. jfg, tier=jessica). Prefer the calc tier,
  // fall back to the INVOICE_BOOKING_TYPE column that the drawer client object carries.
  function resolvedTierLabel_(c, calc) {
    var t = (calc && (calc.bookingTier || calc.tier)) || (c && c['INVOICE_BOOKING_TYPE']) || '';
    return tierLabel(t);
  }

  function bundleNow() {
    var k = String(state.clientId);
    var entry = (typeof _drawerBundleCache !== 'undefined') ? _drawerBundleCache[k] : null;
    return (entry && entry.data) ? entry.data : null;
  }
  function client() { var b = bundleNow(); var c = b && b.client && !b.client.error ? b.client : null; if (c) return c; return (typeof findClientById === 'function') ? findClientById(state.clientId) : null; }

  // FIX 2 (2026-08-06): the bare shimmer (#efe7e3 on #f6f1ee) is very low
  // contrast, carries no text, and after a few seconds is indistinguishable
  // from "this bride has no party". Combined with the watchdog bug above
  // (nothing ever appeared, however long you waited) the honest read was
  // "broken", not "loading". State it in words from first paint.
  function skeleton() {
    return '<div class="cc-skeleton"><div class="cc-sk-bar w60"></div><div class="cc-sk-bar w80"></div><div class="cc-sk-bar w40"></div><div class="cc-sk-bar w80"></div></div>' +
      '<div class="cc-sk-caption" style="font-size:0.72rem;color:var(--text-light);margin-top:0.6rem;">Loading this bride\'s details...</div>';
  }

  /* ---------------- open / nav ---------------- */
  // Fix 2B (2026-07-19): enrich the thin STATE client with the bride's BBS metaobject
  // (bridal_booking_summary), read client-side by deterministic handle via the SAME
  // Storefront token/pattern as the drawer read (_drawerStorefrontFetch_). Gives
  // Contact / Package-summary / progress meaningful fields BEFORE the GAS bundle lands.
  // BBS is on-write-healed + Storefront PUBLIC_READ. Booked brides only carry it; a
  // miss is silent (no enrichment, not an error). One-shot per client (cached).
  var _bbsEnrichCache = {};
  function bbsHandleForEmail_(email) {
    // Mirror bbs_emailToHandle_ (BridalBookingSummarySync.gs): 'bbs-' + email
    // lowercased with @ and . -> - and any non [a-z0-9-] stripped.
    return 'bbs-' + String(email || '').toLowerCase().replace(/[@.]/g, '-').replace(/[^a-z0-9-]/g, '');
  }
  function enrichClientFromBBS_(clientId, email, onDone) {
    if (!email) { if (onDone) onDone(); return; }
    var key = String(clientId);
    if (_bbsEnrichCache[key]) { if (onDone) onDone(); return; } // already enriched/attempted
    var tok = (typeof _drawerSfToken_ === 'function') ? _drawerSfToken_() : '';
    if (!tok) { if (onDone) onDone(); return; }
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    var q = 'query($h:MetaobjectHandleInput!){ metaobject(handle:$h){ fields{ key value } } }';
    var body = { query: q, variables: { h: { type: 'bridal_booking_summary', handle: bbsHandleForEmail_(email) } } };
    nf('https://' + _SF_DRAWER_SHOP + '/api/' + _SF_DRAWER_VER + '/graphql.json', {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (d) {
      _bbsEnrichCache[key] = true; // mark attempted regardless (miss = leads have no BBS)
      var fields = d && d.data && d.data.metaobject && d.data.metaobject.fields;
      if (!fields || !fields.length) { if (onDone) onDone(); return; }
      var map = {};
      fields.forEach(function (fl) { if (fl && fl.key) map[fl.key] = fl.value; });
      // Merge the useful contact/summary fields into the STATE client so client() is richer.
      var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
      if (c) {
        if (map.wedding_location && !c.venue)   c.venue = map.wedding_location;
        if (map.wedding_date && !c.weddingDate) c.weddingDate = map.wedding_date;
        if (map.booking_tier && !c.tier)        c.tier = map.booking_tier;
        // Issue 2 (2026-07-23): don't let BBS enrichment stamp a stale PRE-BOOKING stage
        // ('Quoted'/'Enquiry') from the metaobject onto a booked client, that leaks to
        // the drawer header badge. Only fill stage when we have none AND it isn't a
        // pre-booking stage contradicting a booked client.
        if (map.pipeline_stage && !c.stage) {
          var _isBooked = (c.isBooked === true) || String(c.booked || '').toLowerCase() === 'yes';
          var _ps = String(map.pipeline_stage);
          if (!(_isBooked && (_ps === 'Quoted' || _ps === 'Enquiry'))) c.stage = _ps;
        }
        if (map.artists_required && !c.assignedArtist && map.artists_required) { /* count, not name — leave */ }
      }
      if (onDone) onDone();
    }).catch(function () { _bbsEnrichCache[key] = true; if (onDone) onDone(); });
  }

  function open(clientId) {
    state.clientId = clientId; state.facet = null;
    var drawer = el('detail-drawer');
    if (!drawer) return;
    drawer.classList.add('cc-active');
    // Desktop: open as master-detail by default; mobile stays the stack.
    if (window.innerWidth >= 1024) drawer.classList.add('expanded');
    ensureReturnTab_();
    var root = el('cc-root');
    if (root) root.classList.remove('cc-show-facet');
    renderLanding(bundleNow());
    // Hydrate from the LITE bundle (shell + lightweight sections incl. runsheet,
    // party, invoices, everything facetInfo()/renderRunsheet() need) so the Command
    // Centre paints at the ~8s cold floor instead of blocking on the heavy non-lite
    // aggregators (proposals/comms/forms/portalPreview, which can chain past the
    // Worker's 30s ceiling on a cold instance, see BRIEFS/RESULTS-admin-crm-runsheet-
    // 30s-timeout-2026-07-16.md). openDrawer() already fires its own non-lite fetch
    // for the legacy Overview tab; the heavy CC facets (comms/proposals/forms/
    // portal-preview) upgrade independently via lazyFacet() when opened.
    var forId = clientId;
    // Fix 2B: if no bundle yet, enrich the thin client from BBS (Storefront, client-side)
    // and re-render the landing so Contact/summary/progress show richer fields immediately.
    if (!bundleNow()) {
      var cThin = client() || {};
      enrichClientFromBBS_(clientId, cThin.email || '', function () {
        if (String(state.clientId) === String(forId) && !state.facet) renderLanding(bundleNow());
      });
    }
    if (typeof getDrawerBundle_ === 'function') {
      getDrawerBundle_(clientId, { lite: true }).then(function (b) {
        if (String(state.clientId) !== String(forId)) return;
        if (!state.facet) renderLanding(b);
      });
    }
  }

  function reopen() { // return to the Command Centre from a legacy tab
    var drawer = el('detail-drawer');
    if (drawer) drawer.classList.add('cc-active');
    state.facet = null;
    var root = el('cc-root'); if (root) root.classList.remove('cc-show-facet');
    renderLanding(bundleNow());
  }

  function back() {
    state.facet = null;
    var root = el('cc-root'); if (root) root.classList.remove('cc-show-facet');
    var cards = document.querySelectorAll('#cc-facets .cc-facet-card');
    Array.prototype.forEach.call(cards, function (c) { c.classList.remove('cc-active-facet'); });
  }

  function openFacet(key) {
    state.facet = key;
    var root = el('cc-root'); if (root) root.classList.add('cc-show-facet');
    var cards = document.querySelectorAll('#cc-facets .cc-facet-card');
    Array.prototype.forEach.call(cards, function (c) { c.classList.toggle('cc-active-facet', c.getAttribute('data-facet') === key); });
    var meta = FACETS.filter(function (f) { return f.key === key; })[0] || { label: key };
    var t = el('cc-facet-title'); if (t) t.textContent = meta.label;
    var body = el('cc-facet-body'); if (!body) return;
    body.innerHTML = skeleton();
    renderFacet(key, body);
    // P1-2 re-fix (Group B T2, 2026-07-19): on desktop the facet rail + detail SHARE the
    // #detail-drawer .drawer-body scroll container, so resetting the facet body's own
    // scrollTop was a silent no-op (measured stuck at 349, #cc-facet at -236px off-screen).
    // Reset the SHARED container to top so a facet switch always brings the detail into
    // view. Keep the facet-body reset too (harmless), and scrollIntoView as a belt-and-braces.
    try { body.scrollTop = 0; } catch (e) {}
    try {
      var sc = document.querySelector('#detail-drawer .drawer-body');
      if (sc) sc.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {}
    try { var f = el('cc-facet'); if (f) f.scrollIntoView({ block: 'start' }); } catch (e) {}
  }

  /* ---------------- landing ---------------- */
  function renderLanding(b) {
    var c = (b && b.client && !b.client.error) ? b.client : client();
    var hero = el('cc-hero'), prog = el('cc-progress'), facets = el('cc-facets');
    if (!hero || !facets) return;
    if (!c) { hero.innerHTML = skeleton(); if (prog) prog.innerHTML = ''; facets.innerHTML = ''; return; }
    // 2026-08-13, same fix as the Bill Partner button above: openBillPartnerModal
    // reads _lastDrawerClient, which was previously only ever set by the dead legacy
    // renderDrawerOverview() (line ~4475). The button now renders here too, so this
    // must set the same global here too, or the button would render but the modal
    // it opens would read a stale/null client.
    _lastDrawerClient = c;
    hero.innerHTML = heroHtml(c);
    if (prog) prog.innerHTML = progressHtml(b);
    facets.innerHTML = FACETS.map(function (f) { return facetCardHtml(f, b, c); }).join('');
    populateLeadOwnerSelect_(c); // Team KPI Phase 1: fill the Lead Owner dropdown
  }

  function heroHtml(c) {
    var bookable = !c.category || ['Bridal', 'Non-Bridal'].indexOf(c.category) !== -1;
    var cd = countdown(c.weddingDate);
    var name = (c.businessName && !bookable) ? c.businessName : (c.name || 'Client');
    var metaLine2bits = [];
    if (bookable) { metaLine2bits.push(esc(c.category || 'Bridal')); if (c.venue) metaLine2bits.push(esc(c.venue)); if (c.assignedArtist) metaLine2bits.push('Artist: ' + esc(c.assignedArtist)); }
    else { metaLine2bits.push(esc(c.category || 'Contact')); if (c.contactType) metaLine2bits.push(esc(c.contactType)); }
    var h = '<div class="cc-hero-top"><h2>' + esc(name) + '</h2>' +
      '<span class="cc-stage-pill"><span class="cc-stage-dot"></span>' + esc((typeof stageDisplay === 'function' ? stageDisplay(c.stage) : c.stage) || 'Lead') + '</span></div>';
    h += '<div class="cc-hero-meta">';
    if (bookable && c.weddingDate) { h += esc(fdate(c.weddingDate)) + (cd != null && cd >= 0 ? ' <span class="cc-count">' + cd + ' day' + (cd === 1 ? '' : 's') + '</span>' : '') + '<br>'; }
    h += '<span class="cc-cat">' + metaLine2bits.join(' &middot; ') + '</span></div>';
    if (c.isPartnerManaged && c.partnerAccountName) {
      h += '<div class="cc-hero-meta cc-muted" style="margin-top:6px;">Managed by ' + esc(c.partnerAccountName) + (c.partnerRole ? ' &middot; ' + esc(c.partnerRole) : '') + '</div>';
    }
    h += '<div class="cc-quick-row">';
    if (c.phone) h += '<a class="btn btn-ghost" href="tel:' + escA(String(c.phone).replace(/\s+/g, '')) + '">' + ICONS.phone + 'Call</a>';
    h += '<button class="btn btn-ghost" onclick="CC.openFacet(\'comms\')">' + ICONS.message + 'Message</button>';
    if (bookable) h += '<button class="btn btn-primary" onclick="CC.book()">' + ICONS.calendar + 'Book</button>';
    // Add a service to this booking (2026-08-20, same root-cause fix as Bill Partner
    // directly below: openAddonAddModal's trigger button was only ever written by
    // _renderDrawerInvoices() into the legacy .drawer-pane system, which
    // #detail-drawer.cc-active .drawer-pane{display:none} permanently hides in the
    // live app. Confirmed unreachable by any real user via
    // BRIEFS/RESULTS-verify-addon-catalog-modal-2026-08-20.md. Same fix pattern:
    // render the trigger here, in the live cc-root hero, instead of the dead pane.
    if (bookable && c.email) {
      h += '<button class="btn btn-ghost" onclick="openAddonAddModal(\'' + escA(c.id) + '\',\'' + escA(c.email) + '\')">' + ICONS.invoices + 'Add Service</button>';
    }
    // Bill Partner (2026-08-13, fixing a real bug found by Cowork live verification of
    // BUILD-admin-crm-partner-routing-summary-2026-08-13): openBillPartnerModal's markup
    // was only ever written by the OLD renderDrawerOverview() into the legacy
    // .drawer-pane system, which #detail-drawer.cc-active .drawer-pane{display:none}
    // permanently hides in the live app (same root cause the Quick Links migration
    // comment right below already documents fixing once for a different button). The
    // button existed in source, was genuinely unreachable by any real user. Same fix
    // pattern: render it here, in the live cc-root hero, instead of the dead pane.
    if (c.isPartnerManaged && c.partnerAccountEmail) {
      h += '<button class="btn btn-ghost" onclick="openBillPartnerModal(\'' + escA(c.id) + '\')">' + ICONS.invoices + 'Bill Partner</button>';
    }
    h += '</div>';
    // Quick Links. One-click access to this bride's runsheet, drive / trial /
    // inspiration folders, agreement, invoices and pay link, rendered into the
    // command-centre hero (the live UI) directly under the action row. Uses the
    // same data (c.quickLinks, already on the cached bundle) and the same pill
    // renderer as the legacy drawer, so the two never diverge. Rendering here
    // (inside cc-root) avoids the '#detail-drawer.cc-active .drawer-pane{display:none}'
    // rule that was force-hiding the pills in the legacy overview pane. The
    // renderer returns '' when no links exist, so sparse leads show no empty row.
    if (typeof _renderBrideQuickLinks_ === 'function') {
      try { h += _renderBrideQuickLinks_(c); } catch (eQL) {}
    }
    // Team KPI Phase 1: Lead Owner attribution (assign / claim). Bookable leads only.
    if (bookable) {
      var ownerLabel = c.leadOwnerName ? esc(c.leadOwnerName) : (c.leadOwner ? esc(c.leadOwner) : 'Unassigned');
      var convLine = c.leadConvertedAt ? '<span class="cc-lo-converted"> &middot; converted ' + esc(dShort(c.leadConvertedAt)) + '</span>' : '';
      h += '<div class="cc-lead-owner" id="cc-lead-owner">';
      h += '<div class="cc-lo-label">Lead Owner: <strong id="cc-lo-current">' + ownerLabel + '</strong>' + convLine + '</div>';
      h += '<div class="cc-lo-editor">';
      h += '<span class="cc-lo-loading" id="cc-lo-loading"><span class="mini-spinner"></span> Loading artists…</span>';
      h += '<select id="cc-lo-select" class="cc-lo-select" aria-label="Lead owner" aria-busy="true" disabled style="display:none;"><option value="">Loading artists…</option></select>';
      h += '<button class="btn btn-ghost btn-sm" type="button" onclick="CC.assignLeadOwner()">Assign</button>';
      h += '<button class="btn btn-ghost btn-sm" type="button" onclick="CC.claimLead()">Claim</button>';
      h += '</div><div class="cc-lo-msg" id="cc-lo-msg"></div></div>';
    }
    return h;
  }

  function onboarding(b) {
    var pr = (b && b.onboardingProgress && b.onboardingProgress.ok && b.onboardingProgress.bride) ? b.onboardingProgress.bride : null;
    var c = (b && b.client) ? b.client : {};
    function st(score, max) { if (!score || score <= 0) return 'todo'; return score >= max ? 'done' : 'part'; }
    var pct = pr ? Math.max(0, Math.min(100, parseInt(pr.overallPct, 10) || 0)) : 0;
    var _loading = !pr; // Fix 2C: no onboardingProgress in the bundle yet -> ring shows loading, not a misleading 0%
    var vision = pr && pr.vision ? (pr.vision.score || 0) : 0;
    var brief = pr && pr.brief ? (pr.brief.score || 0) : 0;
    var party = pr && pr.party ? pr.party : { total: 0, completed: 0 };
    var partyState = party.total > 0 ? (party.completed >= party.total ? 'done' : (party.completed > 0 ? 'part' : 'todo')) : 'todo';
    var inspoThumbs = (b && b.partyMembers && (b.partyMembers.brideInspo || []).length) || 0;
    var inspoState = inspoThumbs > 0 ? 'done' : (String(c['INSPIRATION FOLDER'] || '').trim() ? 'part' : 'todo');
    var depositState = (num(c['DEPOSIT PAID']) > 0 || String(c['BOOKED?'] || '').toLowerCase() === 'yes') ? 'done' : 'todo';
    var trialState = truthy(c['Trial Files Uploaded']) ? 'done' : (String(c['TRIAL DATE'] || '').trim() ? 'part' : 'todo');
    // Trial BOOKING state (separate from photos: required but not yet booked)
    var trialReq = String(c['TRIAL REQUIRED?'] || '').trim().toLowerCase();
    var trialDate = String(c['TRIAL DATE'] || '').trim();
    var trialBookingState = (trialReq === 'no' || trialReq === 'opted_out') ? 'na' : (trialDate ? 'booked' : (trialReq === 'yes' || trialReq === 'y' ? 'unbooked' : 'na'));
    return {
      pct: pct,
      loading: _loading,
      party: party,
      depositState: depositState,
      inspoState: inspoState,
      trialBookingState: trialBookingState,
      trialPhotosState: trialState,
      stage: String(c.stage || '').toLowerCase(),
      items: [
        { label: 'Vision', state: st(vision, 4), facet: 'package' },
        { label: 'Brief', state: st(brief, 4), facet: 'package' },
        { label: 'Inspiration', state: inspoState, facet: 'inspiration' },
        // FIX 4 (2026-08-06): _loading (set above when the bundle has no
        // onboardingProgress yet) was already honoured by the ring but NOT by
        // this chip, which rendered a confident "Party 0/0" on a populated
        // 6-person party (observed live on Bianca Dibou). Same class of bug as
        // the runsheet banner: a loading state stated as a factual zero.
        { label: _loading ? 'Party ...' : ('Party ' + (party.completed || 0) + '/' + (party.total || 0)), state: partyState, facet: 'party' },
        { label: 'Deposit', state: depositState, facet: 'invoices' },
        { label: 'Trial photos', state: trialState, facet: 'trial' }
      ]
    };
  }

  /* NBA_NUDGE_MSG: default inspiration nudge body. Jess reviews + presses Send */
  var NBA_NUDGE_MSG_ = 'Hi, just following up on your inspiration. Have you had a chance to gather any hair or makeup images you love? Sending through a Pinterest board or some saved photos would be a great start. Looking forward to seeing your vision.';

  /* Resolve the single highest-priority actionable gap for this bride.
     Returns { text, btnLabel, action } or null (all clear / no booking stage). */
  function resolveNextAction_(b) {
    var c = (b && b.client) ? b.client : null;
    if (!c) return null;
    var o = onboarding(b);
    var stage = o.stage;
    // Booking stages: deposit / trial / party / inspiration are relevant
    var isBookingStage = /booked|onboarding|trial/.test(stage);
    // Pre-booking stages: lead, enquiry, quoted. Don't surface operational gaps
    var isPreBooking = !isBookingStage;

    // 1. Deposit unpaid (booking stages only)
    if (isBookingStage && o.depositState !== 'done') {
      return { text: 'Deposit unpaid. Booking not yet confirmed.', btnLabel: 'Open invoices', action: function () { CC.openFacet('invoices'); } };
    }
    // 2. Trial required but not booked (booking stages only)
    if (isBookingStage && o.trialBookingState === 'unbooked') {
      return { text: 'Trial required but not booked.', btnLabel: 'Book trial', action: function () { CC.book(); } };
    }
    // 3. Inspiration not received (booking stages only)
    if (isBookingStage && o.inspoState !== 'done') {
      return { text: 'Inspiration not received. Nudge her.', btnLabel: 'Send nudge', action: function () { openCommsWithBody_(NBA_NUDGE_MSG_); } };
    }
    // 4. Party members not onboarded (booking stages, party exists)
    if (isBookingStage && o.party.total > 0) {
      var outstanding = o.party.total - (o.party.completed || 0);
      if (outstanding > 0) {
        return { text: 'Party ' + (o.party.completed || 0) + ' of ' + o.party.total + ' onboarded. ' + outstanding + ' still to complete.', btnLabel: 'Manage party', action: function () { CC.manageParty(); } };
      }
    }
    // 5. Trial photos pending (after trial date, photos not uploaded)
    if (isBookingStage && o.trialBookingState === 'booked' && o.trialPhotosState !== 'done') {
      return { text: 'Trial photos pending.', btnLabel: 'Open trial', action: function () { CC.openFacet('trial'); } };
    }
    // 6 + 7. Brief / Vision (optional, not applicable for pre-booking)
    if (isBookingStage) {
      var briefItem = o.items.filter(function (i) { return i.label === 'Brief'; })[0];
      if (briefItem && briefItem.state !== 'done') {
        return { text: 'Beauty brief incomplete.', btnLabel: 'Open package', action: function () { CC.openFacet('package'); } };
      }
      var visionItem = o.items.filter(function (i) { return i.label === 'Vision'; })[0];
      if (visionItem && visionItem.state !== 'done') {
        return { text: 'Wedding vision not filled in.', btnLabel: 'Open package', action: function () { CC.openFacet('package'); } };
      }
    }
    // All clear, or pre-booking where we don't surface operational gaps
    if (isPreBooking) return null; // no banner for leads/quotes
    return { text: "She's all set. Nothing needs you right now.", btnLabel: null, action: null };
  }

  /* Open the comms facet and pre-fill the message body for Jess to review + send */
  function openCommsWithBody_(body) {
    CC.openFacet('comms');
    // Body is set after renderFacet completes (it renders asynchronously into the DOM)
    function tryFill_(attempts) {
      var el_ = document.getElementById('cc-msg-body');
      if (el_) { el_.value = body; el_.focus(); return; }
      if (attempts > 0) setTimeout(function () { tryFill_(attempts - 1); }, 80);
    }
    setTimeout(function () { tryFill_(10); }, 80);
  }

  function progressHtml(b) {
    var o = onboarding(b);
    var circ = 2 * Math.PI * 33; // r=33
    var off = circ * (1 - o.pct / 100);
    var ring = o.loading
      ? '<div class="cc-ring"><svg width="74" height="74">' +
          '<circle cx="37" cy="37" r="33" stroke="#ece4e0" stroke-width="7" fill="none"/>' +
        '</svg><div class="cc-ring-val"><b>--</b><span>loading</span></div></div>'
      : '<div class="cc-ring"><svg width="74" height="74">' +
      '<circle cx="37" cy="37" r="33" stroke="#ece4e0" stroke-width="7" fill="none"/>' +
      '<circle cx="37" cy="37" r="33" stroke="var(--brand-primary)" stroke-width="7" fill="none" stroke-linecap="round" stroke-dasharray="' + circ.toFixed(1) + '" stroke-dashoffset="' + off.toFixed(1) + '"/>' +
      '</svg><div class="cc-ring-val"><b>' + o.pct + '%</b><span>ready</span></div></div>';

    // Feature 2: clickable checklist rows, each maps to its facet key
    var list = '<div class="cc-checklist">' + o.items.map(function (it) {
      var mark = it.state === 'done' ? ICONS.check : '';
      var facetKey = it.facet || '';
      var onclk = facetKey ? ' onclick="CC.openFacet(\'' + facetKey + '\')" onkeydown="if(event.key===\'Enter\'||event.key===\' \')CC.openFacet(\'' + facetKey + '\')" role="button" tabindex="0"' : '';
      return '<div class="cc-chk ' + it.state + ' cc-chk-btn"' + onclk + '><i>' + mark + '</i><span>' + esc(it.label) + '</span></div>';
    }).join('') + '</div>';

    // Feature 1: next-best-action line above the ring
    var nba = resolveNextAction_(b);
    var nbaHtml = '';
    if (nba) {
      var btn = nba.btnLabel
        ? '<button class="btn btn-primary btn-sm cc-nba-btn" type="button" onclick="CC.nbaAction()">' + esc(nba.btnLabel) + '</button>'
        : '';
      nbaHtml = '<div class="cc-nba' + (nba.btnLabel ? '' : ' cc-nba-clear') + '">' +
        '<span class="cc-nba-text">' + esc(nba.text) + '</span>' + btn + '</div>';
      // Store the action for CC.nbaAction() to call
      CC._nbaAction = nba.action;
    } else {
      CC._nbaAction = null;
    }

    return nbaHtml + '<div class="cc-progress-card">' + ring + list + '</div>';
  }

  /* facet glance + badge (mirrors the GAS builder, computed client-side from the cached bundle) */
  function facetInfo(key, b, c) {
    var g = '', badge = null;
    if (key === 'contact') { var bits = []; if (c.venue) bits.push(c.venue); if (c.phone) bits.push(c.phone); g = bits.join(' · ') || (c.email || 'No contact details'); }
    else if (key === 'party') { var pm = (b && b.partyMembers && b.partyMembers.members) || []; var tot = pm.length, on = 0; pm.forEach(function (m) { if (m.onboarded || m.onboardStatus === 'onboarded') on++; }); var aw = tot - on; g = tot === 0 ? 'No party members yet' : (tot + ' member' + (tot === 1 ? '' : 's') + ' · ' + on + ' onboarded'); if (aw > 0) badge = { t: aw + ' left', c: 'warn' }; else if (tot > 0) badge = { t: 'All in', c: 'ok' }; }
    else if (key === 'runsheet') { var rs = (b && b.runsheet) || {}; var sgn = /signed/i.test(String((c && c['RUNSHEET_STAGE']) || '')); if (rs.runsheetState === 'published') { g = 'Published · ' + (sgn ? 'signed off' : 'awaiting signoff'); badge = { t: sgn ? 'Signed' : 'Live', c: 'ok' }; } else if (rs.runsheetState === 'draft') { g = 'Draft in progress'; badge = { t: 'Draft', c: 'warn' }; } else g = 'Not built yet'; }
    else if (key === 'inspiration') { var th = (b && b.partyMembers && b.partyMembers.brideInspo) || []; var hair = th.filter(function (t) { return /hair/i.test(t.category || ''); }).length; var mk = th.filter(function (t) { return /makeup/i.test(t.category || ''); }).length; g = th.length === 0 ? (String(c['INSPIRATION FOLDER'] || '').trim() ? 'Folder ready · no pins' : 'No inspiration yet') : ((hair && mk ? 'Hair + makeup' : (hair ? 'Hair' : 'Makeup')) + ' · ' + th.length + ' pin' + (th.length === 1 ? '' : 's')); }
    else if (key === 'package') { var calc = parseCalc(c); var tl = resolvedTierLabel_(c, calc); var tot2 = (calc && (calc.total != null ? calc.total : calc.grandTotal)) || num(c['TOTAL VALUE']); g = (!tl && !tot2) ? 'No proposal yet' : ((tl || 'Package') + (tot2 ? ' · ' + money(tot2) : '')); }
    else if (key === 'invoices') { var total = num(c['TOTAL VALUE']), dep = num(c['DEPOSIT PAID']), bal = num(c['BALANCE DUE']); if (!bal && total) bal = Math.max(0, total - dep); var owing = bal > 0; g = (!total && !dep) ? 'No invoices yet' : ((dep > 0 ? 'Deposit paid' : 'Unpaid') + (owing ? ' · ' + money(bal) + ' owing' : ' · paid in full')); if (owing) badge = { t: 'Owing', c: 'warn' }; else if (total) badge = { t: 'Paid', c: 'ok' }; }
    else if (key === 'trial') { var date = String(c['TRIAL DATE'] || '').trim(); var req = String(c['TRIAL REQUIRED?'] || '').trim().toLowerCase(); var up = truthy(c['Trial Files Uploaded']); if (req === 'no' || req === 'opted_out') g = 'No trial'; else if (date) { g = 'Booked ' + dShort(date) + ' · ' + (up ? 'photos in' : 'photos pending'); if (!up) badge = { t: 'Pending', c: 'warn' }; } else if (req === 'yes' || req === 'y') { g = 'Required · not booked'; badge = { t: 'To book', c: 'warn' }; } else g = 'Trial unset'; }
    else if (key === 'bookings') { var btd = String(c['TRIAL DATE'] || '').trim(); g = btd ? ('Trial booked · ' + dShort(btd)) : 'Manage bookings'; }
    else if (key === 'comms') { var cl = (b && b.commsLog && b.commsLog.length) ? b.commsLog : null; if (cl) { var last = cl[0]; g = 'Last: ' + esc((last.channel || last.type || 'message')); } else g = 'View conversation'; }
    return { glance: g, badge: badge };
  }

  function facetCardHtml(f, b, c) {
    var info = facetInfo(f.key, b, c);
    var badge = info.badge ? '<span class="cc-badge cc-badge-' + info.badge.c + '">' + esc(info.badge.t) + '</span>' : '';
    return '<div class="cc-facet-card" data-facet="' + f.key + '" onclick="CC.openFacet(\'' + f.key + '\')">' +
      badge +
      '<div class="cc-fi">' + ICONS[f.icon] + '</div>' +
      '<h4>' + esc(f.label) + '</h4>' +
      '<div class="cc-glance">' + esc(info.glance) + '</div>' +
      '</div>';
  }

  function parseCalc(c) { try { return c['PROPOSAL_CALC_JSON'] ? JSON.parse(c['PROPOSAL_CALC_JSON']) : null; } catch (e) { return null; } }

  /* ---------------- facet detail dispatch ---------------- */
  // Fix 2 (2026-07-19) helpers: instant-paint support for the client modal.
  function refreshingNote_() {
    return '<div class="cc-refreshing" style="font-size:0.68rem;color:var(--text-light);margin-top:0.6rem;">Refreshing latest details...</div>';
  }

  function renderPackageSummaryLocal_(c) {
    c = c || {};
    var h = '';
    if (c.stage)       h += infoRow('Stage', c.stage);
    if (c.services)    h += infoRow('Services', c.services);
    if (c.balanceDue != null)  h += infoRow('Balance due', (typeof fmoney === 'function' ? fmoney(c.balanceDue) : ('$' + c.balanceDue)));
    if (c.depositPaid != null) h += infoRow('Deposit', c.depositPaid ? 'Paid' : 'Not yet');
    if (!h) h = '<div class="cc-empty">Package details load in a moment...</div>';
    return h;
  }

  // Fix 2C: watchdog. If the bundle has not resolved in ~12s, swap the refreshing
  // note for a Retry / Open-full-profile affordance so a facet never stays blank.
  var _ccWatchdogTimer = null;
  function armCcWatchdog_(clientId, key, body) {
    if (_ccWatchdogTimer) { clearTimeout(_ccWatchdogTimer); _ccWatchdogTimer = null; }
    _ccWatchdogTimer = setTimeout(function () {
      if (String(state.clientId) !== String(clientId) || state.facet !== key) return;
      if (bundleNow()) return; // resolved in time
      var note = body.querySelector('.cc-refreshing');
      var c = client() || {};
      var email = c.email || '';
      // 2026-08-25 identity-mismatch fix (see openClientProfile_ above), pass the
      // row id too so a duplicate-email bride opens the exact row being viewed.
      var profileUrl = '/pages/admin-bride-profile?bride=' + escA(email) + (c.id ? '&row=' + escA(String(c.id)) : '');
      var affordance = '<div class="cc-refreshing" style="font-size:0.72rem;color:var(--text-light);margin-top:0.6rem;">' +
        'Still loading. ' +
        '<button class="btn btn-ghost btn-sm" type="button" onclick="CC.retryBundle()" style="font-size:0.66rem;">Retry</button>' +
        (email ? ' <a class="btn btn-ghost btn-sm" href="' + profileUrl + '" target="_blank" rel="noopener" style="font-size:0.66rem;">Open full profile</a>' : '') +
        '</div>';
      // FIX 1 (2026-08-06): only the contact + package branches emit a
      // .cc-refreshing note; every other facet (party, runsheet, invoices,
      // trial, bookings, comms, history) renders skeleton(), which contains no
      // such element. So this lookup returned null, the guard was false, and
      // the affordance was silently DISCARDED on exactly the slow facets that
      // most needed it. The watchdog decided to help, then threw the help away.
      // Append when there is nothing to replace, so Retry is reachable everywhere.
      if (note) note.outerHTML = affordance;
      else body.insertAdjacentHTML('beforeend', affordance);
      // TIMING (2026-08-06): the handoff suggested dropping 12s -> 6-8s. I tried
      // 8s and reverted it. The documented GAS cold-start floor is 7-10s, and an
      // observed cold drawer was ~35s, so an 8s watchdog would fire during a
      // perfectly HEALTHY cold load and offer Retry for something that was never
      // stuck. That teaches the admin to ignore the affordance, which is worse
      // than waiting for it. 12s stays: it is clear of the floor, and the real
      // gap (nothing visible before it fires) is now closed by the skeleton
      // caption, which appears immediately rather than at 12s.
    }, 12000);
  }

  function renderFacet(key, body) {
    var b = bundleNow();
    if (!b) {
      // Fix 2A (2026-07-19): DON'T blank-early-return while the bundle loads. The
      // thin STATE client (+ BBS enrichment, Fix 2B) is enough to paint Contact and
      // a Package summary NOW; heavier facets still need the bundle so they skeleton.
      // Kick the lite fetch and re-render this facet on resolve. Fixes P0-3 (blank
      // pane for the ~297/301 brides not in the drawer island).
      var cLocal = client() || {};
      if (key === 'contact')      body.innerHTML = renderContact(cLocal) + refreshingNote_();
      else if (key === 'package') body.innerHTML = renderPackageSummaryLocal_(cLocal) + refreshingNote_();
      else                        body.innerHTML = skeleton();
      if (typeof getDrawerBundle_ === 'function') {
        var forId = state.clientId;
        getDrawerBundle_(state.clientId, { lite: true }).then(function (nb) { if (String(state.clientId) === String(forId) && state.facet === key) renderFacet(key, body); });
        armCcWatchdog_(state.clientId, key, body);
      }
      return;
    }
    var c = client() || {};
    switch (key) {
      case 'contact': body.innerHTML = renderContact(c); break;
      case 'party': body.innerHTML = renderParty(b, c); break;
      case 'runsheet': body.innerHTML = renderRunsheet(b, c); break;
      case 'inspiration': renderInspiration(b, c, body); break;
      case 'package': renderPackage(b, c, body); break;
      case 'invoices': body.innerHTML = renderInvoices(b, c); maybeAutoRefreshInvoices(c); break;
      case 'trial': renderTrial(b, c, body); break;
      case 'bookings': renderBookings(b, c, body); break;
      case 'comms': renderComms(b, c, body); break;
      case 'history': renderHistory(b, c, body); break;
      default: body.innerHTML = '<div class="cc-empty">Nothing here yet.</div>';
    }
  }

  function infoRow(label, value, isLink) {
    if (!value) return '';
    var v = isLink ? '<a href="' + escA(value) + '" target="_blank" rel="noopener">' + esc(value) + '</a>' : esc(value);
    return '<div class="cc-info-row"><span class="cc-il">' + esc(label) + '</span><span class="cc-iv">' + v + '</span></div>';
  }

  function renderContact(c) {
    var bookable = !c.category || ['Bridal', 'Non-Bridal'].indexOf(c.category) !== -1;
    var h = '';
    h += infoRow('Email', c.email);
    h += infoRow('Phone', c.phone);
    if (bookable) { h += infoRow('Venue', c.venue); h += infoRow('Wedding', fdate(c.weddingDate)); h += infoRow('Artist', c.assignedArtist); }
    h += infoRow('Category', (c.category || 'Bridal') + (c.contactType ? ' · ' + c.contactType : ''));
    if (c.businessName) h += infoRow('Business', c.businessName);
    if (c.abn) h += infoRow('ABN', c.abn);
    if (c.website) h += infoRow('Website', c.website, true);
    if (c.isPartnerManaged && c.partnerAccountName) h += infoRow('Managed by', c.partnerAccountName + (c.partnerRole ? ' (' + c.partnerRole + ')' : ''));
    h += '<div class="cc-block-actions">';
    if (c.phone) h += '<a class="btn btn-ghost" href="tel:' + escA(String(c.phone).replace(/\s+/g, '')) + '">' + ICONS.phone + 'Call</a>';
    if (c.email) h += '<a class="btn btn-ghost" href="mailto:' + escA(c.email) + '">' + ICONS.message + 'Email</a>';
    if (bookable) h += '<button class="btn btn-primary" onclick="CC.book()">' + ICONS.calendar + 'Book</button>';
    h += '</div>';
    h += '<div class="cc-block-actions">';
    if (typeof openRecategorisePanel === 'function') h += '<button class="btn btn-ghost btn-sm" onclick="openRecategorisePanel()">Change category</button>';
    // Archive Contact (2026-10-28): same root cause as Add Service / Bill Partner /
    // Quick Links above -- confirmArchiveClient's trigger button was only ever written
    // by the legacy renderDrawerOverview() into the .drawer-pane system, which
    // #detail-drawer.cc-active .drawer-pane{display:none} permanently hides in the live
    // app. Existed in the accessibility tree, never reachable by a real user (confirmed
    // BRIEFS/RESULTS-partner-bride-duplicate-guard-verify-2026-10-27.md). Same fix
    // pattern: render the trigger here, in the live Contact facet, instead of the dead
    // pane. confirmArchiveClient()/doArchiveClient() are unchanged and already
    // independent of the legacy DOM (they only read _lastDrawerClient, which
    // renderLanding() already sets for every client shown in this facet).
    if (typeof confirmArchiveClient === 'function') h += '<button class="btn btn-ghost btn-sm btn-danger-ghost" onclick="confirmArchiveClient(\'' + escA(String(c.id)) + '\')">Archive Contact</button>';
    h += '</div>';
    return h;
  }

  function renderParty(b, c) {
    var pm = (b && b.partyMembers && b.partyMembers.members) || [];
    var tot = pm.length, on = 0; pm.forEach(function (m) { if (m.onboarded || m.onboardStatus === 'onboarded') on++; });
    var sub = tot === 0 ? 'No party members yet' : (tot + ' member' + (tot === 1 ? '' : 's') + ' · ' + on + ' onboarded · ' + (tot - on) + ' awaiting');
    var h = '<p class="cc-detail-sub">' + esc(sub) + '</p>';
    if (tot === 0) {
      h += '<div class="cc-empty">No party members yet. Add them to start onboarding.</div>';
    } else {
      pm.forEach(function (m) {
        var onb = m.onboarded || m.onboardStatus === 'onboarded';
        var svc = '';
        var ref = (m.refs && m.refs.published_runsheet) || {};
        if (ref.service || ref.start_time) svc = [ref.service, ref.start_time, ref.artist].filter(Boolean).join(' · ');
        else svc = onb ? 'Onboarded' : ((m.onboardStatus === 'invited') ? 'Awaiting details · invite sent' : 'Awaiting details · not invited');
        h += '<div class="cc-member"><div class="cc-avatar">' + esc(initials(m.name)) + '</div>' +
          '<div class="cc-m-main"><div class="cc-m-name">' + esc(m.name || 'Member') + (m.role ? ' <span class="cc-role-chip">' + esc(m.role) + '</span>' : '') + '</div>' +
          '<div class="cc-m-svc">' + esc(svc) + '</div>' +
          (typeof window.bbsMemberHairstyleHtml_ === 'function' ? window.bbsMemberHairstyleHtml_(m) : '') +
          '</div>' +
          '<div class="cc-m-state"><span class="cc-tick ' + (onb ? 'on' : 'off') + '">' + (onb ? ICONS.check : ICONS.info) + '</span></div></div>';
      });
    }
    h += '<div class="cc-block-actions"><button class="btn btn-ghost btn-block" onclick="CC.manageParty()">' + ICONS.plus + 'Add or manage members</button></div>';
    return h;
  }

  function renderRunsheet(b, c) {
    var rs = (b && b.runsheet) || {};
    var state2 = rs.runsheetState || 'none';
    var signed = /signed/i.test(String(c['RUNSHEET_STAGE'] || ''));

    // Primary: tokenised Shopify webview (/pages/runsheet-view?token=...).
    // This is the interactive JV-branded runsheet the bride and admin see.
    // Secondary: Drive PDF preview — only shown if no token exists (legacy brides).
    var viewerToken = String(c['RUNSHEET_VIEWER_TOKEN'] || '').trim();
    var webviewUrl = viewerToken ? '/pages/runsheet-view?token=' + encodeURIComponent(viewerToken) : '';
    var pdfUrl = String((rs.publishedData && rs.publishedData.pdfUrl) || c['RUNSHEET VIEW LINK'] || '').trim();

    // FIX 3 (2026-08-06): when the drawer bundle has not resolved, `rs` is {} and
    // state2 falls back to 'none', which previously rendered the CONFIDENT claim
    // "Not built yet" for a bride with a published runsheet (observed live on
    // Bianca Dibou). An unknown state must read as unknown, never as a fact.
    // Only say "Not built yet" when the bundle actually arrived and said so.
    var rsLoaded = !!(b && b.runsheet);
    var banner = state2 === 'published' ? ('Published' + (signed ? ' · signed off' : ' · awaiting signoff'))
      : (state2 === 'draft' ? 'Draft in progress'
      : (rsLoaded ? 'Not built yet' : 'Loading runsheet status...'));
    var h = '<p class="cc-detail-sub">' + esc(banner) + '</p>';
    var svcs = (rs.publishedData && rs.publishedData.services) || [];
    if (svcs.length) {
      h += '<div style="margin-bottom:14px;">';
      svcs.slice(0, 30).forEach(function (s) {
        h += '<div class="cc-info-row"><span class="cc-il">' + esc((s.time || '') + (s.client ? ' · ' + s.client : '')) + '</span><span class="cc-iv">' + esc([s.service, s.artist].filter(Boolean).join(' · ')) + '</span></div>';
      });
      h += '</div>';
    }
    h += '<div class="cc-block-actions cc-block-actions--col">';
    if (webviewUrl) {
      h += '<a class="btn btn-primary cc-action-btn" href="' + escA(webviewUrl) + '" target="_blank" rel="noopener">' + ICONS.external + 'Open runsheet view</a>';
    } else if (pdfUrl) {
      h += '<a class="btn btn-primary cc-action-btn" href="' + escA(pdfUrl) + '" target="_blank" rel="noopener">' + ICONS.external + 'Open runsheet view</a>';
    }
    h += '<a class="btn btn-ghost cc-action-btn" href="/pages/runsheet-app" target="_blank" rel="noopener">' + ICONS.external + 'Open in Runsheet Builder</a>';
    h += '</div>';
    return h;
  }

  function renderInspiration(b, c, body) {
    var th = (b && b.partyMembers && b.partyMembers.brideInspo) || [];
    var folder = String(c['INSPIRATION FOLDER'] || '').trim();
    var h = '';
    if (th.length === 0) {
      h += '<div class="cc-empty">No inspiration uploaded yet.' + (folder ? ' The folder is ready.' : '') + '</div>';
    } else {
      h += '<p class="cc-detail-sub">' + th.length + ' inspiration pin' + (th.length === 1 ? '' : 's') + '</p>';
      h += '<div class="cc-thumbs">' + th.slice(0, 18).map(function (t) {
        var u = t.thumbUrl || t.driveUrl || '';
        return '<div class="cc-thumb">' + (u ? '<img src="' + escA(u) + '" loading="lazy" alt="">' : ICONS.inspiration) + '</div>';
      }).join('') + '</div>';
    }
    h += '<div class="cc-block-actions">';
    if (folder) h += '<a class="btn btn-ghost btn-block" href="' + escA(folder) + '" target="_blank" rel="noopener">' + ICONS.folder + 'Open inspiration folder</a>';
    h += '</div>';
    body.innerHTML = h;
  }

  function renderPackage(b, c, body) {
    var calc = parseCalc(c);
    // Issue 6 (2026-07-23): resolve the tier with the INVOICE_BOOKING_TYPE fallback so an
    // invoiced-without-stored-calc bride (e.g. jfg, tier=jessica) shows "Jessica Vegas"
    // here, matching the profile Package tile, instead of "TBC".
    var tl = resolvedTierLabel_(c, calc);
    var total = (calc && (calc.total != null ? calc.total : calc.grandTotal)) || num(c['TOTAL VALUE']);
    // Balance must reconcile with the Total shown on THIS card. When `total`
    // comes from the live proposal calc (PROPOSAL_CALC_JSON), the raw CRM
    // BALANCE DUE column is written from a Xero invoice sync (xero_bestInvoice_
    // picks AmountDue of the highest-total AUTHORISED/PAID invoice on the Xero
    // contact), which can be a different/older/unrelated invoice. That made the
    // card read Balance > Total (e.g. $7,953 owing on a $2,282.50 package).
    // Derive balance from the displayed total minus deposit, and only trust the
    // CRM BALANCE DUE when it is internally consistent (0 < bal <= total).
    var dep = num(c['DEPOSIT PAID']);
    var crmBal = num(c['BALANCE DUE']);
    var bal = (crmBal > 0 && total && crmBal <= total) ? crmBal : Math.max(0, total - dep);
    var h = '';
    h += '<div class="cc-stat-row"><div class="cc-stat"><div class="cc-k">Tier</div><div class="cc-v">' + esc(tl || 'TBC') + '</div></div>' +
      '<div class="cc-stat"><div class="cc-k">Total</div><div class="cc-v">' + (total ? money(total) : 'n/a') + '</div></div>' +
      '<div class="cc-stat"><div class="cc-k">Balance</div><div class="cc-v ' + (bal > 0 ? 'cc-owing' : '') + '">' + (total ? money(bal) : 'n/a') + '</div></div></div>';
    var vision = String(c['BRIDE_VISION_WORDS'] || '').trim();
    if (vision) { h += '<p class="cc-detail-sub">Vision</p><div class="cc-chip-row">' + vision.split(/[,\n]+/).filter(Boolean).slice(0, 8).map(function (w) { return '<span class="cc-vision-chip">' + esc(w.trim()) + '</span>'; }).join('') + '</div>'; }
    if (c['PARTNER_NAME']) h += infoRow('Partner', c['PARTNER_NAME']);
    var dt = []; try { dt = c['BRIDE_DREAM_TEAM_JSON'] ? JSON.parse(c['BRIDE_DREAM_TEAM_JSON']) : []; } catch (e) { dt = []; }
    if (dt && dt.length) { h += '<p class="cc-detail-sub" style="margin-top:14px;">Dream team</p>'; dt.slice(0, 8).forEach(function (v) { h += infoRow(v.role || 'Vendor', v.name || v.businessName || ''); }); }
    h += '<div class="cc-block-actions cc-block-actions--col">';
    h += '<a class="btn btn-primary cc-action-btn" href="/pages/proposal-builder" target="_blank" rel="noopener">' + ICONS.external + 'Open in Proposal Builder</a>';
    if (c.hasProposal && c.email && typeof openProposalModal === 'function') h += '<button class="btn btn-ghost cc-action-btn" onclick="openProposalModal(\'' + escA(c.email) + '\')">View proposal</button>';
    h += '</div>';
    body.innerHTML = h;
    // lazy full detail (line items) via the contract, only if a proposal exists
    if (c.hasProposal) lazyFacet('package', function (f) {
      if (!f || !f.calc || !f.calc.lineItems || state.facet !== 'package') return;
      var li = '<p class="cc-detail-sub" style="margin-top:14px;">Line items</p>';
      f.calc.lineItems.slice(0, 40).forEach(function (it) { li += infoRow((it.label || it.name || it.description || 'Item'), it.amount != null ? money(it.amount) : (it.total != null ? money(it.total) : '')); });
      var holder = document.createElement('div'); holder.innerHTML = li;
      if (state.facet === 'package' && body) body.appendChild(holder);
    });
  }

  function renderInvoices(b, c) {
    var rows = (b && b.invoices && Array.isArray(b.invoices)) ? b.invoices.filter(function (i) { return c.email && String(i.email || '').toLowerCase() === String(c.email).toLowerCase(); }) : [];
    // Same reconciliation guard as renderPackage: only trust the raw CRM
    // BALANCE DUE when it is consistent with TOTAL VALUE (0 < bal <= total),
    // otherwise derive balance owing from total minus deposit. Protects against
    // a stale BALANCE DUE left over from a prior/unrelated Xero invoice sync.
    var total = num(c['TOTAL VALUE']);
    var dep = num(c['DEPOSIT PAID']);
    var crmBal = num(c['BALANCE DUE']);
    // Fallback (Cowork E2E finding: summary stayed "n/a" even after a live Xero
    // refresh returned real invoices). When the CRM money columns are blank/zero but
    // we DO have invoice rows, derive the figures from the rows so the header never
    // reads "n/a" while real invoices are listed below it.
    if (!total && rows.length) {
      var rowTotal = 0, rowBal = 0;
      rows.forEach(function (i) { rowTotal += num(i.totalValue || i.total); rowBal += num(i.balanceDue); });
      if (rowTotal > 0) { total = rowTotal; if (!crmBal) crmBal = rowBal; }
    }
    // Deposit fallback (Cowork V4, 2026-07-23): the CRM DEPOSIT PAID column is often
    // blank for brides whose money lives in Xero, so Deposit read "n/a" even after a
    // refresh returned real invoices. Derive amount-paid-so-far from the rows: prefer
    // (total - total balance owing); else sum PAID invoice totals. Only when the column
    // is blank, so a real CRM deposit still wins.
    if (!dep && rows.length) {
      var rowTotal2 = 0, rowBal2 = 0, paidSum = 0;
      rows.forEach(function (i) {
        var t = num(i.totalValue || i.total); rowTotal2 += t; rowBal2 += num(i.balanceDue);
        var isPaid = /paid/i.test(String(i.status || '')) || (num(i.balanceDue) === 0 && t > 0);
        if (isPaid) paidSum += t;
      });
      var derivedPaid = (rowTotal2 > 0 && rowBal2 >= 0 && rowBal2 <= rowTotal2) ? (rowTotal2 - rowBal2) : paidSum;
      if (derivedPaid > 0) dep = derivedPaid;
    }
    var bal = (crmBal > 0 && total && crmBal <= total) ? crmBal : Math.max(0, total - dep);
    var h = '<div class="cc-stat-row"><div class="cc-stat"><div class="cc-k">Total</div><div class="cc-v">' + (total ? money(total) : 'n/a') + '</div></div>' +
      '<div class="cc-stat"><div class="cc-k">Deposit</div><div class="cc-v">' + (dep ? money(dep) : 'n/a') + '</div></div>' +
      '<div class="cc-stat"><div class="cc-k">Balance owing</div><div class="cc-v ' + (bal > 0 ? 'cc-owing' : '') + '">' + (total ? money(bal) : 'n/a') + '</div></div></div>';
    if (rows.length === 0) { h += '<div class="cc-empty">No invoice rows cached. Use Refresh from Xero to fetch the latest.</div>'; }
    else {
      rows.forEach(function (i) {
        var paid = /paid/i.test(String(i.status || '')) || (num(i.balanceDue) === 0 && num(i.totalValue) > 0);
        h += '<div class="cc-inv"><div class="cc-i-main"><div class="cc-t">' + esc(i.invoiceNumber || 'Invoice') + '</div><div class="cc-d">' + esc((i.issueDate ? fdate(i.issueDate) : '') + (i.status ? ' · ' + i.status : '')) + '</div></div>' +
          '<div class="cc-i-amt"><div class="cc-a">' + money(i.totalValue || i.total) + '</div><span class="cc-chip ' + (paid ? 'cc-chip-paid' : 'cc-chip-owing') + '">' + (paid ? 'Paid' : 'Owing') + '</span></div></div>';
      });
    }
    h += '<div class="cc-block-actions">';
    h += '<button class="btn btn-ghost" onclick="CC.refreshInvoices()">Refresh from Xero</button>';
    var anyUrl = rows.filter(function (i) { return i.invoiceUrl || i.pdfUrl; })[0];
    if (anyUrl) h += '<a class="btn btn-ghost" href="' + escA(anyUrl.invoiceUrl || anyUrl.pdfUrl) + '" target="_blank" rel="noopener">' + ICONS.external + 'Open in Xero</a>';
    h += '</div>';
    h += '<p class="cc-section-note">Rows are cached (no live Xero call on open, to protect the daily quota). Refresh from Xero fetches the latest on demand.</p>';
    return h;
  }

  // Manual "Refresh from Xero": show a full skeleton while the live call runs so the
  // click is never a silent 5-7s blank (Cowork E2E finding: no loading feedback).
  function refreshInvoices() {
    var body = el('cc-facet-body'); if (!body) return;
    var c = client() || {}; if (!c.email) { if (typeof jvToast === 'function') jvToast('No email on file.', 'error'); return; }
    body.innerHTML = '<div class="cc-facet-refreshing">' + skeleton() + '<p class="cc-section-note" style="text-align:center;">Fetching the latest from Xero...</p></div>';
    var forId = state.clientId;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoices', args: { refresh: true, email: c.email } })
      .then(function (res) {
        if (String(state.clientId) !== String(forId) || state.facet !== 'invoices') return;
        var rows = (res && res.ok && Array.isArray(res.data)) ? res.data : [];
        var b = bundleNow() || {}; b.invoices = rows; // stash for the render
        body.innerHTML = renderInvoices(b, c);
      })
      .catch(function () { if (state.facet === 'invoices') body.innerHTML = retryHtml('invoices'); });
  }

  // Auto-refresh from Xero on facet open for a BOOKED bride (Cowork E2E finding: the
  // CACHED invoice view actively misrepresented a bride's state, showing a $0 draft
  // when she had 9+ "Owing" invoices, and the admin had to know to click Refresh). We
  // keep the instant cached paint for speed, then silently pull live Xero in the
  // BACKGROUND and repaint. A subtle inline "checking Xero" note tells the admin a live
  // check is running, so the money figures are never quietly wrong. Non-booked leads
  // stay cache-only (no invoices to reconcile; protects the Xero daily quota).
  var _invAutoRefreshedFor_ = null;
  function maybeAutoRefreshInvoices(c) {
    if (!c || !c.email) return;
    // Fire for any bride who is booked by ANY signal, not just the BOOKED? column
    // (Cowork V4: jfg's BOOKED? column was blank while PIPELINE_STAGE said Booked, so
    // the auto-refresh never ran and Invoices sat on the stale "n/a" cached state). Also
    // fire when there are already invoice rows on the bride (she clearly has invoices to
    // reconcile). Leads with no invoices + no booked signal stay cache-only (Xero quota).
    var stageStr = String(c.stage || c['PIPELINE_STAGE'] || '').toLowerCase();
    var bookedStage = ['booked', 'onboarding', 'trial', 'post-wedding', 'completed'].indexOf(stageStr) !== -1;
    var hasInvoiceRows = !!(bundleNow() && Array.isArray(bundleNow().invoices) && bundleNow().invoices.length);
    var isBooked = !!(c.isBooked || String(c['BOOKED?'] || '').toLowerCase() === 'yes' || bookedStage || hasInvoiceRows);
    if (!isBooked) return;
    if (_invAutoRefreshedFor_ === String(state.clientId)) return; // once per drawer open
    _invAutoRefreshedFor_ = String(state.clientId);
    var forId = state.clientId;
    var note = el('cc-facet-body') && el('cc-facet-body').querySelector('.cc-section-note');
    if (note) note.textContent = 'Checking Xero for the latest...';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getInvoices', args: { refresh: true, email: c.email } })
      .then(function (res) {
        if (String(state.clientId) !== String(forId) || state.facet !== 'invoices') return; // moved on
        if (!res || !res.ok || !Array.isArray(res.data)) return; // keep cached view on failure
        var body = el('cc-facet-body'); if (!body) return;
        var b = bundleNow() || {}; b.invoices = res.data;
        body.innerHTML = renderInvoices(b, c);
      })
      .catch(function () { /* keep the cached view; manual Refresh still available */ });
  }

  /* Trial Photos: the one new screen. Camera-roll upload to bride TRIAL FOLDER. */
  function renderTrial(b, c, body) {
    var date = String(c['TRIAL DATE'] || '').trim();
    var time = String(c['TRIAL TIME'] || '').trim();
    var type = String(c['TRIAL TYPE'] || c['bridal_trial_type'] || c['TRIAL_TYPE'] || '').trim();
    var folder = String(c['TRIAL FOLDER'] || '').trim();
    var up = truthy(c['Trial Files Uploaded']);
    var subBits = [];
    if (date) subBits.push('Trial: ' + dShort(date)); if (type) subBits.push(type); if (time) subBits.push(time);
    var h = '<p class="cc-detail-sub">' + esc(subBits.join(' · ') || (String(c['TRIAL REQUIRED?'] || '').toLowerCase() === 'no' ? 'No trial required' : 'Trial not booked yet')) + '</p>';
    h += '<div class="cc-thumbs" id="cc-trial-thumbs"></div>';
    h += '<div class="cc-uploader" onclick="CC.trialPick()"><div class="cc-up-ic">' + ICONS.upload + '</div>' +
      '<p>Upload from phone</p><small>Camera roll or take a photo · up to 10 MB each</small></div>';
    h += '<div class="cc-progress-line" id="cc-trial-prog" style="display:none;"><i></i></div>';
    h += '<div class="cc-status-line" id="cc-trial-status">' + (up ? 'Trial photos uploaded · task closed' : '') + '</div>';
    h += '<input type="file" id="cc-trial-file" accept="image/jpeg,image/png,image/heic,image/heif,image/webp" multiple style="display:none;" onchange="CC.trialUpload(this.files)">';
    h += '<div class="cc-block-actions">';
    if (folder) h += '<a class="btn btn-ghost btn-block" href="' + escA(folder) + '" target="_blank" rel="noopener">' + ICONS.folder + 'Open trial folder</a>';
    // Trial Assist link (Jess, 2026-07-24): the drawer previously had no way to reach
    // the artist's on-the-day prescription/sketch tool (jv-trial-design-notes.liquid),
    // only the photo uploader above. That page auto-loads a bride via ?c=<Shopify
    // Customer ID> (it does not read email at all), so only render the link when she
    // has one on file. No status gate, useful before, during, and after the trial.
    var _scid = String(c['Shopify Customer ID'] || '').trim();
    if (_scid) h += '<a class="btn btn-ghost btn-block" href="/pages/trial-design-notes?c=' + escA(_scid) + '" target="_blank" rel="noopener">' + ICONS.check + 'Open trial assist</a>';
    h += '<button class="btn btn-ghost btn-block" onclick="CC.markFeedback()">' + ICONS.check + 'Mark feedback received</button>';
    h += '</div>';
    body.innerHTML = h;
    // Read the already-uploaded photos back from Drive so the gallery persists
    // across reopen/refresh (the screen previously had an upload path only; the
    // empty container meant thumbnails vanished on any re-render).
    loadTrialThumbs_();
  }

  // Fetch the bride's trial photos via the read route and paint cc-trial-thumbs.
  // Guarded against stale responses (drawer switched clients or facets mid-flight).
  function loadTrialThumbs_() {
    var forId = state.clientId;
    jvBridge.callAdmin('bridge_admin_trialPhotoList', { clientId: forId })
      .then(function (res) {
        if (String(state.clientId) !== String(forId) || state.facet !== 'trial') return;
        var thumbs = el('cc-trial-thumbs'); if (!thumbs) return;
        var photos = (res && res.ok && Array.isArray(res.photos)) ? res.photos : [];
        thumbs.innerHTML = photos.slice(0, 60).map(function (p) {
          var u = p.thumbUrl || p.driveUrl || '';
          return '<div class="cc-thumb">' + (u ? '<img src="' + escA(u) + '" loading="lazy" alt="">' : '') + '</div>';
        }).join('');
      })
      .catch(function () { /* leave whatever is already painted */ });
  }

  function trialPick() { var i = el('cc-trial-file'); if (i) i.click(); }

  function readB64_(file, cb) {
    var r = new FileReader();
    r.onload = function () { var s = String(r.result || ''); var k = s.indexOf(','); cb(k >= 0 ? s.slice(k + 1) : s, file.type || 'image/jpeg'); };
    r.onerror = function () { cb(null); };
    r.readAsDataURL(file);
  }

  function trialUpload(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (!files.length) return;
    var clientId = state.clientId;
    var prog = el('cc-trial-prog'), status = el('cc-trial-status'), thumbs = el('cc-trial-thumbs');
    if (prog) { prog.style.display = ''; prog.querySelector('i').style.width = '0%'; }
    var done = 0, ok = 0;
    function setProg() { if (prog) prog.querySelector('i').style.width = Math.round(done / files.length * 100) + '%'; if (status) status.textContent = 'Uploading ' + Math.min(done + 1, files.length) + ' of ' + files.length + '...'; }
    setProg();
    function next(i) {
      if (i >= files.length) {
        if (prog) prog.style.display = 'none';
        if (status) status.textContent = ok + ' uploaded' + (ok > 0 ? ' · task closed' : '');
        if (ok > 0 && typeof jvToast === 'function') jvToast(ok + ' trial photo' + (ok === 1 ? '' : 's') + ' uploaded.', 'success');
        if (ok < files.length && typeof jvToast === 'function') jvToast((files.length - ok) + ' failed to upload.', 'error');
        // refresh the bundle so the landing/glance reflects the closed task
        if (typeof getDrawerBundle_ === 'function') getDrawerBundle_(clientId, { fresh: true, forceServer: true });
        // re-read the gallery from Drive (source of truth) so it survives re-render,
        // rather than trusting only the optimistically-appended thumbnails above
        if (typeof loadTrialThumbs_ === 'function' && state.facet === 'trial') loadTrialThumbs_();
        return;
      }
      var file = files[i];
      readB64_(file, function (b64, mime) {
        if (!b64) { done++; setProg(); next(i + 1); return; }
        uploadOne_(clientId, file.name, b64, mime, 1, function (res) {
          done++;
          if (res && res.ok) { ok++; if (thumbs && res.thumbUrl) { var d = document.createElement('div'); d.className = 'cc-thumb'; d.innerHTML = '<img src="' + escA(res.thumbUrl) + '" alt="">'; thumbs.appendChild(d); } }
          setProg();
          next(i + 1);
        });
      });
    }
    next(0);
  }

  function uploadOne_(clientId, filename, b64, mime, attempt, cb) {
    jvBridge.callAdmin('bridge_admin_trialPhotoUpload', { clientId: clientId, filename: filename, base64Content: b64, mimeType: mime })
      .then(function (res) {
        // dedicated route: response object is the handler result ({ok,...})
        if (res && res.ok) { cb(res); return; }
        if (attempt < 2) { uploadOne_(clientId, filename, b64, mime, attempt + 1, cb); return; }
        cb(res || { ok: false });
      })
      .catch(function () { if (attempt < 2) uploadOne_(clientId, filename, b64, mime, attempt + 1, cb); else cb({ ok: false }); });
  }

  function markFeedback() {
    var clientId = state.clientId;
    // Row-position identity guard (adminCrm_updatePortalTaskStatus now accepts
    // expectedEmail and re-resolves a stale clientId, see AdminCRMAPI.gs).
    var expectedEmail = state.clientEmail || (STATE.drawerClient && STATE.drawerClient.email) || '';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_updatePortalTaskStatus', args: { id: clientId, taskId: 'trial_feedback', value: 'done', expectedEmail: expectedEmail } })
      .then(function (res) {
        var ok = res && (res.ok || (res.data && res.data.ok));
        if (typeof jvToast === 'function') jvToast(ok ? 'Marked: trial feedback received.' : 'Could not update.', ok ? 'success' : 'error');
      })
      .catch(function () { if (typeof jvToast === 'function') jvToast('Could not update.', 'error'); });
  }

  /* Comms: journey + timeline + composer (honest send result; reuses the gated bridge_admin_sendMessage) */
  function renderComms(b, c, body) {
    var journey = (b && b.journey && b.journey.steps) ? b.journey.steps : [];
    var comms = (b && Array.isArray(b.commsLog)) ? b.commsLog : null;
    if (comms === null && b && b.commsLog && b.commsLog.lite) {
      // heavy section was lite in the bundle; hydrate via the contract
      body.innerHTML = skeleton();
      lazyFacet('comms', function (f) { if (state.facet === 'comms') paintComms_(body, (f && f.journey) || journey, (f && f.comms) || []); });
      return;
    }
    paintComms_(body, journey, comms || []);
  }

  function paintComms_(body, journey, comms) {
    var h = '';
    var items = [];
    (journey || []).forEach(function (s) { if (s.status === 'completed' || s.status === 'active') items.push({ t: s.name, x: s.detail || '', time: s.date ? fdate(s.date) : '', icon: 'check' }); });
    (comms || []).slice(0, 40).forEach(function (m) { items.push({ t: (m.channel || m.type || 'Message'), x: m.body || m.summary || m.note || '', time: m.date ? fdate(m.date) : '', icon: 'message' }); });
    if (items.length === 0) h += '<div class="cc-empty">No history yet.</div>';
    items.forEach(function (it) {
      h += '<div class="cc-tl-item"><div class="cc-tl-dot">' + (ICONS[it.icon] || ICONS.message) + '</div>' +
        '<div class="cc-tl-body"><div class="cc-tl-t">' + esc(it.t) + '</div>' + (it.x ? '<div class="cc-tl-x">' + esc(String(it.x).slice(0, 200)) + '</div>' : '') +
        (it.time ? '<div class="cc-tl-time">' + esc(it.time) + '</div>' : '') + '</div></div>';
    });
    var c = client() || {};
    var bookable = !c.category || ['Bridal', 'Non-Bridal'].indexOf(c.category) !== -1;
    if (bookable) {
      h += '<div class="cc-composer">' +
        '<select id="cc-msg-channel" onchange="CC.commsChannelChange()"><option value="email">Email</option><option value="sms">SMS</option></select>' +
        '<input type="text" id="cc-msg-subject" placeholder="Subject">' +
        '<textarea id="cc-msg-body" placeholder="Write a message..."></textarea>' +
        '<button class="btn btn-primary btn-block" id="cc-msg-send" onclick="CC.commsSend()">' + ICONS.send + 'Send</button>' +
        '<div class="cc-send-result" id="cc-msg-result"></div>' +
        '</div>';
    }
    // RACE GUARD (Cowork E2E, 2026-07-23): only paint if Comms is STILL the active
    // facet, and always into the LIVE facet body (never a captured/stale ref), so a
    // late comms response can't render into whatever facet the admin switched to.
    if (state.facet !== 'comms') return;
    var live = el('cc-facet-body') || body;
    live.innerHTML = h;
  }

  function commsChannelChange() { var ch = el('cc-msg-channel'); var subj = el('cc-msg-subject'); if (subj) subj.style.display = (ch && ch.value === 'email') ? '' : 'none'; }

  function commsSend() {
    var ch = el('cc-msg-channel'), subjEl = el('cc-msg-subject'), bodyEl = el('cc-msg-body'), btn = el('cc-msg-send'), out = el('cc-msg-result');
    var channel = ch ? ch.value : 'email';
    var body = bodyEl ? bodyEl.value.trim() : '';
    if (!body) { if (out) { out.className = 'cc-send-result blocked'; out.textContent = 'Message cannot be empty.'; } return; }
    if (btn) { btn.disabled = true; }
    if (out) { out.className = 'cc-send-result'; out.textContent = 'Sending...'; }
    jvBridge.callAdmin('bridge_admin_sendMessage', { brideId: state.clientId, email: jvExpectedEmailFor(state.clientId), brideUid: ((STATE.drawerClient && STATE.drawerClient.brideUid) || ''), channel: channel, subject: subjEl ? subjEl.value : '', body: body })
      .then(function (res) {
        if (btn) btn.disabled = false;
        var r = (res && res.ok) ? res.data : null;
        var st = r && r.status ? String(r.status).toLowerCase() : '';
        // honest result (P0.6): Sent only on a real send; Deferred / Blocked / Rate-limited otherwise
        if (st === 'blocked_safe_mode' || st === 'blocked') { setResult_(out, 'blocked', 'Blocked: safe mode is active. Nothing was sent.'); }
        else if (st === 'deferred' || st === 'blocked_quiet_hours') { setResult_(out, 'deferred', 'Deferred: outside contact hours. Will send after 8am Sydney.'); clearComposer_(); }
        else if (st === 'rate_limited') { setResult_(out, 'blocked', 'Not sent: daily message limit for this bride reached.'); }
        else if (r && r.ok && (st === 'sent' || st === 'queued' || !st)) { setResult_(out, 'sent', 'Sent via ' + channel + '.'); clearComposer_(); }
        else { setResult_(out, 'blocked', 'Send failed: ' + ((r && r.error) || (res && res.error) || 'unknown error')); }
      })
      .catch(function (err) { if (btn) btn.disabled = false; setResult_(out, 'blocked', 'Error: ' + (err && err.message || err)); });
  }
  function setResult_(out, cls, msg) { if (out) { out.className = 'cc-send-result ' + cls; out.textContent = msg; } }
  function clearComposer_() { var b = el('cc-msg-body'); if (b) b.value = ''; var s = el('cc-msg-subject'); if (s) s.value = ''; }

  /* ── History / Activity Trail (Gap #4) ────────────────────────────── */

  function renderHistory(b, c, body) {
    // Explicit loading label (Cowork V6, 2026-07-23): the History fetch can take
    // 15-17s and the bare skeleton read as a permanently blank pane. Show a clear
    // "Loading history..." so it never looks broken while the call is in flight.
    body.innerHTML = skeleton() + '<p class="cc-section-note" style="text-align:center;">Loading history...</p>';
    var email = (c && c.email) ? c.email : (state.clientEmail || '');
    if (!email) { body.innerHTML = '<div class="cc-empty">No email for this client.</div>'; return; }
    lazyHistory_(email, 0, body);
  }

  function lazyHistory_(email, offset, body) {
    jvBridge.callAdmin('bridge_admin_generic', {
      function: 'adminCrm_getActivityTrail',
      args: { email: email, limit: 100, offset: offset }
    })
    .then(function (res) {
      if (state.facet !== 'history') return; // navigated away
      var live = el('cc-facet-body') || body; // always the live body, never a stale ref
      var r = res && res.data ? res.data : res;
      if (!r || !r.ok) {
        live.innerHTML = retryHtml('history');
        return;
      }
      paintHistory_(live, r.trail || [], r.hasMore, r.total, email, offset);
    })
    .catch(function () { if (state.facet === 'history') { var lb = el('cc-facet-body') || body; lb.innerHTML = retryHtml('history'); } });
  }

  function paintHistory_(body, trail, hasMore, total, email, offset) {
    if (!trail || trail.length === 0) {
      body.innerHTML = '<div class="cc-empty">No history yet.</div>';
      return;
    }
    var h = '<div class="cc-history">';

    // Group rows by calendar day
    var days = [];
    var dayMap = {};
    trail.forEach(function (row) {
      var day = '';
      try { day = new Date(row.ts).toISOString().slice(0, 10); } catch (e) { day = 'unknown'; }
      if (!dayMap[day]) { dayMap[day] = []; days.push(day); }
      dayMap[day].push(row);
    });

    days.forEach(function (day) {
      var label = '';
      if (day === 'unknown') {
        label = 'Unknown date';
      } else {
        try {
          var d = new Date(day + 'T12:00:00');
          var today = new Date(); today.setHours(0,0,0,0);
          var diff = Math.round((today - d) / 86400000);
          if (diff === 0) label = 'Today';
          else if (diff === 1) label = 'Yesterday';
          else label = d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
        } catch (e) { label = day; }
      }
      h += '<div class="cc-hist-day-header">' + esc(label) + '</div>';
      dayMap[day].forEach(function (row) {
        var kindIcon = historyKindIcon_(row.kind);
        var actorChip = historyActorChip_(row.actor, row.actorKind);
        var timeStr = '';
        try { timeStr = new Date(row.ts).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' }); } catch (e) {}
        h += '<div class="cc-hist-row' + (row.derived ? ' cc-hist-derived' : '') + '">' +
          '<div class="cc-hist-dot">' + kindIcon + '</div>' +
          '<div class="cc-hist-body">' +
            '<div class="cc-hist-label">' + esc(row.label || '') + actorChip + '</div>' +
            (row.detail ? '<div class="cc-hist-detail">' + esc(String(row.detail).slice(0, 200)) + '</div>' : '') +
            (timeStr ? '<div class="cc-hist-time">' + esc(timeStr) + (row.channel ? ' · ' + esc(row.channel) : '') + '</div>' : '') +
          '</div>' +
        '</div>';
      });
    });

    if (hasMore) {
      var nextOffset = offset + 100;
      h += '<div class="cc-hist-loadmore">' +
        '<button class="btn btn-ghost btn-sm cc-hist-more-btn" data-email="' + escA(email) + '" data-offset="' + nextOffset + '">' +
        'Load more (' + (total - nextOffset) + ' remaining)</button></div>';
    }
    h += '</div>';

    if (offset === 0) {
      body.innerHTML = h;
    } else {
      // Append to existing content (load-more)
      var existing = body.querySelector('.cc-history');
      if (existing) {
        var tmp = document.createElement('div');
        tmp.innerHTML = h;
        var newContent = tmp.querySelector('.cc-history');
        // Replace the load-more button on the previous page
        var oldMore = existing.querySelector('.cc-hist-loadmore');
        if (oldMore) existing.removeChild(oldMore);
        if (newContent) {
          var nodes = Array.prototype.slice.call(newContent.childNodes);
          nodes.forEach(function (n) { existing.appendChild(n); });
        }
      } else {
        body.innerHTML = h;
      }
    }

    // Wire load-more buttons
    var moreBtn = body.querySelector('.cc-hist-more-btn');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var em = this.getAttribute('data-email');
        var off = parseInt(this.getAttribute('data-offset'), 10) || 0;
        this.disabled = true;
        this.textContent = 'Loading…';
        lazyHistory_(em, off, body);
      });
    }
  }

  function historyKindIcon_(kind) {
    switch (String(kind || '').toLowerCase()) {
      case 'money':     return ICONS.invoices;
      case 'stage':     return ICONS.info;
      case 'ownership': return ICONS.contact;
      case 'milestone': return ICONS.check;
      case 'comms':     return ICONS.message;
      default:          return ICONS.history;
    }
  }

  function historyActorChip_(actor, actorKind) {
    if (!actor || actor === 'system') return '<span class="cc-hist-actor system">system</span>';
    if (actor === 'you') return '<span class="cc-hist-actor admin">you</span>';
    var cls = String(actorKind || 'team').toLowerCase() === 'admin' ? 'admin' : 'team';
    return '<span class="cc-hist-actor ' + cls + '">' + esc(actor) + '</span>';
  }

  /* lazy facet detail via the fb_admin_client_detail contract (one call + bounded retry) */
  function lazyFacet(key, onData) {
    var clientId = state.clientId, attempt = 0;
    function go() {
      attempt++;
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getClientDetail', args: { clientId: clientId, facet: key } })
        .then(function (res) {
          // RACE GUARD (Cowork E2E, 2026-07-23): drop the response if the drawer moved
          // to another bride OR another facet while this async call was in flight. Without
          // the facet check, a slow Comms/Package fetch could paint its data into whatever
          // facet the admin had since switched to (observed: stray EMAIL/SMS tags rendered
          // under the Overview hero after clicking away from Comms).
          if (String(state.clientId) !== String(clientId) || state.facet !== key) return;
          var f = (res && res.ok && res.data && res.data.ok && res.data.facets) ? res.data.facets[key] : null;
          if (f) { onData(f); }
          else if (attempt < 2) { go(); }
          else { onData(null); }
        })
        .catch(function () {
          if (String(state.clientId) !== String(clientId) || state.facet !== key) return;
          if (attempt < 2) go(); else onData(null);
        });
    }
    go();
  }

  function retryHtml(key) {
    return '<div class="cc-retry"><p>Couldn\'t load this.</p><button class="btn btn-ghost" onclick="CC.openFacet(\'' + key + '\')">Tap to retry</button></div>';
  }

  /* delegate heavy CRUD to the legacy party tab; the return tab brings the user back */
  function manageParty() {
    var drawer = el('detail-drawer');
    if (typeof ensurePartyMembersTab_ === 'function') ensurePartyMembersTab_();
    ensureReturnTab_(); // inject ← Command Centre breadcrumb before switching tab
    if (drawer) drawer.classList.remove('cc-active');
    var tab = document.querySelector('#detail-drawer .drawer-tab[data-pane="party-members"]');
    if (typeof switchDrawerTab === 'function') switchDrawerTab('party-members', tab);
  }

  function ensureReturnTab_() {
    var tabs = document.querySelector('#detail-drawer .drawer-tabs');
    if (!tabs || document.getElementById('cc-return-tab')) return;
    var t = document.createElement('div');
    t.className = 'drawer-tab'; t.id = 'cc-return-tab';
    t.textContent = 'Command Centre';
    t.setAttribute('onclick', 'CC.reopen()');
    tabs.insertBefore(t, tabs.firstChild);
  }

  function book() { if (typeof drawerBookTrial === 'function') drawerBookTrial(); }

  /* ---------------- Team KPI Phase 1: Lead Owner attribution ---------------- */
  var _ccLeadOwnerArtists = null; // session cache of active roster artists

  function invalidateBundle_() {
    try { if (typeof _drawerBundleCache !== 'undefined' && state.clientId != null) delete _drawerBundleCache[String(state.clientId)]; } catch (e) {}
  }

  function populateLeadOwnerSelect_(c) {
    var sel = el('cc-lo-select'); if (!sel) return;
    var loadEl = el('cc-lo-loading');
    function showSelect_() {
      if (loadEl) loadEl.style.display = 'none';
      sel.style.display = '';
      sel.removeAttribute('disabled');
      sel.removeAttribute('aria-busy');
    }
    function showFailed_() {
      if (loadEl) {
        loadEl.style.display = '';
        loadEl.innerHTML = 'Couldn\'t load. <button class="btn btn-ghost btn-sm" type="button" onclick="CC.retryLeadOwner()">Retry</button>';
      }
      sel.style.display = 'none';
    }
    function showLoading_() {
      if (loadEl) {
        loadEl.style.display = '';
        loadEl.innerHTML = '<span class="mini-spinner"></span> Loading artists…';
      }
      sel.style.display = 'none';
      sel.setAttribute('disabled', 'disabled');
      sel.setAttribute('aria-busy', 'true');
    }
    function fill(list) {
      var cur = String((c && c.leadOwner) || '').toLowerCase();
      var opts = '<option value="">Select artist...</option>';
      (list || []).forEach(function (a) {
        if (!a.email) return;
        opts += '<option value="' + escA(a.email) + '"' + (String(a.email).toLowerCase() === cur ? ' selected' : '') + '>' + esc(a.name || a.email) + '</option>';
      });
      opts += '<option value="__clear__">Clear owner</option>';
      sel.innerHTML = opts;
      showSelect_();
    }
    if (_ccLeadOwnerArtists) { fill(_ccLeadOwnerArtists); return; }
    if (typeof jvBridge === 'undefined') { showFailed_(); return; }
    showLoading_();
    leadOwnerArtistsFetch_()
      .then(function (res) {
        if (!(res && res.ok && res.data && res.data.artists)) { showFailed_(); return; }
        _ccLeadOwnerArtists = res.data.artists; fill(_ccLeadOwnerArtists);
      })
      .catch(function () { showFailed_(); });
  }

  function retryLeadOwner_() { populateLeadOwnerSelect_(client()); }

  function assignLeadOwner() {
    var c = client(); if (!c || !c.email) { if (typeof jvToast === 'function') jvToast('No email on file for this client.', 'error'); return; }
    var sel = el('cc-lo-select'), msg = el('cc-lo-msg'); if (!sel) return;
    var val = sel.value; var ownerEmail = (val === '__clear__' || val === '') ? '' : val;
    if (msg) msg.textContent = 'Saving...';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_setLeadOwner', args: { email: c.email, ownerEmail: ownerEmail } })
      .then(function (res) {
        var d = res && res.data;
        if (res && res.ok && d && d.ok) {
          c.leadOwner = d.owner || ''; c.leadOwnerName = d.ownerName || '';
          var cur = el('cc-lo-current'); if (cur) cur.textContent = d.owner ? (d.ownerName || d.owner) : 'Unassigned';
          if (msg) msg.textContent = d.message || 'Saved.';
          if (typeof jvToast === 'function') jvToast(d.message || 'Lead owner updated.', 'success');
          invalidateBundle_();
        } else {
          var e = (d && d.error) || (res && res.error) || 'Save failed';
          if (msg) msg.textContent = String(e);
          if (typeof jvToast === 'function') jvToast(String(e), 'error');
        }
      })
      .catch(function (err) { if (msg) msg.textContent = String(err.message || err); });
  }

  function claimLead() {
    var c = client(); if (!c || !c.email) { if (typeof jvToast === 'function') jvToast('No email on file for this client.', 'error'); return; }
    var who = (window.jvAuth && window.jvAuth.email) ? String(window.jvAuth.email).trim().toLowerCase() : '';
    var msg = el('cc-lo-msg');
    if (!who) { if (msg) msg.textContent = 'Could not identify the logged-in artist.'; if (typeof jvToast === 'function') jvToast('Could not identify you.', 'error'); return; }
    if (msg) msg.textContent = 'Claiming...';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_claimLead', args: { email: c.email, claimantEmail: who } })
      .then(function (res) {
        var d = res && res.data;
        if (res && res.ok && d && d.ok) {
          if (d.claimed) {
            c.leadOwner = d.owner || who; c.leadOwnerName = d.ownerName || '';
            var cur = el('cc-lo-current'); if (cur) cur.textContent = c.leadOwnerName || c.leadOwner;
            var sel = el('cc-lo-select'); if (sel) sel.value = c.leadOwner;
            invalidateBundle_();
          }
          if (msg) msg.textContent = d.message || '';
          if (typeof jvToast === 'function') jvToast(d.message || 'Done.', d.claimed ? 'success' : 'info');
        } else {
          var e = (d && d.error) || (res && res.error) || 'Claim failed';
          if (msg) msg.textContent = String(e);
          if (typeof jvToast === 'function') jvToast(String(e), 'error');
        }
      })
      .catch(function (err) { if (msg) msg.textContent = String(err.message || err); });
  }

  /* ---------------- Bookings facet (cancel / reschedule / remind) ----------------
     Unions the two booking stores (trial-path on the bride CRM row + S.O.-ledger
     path on the Trial Bookings sheet) via adminCrm_listClientBookings, and acts on
     each through adminCrm_cancelBooking / _rescheduleBooking / _sendBookingReminder.
     Design: BRIEFS/DESIGN-booking-management-PLAN-2026-06-18.md. */
  var _ccBookingsCache = {}; // clientId -> { upcoming, past, dryRun }
  var _ccBookingEdit = null; // { bookingId, mode:'cancel'|'reschedule', bk, source }
  var _ccExtensionBondCache = {}; // clientId -> { bondId, status } | null. Bundle-only, no separate live refresh (2026-08-18).

  function renderBookings(b, c, body) {
    c = c || client() || {};
    if (!state.clientId && !c.email) { body.innerHTML = '<div class="cc-empty">No client loaded.</div>'; return; }
    _ccBookingEdit = null;
    var forId = state.clientId;
    // Extension hire bond (2026-08-18): rides the bundle, no separate live-refresh
    // call -- it's a one-row sheet scan the bundle already carries. undefined
    // (bundle field absent, e.g. stale cache pre-dating this field) is treated the
    // same as null (no live bond) -- never renders a broken/partial card.
    _ccExtensionBondCache[String(forId)] = (b && b.extensionBond) || null;

    // P1 CDN-first (2026-07-22): the drawer bundle now carries `bookings` (built by the
    // warmer, read from the CDN metaobject on open). Paint from it FIRST so the tab shows
    // instantly with zero GAS, then live-refresh below (stale-while-revalidate). Falls
    // through to the skeleton + live call when the bundle has no bookings (cold/lite).
    var bundleBookings = (b && b.bookings && b.bookings.ok) ? b.bookings : null;
    if (bundleBookings) {
      _ccBookingsCache[String(forId)] = { upcoming: bundleBookings.upcoming || [], past: bundleBookings.past || [], dryRun: !!bundleBookings.dryRun };
      paintBookings_(body);
    } else {
      body.innerHTML = skeleton();
    }

    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_listClientBookings', args: { clientId: state.clientId, email: c.email } })
      .then(function (res) {
        if (String(state.clientId) !== String(forId) || state.facet !== 'bookings') return;
        if (!res || !res.ok) {
          // Live refresh failed: keep the bundle-painted view if we already have one,
          // otherwise show the retry affordance.
          if (!bundleBookings) body.innerHTML = retryHtml('bookings');
          return;
        }
        _ccBookingsCache[String(forId)] = { upcoming: res.upcoming || [], past: res.past || [], dryRun: !!res.dryRun };
        paintBookings_(body);
      })
      .catch(function () { if (state.facet === 'bookings' && !bundleBookings) body.innerHTML = retryHtml('bookings'); });
  }

  function paintBookings_(body) {
    var data = _ccBookingsCache[String(state.clientId)] || { upcoming: [], past: [] };
    var h = '';
    h += extensionBondCardHtml_();
    if (data.dryRun) h += '<p class="cc-section-note">Comms are in dry-run, cancel / reschedule / reminder messages are previewed, not sent. They go live once approved.</p>';
    if (!data.upcoming.length && !data.past.length) h += '<div class="cc-empty">No bookings on file for this client.</div>';
    if (data.upcoming.length) {
      h += '<p class="cc-detail-sub">Upcoming</p>';
      data.upcoming.forEach(function (bk) { h += bookingCardHtml_(bk, true); });
    }
    if (data.past.length) {
      h += '<details class="cc-past-bookings"><summary>Past and cancelled (' + data.past.length + ')</summary>';
      data.past.forEach(function (bk) { h += bookingCardHtml_(bk, false); });
      h += '</details>';
    }
    body.innerHTML = h;
  }

  // Extension hire deep-link card (2026-08-18): shown only when this bride has a
  // live (non-refunded/non-forfeited) hair-extension bond, per bundle.extensionBond
  // (AdminCRMDrawerBundle.gs, extBond_findLive_). "View extension hire" opens the
  // admin Extension Set Assignment page pre-loaded to HER bond via ?bond=<id>,
  // instead of Jess needing to know/paste a Bond ID cold on that page. Empty
  // string when she has none -- the common case, no visible change to the tab.
  //
  // VOID button (2026-09-25, item 3 of state/findings/SCOPE-extension-hire-
  // full-e2e-cloudflare-2026-09-25.md, Piece 4 of the Sept-19 synchronous-
  // refusal scope): only shown when eb.status === 'owed' (client-side
  // pre-filter matching the SAME guard the Worker re-checks server-side --
  // never trusted alone, the click handler below still gets a real refusal
  // if the status has moved since this card was painted). Calls the
  // synchronous-refusal decision DIRECTLY on jv-crm-mirror via the relay's
  // new 'extension-bond-check-admin' entity (Cloudflare/Edge, commit
  // `3b6f3b41`) -- deliberately NOT a GAS function (the Consolidator's
  // explicit doctrine correction: the decision already lives on the Worker,
  // wrapping it in a new GAS function would be new GAS decision logic this
  // project's build doctrine forbids). The actual bond-status write, when
  // allowed, still happens via the existing GAS Sheet write for now (this
  // is the DECISION half only, per the same "decision moved, write didn't
  // yet" scope split the void_stale_bond action already uses).
  function extensionBondCardHtml_() {
    var eb = _ccExtensionBondCache[String(state.clientId)];
    if (!eb || !eb.bondId) return '';
    var statusLabelMap = { owed: 'Bond owed', invoiced: 'Bond invoiced', held: 'Bond held', returned: 'Extensions returned, bond pending refund' };
    var statusLabel = statusLabelMap[eb.status] || eb.status || 'Live hire';
    var url = '/pages/extension-inventory?bond=' + encodeURIComponent(eb.bondId);
    var h = '<div class="cc-booking-card cc-ext-bond-card">';
    h += '<div class="cc-bk-head"><div class="cc-bk-main"><div class="cc-bk-title">Hair Extension Rental</div>';
    h += '<div class="cc-bk-meta">' + esc(statusLabel) + '</div></div></div>';
    h += '<div class="cc-block-actions cc-bk-actions">';
    h += '<a class="btn btn-ghost btn-sm" href="' + escA(url) + '" target="_blank" rel="noopener">' + (typeof ICONS !== 'undefined' && ICONS.calendar ? ICONS.calendar : '') + 'View extension hire</a>';
    if (eb.status === 'owed') {
      h += '<button class="btn btn-ghost btn-sm cc-ext-bond-void" onclick="CC.extensionBondVoid(\'' + escA(eb.bondId) + '\')">Void stale bond</button>';
    }
    h += '</div></div>';
    return h;
  }

  // Confirm-inline + call, matching bookingRemind_'s own toast-only pattern
  // (no modal, no page reload). extension-bond-check-admin is gated OFF at
  // BOTH the relay/Worker level (EXTENSION_BOND_CHECK_ENABLED, dark until
  // Jess's go-live checklist is confirmed) -- every click before that lands
  // as a clean "not yet available" refusal, never a silent no-op and never
  // a real void firing early.
  function extensionBondVoid(bondId) {
    var c = client() || {};
    var brideUid = c.brideUid || '';
    if (!bondId || !brideUid) {
      if (typeof jvToast === 'function') jvToast('Could not identify this bond or bride.', 'error');
      return;
    }
    if (!window.confirm('Void this stale extension bond? This only works if it has never been signed or invoiced.')) return;

    var base = window._jvAdminProxyBase;
    if (!base) {
      if (typeof jvToast === 'function') jvToast('Admin actions are only available to admins.', 'error');
      return;
    }
    var url = String(base).replace(/\/+$/, '') + '/partner/extension-bond-check-admin/check';
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    nf(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ brideUid: brideUid, action: 'void_stale_bond', bondId: bondId })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.ok !== true) {
        if (typeof jvToast === 'function') jvToast((res && res.error) || 'Stale-bond void is not yet available.', 'error');
        return;
      }
      if (!res.allowed) {
        if (typeof jvToast === 'function') jvToast(res.detail || res.reason || 'This bond cannot be voided.', 'error');
        return;
      }
      // Allowed by the decision. The actual write still happens GAS-side
      // for now (per this feature's decision-only scope) -- once that write
      // path exists, this becomes a second call; until then, surface the
      // decision result honestly rather than claiming a void that hasn't
      // actually happened yet.
      if (typeof jvToast === 'function') jvToast('Void approved by the bond check. The write-through is not yet built -- nothing has changed yet.', 'info');
    }).catch(function () {
      if (typeof jvToast === 'function') jvToast('Could not reach the bond check.', 'error');
    });
  }

  function bookingCardHtml_(bk, isUpcoming) {
    var bid = bk.bookingId, src = bk.source;
    var statusMap = { upcoming: { t: 'Upcoming', c: 'ok' }, pending_payment: { t: 'Awaiting payment', c: 'warn' }, completed: { t: 'Completed', c: 'mut' }, cancelled: { t: 'Cancelled', c: 'mut' }, refunded: { t: 'Refunded', c: 'mut' } };
    var st = statusMap[bk.status] || { t: bk.status, c: 'mut' };
    var meta = [bk.dateLabel, bk.timeLabel].filter(Boolean).join(' · ');
    var isZoomStyling = (src === 'ledger' && String(bk.mode || '').toLowerCase() === 'zoom');
    // For Zoom styling sessions the location holds the join URL, so don't print it as text.
    var loc = isZoomStyling ? bk.mode : (bk.mode || bk.location || '');
    var srcTag = 'Service';
    if (src === 'trial') srcTag = 'Bridal Trial';
    else if (src === 'wedding') srcTag = 'Wedding Day';
    else if (isZoomStyling) srcTag = 'Styling Session';
    var refundNote = bk.refundPending ? '<div class="cc-bk-meta cc-bk-refund">Refund pending, action manually</div>' : '';

    var h = '<div class="cc-booking-card" data-bk="' + escA(bid) + '">';
    h += '<div class="cc-bk-head"><div class="cc-bk-main"><div class="cc-bk-title">' + esc(bk.service || 'Booking') + ' <span class="cc-role-chip">' + esc(srcTag) + '</span></div>';
    h += '<div class="cc-bk-meta">' + esc(meta || 'No date set') + (loc ? ' · ' + esc(loc) : '') + '</div>' + refundNote + '</div>';
    h += '<span class="cc-badge cc-badge-' + st.c + '">' + esc(st.t) + '</span></div>';

    var calLink = bk.calendarUrl ? '<a class="btn btn-ghost btn-sm" href="' + escA(bk.calendarUrl) + '" target="_blank" rel="noopener">' + ICONS.calendar + 'View in calendar</a>' : '';
    var zoomLink = (isZoomStyling && /^https?:\/\//i.test(String(bk.location || ''))) ? '<a class="btn btn-ghost btn-sm" href="' + escA(bk.location) + '" target="_blank" rel="noopener">' + ICONS.external + 'Join Zoom</a>' : '';

    var editing = _ccBookingEdit && _ccBookingEdit.bookingId === bid;
    if (editing && _ccBookingEdit.mode === 'reschedule') { h += bookingReschedulePanel_(bk); }
    else if (editing && _ccBookingEdit.mode === 'cancel') { h += bookingCancelPanel_(bk); }
    else {
      var actions = calLink + zoomLink;
      if (isUpcoming) {
        if (bk.canReschedule) actions += '<button class="btn btn-ghost btn-sm" onclick="CC.bookingEdit(\'' + escA(src) + '\',\'' + escA(bid) + '\',\'reschedule\')">' + ICONS.calendar + 'Reschedule</button>';
        if (bk.canRemind) actions += '<button class="btn btn-ghost btn-sm" onclick="CC.bookingRemind(\'' + escA(src) + '\',\'' + escA(bid) + '\')">' + ICONS.message + 'Send reminder</button>';
        if (bk.canCancel) actions += '<button class="btn btn-ghost btn-sm cc-bk-cancel" onclick="CC.bookingEdit(\'' + escA(src) + '\',\'' + escA(bid) + '\',\'cancel\')">Cancel</button>';
      }
      if (actions) h += '<div class="cc-block-actions cc-bk-actions">' + actions + '</div>';
    }
    h += '</div>';
    return h;
  }

  function bookingReschedulePanel_(bk) {
    var h = '<div class="cc-bk-panel">';
    h += '<div class="cc-bk-fields"><label class="cc-bk-field">New date<input type="date" id="cc-bk-date"></label>';
    h += '<label class="cc-bk-field">New time<input type="time" id="cc-bk-time"></label></div>';
    h += '<div class="cc-block-actions"><button class="btn btn-primary btn-sm" onclick="CC.bookingRescheduleConfirm(\'' + escA(bk.source) + '\',\'' + escA(bk.bookingId) + '\')">Move booking</button>';
    h += '<button class="btn btn-ghost btn-sm" onclick="CC.bookingEditCancel()">Keep current time</button></div></div>';
    return h;
  }

  function bookingCancelPanel_(bk) {
    var paidWarn = bk.paid ? '<p class="cc-bk-warn">This booking is paid. Cancelling will not refund automatically, the payment is flagged for you to action manually.</p>' : '';
    var h = '<div class="cc-bk-panel">' + paidWarn;
    h += '<label class="cc-bk-field">Reason (optional)<input type="text" id="cc-bk-reason" placeholder="e.g. client requested"></label>';
    h += '<div class="cc-block-actions"><button class="btn btn-primary btn-sm cc-bk-confirm-cancel" onclick="CC.bookingCancelConfirm(\'' + escA(bk.source) + '\',\'' + escA(bk.bookingId) + '\')">Confirm cancel</button>';
    h += '<button class="btn btn-ghost btn-sm" onclick="CC.bookingEditCancel()">Keep booking</button></div></div>';
    return h;
  }

  function bookingFindCached_(bookingId) {
    var data = _ccBookingsCache[String(state.clientId)] || {};
    var all = (data.upcoming || []).concat(data.past || []);
    return all.filter(function (x) { return x.bookingId === bookingId; })[0] || null;
  }

  function bookingEdit(source, bookingId, mode) {
    _ccBookingEdit = { bookingId: bookingId, mode: mode, bk: bookingFindCached_(bookingId), source: source };
    var body = el('cc-facet-body'); if (body) paintBookings_(body);
  }
  function bookingEditCancel() { _ccBookingEdit = null; var body = el('cc-facet-body'); if (body) paintBookings_(body); }

  function bookingRemind(source, bookingId) {
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_sendBookingReminder', args: { source: source, bookingId: bookingId } })
      .then(function (res) {
        if (!res || !res.ok) { if (typeof jvToast === 'function') jvToast((res && res.error) || 'Reminder failed', 'error'); return; }
        if (res.skipped) { if (typeof jvToast === 'function') jvToast('Already reminded recently.', 'info'); return; }
        var dry = res.commsDryRun || (res.comms && res.comms.dryRun);
        if (typeof jvToast === 'function') jvToast(dry ? 'Reminder previewed (dry-run, not sent).' : 'Reminder sent.', 'success');
      })
      .catch(function (e) { if (typeof jvToast === 'function') jvToast(String((e && e.message) || e), 'error'); });
  }

  function bookingRescheduleConfirm(source, bookingId) {
    var d = el('cc-bk-date'), t = el('cc-bk-time');
    var newDate = d ? d.value : '', newTime = t ? t.value : '';
    if (!newDate || !newTime) { if (typeof jvToast === 'function') jvToast('Pick a new date and time.', 'error'); return; }
    var body = el('cc-facet-body'); if (body) body.innerHTML = skeleton();
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_rescheduleBooking', args: { source: source, bookingId: bookingId, newDate: newDate, newTime: newTime } })
      .then(function (res) {
        _ccBookingEdit = null;
        if (!res || !res.ok) { if (typeof jvToast === 'function') jvToast((res && res.error) || 'Reschedule failed', 'error'); }
        else {
          var dry = res.commsDryRun || (res.comms && res.comms.dryRun);
          if (typeof jvToast === 'function') jvToast('Booking moved.' + (dry ? ' Confirmation previewed (dry-run).' : ''), 'success');
        }
        _ccBookingsCache[String(state.clientId)] = null;
        renderBookings(bundleNow(), client(), el('cc-facet-body'));
      })
      .catch(function (e) { if (typeof jvToast === 'function') jvToast(String((e && e.message) || e), 'error'); renderBookings(bundleNow(), client(), el('cc-facet-body')); });
  }

  function bookingCancelConfirm(source, bookingId) {
    var r = el('cc-bk-reason'); var reason = r ? r.value : '';
    var body = el('cc-facet-body'); if (body) body.innerHTML = skeleton();
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_cancelBooking', args: { source: source, bookingId: bookingId, reason: reason } })
      .then(function (res) {
        _ccBookingEdit = null;
        if (!res || !res.ok) { if (typeof jvToast === 'function') jvToast((res && res.error) || 'Cancel failed', 'error'); }
        else {
          var dry = res.commsDryRun || (res.comms && res.comms.dryRun);
          var msg = 'Booking cancelled.';
          if (res.refundFlagged) msg += ' Paid, refund flagged for manual action.';
          if (dry) msg += ' Confirmation previewed (dry-run).';
          if (typeof jvToast === 'function') jvToast(msg, 'success');
        }
        _ccBookingsCache[String(state.clientId)] = null;
        renderBookings(bundleNow(), client(), el('cc-facet-body'));
      })
      .catch(function (e) { if (typeof jvToast === 'function') jvToast(String((e && e.message) || e), 'error'); renderBookings(bundleNow(), client(), el('cc-facet-body')); });
  }

  return {
    open: open, reopen: reopen, back: back, openFacet: openFacet,
    retryBundle: function () { if (typeof getDrawerBundle_ === 'function') { getDrawerBundle_(state.clientId, { fresh: true, forceServer: true }).then(function () { if (state.facet) { var body = document.getElementById('cc-facet-body'); if (body) renderFacet(state.facet, body); } }); } },
    book: book, manageParty: manageParty,
    trialPick: trialPick, trialUpload: trialUpload, markFeedback: markFeedback,
    refreshInvoices: refreshInvoices, commsSend: commsSend, commsChannelChange: commsChannelChange,
    assignLeadOwner: assignLeadOwner, claimLead: claimLead, retryLeadOwner: retryLeadOwner_,
    bookingEdit: bookingEdit, bookingEditCancel: bookingEditCancel, bookingRemind: bookingRemind,
    bookingRescheduleConfirm: bookingRescheduleConfirm, bookingCancelConfirm: bookingCancelConfirm,
    extensionBondVoid: extensionBondVoid,
    nbaAction: function () { if (typeof CC._nbaAction === 'function') CC._nbaAction(); },
    _nbaAction: null,
    // Expose the currently-open client id so save handlers rendered OUTSIDE this module
    // (e.g. bbsPartyHairstyleSave) can resolve the right bride. The CC drawer keeps its
    // id in the closure `state`, not the global STATE.drawerClientId (Cowork V8 fix).
    currentClientId: function () { return state.clientId; }
  };
})();
window.CC = CC;

// Hook the Command Centre into the drawer lifecycle (additive wrappers).
(function () {
  var _open = window.openDrawer;
  if (typeof _open === 'function') {
    window.openDrawer = function (clientId) {
      _open(clientId);
      try { CC.open(clientId); } catch (e) { if (typeof console !== 'undefined') console.warn('CC.open failed', e); }
    };
  }
  var _close = window.closeDrawer;
  if (typeof _close === 'function') {
    window.closeDrawer = function () {
      var d = document.getElementById('detail-drawer');
      if (d) d.classList.remove('cc-active');
      _close();
    };
  }
})();

/* ============================================================
   BBS EDITOR - Booking Summary block on the Command Centre landing
   (BRIEFS/bbs-builder-editor-admin-crm-2026-07-17.md; moved onto the CC landing
   per Jess 2026-07-22 - the drawer opens into Command Centre mode, so the CC
   hero/facet-grid landing IS the "main client page". The earlier tab / legacy-
   Overview placements were invisible because CC hides the legacy tab strip.)

   Injects a Booking Summary panel onto the CC landing (into #cc-landing, after
   #cc-progress, before the Facets grid) so the most-used fields are editable
   inline with zero clicks. Wraps window.CC.open/reopen/back (all exposed on
   window.CC) so the panel re-appears every time CC repaints the landing; the
   frozen CC IIFE internals are untouched.

   Field selection (Jess 2026-07-22):
     Referenced (read-only): Booking tier, Wedding date + location, Artists required.
     Editable inline: Wedding day start/finish time, Trial required (Yes/No),
       Trial tier (Mobile/In-studio), Trial location (free text), Final payment
       status, Hairstyle confirmation status, Pipeline stage.
   The per-member hairstyle picker lives in the party facet (renderParty), not here.

   Backend: adminCrm_getBbs / adminCrm_saveBbsField / adminCrm_rebuildBbs
   (BbsEditorApi_2026_07_22.gs), all routed through bridge_admin_generic.
   ============================================================ */
(function () {

  // Referenced (read-only) fields shown at the top of the panel.
  // trial_entitlement_state added 2026-08-19, read-only by design (it replaces the
  // old editable trial_tier override, RETIRED same day, see BbsEditorApi_2026_07_22.gs
  // header comment): a wrong auto-detected value is a detection-logic bug to fix at
  // the source, not something to hand-override per bride.
  var BBS_REF_ORDER_ = ['booking_tier', 'wedding_date', 'wedding_location', 'artists_required', 'trial_entitlement_state'];
  // Editable fields, in display order.
  var BBS_EDIT_ORDER_ = [
    'wedding_day_start_time', 'wedding_day_finish_time',
    'trial_required', 'trial_location',
    'final_payment_status', 'hairstyle_confirmation_status', 'bride_system_era', 'pipeline_stage'
  ];
  var BBS_FIELD_LABELS_ = {
    booking_tier: 'Booking tier', wedding_date: 'Wedding date', wedding_location: 'Wedding location',
    artists_required: 'Artists required', trial_entitlement_state: 'Trial paid (auto-detected)',
    wedding_day_start_time: 'Wedding day start', wedding_day_finish_time: 'Wedding day finish',
    trial_required: 'Trial required', trial_location: 'Trial address',
    final_payment_status: 'Final payment', hairstyle_confirmation_status: 'Hairstyle confirmation',
    bride_system_era: 'Booking system era', pipeline_stage: 'Pipeline stage'
  };
  // Pretty option labels for select fields (value stays the canonical token).
  var BBS_OPT_LABELS_ = {
    // Booking system era, drives the hairstyle-upgrade invoicing route. Blank = auto by
    // the 30 Jun 2026 booking-date cutoff (fail-safe to Moxie). moxie = old-system (upgrades
    // invoiced manually inside Moxie, never a direct Xero invoice). new = new-system (upgrades
    // auto-invoiced as a separate Xero invoice due at final balance).
    bride_system_era: { '': 'Auto (by booking date)', moxie: 'Moxie (old, manual invoice)', 'new': 'New (auto Xero invoice)' }
  };

  var _bbsState = { email: null, clientId: null, live: null, overrides: null, editable: null };
  var _bbsCacheByClient = {}; // clientId -> { email, live, overrides, editable }

  // Idempotent mount: a panel injected into #cc-landing after #cc-progress.
  // CC replaces #cc-hero / #cc-facets innerHTML on each landing paint but leaves
  // its siblings, so ensure-then-fill keeps our panel in place across repaints.
  function ensureBbsPanel_() {
    var landing = document.getElementById('cc-landing');
    if (!landing) return null;
    var existing = document.getElementById('bbs-cc-panel');
    if (existing) return existing;
    var panel = document.createElement('div');
    panel.id = 'bbs-cc-panel';
    panel.className = 'bbs-cc-panel';
    // Place right after the progress card, before the Facets grid label.
    var progress = document.getElementById('cc-progress');
    if (progress && progress.nextSibling) landing.insertBefore(panel, progress.nextSibling);
    else if (progress) landing.appendChild(panel);
    else landing.insertBefore(panel, landing.firstChild);
    return panel;
  }

  // Wrap CC.open / CC.reopen / CC.back so the panel (re)renders on every landing paint.
  function wrapCc_() {
    if (typeof window.CC === 'undefined' || window.CC._bbsWrapped) return;
    ['open', 'reopen', 'back'].forEach(function (fn) {
      var orig = window.CC[fn];
      if (typeof orig !== 'function') return;
      window.CC[fn] = function () {
        var r = orig.apply(window.CC, arguments);
        try { renderBbsPanel_(); } catch (e) {}
        return r;
      };
    });
    window.CC._bbsWrapped = true;
  }
  // CC is defined earlier in this file; wrap now (module load order guarantees it).
  wrapCc_();

  // Resolve the current bride email + clientId from CC/STATE.
  function currentBride_() {
    var clientId = (window.STATE && window.STATE.drawerClientId) || null;
    if (!clientId) return null;
    var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
    var email = (c && c.email) ? String(c.email).trim().toLowerCase()
              : (_lastDrawerClient && _lastDrawerClient.email ? String(_lastDrawerClient.email).trim().toLowerCase() : '');
    return { clientId: clientId, email: email };
  }

  /* D1 first paint for the Booking Summary panel (2026-10-06, QA: stuck on "Loading booking summary"
     15s+ behind a live Shopify GraphQL read). Flag OFF. Reads relay entity bbs-summary (D1
     bbs_live_summary, written through from every metaobject rebuild, plus overrides). A D1 miss
     (_d1Miss: no mirrored summary / stale mirror) paints nothing and Apps Script answers as today.
     Painted only until Apps Script returns; its result always repaints and is what is cached/edited
     against. Remaining GAS dependency: the verify call and the write-through producer (BRIDAL.gs). */
  var ADMIN_BBS_D1_FIRSTPAINT_ENABLED_ = false;
  function d1BbsFirstPaint_(b) {
    var base = window._jvAdminProxyBase;
    if (!ADMIN_BBS_D1_FIRSTPAINT_ENABLED_ || !base || !b.email) return Promise.resolve(null);
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    return nf(String(base).replace(/\/+$/, '') + '/partner/bbs-summary/read', {
      method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ email: b.email })
    }).then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.ok === true && d.live && d.live.ok) ? d : null; })
      .catch(function () { return null; });
  }

  function renderBbsPanel_() {
    var panel = ensureBbsPanel_();
    if (!panel) return;
    var b = currentBride_();
    if (!b || !b.email) { panel.innerHTML = ''; return; } // leads with no email: no summary

    // Serve from per-client cache instantly if present, then refresh in the background.
    var cached = _bbsCacheByClient[String(b.clientId)];
    if (cached) {
      _bbsState = cached;
      panel.innerHTML = bbsPanelHtml_(cached);
    } else {
      panel.innerHTML = '<div class="bbs-cc-heading">Booking Summary</div>' +
        '<div class="cc-refreshing" style="font-size:0.72rem;color:var(--text-light);">Loading booking summary...</div>';
    }

    var gasDone = false;
    if (!cached) {
      d1BbsFirstPaint_(b).then(function (d1) {
        if (gasDone || !d1) return;
        if (!window.STATE || String(window.STATE.drawerClientId) !== String(b.clientId)) return;
        var pp = ensureBbsPanel_(); if (!pp) return;
        var st1 = { email: b.email, clientId: b.clientId, live: d1.live, overrides: d1.overrides || {}, editable: d1.editable || {} };
        pp.innerHTML = bbsPanelHtml_(st1); // painted only; NOT cached and NOT _bbsState, Apps Script result is authoritative
      });
    }
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getBbs', args: { email: b.email } })
      .then(function (res) {
        gasDone = true;
        // Staleness guard: discard if the drawer moved on while this was in flight.
        if (!window.STATE || String(window.STATE.drawerClientId) !== String(b.clientId)) return;
        var freshPanel = ensureBbsPanel_();
        if (!freshPanel) return;
        var data = (res && res.ok) ? res.data : null;
        if (!data || !data.ok) {
          if (!cached) freshPanel.innerHTML = '<div class="bbs-cc-heading">Booking Summary</div>' +
            '<div class="alert danger">Couldn\'t load booking summary' +
            (data && data.error ? ': ' + escHtml(String(data.error)) : '') +
            '</div><button class="btn btn-ghost btn-sm" type="button" onclick="bbsCcReload()">Retry</button>';
          return;
        }
        var st = { email: b.email, clientId: b.clientId, live: data.live, overrides: data.overrides || {}, editable: data.editable || {} };
        _bbsState = st;
        _bbsCacheByClient[String(b.clientId)] = st;
        freshPanel.innerHTML = bbsPanelHtml_(st);
        // Issue 2 (2026-07-23): correct the drawer header badge in place if it disagrees
        // with the live CRM PIPELINE_STAGE this call just fetched. The badge is painted
        // from whichever cached island (pipeline/clients list or drawer bundle) seeded
        // STATE.clients at open time, which can be a different cache generation than the
        // live column value below and self-contradict across opens. Correct once, cheaply,
        // no extra call.
        try { bbsCorrectHeaderStage_(b.clientId, data.crmPipelineStage); } catch (e) {}
      })
      .catch(function (err) {
        if (cached) return; // keep the cached paint on a transient error
        var freshPanel = ensureBbsPanel_();
        if (freshPanel) freshPanel.innerHTML = '<div class="bbs-cc-heading">Booking Summary</div>' +
          '<div class="alert danger">' + escHtml(String(err && err.message || err)) + '</div>';
      });
  }
  window.bbsCcReload = function () {
    var b = currentBride_();
    if (b && b.clientId) delete _bbsCacheByClient[String(b.clientId)];
    renderBbsPanel_();
  };

  // Issue 2 fix (2026-07-23): the drawer header badge (_paintDrawerHeader_) is painted
  // from whichever cached island (pipeline/clients list, or the drawer bundle cache)
  // happened to seed client.stage at open time, a snapshot that can disagree with the
  // live CRM PIPELINE_STAGE cell. Once this panel's own live read resolves, if the two
  // disagree, correct the already-painted badge in place (DOM + STATE.clients entry)
  // so the drawer never shows two different stages to the same admin in one view.
  function bbsCorrectHeaderStage_(clientId, crmStage) {
    if (!crmStage || String(window.STATE && window.STATE.drawerClientId) !== String(clientId)) return;
    var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
    if (!c || c.stage === crmStage) return;
    c.stage = crmStage;
    var meta = document.getElementById('drawer-meta');
    if (!meta) return;
    var badge = meta.querySelector('.stage-badge');
    if (!badge) return;
    badge.className = 'stage-badge ' + stageBadgeClass(crmStage);
    badge.textContent = stageDisplay(crmStage);
  }

  function bbsLiveVal_(live, key) {
    if (!live || !live.ok || !live.fields) return '';
    return live.fields[key] != null ? String(live.fields[key]) : '';
  }

  function bbsFieldInput_(key, map, liveVal) {
    var val = liveVal || '';
    var id = 'bbs-field-' + key;
    if (map.type === 'toggle') {
      var checked = (val === 'true' || val === 'yes' || val === 'Yes');
      return '<select id="' + id + '" class="bbs-cc-input"><option value="Yes"' + (checked ? ' selected' : '') +
        '>Yes</option><option value="No"' + (!checked ? ' selected' : '') + '>No</option></select>';
    }
    if (map.type === 'select' && Array.isArray(map.options) && map.options.length) {
      var lbls = BBS_OPT_LABELS_[key] || {};
      var opts = map.options.map(function (o) {
        return '<option value="' + escAttr(o) + '"' + (o === val ? ' selected' : '') + '>' + escHtml(lbls[o] || o) + '</option>';
      }).join('');
      return '<select id="' + id + '" class="bbs-cc-input">' + opts + '</select>';
    }
    if (map.type === 'date') {
      var isoVal = val ? String(val).slice(0, 10) : '';
      return '<input type="date" id="' + id + '" class="bbs-cc-input" value="' + escAttr(isoVal) + '">';
    }
    if (map.type === 'time') {
      return '<input type="text" id="' + id + '" class="bbs-cc-input" placeholder="e.g. 11:00 AM" value="' + escAttr(val) + '">';
    }
    if (map.type === 'number') {
      return '<input type="number" id="' + id + '" class="bbs-cc-input" value="' + escAttr(val) + '">';
    }
    return '<input type="text" id="' + id + '" class="bbs-cc-input" value="' + escAttr(val) + '">';
  }

  var BBS_TRIAL_ENTITLEMENT_LABELS_ = {
    mobile_paid: 'Yes, mobile', studio_paid: 'Yes, in-studio',
    unpaid: 'Not paid', opted_out: 'Opted out'
  };

  function bbsRefValue_(live, key) {
    var v = bbsLiveVal_(live, key);
    if (key === 'booking_tier' && typeof tierLabel === 'function') return tierLabel(v) || 'Not set';
    if (key === 'wedding_date' && v) { try { return formatDate(v, 'short'); } catch (e) { return v; } }
    if (key === 'trial_entitlement_state') return BBS_TRIAL_ENTITLEMENT_LABELS_[v] || v || 'Not set';
    return v || 'Not set';
  }

  function bbsPanelHtml_(state) {
    var live = state.live;
    var editable = state.editable || {};
    var html = '';

    // Heading + live status + Rebuild now.
    html += '<div class="bbs-cc-head">';
    html += '<span class="bbs-cc-heading">Booking Summary</span>';
    if (live && live.ok) {
      html += '<span class="bbs-cc-status-ok" title="Live on Shopify, updated ' + escAttr(formatDate(live.updatedAt, 'short')) + '">Live</span>';
    } else {
      html += '<span class="bbs-cc-status-warn">No live summary yet</span>';
    }
    html += '<button class="btn btn-ghost btn-sm" type="button" onclick="bbsCcRebuild()">Rebuild now</button>';
    html += '</div>';

    // Referenced (read-only) row.
    html += '<div class="bbs-cc-ref">';
    BBS_REF_ORDER_.forEach(function (key) {
      html += '<div class="bbs-cc-ref-item"><span class="bbs-cc-ref-label">' + escHtml(BBS_FIELD_LABELS_[key] || key) +
        '</span><span class="bbs-cc-ref-val">' + escHtml(bbsRefValue_(live, key)) + '</span></div>';
    });
    html += '</div>';

    // Editable fields.
    html += '<div class="bbs-cc-fields">';
    BBS_EDIT_ORDER_.forEach(function (key) {
      var map = editable[key];
      if (!map || !map.editable) return;
      var liveVal = bbsLiveVal_(live, key);
      html += '<div class="bbs-cc-field" data-bbs-key="' + escAttr(key) + '">';
      html += '<label class="bbs-cc-field-label" for="bbs-field-' + key + '">' + escHtml(BBS_FIELD_LABELS_[key] || key) +
        (map.override ? ' <span class="bbs-cc-override" title="Manual override">override</span>' : '') + '</label>';
      html += '<div class="bbs-cc-field-row">' + bbsFieldInput_(key, map, liveVal) +
        '<button class="btn btn-ghost btn-sm" type="button" onclick="bbsCcSave(\'' + key + '\')">Save</button></div>';
      html += '</div>';
    });
    html += '</div>';

    // Party roster: read-only glance here + link to the party facet where the
    // per-member hairstyle picker lives (renderParty).
    var partyJson = bbsLiveVal_(live, 'party_members_json');
    var party = null;
    try { party = partyJson ? JSON.parse(partyJson) : null; } catch (e) { party = null; }
    var members = (party && Array.isArray(party.members)) ? party.members : [];
    html += '<div class="bbs-cc-party">';
    html += '<div class="bbs-cc-party-head"><span class="bbs-cc-party-title">Party members</span>' +
      '<button class="btn btn-ghost btn-sm" type="button" onclick="CC.openFacet(\'party\')">Open party</button></div>';
    if (!members.length) {
      html += '<div class="bbs-cc-ref-val">No party members yet.</div>';
    } else {
      html += '<div class="bbs-cc-party-list">';
      members.forEach(function (m) {
        var name = m.name ? escHtml(m.name) : '<em>(empty slot)</em>';
        html += '<div class="bbs-cc-party-row"><span class="bbs-cc-party-role">' +
          escHtml(m.role_label || m.role || '') + '</span><span class="bbs-cc-party-name">' + name + '</span></div>';
      });
      html += '</div>';
    }
    html += '</div>';

    return html;
  }

  window.bbsCcRebuild = function () {
    if (!_bbsState.email) return;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_rebuildBbs', args: { email: _bbsState.email } })
      .then(function (res) {
        if (res && res.ok && res.data && res.data.ok) { jvToast('Booking summary rebuilt.', 'success'); window.bbsCcReload(); }
        else jvToast('Rebuild failed.', 'error');
      })
      .catch(function () { jvToast('Rebuild request failed.', 'error'); });
  };

  window.bbsCcSave = function (key) {
    if (!_bbsState.email) return;
    var input = document.getElementById('bbs-field-' + key);
    if (!input) return;
    var value = input.value;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_saveBbsField', args: { email: _bbsState.email, key: key, value: value } })
      .then(function (res) {
        if (res && res.ok && res.data && res.data.ok) {
          jvToast('Saved.', 'success');
          try { if (typeof _drawerBundleCache !== 'undefined') delete _drawerBundleCache[String(_bbsState.clientId)]; } catch (e) {}
          window.bbsCcReload();
        } else {
          jvToast('Save failed' + (res && res.data && res.data.error ? ': ' + res.data.error : '') + '.', 'error');
        }
      })
      .catch(function () { jvToast('Save request failed.', 'error'); });
  };

  /* ---- Per-member hairstyle + status picker (rendered inside the party facet) ---- */

  // Canonical 5 hairstyles only (JV_HAIRSTYLE_OPTIONS in HairstyleOptions.gs, the ONE
  // source of truth). The backend save handler now normalises any variant through
  // JV_hairstyleOptions_normalise, so a legacy short-label value ("Soft Waves",
  // "1/2 Updo", "Above Collar") still matches its canonical option below via curStyle.
  var BBS_HAIRSTYLES_ = ['Soft Waves/Curls', '1/2 Updo', 'Updo', 'Hollywood Waves', 'Above Collar/Short Hair'];
  var BBS_HAIR_STATUS_ = ['pending', 'confirmed', 'invoiced'];

  // Build the hairstyle + status picker HTML for one party member row. Only real
  // (pm_id-bearing) members get it; empty slots don't. Called from renderParty.
  window.bbsMemberHairstyleHtml_ = function (m) {
    var pmId = m && m.pm_id ? String(m.pm_id) : '';
    if (!pmId) return '';
    var curStyle = String((m.hairStyle || m.hair_style || '')).trim();
    var curStatus = String((m.hairstyleStatus || m.hairstyle_status || '')).trim().toLowerCase();
    var idSafe = escAttr(pmId);
    var styleOpts = '<option value="">Hairstyle...</option>' + BBS_HAIRSTYLES_.map(function (s) {
      return '<option value="' + escAttr(s) + '"' + (s === curStyle ? ' selected' : '') + '>' + escHtml(s) + '</option>';
    }).join('');
    var statusOpts = '<option value="">Status...</option>' + BBS_HAIR_STATUS_.map(function (s) {
      return '<option value="' + escAttr(s) + '"' + (s === curStatus ? ' selected' : '') + '>' + escHtml(s.charAt(0).toUpperCase() + s.slice(1)) + '</option>';
    }).join('');
    return '<div class="bbs-cc-member-hair" data-pm="' + idSafe + '">' +
      '<select class="bbs-cc-input bbs-cc-hair-style" id="bbs-hair-style-' + idSafe + '">' + styleOpts + '</select>' +
      '<select class="bbs-cc-input bbs-cc-hair-status" id="bbs-hair-status-' + idSafe + '">' + statusOpts + '</select>' +
      '<button class="btn btn-ghost btn-sm" type="button" onclick="bbsPartyHairstyleSave(\'' + idSafe + '\')">Save</button>' +
      '</div>';
  };

  window.bbsPartyHairstyleSave = function (pmId) {
    // Resolve the OPEN client id. The Command Centre drawer keeps its id in the CC
    // module's own state (CC.currentClientId), NOT the global STATE.drawerClientId that
    // only the legacy drawer sets. Reading only the global meant a save from the CC
    // Bridal Party facet ran with a stale/null id, so the hairstyle/status write silently
    // no-op'd and was lost on reload (Cowork V8, 2026-07-23). Prefer the CC id, fall back
    // to the legacy global.
    var clientId = (window.CC && typeof window.CC.currentClientId === 'function' && window.CC.currentClientId())
      || (window.STATE && window.STATE.drawerClientId);
    if (!clientId || !pmId) { if (typeof jvToast === 'function') jvToast('Could not resolve the open client, reopen the drawer and try again.', 'error'); return; }
    var styleEl = document.getElementById('bbs-hair-style-' + pmId);
    var statusEl = document.getElementById('bbs-hair-status-' + pmId);
    var hairStyle = styleEl ? styleEl.value : '';
    var hairstyleStatus = statusEl ? statusEl.value : '';
    // Row-position identity guard (adminCrm_savePartyMemberHairstyle now accepts
    // expectedEmail and re-resolves a stale clientId, see AdminCRMAPI.gs).
    var expectedEmail = (STATE.drawerClient && STATE.drawerClient.email) || '';
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_savePartyMemberHairstyle', args: { clientId: clientId, pm_id: pmId, hairStyle: hairStyle, hairstyleStatus: hairstyleStatus, expectedEmail: expectedEmail } })
      .then(function (res) {
        if (res && res.ok && res.data && res.data.ok) {
          jvToast('Hairstyle saved.', 'success');
          try { if (typeof _drawerBundleCache !== 'undefined') delete _drawerBundleCache[String(clientId)]; } catch (e) {}
        } else {
          jvToast('Save failed' + (res && res.data && res.data.error ? ': ' + res.data.error : '') + '.', 'error');
        }
      })
      .catch(function () { jvToast('Save request failed.', 'error'); });
  };

})();

/* ============================================================
   BBS INVOICE RECONCILIATION - itemised charges + quoted/invoiced/owed
   Brief: BRIEFS/BRIEF-bbs-invoice-reconciliation-scope-2026-07-26.md
   Backend: adminCrm_getBbsCharges / adminCrm_saveBbsChargeLine /
            adminCrm_deleteBbsChargeLine / adminCrm_setBbsChargeFlag /
            adminCrm_prefillBbsCharges  (all via bridge_admin_generic)
   Mounts as a sibling panel (#bbs-recon-panel) in the Command Centre landing,
   directly after the Booking Summary panel, re-rendered on every drawer open.
   ============================================================ */
(function () {
  var CATS = [
    { key: 'services',           label: 'Services' },
    { key: 'style_upgrades',     label: 'Style upgrades' },
    { key: 'travel',             label: 'Travel' },
    { key: 'additional_artists', label: 'Additional artists' },
    { key: 'party_size',         label: 'Party size' },
    { key: 'trial',              label: 'Trial' }
  ];
  var _reconCache = {}; // clientId -> recon payload

  function money_(cents) {
    var n = Number(cents || 0) / 100;
    return '$' + n.toFixed(2);
  }
  function esc_(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function ensureReconPanel_() {
    var landing = document.getElementById('cc-landing');
    if (!landing) return null;
    var existing = document.getElementById('bbs-recon-panel');
    if (existing) return existing;
    var panel = document.createElement('div');
    panel.id = 'bbs-recon-panel';
    panel.className = 'bbs-cc-panel bbs-recon-panel';
    // Place right after the Booking Summary panel if present, else after progress.
    var bbs = document.getElementById('bbs-cc-panel');
    var anchor = bbs || document.getElementById('cc-progress');
    if (anchor && anchor.nextSibling) landing.insertBefore(panel, anchor.nextSibling);
    else if (anchor) landing.appendChild(panel);
    else landing.insertBefore(panel, landing.firstChild);
    return panel;
  }

  function currentBride_() {
    var clientId = (window.STATE && window.STATE.drawerClientId) || null;
    if (!clientId) return null;
    var c = (typeof findClientById === 'function') ? findClientById(clientId) : null;
    var email = (c && c.email) ? String(c.email).trim().toLowerCase() : '';
    return { clientId: clientId, email: email, brideUid: (c && c.brideUid) ? String(c.brideUid) : '' };
  }

  /* D1 first paint for Charges & Reconciliation (2026-10-06, QA: panel sat on "Loading charges" 15s+ on
     a cold Apps Script read). Flag OFF. Reads the existing admin relay entity bbs-recon (D1 bbs_charge_lines,
     already recon-shaped). Painted ONLY when D1 holds at least one charge line for her (Platform rule: the
     mirror may still be incomplete, so an empty D1 answer proves nothing) and ONLY until Apps Script returns;
     the Apps Script result then always repaints and is what gets cached. Never the final word.
     Remaining GAS dependency: the verify call itself and the charge-line mirror sync. */
  var ADMIN_CHARGES_D1_FIRSTPAINT_ENABLED_ = true;
  function d1ReconFirstPaint_(b) {
    var base = window._jvAdminProxyBase;
    if (!ADMIN_CHARGES_D1_FIRSTPAINT_ENABLED_ || !base || !b.brideUid) return Promise.resolve(null);
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    return nf(String(base).replace(/\/+$/, '') + '/partner/bbs-recon/read', {
      method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ brideUid: b.brideUid })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.ok !== true || !d.recon) return null;
      var n = 0; var cats = d.recon.categories || {};
      Object.keys(cats).forEach(function (k) { n += ((cats[k] && cats[k].lines) || []).length; });
      return n > 0 ? { ok: true, recon: d.recon } : null;
    }).catch(function () { return null; });
  }

  function lineRowHtml_(cat, l) {
    var owedCls = l.owedCents > 0 ? 'bbs-owed-pos' : '';
    var badges = '';
    if (l.source === 'quote')  badges += '<span class="bbs-badge bbs-badge-quote">quote</span>';
    if (l.source === 'moxie')  badges += '<span class="bbs-badge bbs-badge-moxie">moxie</span>';
    if (l.source === 'manual') badges += '<span class="bbs-badge bbs-badge-manual">manual</span>';
    if (l.origin === 'addon')  badges += '<span class="bbs-badge bbs-badge-addon">add-on</span>';
    if (!l.verified)           badges += '<span class="bbs-badge bbs-badge-unverified">unverified</span>';
    if (l.uninvoicedAddon)     badges += '<span class="bbs-badge bbs-badge-chase">no deposit</span>';
    var depNote = (l.depositExpectedCents > 0)
      ? (money_(l.depositPaidCents) + ' / ' + money_(l.depositExpectedCents) + ' dep')
      : 'no deposit expected';
    return '<div class="bbs-recon-line" data-lineid="' + esc_(l.lineId) + '">' +
      '<div class="bbs-recon-line-main">' +
        '<span class="bbs-recon-line-label">' + esc_(l.label) + (l.person ? ' <em>(' + esc_(l.person) + ')</em>' : '') + '</span>' +
        badges +
      '</div>' +
      '<div class="bbs-recon-line-figs">' +
        '<span title="Quoted">' + money_(l.quotedCents) + '</span>' +
        '<span title="Invoiced">' + money_(l.invoicedCents) + '</span>' +
        '<span class="' + owedCls + '" title="Still owed">' + money_(l.owedCents) + '</span>' +
        '<span class="bbs-recon-dep" title="Deposit paid / expected">' + depNote + '</span>' +
      '</div>' +
      '<div class="bbs-recon-line-actions">' +
        '<label class="bbs-mini-check"><input type="checkbox" ' + (l.verified ? 'checked' : '') +
          ' onchange="JV_bbsReconFlag(\'' + esc_(l.lineId) + '\',\'verified\',this.checked)"> verified</label>' +
        '<label class="bbs-mini-check"><input type="checkbox" ' + (l.queuedForFinalInvoice ? 'checked' : '') +
          ' onchange="JV_bbsReconFlag(\'' + esc_(l.lineId) + '\',\'queuedForFinalInvoice\',this.checked)"> add to final invoice</label>' +
        '<button class="bbs-mini-btn" onclick="JV_bbsReconEditLine(\'' + esc_(cat) + '\',\'' + esc_(l.lineId) + '\')">Edit</button>' +
        '<button class="bbs-mini-btn bbs-mini-danger" onclick="JV_bbsReconDeleteLine(\'' + esc_(l.lineId) + '\')">Remove</button>' +
      '</div>' +
    '</div>';
  }

  // READ-ONLY in the drawer (BRIEF-bbs-client-page-placement 2026-07-26). The pipeline
  // drawer is a stage-reference quick-peek; the ONE editing home for money data is the
  // client page (/pages/admin-bride-profile). So this renders totals + a per-category
  // owed summary + an "Open full profile" CTA, with NO add/edit/remove/verify/queue/
  // prefill controls. The interactive functions still exist for the client-page port,
  // they're just not referenced here.
  function panelHtml_(payload) {
    var _cb = currentBride_() || {};
    var email = _cb.email || '';
    // 2026-08-25 identity-mismatch fix (see openClientProfile_ above), pass the
    // row id too so a duplicate-email bride opens the exact row being viewed.
    var profileUrl = '/pages/admin-bride-profile?bride=' + encodeURIComponent(email) +
      (_cb.clientId ? '&row=' + encodeURIComponent(_cb.clientId) : '');
    var cta = email
      ? '<a class="btn btn-ghost btn-sm" href="' + profileUrl + '" style="font-size:0.66rem;">Open full profile to edit &rarr;</a>'
      : '';
    if (!payload || !payload.ok) {
      return '<div class="bbs-cc-heading">Charges &amp; Reconciliation</div>' +
        '<div class="cc-refreshing" style="font-size:0.72rem;color:var(--text-light);">Unable to load charges.</div>' + cta;
    }
    var recon = payload.recon || {};
    var t = recon.totals || {};
    var flags = recon.flags || {};
    var html = '<div class="bbs-recon-cat-head" style="margin-bottom:0.5rem;">' +
      '<div class="bbs-cc-heading" style="margin-right:auto;">Charges &amp; Reconciliation</div>' + cta + '</div>';

    // Top-line summary strip (read-only).
    html += '<div class="bbs-recon-summary">' +
      '<div class="bbs-recon-stat"><span>Quoted</span><strong>' + money_(t.quotedCents) + '</strong></div>' +
      '<div class="bbs-recon-stat"><span>Invoiced</span><strong>' + money_(t.invoicedCents) + '</strong></div>' +
      '<div class="bbs-recon-stat bbs-recon-stat-owed"><span>Still to invoice</span><strong>' + money_(t.owedCents) + '</strong></div>' +
      '<div class="bbs-recon-stat"><span>Deposit owed</span><strong>' + money_(t.depositOwedCents) + '</strong></div>' +
    '</div>';

    if (flags.hasUninvoicedAddons) {
      html += '<div class="bbs-recon-warn">' + money_(t.addonOwedCents) + ' in add-ons with no deposit collected and not yet invoiced.</div>';
    }
    if (flags.hasUnverified) {
      html += '<div class="bbs-recon-warn bbs-recon-warn-soft">' + t.unverifiedCount + ' line(s) unverified. Open the full profile to review.</div>';
    }
    if (t.queuedForFinalCount > 0) {
      html += '<div class="bbs-recon-queued">' + t.queuedForFinalCount + ' line(s) queued for the final invoice (' + money_(t.queuedForFinalCents) + ').</div>';
    }

    // Per-category owed summary (read-only, no line controls).
    var anyLines = false;
    CATS.forEach(function (cat) {
      var c = (recon.categories && recon.categories[cat.key]) || { lines: [], quotedCents: 0, owedCents: 0 };
      if (c.lines && c.lines.length) anyLines = true;
      html += '<div class="bbs-recon-cat" style="margin-bottom:0.3rem;">' +
        '<div class="bbs-recon-cat-head"><span>' + esc_(cat.label) + '</span>' +
        '<span class="bbs-recon-cat-tot">' + money_(c.quotedCents) + ' quoted, ' + money_(c.owedCents) + ' owed</span></div>' +
      '</div>';
    });
    if (!anyLines) {
      html += '<div class="bbs-recon-empty">No charges recorded. Open the full profile to add them.</div>';
    }
    return html;
  }

  function render_() {
    var panel = ensureReconPanel_();
    if (!panel) return;
    var b = currentBride_();
    if (!b || !b.email) { panel.innerHTML = ''; return; }
    window._bbsReconEmail = b.email;
    window._bbsReconBrideUid = b.brideUid || '';

    var cached = _reconCache[String(b.clientId)];
    if (cached) panel.innerHTML = panelHtml_(cached);
    else panel.innerHTML = '<div class="bbs-cc-heading">Charges &amp; Reconciliation</div>' +
      '<div class="cc-refreshing" style="font-size:0.72rem;color:var(--text-light);">Loading charges...</div>';

    var gasDone = false;
    if (!cached) {
      d1ReconFirstPaint_(b).then(function (d1) {
        if (gasDone || !d1) return;
        if (!window.STATE || String(window.STATE.drawerClientId) !== String(b.clientId)) return;
        var pp = ensureReconPanel_(); if (pp) pp.innerHTML = panelHtml_(d1);
      });
    }
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_getBbsCharges', args: { email: b.email } })
      .then(function (res) {
        gasDone = true;
        if (!window.STATE || String(window.STATE.drawerClientId) !== String(b.clientId)) return;
        var data = (res && res.data) ? res.data : res;
        // Never show an error over content that already painted. On a failed verify
        // (504 / not-ok) keep the cached paint exactly as-is; only an uncached panel
        // may render the unavailable state. Mirrors the Booking Summary guard above.
        if (!data || !data.ok) {
          if (cached) return;
          var p = ensureReconPanel_(); if (p) p.innerHTML = panelHtml_(null);
          return;
        }
        _reconCache[String(b.clientId)] = data;
        var p2 = ensureReconPanel_(); if (p2) p2.innerHTML = panelHtml_(data);
      })
      .catch(function () {});
  }

  // Apply a fresh recon payload returned by a mutating call (repaint totals + lines).
  function applyFresh_(res) {
    var data = (res && res.data) ? res.data : res;
    if (!data) return;
    var clientId = (window.STATE && window.STATE.drawerClientId) || null;
    if (data.recon) {
      // wrap into the same shape getBbsCharges returns so panelHtml_ is uniform
      var wrapped = _reconCache[String(clientId)] || { ok: true };
      wrapped.recon = data.recon;
      wrapped.ok = true;
      _reconCache[String(clientId)] = wrapped;
      var p = ensureReconPanel_(); if (p) p.innerHTML = panelHtml_(wrapped);
    } else {
      render_();
    }
  }

  // Wrap CC landing paints so the panel re-renders (same pattern as the BBS panel).
  function wrapCc_() {
    if (typeof window.CC === 'undefined' || window.CC._reconWrapped) return;
    ['open', 'reopen', 'back'].forEach(function (fn) {
      var orig = window.CC[fn];
      if (typeof orig !== 'function') return;
      window.CC[fn] = function () {
        var r = orig.apply(window.CC, arguments);
        try { render_(); } catch (e) {}
        return r;
      };
    });
    window.CC._reconWrapped = true;
  }
  wrapCc_();

  // Shared idempotency-key builder, same shape as pmSaveNewMember_/cppAdd_'s
  // D1-first call sites elsewhere in this file.
  function bbsReconIdemKey_(kind, extra) {
    return (window._bbsReconBrideUid || '') + '|' + kind + '|' + (extra || '') +
      '|' + Date.now() + '|' + Math.random().toString(36).slice(2);
  }

  // Global action handlers (referenced by inline onclick/onchange).
  //
  // CLOUDFLARE-FIRST (2026-10-14, continuation of the ABP v6 Tier 1 BBS port,
  // BRIEFS/RESULTS-write-path-audit-2026-10-14.md). bridge_admin_toggleBbsChargeFlagD1/
  // deleteBbsChargeLineD1/prefillBbsChargesD1 ALL already have relay routing + the
  // jv-admin-saves insert-mode-outbox handler + a GAS drain branch (confirmed live in
  // InsertModeOutboxDrain_2026_08_28.gs) -- these three admin-crm.js call sites were
  // simply never flipped. No new GAS deploy needed (GAS is frozen, see CLAUDE.md --
  // this wiring only reaches EXISTING drain branches). Same unconditional-D1-first,
  // fall-back-on-any-non-d1-result pattern already used elsewhere in this file
  // (pmSaveNewMember_/cppAdd_), not v6's newer ambiguous-timeout variant -- kept
  // consistent with this file's own convention.
  window.JV_bbsReconFlag = function (lineId, flag, value) {
    var email = window._bbsReconEmail;
    if (!email) return;
    function fallbackToGasFlag_() {
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_setBbsChargeFlag',
        args: { email: email, lineId: lineId, flag: flag, value: !!value } })
        .then(function (res) {
          var data = (res && res.data) ? res.data : res;
          if (data && data.ok) applyFresh_(data);
          else jvToast('Update failed.', 'error');
        })
        .catch(function () { jvToast('Update request failed.', 'error'); });
    }
    var brideUid = window._bbsReconBrideUid;
    if (!brideUid) { fallbackToGasFlag_(); return; }
    jvBridge.call('bridge_admin_toggleBbsChargeFlagD1', {
      bride_uid: brideUid, bride_email: email,
      idempotency_key: bbsReconIdemKey_('bbsFlag', lineId + '-' + flag),
      record: { lineId: lineId, flag: flag, value: !!value }
    }).then(function (res) {
      if (res && res.ok && res.writtenTo === 'd1') {
        jvToast('Saved, syncing.', 'success');
      } else {
        fallbackToGasFlag_();
      }
    }).catch(function () { fallbackToGasFlag_(); });
  };

  window.JV_bbsReconDeleteLine = function (lineId) {
    var email = window._bbsReconEmail;
    if (!email) return;
    // Inline confirm (no blocking window.confirm, which froze the tab in QA 2026-07-26).
    bbsReconConfirm_('Remove this charge line?', function () {
      function fallbackToGasDelete_() {
        jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_deleteBbsChargeLine',
          args: { email: email, lineId: lineId } })
          .then(function (res) {
            var data = (res && res.data) ? res.data : res;
            if (data && data.ok) applyFresh_(data);
            else jvToast('Remove failed.', 'error');
          })
          .catch(function () { jvToast('Remove request failed.', 'error'); });
      }
      var brideUid = window._bbsReconBrideUid;
      if (!brideUid) { fallbackToGasDelete_(); return; }
      jvBridge.call('bridge_admin_deleteBbsChargeLineD1', {
        bride_uid: brideUid, bride_email: email,
        idempotency_key: bbsReconIdemKey_('bbsDelete', lineId),
        record: { lineId: lineId }
      }).then(function (res) {
        if (res && res.ok && res.writtenTo === 'd1') {
          jvToast('Removed, syncing.', 'success');
        } else {
          fallbackToGasDelete_();
        }
      }).catch(function () { fallbackToGasDelete_(); });
    });
  };

  window.JV_bbsReconPrefill = function () {
    var email = window._bbsReconEmail;
    if (!email) return;
    function fallbackToGasPrefill_() {
      jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_prefillBbsCharges',
        args: { email: email } })
        .then(function (res) {
          var data = (res && res.data) ? res.data : res;
          if (data && data.ok) {
            if (data.created > 0) jvToast('Prefilled ' + data.created + ' line(s). Review + verify each.', 'success');
            else jvToast('Nothing to prefill (' + (data.skipped || 'no items') + ').', 'info');
            render_();
          } else jvToast('Prefill failed.', 'error');
        })
        .catch(function () { jvToast('Prefill request failed.', 'error'); });
    }
    var brideUid = window._bbsReconBrideUid;
    if (!brideUid) { fallbackToGasPrefill_(); return; }
    jvBridge.call('bridge_admin_prefillBbsChargesD1', {
      bride_uid: brideUid, bride_email: email,
      idempotency_key: bbsReconIdemKey_('bbsPrefill'),
      // Per the jv-admin-saves registry comment: FRONTEND MUST SEND A
      // NON-EMPTY record for this type, else a blank {} is ambiguous
      // with "nothing to do".
      record: { requested: true }
    }).then(function (res) {
      if (res && res.ok && res.writtenTo === 'd1') {
        jvToast('Prefilling, syncing.', 'success');
      } else {
        fallbackToGasPrefill_();
      }
    }).catch(function () { fallbackToGasPrefill_(); });
  };

  // ── Inline modal (replaces window.prompt/confirm, which are blocking + froze the
  //    tab in QA 2026-07-26, and are off-brand). One reusable overlay element. ──
  function bbsReconEnsureModal_() {
    var m = document.getElementById('bbs-recon-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'bbs-recon-modal';
    m.className = 'bbs-recon-modal-overlay';
    m.style.display = 'none';
    m.innerHTML = '<div class="bbs-recon-modal-card"><div class="bbs-recon-modal-body"></div></div>';
    document.body.appendChild(m);
    // Click the backdrop (not the card) to cancel.
    m.addEventListener('click', function (e) { if (e.target === m) bbsReconCloseModal_(); });
    return m;
  }
  function bbsReconCloseModal_() {
    var m = document.getElementById('bbs-recon-modal');
    if (m) { m.style.display = 'none'; m.querySelector('.bbs-recon-modal-body').innerHTML = ''; }
  }
  window.bbsReconCloseModal_ = bbsReconCloseModal_;

  // Lightweight confirm dialog (used by delete).
  function bbsReconConfirm_(message, onYes) {
    var m = bbsReconEnsureModal_();
    var body = m.querySelector('.bbs-recon-modal-body');
    body.innerHTML =
      '<div class="bbs-recon-modal-title">' + message.replace(/</g, '&lt;') + '</div>' +
      '<div class="bbs-recon-modal-actions">' +
        '<button class="bbs-mini-btn" onclick="bbsReconCloseModal_()">Cancel</button>' +
        '<button class="bbs-mini-btn bbs-mini-danger" id="bbs-recon-confirm-yes">Remove</button>' +
      '</div>';
    m.style.display = 'flex';
    document.getElementById('bbs-recon-confirm-yes').onclick = function () {
      bbsReconCloseModal_();
      onYes();
    };
  }

  // Charge line add/edit form. onSave receives the assembled line object.
  function bbsReconLineForm_(cat, existing, onSave) {
    var m = bbsReconEnsureModal_();
    var body = m.querySelector('.bbs-recon-modal-body');
    var isEdit = !!existing;
    var amt = existing ? (existing.unitAmountCents / 100).toFixed(2) : '';
    var qty = existing ? String(existing.qty || 1) : '1';
    var originOriginalChecked = (!existing || existing.origin !== 'addon') ? 'checked' : '';
    var originAddonChecked = (existing && existing.origin === 'addon') ? 'checked' : '';
    body.innerHTML =
      '<div class="bbs-recon-modal-title">' + (isEdit ? 'Edit charge' : 'Add charge') + '</div>' +
      '<label class="bbs-recon-flabel">Description</label>' +
      '<input class="bbs-recon-finput" id="bbsf-label" type="text" value="' +
        (existing ? String(existing.label).replace(/"/g, '&quot;') : '') + '">' +
      '<label class="bbs-recon-flabel">Charged to (person, optional)</label>' +
      '<input class="bbs-recon-finput" id="bbsf-person" type="text" value="' +
        (existing ? String(existing.person || '').replace(/"/g, '&quot;') : '') + '">' +
      '<div class="bbs-recon-frow">' +
        '<div style="flex:2;"><label class="bbs-recon-flabel">Amount per unit ($ inc GST)</label>' +
          '<input class="bbs-recon-finput" id="bbsf-amt" type="number" step="0.01" min="0" value="' + amt + '"></div>' +
        '<div style="flex:1;"><label class="bbs-recon-flabel">Qty</label>' +
          '<input class="bbs-recon-finput" id="bbsf-qty" type="number" step="1" min="1" value="' + qty + '"></div>' +
      '</div>' +
      '<label class="bbs-recon-flabel">Booking origin</label>' +
      '<div class="bbs-recon-fradio">' +
        '<label><input type="radio" name="bbsf-origin" value="original" ' + originOriginalChecked + '> Original booking (50% deposit)</label>' +
        '<label><input type="radio" name="bbsf-origin" value="addon" ' + originAddonChecked + '> Add-on (no deposit)</label>' +
      '</div>' +
      '<div class="bbs-recon-modal-actions">' +
        '<button class="bbs-mini-btn" onclick="bbsReconCloseModal_()">Cancel</button>' +
        '<button class="bbs-mini-btn bbs-mini-save" id="bbsf-save">' + (isEdit ? 'Save' : 'Add') + '</button>' +
      '</div>';
    m.style.display = 'flex';
    var labelEl = document.getElementById('bbsf-label');
    if (labelEl) labelEl.focus();
    document.getElementById('bbsf-save').onclick = function () {
      var label = (document.getElementById('bbsf-label').value || '').trim();
      if (!label) { jvToast('Description is required.', 'error'); return; }
      var originEl = m.querySelector('input[name="bbsf-origin"]:checked');
      var origin = originEl ? originEl.value : 'original';
      var line = {
        label: label,
        person: (document.getElementById('bbsf-person').value || '').trim(),
        unitAmountCents: Math.round(parseFloat(document.getElementById('bbsf-amt').value || '0') * 100),
        qty: Math.max(1, parseInt(document.getElementById('bbsf-qty').value || '1', 10)),
        origin: origin,
        source: existing ? existing.source : 'manual',
        verified: existing ? existing.verified : false,
        priceOverridden: existing ? true : false
      };
      if (existing) line.lineId = existing.lineId;
      bbsReconCloseModal_();
      onSave(line);
    };
  }

  function bbsReconSaveLine_(cat, line, verbCreated) {
    var email = window._bbsReconEmail;
    if (!email) return;
    jvBridge.callAdmin('bridge_admin_generic', { function: 'adminCrm_saveBbsChargeLine',
      args: { email: email, category: cat, line: line } })
      .then(function (res) {
        var data = (res && res.data) ? res.data : res;
        if (data && data.ok) { jvToast(verbCreated ? 'Charge added.' : 'Charge updated.', 'success'); applyFresh_(data); }
        else jvToast((verbCreated ? 'Add' : 'Update') + ' failed.', 'error');
      })
      .catch(function () { jvToast('Request failed.', 'error'); });
  }

  window.JV_bbsReconAddLine = function (cat) {
    if (!window._bbsReconEmail) return;
    bbsReconLineForm_(cat, null, function (line) { bbsReconSaveLine_(cat, line, true); });
  };

  window.JV_bbsReconEditLine = function (cat, lineId) {
    if (!window._bbsReconEmail) return;
    var clientId = (window.STATE && window.STATE.drawerClientId) || null;
    var cached = _reconCache[String(clientId)];
    var existing = null;
    if (cached && cached.recon && cached.recon.categories && cached.recon.categories[cat]) {
      (cached.recon.categories[cat].lines || []).forEach(function (l) { if (l.lineId === lineId) existing = l; });
    }
    if (!existing) { jvToast('Line not found. Reopen the drawer.', 'error'); return; }
    bbsReconLineForm_(cat, existing, function (line) { bbsReconSaveLine_(cat, line, false); });
  };

})();
